/* eslint-disable */
import * as Types from './operations'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from '@sketch/graphql-apollo'
import {
  FieldPolicy,
  FieldReadFunction,
  TypePolicies,
  TypePolicy,
} from '@apollo/client/cache'
const defaultOptions = {} as const
export const AnnotationPageInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationPageInfo on Page {
    identifier
    pageUUID: uuid
  }
`
export const DeletedAnnotationSubjectCountersFragmentDoc = /*#__PURE__*/ gql`
  fragment DeletedAnnotationSubjectCounters on AnnotationDeletedEvent {
    identifier
    page: currentPage {
      identifier
      uuid
      ...AnnotationPageInfo
    }
  }
  ${AnnotationPageInfoFragmentDoc}
`
export const AnnotationSubjectFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationSubject on Annotation {
    identifier
    currentSubject {
      ... on Artboard {
        documentVersionShortId
        permanentArtboardShortId
        uuid
        page {
          identifier
          uuid
        }
      }
      ... on Page {
        identifier
        pageUUID: uuid
      }
      ... on Component {
        identifier
        uuid
      }
    }
  }
`
export const AnnotationSubjectSubscriptionStatusFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationSubjectSubscriptionStatus on Annotation {
    identifier
    subscriptionStatus
    share {
      identifier
      subscriptionStatus
    }
    ...AnnotationSubject
    currentSubject {
      ... on Artboard {
        documentVersionShortId
        permanentArtboardShortId
        uuid
        subscriptionStatus
      }
    }
  }
  ${AnnotationSubjectFragmentDoc}
`
export const CommentUserFragmentDoc = /*#__PURE__*/ gql`
  fragment CommentUser on PublicUser {
    avatar {
      small
    }
    identifier
    name
  }
`
export const BaseCommentFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseComment on Comment {
    identifier
    userIsCreator
    userCanDelete
    isRead
  }
`
export const CommentFragmentDoc = /*#__PURE__*/ gql`
  fragment Comment on Comment {
    identifier
    body
    createdAt
    isRead
    isEdited
    user {
      ...CommentUser
    }
    ...BaseComment
  }
  ${CommentUserFragmentDoc}
  ${BaseCommentFragmentDoc}
`
export const AnnotationCoordinatesFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationCoordinates on Annotation {
    identifier
    coordinates {
      identifier @client
      x
      y
    }
  }
`
export const AnnotationResolutionInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationResolutionInfo on Annotation {
    identifier
    resolution {
      resolvedAt
      user {
        ...CommentUser
      }
    }
  }
  ${CommentUserFragmentDoc}
`
export const AnnotationDotFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationDot on Annotation {
    identifier
    hasNewComments
    isOptimistic @client
    ...AnnotationSubject
    ...AnnotationCoordinates
    ...AnnotationResolutionInfo
  }
  ${AnnotationSubjectFragmentDoc}
  ${AnnotationCoordinatesFragmentDoc}
  ${AnnotationResolutionInfoFragmentDoc}
`
export const AnnotationLastCommentFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationLastComment on Annotation {
    identifier
    latestCommentCreatedAt
  }
`
export const AnnotationCommentCountFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationCommentCount on Annotation {
    comments {
      meta {
        totalCount
      }
    }
  }
`
export const BaseAnnotationFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseAnnotation on Annotation {
    identifier
    isNew
    subscriptionStatus
    firstComment {
      ...Comment
    }
    share {
      identifier
      subscriptionStatus
    }
    ...AnnotationDot
    ...AnnotationLastComment
    ...AnnotationCommentCount
  }
  ${CommentFragmentDoc}
  ${AnnotationDotFragmentDoc}
  ${AnnotationLastCommentFragmentDoc}
  ${AnnotationCommentCountFragmentDoc}
`
export const AnnotationSubjectCountersFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationSubjectCounters on Annotation {
    identifier
    page {
      ... on Page {
        identifier
        uuid
        ...AnnotationPageInfo
      }
    }
  }
  ${AnnotationPageInfoFragmentDoc}
`
export const AnnotationCoordinatesAndCountersFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationCoordinatesAndCounters on Annotation {
    identifier
    share {
      identifier
    }
    ...AnnotationCoordinates
    ...AnnotationSubjectCounters
  }
  ${AnnotationCoordinatesFragmentDoc}
  ${AnnotationSubjectCountersFragmentDoc}
`
export const CredentialsFragmentDoc = /*#__PURE__*/ gql`
  fragment Credentials on OAuthCredentials {
    authToken
    refreshToken
    expirationDateTime
  }
`
export const UserErrorExtensionsFragmentDoc = /*#__PURE__*/ gql`
  fragment UserErrorExtensions on UserErrorExtensions {
    reason
  }
`
export const UserErrorFragmentDoc = /*#__PURE__*/ gql`
  fragment UserError on UserError {
    message
    code
    extensions {
      ...UserErrorExtensions
    }
  }
  ${UserErrorExtensionsFragmentDoc}
`
export const SizeFragmentDoc = /*#__PURE__*/ gql`
  fragment Size on Size {
    xs
    sm
    md
    lg
    xl
  }
`
export const LinkFragmentDoc = /*#__PURE__*/ gql`
  fragment Link on Link {
    text
    url
    icon
    variant
  }
`
export const PublicationQueryPreferencesFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicationQueryPreferences on PublicationQueryPreferences {
    search
    limit
    sort
    period
    include
    exclude
    allowPagination
    documentType
  }
`
export const CommunityPublicationQueryFragmentDoc = /*#__PURE__*/ gql`
  fragment CommunityPublicationQuery on CommunityPublicationQuery {
    id
    title
    subTitle
    link {
      ...Link
    }
    preferences {
      ...PublicationQueryPreferences
    }
    ... on CommunityGrid {
      modifiers
    }
  }
  ${LinkFragmentDoc}
  ${PublicationQueryPreferencesFragmentDoc}
`
export const SingleImageFragmentDoc = /*#__PURE__*/ gql`
  fragment SingleImage on SingleImage {
    alt
    src
  }
`
export const ResponsiveImageFragmentDoc = /*#__PURE__*/ gql`
  fragment ResponsiveImage on ResponsiveImage {
    alt
    source {
      xs
      sm
      md
      lg
      xl
    }
  }
`
export const VideoSourceFragmentDoc = /*#__PURE__*/ gql`
  fragment VideoSource on VideoSource {
    backgroundColor
    poster
    src
  }
`
export const VideoFragmentDoc = /*#__PURE__*/ gql`
  fragment Video on Video {
    standard {
      ...VideoSource
    }
    retina {
      ...VideoSource
    }
  }
  ${VideoSourceFragmentDoc}
`
export const CommunityHeroFragmentDoc = /*#__PURE__*/ gql`
  fragment CommunityHero on CommunityHero {
    id
    image {
      ...SingleImage
      ...ResponsiveImage
    }
    video {
      ...Video
    }
    backgroundColor
    title
    content
    contentPosition
    icon
    links {
      ...Link
    }
    size {
      ...Size
    }
  }
  ${SingleImageFragmentDoc}
  ${ResponsiveImageFragmentDoc}
  ${VideoFragmentDoc}
  ${LinkFragmentDoc}
  ${SizeFragmentDoc}
`
export const CommunityItemFragmentDoc = /*#__PURE__*/ gql`
  fragment CommunityItem on CommunityItem {
    ... on CommunityPublicationQuery {
      ...CommunityPublicationQuery
    }
    ... on CommunityHero {
      ...CommunityHero
    }
  }
  ${CommunityPublicationQueryFragmentDoc}
  ${CommunityHeroFragmentDoc}
`
export const CommunitySectionFragmentDoc = /*#__PURE__*/ gql`
  fragment CommunitySection on CommunitySection {
    id
    size {
      ...Size
    }
    items {
      ...CommunityItem
    }
  }
  ${SizeFragmentDoc}
  ${CommunityItemFragmentDoc}
`
export const VisibilityFragmentDoc = /*#__PURE__*/ gql`
  fragment Visibility on Visibility {
    hideOnBreakpoint
    hiddenForFF
  }
`
export const PermissionsFragmentDoc = /*#__PURE__*/ gql`
  fragment Permissions on Permissions {
    roles
    audience
    categories
  }
`
export const EventDateFragmentDoc = /*#__PURE__*/ gql`
  fragment EventDate on EventDate {
    day
    time
  }
`
export const SpeakerFragmentDoc = /*#__PURE__*/ gql`
  fragment Speaker on Speaker {
    name
    role
    image
  }
`
export const DiscoverItemFragmentDoc = /*#__PURE__*/ gql`
  fragment DiscoverItem on DiscoverItem {
    id
    type
    image {
      ...SingleImage
      ...ResponsiveImage
    }
    video {
      ...Video
    }
    title
    content
    url
    featured
    size {
      ...Size
    }
    permissions {
      ...Permissions
    }
    categories
    mobile {
      description
      icon
    }
    links {
      ...Link
    }
    contentPosition
    source
    length
    author
    icon
    note
    place
    backgroundColor
    date {
      ...EventDate
    }
    speakers {
      ...Speaker
    }
    dismissable
  }
  ${SingleImageFragmentDoc}
  ${ResponsiveImageFragmentDoc}
  ${VideoFragmentDoc}
  ${SizeFragmentDoc}
  ${PermissionsFragmentDoc}
  ${LinkFragmentDoc}
  ${EventDateFragmentDoc}
  ${SpeakerFragmentDoc}
`
export const DiscoverSectionFragmentDoc = /*#__PURE__*/ gql`
  fragment DiscoverSection on DiscoverSection {
    id
    type
    title
    subTitle {
      text
      visibility {
        ...Visibility
      }
    }
    stretchedContent
    permissions {
      ...Permissions
    }
    limit
    size {
      ...Size
    }
    categories {
      id
      name
    }
    links {
      ...Link
    }
    items {
      ... on DiscoverItem {
        ...DiscoverItem
      }
    }
    visibility {
      ...Visibility
    }
  }
  ${VisibilityFragmentDoc}
  ${PermissionsFragmentDoc}
  ${SizeFragmentDoc}
  ${LinkFragmentDoc}
  ${DiscoverItemFragmentDoc}
`
export const BasicPreviewFragmentDoc = /*#__PURE__*/ gql`
  fragment BasicPreview on Preview {
    identifier
    name
    commentsEnabled
    description
    inspectEnabled
    expiryDate
    passwordProtected
  }
`
export const PresentationFileFragmentDoc = /*#__PURE__*/ gql`
  fragment PresentationFile on Page {
    identifier
    uuid
    presentationFile {
      downloadUrl
      imageToken
      manifestUrl
    }
  }
`
export const FrameDetailInfoCwvFragmentDoc = /*#__PURE__*/ gql`
  fragment FrameDetailInfoCWV on Frame {
    identifier
    uuid
    width
    height
    files(type: FULL) {
      identifier
      url
      scale
      thumbnails {
        type
        url
      }
    }
  }
`
export const ArtboardDetailInfoCwvFragmentDoc = /*#__PURE__*/ gql`
  fragment ArtboardDetailInfoCWV on Artboard {
    identifier
    permanentArtboardShortId
    documentVersionShortId
    uuid
    files(type: FULL) {
      identifier
      url
      scale
      thumbnails {
        type
        url
      }
    }
  }
`
export const SymbolFragmentDoc = /*#__PURE__*/ gql`
  fragment Symbol on Symbol {
    frame {
      ... on Frame {
        ...FrameDetailInfoCWV
      }
      ... on Artboard {
        ...ArtboardDetailInfoCWV
      }
    }
  }
  ${FrameDetailInfoCwvFragmentDoc}
  ${ArtboardDetailInfoCwvFragmentDoc}
`
export const FrameGroupThumbnailsFragmentDoc = /*#__PURE__*/ gql`
  fragment FrameGroupThumbnails on File {
    thumbnails {
      type
      url
    }
  }
`
export const AnnotationFrameGroupInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment AnnotationFrameGroupInfo on FrameGroup {
    ... on Artboard {
      permanentArtboardShortId
    }
    documentVersionShortId
    subscriptionStatus
    unreadCount
    annotationCount
  }
`
export const FrameGroupDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment FrameGroupDetails on FrameGroup {
    uuid
    identifier
    ... on Artboard {
      documentVersionShortId
      permanentArtboardShortId
    }
    documentVersionShortId
    name
    documentOrder
    isFlowHome
    subscriptionStatus
    hasMissingFonts
    page {
      uuid
      identifier
      name
      frameCount
      ...PresentationFile
    }
    component {
      identifier
      uuid
      name
      description
      path
      depth
      ... on Symbol {
        ...Symbol
      }
    }
    files(type: FULL) {
      identifier
      url
      scale
      ...FrameGroupThumbnails
    }
    ...AnnotationFrameGroupInfo
  }
  ${PresentationFileFragmentDoc}
  ${SymbolFragmentDoc}
  ${FrameGroupThumbnailsFragmentDoc}
  ${AnnotationFrameGroupInfoFragmentDoc}
`
export const PreviewDetailsFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment PreviewDetailsFragment on Preview {
    ...BasicPreview
    presentationStatus
    pages {
      entries {
        name
        identifier
        uuid
        presentationFile {
          downloadUrl
          imageToken
          manifestUrl
        }
      }
      meta {
        after
        totalCount
      }
    }
    prototypes {
      entries {
        identifier
        uuid
        ...FrameGroupDetails
      }
      meta {
        after
        totalCount
      }
    }
  }
  ${BasicPreviewFragmentDoc}
  ${FrameGroupDetailsFragmentDoc}
`
export const ProjectFragmentDoc = /*#__PURE__*/ gql`
  fragment Project on Project {
    name
    description
    identifier
    projectType
    projectPrivacyIcon
    workspaceAccessLevel
    userCanLeave
    deletedAt
    archivedAt
    pinnedByCurrentUserAt
    parentProjectIdentifier
    topLevelProject {
      identifier
      name
      workspaceAccessLevel
    }
    isOptimistic @client
  }
`
export const ProjectSearchDestinationFragmentDoc = /*#__PURE__*/ gql`
  fragment ProjectSearchDestination on Project {
    ...Project
    workspace {
      identifier
      name
    }
  }
  ${ProjectFragmentDoc}
`
export const ShareThumbnailsFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareThumbnails on File {
    identifier
    thumbnails {
      identifier
      url
      url2x
      type
    }
  }
`
export const ProjectListItemFragmentDoc = /*#__PURE__*/ gql`
  fragment ProjectListItem on Project {
    ...Project
    parentProject {
      identifier
      name
    }
    shares(limit: 4) {
      entries {
        identifier
        name
        version {
          identifier
          shortId
          document {
            identifier
            previewFile {
              url
              ...ShareThumbnails
            }
          }
        }
      }
      meta {
        totalCount
      }
    }
  }
  ${ProjectFragmentDoc}
  ${ShareThumbnailsFragmentDoc}
`
export const WorkspaceMembershipFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceMembership on WorkspaceMembership {
    identifier
    acceptedAt
    isEditor
    isOwner
    activityStatus {
      lastSeenInDays
      status
    }
    user {
      identifier
      email
      avatar {
        small
        large
      }
      name
    }
    invite {
      identifier
      email
    }
    role
  }
`
export const ProjectMembershipFragmentDoc = /*#__PURE__*/ gql`
  fragment ProjectMembership on ProjectMembership {
    identifier
    inviteStatus
    privateAccessLevel
    guestCommentsEnabled
    guestInspectEnabled
    workspaceMembership {
      ...WorkspaceMembership
    }
  }
  ${WorkspaceMembershipFragmentDoc}
`
export const UserAccessProjectMembershipFragmentDoc = /*#__PURE__*/ gql`
  fragment UserAccessProjectMembership on ProjectMembership {
    ...ProjectMembership
    project {
      ...Project
      projectPrivacyIcon
    }
  }
  ${ProjectMembershipFragmentDoc}
  ${ProjectFragmentDoc}
`
export const WorkspacePermissionGroupFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspacePermissionGroup on PermissionGroup {
    identifier
    name
    members {
      meta {
        totalCount
      }
    }
  }
`
export const ProjectGroupMembershipFragmentDoc = /*#__PURE__*/ gql`
  fragment ProjectGroupMembership on PermissionGroupRelationProject {
    identifier
    permissionGroup {
      ...WorkspacePermissionGroup
    }
  }
  ${WorkspacePermissionGroupFragmentDoc}
`
export const TrashedProjectFragmentDoc = /*#__PURE__*/ gql`
  fragment TrashedProject on TrashedProject {
    identifier
    shortId
    deletedAt
    name
    shares(limit: 4) {
      entries {
        identifier
        name
        version {
          shortId
          identifier
          document {
            identifier
            previewFile {
              url
              ...ShareThumbnails
            }
          }
        }
      }
      meta {
        totalCount
      }
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const WorkspaceProfileFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceProfile on WorkspaceProfile {
    identifier
    description
    websiteUrl
    isPublic
    isOfficial
    shortUrlName
    workspace {
      identifier
      name
      userRole
      avatar {
        large
        small
      }
    }
  }
`
export const PublicationPageFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicationPage on Page {
    identifier
    uuid
    name
    ...PresentationFile
  }
  ${PresentationFileFragmentDoc}
`
export const PublicWorkspaceMinimalFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicWorkspaceMinimal on PublicWorkspace {
    identifier
    name
    userRole
    type
    avatar {
      small
      large
    }
    customer {
      identifier
      ssoStartUrl
      ssoEnabled
    }
    profile {
      identifier
      shortUrlName
    }
  }
`
export const PublicWorkspaceProfileFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicWorkspaceProfile on PublicWorkspaceProfile {
    identifier
    description
    isPublic
    shortUrlName
    websiteUrl
  }
`
export const PublicationThumbnailFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicationThumbnail on Publication {
    identifier
    previewFile {
      identifier
      ...ShareThumbnails
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const PublicationReactionsFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicationReactions on Publication {
    identifier
    totalHearts
    userReaction
  }
`
export const PublicationFragmentDoc = /*#__PURE__*/ gql`
  fragment Publication on Publication {
    identifier
    updatedAt
    workspaceProfile {
      identifier
      isOfficial
      ...WorkspaceProfile
    }
    share {
      identifier
      name
      description
      shareType
      publicAccessLevel
      userCanInspect
      publicCommentsEnabled
      publicInspectEnabled
      userCanEdit
      userCanUpdateSettings
      version(preferredState: PROCESSED_AND_PUBLISHED) {
        identifier
        shortId
        description
        kind
        createdAt
        document {
          identifier
          downloadAvailable
          url
          renderStatus
          updatedAt
          previewFile {
            ...ShareThumbnails
          }
          pages(limit: 1) {
            entries {
              ...PublicationPage
            }
          }
        }
      }
      workspace {
        identifier
        ...PublicWorkspaceMinimal
        profile {
          identifier
          ...PublicWorkspaceProfile
        }
      }
    }
    ...PublicationThumbnail
    ...PublicationReactions
  }
  ${WorkspaceProfileFragmentDoc}
  ${ShareThumbnailsFragmentDoc}
  ${PublicationPageFragmentDoc}
  ${PublicWorkspaceMinimalFragmentDoc}
  ${PublicWorkspaceProfileFragmentDoc}
  ${PublicationThumbnailFragmentDoc}
  ${PublicationReactionsFragmentDoc}
`
export const PublicationItemDownloadFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicationItemDownload on Document {
    url
    downloadAvailable
    downloadUnavailableError
    userCanOpenInApp
  }
`
export const PublicationItemFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicationItem on Publication {
    identifier
    updatedAt
    workspaceProfile {
      identifier
      shortUrlName
      isOfficial
      workspace {
        identifier
        ...PublicWorkspaceMinimal
      }
    }
    share {
      name
      identifier
      shareType
      publicAccessLevel
      userCanInspect
      publicCommentsEnabled
      publicInspectEnabled
      workspace {
        identifier
        ...PublicWorkspaceMinimal
      }
      version(preferredState: PROCESSED_AND_PUBLISHED) {
        identifier
        shortId
        createdAt
        document {
          identifier
          ...PublicationItemDownload
          previewFile {
            identifier
            ...ShareThumbnails
          }
        }
      }
    }
    ...PublicationReactions
    ...PublicationThumbnail
  }
  ${PublicWorkspaceMinimalFragmentDoc}
  ${PublicationItemDownloadFragmentDoc}
  ${ShareThumbnailsFragmentDoc}
  ${PublicationReactionsFragmentDoc}
  ${PublicationThumbnailFragmentDoc}
`
export const PublicationListingFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicationListing on PublicationListing {
    title
    preferences {
      ...PublicationQueryPreferences
    }
    modifiers
  }
  ${PublicationQueryPreferencesFragmentDoc}
`
export const ScimPersonalAccessTokenFragmentDoc = /*#__PURE__*/ gql`
  fragment ScimPersonalAccessToken on ScimPersonalAccessToken {
    identifier
    accessScopes
    description
    expiresAt
    lastUsedAt
    createdAt
  }
`
export const ArtboardCacheInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment ArtboardCacheInfo on Artboard {
    identifier
    shortId
    documentVersionShortId
    permanentArtboardShortId
    uuid
  }
`
export const ComponentInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment ComponentInfo on Component {
    identifier
    uuid
    name
    description
    path
    depth
    pathInfo {
      id
      name
    }
    ... on Symbol {
      ...Symbol
    }
    ... on ColorVariable {
      rgbaValue {
        blue
        green
        red
        alpha
      }
    }
    ... on TextStyle {
      needsContrastingBackground
      horizontalAlignment
      font {
        size
        name
        weight
      }
      files {
        identifier
        url
        scale
        thumbnails {
          type
          url
        }
      }
    }
    ... on LayerStyle {
      needsContrastingBackground
      files {
        identifier
        url
        scale
        thumbnails {
          type
          url
        }
      }
    }
  }
  ${SymbolFragmentDoc}
`
export const PageDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment PageDetails on Page {
    identifier
    uuid
    name
  }
`
export const ShareMetaFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareMeta on PaginationMeta {
    after
    limit
    totalCount
  }
`
export const ShareSettingsFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareSettings on Share {
    description
    shareType
    commentsEnabled
    userCanInspect
    updatedAt
  }
`
export const ShareViewerHasUnacceptedMembershipInviteFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareViewerHasUnacceptedMembershipInvite on Share {
    userHasUnacceptedInvitationToView
  }
`
export const ShareListItemBaseFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareListItemBase on Share {
    identifier
    name
    shareType
    userCanUpdateSettings
    createdAt
    updatedAt
    deletedAt
    archivedAt
    sharePrivacyIcon
    publicAccessLevel
    pinnedByCurrentUserAt
    isOptimistic @client
  }
`
export const SubscriptionShareFragmentDoc = /*#__PURE__*/ gql`
  fragment SubscriptionShare on Share {
    identifier
    workspace {
      identifier
    }
    ...ShareListItemBase
    project {
      ...Project
    }
  }
  ${ShareListItemBaseFragmentDoc}
  ${ProjectFragmentDoc}
`
export const ShareDropdownOptionsBaseFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareDropdownOptionsBase on Share {
    userCanEdit
    userCanInspect
    userCanLeaveShare
    userAccessLevel
    userCanPublish
    commentsEnabled
    publicAccessLevel
    pinnedByCurrentUserAt
    workspace {
      identifier
    }
    subscriptionStatus
    publicCommentsEnabled
    publicInspectEnabled
    publication {
      identifier
    }
  }
`
export const DocumentDownloadFragmentDoc = /*#__PURE__*/ gql`
  fragment DocumentDownload on Document {
    url
    downloadAvailable
    downloadUnavailableError
    userCanOpenInApp
  }
`
export const ShareDropdownOptionsFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareDropdownOptions on Share {
    identifier
    ...ShareDropdownOptionsBase
    version(shortId: $versionShortId) {
      shortId
      identifier
      document {
        identifier
        sketchVersion
        ...DocumentDownload
      }
    }
  }
  ${ShareDropdownOptionsBaseFragmentDoc}
  ${DocumentDownloadFragmentDoc}
`
export const ShareWorkspaceFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareWorkspace on Share {
    identifier
    workspace {
      identifier
      userRole
    }
  }
`
export const ArtboardThumbnailsFragmentDoc = /*#__PURE__*/ gql`
  fragment ArtboardThumbnails on File {
    thumbnails {
      type
      url
    }
  }
`
export const ArtboardDetailInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment ArtboardDetailInfo on Artboard {
    shortId
    documentVersionShortId
    permanentArtboardShortId
    revisionIdentifier
    files(type: FULL) {
      identifier
      url
      scale
      ...ArtboardThumbnails
    }
    ...FrameGroupDetails
    ...AnnotationFrameGroupInfo
  }
  ${ArtboardThumbnailsFragmentDoc}
  ${FrameGroupDetailsFragmentDoc}
  ${AnnotationFrameGroupInfoFragmentDoc}
`
export const FrameDetailInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment FrameDetailInfo on Frame {
    ...FrameGroupDetails
  }
  ${FrameGroupDetailsFragmentDoc}
`
export const ShareAboutFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareAbout on Share {
    identifier
    description
    name
    commentsEnabled
    shareType
    userIsMember
    userCanInspect
    userCanUpdateSettings
    userAccessLevel
    updatedAt
    subscriptionStatus
    publication {
      identifier
    }
    workspace {
      identifier
      userIsMember
    }
    version(shortId: $versionShortId) {
      identifier
      shortId
      kind
      userIsCreator
      creator {
        identifier
        name
        avatar {
          small
        }
      }
      document {
        identifier
        pages(limit: 1) {
          entries {
            uuid
          }
          meta {
            totalCount
          }
        }
        prototypes: frames(limit: 3, filter: PROTOTYPE) {
          entries {
            ... on Artboard {
              ...ArtboardDetailInfo
            }
            ... on Frame {
              ...FrameDetailInfo
            }
          }
          meta {
            totalCount
          }
        }
        componentCount {
          colorVar
          layerStyle
          symbol
          textStyle
        }
      }
    }
  }
  ${ArtboardDetailInfoFragmentDoc}
  ${FrameDetailInfoFragmentDoc}
`
export const SharePublicationFragmentDoc = /*#__PURE__*/ gql`
  fragment SharePublication on Share {
    identifier
    name
    version {
      shortId
      identifier
      document {
        identifier
        previewFile {
          ...ShareThumbnails
        }
      }
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const ShareSubscriptionStatusFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareSubscriptionStatus on Share {
    subscriptionStatus
  }
`
export const ShareUserAccessLevelFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareUserAccessLevel on Share {
    userAccessLevel
  }
`
export const SharePublicPermissionsFragmentDoc = /*#__PURE__*/ gql`
  fragment SharePublicPermissions on Share {
    identifier
    name
    publicAccessLevel
    publicCommentsEnabled
    publicInspectEnabled
    userCanUpdateCommentsEnabled
    sharePrivacyIcon
    userCanPublish
    publication {
      identifier
    }
  }
`
export const ShareDropdownOptionsPreloadFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareDropdownOptionsPreload on Share {
    identifier
    ...ShareDropdownOptionsBase
    version(preferredState: PROCESSED) {
      shortId
      identifier
      document {
        identifier
        sketchVersion
        ...DocumentDownload
      }
    }
  }
  ${ShareDropdownOptionsBaseFragmentDoc}
  ${DocumentDownloadFragmentDoc}
`
export const SharePermissionsFragmentDoc = /*#__PURE__*/ gql`
  fragment SharePermissions on Share {
    ...ShareDropdownOptionsPreload
    parentAccessLevel
    updatedAt
    userCanInspect
    userCanUpdateParentPermissions
    userCanUpdateSettings
    versionTypeAvailableToUser
  }
  ${ShareDropdownOptionsPreloadFragmentDoc}
`
export const ShareBaseFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareBase on Share {
    ...ShareListItemBase
    ...ShareSubscriptionStatus
    ...ShareUserAccessLevel
    ...SharePublicPermissions
    ...ShareDropdownOptionsBase
    ...SharePermissions
    shareType
    userCanUpdateCommentsEnabled
    userCanLeaveShare
    createdAt
    updatedAt
    deletedAt
    sharePrivacyIcon
    publicUrl
    allowedParentAccessLevels
    parentAccessLevel
    userCanUpdateParentPermissions
    isShared
    isDraft
    userIsMember
    isSharedWithGuests
    memberships {
      meta {
        totalCount
      }
    }
    description
    commentsEnabled
    userIsWatching
    userHasUnacceptedInvitationToView
    unreadCount
    versionTypeAvailableToUser
  }
  ${ShareListItemBaseFragmentDoc}
  ${ShareSubscriptionStatusFragmentDoc}
  ${ShareUserAccessLevelFragmentDoc}
  ${SharePublicPermissionsFragmentDoc}
  ${ShareDropdownOptionsBaseFragmentDoc}
  ${SharePermissionsFragmentDoc}
`
export const PublicWorkspaceSsoIdentityFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicWorkspaceSSOIdentity on PublicWorkspace {
    identifier
    name
    userRole
    customer {
      identifier
      ssoEnabled
      ssoStartUrl
    }
  }
`
export const PublicWorkspaceFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicWorkspace on PublicWorkspace {
    ...PublicWorkspaceSSOIdentity
    identifier
    name
    userIsMember
    userRole
    userIsOwner
    type
    avatar {
      small
      large
    }
  }
  ${PublicWorkspaceSsoIdentityFragmentDoc}
`
export const VersionListItemFragmentDoc = /*#__PURE__*/ gql`
  fragment VersionListItem on Version {
    identifier
    shortId
    kind
    createdAt
    userIsCreator
    createdAfterVersioning
    updatedAt
    deletedAt
    description
    hasComponentManifest
    presentationStatus
    creator {
      identifier
      name
      avatar {
        small
      }
    }
    document {
      identifier
      ...DocumentDownload
      renderStatus
      colorspace
      size
      sketchVersion
      previewFile {
        identifier
        width
        height
        url
        ...ShareThumbnails
      }
    }
  }
  ${DocumentDownloadFragmentDoc}
  ${ShareThumbnailsFragmentDoc}
`
export const DownloadableAssetFragmentDoc = /*#__PURE__*/ gql`
  fragment DownloadableAsset on DownloadableAsset {
    __typename
    identifier
    status
    fileName
    fileSizeInBytes
    path
    layerUuids
  }
`
export const DocumentDownloadableAssetsFragmentDoc = /*#__PURE__*/ gql`
  fragment DocumentDownloadableAssets on Document {
    __typename
    identifier
    assetStatus
    downloadableAssets {
      ...DownloadableAsset
    }
  }
  ${DownloadableAssetFragmentDoc}
`
export const VersionDocumentFragmentDoc = /*#__PURE__*/ gql`
  fragment VersionDocument on Document {
    identifier
    ...DocumentDownload
    renderStatus
    colorspace
    size
    sketchVersion
    downloadUnavailableError
    name
    isPresent
    pageCount
    frameCount
    documentVersion
    coeditCompatibilityVersion
    canEditDescriptions
    uuid
    ...DocumentDownloadableAssets
    pages(limit: 1) {
      entries {
        uuid
      }
    }
  }
  ${DocumentDownloadFragmentDoc}
  ${DocumentDownloadableAssetsFragmentDoc}
`
export const VersionFragmentDoc = /*#__PURE__*/ gql`
  fragment Version on Version {
    ...VersionListItem
    document {
      ...VersionDocument
      previewFile {
        identifier
        width
        height
        url
        ...ShareThumbnails
      }
    }
  }
  ${VersionListItemFragmentDoc}
  ${VersionDocumentFragmentDoc}
  ${ShareThumbnailsFragmentDoc}
`
export const ProjectListCountsFragmentDoc = /*#__PURE__*/ gql`
  fragment ProjectListCounts on Project {
    identifier
    sharesCount
    nestedProjectsCount
  }
`
export const ProjectSharePreviewFragmentDoc = /*#__PURE__*/ gql`
  fragment ProjectSharePreview on ProjectSharePreview {
    shareIdentifier
    name
    file {
      ...ShareThumbnails
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const ProjectPreviewFragmentDoc = /*#__PURE__*/ gql`
  fragment ProjectPreview on Project {
    ...ProjectListCounts
    previews {
      ...ProjectSharePreview
    }
  }
  ${ProjectListCountsFragmentDoc}
  ${ProjectSharePreviewFragmentDoc}
`
export const NestedProjectFragmentDoc = /*#__PURE__*/ gql`
  fragment NestedProject on Project {
    ...Project
    ...ProjectPreview
  }
  ${ProjectFragmentDoc}
  ${ProjectPreviewFragmentDoc}
`
export const ProjectDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment ProjectDetails on Project {
    ...NestedProject
    workspace {
      identifier
      name
    }
    parentProjects {
      ...Project
      nestedProjectsCount
    }
    parentProject {
      ...NestedProject
    }
  }
  ${NestedProjectFragmentDoc}
  ${ProjectFragmentDoc}
`
export const ShareInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareInfo on Share {
    ...ShareBase
    workspace {
      ...PublicWorkspace
      customer {
        ssoEnabled
      }
    }
    version(preferredState: PROCESSED) {
      ...Version
      document {
        previewFile {
          ...ShareThumbnails
        }
      }
    }
    project {
      ...ProjectDetails
    }
  }
  ${ShareBaseFragmentDoc}
  ${PublicWorkspaceFragmentDoc}
  ${VersionFragmentDoc}
  ${ShareThumbnailsFragmentDoc}
  ${ProjectDetailsFragmentDoc}
`
export const ShareWithSizeFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareWithSize on ShareWithSize {
    size
    share {
      ...ShareInfo
      versions {
        meta {
          totalCount
        }
      }
    }
  }
  ${ShareInfoFragmentDoc}
`
export const ShareUserRelatedFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareUserRelatedFields on Share {
    identifier
    commentsEnabled
    userCanEdit
    userCanInspect
    userCanUpdateSettings
    userAccessLevel
  }
`
export const ShareWithPublicationFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareWithPublication on Share {
    identifier
    name
    publication {
      identifier
    }
    version(preferredState: PROCESSED) {
      identifier
      shortId
      document {
        identifier
        previewFile {
          ...ShareThumbnails
        }
      }
      createdAt
    }
    updatedAt
  }
  ${ShareThumbnailsFragmentDoc}
`
export const ShareMembershipInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareMembershipInfo on ShareMembership {
    identifier
    email
    acceptedAt
    inviteStatus
    privateAccessLevel
    guestCommentsEnabled
    guestInspectEnabled
    userCanUpdateCommentsEnabled
    workspaceMembership {
      identifier
      role
      user {
        identifier
        name
        email
        avatar {
          small
        }
      }
    }
  }
`
export const UserAccessShareMembershipFragmentDoc = /*#__PURE__*/ gql`
  fragment UserAccessShareMembership on ShareMembership {
    ...ShareMembershipInfo
    share {
      ...ShareInfo
    }
  }
  ${ShareMembershipInfoFragmentDoc}
  ${ShareInfoFragmentDoc}
`
export const ShareGroupMembershipInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareGroupMembershipInfo on PermissionGroupRelationShare {
    identifier
    accessLevel
    permissionGroup {
      ...WorkspacePermissionGroup
    }
  }
  ${WorkspacePermissionGroupFragmentDoc}
`
export const TrashedShareFragmentDoc = /*#__PURE__*/ gql`
  fragment TrashedShare on TrashedShare {
    identifier
    deletedAt
    updatedAt
    name
    userAccessLevel
    shareType
    sharePrivacyIcon
    userAccessLevel
    version {
      identifier
      userIsCreator
      shortId
      kind
      createdAt
      updatedAt
      document {
        identifier
        downloadAvailable
        url
        renderStatus
        previewFile {
          identifier
          width
          height
          url
          ...ShareThumbnails
        }
      }
      creator {
        identifier
        name
        avatar {
          small
        }
      }
    }
    workspace {
      identifier
      userRole
    }
    project {
      ...Project
    }
  }
  ${ShareThumbnailsFragmentDoc}
  ${ProjectFragmentDoc}
`
export const IdentityProviderConfigFragmentDoc = /*#__PURE__*/ gql`
  fragment IdentityProviderConfig on IdentityProviderConfig {
    binding
    certificate
    entityId
    ssoUrl
  }
`
export const AttributeMappingEntryFragmentDoc = /*#__PURE__*/ gql`
  fragment AttributeMappingEntry on AttributeMappingEntry {
    fullName {
      firstName
      surname
      updateOnLogin
    }
    email {
      mapping
      updateOnLogin
    }
  }
`
export const WorkspaceSsoConfigFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceSsoConfig on WorkspaceSsoConfig {
    acsUrl
    serviceProviderEntityId
    config {
      ...IdentityProviderConfig
    }
    attributeMapping {
      ...AttributeMappingEntry
    }
  }
  ${IdentityProviderConfigFragmentDoc}
  ${AttributeMappingEntryFragmentDoc}
`
export const SharesListVersionItemFragmentDoc = /*#__PURE__*/ gql`
  fragment SharesListVersionItem on Version {
    identifier
    shortId
    kind
    createdAt
    updatedAt
    userIsCreator
    creator {
      identifier
      name
      avatar {
        small
      }
    }
    document {
      identifier
      renderStatus
      previewFile {
        identifier
        url
        ...ShareThumbnails
      }
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const ShareListItemFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareListItem on Share {
    ...ShareListItemBase
    version(preferredState: PROCESSED) {
      ...SharesListVersionItem
    }
    project {
      ...Project
    }
  }
  ${ShareListItemBaseFragmentDoc}
  ${SharesListVersionItemFragmentDoc}
  ${ProjectFragmentDoc}
`
export const StorageItemFragmentDoc = /*#__PURE__*/ gql`
  fragment StorageItem on StorageItem {
    ... on Project {
      ...NestedProject
    }
    ... on Share {
      ...ShareListItem
    }
  }
  ${NestedProjectFragmentDoc}
  ${ShareListItemFragmentDoc}
`
export const StorageItemDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment StorageItemDetails on StorageItem {
    ... on Project {
      ...ProjectDetails
    }
    ... on Share {
      ...ShareInfo
    }
  }
  ${ProjectDetailsFragmentDoc}
  ${ShareInfoFragmentDoc}
`
export const StorageItemsPaginationMetaFragmentDoc = /*#__PURE__*/ gql`
  fragment StorageItemsPaginationMeta on StorageItemsPaginationMeta {
    after
    totalCount
    sharesCount
    nestedProjectsCount
  }
`
export const PublicWorkspaceMinimalIdentityFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicWorkspaceMinimalIdentity on PublicWorkspace {
    identifier
    name
    avatar {
      small
      large
    }
  }
`
export const UserNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment UserNotification on UserNotification {
    __typename
    identifier
    createdAt
    state
    isPinned
    title
    subtitle
    path
    user {
      identifier
      name
      avatar {
        small
      }
    }
    workspace {
      ...PublicWorkspaceMinimalIdentity
    }
  }
  ${PublicWorkspaceMinimalIdentityFragmentDoc}
`
export const NotificationCommentFragmentDoc = /*#__PURE__*/ gql`
  fragment NotificationComment on Comment {
    identifier
    body
    annotation {
      identifier
      subscriptionStatus
      firstComment {
        identifier
      }
      currentSubject {
        ... on Artboard {
          permanentArtboardShortId
          documentVersionShortId
          nameArtboard: name
        }
        ... on Page {
          identifier
          uuid
          name
        }
      }
    }
  }
`
export const CommentNotificationDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment CommentNotificationDetails on CommentNotification {
    comment {
      ...NotificationComment
    }
    share {
      identifier
      name
      subscriptionStatus
      previewFiles {
        ...ShareThumbnails
      }
      workspace {
        identifier
        name
      }
      version {
        identifier
        shortId
      }
    }
    previews {
      identifier
      url
    }
    artboard {
      identifier
      shortId
      name
      documentVersionShortId
      permanentArtboardShortId
      files(type: FULL) {
        identifier
        url
        size
        thumbnails {
          type
          url
        }
      }
      ...AnnotationFrameGroupInfo
    }
  }
  ${NotificationCommentFragmentDoc}
  ${ShareThumbnailsFragmentDoc}
  ${AnnotationFrameGroupInfoFragmentDoc}
`
export const CommentNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment CommentNotification on CommentNotification {
    ...UserNotification
    ...CommentNotificationDetails
  }
  ${UserNotificationFragmentDoc}
  ${CommentNotificationDetailsFragmentDoc}
`
export const MentionNotificationDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment MentionNotificationDetails on MentionNotification {
    comment {
      ...NotificationComment
    }
    share {
      identifier
      name
      subscriptionStatus
      previewFiles {
        ...ShareThumbnails
      }
      workspace {
        identifier
        name
      }
      version {
        identifier
        shortId
      }
    }
    previews {
      identifier
      url
    }
    artboard {
      identifier
      shortId
      name
      documentVersionShortId
      permanentArtboardShortId
      files(type: FULL) {
        identifier
        url
        size
        thumbnails {
          type
          url
        }
      }
    }
  }
  ${NotificationCommentFragmentDoc}
  ${ShareThumbnailsFragmentDoc}
`
export const MentionNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment MentionNotification on MentionNotification {
    ...UserNotification
    ...MentionNotificationDetails
  }
  ${UserNotificationFragmentDoc}
  ${MentionNotificationDetailsFragmentDoc}
`
export const StarNotificationDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment StarNotificationDetails on StarNotification {
    share {
      identifier
      name
      subscriptionStatus
      previewFiles {
        ...ShareThumbnails
      }
      workspace {
        identifier
        name
      }
      version {
        identifier
        shortId
      }
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const StarNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment StarNotification on StarNotification {
    ...UserNotification
    ...StarNotificationDetails
  }
  ${UserNotificationFragmentDoc}
  ${StarNotificationDetailsFragmentDoc}
`
export const AddShareMemberNotificationDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment AddShareMemberNotificationDetails on AddShareMemberNotification {
    token
    share {
      identifier
      name
      userHasUnacceptedInvitationToView
      subscriptionStatus
      previewFiles {
        ...ShareThumbnails
      }
      workspace {
        identifier
        name
      }
      project {
        identifier
        name
      }
      version {
        identifier
        shortId
      }
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const AddShareMemberNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment AddShareMemberNotification on AddShareMemberNotification {
    ...UserNotification
    ...AddShareMemberNotificationDetails
  }
  ${UserNotificationFragmentDoc}
  ${AddShareMemberNotificationDetailsFragmentDoc}
`
export const DownloadableAssetRenderedNotificationDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment DownloadableAssetRenderedNotificationDetails on DownloadableAssetRenderedNotification {
    share {
      identifier
      name
      subscriptionStatus
      workspace {
        identifier
        name
      }
      project {
        identifier
        name
      }
    }
    notifiedVersion {
      identifier
      shortId
      document {
        ...DocumentDownloadableAssets
        previewFile {
          ...ShareThumbnails
        }
      }
    }
  }
  ${DocumentDownloadableAssetsFragmentDoc}
  ${ShareThumbnailsFragmentDoc}
`
export const DownloadableAssetRenderedNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment DownloadableAssetRenderedNotification on DownloadableAssetRenderedNotification {
    ...UserNotification
    ...DownloadableAssetRenderedNotificationDetails
  }
  ${UserNotificationFragmentDoc}
  ${DownloadableAssetRenderedNotificationDetailsFragmentDoc}
`
export const FolderArchivedNotificationDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment FolderArchivedNotificationDetails on FolderArchivedNotification {
    folder {
      identifier
      name
      projectPrivacyIcon
      projectType
      previews {
        name
        file {
          ...ShareThumbnails
        }
      }
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const FolderArchivedNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment FolderArchivedNotification on FolderArchivedNotification {
    ...UserNotification
    ...FolderArchivedNotificationDetails
  }
  ${UserNotificationFragmentDoc}
  ${FolderArchivedNotificationDetailsFragmentDoc}
`
export const FolderTrashedNotificationDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment FolderTrashedNotificationDetails on FolderTrashedNotification {
    folder {
      identifier
      name
      projectPrivacyIcon
      projectType
      previews {
        name
        file {
          ...ShareThumbnails
        }
      }
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const FolderTrashedNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment FolderTrashedNotification on FolderTrashedNotification {
    ...UserNotification
    ...FolderTrashedNotificationDetails
  }
  ${UserNotificationFragmentDoc}
  ${FolderTrashedNotificationDetailsFragmentDoc}
`
export const FolderRestoredNotificationDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment FolderRestoredNotificationDetails on FolderRestoredNotification {
    folder {
      identifier
      name
      projectPrivacyIcon
      projectType
      previews {
        name
        file {
          ...ShareThumbnails
        }
      }
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const FolderRestoredNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment FolderRestoredNotification on FolderRestoredNotification {
    ...UserNotification
    ...FolderRestoredNotificationDetails
  }
  ${UserNotificationFragmentDoc}
  ${FolderRestoredNotificationDetailsFragmentDoc}
`
export const AddProjectMemberNotificationDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment AddProjectMemberNotificationDetails on AddProjectMemberNotification {
    folder {
      identifier
      name
      projectPrivacyIcon
      projectType
      previews {
        name
        file {
          ...ShareThumbnails
        }
      }
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const AddProjectMemberNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment AddProjectMemberNotification on AddProjectMemberNotification {
    ...UserNotification
    ...AddProjectMemberNotificationDetails
  }
  ${UserNotificationFragmentDoc}
  ${AddProjectMemberNotificationDetailsFragmentDoc}
`
export const FolderPermanentlyDeletedNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment FolderPermanentlyDeletedNotification on FolderPermanentlyDeletedNotification {
    ...UserNotification
  }
  ${UserNotificationFragmentDoc}
`
export const WorkspaceInvitedNotificationDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceInvitedNotificationDetails on WorkspaceInvitedNotification {
    token
    membership {
      identifier
      acceptedAt
    }
  }
`
export const WorkspaceInvitedNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceInvitedNotification on WorkspaceInvitedNotification {
    ...UserNotification
    ...WorkspaceInvitedNotificationDetails
  }
  ${UserNotificationFragmentDoc}
  ${WorkspaceInvitedNotificationDetailsFragmentDoc}
`
export const WorkspaceInviteAcceptedNotificationDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceInviteAcceptedNotificationDetails on WorkspaceInviteAcceptedNotification {
    membership {
      identifier
      role
      isEditor
    }
  }
`
export const WorkspaceInviteAcceptedNotificationFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceInviteAcceptedNotification on WorkspaceInviteAcceptedNotification {
    ...UserNotification
    ...WorkspaceInviteAcceptedNotificationDetails
  }
  ${UserNotificationFragmentDoc}
  ${WorkspaceInviteAcceptedNotificationDetailsFragmentDoc}
`
export const NotificationInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment NotificationInfo on UserNotification {
    ...UserNotification
    ... on CommentNotification {
      ...CommentNotificationDetails
    }
    ... on MentionNotification {
      ...MentionNotificationDetails
    }
    ... on StarNotification {
      ...StarNotificationDetails
    }
    ... on AddShareMemberNotification {
      ...AddShareMemberNotificationDetails
    }
    ... on DownloadableAssetRenderedNotification {
      ...DownloadableAssetRenderedNotificationDetails
    }
    ... on FolderArchivedNotification {
      ...FolderArchivedNotificationDetails
    }
    ... on FolderTrashedNotification {
      ...FolderTrashedNotificationDetails
    }
    ... on FolderRestoredNotification {
      ...FolderRestoredNotificationDetails
    }
    ... on WorkspaceInvitedNotification {
      ...WorkspaceInvitedNotificationDetails
    }
    ... on WorkspaceInviteAcceptedNotification {
      ...WorkspaceInviteAcceptedNotificationDetails
    }
    ... on AddProjectMemberNotification {
      ...AddProjectMemberNotificationDetails
    }
  }
  ${UserNotificationFragmentDoc}
  ${CommentNotificationDetailsFragmentDoc}
  ${MentionNotificationDetailsFragmentDoc}
  ${StarNotificationDetailsFragmentDoc}
  ${AddShareMemberNotificationDetailsFragmentDoc}
  ${DownloadableAssetRenderedNotificationDetailsFragmentDoc}
  ${FolderArchivedNotificationDetailsFragmentDoc}
  ${FolderTrashedNotificationDetailsFragmentDoc}
  ${FolderRestoredNotificationDetailsFragmentDoc}
  ${WorkspaceInvitedNotificationDetailsFragmentDoc}
  ${WorkspaceInviteAcceptedNotificationDetailsFragmentDoc}
  ${AddProjectMemberNotificationDetailsFragmentDoc}
`
export const CommentNotificationListDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment CommentNotificationListDetails on CommentNotification {
    comment {
      identifier
      annotation {
        identifier
        subscriptionStatus
      }
    }
    share {
      identifier
      name
      subscriptionStatus
      previewFiles {
        ...ShareThumbnails
      }
      version {
        identifier
        shortId
      }
    }
    artboard {
      identifier
      permanentArtboardShortId
      documentVersionShortId
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const MentionNotificationListDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment MentionNotificationListDetails on MentionNotification {
    comment {
      identifier
      annotation {
        identifier
        subscriptionStatus
      }
    }
    share {
      identifier
      name
      subscriptionStatus
      previewFiles {
        ...ShareThumbnails
      }
      version {
        identifier
        shortId
      }
    }
    artboard {
      identifier
      permanentArtboardShortId
      documentVersionShortId
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const StarNotificationListDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment StarNotificationListDetails on StarNotification {
    share {
      identifier
      name
      previewFiles {
        ...ShareThumbnails
      }
      version {
        identifier
        shortId
      }
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const DownloadableAssetRenderedListDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment DownloadableAssetRenderedListDetails on DownloadableAssetRenderedNotification {
    share {
      identifier
      name
    }
    notifiedVersion {
      identifier
      shortId
      document {
        identifier
        previewFile {
          ...ShareThumbnails
        }
        downloadableAssets {
          identifier
          status
          path
        }
      }
    }
  }
  ${ShareThumbnailsFragmentDoc}
`
export const NotificationListInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment NotificationListInfo on UserNotification {
    ...UserNotification
    ... on CommentNotification {
      ...CommentNotificationListDetails
    }
    ... on MentionNotification {
      ...MentionNotificationListDetails
    }
    ... on StarNotification {
      ...StarNotificationListDetails
    }
    ... on DownloadableAssetRenderedNotification {
      ...DownloadableAssetRenderedListDetails
    }
    ... on FolderArchivedNotification {
      ...FolderArchivedNotificationDetails
    }
    ... on FolderTrashedNotification {
      ...FolderTrashedNotificationDetails
    }
    ... on FolderRestoredNotification {
      ...FolderRestoredNotificationDetails
    }
    ... on AddProjectMemberNotification {
      ...AddProjectMemberNotificationDetails
    }
    ... on WorkspaceInviteAcceptedNotification {
      ...WorkspaceInviteAcceptedNotificationDetails
    }
  }
  ${UserNotificationFragmentDoc}
  ${CommentNotificationListDetailsFragmentDoc}
  ${MentionNotificationListDetailsFragmentDoc}
  ${StarNotificationListDetailsFragmentDoc}
  ${DownloadableAssetRenderedListDetailsFragmentDoc}
  ${FolderArchivedNotificationDetailsFragmentDoc}
  ${FolderTrashedNotificationDetailsFragmentDoc}
  ${FolderRestoredNotificationDetailsFragmentDoc}
  ${AddProjectMemberNotificationDetailsFragmentDoc}
  ${WorkspaceInviteAcceptedNotificationDetailsFragmentDoc}
`
export const ShareMemberInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareMemberInfo on PublicUser {
    identifier
    name
    avatar {
      small
    }
  }
`
export const NotificationStatusFragmentDoc = /*#__PURE__*/ gql`
  fragment NotificationStatus on User {
    identifier
    hasUnreadNotifications
  }
`
export const UserEmailFragmentDoc = /*#__PURE__*/ gql`
  fragment UserEmail on User {
    identifier
    email
  }
`
export const UserPreferencesFragmentDoc = /*#__PURE__*/ gql`
  fragment UserPreferences on User {
    identifier
    preferences {
      showOnboardingFirstSteps
      showStorageLimitChanges
    }
  }
`
export const UserFragmentDoc = /*#__PURE__*/ gql`
  fragment User on User {
    email
    identifier
    name
    personalIdentityEmail
    isVerified
    isSuperadmin
    isPartner
    isWebSignup
    hasAvatar
    avatar {
      small
    }
    receiveEmailNotifications
    hasAcceptedAgreement
    eligibleForWorkspaceTrial
    ...UserPreferences
  }
  ${UserPreferencesFragmentDoc}
`
export const UserFeatureFlagsFragmentDoc = /*#__PURE__*/ gql`
  fragment UserFeatureFlags on User {
    identifier
    featureFlags
  }
`
export const InitialUserFragmentDoc = /*#__PURE__*/ gql`
  fragment InitialUser on User {
    identifier
    hasPersonalIdentity
    isPaasAdmin
    mfaState
    signInOptions
    avatar {
      small
      large
    }
    ...User
    ...UserFeatureFlags
  }
  ${UserFragmentDoc}
  ${UserFeatureFlagsFragmentDoc}
`
export const WorkspaceMinimalIdentityFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceMinimalIdentity on Workspace {
    identifier
    name
    avatar {
      small
    }
  }
`
export const WorkspaceSsoIdentityFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceSSOIdentity on Workspace {
    identifier
    name
    userRole
    customer {
      identifier
      ssoEnabled
      ssoStartUrl
      tosAgreed
    }
  }
`
export const WorkspaceMinimalFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceMinimal on Workspace {
    ...WorkspaceMinimalIdentity
    ...WorkspaceSSOIdentity
    type
    avatar {
      large
    }
    status
    userCanEdit
    userCanAdminister
    userRole
    userIsOwner
    status
    type
    features {
      restrictedPublicLinks
      workspaceProfileEnabled
      permissionGroupsEnabled
      archiveEnabled
      unlimitedStorageEnabled
      unlimitedTrialEnabled
      encryptionEnabled
      accountLinkingEnabled
    }
  }
  ${WorkspaceMinimalIdentityFragmentDoc}
  ${WorkspaceSsoIdentityFragmentDoc}
`
export const UserWorkspaceMembershipFragmentDoc = /*#__PURE__*/ gql`
  fragment UserWorkspaceMembership on WorkspaceMembership {
    identifier
    role
    isEditor
    acceptedAt
    workspace {
      ...WorkspaceMinimal
      customer {
        identifier
        source
        billing {
          status
          trialEnd
          subscriptionSetUp
        }
      }
    }
    user {
      identifier
      email
    }
  }
  ${WorkspaceMinimalFragmentDoc}
`
export const UserActiveSessionFragmentDoc = /*#__PURE__*/ gql`
  fragment UserActiveSession on Session {
    id
    lastUpdateAt
    type
    ipAddress
    countryCode
    deviceName
    userAgent
    isCurrentOne
  }
`
export const UserNotificationCountFragmentDoc = /*#__PURE__*/ gql`
  fragment UserNotificationCount on User {
    identifier
    unreadNotificationsCount: notifications(
      filter: { states: [UNREAD] }
      sortOrder: CREATED_AT_DESC
      limit: 1
    ) {
      meta {
        totalCount
      }
      entries {
        identifier
      }
    }
  }
`
export const ReadShareFragmentDoc = /*#__PURE__*/ gql`
  fragment ReadShare on Share {
    identifier
  }
`
export const ArtboardRevisionFragmentDoc = /*#__PURE__*/ gql`
  fragment ArtboardRevision on Revision {
    identifier
    kind
    creator {
      identifier
      name
    }
    userIsCreator
    createdAt
    version {
      identifier
      shortId
      description
      kind
    }
    frame {
      ... on Artboard {
        permanentArtboardShortId
        documentVersionShortId
        uuid
      }
      ... on Frame {
        identifier
        documentVersionShortId
        uuid
      }
    }
  }
`
export const ArtboardRevisionDeletedFragmentDoc = /*#__PURE__*/ gql`
  fragment ArtboardRevisionDeleted on RevisionDeleted {
    identifier
    creator {
      name
    }
    userIsCreator
    createdAt
    frameIdentifier
  }
`
export const ArtboardRevisionUnavailableFragmentDoc = /*#__PURE__*/ gql`
  fragment ArtboardRevisionUnavailable on RevisionUnavailable {
    identifier
    creator {
      name
    }
    userIsCreator
    createdAt
  }
`
export const FrameGroupRevisionFragmentDoc = /*#__PURE__*/ gql`
  fragment FrameGroupRevision on Revision {
    identifier
    kind
    creator {
      identifier
      name
    }
    userIsCreator
    createdAt
    version {
      identifier
      shortId
      description
      kind
    }
    frame {
      identifier
      ... on Artboard {
        permanentArtboardShortId
      }
      documentVersionShortId
      uuid
    }
  }
`
export const FrameGroupRevisionDeletedFragmentDoc = /*#__PURE__*/ gql`
  fragment FrameGroupRevisionDeleted on RevisionDeleted {
    identifier
    creator {
      name
    }
    userIsCreator
    createdAt
    frameIdentifier
  }
`
export const FrameGroupRevisionUnavailableFragmentDoc = /*#__PURE__*/ gql`
  fragment FrameGroupRevisionUnavailable on RevisionUnavailable {
    identifier
    creator {
      name
    }
    userIsCreator
    createdAt
  }
`
export const ShareLatestStarredVersionFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareLatestStarredVersion on Share {
    identifier
    lastStarredVersion: version(preferredState: PROCESSED_AND_PUBLISHED) {
      kind
      ...Version
    }
  }
  ${VersionFragmentDoc}
`
export const VersionDeletedFragmentDoc = /*#__PURE__*/ gql`
  fragment VersionDeleted on VersionDeleted {
    identifier
    deletedAtDate: deletedAt
    createdAt
    order
    kind
    shortId
    creator {
      identifier
      name
    }
    userIsCreator
  }
`
export const VersionUnavailableFragmentDoc = /*#__PURE__*/ gql`
  fragment VersionUnavailable on VersionUnavailable {
    identifier
    createdAt
    creator {
      identifier
      name
    }
    userIsCreator
  }
`
export const VersionUnavailableWithOrderFragmentDoc = /*#__PURE__*/ gql`
  fragment VersionUnavailableWithOrder on VersionUnavailable {
    ...VersionUnavailable
    order
  }
  ${VersionUnavailableFragmentDoc}
`
export const VersionListItemWithOrderFragmentDoc = /*#__PURE__*/ gql`
  fragment VersionListItemWithOrder on Version {
    ...VersionListItem
    order
  }
  ${VersionListItemFragmentDoc}
`
export const ShareVersionHistoryFragmentDoc = /*#__PURE__*/ gql`
  fragment ShareVersionHistory on Share {
    identifier
    workspace {
      identifier
    }
    availableVersions: versionHistory(include: [VERSION]) {
      meta {
        totalCount
      }
    }
    ...ShareLatestStarredVersion
    versionHistory(
      after: $after
      limit: $limit
      include: [VERSION, VERSION_UNAVAILABLE]
    ) {
      entries {
        ...VersionDeleted
        ...VersionUnavailableWithOrder
        ...VersionListItemWithOrder
      }
      meta {
        totalCount
        after
      }
    }
  }
  ${ShareLatestStarredVersionFragmentDoc}
  ${VersionDeletedFragmentDoc}
  ${VersionUnavailableWithOrderFragmentDoc}
  ${VersionListItemWithOrderFragmentDoc}
`
export const BillingMinimalFragmentDoc = /*#__PURE__*/ gql`
  fragment BillingMinimal on Billing {
    status
    subscriptionEnd
  }
`
export const BillingWorkspaceNoticeFragmentDoc = /*#__PURE__*/ gql`
  fragment BillingWorkspaceNotice on Billing {
    status
    subscriptionEnd
    trialEnd
    subscriptionSetUp
  }
`
export const BillingDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment BillingDetails on BillingDetails {
    name
    email
    address {
      line1
      city
      state
      country
      postalCode
    }
    taxId {
      id
      status
    }
  }
`
export const PriceFragmentDoc = /*#__PURE__*/ gql`
  fragment Price on Price {
    amount
    currency
  }
`
export const CouponMinimalFragmentDoc = /*#__PURE__*/ gql`
  fragment CouponMinimal on CouponInfo {
    promotionCode
    percentOff
    endDate
  }
`
export const BillingHistoryEntryFragmentDoc = /*#__PURE__*/ gql`
  fragment BillingHistoryEntry on BillingHistoryEntry {
    id
    price {
      ...Price
    }
    description
    createdAt
    ... on CustomerInvoice {
      pdf
      couponInfo {
        ...CouponMinimal
      }
    }
    ... on CreditTransaction {
      licenseRedemption {
        serial
        months
        seats
        credits
      }
    }
  }
  ${PriceFragmentDoc}
  ${CouponMinimalFragmentDoc}
`
export const BillingPlanFragmentDoc = /*#__PURE__*/ gql`
  fragment BillingPlan on BillingPlan {
    id
    name
    type
    product
    prices {
      invoice
      monthly
      currency
    }
  }
`
export const AppStoreBillingPlanFragmentDoc = /*#__PURE__*/ gql`
  fragment AppStoreBillingPlan on AppStoreBillingPlan {
    id
    type
  }
`
export const CloudBillingPlanFragmentDoc = /*#__PURE__*/ gql`
  fragment CloudBillingPlan on CloudBillingPlan {
    id
    name
    type
    product
    prices {
      invoice
      monthly
      currency
    }
  }
`
export const BillingPlanInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment BillingPlanInfo on BillingPlanInfo {
    ... on AppStoreBillingPlan {
      ...AppStoreBillingPlan
    }
    ... on CloudBillingPlan {
      ...CloudBillingPlan
    }
  }
  ${AppStoreBillingPlanFragmentDoc}
  ${CloudBillingPlanFragmentDoc}
`
export const SubscriptionInfoPlanFragmentDoc = /*#__PURE__*/ gql`
  fragment SubscriptionInfoPlan on SubscriptionInfo {
    currentPlan {
      ...BillingPlanInfo
    }
  }
  ${BillingPlanInfoFragmentDoc}
`
export const BillingPriceFragmentDoc = /*#__PURE__*/ gql`
  fragment BillingPrice on BillingPrice {
    invoice
    monthly
    currency
  }
`
export const BillingSeatsInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment BillingSeatsInfo on BillingSeatsInfo {
    availableSeats
    usedSeats
    currentSeatsTotal
    scheduledSeatsTotal
  }
`
export const CouponFragmentDoc = /*#__PURE__*/ gql`
  fragment Coupon on CouponInfo {
    promotionCode
    percentOff
    amountOff
    errorCode
  }
`
export const CreditBalanceFragmentDoc = /*#__PURE__*/ gql`
  fragment CreditBalance on CreditBalance {
    amount
    projectedDuration
  }
`
export const IntegrationIdentityFragmentDoc = /*#__PURE__*/ gql`
  fragment IntegrationIdentity on WorkspaceIntegrationIdentity {
    identifier
    createdAt
    integration {
      integrationProvider
    }
  }
`
export const PaymentDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment PaymentDetails on PaymentDetails {
    type
    ... on CreditCardPaymentDetails {
      id
      last4Digits
      brand
      expiration {
        month
        year
      }
    }
  }
`
export const PublicWorkspaceMinimalWithFeatureFlagsFragmentDoc = /*#__PURE__*/ gql`
  fragment PublicWorkspaceMinimalWithFeatureFlags on PublicWorkspace {
    identifier
    ...PublicWorkspaceMinimal
    features {
      accountLinkingEnabled
    }
  }
  ${PublicWorkspaceMinimalFragmentDoc}
`
export const WorkspaceMinimalWithBillingStatusFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceMinimalWithBillingStatus on Workspace {
    ...WorkspaceMinimal
    customer {
      identifier
      billing {
        status
        subscriptionSetUp
      }
    }
  }
  ${WorkspaceMinimalFragmentDoc}
`
export const DuplicationWorkspaceFragmentDoc = /*#__PURE__*/ gql`
  fragment DuplicationWorkspace on Workspace {
    ...WorkspaceMinimalIdentity
    ...WorkspaceSSOIdentity
    status
    userCanEdit
    uploadsRestrictedFor
  }
  ${WorkspaceMinimalIdentityFragmentDoc}
  ${WorkspaceSsoIdentityFragmentDoc}
`
export const DraftsWorkspaceFragmentDoc = /*#__PURE__*/ gql`
  fragment DraftsWorkspace on Workspace {
    ...WorkspaceMinimal
    status
    userCanEdit
    draftsProject: projects(limit: 1, type: PERSONAL_DRAFTS, topLevel: false) {
      entries {
        ...Project
      }
    }
  }
  ${WorkspaceMinimalFragmentDoc}
  ${ProjectFragmentDoc}
`
export const WorkspaceIntegrationManagerFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceIntegrationManager on WorkspaceUser {
    identifier
    email
    name
    avatar {
      large
    }
  }
`
export const IntegrationFragmentDoc = /*#__PURE__*/ gql`
  fragment Integration on WorkspaceIntegration {
    identifier
    createdAt
    integrationProvider
    externalWorkspaceName
    isActive
    managedBy {
      ...WorkspaceIntegrationManager
    }
  }
  ${WorkspaceIntegrationManagerFragmentDoc}
`
export const WorkspaceIntegrationsFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceIntegrations on Workspace {
    identifier
    integrations {
      ...Integration
    }
  }
  ${IntegrationFragmentDoc}
`
export const InvitableUserFragmentDoc = /*#__PURE__*/ gql`
  fragment InvitableUser on WorkspaceMembership {
    isEditor
    role
    identifier
    user {
      identifier
      avatar {
        small
        large
      }
      email
      name
    }
    invite {
      identifier
      email
    }
  }
`
export const InvitableUserEmailFragmentDoc = /*#__PURE__*/ gql`
  fragment InvitableUserEmail on WorkspaceMembership {
    identifier
    user {
      identifier
      email
    }
  }
`
export const WorkspacePermissionGroupMembershipFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspacePermissionGroupMembership on PermissionGroupMembership {
    identifier
    permissionGroup {
      identifier
      ...WorkspacePermissionGroup
    }
  }
  ${WorkspacePermissionGroupFragmentDoc}
`
export const CreateAnnotationDocument = /*#__PURE__*/ gql`
  mutation createAnnotation(
    $shareIdentifier: UUID!
    $body: String!
    $subject: AnnotationSubjectInput!
    $coordinates: AnnotationCoordinatesInput
  ) {
    createAnnotation(
      body: $body
      shareIdentifier: $shareIdentifier
      subject: $subject
      coordinates: $coordinates
    ) {
      annotation {
        isOptimistic @client
        ...BaseAnnotation
        ...AnnotationCoordinatesAndCounters
      }
    }
  }
  ${BaseAnnotationFragmentDoc}
  ${AnnotationCoordinatesAndCountersFragmentDoc}
`
export type CreateAnnotationMutationFn = Apollo.MutationFunction<
  Types.CreateAnnotationMutation,
  Types.CreateAnnotationMutationVariables
>

/**
 * __useCreateAnnotationMutation__
 *
 * To run a mutation, you first call `useCreateAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnotationMutation, { data, loading, error }] = useCreateAnnotationMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      body: // value for 'body'
 *      subject: // value for 'subject'
 *      coordinates: // value for 'coordinates'
 *   },
 * });
 */
export function useCreateAnnotationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreateAnnotationMutation,
    Types.CreateAnnotationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreateAnnotationMutation,
    Types.CreateAnnotationMutationVariables
  >(CreateAnnotationDocument, options)
}
export type CreateAnnotationMutationHookResult = ReturnType<
  typeof useCreateAnnotationMutation
>
export type CreateAnnotationMutationResult =
  Apollo.MutationResult<Types.CreateAnnotationMutation>
export type CreateAnnotationMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateAnnotationMutation,
  Types.CreateAnnotationMutationVariables
>
export const MoveAnnotationDocument = /*#__PURE__*/ gql`
  mutation moveAnnotation(
    $annotationIdentifier: UUID!
    $coordinates: AnnotationCoordinatesInput!
    $subject: AnnotationSubjectInput!
  ) {
    moveAnnotation(
      annotationIdentifier: $annotationIdentifier
      coordinates: $coordinates
      subject: $subject
    ) {
      annotation {
        identifier
        frameUuid
        ...AnnotationCoordinates
        ...AnnotationSubject
        ...AnnotationSubjectCounters
        share {
          identifier
        }
      }
    }
  }
  ${AnnotationCoordinatesFragmentDoc}
  ${AnnotationSubjectFragmentDoc}
  ${AnnotationSubjectCountersFragmentDoc}
`
export type MoveAnnotationMutationFn = Apollo.MutationFunction<
  Types.MoveAnnotationMutation,
  Types.MoveAnnotationMutationVariables
>

/**
 * __useMoveAnnotationMutation__
 *
 * To run a mutation, you first call `useMoveAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveAnnotationMutation, { data, loading, error }] = useMoveAnnotationMutation({
 *   variables: {
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *      coordinates: // value for 'coordinates'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useMoveAnnotationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.MoveAnnotationMutation,
    Types.MoveAnnotationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.MoveAnnotationMutation,
    Types.MoveAnnotationMutationVariables
  >(MoveAnnotationDocument, options)
}
export type MoveAnnotationMutationHookResult = ReturnType<
  typeof useMoveAnnotationMutation
>
export type MoveAnnotationMutationResult =
  Apollo.MutationResult<Types.MoveAnnotationMutation>
export type MoveAnnotationMutationOptions = Apollo.BaseMutationOptions<
  Types.MoveAnnotationMutation,
  Types.MoveAnnotationMutationVariables
>
export const DeleteAnnotationDocument = /*#__PURE__*/ gql`
  mutation deleteAnnotation($identifier: UUID!) {
    deleteAnnotation(annotationIdentifier: $identifier) {
      annotation {
        frameUuid
        ...AnnotationCoordinatesAndCounters
      }
    }
  }
  ${AnnotationCoordinatesAndCountersFragmentDoc}
`
export type DeleteAnnotationMutationFn = Apollo.MutationFunction<
  Types.DeleteAnnotationMutation,
  Types.DeleteAnnotationMutationVariables
>

/**
 * __useDeleteAnnotationMutation__
 *
 * To run a mutation, you first call `useDeleteAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnotationMutation, { data, loading, error }] = useDeleteAnnotationMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useDeleteAnnotationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeleteAnnotationMutation,
    Types.DeleteAnnotationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeleteAnnotationMutation,
    Types.DeleteAnnotationMutationVariables
  >(DeleteAnnotationDocument, options)
}
export type DeleteAnnotationMutationHookResult = ReturnType<
  typeof useDeleteAnnotationMutation
>
export type DeleteAnnotationMutationResult =
  Apollo.MutationResult<Types.DeleteAnnotationMutation>
export type DeleteAnnotationMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteAnnotationMutation,
  Types.DeleteAnnotationMutationVariables
>
export const ResolveAnnotationDocument = /*#__PURE__*/ gql`
  mutation resolveAnnotation($annotationIdentifier: UUID!) {
    resolveAnnotation(annotationIdentifier: $annotationIdentifier) {
      annotation {
        identifier
        ...AnnotationResolutionInfo
        ...AnnotationSubject
      }
    }
  }
  ${AnnotationResolutionInfoFragmentDoc}
  ${AnnotationSubjectFragmentDoc}
`
export type ResolveAnnotationMutationFn = Apollo.MutationFunction<
  Types.ResolveAnnotationMutation,
  Types.ResolveAnnotationMutationVariables
>

/**
 * __useResolveAnnotationMutation__
 *
 * To run a mutation, you first call `useResolveAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveAnnotationMutation, { data, loading, error }] = useResolveAnnotationMutation({
 *   variables: {
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *   },
 * });
 */
export function useResolveAnnotationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ResolveAnnotationMutation,
    Types.ResolveAnnotationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ResolveAnnotationMutation,
    Types.ResolveAnnotationMutationVariables
  >(ResolveAnnotationDocument, options)
}
export type ResolveAnnotationMutationHookResult = ReturnType<
  typeof useResolveAnnotationMutation
>
export type ResolveAnnotationMutationResult =
  Apollo.MutationResult<Types.ResolveAnnotationMutation>
export type ResolveAnnotationMutationOptions = Apollo.BaseMutationOptions<
  Types.ResolveAnnotationMutation,
  Types.ResolveAnnotationMutationVariables
>
export const UnResolveAnnotationDocument = /*#__PURE__*/ gql`
  mutation unResolveAnnotation($annotationIdentifier: UUID!) {
    unresolveAnnotation(annotationIdentifier: $annotationIdentifier) {
      annotation {
        identifier
        ...AnnotationResolutionInfo
        ...AnnotationSubject
      }
    }
  }
  ${AnnotationResolutionInfoFragmentDoc}
  ${AnnotationSubjectFragmentDoc}
`
export type UnResolveAnnotationMutationFn = Apollo.MutationFunction<
  Types.UnResolveAnnotationMutation,
  Types.UnResolveAnnotationMutationVariables
>

/**
 * __useUnResolveAnnotationMutation__
 *
 * To run a mutation, you first call `useUnResolveAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnResolveAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unResolveAnnotationMutation, { data, loading, error }] = useUnResolveAnnotationMutation({
 *   variables: {
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *   },
 * });
 */
export function useUnResolveAnnotationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UnResolveAnnotationMutation,
    Types.UnResolveAnnotationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UnResolveAnnotationMutation,
    Types.UnResolveAnnotationMutationVariables
  >(UnResolveAnnotationDocument, options)
}
export type UnResolveAnnotationMutationHookResult = ReturnType<
  typeof useUnResolveAnnotationMutation
>
export type UnResolveAnnotationMutationResult =
  Apollo.MutationResult<Types.UnResolveAnnotationMutation>
export type UnResolveAnnotationMutationOptions = Apollo.BaseMutationOptions<
  Types.UnResolveAnnotationMutation,
  Types.UnResolveAnnotationMutationVariables
>
export const GetAnnotationsDocument = /*#__PURE__*/ gql`
  query getAnnotations(
    $shareIdentifier: UUID!
    $versionIdentifier: UUID
    $subjects: [AnnotationSubjectInput!]
    $after: String
    $sort: AnnotationSortOrder
    $annotationStatus: AnnotationStatusFilter
  ) {
    annotations(
      shareIdentifier: $shareIdentifier
      versionIdentifier: $versionIdentifier
      subjects: $subjects
      after: $after
      sortOrder: $sort
      status: $annotationStatus
    ) {
      entries {
        ...BaseAnnotation
      }
      meta {
        after
        totalCount
      }
    }
  }
  ${BaseAnnotationFragmentDoc}
`

/**
 * __useGetAnnotationsQuery__
 *
 * To run a query within a React component, call `useGetAnnotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationsQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionIdentifier: // value for 'versionIdentifier'
 *      subjects: // value for 'subjects'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *      annotationStatus: // value for 'annotationStatus'
 *   },
 * });
 */
export function useGetAnnotationsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetAnnotationsQuery,
    Types.GetAnnotationsQueryVariables
  > &
    (
      | { variables: Types.GetAnnotationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAnnotationsQuery,
    Types.GetAnnotationsQueryVariables
  >(GetAnnotationsDocument, options)
}
export function useGetAnnotationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAnnotationsQuery,
    Types.GetAnnotationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAnnotationsQuery,
    Types.GetAnnotationsQueryVariables
  >(GetAnnotationsDocument, options)
}

export type GetAnnotationsQueryHookResult = ReturnType<
  typeof useGetAnnotationsQuery
>
export type GetAnnotationsLazyQueryHookResult = ReturnType<
  typeof useGetAnnotationsLazyQuery
>
export type GetAnnotationsQueryResult = Apollo.QueryResult<
  Types.GetAnnotationsQuery,
  Types.GetAnnotationsQueryVariables
>
export const GetAnnotationCommentsDocument = /*#__PURE__*/ gql`
  query getAnnotationComments(
    $annotationIdentifier: UUID!
    $after: String
    $limit: Int
    $related: UUID
  ) {
    annotation(identifier: $annotationIdentifier) {
      identifier
      isNew
      share {
        identifier
      }
      ...AnnotationSubject
      subscriptionStatus
      ...AnnotationResolutionInfo
      firstComment {
        ...BaseComment
      }
      comments(after: $after, limit: $limit, related: $related) {
        entries {
          ...Comment
        }
        meta {
          after
          before
          totalCount
        }
      }
    }
  }
  ${AnnotationSubjectFragmentDoc}
  ${AnnotationResolutionInfoFragmentDoc}
  ${BaseCommentFragmentDoc}
  ${CommentFragmentDoc}
`

/**
 * __useGetAnnotationCommentsQuery__
 *
 * To run a query within a React component, call `useGetAnnotationCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationCommentsQuery({
 *   variables: {
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *      related: // value for 'related'
 *   },
 * });
 */
export function useGetAnnotationCommentsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetAnnotationCommentsQuery,
    Types.GetAnnotationCommentsQueryVariables
  > &
    (
      | { variables: Types.GetAnnotationCommentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAnnotationCommentsQuery,
    Types.GetAnnotationCommentsQueryVariables
  >(GetAnnotationCommentsDocument, options)
}
export function useGetAnnotationCommentsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAnnotationCommentsQuery,
    Types.GetAnnotationCommentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAnnotationCommentsQuery,
    Types.GetAnnotationCommentsQueryVariables
  >(GetAnnotationCommentsDocument, options)
}

export type GetAnnotationCommentsQueryHookResult = ReturnType<
  typeof useGetAnnotationCommentsQuery
>
export type GetAnnotationCommentsLazyQueryHookResult = ReturnType<
  typeof useGetAnnotationCommentsLazyQuery
>
export type GetAnnotationCommentsQueryResult = Apollo.QueryResult<
  Types.GetAnnotationCommentsQuery,
  Types.GetAnnotationCommentsQueryVariables
>
export const GetMentionableUsersDocument = /*#__PURE__*/ gql`
  query getMentionableUsers($shareIdentifier: UUID!) {
    share(id: $shareIdentifier) {
      identifier
      mentionableUsers {
        avatar {
          small
        }
        identifier
        name
      }
    }
  }
`

/**
 * __useGetMentionableUsersQuery__
 *
 * To run a query within a React component, call `useGetMentionableUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentionableUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentionableUsersQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetMentionableUsersQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetMentionableUsersQuery,
    Types.GetMentionableUsersQueryVariables
  > &
    (
      | { variables: Types.GetMentionableUsersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetMentionableUsersQuery,
    Types.GetMentionableUsersQueryVariables
  >(GetMentionableUsersDocument, options)
}
export function useGetMentionableUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetMentionableUsersQuery,
    Types.GetMentionableUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetMentionableUsersQuery,
    Types.GetMentionableUsersQueryVariables
  >(GetMentionableUsersDocument, options)
}

export type GetMentionableUsersQueryHookResult = ReturnType<
  typeof useGetMentionableUsersQuery
>
export type GetMentionableUsersLazyQueryHookResult = ReturnType<
  typeof useGetMentionableUsersLazyQuery
>
export type GetMentionableUsersQueryResult = Apollo.QueryResult<
  Types.GetMentionableUsersQuery,
  Types.GetMentionableUsersQueryVariables
>
export const GetAnnotationDotsDocument = /*#__PURE__*/ gql`
  query getAnnotationDots(
    $shareIdentifier: UUID!
    $versionIdentifier: UUID
    $subjects: [AnnotationSubjectInput!]
    $after: String
    $annotationStatus: AnnotationStatusFilter
    $sort: AnnotationSortOrder
  ) {
    annotations(
      shareIdentifier: $shareIdentifier
      versionIdentifier: $versionIdentifier
      subjects: $subjects
      limit: 100
      after: $after
      status: $annotationStatus
      sortOrder: $sort
    ) {
      entries {
        ...AnnotationDot
      }
      meta {
        after
        totalCount
      }
    }
  }
  ${AnnotationDotFragmentDoc}
`

/**
 * __useGetAnnotationDotsQuery__
 *
 * To run a query within a React component, call `useGetAnnotationDotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationDotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationDotsQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionIdentifier: // value for 'versionIdentifier'
 *      subjects: // value for 'subjects'
 *      after: // value for 'after'
 *      annotationStatus: // value for 'annotationStatus'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAnnotationDotsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetAnnotationDotsQuery,
    Types.GetAnnotationDotsQueryVariables
  > &
    (
      | { variables: Types.GetAnnotationDotsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAnnotationDotsQuery,
    Types.GetAnnotationDotsQueryVariables
  >(GetAnnotationDotsDocument, options)
}
export function useGetAnnotationDotsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAnnotationDotsQuery,
    Types.GetAnnotationDotsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAnnotationDotsQuery,
    Types.GetAnnotationDotsQueryVariables
  >(GetAnnotationDotsDocument, options)
}

export type GetAnnotationDotsQueryHookResult = ReturnType<
  typeof useGetAnnotationDotsQuery
>
export type GetAnnotationDotsLazyQueryHookResult = ReturnType<
  typeof useGetAnnotationDotsLazyQuery
>
export type GetAnnotationDotsQueryResult = Apollo.QueryResult<
  Types.GetAnnotationDotsQuery,
  Types.GetAnnotationDotsQueryVariables
>
export const GetAnnotationDotDocument = /*#__PURE__*/ gql`
  query getAnnotationDot($identifier: UUID!) {
    annotation(identifier: $identifier) {
      ...AnnotationDot
    }
  }
  ${AnnotationDotFragmentDoc}
`

/**
 * __useGetAnnotationDotQuery__
 *
 * To run a query within a React component, call `useGetAnnotationDotQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationDotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationDotQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetAnnotationDotQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetAnnotationDotQuery,
    Types.GetAnnotationDotQueryVariables
  > &
    (
      | { variables: Types.GetAnnotationDotQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAnnotationDotQuery,
    Types.GetAnnotationDotQueryVariables
  >(GetAnnotationDotDocument, options)
}
export function useGetAnnotationDotLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAnnotationDotQuery,
    Types.GetAnnotationDotQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAnnotationDotQuery,
    Types.GetAnnotationDotQueryVariables
  >(GetAnnotationDotDocument, options)
}

export type GetAnnotationDotQueryHookResult = ReturnType<
  typeof useGetAnnotationDotQuery
>
export type GetAnnotationDotLazyQueryHookResult = ReturnType<
  typeof useGetAnnotationDotLazyQuery
>
export type GetAnnotationDotQueryResult = Apollo.QueryResult<
  Types.GetAnnotationDotQuery,
  Types.GetAnnotationDotQueryVariables
>
export const GetAnnotationLatestVisibleVersionDocument = /*#__PURE__*/ gql`
  query getAnnotationLatestVisibleVersion($identifier: UUID!) {
    annotation(identifier: $identifier) {
      identifier
      latestVisibleVersion {
        isLatest
        identifier
        shortId
      }
    }
  }
`

/**
 * __useGetAnnotationLatestVisibleVersionQuery__
 *
 * To run a query within a React component, call `useGetAnnotationLatestVisibleVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationLatestVisibleVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationLatestVisibleVersionQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetAnnotationLatestVisibleVersionQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetAnnotationLatestVisibleVersionQuery,
    Types.GetAnnotationLatestVisibleVersionQueryVariables
  > &
    (
      | {
          variables: Types.GetAnnotationLatestVisibleVersionQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAnnotationLatestVisibleVersionQuery,
    Types.GetAnnotationLatestVisibleVersionQueryVariables
  >(GetAnnotationLatestVisibleVersionDocument, options)
}
export function useGetAnnotationLatestVisibleVersionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAnnotationLatestVisibleVersionQuery,
    Types.GetAnnotationLatestVisibleVersionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAnnotationLatestVisibleVersionQuery,
    Types.GetAnnotationLatestVisibleVersionQueryVariables
  >(GetAnnotationLatestVisibleVersionDocument, options)
}

export type GetAnnotationLatestVisibleVersionQueryHookResult = ReturnType<
  typeof useGetAnnotationLatestVisibleVersionQuery
>
export type GetAnnotationLatestVisibleVersionLazyQueryHookResult = ReturnType<
  typeof useGetAnnotationLatestVisibleVersionLazyQuery
>
export type GetAnnotationLatestVisibleVersionQueryResult = Apollo.QueryResult<
  Types.GetAnnotationLatestVisibleVersionQuery,
  Types.GetAnnotationLatestVisibleVersionQueryVariables
>
export const AnnotationCreatedDocument = /*#__PURE__*/ gql`
  subscription annotationCreated(
    $permanentArtboardId: String
    $permanentPageId: String
    $shareIdentifier: UUID
    $previewIdentifier: UUID
  ) {
    annotationCreated(
      permanentArtboardId: $permanentArtboardId
      permanentPageId: $permanentPageId
      shareIdentifier: $shareIdentifier
      previewIdentifier: $previewIdentifier
    ) {
      ...BaseAnnotation
      ...AnnotationSubjectCounters
    }
  }
  ${BaseAnnotationFragmentDoc}
  ${AnnotationSubjectCountersFragmentDoc}
`

/**
 * __useAnnotationCreatedSubscription__
 *
 * To run a query within a React component, call `useAnnotationCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnotationCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnotationCreatedSubscription({
 *   variables: {
 *      permanentArtboardId: // value for 'permanentArtboardId'
 *      permanentPageId: // value for 'permanentPageId'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      previewIdentifier: // value for 'previewIdentifier'
 *   },
 * });
 */
export function useAnnotationCreatedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.AnnotationCreatedSubscription,
    Types.AnnotationCreatedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.AnnotationCreatedSubscription,
    Types.AnnotationCreatedSubscriptionVariables
  >(AnnotationCreatedDocument, options)
}
export type AnnotationCreatedSubscriptionHookResult = ReturnType<
  typeof useAnnotationCreatedSubscription
>
export type AnnotationCreatedSubscriptionResult =
  Apollo.SubscriptionResult<Types.AnnotationCreatedSubscription>
export const AnnotationDeletedDocument = /*#__PURE__*/ gql`
  subscription annotationDeleted(
    $annotationIdentifier: UUID
    $permanentArtboardId: String
    $permanentPageId: String
    $shareIdentifier: UUID
    $previewIdentifier: UUID
    $subject: AnnotationSubjectInput
  ) {
    annotationDeleted(
      annotationIdentifier: $annotationIdentifier
      permanentArtboardId: $permanentArtboardId
      permanentPageId: $permanentPageId
      shareIdentifier: $shareIdentifier
      previewIdentifier: $previewIdentifier
      subject: $subject
    ) {
      identifier
      currentSubject {
        ... on Artboard {
          permanentArtboardShortId
          documentVersionShortId
          uuid
        }
      }
      ...DeletedAnnotationSubjectCounters
    }
  }
  ${DeletedAnnotationSubjectCountersFragmentDoc}
`

/**
 * __useAnnotationDeletedSubscription__
 *
 * To run a query within a React component, call `useAnnotationDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnotationDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnotationDeletedSubscription({
 *   variables: {
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *      permanentArtboardId: // value for 'permanentArtboardId'
 *      permanentPageId: // value for 'permanentPageId'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      previewIdentifier: // value for 'previewIdentifier'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useAnnotationDeletedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.AnnotationDeletedSubscription,
    Types.AnnotationDeletedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.AnnotationDeletedSubscription,
    Types.AnnotationDeletedSubscriptionVariables
  >(AnnotationDeletedDocument, options)
}
export type AnnotationDeletedSubscriptionHookResult = ReturnType<
  typeof useAnnotationDeletedSubscription
>
export type AnnotationDeletedSubscriptionResult =
  Apollo.SubscriptionResult<Types.AnnotationDeletedSubscription>
export const AnnotationMovedDocument = /*#__PURE__*/ gql`
  subscription annotationMoved(
    $permanentArtboardId: String
    $permanentPageId: String
    $shareIdentifier: UUID
    $previewIdentifier: UUID
    $subject: AnnotationSubjectInput
  ) {
    annotationMoved(
      permanentArtboardId: $permanentArtboardId
      permanentPageId: $permanentPageId
      shareIdentifier: $shareIdentifier
      previewIdentifier: $previewIdentifier
      subject: $subject
    ) {
      ...BaseAnnotation
      ...AnnotationSubjectCounters
    }
  }
  ${BaseAnnotationFragmentDoc}
  ${AnnotationSubjectCountersFragmentDoc}
`

/**
 * __useAnnotationMovedSubscription__
 *
 * To run a query within a React component, call `useAnnotationMovedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnotationMovedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnotationMovedSubscription({
 *   variables: {
 *      permanentArtboardId: // value for 'permanentArtboardId'
 *      permanentPageId: // value for 'permanentPageId'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      previewIdentifier: // value for 'previewIdentifier'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useAnnotationMovedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.AnnotationMovedSubscription,
    Types.AnnotationMovedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.AnnotationMovedSubscription,
    Types.AnnotationMovedSubscriptionVariables
  >(AnnotationMovedDocument, options)
}
export type AnnotationMovedSubscriptionHookResult = ReturnType<
  typeof useAnnotationMovedSubscription
>
export type AnnotationMovedSubscriptionResult =
  Apollo.SubscriptionResult<Types.AnnotationMovedSubscription>
export const AnnotationResolvedDocument = /*#__PURE__*/ gql`
  subscription annotationResolved(
    $shareIdentifier: UUID
    $previewIdentifier: UUID
    $annotationIdentifier: UUID
  ) {
    annotationResolved(
      shareIdentifier: $shareIdentifier
      previewIdentifier: $previewIdentifier
      annotationIdentifier: $annotationIdentifier
    ) {
      identifier
      ...BaseAnnotation
    }
  }
  ${BaseAnnotationFragmentDoc}
`

/**
 * __useAnnotationResolvedSubscription__
 *
 * To run a query within a React component, call `useAnnotationResolvedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnotationResolvedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnotationResolvedSubscription({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      previewIdentifier: // value for 'previewIdentifier'
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *   },
 * });
 */
export function useAnnotationResolvedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.AnnotationResolvedSubscription,
    Types.AnnotationResolvedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.AnnotationResolvedSubscription,
    Types.AnnotationResolvedSubscriptionVariables
  >(AnnotationResolvedDocument, options)
}
export type AnnotationResolvedSubscriptionHookResult = ReturnType<
  typeof useAnnotationResolvedSubscription
>
export type AnnotationResolvedSubscriptionResult =
  Apollo.SubscriptionResult<Types.AnnotationResolvedSubscription>
export const AnnotationUnresolvedDocument = /*#__PURE__*/ gql`
  subscription annotationUnresolved(
    $shareIdentifier: UUID
    $previewIdentifier: UUID
    $annotationIdentifier: UUID
  ) {
    annotationUnresolved(
      shareIdentifier: $shareIdentifier
      previewIdentifier: $previewIdentifier
      annotationIdentifier: $annotationIdentifier
    ) {
      identifier
      ...BaseAnnotation
    }
  }
  ${BaseAnnotationFragmentDoc}
`

/**
 * __useAnnotationUnresolvedSubscription__
 *
 * To run a query within a React component, call `useAnnotationUnresolvedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnotationUnresolvedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnotationUnresolvedSubscription({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      previewIdentifier: // value for 'previewIdentifier'
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *   },
 * });
 */
export function useAnnotationUnresolvedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.AnnotationUnresolvedSubscription,
    Types.AnnotationUnresolvedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.AnnotationUnresolvedSubscription,
    Types.AnnotationUnresolvedSubscriptionVariables
  >(AnnotationUnresolvedDocument, options)
}
export type AnnotationUnresolvedSubscriptionHookResult = ReturnType<
  typeof useAnnotationUnresolvedSubscription
>
export type AnnotationUnresolvedSubscriptionResult =
  Apollo.SubscriptionResult<Types.AnnotationUnresolvedSubscription>
export const EditCommentDocument = /*#__PURE__*/ gql`
  mutation editComment($identifier: UUID!, $body: String!) {
    editComment(commentIdentifier: $identifier, body: $body) {
      comment {
        identifier
        body
        isEdited
      }
    }
  }
`
export type EditCommentMutationFn = Apollo.MutationFunction<
  Types.EditCommentMutation,
  Types.EditCommentMutationVariables
>

/**
 * __useEditCommentMutation__
 *
 * To run a mutation, you first call `useEditCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCommentMutation, { data, loading, error }] = useEditCommentMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useEditCommentMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.EditCommentMutation,
    Types.EditCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.EditCommentMutation,
    Types.EditCommentMutationVariables
  >(EditCommentDocument, options)
}
export type EditCommentMutationHookResult = ReturnType<
  typeof useEditCommentMutation
>
export type EditCommentMutationResult =
  Apollo.MutationResult<Types.EditCommentMutation>
export type EditCommentMutationOptions = Apollo.BaseMutationOptions<
  Types.EditCommentMutation,
  Types.EditCommentMutationVariables
>
export const CreateAnnotationCommentDocument = /*#__PURE__*/ gql`
  mutation createAnnotationComment($identifier: UUID!, $body: String!) {
    createAnnotationReply(annotationIdentifier: $identifier, body: $body) {
      comment {
        ...Comment
        annotation {
          ...AnnotationSubjectCounters
          ...AnnotationLastComment
          share {
            identifier
          }
          frameUuid
          subscriptionStatus
        }
      }
    }
  }
  ${CommentFragmentDoc}
  ${AnnotationSubjectCountersFragmentDoc}
  ${AnnotationLastCommentFragmentDoc}
`
export type CreateAnnotationCommentMutationFn = Apollo.MutationFunction<
  Types.CreateAnnotationCommentMutation,
  Types.CreateAnnotationCommentMutationVariables
>

/**
 * __useCreateAnnotationCommentMutation__
 *
 * To run a mutation, you first call `useCreateAnnotationCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnotationCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnotationCommentMutation, { data, loading, error }] = useCreateAnnotationCommentMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateAnnotationCommentMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreateAnnotationCommentMutation,
    Types.CreateAnnotationCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreateAnnotationCommentMutation,
    Types.CreateAnnotationCommentMutationVariables
  >(CreateAnnotationCommentDocument, options)
}
export type CreateAnnotationCommentMutationHookResult = ReturnType<
  typeof useCreateAnnotationCommentMutation
>
export type CreateAnnotationCommentMutationResult =
  Apollo.MutationResult<Types.CreateAnnotationCommentMutation>
export type CreateAnnotationCommentMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateAnnotationCommentMutation,
  Types.CreateAnnotationCommentMutationVariables
>
export const DeleteAnnotationReplyDocument = /*#__PURE__*/ gql`
  mutation deleteAnnotationReply($identifier: UUID!) {
    deleteAnnotationReply(commentIdentifier: $identifier) {
      comment {
        identifier
        annotation {
          identifier
          ...AnnotationCommentCount
        }
      }
    }
  }
  ${AnnotationCommentCountFragmentDoc}
`
export type DeleteAnnotationReplyMutationFn = Apollo.MutationFunction<
  Types.DeleteAnnotationReplyMutation,
  Types.DeleteAnnotationReplyMutationVariables
>

/**
 * __useDeleteAnnotationReplyMutation__
 *
 * To run a mutation, you first call `useDeleteAnnotationReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnotationReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnotationReplyMutation, { data, loading, error }] = useDeleteAnnotationReplyMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useDeleteAnnotationReplyMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeleteAnnotationReplyMutation,
    Types.DeleteAnnotationReplyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeleteAnnotationReplyMutation,
    Types.DeleteAnnotationReplyMutationVariables
  >(DeleteAnnotationReplyDocument, options)
}
export type DeleteAnnotationReplyMutationHookResult = ReturnType<
  typeof useDeleteAnnotationReplyMutation
>
export type DeleteAnnotationReplyMutationResult =
  Apollo.MutationResult<Types.DeleteAnnotationReplyMutation>
export type DeleteAnnotationReplyMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteAnnotationReplyMutation,
  Types.DeleteAnnotationReplyMutationVariables
>
export const MarkCommentsAsReadDocument = /*#__PURE__*/ gql`
  mutation markCommentsAsRead($commentIdentifiers: [UUID!]!) {
    markCommentsAsRead(commentIdentifiers: $commentIdentifiers) {
      comments {
        identifier
        isRead
        annotation {
          identifier
          hasNewComments
          isNew
          ...AnnotationSubjectCounters
        }
      }
    }
  }
  ${AnnotationSubjectCountersFragmentDoc}
`
export type MarkCommentsAsReadMutationFn = Apollo.MutationFunction<
  Types.MarkCommentsAsReadMutation,
  Types.MarkCommentsAsReadMutationVariables
>

/**
 * __useMarkCommentsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkCommentsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCommentsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCommentsAsReadMutation, { data, loading, error }] = useMarkCommentsAsReadMutation({
 *   variables: {
 *      commentIdentifiers: // value for 'commentIdentifiers'
 *   },
 * });
 */
export function useMarkCommentsAsReadMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.MarkCommentsAsReadMutation,
    Types.MarkCommentsAsReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.MarkCommentsAsReadMutation,
    Types.MarkCommentsAsReadMutationVariables
  >(MarkCommentsAsReadDocument, options)
}
export type MarkCommentsAsReadMutationHookResult = ReturnType<
  typeof useMarkCommentsAsReadMutation
>
export type MarkCommentsAsReadMutationResult =
  Apollo.MutationResult<Types.MarkCommentsAsReadMutation>
export type MarkCommentsAsReadMutationOptions = Apollo.BaseMutationOptions<
  Types.MarkCommentsAsReadMutation,
  Types.MarkCommentsAsReadMutationVariables
>
export const MarkAllCommentsAsReadDocument = /*#__PURE__*/ gql`
  mutation markAllCommentsAsRead(
    $shareIdentifier: UUID!
    $frameUuid: String
    $pageUuid: String
  ) {
    markAllCommentsAsRead(
      frameUuid: $frameUuid
      pageUuid: $pageUuid
      shareIdentifier: $shareIdentifier
    ) {
      comments {
        identifier
        isRead
        annotation {
          identifier
          hasNewComments
          isNew
          ...AnnotationSubjectCounters
        }
      }
    }
  }
  ${AnnotationSubjectCountersFragmentDoc}
`
export type MarkAllCommentsAsReadMutationFn = Apollo.MutationFunction<
  Types.MarkAllCommentsAsReadMutation,
  Types.MarkAllCommentsAsReadMutationVariables
>

/**
 * __useMarkAllCommentsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllCommentsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllCommentsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllCommentsAsReadMutation, { data, loading, error }] = useMarkAllCommentsAsReadMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      frameUuid: // value for 'frameUuid'
 *      pageUuid: // value for 'pageUuid'
 *   },
 * });
 */
export function useMarkAllCommentsAsReadMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.MarkAllCommentsAsReadMutation,
    Types.MarkAllCommentsAsReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.MarkAllCommentsAsReadMutation,
    Types.MarkAllCommentsAsReadMutationVariables
  >(MarkAllCommentsAsReadDocument, options)
}
export type MarkAllCommentsAsReadMutationHookResult = ReturnType<
  typeof useMarkAllCommentsAsReadMutation
>
export type MarkAllCommentsAsReadMutationResult =
  Apollo.MutationResult<Types.MarkAllCommentsAsReadMutation>
export type MarkAllCommentsAsReadMutationOptions = Apollo.BaseMutationOptions<
  Types.MarkAllCommentsAsReadMutation,
  Types.MarkAllCommentsAsReadMutationVariables
>
export const GetBaseCommentDocument = /*#__PURE__*/ gql`
  query getBaseComment($identifier: UUID!) {
    comment(identifier: $identifier) @client {
      identifier
      ...BaseComment
    }
  }
  ${BaseCommentFragmentDoc}
`

/**
 * __useGetBaseCommentQuery__
 *
 * To run a query within a React component, call `useGetBaseCommentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaseCommentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaseCommentQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetBaseCommentQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetBaseCommentQuery,
    Types.GetBaseCommentQueryVariables
  > &
    (
      | { variables: Types.GetBaseCommentQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetBaseCommentQuery,
    Types.GetBaseCommentQueryVariables
  >(GetBaseCommentDocument, options)
}
export function useGetBaseCommentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetBaseCommentQuery,
    Types.GetBaseCommentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetBaseCommentQuery,
    Types.GetBaseCommentQueryVariables
  >(GetBaseCommentDocument, options)
}

export type GetBaseCommentQueryHookResult = ReturnType<
  typeof useGetBaseCommentQuery
>
export type GetBaseCommentLazyQueryHookResult = ReturnType<
  typeof useGetBaseCommentLazyQuery
>
export type GetBaseCommentQueryResult = Apollo.QueryResult<
  Types.GetBaseCommentQuery,
  Types.GetBaseCommentQueryVariables
>
export const AnnotationReplyCreatedDocument = /*#__PURE__*/ gql`
  subscription annotationReplyCreated(
    $shareIdentifier: UUID
    $previewIdentifier: UUID
  ) {
    annotationReplyCreated(
      shareIdentifier: $shareIdentifier
      previewIdentifier: $previewIdentifier
    ) {
      identifier
      ...Comment
      annotation {
        ...BaseAnnotation
        ...AnnotationSubjectCounters
      }
    }
  }
  ${CommentFragmentDoc}
  ${BaseAnnotationFragmentDoc}
  ${AnnotationSubjectCountersFragmentDoc}
`

/**
 * __useAnnotationReplyCreatedSubscription__
 *
 * To run a query within a React component, call `useAnnotationReplyCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnotationReplyCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnotationReplyCreatedSubscription({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      previewIdentifier: // value for 'previewIdentifier'
 *   },
 * });
 */
export function useAnnotationReplyCreatedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.AnnotationReplyCreatedSubscription,
    Types.AnnotationReplyCreatedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.AnnotationReplyCreatedSubscription,
    Types.AnnotationReplyCreatedSubscriptionVariables
  >(AnnotationReplyCreatedDocument, options)
}
export type AnnotationReplyCreatedSubscriptionHookResult = ReturnType<
  typeof useAnnotationReplyCreatedSubscription
>
export type AnnotationReplyCreatedSubscriptionResult =
  Apollo.SubscriptionResult<Types.AnnotationReplyCreatedSubscription>
export const AnnotationReplyDeletedDocument = /*#__PURE__*/ gql`
  subscription annotationReplyDeleted(
    $shareIdentifier: UUID
    $previewIdentifier: UUID
  ) {
    annotationReplyDeleted(
      shareIdentifier: $shareIdentifier
      previewIdentifier: $previewIdentifier
    ) {
      identifier
      annotation {
        ...BaseAnnotation
        ...AnnotationSubjectCounters
      }
    }
  }
  ${BaseAnnotationFragmentDoc}
  ${AnnotationSubjectCountersFragmentDoc}
`

/**
 * __useAnnotationReplyDeletedSubscription__
 *
 * To run a query within a React component, call `useAnnotationReplyDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnotationReplyDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnotationReplyDeletedSubscription({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      previewIdentifier: // value for 'previewIdentifier'
 *   },
 * });
 */
export function useAnnotationReplyDeletedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.AnnotationReplyDeletedSubscription,
    Types.AnnotationReplyDeletedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.AnnotationReplyDeletedSubscription,
    Types.AnnotationReplyDeletedSubscriptionVariables
  >(AnnotationReplyDeletedDocument, options)
}
export type AnnotationReplyDeletedSubscriptionHookResult = ReturnType<
  typeof useAnnotationReplyDeletedSubscription
>
export type AnnotationReplyDeletedSubscriptionResult =
  Apollo.SubscriptionResult<Types.AnnotationReplyDeletedSubscription>
export const AnnotationReplyEditedDocument = /*#__PURE__*/ gql`
  subscription annotationReplyEdited(
    $shareIdentifier: UUID
    $previewIdentifier: UUID
  ) {
    commentEdited(
      shareIdentifier: $shareIdentifier
      previewIdentifier: $previewIdentifier
    ) {
      identifier
      body
      isEdited
    }
  }
`

/**
 * __useAnnotationReplyEditedSubscription__
 *
 * To run a query within a React component, call `useAnnotationReplyEditedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnotationReplyEditedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnotationReplyEditedSubscription({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      previewIdentifier: // value for 'previewIdentifier'
 *   },
 * });
 */
export function useAnnotationReplyEditedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.AnnotationReplyEditedSubscription,
    Types.AnnotationReplyEditedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.AnnotationReplyEditedSubscription,
    Types.AnnotationReplyEditedSubscriptionVariables
  >(AnnotationReplyEditedDocument, options)
}
export type AnnotationReplyEditedSubscriptionHookResult = ReturnType<
  typeof useAnnotationReplyEditedSubscription
>
export type AnnotationReplyEditedSubscriptionResult =
  Apollo.SubscriptionResult<Types.AnnotationReplyEditedSubscription>
export const AnnotationReplyReadDocument = /*#__PURE__*/ gql`
  subscription annotationReplyRead(
    $shareIdentifier: UUID
    $previewIdentifier: UUID
  ) {
    commentsMarkedAsRead(
      shareIdentifier: $shareIdentifier
      previewIdentifier: $previewIdentifier
    ) {
      identifier
      body
      isRead
      annotation {
        ...BaseAnnotation
        ...AnnotationSubjectCounters
      }
    }
  }
  ${BaseAnnotationFragmentDoc}
  ${AnnotationSubjectCountersFragmentDoc}
`

/**
 * __useAnnotationReplyReadSubscription__
 *
 * To run a query within a React component, call `useAnnotationReplyReadSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnotationReplyReadSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnotationReplyReadSubscription({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      previewIdentifier: // value for 'previewIdentifier'
 *   },
 * });
 */
export function useAnnotationReplyReadSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.AnnotationReplyReadSubscription,
    Types.AnnotationReplyReadSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.AnnotationReplyReadSubscription,
    Types.AnnotationReplyReadSubscriptionVariables
  >(AnnotationReplyReadDocument, options)
}
export type AnnotationReplyReadSubscriptionHookResult = ReturnType<
  typeof useAnnotationReplyReadSubscription
>
export type AnnotationReplyReadSubscriptionResult =
  Apollo.SubscriptionResult<Types.AnnotationReplyReadSubscription>
export const SetNotificationSubscriptionDocument = /*#__PURE__*/ gql`
  mutation setNotificationSubscription(
    $shareIdentifier: UUID
    $frameUUID: String
    $annotationIdentifier: UUID
    $state: NotificationSubscriptionState!
  ) {
    setNotificationSubscription(
      shareIdentifier: $shareIdentifier
      annotationIdentifier: $annotationIdentifier
      frameUuid: $frameUUID
      state: $state
    ) {
      share {
        identifier
        subscriptionStatus
      }
      annotation {
        identifier
        subscriptionStatus
      }
      frame {
        documentVersionShortId
        subscriptionStatus
        ... on Artboard {
          permanentArtboardShortId
        }
        ... on Frame {
          identifier
        }
      }
    }
  }
`
export type SetNotificationSubscriptionMutationFn = Apollo.MutationFunction<
  Types.SetNotificationSubscriptionMutation,
  Types.SetNotificationSubscriptionMutationVariables
>

/**
 * __useSetNotificationSubscriptionMutation__
 *
 * To run a mutation, you first call `useSetNotificationSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNotificationSubscriptionMutation, { data, loading, error }] = useSetNotificationSubscriptionMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      frameUUID: // value for 'frameUUID'
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSetNotificationSubscriptionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SetNotificationSubscriptionMutation,
    Types.SetNotificationSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SetNotificationSubscriptionMutation,
    Types.SetNotificationSubscriptionMutationVariables
  >(SetNotificationSubscriptionDocument, options)
}
export type SetNotificationSubscriptionMutationHookResult = ReturnType<
  typeof useSetNotificationSubscriptionMutation
>
export type SetNotificationSubscriptionMutationResult =
  Apollo.MutationResult<Types.SetNotificationSubscriptionMutation>
export type SetNotificationSubscriptionMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SetNotificationSubscriptionMutation,
    Types.SetNotificationSubscriptionMutationVariables
  >
export const SignInDocument = /*#__PURE__*/ gql`
  mutation signIn(
    $email: String!
    $password: String!
    $createWorkspace: Boolean
  ) {
    signIn(
      email: $email
      password: $password
      createWorkspace: $createWorkspace
    ) @client {
      ... on MFACredentials {
        mfaToken
      }
      ... on SignInCredentials {
        credentials {
          ...Credentials
        }
        createdWorkspace
      }
    }
  }
  ${CredentialsFragmentDoc}
`
export type SignInMutationFn = Apollo.MutationFunction<
  Types.SignInMutation,
  Types.SignInMutationVariables
>

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      createWorkspace: // value for 'createWorkspace'
 *   },
 * });
 */
export function useSignInMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SignInMutation,
    Types.SignInMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SignInMutation,
    Types.SignInMutationVariables
  >(SignInDocument, options)
}
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>
export type SignInMutationResult = Apollo.MutationResult<Types.SignInMutation>
export type SignInMutationOptions = Apollo.BaseMutationOptions<
  Types.SignInMutation,
  Types.SignInMutationVariables
>
export const SignUpDocument = /*#__PURE__*/ gql`
  mutation signUp($input: SignUpInput!) {
    signUp(input: $input) {
      errors {
        ...UserError
      }
      successful
      credentials {
        ...Credentials
      }
      user {
        identifier
        ...InitialUser
        workspaces {
          identifier
        }
      }
    }
  }
  ${UserErrorFragmentDoc}
  ${CredentialsFragmentDoc}
  ${InitialUserFragmentDoc}
`
export type SignUpMutationFn = Apollo.MutationFunction<
  Types.SignUpMutation,
  Types.SignUpMutationVariables
>

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SignUpMutation,
    Types.SignUpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SignUpMutation,
    Types.SignUpMutationVariables
  >(SignUpDocument, options)
}
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>
export type SignUpMutationResult = Apollo.MutationResult<Types.SignUpMutation>
export type SignUpMutationOptions = Apollo.BaseMutationOptions<
  Types.SignUpMutation,
  Types.SignUpMutationVariables
>
export const SignInWithSsoDocument = /*#__PURE__*/ gql`
  mutation signInWithSso($exchangeToken: String!) {
    signInWithSso(exchangeToken: $exchangeToken) @client {
      credentials {
        ...Credentials
      }
      workspaceId
    }
  }
  ${CredentialsFragmentDoc}
`
export type SignInWithSsoMutationFn = Apollo.MutationFunction<
  Types.SignInWithSsoMutation,
  Types.SignInWithSsoMutationVariables
>

/**
 * __useSignInWithSsoMutation__
 *
 * To run a mutation, you first call `useSignInWithSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInWithSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInWithSsoMutation, { data, loading, error }] = useSignInWithSsoMutation({
 *   variables: {
 *      exchangeToken: // value for 'exchangeToken'
 *   },
 * });
 */
export function useSignInWithSsoMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SignInWithSsoMutation,
    Types.SignInWithSsoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SignInWithSsoMutation,
    Types.SignInWithSsoMutationVariables
  >(SignInWithSsoDocument, options)
}
export type SignInWithSsoMutationHookResult = ReturnType<
  typeof useSignInWithSsoMutation
>
export type SignInWithSsoMutationResult =
  Apollo.MutationResult<Types.SignInWithSsoMutation>
export type SignInWithSsoMutationOptions = Apollo.BaseMutationOptions<
  Types.SignInWithSsoMutation,
  Types.SignInWithSsoMutationVariables
>
export const SignInWithSocialDocument = /*#__PURE__*/ gql`
  mutation signInWithSocial($exchangeToken: String!, $state: String) {
    signInWithSocial(exchangeToken: $exchangeToken, state: $state) @client {
      ... on MFACredentials {
        mfaToken
      }
      ... on SignInCredentials {
        credentials {
          ...Credentials
        }
      }
    }
  }
  ${CredentialsFragmentDoc}
`
export type SignInWithSocialMutationFn = Apollo.MutationFunction<
  Types.SignInWithSocialMutation,
  Types.SignInWithSocialMutationVariables
>

/**
 * __useSignInWithSocialMutation__
 *
 * To run a mutation, you first call `useSignInWithSocialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInWithSocialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInWithSocialMutation, { data, loading, error }] = useSignInWithSocialMutation({
 *   variables: {
 *      exchangeToken: // value for 'exchangeToken'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSignInWithSocialMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SignInWithSocialMutation,
    Types.SignInWithSocialMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SignInWithSocialMutation,
    Types.SignInWithSocialMutationVariables
  >(SignInWithSocialDocument, options)
}
export type SignInWithSocialMutationHookResult = ReturnType<
  typeof useSignInWithSocialMutation
>
export type SignInWithSocialMutationResult =
  Apollo.MutationResult<Types.SignInWithSocialMutation>
export type SignInWithSocialMutationOptions = Apollo.BaseMutationOptions<
  Types.SignInWithSocialMutation,
  Types.SignInWithSocialMutationVariables
>
export const RevokeOAuthDocument = /*#__PURE__*/ gql`
  mutation revokeOAuth($token: String!) {
    revokeOAuth(token: $token) @client {
      successful
    }
  }
`
export type RevokeOAuthMutationFn = Apollo.MutationFunction<
  Types.RevokeOAuthMutation,
  Types.RevokeOAuthMutationVariables
>

/**
 * __useRevokeOAuthMutation__
 *
 * To run a mutation, you first call `useRevokeOAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeOAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeOAuthMutation, { data, loading, error }] = useRevokeOAuthMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRevokeOAuthMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RevokeOAuthMutation,
    Types.RevokeOAuthMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RevokeOAuthMutation,
    Types.RevokeOAuthMutationVariables
  >(RevokeOAuthDocument, options)
}
export type RevokeOAuthMutationHookResult = ReturnType<
  typeof useRevokeOAuthMutation
>
export type RevokeOAuthMutationResult =
  Apollo.MutationResult<Types.RevokeOAuthMutation>
export type RevokeOAuthMutationOptions = Apollo.BaseMutationOptions<
  Types.RevokeOAuthMutation,
  Types.RevokeOAuthMutationVariables
>
export const ValidateMfaTotpDocument = /*#__PURE__*/ gql`
  mutation validateMfaTotp(
    $token: String!
    $totp: String!
    $createWorkspace: Boolean
  ) {
    validateMfaTotp(
      token: $token
      totp: $totp
      createWorkspace: $createWorkspace
    ) @client {
      createdWorkspace
      credentials {
        ...Credentials
      }
    }
  }
  ${CredentialsFragmentDoc}
`
export type ValidateMfaTotpMutationFn = Apollo.MutationFunction<
  Types.ValidateMfaTotpMutation,
  Types.ValidateMfaTotpMutationVariables
>

/**
 * __useValidateMfaTotpMutation__
 *
 * To run a mutation, you first call `useValidateMfaTotpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateMfaTotpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateMfaTotpMutation, { data, loading, error }] = useValidateMfaTotpMutation({
 *   variables: {
 *      token: // value for 'token'
 *      totp: // value for 'totp'
 *      createWorkspace: // value for 'createWorkspace'
 *   },
 * });
 */
export function useValidateMfaTotpMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ValidateMfaTotpMutation,
    Types.ValidateMfaTotpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ValidateMfaTotpMutation,
    Types.ValidateMfaTotpMutationVariables
  >(ValidateMfaTotpDocument, options)
}
export type ValidateMfaTotpMutationHookResult = ReturnType<
  typeof useValidateMfaTotpMutation
>
export type ValidateMfaTotpMutationResult =
  Apollo.MutationResult<Types.ValidateMfaTotpMutation>
export type ValidateMfaTotpMutationOptions = Apollo.BaseMutationOptions<
  Types.ValidateMfaTotpMutation,
  Types.ValidateMfaTotpMutationVariables
>
export const ValidateMfaRecoveryCodeDocument = /*#__PURE__*/ gql`
  mutation validateMfaRecoveryCode(
    $token: String!
    $recoveryCode: String!
    $createWorkspace: Boolean
  ) {
    validateMfaRecoveryCode(
      token: $token
      recoveryCode: $recoveryCode
      createWorkspace: $createWorkspace
    ) @client {
      createdWorkspace
      credentials {
        ...Credentials
      }
    }
  }
  ${CredentialsFragmentDoc}
`
export type ValidateMfaRecoveryCodeMutationFn = Apollo.MutationFunction<
  Types.ValidateMfaRecoveryCodeMutation,
  Types.ValidateMfaRecoveryCodeMutationVariables
>

/**
 * __useValidateMfaRecoveryCodeMutation__
 *
 * To run a mutation, you first call `useValidateMfaRecoveryCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateMfaRecoveryCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateMfaRecoveryCodeMutation, { data, loading, error }] = useValidateMfaRecoveryCodeMutation({
 *   variables: {
 *      token: // value for 'token'
 *      recoveryCode: // value for 'recoveryCode'
 *      createWorkspace: // value for 'createWorkspace'
 *   },
 * });
 */
export function useValidateMfaRecoveryCodeMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ValidateMfaRecoveryCodeMutation,
    Types.ValidateMfaRecoveryCodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ValidateMfaRecoveryCodeMutation,
    Types.ValidateMfaRecoveryCodeMutationVariables
  >(ValidateMfaRecoveryCodeDocument, options)
}
export type ValidateMfaRecoveryCodeMutationHookResult = ReturnType<
  typeof useValidateMfaRecoveryCodeMutation
>
export type ValidateMfaRecoveryCodeMutationResult =
  Apollo.MutationResult<Types.ValidateMfaRecoveryCodeMutation>
export type ValidateMfaRecoveryCodeMutationOptions = Apollo.BaseMutationOptions<
  Types.ValidateMfaRecoveryCodeMutation,
  Types.ValidateMfaRecoveryCodeMutationVariables
>
export const RevokeActiveSessionsDocument = /*#__PURE__*/ gql`
  mutation revokeActiveSessions($exceptCurrentOne: Boolean!) {
    revokeActiveSessions(exceptCurrentOne: $exceptCurrentOne) {
      errors {
        ...UserError
      }
      successful
    }
  }
  ${UserErrorFragmentDoc}
`
export type RevokeActiveSessionsMutationFn = Apollo.MutationFunction<
  Types.RevokeActiveSessionsMutation,
  Types.RevokeActiveSessionsMutationVariables
>

/**
 * __useRevokeActiveSessionsMutation__
 *
 * To run a mutation, you first call `useRevokeActiveSessionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeActiveSessionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeActiveSessionsMutation, { data, loading, error }] = useRevokeActiveSessionsMutation({
 *   variables: {
 *      exceptCurrentOne: // value for 'exceptCurrentOne'
 *   },
 * });
 */
export function useRevokeActiveSessionsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RevokeActiveSessionsMutation,
    Types.RevokeActiveSessionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RevokeActiveSessionsMutation,
    Types.RevokeActiveSessionsMutationVariables
  >(RevokeActiveSessionsDocument, options)
}
export type RevokeActiveSessionsMutationHookResult = ReturnType<
  typeof useRevokeActiveSessionsMutation
>
export type RevokeActiveSessionsMutationResult =
  Apollo.MutationResult<Types.RevokeActiveSessionsMutation>
export type RevokeActiveSessionsMutationOptions = Apollo.BaseMutationOptions<
  Types.RevokeActiveSessionsMutation,
  Types.RevokeActiveSessionsMutationVariables
>
export const RevokeSessionDocument = /*#__PURE__*/ gql`
  mutation revokeSession($id: UUID!) {
    revokeSession(id: $id) {
      errors {
        ...UserError
      }
      successful
    }
  }
  ${UserErrorFragmentDoc}
`
export type RevokeSessionMutationFn = Apollo.MutationFunction<
  Types.RevokeSessionMutation,
  Types.RevokeSessionMutationVariables
>

/**
 * __useRevokeSessionMutation__
 *
 * To run a mutation, you first call `useRevokeSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeSessionMutation, { data, loading, error }] = useRevokeSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeSessionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RevokeSessionMutation,
    Types.RevokeSessionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RevokeSessionMutation,
    Types.RevokeSessionMutationVariables
  >(RevokeSessionDocument, options)
}
export type RevokeSessionMutationHookResult = ReturnType<
  typeof useRevokeSessionMutation
>
export type RevokeSessionMutationResult =
  Apollo.MutationResult<Types.RevokeSessionMutation>
export type RevokeSessionMutationOptions = Apollo.BaseMutationOptions<
  Types.RevokeSessionMutation,
  Types.RevokeSessionMutationVariables
>
export const UnlinkSocialAccountDocument = /*#__PURE__*/ gql`
  mutation unlinkSocialAccount($identifier: UUID!) {
    unlinkSocialAccount(identifier: $identifier) {
      user {
        identifier
        socialAccounts {
          identifier
          provider
        }
      }
    }
  }
`
export type UnlinkSocialAccountMutationFn = Apollo.MutationFunction<
  Types.UnlinkSocialAccountMutation,
  Types.UnlinkSocialAccountMutationVariables
>

/**
 * __useUnlinkSocialAccountMutation__
 *
 * To run a mutation, you first call `useUnlinkSocialAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkSocialAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkSocialAccountMutation, { data, loading, error }] = useUnlinkSocialAccountMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useUnlinkSocialAccountMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UnlinkSocialAccountMutation,
    Types.UnlinkSocialAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UnlinkSocialAccountMutation,
    Types.UnlinkSocialAccountMutationVariables
  >(UnlinkSocialAccountDocument, options)
}
export type UnlinkSocialAccountMutationHookResult = ReturnType<
  typeof useUnlinkSocialAccountMutation
>
export type UnlinkSocialAccountMutationResult =
  Apollo.MutationResult<Types.UnlinkSocialAccountMutation>
export type UnlinkSocialAccountMutationOptions = Apollo.BaseMutationOptions<
  Types.UnlinkSocialAccountMutation,
  Types.UnlinkSocialAccountMutationVariables
>
export const GetSocialAuthStartUrlDocument = /*#__PURE__*/ gql`
  mutation getSocialAuthStartUrl(
    $provider: SocialSignInProvider!
    $destinationUrl: String
    $createWorkspace: Boolean
    $action: SocialAuthAction!
    $workspaceIdentifier: UUID
  ) {
    socialAuthStartUrl(
      provider: $provider
      destinationUrl: $destinationUrl
      createWorkspace: $createWorkspace
      action: $action
      workspaceIdentifier: $workspaceIdentifier
    ) {
      url
      state
    }
  }
`
export type GetSocialAuthStartUrlMutationFn = Apollo.MutationFunction<
  Types.GetSocialAuthStartUrlMutation,
  Types.GetSocialAuthStartUrlMutationVariables
>

/**
 * __useGetSocialAuthStartUrlMutation__
 *
 * To run a mutation, you first call `useGetSocialAuthStartUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetSocialAuthStartUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getSocialAuthStartUrlMutation, { data, loading, error }] = useGetSocialAuthStartUrlMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      destinationUrl: // value for 'destinationUrl'
 *      createWorkspace: // value for 'createWorkspace'
 *      action: // value for 'action'
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *   },
 * });
 */
export function useGetSocialAuthStartUrlMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.GetSocialAuthStartUrlMutation,
    Types.GetSocialAuthStartUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.GetSocialAuthStartUrlMutation,
    Types.GetSocialAuthStartUrlMutationVariables
  >(GetSocialAuthStartUrlDocument, options)
}
export type GetSocialAuthStartUrlMutationHookResult = ReturnType<
  typeof useGetSocialAuthStartUrlMutation
>
export type GetSocialAuthStartUrlMutationResult =
  Apollo.MutationResult<Types.GetSocialAuthStartUrlMutation>
export type GetSocialAuthStartUrlMutationOptions = Apollo.BaseMutationOptions<
  Types.GetSocialAuthStartUrlMutation,
  Types.GetSocialAuthStartUrlMutationVariables
>
export const GetUserCredentialsDocument = /*#__PURE__*/ gql`
  query getUserCredentials {
    userCredentials @client {
      ...Credentials
    }
  }
  ${CredentialsFragmentDoc}
`

/**
 * __useGetUserCredentialsQuery__
 *
 * To run a query within a React component, call `useGetUserCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCredentialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserCredentialsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetUserCredentialsQuery,
    Types.GetUserCredentialsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetUserCredentialsQuery,
    Types.GetUserCredentialsQueryVariables
  >(GetUserCredentialsDocument, options)
}
export function useGetUserCredentialsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetUserCredentialsQuery,
    Types.GetUserCredentialsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetUserCredentialsQuery,
    Types.GetUserCredentialsQueryVariables
  >(GetUserCredentialsDocument, options)
}

export type GetUserCredentialsQueryHookResult = ReturnType<
  typeof useGetUserCredentialsQuery
>
export type GetUserCredentialsLazyQueryHookResult = ReturnType<
  typeof useGetUserCredentialsLazyQuery
>
export type GetUserCredentialsQueryResult = Apollo.QueryResult<
  Types.GetUserCredentialsQuery,
  Types.GetUserCredentialsQueryVariables
>
export const SetupMfaDocument = /*#__PURE__*/ gql`
  mutation setupMfa {
    setupMfa {
      otpAuthUri
    }
  }
`
export type SetupMfaMutationFn = Apollo.MutationFunction<
  Types.SetupMfaMutation,
  Types.SetupMfaMutationVariables
>

/**
 * __useSetupMfaMutation__
 *
 * To run a mutation, you first call `useSetupMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupMfaMutation, { data, loading, error }] = useSetupMfaMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetupMfaMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SetupMfaMutation,
    Types.SetupMfaMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SetupMfaMutation,
    Types.SetupMfaMutationVariables
  >(SetupMfaDocument, options)
}
export type SetupMfaMutationHookResult = ReturnType<typeof useSetupMfaMutation>
export type SetupMfaMutationResult =
  Apollo.MutationResult<Types.SetupMfaMutation>
export type SetupMfaMutationOptions = Apollo.BaseMutationOptions<
  Types.SetupMfaMutation,
  Types.SetupMfaMutationVariables
>
export const ConfirmMfaSetupDocument = /*#__PURE__*/ gql`
  mutation confirmMfaSetup($totp: String!) {
    confirmMfaSetup(totp: $totp) {
      recoveryCodes {
        entries
      }
    }
  }
`
export type ConfirmMfaSetupMutationFn = Apollo.MutationFunction<
  Types.ConfirmMfaSetupMutation,
  Types.ConfirmMfaSetupMutationVariables
>

/**
 * __useConfirmMfaSetupMutation__
 *
 * To run a mutation, you first call `useConfirmMfaSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmMfaSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmMfaSetupMutation, { data, loading, error }] = useConfirmMfaSetupMutation({
 *   variables: {
 *      totp: // value for 'totp'
 *   },
 * });
 */
export function useConfirmMfaSetupMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ConfirmMfaSetupMutation,
    Types.ConfirmMfaSetupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ConfirmMfaSetupMutation,
    Types.ConfirmMfaSetupMutationVariables
  >(ConfirmMfaSetupDocument, options)
}
export type ConfirmMfaSetupMutationHookResult = ReturnType<
  typeof useConfirmMfaSetupMutation
>
export type ConfirmMfaSetupMutationResult =
  Apollo.MutationResult<Types.ConfirmMfaSetupMutation>
export type ConfirmMfaSetupMutationOptions = Apollo.BaseMutationOptions<
  Types.ConfirmMfaSetupMutation,
  Types.ConfirmMfaSetupMutationVariables
>
export const DisableMfaDocument = /*#__PURE__*/ gql`
  mutation disableMfa($password: String!) {
    disableMfa(password: $password) {
      user {
        identifier
        mfaState
      }
    }
  }
`
export type DisableMfaMutationFn = Apollo.MutationFunction<
  Types.DisableMfaMutation,
  Types.DisableMfaMutationVariables
>

/**
 * __useDisableMfaMutation__
 *
 * To run a mutation, you first call `useDisableMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableMfaMutation, { data, loading, error }] = useDisableMfaMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useDisableMfaMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DisableMfaMutation,
    Types.DisableMfaMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DisableMfaMutation,
    Types.DisableMfaMutationVariables
  >(DisableMfaDocument, options)
}
export type DisableMfaMutationHookResult = ReturnType<
  typeof useDisableMfaMutation
>
export type DisableMfaMutationResult =
  Apollo.MutationResult<Types.DisableMfaMutation>
export type DisableMfaMutationOptions = Apollo.BaseMutationOptions<
  Types.DisableMfaMutation,
  Types.DisableMfaMutationVariables
>
export const GenerateMfaRecoveryCodesDocument = /*#__PURE__*/ gql`
  mutation generateMfaRecoveryCodes($password: String!) {
    generateMfaRecoveryCodes(password: $password) {
      recoveryCodes {
        entries
      }
    }
  }
`
export type GenerateMfaRecoveryCodesMutationFn = Apollo.MutationFunction<
  Types.GenerateMfaRecoveryCodesMutation,
  Types.GenerateMfaRecoveryCodesMutationVariables
>

/**
 * __useGenerateMfaRecoveryCodesMutation__
 *
 * To run a mutation, you first call `useGenerateMfaRecoveryCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMfaRecoveryCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMfaRecoveryCodesMutation, { data, loading, error }] = useGenerateMfaRecoveryCodesMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useGenerateMfaRecoveryCodesMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.GenerateMfaRecoveryCodesMutation,
    Types.GenerateMfaRecoveryCodesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.GenerateMfaRecoveryCodesMutation,
    Types.GenerateMfaRecoveryCodesMutationVariables
  >(GenerateMfaRecoveryCodesDocument, options)
}
export type GenerateMfaRecoveryCodesMutationHookResult = ReturnType<
  typeof useGenerateMfaRecoveryCodesMutation
>
export type GenerateMfaRecoveryCodesMutationResult =
  Apollo.MutationResult<Types.GenerateMfaRecoveryCodesMutation>
export type GenerateMfaRecoveryCodesMutationOptions =
  Apollo.BaseMutationOptions<
    Types.GenerateMfaRecoveryCodesMutation,
    Types.GenerateMfaRecoveryCodesMutationVariables
  >
export const SignInAndDisableMfaDocument = /*#__PURE__*/ gql`
  mutation signInAndDisableMfa(
    $email: String!
    $password: String!
    $disableMfaToken: UUID!
  ) {
    signInAndDisableMfa(
      email: $email
      password: $password
      disableMfaToken: $disableMfaToken
    ) @client {
      credentials {
        ...Credentials
      }
    }
  }
  ${CredentialsFragmentDoc}
`
export type SignInAndDisableMfaMutationFn = Apollo.MutationFunction<
  Types.SignInAndDisableMfaMutation,
  Types.SignInAndDisableMfaMutationVariables
>

/**
 * __useSignInAndDisableMfaMutation__
 *
 * To run a mutation, you first call `useSignInAndDisableMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInAndDisableMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInAndDisableMfaMutation, { data, loading, error }] = useSignInAndDisableMfaMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      disableMfaToken: // value for 'disableMfaToken'
 *   },
 * });
 */
export function useSignInAndDisableMfaMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SignInAndDisableMfaMutation,
    Types.SignInAndDisableMfaMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SignInAndDisableMfaMutation,
    Types.SignInAndDisableMfaMutationVariables
  >(SignInAndDisableMfaDocument, options)
}
export type SignInAndDisableMfaMutationHookResult = ReturnType<
  typeof useSignInAndDisableMfaMutation
>
export type SignInAndDisableMfaMutationResult =
  Apollo.MutationResult<Types.SignInAndDisableMfaMutation>
export type SignInAndDisableMfaMutationOptions = Apollo.BaseMutationOptions<
  Types.SignInAndDisableMfaMutation,
  Types.SignInAndDisableMfaMutationVariables
>
export const GetBrowserSettingsDocument = /*#__PURE__*/ gql`
  query getBrowserSettings {
    sidebarRightOpen @client
  }
`

/**
 * __useGetBrowserSettingsQuery__
 *
 * To run a query within a React component, call `useGetBrowserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrowserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrowserSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBrowserSettingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetBrowserSettingsQuery,
    Types.GetBrowserSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetBrowserSettingsQuery,
    Types.GetBrowserSettingsQueryVariables
  >(GetBrowserSettingsDocument, options)
}
export function useGetBrowserSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetBrowserSettingsQuery,
    Types.GetBrowserSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetBrowserSettingsQuery,
    Types.GetBrowserSettingsQueryVariables
  >(GetBrowserSettingsDocument, options)
}

export type GetBrowserSettingsQueryHookResult = ReturnType<
  typeof useGetBrowserSettingsQuery
>
export type GetBrowserSettingsLazyQueryHookResult = ReturnType<
  typeof useGetBrowserSettingsLazyQuery
>
export type GetBrowserSettingsQueryResult = Apollo.QueryResult<
  Types.GetBrowserSettingsQuery,
  Types.GetBrowserSettingsQueryVariables
>
export const GetCommunityPageItemsDocument = /*#__PURE__*/ gql`
  query getCommunityPageItems {
    community @client {
      sections {
        ...CommunitySection
      }
    }
  }
  ${CommunitySectionFragmentDoc}
`

/**
 * __useGetCommunityPageItemsQuery__
 *
 * To run a query within a React component, call `useGetCommunityPageItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityPageItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityPageItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommunityPageItemsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetCommunityPageItemsQuery,
    Types.GetCommunityPageItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetCommunityPageItemsQuery,
    Types.GetCommunityPageItemsQueryVariables
  >(GetCommunityPageItemsDocument, options)
}
export function useGetCommunityPageItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetCommunityPageItemsQuery,
    Types.GetCommunityPageItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetCommunityPageItemsQuery,
    Types.GetCommunityPageItemsQueryVariables
  >(GetCommunityPageItemsDocument, options)
}

export type GetCommunityPageItemsQueryHookResult = ReturnType<
  typeof useGetCommunityPageItemsQuery
>
export type GetCommunityPageItemsLazyQueryHookResult = ReturnType<
  typeof useGetCommunityPageItemsLazyQuery
>
export type GetCommunityPageItemsQueryResult = Apollo.QueryResult<
  Types.GetCommunityPageItemsQuery,
  Types.GetCommunityPageItemsQueryVariables
>
export const GetDiscoverDocument = /*#__PURE__*/ gql`
  query getDiscover {
    discover @client {
      sections @client {
        ...DiscoverSection
      }
    }
  }
  ${DiscoverSectionFragmentDoc}
`

/**
 * __useGetDiscoverQuery__
 *
 * To run a query within a React component, call `useGetDiscoverQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscoverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscoverQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDiscoverQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetDiscoverQuery,
    Types.GetDiscoverQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetDiscoverQuery,
    Types.GetDiscoverQueryVariables
  >(GetDiscoverDocument, options)
}
export function useGetDiscoverLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetDiscoverQuery,
    Types.GetDiscoverQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetDiscoverQuery,
    Types.GetDiscoverQueryVariables
  >(GetDiscoverDocument, options)
}

export type GetDiscoverQueryHookResult = ReturnType<typeof useGetDiscoverQuery>
export type GetDiscoverLazyQueryHookResult = ReturnType<
  typeof useGetDiscoverLazyQuery
>
export type GetDiscoverQueryResult = Apollo.QueryResult<
  Types.GetDiscoverQuery,
  Types.GetDiscoverQueryVariables
>
export const GetDiscoverResourcesDocument = /*#__PURE__*/ gql`
  query getDiscoverResources($type: DiscoveryResourceType!) {
    discoverResources(type: $type) @client {
      ...DiscoverSection
    }
  }
  ${DiscoverSectionFragmentDoc}
`

/**
 * __useGetDiscoverResourcesQuery__
 *
 * To run a query within a React component, call `useGetDiscoverResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscoverResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscoverResourcesQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetDiscoverResourcesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetDiscoverResourcesQuery,
    Types.GetDiscoverResourcesQueryVariables
  > &
    (
      | { variables: Types.GetDiscoverResourcesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetDiscoverResourcesQuery,
    Types.GetDiscoverResourcesQueryVariables
  >(GetDiscoverResourcesDocument, options)
}
export function useGetDiscoverResourcesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetDiscoverResourcesQuery,
    Types.GetDiscoverResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetDiscoverResourcesQuery,
    Types.GetDiscoverResourcesQueryVariables
  >(GetDiscoverResourcesDocument, options)
}

export type GetDiscoverResourcesQueryHookResult = ReturnType<
  typeof useGetDiscoverResourcesQuery
>
export type GetDiscoverResourcesLazyQueryHookResult = ReturnType<
  typeof useGetDiscoverResourcesLazyQuery
>
export type GetDiscoverResourcesQueryResult = Apollo.QueryResult<
  Types.GetDiscoverResourcesQuery,
  Types.GetDiscoverResourcesQueryVariables
>
export const CreatePreviewDocument = /*#__PURE__*/ gql`
  mutation createPreview(
    $shareIdentifier: UUID!
    $name: String!
    $description: String
    $inspectEnabled: Boolean
    $commentsEnabled: Boolean
    $expiryDate: DateTime
    $password: String
    $content: [PreviewContentItem!]
  ) {
    createPreview(
      shareIdentifier: $shareIdentifier
      name: $name
      description: $description
      inspectEnabled: $inspectEnabled
      commentsEnabled: $commentsEnabled
      content: $content
      expiryDate: $expiryDate
      password: $password
    ) {
      preview {
        ...BasicPreview
        pages {
          entries {
            name
          }
          meta {
            totalCount
          }
        }
      }
    }
  }
  ${BasicPreviewFragmentDoc}
`
export type CreatePreviewMutationFn = Apollo.MutationFunction<
  Types.CreatePreviewMutation,
  Types.CreatePreviewMutationVariables
>

/**
 * __useCreatePreviewMutation__
 *
 * To run a mutation, you first call `useCreatePreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPreviewMutation, { data, loading, error }] = useCreatePreviewMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      inspectEnabled: // value for 'inspectEnabled'
 *      commentsEnabled: // value for 'commentsEnabled'
 *      expiryDate: // value for 'expiryDate'
 *      password: // value for 'password'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCreatePreviewMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreatePreviewMutation,
    Types.CreatePreviewMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreatePreviewMutation,
    Types.CreatePreviewMutationVariables
  >(CreatePreviewDocument, options)
}
export type CreatePreviewMutationHookResult = ReturnType<
  typeof useCreatePreviewMutation
>
export type CreatePreviewMutationResult =
  Apollo.MutationResult<Types.CreatePreviewMutation>
export type CreatePreviewMutationOptions = Apollo.BaseMutationOptions<
  Types.CreatePreviewMutation,
  Types.CreatePreviewMutationVariables
>
export const DeletePreviewDocument = /*#__PURE__*/ gql`
  mutation deletePreview($identifier: UUID!) {
    deletePreview(identifier: $identifier) {
      preview {
        identifier
        name
      }
    }
  }
`
export type DeletePreviewMutationFn = Apollo.MutationFunction<
  Types.DeletePreviewMutation,
  Types.DeletePreviewMutationVariables
>

/**
 * __useDeletePreviewMutation__
 *
 * To run a mutation, you first call `useDeletePreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePreviewMutation, { data, loading, error }] = useDeletePreviewMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useDeletePreviewMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeletePreviewMutation,
    Types.DeletePreviewMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeletePreviewMutation,
    Types.DeletePreviewMutationVariables
  >(DeletePreviewDocument, options)
}
export type DeletePreviewMutationHookResult = ReturnType<
  typeof useDeletePreviewMutation
>
export type DeletePreviewMutationResult =
  Apollo.MutationResult<Types.DeletePreviewMutation>
export type DeletePreviewMutationOptions = Apollo.BaseMutationOptions<
  Types.DeletePreviewMutation,
  Types.DeletePreviewMutationVariables
>
export const UpdatePreviewDocument = /*#__PURE__*/ gql`
  mutation updatePreview(
    $identifier: UUID!
    $name: String!
    $description: String
    $inspectEnabled: Boolean!
    $commentsEnabled: Boolean!
    $expiryDate: DateTime
    $password: String
    $content: [PreviewContentItem!]
  ) {
    updatePreview(
      identifier: $identifier
      name: $name
      description: $description
      inspectEnabled: $inspectEnabled
      commentsEnabled: $commentsEnabled
      content: $content
      expiryDate: $expiryDate
      password: $password
    ) {
      preview {
        ...BasicPreview
        pages {
          entries {
            name
          }
          meta {
            totalCount
          }
        }
        prototypes {
          entries {
            ... on Artboard {
              permanentArtboardShortId
              documentVersionShortId
            }
            name
          }
          meta {
            totalCount
          }
        }
      }
    }
  }
  ${BasicPreviewFragmentDoc}
`
export type UpdatePreviewMutationFn = Apollo.MutationFunction<
  Types.UpdatePreviewMutation,
  Types.UpdatePreviewMutationVariables
>

/**
 * __useUpdatePreviewMutation__
 *
 * To run a mutation, you first call `useUpdatePreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreviewMutation, { data, loading, error }] = useUpdatePreviewMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      inspectEnabled: // value for 'inspectEnabled'
 *      commentsEnabled: // value for 'commentsEnabled'
 *      expiryDate: // value for 'expiryDate'
 *      password: // value for 'password'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpdatePreviewMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdatePreviewMutation,
    Types.UpdatePreviewMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdatePreviewMutation,
    Types.UpdatePreviewMutationVariables
  >(UpdatePreviewDocument, options)
}
export type UpdatePreviewMutationHookResult = ReturnType<
  typeof useUpdatePreviewMutation
>
export type UpdatePreviewMutationResult =
  Apollo.MutationResult<Types.UpdatePreviewMutation>
export type UpdatePreviewMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdatePreviewMutation,
  Types.UpdatePreviewMutationVariables
>
export const RefreshPreviewDocument = /*#__PURE__*/ gql`
  mutation refreshPreview($identifier: UUID!) {
    refreshPreview(identifier: $identifier) {
      preview {
        ...BasicPreview
      }
    }
  }
  ${BasicPreviewFragmentDoc}
`
export type RefreshPreviewMutationFn = Apollo.MutationFunction<
  Types.RefreshPreviewMutation,
  Types.RefreshPreviewMutationVariables
>

/**
 * __useRefreshPreviewMutation__
 *
 * To run a mutation, you first call `useRefreshPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshPreviewMutation, { data, loading, error }] = useRefreshPreviewMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useRefreshPreviewMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RefreshPreviewMutation,
    Types.RefreshPreviewMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RefreshPreviewMutation,
    Types.RefreshPreviewMutationVariables
  >(RefreshPreviewDocument, options)
}
export type RefreshPreviewMutationHookResult = ReturnType<
  typeof useRefreshPreviewMutation
>
export type RefreshPreviewMutationResult =
  Apollo.MutationResult<Types.RefreshPreviewMutation>
export type RefreshPreviewMutationOptions = Apollo.BaseMutationOptions<
  Types.RefreshPreviewMutation,
  Types.RefreshPreviewMutationVariables
>
export const DeleteAllPreviewsDocument = /*#__PURE__*/ gql`
  mutation deleteAllPreviews($workspaceIdentifier: UUID!) {
    deleteAllPreviews(identifier: $workspaceIdentifier) {
      workspace {
        identifier
      }
    }
  }
`
export type DeleteAllPreviewsMutationFn = Apollo.MutationFunction<
  Types.DeleteAllPreviewsMutation,
  Types.DeleteAllPreviewsMutationVariables
>

/**
 * __useDeleteAllPreviewsMutation__
 *
 * To run a mutation, you first call `useDeleteAllPreviewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllPreviewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllPreviewsMutation, { data, loading, error }] = useDeleteAllPreviewsMutation({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *   },
 * });
 */
export function useDeleteAllPreviewsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeleteAllPreviewsMutation,
    Types.DeleteAllPreviewsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeleteAllPreviewsMutation,
    Types.DeleteAllPreviewsMutationVariables
  >(DeleteAllPreviewsDocument, options)
}
export type DeleteAllPreviewsMutationHookResult = ReturnType<
  typeof useDeleteAllPreviewsMutation
>
export type DeleteAllPreviewsMutationResult =
  Apollo.MutationResult<Types.DeleteAllPreviewsMutation>
export type DeleteAllPreviewsMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteAllPreviewsMutation,
  Types.DeleteAllPreviewsMutationVariables
>
export const RefreshAllPreviewsDocument = /*#__PURE__*/ gql`
  mutation refreshAllPreviews($workspaceIdentifier: String!) {
    refreshAllPreviews(identifier: $workspaceIdentifier) {
      workspace {
        identifier
      }
    }
  }
`
export type RefreshAllPreviewsMutationFn = Apollo.MutationFunction<
  Types.RefreshAllPreviewsMutation,
  Types.RefreshAllPreviewsMutationVariables
>

/**
 * __useRefreshAllPreviewsMutation__
 *
 * To run a mutation, you first call `useRefreshAllPreviewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshAllPreviewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshAllPreviewsMutation, { data, loading, error }] = useRefreshAllPreviewsMutation({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *   },
 * });
 */
export function useRefreshAllPreviewsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RefreshAllPreviewsMutation,
    Types.RefreshAllPreviewsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RefreshAllPreviewsMutation,
    Types.RefreshAllPreviewsMutationVariables
  >(RefreshAllPreviewsDocument, options)
}
export type RefreshAllPreviewsMutationHookResult = ReturnType<
  typeof useRefreshAllPreviewsMutation
>
export type RefreshAllPreviewsMutationResult =
  Apollo.MutationResult<Types.RefreshAllPreviewsMutation>
export type RefreshAllPreviewsMutationOptions = Apollo.BaseMutationOptions<
  Types.RefreshAllPreviewsMutation,
  Types.RefreshAllPreviewsMutationVariables
>
export const CreatePreviewAnnotationDocument = /*#__PURE__*/ gql`
  mutation createPreviewAnnotation(
    $previewIdentifier: UUID!
    $coordinates: AnnotationCoordinatesInput
    $pageUuid: String
    $frameUuid: String
    $body: String!
  ) {
    createAnnotation: createPreviewAnnotation(
      previewIdentifier: $previewIdentifier
      coordinates: $coordinates
      pageUuid: $pageUuid
      frameUuid: $frameUuid
      body: $body
    ) {
      annotation {
        isOptimistic @client
        identifier
        isNew
        subscriptionStatus
        hasNewComments
        firstComment {
          ...Comment
        }
        share {
          identifier
          subscriptionStatus
        }
        latestCommentCreatedAt
        comments {
          meta {
            totalCount
          }
        }
        currentSubject {
          ... on Artboard {
            documentVersionShortId
            permanentArtboardShortId
            uuid
            page {
              identifier
              uuid
            }
          }
          ... on Page {
            identifier
            pageUUID: uuid
          }
          ... on Component {
            identifier
            uuid
          }
        }
        page {
          ... on Page {
            identifier
            uuid
            ...AnnotationPageInfo
          }
        }
        ...AnnotationCoordinates
        ...AnnotationResolutionInfo
      }
    }
  }
  ${CommentFragmentDoc}
  ${AnnotationPageInfoFragmentDoc}
  ${AnnotationCoordinatesFragmentDoc}
  ${AnnotationResolutionInfoFragmentDoc}
`
export type CreatePreviewAnnotationMutationFn = Apollo.MutationFunction<
  Types.CreatePreviewAnnotationMutation,
  Types.CreatePreviewAnnotationMutationVariables
>

/**
 * __useCreatePreviewAnnotationMutation__
 *
 * To run a mutation, you first call `useCreatePreviewAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePreviewAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPreviewAnnotationMutation, { data, loading, error }] = useCreatePreviewAnnotationMutation({
 *   variables: {
 *      previewIdentifier: // value for 'previewIdentifier'
 *      coordinates: // value for 'coordinates'
 *      pageUuid: // value for 'pageUuid'
 *      frameUuid: // value for 'frameUuid'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreatePreviewAnnotationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreatePreviewAnnotationMutation,
    Types.CreatePreviewAnnotationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreatePreviewAnnotationMutation,
    Types.CreatePreviewAnnotationMutationVariables
  >(CreatePreviewAnnotationDocument, options)
}
export type CreatePreviewAnnotationMutationHookResult = ReturnType<
  typeof useCreatePreviewAnnotationMutation
>
export type CreatePreviewAnnotationMutationResult =
  Apollo.MutationResult<Types.CreatePreviewAnnotationMutation>
export type CreatePreviewAnnotationMutationOptions = Apollo.BaseMutationOptions<
  Types.CreatePreviewAnnotationMutation,
  Types.CreatePreviewAnnotationMutationVariables
>
export const GetSharePreviewsDocument = /*#__PURE__*/ gql`
  query getSharePreviews($shareIdentifier: UUID!) {
    share(id: $shareIdentifier) {
      identifier
      previews {
        identifier
        name
        expiryDate
      }
    }
  }
`

/**
 * __useGetSharePreviewsQuery__
 *
 * To run a query within a React component, call `useGetSharePreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharePreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharePreviewsQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetSharePreviewsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSharePreviewsQuery,
    Types.GetSharePreviewsQueryVariables
  > &
    (
      | { variables: Types.GetSharePreviewsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSharePreviewsQuery,
    Types.GetSharePreviewsQueryVariables
  >(GetSharePreviewsDocument, options)
}
export function useGetSharePreviewsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSharePreviewsQuery,
    Types.GetSharePreviewsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSharePreviewsQuery,
    Types.GetSharePreviewsQueryVariables
  >(GetSharePreviewsDocument, options)
}

export type GetSharePreviewsQueryHookResult = ReturnType<
  typeof useGetSharePreviewsQuery
>
export type GetSharePreviewsLazyQueryHookResult = ReturnType<
  typeof useGetSharePreviewsLazyQuery
>
export type GetSharePreviewsQueryResult = Apollo.QueryResult<
  Types.GetSharePreviewsQuery,
  Types.GetSharePreviewsQueryVariables
>
export const GetSharePreviewDocument = /*#__PURE__*/ gql`
  query getSharePreview($shareIdentifier: UUID!, $previewIdentifier: UUID!) {
    share(id: $shareIdentifier) {
      identifier
      preview(identifier: $previewIdentifier) {
        ...PreviewDetailsFragment
      }
    }
  }
  ${PreviewDetailsFragmentFragmentDoc}
`

/**
 * __useGetSharePreviewQuery__
 *
 * To run a query within a React component, call `useGetSharePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharePreviewQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      previewIdentifier: // value for 'previewIdentifier'
 *   },
 * });
 */
export function useGetSharePreviewQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSharePreviewQuery,
    Types.GetSharePreviewQueryVariables
  > &
    (
      | { variables: Types.GetSharePreviewQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSharePreviewQuery,
    Types.GetSharePreviewQueryVariables
  >(GetSharePreviewDocument, options)
}
export function useGetSharePreviewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSharePreviewQuery,
    Types.GetSharePreviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSharePreviewQuery,
    Types.GetSharePreviewQueryVariables
  >(GetSharePreviewDocument, options)
}

export type GetSharePreviewQueryHookResult = ReturnType<
  typeof useGetSharePreviewQuery
>
export type GetSharePreviewLazyQueryHookResult = ReturnType<
  typeof useGetSharePreviewLazyQuery
>
export type GetSharePreviewQueryResult = Apollo.QueryResult<
  Types.GetSharePreviewQuery,
  Types.GetSharePreviewQueryVariables
>
export const GetPreviewDocument = /*#__PURE__*/ gql`
  query getPreview($previewIdentifier: UUID!, $password: String) {
    preview(identifier: $previewIdentifier, password: $password) {
      ...BasicPreview
      pages {
        entries {
          identifier
          uuid
          presentationFile {
            downloadUrl
            imageToken
            manifestUrl
          }
        }
      }
      prototypes {
        entries {
          ... on Artboard {
            documentVersionShortId
            permanentArtboardShortId
          }
          identifier
          uuid
        }
      }
    }
  }
  ${BasicPreviewFragmentDoc}
`

/**
 * __useGetPreviewQuery__
 *
 * To run a query within a React component, call `useGetPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewQuery({
 *   variables: {
 *      previewIdentifier: // value for 'previewIdentifier'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useGetPreviewQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPreviewQuery,
    Types.GetPreviewQueryVariables
  > &
    (
      | { variables: Types.GetPreviewQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPreviewQuery,
    Types.GetPreviewQueryVariables
  >(GetPreviewDocument, options)
}
export function useGetPreviewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPreviewQuery,
    Types.GetPreviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPreviewQuery,
    Types.GetPreviewQueryVariables
  >(GetPreviewDocument, options)
}

export type GetPreviewQueryHookResult = ReturnType<typeof useGetPreviewQuery>
export type GetPreviewLazyQueryHookResult = ReturnType<
  typeof useGetPreviewLazyQuery
>
export type GetPreviewQueryResult = Apollo.QueryResult<
  Types.GetPreviewQuery,
  Types.GetPreviewQueryVariables
>
export const GetPreviewMentionableUsersDocument = /*#__PURE__*/ gql`
  query getPreviewMentionableUsers(
    $previewIdentifier: UUID!
    $password: String
  ) {
    preview(identifier: $previewIdentifier, password: $password) {
      identifier
      mentionableUsers {
        avatar {
          small
        }
        identifier
        name
      }
    }
  }
`

/**
 * __useGetPreviewMentionableUsersQuery__
 *
 * To run a query within a React component, call `useGetPreviewMentionableUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewMentionableUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewMentionableUsersQuery({
 *   variables: {
 *      previewIdentifier: // value for 'previewIdentifier'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useGetPreviewMentionableUsersQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPreviewMentionableUsersQuery,
    Types.GetPreviewMentionableUsersQueryVariables
  > &
    (
      | {
          variables: Types.GetPreviewMentionableUsersQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPreviewMentionableUsersQuery,
    Types.GetPreviewMentionableUsersQueryVariables
  >(GetPreviewMentionableUsersDocument, options)
}
export function useGetPreviewMentionableUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPreviewMentionableUsersQuery,
    Types.GetPreviewMentionableUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPreviewMentionableUsersQuery,
    Types.GetPreviewMentionableUsersQueryVariables
  >(GetPreviewMentionableUsersDocument, options)
}

export type GetPreviewMentionableUsersQueryHookResult = ReturnType<
  typeof useGetPreviewMentionableUsersQuery
>
export type GetPreviewMentionableUsersLazyQueryHookResult = ReturnType<
  typeof useGetPreviewMentionableUsersLazyQuery
>
export type GetPreviewMentionableUsersQueryResult = Apollo.QueryResult<
  Types.GetPreviewMentionableUsersQuery,
  Types.GetPreviewMentionableUsersQueryVariables
>
export const GetPreviewDetailsDocument = /*#__PURE__*/ gql`
  query getPreviewDetails($previewIdentifier: UUID!, $password: String) {
    preview(identifier: $previewIdentifier, password: $password) {
      ...PreviewDetailsFragment
    }
  }
  ${PreviewDetailsFragmentFragmentDoc}
`

/**
 * __useGetPreviewDetailsQuery__
 *
 * To run a query within a React component, call `useGetPreviewDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewDetailsQuery({
 *   variables: {
 *      previewIdentifier: // value for 'previewIdentifier'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useGetPreviewDetailsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPreviewDetailsQuery,
    Types.GetPreviewDetailsQueryVariables
  > &
    (
      | { variables: Types.GetPreviewDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPreviewDetailsQuery,
    Types.GetPreviewDetailsQueryVariables
  >(GetPreviewDetailsDocument, options)
}
export function useGetPreviewDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPreviewDetailsQuery,
    Types.GetPreviewDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPreviewDetailsQuery,
    Types.GetPreviewDetailsQueryVariables
  >(GetPreviewDetailsDocument, options)
}

export type GetPreviewDetailsQueryHookResult = ReturnType<
  typeof useGetPreviewDetailsQuery
>
export type GetPreviewDetailsLazyQueryHookResult = ReturnType<
  typeof useGetPreviewDetailsLazyQuery
>
export type GetPreviewDetailsQueryResult = Apollo.QueryResult<
  Types.GetPreviewDetailsQuery,
  Types.GetPreviewDetailsQueryVariables
>
export const GetPreviewPagesDocument = /*#__PURE__*/ gql`
  query getPreviewPages(
    $previewIdentifier: UUID!
    $after: String
    $password: String
  ) {
    preview(identifier: $previewIdentifier, password: $password) {
      identifier
      pages(after: $after) {
        entries {
          ...PublicationPage
        }
        meta {
          after
          totalCount
        }
      }
    }
  }
  ${PublicationPageFragmentDoc}
`

/**
 * __useGetPreviewPagesQuery__
 *
 * To run a query within a React component, call `useGetPreviewPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewPagesQuery({
 *   variables: {
 *      previewIdentifier: // value for 'previewIdentifier'
 *      after: // value for 'after'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useGetPreviewPagesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPreviewPagesQuery,
    Types.GetPreviewPagesQueryVariables
  > &
    (
      | { variables: Types.GetPreviewPagesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPreviewPagesQuery,
    Types.GetPreviewPagesQueryVariables
  >(GetPreviewPagesDocument, options)
}
export function useGetPreviewPagesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPreviewPagesQuery,
    Types.GetPreviewPagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPreviewPagesQuery,
    Types.GetPreviewPagesQueryVariables
  >(GetPreviewPagesDocument, options)
}

export type GetPreviewPagesQueryHookResult = ReturnType<
  typeof useGetPreviewPagesQuery
>
export type GetPreviewPagesLazyQueryHookResult = ReturnType<
  typeof useGetPreviewPagesLazyQuery
>
export type GetPreviewPagesQueryResult = Apollo.QueryResult<
  Types.GetPreviewPagesQuery,
  Types.GetPreviewPagesQueryVariables
>
export const GetPreviewPrototypesDocument = /*#__PURE__*/ gql`
  query getPreviewPrototypes(
    $previewIdentifier: UUID!
    $after: String
    $password: String
  ) {
    preview(identifier: $previewIdentifier, password: $password) {
      identifier
      prototypes(after: $after) {
        entries {
          ...FrameGroupDetails
        }
        meta {
          after
          totalCount
        }
      }
    }
  }
  ${FrameGroupDetailsFragmentDoc}
`

/**
 * __useGetPreviewPrototypesQuery__
 *
 * To run a query within a React component, call `useGetPreviewPrototypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewPrototypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewPrototypesQuery({
 *   variables: {
 *      previewIdentifier: // value for 'previewIdentifier'
 *      after: // value for 'after'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useGetPreviewPrototypesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPreviewPrototypesQuery,
    Types.GetPreviewPrototypesQueryVariables
  > &
    (
      | { variables: Types.GetPreviewPrototypesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPreviewPrototypesQuery,
    Types.GetPreviewPrototypesQueryVariables
  >(GetPreviewPrototypesDocument, options)
}
export function useGetPreviewPrototypesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPreviewPrototypesQuery,
    Types.GetPreviewPrototypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPreviewPrototypesQuery,
    Types.GetPreviewPrototypesQueryVariables
  >(GetPreviewPrototypesDocument, options)
}

export type GetPreviewPrototypesQueryHookResult = ReturnType<
  typeof useGetPreviewPrototypesQuery
>
export type GetPreviewPrototypesLazyQueryHookResult = ReturnType<
  typeof useGetPreviewPrototypesLazyQuery
>
export type GetPreviewPrototypesQueryResult = Apollo.QueryResult<
  Types.GetPreviewPrototypesQuery,
  Types.GetPreviewPrototypesQueryVariables
>
export const GetPreviewPageDocument = /*#__PURE__*/ gql`
  query getPreviewPage(
    $previewIdentifier: UUID!
    $pageUUID: UUID!
    $password: String
  ) {
    preview(identifier: $previewIdentifier, password: $password) {
      identifier
      page(uuid: $pageUUID) {
        ...PageDetails
        ...PresentationFile
        frame {
          ...FrameGroupDetails
        }
        frames {
          entries {
            ...FrameGroupDetails
            ... on Artboard {
              shortId
              permanentArtboardShortId
              revisionIdentifier
            }
          }
        }
      }
    }
  }
  ${PageDetailsFragmentDoc}
  ${PresentationFileFragmentDoc}
  ${FrameGroupDetailsFragmentDoc}
`

/**
 * __useGetPreviewPageQuery__
 *
 * To run a query within a React component, call `useGetPreviewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewPageQuery({
 *   variables: {
 *      previewIdentifier: // value for 'previewIdentifier'
 *      pageUUID: // value for 'pageUUID'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useGetPreviewPageQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPreviewPageQuery,
    Types.GetPreviewPageQueryVariables
  > &
    (
      | { variables: Types.GetPreviewPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPreviewPageQuery,
    Types.GetPreviewPageQueryVariables
  >(GetPreviewPageDocument, options)
}
export function useGetPreviewPageLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPreviewPageQuery,
    Types.GetPreviewPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPreviewPageQuery,
    Types.GetPreviewPageQueryVariables
  >(GetPreviewPageDocument, options)
}

export type GetPreviewPageQueryHookResult = ReturnType<
  typeof useGetPreviewPageQuery
>
export type GetPreviewPageLazyQueryHookResult = ReturnType<
  typeof useGetPreviewPageLazyQuery
>
export type GetPreviewPageQueryResult = Apollo.QueryResult<
  Types.GetPreviewPageQuery,
  Types.GetPreviewPageQueryVariables
>
export const GetWorkspaceSharesWithPreviewsDocument = /*#__PURE__*/ gql`
  query getWorkspaceSharesWithPreviews(
    $workspaceIdentifier: UUID!
    $search: SharesSearchParams
    $after: String
  ) {
    workspace(identifier: $workspaceIdentifier) {
      identifier
      shares(search: $search, sortOrder: NAME_ASC, after: $after) {
        entries {
          ...ShareBase
          version(preferredState: PROCESSED) {
            document {
              previewFile {
                ...ShareThumbnails
              }
            }
          }
          previews {
            ...BasicPreview
          }
        }
        meta {
          after
          totalCount
        }
      }
    }
  }
  ${ShareBaseFragmentDoc}
  ${ShareThumbnailsFragmentDoc}
  ${BasicPreviewFragmentDoc}
`

/**
 * __useGetWorkspaceSharesWithPreviewsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSharesWithPreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSharesWithPreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSharesWithPreviewsQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      search: // value for 'search'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetWorkspaceSharesWithPreviewsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceSharesWithPreviewsQuery,
    Types.GetWorkspaceSharesWithPreviewsQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceSharesWithPreviewsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceSharesWithPreviewsQuery,
    Types.GetWorkspaceSharesWithPreviewsQueryVariables
  >(GetWorkspaceSharesWithPreviewsDocument, options)
}
export function useGetWorkspaceSharesWithPreviewsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceSharesWithPreviewsQuery,
    Types.GetWorkspaceSharesWithPreviewsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceSharesWithPreviewsQuery,
    Types.GetWorkspaceSharesWithPreviewsQueryVariables
  >(GetWorkspaceSharesWithPreviewsDocument, options)
}

export type GetWorkspaceSharesWithPreviewsQueryHookResult = ReturnType<
  typeof useGetWorkspaceSharesWithPreviewsQuery
>
export type GetWorkspaceSharesWithPreviewsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceSharesWithPreviewsLazyQuery
>
export type GetWorkspaceSharesWithPreviewsQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceSharesWithPreviewsQuery,
  Types.GetWorkspaceSharesWithPreviewsQueryVariables
>
export const GetPreviewAnnotationsDocument = /*#__PURE__*/ gql`
  query getPreviewAnnotations(
    $previewIdentifier: UUID!
    $subjects: [AnnotationSubjectInput]
    $annotationStatus: AnnotationStatusFilter
    $sort: AnnotationSortOrder
    $after: String
  ) {
    annotations: previewAnnotations(
      previewIdentifier: $previewIdentifier
      subjects: $subjects
      status: $annotationStatus
      sortOrder: $sort
      after: $after
    ) {
      meta {
        after
        totalCount
      }
      entries {
        ...BaseAnnotation
      }
    }
  }
  ${BaseAnnotationFragmentDoc}
`

/**
 * __useGetPreviewAnnotationsQuery__
 *
 * To run a query within a React component, call `useGetPreviewAnnotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewAnnotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewAnnotationsQuery({
 *   variables: {
 *      previewIdentifier: // value for 'previewIdentifier'
 *      subjects: // value for 'subjects'
 *      annotationStatus: // value for 'annotationStatus'
 *      sort: // value for 'sort'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPreviewAnnotationsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPreviewAnnotationsQuery,
    Types.GetPreviewAnnotationsQueryVariables
  > &
    (
      | { variables: Types.GetPreviewAnnotationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPreviewAnnotationsQuery,
    Types.GetPreviewAnnotationsQueryVariables
  >(GetPreviewAnnotationsDocument, options)
}
export function useGetPreviewAnnotationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPreviewAnnotationsQuery,
    Types.GetPreviewAnnotationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPreviewAnnotationsQuery,
    Types.GetPreviewAnnotationsQueryVariables
  >(GetPreviewAnnotationsDocument, options)
}

export type GetPreviewAnnotationsQueryHookResult = ReturnType<
  typeof useGetPreviewAnnotationsQuery
>
export type GetPreviewAnnotationsLazyQueryHookResult = ReturnType<
  typeof useGetPreviewAnnotationsLazyQuery
>
export type GetPreviewAnnotationsQueryResult = Apollo.QueryResult<
  Types.GetPreviewAnnotationsQuery,
  Types.GetPreviewAnnotationsQueryVariables
>
export const GetPreviewAnnotationDotsDocument = /*#__PURE__*/ gql`
  query getPreviewAnnotationDots(
    $previewIdentifier: UUID!
    $subjects: [AnnotationSubjectInput]
    $status: AnnotationStatusFilter
    $sortOrder: AnnotationSortOrder
    $after: String
  ) {
    previewAnnotations(
      previewIdentifier: $previewIdentifier
      subjects: $subjects
      status: $status
      sortOrder: $sortOrder
      limit: 100
      after: $after
    ) {
      meta {
        after
        totalCount
      }
      entries {
        ...AnnotationDot
      }
    }
  }
  ${AnnotationDotFragmentDoc}
`

/**
 * __useGetPreviewAnnotationDotsQuery__
 *
 * To run a query within a React component, call `useGetPreviewAnnotationDotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewAnnotationDotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewAnnotationDotsQuery({
 *   variables: {
 *      previewIdentifier: // value for 'previewIdentifier'
 *      subjects: // value for 'subjects'
 *      status: // value for 'status'
 *      sortOrder: // value for 'sortOrder'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPreviewAnnotationDotsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPreviewAnnotationDotsQuery,
    Types.GetPreviewAnnotationDotsQueryVariables
  > &
    (
      | {
          variables: Types.GetPreviewAnnotationDotsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPreviewAnnotationDotsQuery,
    Types.GetPreviewAnnotationDotsQueryVariables
  >(GetPreviewAnnotationDotsDocument, options)
}
export function useGetPreviewAnnotationDotsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPreviewAnnotationDotsQuery,
    Types.GetPreviewAnnotationDotsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPreviewAnnotationDotsQuery,
    Types.GetPreviewAnnotationDotsQueryVariables
  >(GetPreviewAnnotationDotsDocument, options)
}

export type GetPreviewAnnotationDotsQueryHookResult = ReturnType<
  typeof useGetPreviewAnnotationDotsQuery
>
export type GetPreviewAnnotationDotsLazyQueryHookResult = ReturnType<
  typeof useGetPreviewAnnotationDotsLazyQuery
>
export type GetPreviewAnnotationDotsQueryResult = Apollo.QueryResult<
  Types.GetPreviewAnnotationDotsQuery,
  Types.GetPreviewAnnotationDotsQueryVariables
>
export const UpdateProjectDocument = /*#__PURE__*/ gql`
  mutation updateProject(
    $identifier: UUID!
    $name: String
    $description: String
  ) {
    updateProject(
      identifier: $identifier
      name: $name
      description: $description
    ) {
      project {
        ...Project
      }
    }
  }
  ${ProjectFragmentDoc}
`
export type UpdateProjectMutationFn = Apollo.MutationFunction<
  Types.UpdateProjectMutation,
  Types.UpdateProjectMutationVariables
>

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateProjectMutation,
    Types.UpdateProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateProjectMutation,
    Types.UpdateProjectMutationVariables
  >(UpdateProjectDocument, options)
}
export type UpdateProjectMutationHookResult = ReturnType<
  typeof useUpdateProjectMutation
>
export type UpdateProjectMutationResult =
  Apollo.MutationResult<Types.UpdateProjectMutation>
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateProjectMutation,
  Types.UpdateProjectMutationVariables
>
export const DeleteProjectDocument = /*#__PURE__*/ gql`
  mutation deleteProject($projectId: ShortId!) {
    deleteProject(projectId: $projectId) {
      successful
      errors {
        ...UserError
      }
      project {
        identifier
        deletedAt
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type DeleteProjectMutationFn = Apollo.MutationFunction<
  Types.DeleteProjectMutation,
  Types.DeleteProjectMutationVariables
>

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeleteProjectMutation,
    Types.DeleteProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeleteProjectMutation,
    Types.DeleteProjectMutationVariables
  >(DeleteProjectDocument, options)
}
export type DeleteProjectMutationHookResult = ReturnType<
  typeof useDeleteProjectMutation
>
export type DeleteProjectMutationResult =
  Apollo.MutationResult<Types.DeleteProjectMutation>
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteProjectMutation,
  Types.DeleteProjectMutationVariables
>
export const RemoveShareFromProjectDocument = /*#__PURE__*/ gql`
  mutation removeShareFromProject($shareId: ShortId!, $projectId: ShortId!) {
    removeShareFromProject(shareId: $shareId, projectId: $projectId) {
      errors {
        ...UserError
      }
      project {
        ...ProjectPreview
      }
      successful
    }
  }
  ${UserErrorFragmentDoc}
  ${ProjectPreviewFragmentDoc}
`
export type RemoveShareFromProjectMutationFn = Apollo.MutationFunction<
  Types.RemoveShareFromProjectMutation,
  Types.RemoveShareFromProjectMutationVariables
>

/**
 * __useRemoveShareFromProjectMutation__
 *
 * To run a mutation, you first call `useRemoveShareFromProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveShareFromProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeShareFromProjectMutation, { data, loading, error }] = useRemoveShareFromProjectMutation({
 *   variables: {
 *      shareId: // value for 'shareId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRemoveShareFromProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RemoveShareFromProjectMutation,
    Types.RemoveShareFromProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RemoveShareFromProjectMutation,
    Types.RemoveShareFromProjectMutationVariables
  >(RemoveShareFromProjectDocument, options)
}
export type RemoveShareFromProjectMutationHookResult = ReturnType<
  typeof useRemoveShareFromProjectMutation
>
export type RemoveShareFromProjectMutationResult =
  Apollo.MutationResult<Types.RemoveShareFromProjectMutation>
export type RemoveShareFromProjectMutationOptions = Apollo.BaseMutationOptions<
  Types.RemoveShareFromProjectMutation,
  Types.RemoveShareFromProjectMutationVariables
>
export const MoveShareToProjectDocument = /*#__PURE__*/ gql`
  mutation moveShareToProject($projectId: UUID!, $shareId: UUID!) {
    moveShareToProject(
      projectIdentifier: $projectId
      shareIdentifier: $shareId
    ) {
      errors {
        ...UserError
      }
      successful
      project {
        ...ProjectDetails
      }
      share {
        ...ShareListItem
        isDraft
      }
    }
  }
  ${UserErrorFragmentDoc}
  ${ProjectDetailsFragmentDoc}
  ${ShareListItemFragmentDoc}
`
export type MoveShareToProjectMutationFn = Apollo.MutationFunction<
  Types.MoveShareToProjectMutation,
  Types.MoveShareToProjectMutationVariables
>

/**
 * __useMoveShareToProjectMutation__
 *
 * To run a mutation, you first call `useMoveShareToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveShareToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveShareToProjectMutation, { data, loading, error }] = useMoveShareToProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      shareId: // value for 'shareId'
 *   },
 * });
 */
export function useMoveShareToProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.MoveShareToProjectMutation,
    Types.MoveShareToProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.MoveShareToProjectMutation,
    Types.MoveShareToProjectMutationVariables
  >(MoveShareToProjectDocument, options)
}
export type MoveShareToProjectMutationHookResult = ReturnType<
  typeof useMoveShareToProjectMutation
>
export type MoveShareToProjectMutationResult =
  Apollo.MutationResult<Types.MoveShareToProjectMutation>
export type MoveShareToProjectMutationOptions = Apollo.BaseMutationOptions<
  Types.MoveShareToProjectMutation,
  Types.MoveShareToProjectMutationVariables
>
export const RestoreProjectDocument = /*#__PURE__*/ gql`
  mutation restoreProject($projectIdentifier: UUID!) {
    restoreProject(identifier: $projectIdentifier) {
      project {
        identifier
        deletedAt
        archivedAt
      }
    }
  }
`
export type RestoreProjectMutationFn = Apollo.MutationFunction<
  Types.RestoreProjectMutation,
  Types.RestoreProjectMutationVariables
>

/**
 * __useRestoreProjectMutation__
 *
 * To run a mutation, you first call `useRestoreProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreProjectMutation, { data, loading, error }] = useRestoreProjectMutation({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useRestoreProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RestoreProjectMutation,
    Types.RestoreProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RestoreProjectMutation,
    Types.RestoreProjectMutationVariables
  >(RestoreProjectDocument, options)
}
export type RestoreProjectMutationHookResult = ReturnType<
  typeof useRestoreProjectMutation
>
export type RestoreProjectMutationResult =
  Apollo.MutationResult<Types.RestoreProjectMutation>
export type RestoreProjectMutationOptions = Apollo.BaseMutationOptions<
  Types.RestoreProjectMutation,
  Types.RestoreProjectMutationVariables
>
export const DeleteProjectPermanentlyDocument = /*#__PURE__*/ gql`
  mutation deleteProjectPermanently($projectIdentifier: UUID!) {
    deleteProjectPermanently(identifier: $projectIdentifier) {
      projectIdentifier
    }
  }
`
export type DeleteProjectPermanentlyMutationFn = Apollo.MutationFunction<
  Types.DeleteProjectPermanentlyMutation,
  Types.DeleteProjectPermanentlyMutationVariables
>

/**
 * __useDeleteProjectPermanentlyMutation__
 *
 * To run a mutation, you first call `useDeleteProjectPermanentlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectPermanentlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectPermanentlyMutation, { data, loading, error }] = useDeleteProjectPermanentlyMutation({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useDeleteProjectPermanentlyMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeleteProjectPermanentlyMutation,
    Types.DeleteProjectPermanentlyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeleteProjectPermanentlyMutation,
    Types.DeleteProjectPermanentlyMutationVariables
  >(DeleteProjectPermanentlyDocument, options)
}
export type DeleteProjectPermanentlyMutationHookResult = ReturnType<
  typeof useDeleteProjectPermanentlyMutation
>
export type DeleteProjectPermanentlyMutationResult =
  Apollo.MutationResult<Types.DeleteProjectPermanentlyMutation>
export type DeleteProjectPermanentlyMutationOptions =
  Apollo.BaseMutationOptions<
    Types.DeleteProjectPermanentlyMutation,
    Types.DeleteProjectPermanentlyMutationVariables
  >
export const RequestAccessToProjectDocument = /*#__PURE__*/ gql`
  mutation requestAccessToProject(
    $projectShortId: ShortId
    $projectIdentifier: UUID
  ) {
    requestAccessToProject(
      projectShortId: $projectShortId
      projectIdentifier: $projectIdentifier
    ) {
      __typename
    }
  }
`
export type RequestAccessToProjectMutationFn = Apollo.MutationFunction<
  Types.RequestAccessToProjectMutation,
  Types.RequestAccessToProjectMutationVariables
>

/**
 * __useRequestAccessToProjectMutation__
 *
 * To run a mutation, you first call `useRequestAccessToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAccessToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAccessToProjectMutation, { data, loading, error }] = useRequestAccessToProjectMutation({
 *   variables: {
 *      projectShortId: // value for 'projectShortId'
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useRequestAccessToProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RequestAccessToProjectMutation,
    Types.RequestAccessToProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RequestAccessToProjectMutation,
    Types.RequestAccessToProjectMutationVariables
  >(RequestAccessToProjectDocument, options)
}
export type RequestAccessToProjectMutationHookResult = ReturnType<
  typeof useRequestAccessToProjectMutation
>
export type RequestAccessToProjectMutationResult =
  Apollo.MutationResult<Types.RequestAccessToProjectMutation>
export type RequestAccessToProjectMutationOptions = Apollo.BaseMutationOptions<
  Types.RequestAccessToProjectMutation,
  Types.RequestAccessToProjectMutationVariables
>
export const UpdateProjectPermissionDocument = /*#__PURE__*/ gql`
  mutation updateProjectPermission(
    $projectIdentifier: UUID!
    $workspaceAccessLevel: ProjectWorkspaceAccessLevel!
  ) {
    updateProjectPermission(
      projectIdentifier: $projectIdentifier
      workspaceAccessLevel: $workspaceAccessLevel
    ) {
      project {
        ...Project
      }
    }
  }
  ${ProjectFragmentDoc}
`
export type UpdateProjectPermissionMutationFn = Apollo.MutationFunction<
  Types.UpdateProjectPermissionMutation,
  Types.UpdateProjectPermissionMutationVariables
>

/**
 * __useUpdateProjectPermissionMutation__
 *
 * To run a mutation, you first call `useUpdateProjectPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectPermissionMutation, { data, loading, error }] = useUpdateProjectPermissionMutation({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *      workspaceAccessLevel: // value for 'workspaceAccessLevel'
 *   },
 * });
 */
export function useUpdateProjectPermissionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateProjectPermissionMutation,
    Types.UpdateProjectPermissionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateProjectPermissionMutation,
    Types.UpdateProjectPermissionMutationVariables
  >(UpdateProjectPermissionDocument, options)
}
export type UpdateProjectPermissionMutationHookResult = ReturnType<
  typeof useUpdateProjectPermissionMutation
>
export type UpdateProjectPermissionMutationResult =
  Apollo.MutationResult<Types.UpdateProjectPermissionMutation>
export type UpdateProjectPermissionMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateProjectPermissionMutation,
  Types.UpdateProjectPermissionMutationVariables
>
export const CreateProjectDocument = /*#__PURE__*/ gql`
  mutation createProject(
    $workspaceId: UUID!
    $name: String!
    $workspaceAccessLevel: ProjectWorkspaceAccessLevel
    $workspaceMembershipIdentifiers: [UUID!]
    $guestsToInvite: [CreateWorkspaceProjectGuestToInvite!]
    $permissionGroups: [PermissionGroupParam!]
    $description: String
    $parentProjectIdentifier: UUID
    $storageItems: [MinimalStorageItem!]
  ) {
    createWorkspaceProject(
      workspaceIdentifier: $workspaceId
      name: $name
      workspaceAccessLevel: $workspaceAccessLevel
      workspaceMembershipIdentifiers: $workspaceMembershipIdentifiers
      guestsToInvite: $guestsToInvite
      permissionGroups: $permissionGroups
      description: $description
      parentProjectIdentifier: $parentProjectIdentifier
      storageItems: $storageItems
    ) {
      project {
        ...Project
        parentProject {
          identifier
          name
          nestedProjectsCount
          sharesCount
        }
      }
    }
  }
  ${ProjectFragmentDoc}
`
export type CreateProjectMutationFn = Apollo.MutationFunction<
  Types.CreateProjectMutation,
  Types.CreateProjectMutationVariables
>

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      name: // value for 'name'
 *      workspaceAccessLevel: // value for 'workspaceAccessLevel'
 *      workspaceMembershipIdentifiers: // value for 'workspaceMembershipIdentifiers'
 *      guestsToInvite: // value for 'guestsToInvite'
 *      permissionGroups: // value for 'permissionGroups'
 *      description: // value for 'description'
 *      parentProjectIdentifier: // value for 'parentProjectIdentifier'
 *      storageItems: // value for 'storageItems'
 *   },
 * });
 */
export function useCreateProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreateProjectMutation,
    Types.CreateProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreateProjectMutation,
    Types.CreateProjectMutationVariables
  >(CreateProjectDocument, options)
}
export type CreateProjectMutationHookResult = ReturnType<
  typeof useCreateProjectMutation
>
export type CreateProjectMutationResult =
  Apollo.MutationResult<Types.CreateProjectMutation>
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateProjectMutation,
  Types.CreateProjectMutationVariables
>
export const RemoveProjectMemberDocument = /*#__PURE__*/ gql`
  mutation removeProjectMember(
    $membershipIdentifier: UUID!
    $confirmed: Boolean! = false
    $removeShareMemberships: Boolean
  ) {
    removeProjectMember(
      membershipIdentifier: $membershipIdentifier
      confirmed: $confirmed
      removeShareMemberships: $removeShareMemberships
    ) {
      project {
        identifier
        projectPrivacyIcon
      }
    }
  }
`
export type RemoveProjectMemberMutationFn = Apollo.MutationFunction<
  Types.RemoveProjectMemberMutation,
  Types.RemoveProjectMemberMutationVariables
>

/**
 * __useRemoveProjectMemberMutation__
 *
 * To run a mutation, you first call `useRemoveProjectMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectMemberMutation, { data, loading, error }] = useRemoveProjectMemberMutation({
 *   variables: {
 *      membershipIdentifier: // value for 'membershipIdentifier'
 *      confirmed: // value for 'confirmed'
 *      removeShareMemberships: // value for 'removeShareMemberships'
 *   },
 * });
 */
export function useRemoveProjectMemberMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RemoveProjectMemberMutation,
    Types.RemoveProjectMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RemoveProjectMemberMutation,
    Types.RemoveProjectMemberMutationVariables
  >(RemoveProjectMemberDocument, options)
}
export type RemoveProjectMemberMutationHookResult = ReturnType<
  typeof useRemoveProjectMemberMutation
>
export type RemoveProjectMemberMutationResult =
  Apollo.MutationResult<Types.RemoveProjectMemberMutation>
export type RemoveProjectMemberMutationOptions = Apollo.BaseMutationOptions<
  Types.RemoveProjectMemberMutation,
  Types.RemoveProjectMemberMutationVariables
>
export const LeaveProjectDocument = /*#__PURE__*/ gql`
  mutation leaveProject($projectIdentifier: UUID!) {
    leaveProject(projectIdentifier: $projectIdentifier) {
      project {
        identifier
      }
    }
  }
`
export type LeaveProjectMutationFn = Apollo.MutationFunction<
  Types.LeaveProjectMutation,
  Types.LeaveProjectMutationVariables
>

/**
 * __useLeaveProjectMutation__
 *
 * To run a mutation, you first call `useLeaveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveProjectMutation, { data, loading, error }] = useLeaveProjectMutation({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useLeaveProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.LeaveProjectMutation,
    Types.LeaveProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.LeaveProjectMutation,
    Types.LeaveProjectMutationVariables
  >(LeaveProjectDocument, options)
}
export type LeaveProjectMutationHookResult = ReturnType<
  typeof useLeaveProjectMutation
>
export type LeaveProjectMutationResult =
  Apollo.MutationResult<Types.LeaveProjectMutation>
export type LeaveProjectMutationOptions = Apollo.BaseMutationOptions<
  Types.LeaveProjectMutation,
  Types.LeaveProjectMutationVariables
>
export const PinProjectDocument = /*#__PURE__*/ gql`
  mutation pinProject($projectIdentifier: UUID!) {
    pinProject(input: { projectIdentifier: $projectIdentifier }) {
      project {
        identifier
      }
    }
  }
`
export type PinProjectMutationFn = Apollo.MutationFunction<
  Types.PinProjectMutation,
  Types.PinProjectMutationVariables
>

/**
 * __usePinProjectMutation__
 *
 * To run a mutation, you first call `usePinProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinProjectMutation, { data, loading, error }] = usePinProjectMutation({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function usePinProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.PinProjectMutation,
    Types.PinProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.PinProjectMutation,
    Types.PinProjectMutationVariables
  >(PinProjectDocument, options)
}
export type PinProjectMutationHookResult = ReturnType<
  typeof usePinProjectMutation
>
export type PinProjectMutationResult =
  Apollo.MutationResult<Types.PinProjectMutation>
export type PinProjectMutationOptions = Apollo.BaseMutationOptions<
  Types.PinProjectMutation,
  Types.PinProjectMutationVariables
>
export const UnpinProjectDocument = /*#__PURE__*/ gql`
  mutation unpinProject($projectIdentifier: UUID!) {
    unpinProject(input: { projectIdentifier: $projectIdentifier }) {
      project {
        identifier
      }
    }
  }
`
export type UnpinProjectMutationFn = Apollo.MutationFunction<
  Types.UnpinProjectMutation,
  Types.UnpinProjectMutationVariables
>

/**
 * __useUnpinProjectMutation__
 *
 * To run a mutation, you first call `useUnpinProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinProjectMutation, { data, loading, error }] = useUnpinProjectMutation({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useUnpinProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UnpinProjectMutation,
    Types.UnpinProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UnpinProjectMutation,
    Types.UnpinProjectMutationVariables
  >(UnpinProjectDocument, options)
}
export type UnpinProjectMutationHookResult = ReturnType<
  typeof useUnpinProjectMutation
>
export type UnpinProjectMutationResult =
  Apollo.MutationResult<Types.UnpinProjectMutation>
export type UnpinProjectMutationOptions = Apollo.BaseMutationOptions<
  Types.UnpinProjectMutation,
  Types.UnpinProjectMutationVariables
>
export const UnarchiveProjectDocument = /*#__PURE__*/ gql`
  mutation unarchiveProject($projectIdentifier: UUID!) {
    unarchiveProject(identifier: $projectIdentifier) {
      project {
        ...Project
      }
    }
  }
  ${ProjectFragmentDoc}
`
export type UnarchiveProjectMutationFn = Apollo.MutationFunction<
  Types.UnarchiveProjectMutation,
  Types.UnarchiveProjectMutationVariables
>

/**
 * __useUnarchiveProjectMutation__
 *
 * To run a mutation, you first call `useUnarchiveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveProjectMutation, { data, loading, error }] = useUnarchiveProjectMutation({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useUnarchiveProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UnarchiveProjectMutation,
    Types.UnarchiveProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UnarchiveProjectMutation,
    Types.UnarchiveProjectMutationVariables
  >(UnarchiveProjectDocument, options)
}
export type UnarchiveProjectMutationHookResult = ReturnType<
  typeof useUnarchiveProjectMutation
>
export type UnarchiveProjectMutationResult =
  Apollo.MutationResult<Types.UnarchiveProjectMutation>
export type UnarchiveProjectMutationOptions = Apollo.BaseMutationOptions<
  Types.UnarchiveProjectMutation,
  Types.UnarchiveProjectMutationVariables
>
export const GetProjectsDocument = /*#__PURE__*/ gql`
  query getProjects($workspaceId: UUID!, $after: String) {
    workspace(identifier: $workspaceId) {
      identifier
      projects(after: $after, type: STANDARD, topLevel: false) {
        entries {
          ...Project
        }
        meta {
          after
          limit
          totalCount
        }
      }
      draftsProject: projects(type: PERSONAL_DRAFTS, topLevel: false) {
        entries {
          ...Project
        }
      }
    }
  }
  ${ProjectFragmentDoc}
`

/**
 * __useGetProjectsQuery__
 *
 * To run a query within a React component, call `useGetProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetProjectsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectsQuery,
    Types.GetProjectsQueryVariables
  > &
    (
      | { variables: Types.GetProjectsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectsQuery,
    Types.GetProjectsQueryVariables
  >(GetProjectsDocument, options)
}
export function useGetProjectsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectsQuery,
    Types.GetProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectsQuery,
    Types.GetProjectsQueryVariables
  >(GetProjectsDocument, options)
}

export type GetProjectsQueryHookResult = ReturnType<typeof useGetProjectsQuery>
export type GetProjectsLazyQueryHookResult = ReturnType<
  typeof useGetProjectsLazyQuery
>
export type GetProjectsQueryResult = Apollo.QueryResult<
  Types.GetProjectsQuery,
  Types.GetProjectsQueryVariables
>
export const GetNestedProjectDocument = /*#__PURE__*/ gql`
  query getNestedProject($projectIdentifier: UUID!) {
    project(identifier: $projectIdentifier) {
      identifier
      ...NestedProject
    }
  }
  ${NestedProjectFragmentDoc}
`

/**
 * __useGetNestedProjectQuery__
 *
 * To run a query within a React component, call `useGetNestedProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNestedProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNestedProjectQuery({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useGetNestedProjectQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetNestedProjectQuery,
    Types.GetNestedProjectQueryVariables
  > &
    (
      | { variables: Types.GetNestedProjectQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetNestedProjectQuery,
    Types.GetNestedProjectQueryVariables
  >(GetNestedProjectDocument, options)
}
export function useGetNestedProjectLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetNestedProjectQuery,
    Types.GetNestedProjectQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetNestedProjectQuery,
    Types.GetNestedProjectQueryVariables
  >(GetNestedProjectDocument, options)
}

export type GetNestedProjectQueryHookResult = ReturnType<
  typeof useGetNestedProjectQuery
>
export type GetNestedProjectLazyQueryHookResult = ReturnType<
  typeof useGetNestedProjectLazyQuery
>
export type GetNestedProjectQueryResult = Apollo.QueryResult<
  Types.GetNestedProjectQuery,
  Types.GetNestedProjectQueryVariables
>
export const GetNestedProjectsDocument = /*#__PURE__*/ gql`
  query getNestedProjects($projectIdentifier: UUID!, $after: String) {
    project(identifier: $projectIdentifier) {
      identifier
      projects(after: $after, limit: 40) {
        entries {
          ...NestedProject
        }
        meta {
          after
          limit
          totalCount
        }
      }
    }
  }
  ${NestedProjectFragmentDoc}
`

/**
 * __useGetNestedProjectsQuery__
 *
 * To run a query within a React component, call `useGetNestedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNestedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNestedProjectsQuery({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetNestedProjectsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetNestedProjectsQuery,
    Types.GetNestedProjectsQueryVariables
  > &
    (
      | { variables: Types.GetNestedProjectsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetNestedProjectsQuery,
    Types.GetNestedProjectsQueryVariables
  >(GetNestedProjectsDocument, options)
}
export function useGetNestedProjectsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetNestedProjectsQuery,
    Types.GetNestedProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetNestedProjectsQuery,
    Types.GetNestedProjectsQueryVariables
  >(GetNestedProjectsDocument, options)
}

export type GetNestedProjectsQueryHookResult = ReturnType<
  typeof useGetNestedProjectsQuery
>
export type GetNestedProjectsLazyQueryHookResult = ReturnType<
  typeof useGetNestedProjectsLazyQuery
>
export type GetNestedProjectsQueryResult = Apollo.QueryResult<
  Types.GetNestedProjectsQuery,
  Types.GetNestedProjectsQueryVariables
>
export const GetWorkspacesDraftsProjectsDocument = /*#__PURE__*/ gql`
  query getWorkspacesDraftsProjects {
    me {
      identifier
      workspaces {
        ...DraftsWorkspace
      }
    }
  }
  ${DraftsWorkspaceFragmentDoc}
`

/**
 * __useGetWorkspacesDraftsProjectsQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesDraftsProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesDraftsProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesDraftsProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkspacesDraftsProjectsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspacesDraftsProjectsQuery,
    Types.GetWorkspacesDraftsProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspacesDraftsProjectsQuery,
    Types.GetWorkspacesDraftsProjectsQueryVariables
  >(GetWorkspacesDraftsProjectsDocument, options)
}
export function useGetWorkspacesDraftsProjectsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspacesDraftsProjectsQuery,
    Types.GetWorkspacesDraftsProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspacesDraftsProjectsQuery,
    Types.GetWorkspacesDraftsProjectsQueryVariables
  >(GetWorkspacesDraftsProjectsDocument, options)
}

export type GetWorkspacesDraftsProjectsQueryHookResult = ReturnType<
  typeof useGetWorkspacesDraftsProjectsQuery
>
export type GetWorkspacesDraftsProjectsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspacesDraftsProjectsLazyQuery
>
export type GetWorkspacesDraftsProjectsQueryResult = Apollo.QueryResult<
  Types.GetWorkspacesDraftsProjectsQuery,
  Types.GetWorkspacesDraftsProjectsQueryVariables
>
export const GetProjectDetailsDocument = /*#__PURE__*/ gql`
  query getProjectDetails($projectIdentifier: UUID!) {
    project(identifier: $projectIdentifier) {
      ...ProjectDetails
    }
  }
  ${ProjectDetailsFragmentDoc}
`

/**
 * __useGetProjectDetailsQuery__
 *
 * To run a query within a React component, call `useGetProjectDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDetailsQuery({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useGetProjectDetailsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectDetailsQuery,
    Types.GetProjectDetailsQueryVariables
  > &
    (
      | { variables: Types.GetProjectDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectDetailsQuery,
    Types.GetProjectDetailsQueryVariables
  >(GetProjectDetailsDocument, options)
}
export function useGetProjectDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectDetailsQuery,
    Types.GetProjectDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectDetailsQuery,
    Types.GetProjectDetailsQueryVariables
  >(GetProjectDetailsDocument, options)
}

export type GetProjectDetailsQueryHookResult = ReturnType<
  typeof useGetProjectDetailsQuery
>
export type GetProjectDetailsLazyQueryHookResult = ReturnType<
  typeof useGetProjectDetailsLazyQuery
>
export type GetProjectDetailsQueryResult = Apollo.QueryResult<
  Types.GetProjectDetailsQuery,
  Types.GetProjectDetailsQueryVariables
>
export const GetProjectsListDocument = /*#__PURE__*/ gql`
  query getProjectsList(
    $workspaceId: UUID!
    $after: String
    $archived: ProjectArchivedStatus = UNARCHIVED
    $searchTerm: String
    $topLevel: Boolean!
  ) {
    workspace(identifier: $workspaceId) {
      identifier
      projects(
        after: $after
        limit: 20
        type: STANDARD
        archived: $archived
        search: { name: $searchTerm }
        topLevel: $topLevel
      ) {
        entries {
          ...ProjectListItem
        }
        meta {
          after
          limit
          totalCount
        }
      }
    }
  }
  ${ProjectListItemFragmentDoc}
`

/**
 * __useGetProjectsListQuery__
 *
 * To run a query within a React component, call `useGetProjectsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsListQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      after: // value for 'after'
 *      archived: // value for 'archived'
 *      searchTerm: // value for 'searchTerm'
 *      topLevel: // value for 'topLevel'
 *   },
 * });
 */
export function useGetProjectsListQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectsListQuery,
    Types.GetProjectsListQueryVariables
  > &
    (
      | { variables: Types.GetProjectsListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectsListQuery,
    Types.GetProjectsListQueryVariables
  >(GetProjectsListDocument, options)
}
export function useGetProjectsListLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectsListQuery,
    Types.GetProjectsListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectsListQuery,
    Types.GetProjectsListQueryVariables
  >(GetProjectsListDocument, options)
}

export type GetProjectsListQueryHookResult = ReturnType<
  typeof useGetProjectsListQuery
>
export type GetProjectsListLazyQueryHookResult = ReturnType<
  typeof useGetProjectsListLazyQuery
>
export type GetProjectsListQueryResult = Apollo.QueryResult<
  Types.GetProjectsListQuery,
  Types.GetProjectsListQueryVariables
>
export const GetShowDocumentsInProjectsDocument = /*#__PURE__*/ gql`
  query getShowDocumentsInProjects {
    showDocumentsInProjects @client
  }
`

/**
 * __useGetShowDocumentsInProjectsQuery__
 *
 * To run a query within a React component, call `useGetShowDocumentsInProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShowDocumentsInProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShowDocumentsInProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShowDocumentsInProjectsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetShowDocumentsInProjectsQuery,
    Types.GetShowDocumentsInProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShowDocumentsInProjectsQuery,
    Types.GetShowDocumentsInProjectsQueryVariables
  >(GetShowDocumentsInProjectsDocument, options)
}
export function useGetShowDocumentsInProjectsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShowDocumentsInProjectsQuery,
    Types.GetShowDocumentsInProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShowDocumentsInProjectsQuery,
    Types.GetShowDocumentsInProjectsQueryVariables
  >(GetShowDocumentsInProjectsDocument, options)
}

export type GetShowDocumentsInProjectsQueryHookResult = ReturnType<
  typeof useGetShowDocumentsInProjectsQuery
>
export type GetShowDocumentsInProjectsLazyQueryHookResult = ReturnType<
  typeof useGetShowDocumentsInProjectsLazyQuery
>
export type GetShowDocumentsInProjectsQueryResult = Apollo.QueryResult<
  Types.GetShowDocumentsInProjectsQuery,
  Types.GetShowDocumentsInProjectsQueryVariables
>
export const GetProjectDocument = /*#__PURE__*/ gql`
  query getProject($shortId: ShortId!) {
    project(shortId: $shortId) {
      ...Project
    }
  }
  ${ProjectFragmentDoc}
`

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      shortId: // value for 'shortId'
 *   },
 * });
 */
export function useGetProjectQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectQuery,
    Types.GetProjectQueryVariables
  > &
    (
      | { variables: Types.GetProjectQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectQuery,
    Types.GetProjectQueryVariables
  >(GetProjectDocument, options)
}
export function useGetProjectLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectQuery,
    Types.GetProjectQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectQuery,
    Types.GetProjectQueryVariables
  >(GetProjectDocument, options)
}

export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>
export type GetProjectLazyQueryHookResult = ReturnType<
  typeof useGetProjectLazyQuery
>
export type GetProjectQueryResult = Apollo.QueryResult<
  Types.GetProjectQuery,
  Types.GetProjectQueryVariables
>
export const GetWorkspaceTransferDestinationsDocument = /*#__PURE__*/ gql`
  query getWorkspaceTransferDestinations(
    $workspaceIdentifier: UUID!
    $after: String
    $search: TransferDestinationSearchParams
  ) {
    workspaceTransferDestinations(
      workspaceIdentifier: $workspaceIdentifier
      after: $after
      search: $search
    ) {
      entries {
        ... on Project {
          ...ProjectSearchDestination
        }
        ... on Workspace {
          identifier
          name
        }
      }
      meta {
        after
        limit
        totalCount
      }
    }
  }
  ${ProjectSearchDestinationFragmentDoc}
`

/**
 * __useGetWorkspaceTransferDestinationsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceTransferDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceTransferDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceTransferDestinationsQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetWorkspaceTransferDestinationsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceTransferDestinationsQuery,
    Types.GetWorkspaceTransferDestinationsQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceTransferDestinationsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceTransferDestinationsQuery,
    Types.GetWorkspaceTransferDestinationsQueryVariables
  >(GetWorkspaceTransferDestinationsDocument, options)
}
export function useGetWorkspaceTransferDestinationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceTransferDestinationsQuery,
    Types.GetWorkspaceTransferDestinationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceTransferDestinationsQuery,
    Types.GetWorkspaceTransferDestinationsQueryVariables
  >(GetWorkspaceTransferDestinationsDocument, options)
}

export type GetWorkspaceTransferDestinationsQueryHookResult = ReturnType<
  typeof useGetWorkspaceTransferDestinationsQuery
>
export type GetWorkspaceTransferDestinationsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceTransferDestinationsLazyQuery
>
export type GetWorkspaceTransferDestinationsQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceTransferDestinationsQuery,
  Types.GetWorkspaceTransferDestinationsQueryVariables
>
export const ProjectChangedDocument = /*#__PURE__*/ gql`
  subscription projectChanged {
    projectChanged {
      __typename
      workspaceIdentifier
      ... on ProjectCreatedEvent {
        project {
          ...Project
        }
      }
      ... on ProjectRestoredEvent {
        project {
          ...Project
        }
      }
      ... on ProjectChangedEvent {
        project {
          ...Project
        }
      }
      ... on ProjectDeletedEvent {
        project {
          ...Project
        }
      }
      ... on ProjectTransferredEvent {
        oldParentProjectIdentifier
        oldWorkspaceIdentifier
        workspaceIdentifier
        project {
          ...Project
        }
      }
      ... on ProjectPermanentlyDeletedEvent {
        projectIdentifier
      }
      ... on ProjectWorkspaceAccessLevelChangedEvent {
        workspaceIdentifier
        project {
          identifier
          workspaceAccessLevel
          userMembership {
            identifier
          }
          projectPrivacyIcon
        }
      }
      ... on ProjectArchivedEvent {
        project {
          ...Project
        }
      }
      ... on ProjectUnarchivedEvent {
        project {
          ...Project
        }
      }
    }
  }
  ${ProjectFragmentDoc}
`

/**
 * __useProjectChangedSubscription__
 *
 * To run a query within a React component, call `useProjectChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useProjectChangedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.ProjectChangedSubscription,
    Types.ProjectChangedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.ProjectChangedSubscription,
    Types.ProjectChangedSubscriptionVariables
  >(ProjectChangedDocument, options)
}
export type ProjectChangedSubscriptionHookResult = ReturnType<
  typeof useProjectChangedSubscription
>
export type ProjectChangedSubscriptionResult =
  Apollo.SubscriptionResult<Types.ProjectChangedSubscription>
export const AddProjectMemberDocument = /*#__PURE__*/ gql`
  mutation addProjectMember(
    $projectIdentifier: UUID!
    $workspaceMembershipIdentifier: UUID
    $email: String
    $guestCommentsEnabled: Boolean = true
    $guestInspectEnabled: Boolean = true
  ) {
    addProjectMember(
      projectIdentifier: $projectIdentifier
      workspaceMembershipIdentifier: $workspaceMembershipIdentifier
      email: $email
      guestCommentsEnabled: $guestCommentsEnabled
      guestInspectEnabled: $guestInspectEnabled
    ) {
      project {
        identifier
        projectPrivacyIcon
      }
      projectMembership {
        ...ProjectMembership
      }
    }
  }
  ${ProjectMembershipFragmentDoc}
`
export type AddProjectMemberMutationFn = Apollo.MutationFunction<
  Types.AddProjectMemberMutation,
  Types.AddProjectMemberMutationVariables
>

/**
 * __useAddProjectMemberMutation__
 *
 * To run a mutation, you first call `useAddProjectMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectMemberMutation, { data, loading, error }] = useAddProjectMemberMutation({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *      workspaceMembershipIdentifier: // value for 'workspaceMembershipIdentifier'
 *      email: // value for 'email'
 *      guestCommentsEnabled: // value for 'guestCommentsEnabled'
 *      guestInspectEnabled: // value for 'guestInspectEnabled'
 *   },
 * });
 */
export function useAddProjectMemberMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AddProjectMemberMutation,
    Types.AddProjectMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AddProjectMemberMutation,
    Types.AddProjectMemberMutationVariables
  >(AddProjectMemberDocument, options)
}
export type AddProjectMemberMutationHookResult = ReturnType<
  typeof useAddProjectMemberMutation
>
export type AddProjectMemberMutationResult =
  Apollo.MutationResult<Types.AddProjectMemberMutation>
export type AddProjectMemberMutationOptions = Apollo.BaseMutationOptions<
  Types.AddProjectMemberMutation,
  Types.AddProjectMemberMutationVariables
>
export const AcceptProjectAccessRequestDocument = /*#__PURE__*/ gql`
  mutation acceptProjectAccessRequest($membershipIdentifier: UUID!) {
    acceptProjectAccessRequest(membershipIdentifier: $membershipIdentifier) {
      project {
        identifier
      }
      projectMembership {
        ...ProjectMembership
        workspaceMembership {
          identifier
          workspace {
            identifier
          }
        }
      }
    }
  }
  ${ProjectMembershipFragmentDoc}
`
export type AcceptProjectAccessRequestMutationFn = Apollo.MutationFunction<
  Types.AcceptProjectAccessRequestMutation,
  Types.AcceptProjectAccessRequestMutationVariables
>

/**
 * __useAcceptProjectAccessRequestMutation__
 *
 * To run a mutation, you first call `useAcceptProjectAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptProjectAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptProjectAccessRequestMutation, { data, loading, error }] = useAcceptProjectAccessRequestMutation({
 *   variables: {
 *      membershipIdentifier: // value for 'membershipIdentifier'
 *   },
 * });
 */
export function useAcceptProjectAccessRequestMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AcceptProjectAccessRequestMutation,
    Types.AcceptProjectAccessRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AcceptProjectAccessRequestMutation,
    Types.AcceptProjectAccessRequestMutationVariables
  >(AcceptProjectAccessRequestDocument, options)
}
export type AcceptProjectAccessRequestMutationHookResult = ReturnType<
  typeof useAcceptProjectAccessRequestMutation
>
export type AcceptProjectAccessRequestMutationResult =
  Apollo.MutationResult<Types.AcceptProjectAccessRequestMutation>
export type AcceptProjectAccessRequestMutationOptions =
  Apollo.BaseMutationOptions<
    Types.AcceptProjectAccessRequestMutation,
    Types.AcceptProjectAccessRequestMutationVariables
  >
export const UpdateProjectMembershipDocument = /*#__PURE__*/ gql`
  mutation updateProjectMembership(
    $membershipIdentifier: UUID!
    $guestCommentsEnabled: Boolean
    $guestInspectEnabled: Boolean
  ) {
    updateProjectMembership(
      identifier: $membershipIdentifier
      guestCommentsEnabled: $guestCommentsEnabled
      guestInspectEnabled: $guestInspectEnabled
    ) {
      projectMembership {
        ...ProjectMembership
      }
    }
  }
  ${ProjectMembershipFragmentDoc}
`
export type UpdateProjectMembershipMutationFn = Apollo.MutationFunction<
  Types.UpdateProjectMembershipMutation,
  Types.UpdateProjectMembershipMutationVariables
>

/**
 * __useUpdateProjectMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMembershipMutation, { data, loading, error }] = useUpdateProjectMembershipMutation({
 *   variables: {
 *      membershipIdentifier: // value for 'membershipIdentifier'
 *      guestCommentsEnabled: // value for 'guestCommentsEnabled'
 *      guestInspectEnabled: // value for 'guestInspectEnabled'
 *   },
 * });
 */
export function useUpdateProjectMembershipMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateProjectMembershipMutation,
    Types.UpdateProjectMembershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateProjectMembershipMutation,
    Types.UpdateProjectMembershipMutationVariables
  >(UpdateProjectMembershipDocument, options)
}
export type UpdateProjectMembershipMutationHookResult = ReturnType<
  typeof useUpdateProjectMembershipMutation
>
export type UpdateProjectMembershipMutationResult =
  Apollo.MutationResult<Types.UpdateProjectMembershipMutation>
export type UpdateProjectMembershipMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateProjectMembershipMutation,
  Types.UpdateProjectMembershipMutationVariables
>
export const AcceptProjectMembershipInvitationDocument = /*#__PURE__*/ gql`
  mutation acceptProjectMembershipInvitation(
    $input: AcceptProjectMembershipInvitationParams!
  ) {
    acceptProjectMembershipInvitation(input: $input) {
      projectMembership {
        identifier
        inviteStatus
        project {
          identifier
        }
      }
    }
  }
`
export type AcceptProjectMembershipInvitationMutationFn =
  Apollo.MutationFunction<
    Types.AcceptProjectMembershipInvitationMutation,
    Types.AcceptProjectMembershipInvitationMutationVariables
  >

/**
 * __useAcceptProjectMembershipInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptProjectMembershipInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptProjectMembershipInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptProjectMembershipInvitationMutation, { data, loading, error }] = useAcceptProjectMembershipInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptProjectMembershipInvitationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AcceptProjectMembershipInvitationMutation,
    Types.AcceptProjectMembershipInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AcceptProjectMembershipInvitationMutation,
    Types.AcceptProjectMembershipInvitationMutationVariables
  >(AcceptProjectMembershipInvitationDocument, options)
}
export type AcceptProjectMembershipInvitationMutationHookResult = ReturnType<
  typeof useAcceptProjectMembershipInvitationMutation
>
export type AcceptProjectMembershipInvitationMutationResult =
  Apollo.MutationResult<Types.AcceptProjectMembershipInvitationMutation>
export type AcceptProjectMembershipInvitationMutationOptions =
  Apollo.BaseMutationOptions<
    Types.AcceptProjectMembershipInvitationMutation,
    Types.AcceptProjectMembershipInvitationMutationVariables
  >
export const GetProjectMembershipsDocument = /*#__PURE__*/ gql`
  query getProjectMemberships($projectIdentifier: UUID!, $after: String) {
    project(identifier: $projectIdentifier) {
      identifier
      members(after: $after) {
        entries {
          ... on ProjectMembership {
            ...ProjectMembership
          }
          ... on PermissionGroupRelationProject {
            ...ProjectGroupMembership
          }
        }
        meta {
          after
          limit
          totalCount
        }
      }
    }
  }
  ${ProjectMembershipFragmentDoc}
  ${ProjectGroupMembershipFragmentDoc}
`

/**
 * __useGetProjectMembershipsQuery__
 *
 * To run a query within a React component, call `useGetProjectMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectMembershipsQuery({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetProjectMembershipsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectMembershipsQuery,
    Types.GetProjectMembershipsQueryVariables
  > &
    (
      | { variables: Types.GetProjectMembershipsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectMembershipsQuery,
    Types.GetProjectMembershipsQueryVariables
  >(GetProjectMembershipsDocument, options)
}
export function useGetProjectMembershipsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectMembershipsQuery,
    Types.GetProjectMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectMembershipsQuery,
    Types.GetProjectMembershipsQueryVariables
  >(GetProjectMembershipsDocument, options)
}

export type GetProjectMembershipsQueryHookResult = ReturnType<
  typeof useGetProjectMembershipsQuery
>
export type GetProjectMembershipsLazyQueryHookResult = ReturnType<
  typeof useGetProjectMembershipsLazyQuery
>
export type GetProjectMembershipsQueryResult = Apollo.QueryResult<
  Types.GetProjectMembershipsQuery,
  Types.GetProjectMembershipsQueryVariables
>
export const GetProjectMembershipsCountDocument = /*#__PURE__*/ gql`
  query getProjectMembershipsCount($projectIdentifier: UUID!) {
    project(identifier: $projectIdentifier) {
      identifier
      membershipCount {
        admin
        member
        guest
        group
      }
    }
  }
`

/**
 * __useGetProjectMembershipsCountQuery__
 *
 * To run a query within a React component, call `useGetProjectMembershipsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectMembershipsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectMembershipsCountQuery({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useGetProjectMembershipsCountQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectMembershipsCountQuery,
    Types.GetProjectMembershipsCountQueryVariables
  > &
    (
      | {
          variables: Types.GetProjectMembershipsCountQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectMembershipsCountQuery,
    Types.GetProjectMembershipsCountQueryVariables
  >(GetProjectMembershipsCountDocument, options)
}
export function useGetProjectMembershipsCountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectMembershipsCountQuery,
    Types.GetProjectMembershipsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectMembershipsCountQuery,
    Types.GetProjectMembershipsCountQueryVariables
  >(GetProjectMembershipsCountDocument, options)
}

export type GetProjectMembershipsCountQueryHookResult = ReturnType<
  typeof useGetProjectMembershipsCountQuery
>
export type GetProjectMembershipsCountLazyQueryHookResult = ReturnType<
  typeof useGetProjectMembershipsCountLazyQuery
>
export type GetProjectMembershipsCountQueryResult = Apollo.QueryResult<
  Types.GetProjectMembershipsCountQuery,
  Types.GetProjectMembershipsCountQueryVariables
>
export const GetProjectMembershipByTokenDocument = /*#__PURE__*/ gql`
  query getProjectMembershipByToken($token: String!) {
    projectMembership(token: $token) {
      identifier
      email
      inviteStatus
      project {
        identifier
        name
        workspace {
          identifier
        }
      }
      inviter {
        name
        avatar {
          large
        }
      }
    }
  }
`

/**
 * __useGetProjectMembershipByTokenQuery__
 *
 * To run a query within a React component, call `useGetProjectMembershipByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectMembershipByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectMembershipByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetProjectMembershipByTokenQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectMembershipByTokenQuery,
    Types.GetProjectMembershipByTokenQueryVariables
  > &
    (
      | {
          variables: Types.GetProjectMembershipByTokenQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectMembershipByTokenQuery,
    Types.GetProjectMembershipByTokenQueryVariables
  >(GetProjectMembershipByTokenDocument, options)
}
export function useGetProjectMembershipByTokenLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectMembershipByTokenQuery,
    Types.GetProjectMembershipByTokenQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectMembershipByTokenQuery,
    Types.GetProjectMembershipByTokenQueryVariables
  >(GetProjectMembershipByTokenDocument, options)
}

export type GetProjectMembershipByTokenQueryHookResult = ReturnType<
  typeof useGetProjectMembershipByTokenQuery
>
export type GetProjectMembershipByTokenLazyQueryHookResult = ReturnType<
  typeof useGetProjectMembershipByTokenLazyQuery
>
export type GetProjectMembershipByTokenQueryResult = Apollo.QueryResult<
  Types.GetProjectMembershipByTokenQuery,
  Types.GetProjectMembershipByTokenQueryVariables
>
export const ProjectAccessChangedDocument = /*#__PURE__*/ gql`
  subscription projectAccessChanged {
    projectAccessChanged {
      workspaceIdentifier
      ... on ProjectAccessRevokedEvent {
        project {
          __typename
          identifier
          name
        }
      }
    }
  }
`

/**
 * __useProjectAccessChangedSubscription__
 *
 * To run a query within a React component, call `useProjectAccessChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectAccessChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectAccessChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useProjectAccessChangedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.ProjectAccessChangedSubscription,
    Types.ProjectAccessChangedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.ProjectAccessChangedSubscription,
    Types.ProjectAccessChangedSubscriptionVariables
  >(ProjectAccessChangedDocument, options)
}
export type ProjectAccessChangedSubscriptionHookResult = ReturnType<
  typeof useProjectAccessChangedSubscription
>
export type ProjectAccessChangedSubscriptionResult =
  Apollo.SubscriptionResult<Types.ProjectAccessChangedSubscription>
export const ProjectMembershipChangedDocument = /*#__PURE__*/ gql`
  subscription projectMembershipChanged {
    projectChanged {
      __typename
      workspaceIdentifier
      ... on ProjectMemberAddedEvent {
        membership {
          ...ProjectMembership
        }
        project {
          identifier
          projectPrivacyIcon
        }
      }
      ... on ProjectMemberChangedEvent {
        membership {
          ...ProjectMembership
        }
        project {
          identifier
        }
      }
      ... on ProjectMemberRemovedEvent {
        membershipIdentifier
        project {
          identifier
          projectPrivacyIcon
        }
      }
    }
  }
  ${ProjectMembershipFragmentDoc}
`

/**
 * __useProjectMembershipChangedSubscription__
 *
 * To run a query within a React component, call `useProjectMembershipChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectMembershipChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectMembershipChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useProjectMembershipChangedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.ProjectMembershipChangedSubscription,
    Types.ProjectMembershipChangedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.ProjectMembershipChangedSubscription,
    Types.ProjectMembershipChangedSubscriptionVariables
  >(ProjectMembershipChangedDocument, options)
}
export type ProjectMembershipChangedSubscriptionHookResult = ReturnType<
  typeof useProjectMembershipChangedSubscription
>
export type ProjectMembershipChangedSubscriptionResult =
  Apollo.SubscriptionResult<Types.ProjectMembershipChangedSubscription>
export const AddReactionToPublicationDocument = /*#__PURE__*/ gql`
  mutation addReactionToPublication(
    $publicationIdentifier: UUID!
    $reaction: PublicationReactionType!
  ) {
    addReactionToPublication(
      publicationIdentifier: $publicationIdentifier
      reaction: $reaction
    ) {
      publication {
        ...PublicationReactions
      }
    }
  }
  ${PublicationReactionsFragmentDoc}
`
export type AddReactionToPublicationMutationFn = Apollo.MutationFunction<
  Types.AddReactionToPublicationMutation,
  Types.AddReactionToPublicationMutationVariables
>

/**
 * __useAddReactionToPublicationMutation__
 *
 * To run a mutation, you first call `useAddReactionToPublicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReactionToPublicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReactionToPublicationMutation, { data, loading, error }] = useAddReactionToPublicationMutation({
 *   variables: {
 *      publicationIdentifier: // value for 'publicationIdentifier'
 *      reaction: // value for 'reaction'
 *   },
 * });
 */
export function useAddReactionToPublicationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AddReactionToPublicationMutation,
    Types.AddReactionToPublicationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AddReactionToPublicationMutation,
    Types.AddReactionToPublicationMutationVariables
  >(AddReactionToPublicationDocument, options)
}
export type AddReactionToPublicationMutationHookResult = ReturnType<
  typeof useAddReactionToPublicationMutation
>
export type AddReactionToPublicationMutationResult =
  Apollo.MutationResult<Types.AddReactionToPublicationMutation>
export type AddReactionToPublicationMutationOptions =
  Apollo.BaseMutationOptions<
    Types.AddReactionToPublicationMutation,
    Types.AddReactionToPublicationMutationVariables
  >
export const GetPublicationDocument = /*#__PURE__*/ gql`
  query getPublication($identifier: UUID!) {
    publication(identifier: $identifier) {
      ...Publication
    }
  }
  ${PublicationFragmentDoc}
`

/**
 * __useGetPublicationQuery__
 *
 * To run a query within a React component, call `useGetPublicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicationQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetPublicationQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPublicationQuery,
    Types.GetPublicationQueryVariables
  > &
    (
      | { variables: Types.GetPublicationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPublicationQuery,
    Types.GetPublicationQueryVariables
  >(GetPublicationDocument, options)
}
export function useGetPublicationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPublicationQuery,
    Types.GetPublicationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPublicationQuery,
    Types.GetPublicationQueryVariables
  >(GetPublicationDocument, options)
}

export type GetPublicationQueryHookResult = ReturnType<
  typeof useGetPublicationQuery
>
export type GetPublicationLazyQueryHookResult = ReturnType<
  typeof useGetPublicationLazyQuery
>
export type GetPublicationQueryResult = Apollo.QueryResult<
  Types.GetPublicationQuery,
  Types.GetPublicationQueryVariables
>
export const GetSharePagesDocument = /*#__PURE__*/ gql`
  query getSharePages($identifier: UUID!, $after: String, $limit: Int) {
    share(id: $identifier) {
      identifier
      version(preferredState: PROCESSED_AND_PUBLISHED) {
        identifier
        shortId
        document {
          identifier
          pages(after: $after, limit: $limit) {
            entries {
              ...PublicationPage
            }
            meta {
              after
              totalCount
            }
          }
        }
      }
    }
  }
  ${PublicationPageFragmentDoc}
`

/**
 * __useGetSharePagesQuery__
 *
 * To run a query within a React component, call `useGetSharePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharePagesQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSharePagesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSharePagesQuery,
    Types.GetSharePagesQueryVariables
  > &
    (
      | { variables: Types.GetSharePagesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSharePagesQuery,
    Types.GetSharePagesQueryVariables
  >(GetSharePagesDocument, options)
}
export function useGetSharePagesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSharePagesQuery,
    Types.GetSharePagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSharePagesQuery,
    Types.GetSharePagesQueryVariables
  >(GetSharePagesDocument, options)
}

export type GetSharePagesQueryHookResult = ReturnType<
  typeof useGetSharePagesQuery
>
export type GetSharePagesLazyQueryHookResult = ReturnType<
  typeof useGetSharePagesLazyQuery
>
export type GetSharePagesQueryResult = Apollo.QueryResult<
  Types.GetSharePagesQuery,
  Types.GetSharePagesQueryVariables
>
export const GetPublicationsDocument = /*#__PURE__*/ gql`
  query getPublications(
    $after: String
    $exclude: [UUID!]
    $include: [UUID!]
    $limit: Int
    $sort: PublicationSortOrder
    $search: PublicationsSearchParams
  ) {
    publications(
      after: $after
      limit: $limit
      sortOrder: $sort
      include: $include
      exclude: $exclude
      search: $search
    ) {
      entries {
        ...PublicationItem
      }
      meta {
        after
        totalCount
      }
    }
  }
  ${PublicationItemFragmentDoc}
`

/**
 * __useGetPublicationsQuery__
 *
 * To run a query within a React component, call `useGetPublicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      exclude: // value for 'exclude'
 *      include: // value for 'include'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPublicationsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetPublicationsQuery,
    Types.GetPublicationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPublicationsQuery,
    Types.GetPublicationsQueryVariables
  >(GetPublicationsDocument, options)
}
export function useGetPublicationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPublicationsQuery,
    Types.GetPublicationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPublicationsQuery,
    Types.GetPublicationsQueryVariables
  >(GetPublicationsDocument, options)
}

export type GetPublicationsQueryHookResult = ReturnType<
  typeof useGetPublicationsQuery
>
export type GetPublicationsLazyQueryHookResult = ReturnType<
  typeof useGetPublicationsLazyQuery
>
export type GetPublicationsQueryResult = Apollo.QueryResult<
  Types.GetPublicationsQuery,
  Types.GetPublicationsQueryVariables
>
export const PublicationReactionsUpdatedDocument = /*#__PURE__*/ gql`
  subscription publicationReactionsUpdated($publicationIdentifier: UUID!) {
    publicationReactionsUpdated(publicationIdentifier: $publicationIdentifier) {
      publication {
        ...PublicationReactions
      }
    }
  }
  ${PublicationReactionsFragmentDoc}
`

/**
 * __usePublicationReactionsUpdatedSubscription__
 *
 * To run a query within a React component, call `usePublicationReactionsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePublicationReactionsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicationReactionsUpdatedSubscription({
 *   variables: {
 *      publicationIdentifier: // value for 'publicationIdentifier'
 *   },
 * });
 */
export function usePublicationReactionsUpdatedSubscription(
  baseOptions: ApolloReactHooks.SubscriptionHookOptions<
    Types.PublicationReactionsUpdatedSubscription,
    Types.PublicationReactionsUpdatedSubscriptionVariables
  > &
    (
      | {
          variables: Types.PublicationReactionsUpdatedSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.PublicationReactionsUpdatedSubscription,
    Types.PublicationReactionsUpdatedSubscriptionVariables
  >(PublicationReactionsUpdatedDocument, options)
}
export type PublicationReactionsUpdatedSubscriptionHookResult = ReturnType<
  typeof usePublicationReactionsUpdatedSubscription
>
export type PublicationReactionsUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<Types.PublicationReactionsUpdatedSubscription>
export const GetPublicationListingDocument = /*#__PURE__*/ gql`
  query getPublicationListing($identifier: String!) {
    publicationListing(identifier: $identifier) @client {
      ...PublicationListing
    }
  }
  ${PublicationListingFragmentDoc}
`

/**
 * __useGetPublicationListingQuery__
 *
 * To run a query within a React component, call `useGetPublicationListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicationListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicationListingQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetPublicationListingQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPublicationListingQuery,
    Types.GetPublicationListingQueryVariables
  > &
    (
      | { variables: Types.GetPublicationListingQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPublicationListingQuery,
    Types.GetPublicationListingQueryVariables
  >(GetPublicationListingDocument, options)
}
export function useGetPublicationListingLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPublicationListingQuery,
    Types.GetPublicationListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPublicationListingQuery,
    Types.GetPublicationListingQueryVariables
  >(GetPublicationListingDocument, options)
}

export type GetPublicationListingQueryHookResult = ReturnType<
  typeof useGetPublicationListingQuery
>
export type GetPublicationListingLazyQueryHookResult = ReturnType<
  typeof useGetPublicationListingLazyQuery
>
export type GetPublicationListingQueryResult = Apollo.QueryResult<
  Types.GetPublicationListingQuery,
  Types.GetPublicationListingQueryVariables
>
export const GetScimPersonalAccessTokensDocument = /*#__PURE__*/ gql`
  query getScimPersonalAccessTokens {
    me {
      identifier
      scimPersonalAccessTokens {
        ...ScimPersonalAccessToken
      }
    }
  }
  ${ScimPersonalAccessTokenFragmentDoc}
`

/**
 * __useGetScimPersonalAccessTokensQuery__
 *
 * To run a query within a React component, call `useGetScimPersonalAccessTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScimPersonalAccessTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScimPersonalAccessTokensQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetScimPersonalAccessTokensQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetScimPersonalAccessTokensQuery,
    Types.GetScimPersonalAccessTokensQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetScimPersonalAccessTokensQuery,
    Types.GetScimPersonalAccessTokensQueryVariables
  >(GetScimPersonalAccessTokensDocument, options)
}
export function useGetScimPersonalAccessTokensLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetScimPersonalAccessTokensQuery,
    Types.GetScimPersonalAccessTokensQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetScimPersonalAccessTokensQuery,
    Types.GetScimPersonalAccessTokensQueryVariables
  >(GetScimPersonalAccessTokensDocument, options)
}

export type GetScimPersonalAccessTokensQueryHookResult = ReturnType<
  typeof useGetScimPersonalAccessTokensQuery
>
export type GetScimPersonalAccessTokensLazyQueryHookResult = ReturnType<
  typeof useGetScimPersonalAccessTokensLazyQuery
>
export type GetScimPersonalAccessTokensQueryResult = Apollo.QueryResult<
  Types.GetScimPersonalAccessTokensQuery,
  Types.GetScimPersonalAccessTokensQueryVariables
>
export const ScimPersonalAccessTokenCreateDocument = /*#__PURE__*/ gql`
  mutation scimPersonalAccessTokenCreate(
    $accessScopes: [ScimApiAccessScope!]!
    $description: String!
    $expiresAt: DateTime
  ) {
    scimPersonalAccessTokenCreate(
      accessScopes: $accessScopes
      description: $description
      expiresAt: $expiresAt
    ) {
      secret
      personalAccessToken {
        ...ScimPersonalAccessToken
      }
    }
  }
  ${ScimPersonalAccessTokenFragmentDoc}
`
export type ScimPersonalAccessTokenCreateMutationFn = Apollo.MutationFunction<
  Types.ScimPersonalAccessTokenCreateMutation,
  Types.ScimPersonalAccessTokenCreateMutationVariables
>

/**
 * __useScimPersonalAccessTokenCreateMutation__
 *
 * To run a mutation, you first call `useScimPersonalAccessTokenCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScimPersonalAccessTokenCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scimPersonalAccessTokenCreateMutation, { data, loading, error }] = useScimPersonalAccessTokenCreateMutation({
 *   variables: {
 *      accessScopes: // value for 'accessScopes'
 *      description: // value for 'description'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useScimPersonalAccessTokenCreateMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ScimPersonalAccessTokenCreateMutation,
    Types.ScimPersonalAccessTokenCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ScimPersonalAccessTokenCreateMutation,
    Types.ScimPersonalAccessTokenCreateMutationVariables
  >(ScimPersonalAccessTokenCreateDocument, options)
}
export type ScimPersonalAccessTokenCreateMutationHookResult = ReturnType<
  typeof useScimPersonalAccessTokenCreateMutation
>
export type ScimPersonalAccessTokenCreateMutationResult =
  Apollo.MutationResult<Types.ScimPersonalAccessTokenCreateMutation>
export type ScimPersonalAccessTokenCreateMutationOptions =
  Apollo.BaseMutationOptions<
    Types.ScimPersonalAccessTokenCreateMutation,
    Types.ScimPersonalAccessTokenCreateMutationVariables
  >
export const ScimPersonalAccessTokenDeleteDocument = /*#__PURE__*/ gql`
  mutation scimPersonalAccessTokenDelete($identifier: UUID!) {
    scimPersonalAccessTokenDelete(identifier: $identifier) {
      identifier
    }
  }
`
export type ScimPersonalAccessTokenDeleteMutationFn = Apollo.MutationFunction<
  Types.ScimPersonalAccessTokenDeleteMutation,
  Types.ScimPersonalAccessTokenDeleteMutationVariables
>

/**
 * __useScimPersonalAccessTokenDeleteMutation__
 *
 * To run a mutation, you first call `useScimPersonalAccessTokenDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScimPersonalAccessTokenDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scimPersonalAccessTokenDeleteMutation, { data, loading, error }] = useScimPersonalAccessTokenDeleteMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useScimPersonalAccessTokenDeleteMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ScimPersonalAccessTokenDeleteMutation,
    Types.ScimPersonalAccessTokenDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ScimPersonalAccessTokenDeleteMutation,
    Types.ScimPersonalAccessTokenDeleteMutationVariables
  >(ScimPersonalAccessTokenDeleteDocument, options)
}
export type ScimPersonalAccessTokenDeleteMutationHookResult = ReturnType<
  typeof useScimPersonalAccessTokenDeleteMutation
>
export type ScimPersonalAccessTokenDeleteMutationResult =
  Apollo.MutationResult<Types.ScimPersonalAccessTokenDeleteMutation>
export type ScimPersonalAccessTokenDeleteMutationOptions =
  Apollo.BaseMutationOptions<
    Types.ScimPersonalAccessTokenDeleteMutation,
    Types.ScimPersonalAccessTokenDeleteMutationVariables
  >
export const GetDetailViewArtboardDocument = /*#__PURE__*/ gql`
  query getDetailViewArtboard(
    $permanentArtboardShortId: ShortId!
    $documentVersionShortId: ShortId
    $shareIdentifier: UUID!
  ) {
    artboard(
      permanentArtboardShortId: $permanentArtboardShortId
      documentVersionShortId: $documentVersionShortId
      shareIdentifier: $shareIdentifier
    ) {
      ...ArtboardCacheInfo
    }
  }
  ${ArtboardCacheInfoFragmentDoc}
`

/**
 * __useGetDetailViewArtboardQuery__
 *
 * To run a query within a React component, call `useGetDetailViewArtboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailViewArtboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailViewArtboardQuery({
 *   variables: {
 *      permanentArtboardShortId: // value for 'permanentArtboardShortId'
 *      documentVersionShortId: // value for 'documentVersionShortId'
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetDetailViewArtboardQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetDetailViewArtboardQuery,
    Types.GetDetailViewArtboardQueryVariables
  > &
    (
      | { variables: Types.GetDetailViewArtboardQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetDetailViewArtboardQuery,
    Types.GetDetailViewArtboardQueryVariables
  >(GetDetailViewArtboardDocument, options)
}
export function useGetDetailViewArtboardLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetDetailViewArtboardQuery,
    Types.GetDetailViewArtboardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetDetailViewArtboardQuery,
    Types.GetDetailViewArtboardQueryVariables
  >(GetDetailViewArtboardDocument, options)
}

export type GetDetailViewArtboardQueryHookResult = ReturnType<
  typeof useGetDetailViewArtboardQuery
>
export type GetDetailViewArtboardLazyQueryHookResult = ReturnType<
  typeof useGetDetailViewArtboardLazyQuery
>
export type GetDetailViewArtboardQueryResult = Apollo.QueryResult<
  Types.GetDetailViewArtboardQuery,
  Types.GetDetailViewArtboardQueryVariables
>
export const GetArtboardByPermanentArtboardShortIdDocument = /*#__PURE__*/ gql`
  query getArtboardByPermanentArtboardShortId(
    $permanentArtboardShortId: ShortId!
    $shareIdentifier: UUID!
    $documentVersionShortId: ShortId
  ) {
    artboard(
      permanentArtboardShortId: $permanentArtboardShortId
      shareIdentifier: $shareIdentifier
      documentVersionShortId: $documentVersionShortId
    ) {
      documentVersionShortId
      permanentArtboardShortId
      uuid
      isFlowHome
    }
  }
`

/**
 * __useGetArtboardByPermanentArtboardShortIdQuery__
 *
 * To run a query within a React component, call `useGetArtboardByPermanentArtboardShortIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtboardByPermanentArtboardShortIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtboardByPermanentArtboardShortIdQuery({
 *   variables: {
 *      permanentArtboardShortId: // value for 'permanentArtboardShortId'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      documentVersionShortId: // value for 'documentVersionShortId'
 *   },
 * });
 */
export function useGetArtboardByPermanentArtboardShortIdQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetArtboardByPermanentArtboardShortIdQuery,
    Types.GetArtboardByPermanentArtboardShortIdQueryVariables
  > &
    (
      | {
          variables: Types.GetArtboardByPermanentArtboardShortIdQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetArtboardByPermanentArtboardShortIdQuery,
    Types.GetArtboardByPermanentArtboardShortIdQueryVariables
  >(GetArtboardByPermanentArtboardShortIdDocument, options)
}
export function useGetArtboardByPermanentArtboardShortIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetArtboardByPermanentArtboardShortIdQuery,
    Types.GetArtboardByPermanentArtboardShortIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetArtboardByPermanentArtboardShortIdQuery,
    Types.GetArtboardByPermanentArtboardShortIdQueryVariables
  >(GetArtboardByPermanentArtboardShortIdDocument, options)
}

export type GetArtboardByPermanentArtboardShortIdQueryHookResult = ReturnType<
  typeof useGetArtboardByPermanentArtboardShortIdQuery
>
export type GetArtboardByPermanentArtboardShortIdLazyQueryHookResult =
  ReturnType<typeof useGetArtboardByPermanentArtboardShortIdLazyQuery>
export type GetArtboardByPermanentArtboardShortIdQueryResult =
  Apollo.QueryResult<
    Types.GetArtboardByPermanentArtboardShortIdQuery,
    Types.GetArtboardByPermanentArtboardShortIdQueryVariables
  >
export const GetComponentsDocument = /*#__PURE__*/ gql`
  query getComponents(
    $shareIdentifier: UUID
    $versionShortId: ShortId
    $after: String = null
    $type: ComponentFilterType = SYMBOL
    $search: String = null
    $path: String = null
    $limit: Int = 40
  ) {
    share(id: $shareIdentifier) {
      identifier
      version(shortId: $versionShortId) {
        identifier
        shortId
        hasComponentManifest
        document {
          identifier
          documentVersion
          coeditCompatibilityVersion
          canEditDescriptions
          components(
            type: $type
            after: $after
            search: $search
            path: $path
            limit: $limit
          ) {
            entries {
              ...ComponentInfo
            }
            meta {
              after
              limit
              totalCount
            }
          }
        }
      }
      latestVersionOfAnyState: version {
        shortId
        identifier
        document {
          identifier
          renderStatus
        }
      }
    }
  }
  ${ComponentInfoFragmentDoc}
`

/**
 * __useGetComponentsQuery__
 *
 * To run a query within a React component, call `useGetComponentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComponentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComponentsQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *      after: // value for 'after'
 *      type: // value for 'type'
 *      search: // value for 'search'
 *      path: // value for 'path'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetComponentsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetComponentsQuery,
    Types.GetComponentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetComponentsQuery,
    Types.GetComponentsQueryVariables
  >(GetComponentsDocument, options)
}
export function useGetComponentsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetComponentsQuery,
    Types.GetComponentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetComponentsQuery,
    Types.GetComponentsQueryVariables
  >(GetComponentsDocument, options)
}

export type GetComponentsQueryHookResult = ReturnType<
  typeof useGetComponentsQuery
>
export type GetComponentsLazyQueryHookResult = ReturnType<
  typeof useGetComponentsLazyQuery
>
export type GetComponentsQueryResult = Apollo.QueryResult<
  Types.GetComponentsQuery,
  Types.GetComponentsQueryVariables
>
export const GetComponentsCountDocument = /*#__PURE__*/ gql`
  query getComponentsCount($shareIdentifier: UUID, $versionShortId: ShortId) {
    share(id: $shareIdentifier) {
      identifier
      version(shortId: $versionShortId) {
        identifier
        shortId
        hasComponentManifest
        document {
          identifier
          componentCount {
            layerStyle
            textStyle
            colorVar
            symbol
          }
        }
      }
    }
  }
`

/**
 * __useGetComponentsCountQuery__
 *
 * To run a query within a React component, call `useGetComponentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComponentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComponentsCountQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *   },
 * });
 */
export function useGetComponentsCountQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetComponentsCountQuery,
    Types.GetComponentsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetComponentsCountQuery,
    Types.GetComponentsCountQueryVariables
  >(GetComponentsCountDocument, options)
}
export function useGetComponentsCountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetComponentsCountQuery,
    Types.GetComponentsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetComponentsCountQuery,
    Types.GetComponentsCountQueryVariables
  >(GetComponentsCountDocument, options)
}

export type GetComponentsCountQueryHookResult = ReturnType<
  typeof useGetComponentsCountQuery
>
export type GetComponentsCountLazyQueryHookResult = ReturnType<
  typeof useGetComponentsCountLazyQuery
>
export type GetComponentsCountQueryResult = Apollo.QueryResult<
  Types.GetComponentsCountQuery,
  Types.GetComponentsCountQueryVariables
>
export const GetComponentGroupsDocument = /*#__PURE__*/ gql`
  query getComponentGroups(
    $uuid: UUID!
    $type: ComponentFilterType!
    $versionShortId: ShortId
  ) {
    share(id: $uuid) {
      identifier
      version(shortId: $versionShortId) {
        shortId
        identifier
        document {
          identifier
          componentGroups(type: $type) {
            data
          }
        }
      }
    }
  }
`

/**
 * __useGetComponentGroupsQuery__
 *
 * To run a query within a React component, call `useGetComponentGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComponentGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComponentGroupsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      type: // value for 'type'
 *      versionShortId: // value for 'versionShortId'
 *   },
 * });
 */
export function useGetComponentGroupsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetComponentGroupsQuery,
    Types.GetComponentGroupsQueryVariables
  > &
    (
      | { variables: Types.GetComponentGroupsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetComponentGroupsQuery,
    Types.GetComponentGroupsQueryVariables
  >(GetComponentGroupsDocument, options)
}
export function useGetComponentGroupsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetComponentGroupsQuery,
    Types.GetComponentGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetComponentGroupsQuery,
    Types.GetComponentGroupsQueryVariables
  >(GetComponentGroupsDocument, options)
}

export type GetComponentGroupsQueryHookResult = ReturnType<
  typeof useGetComponentGroupsQuery
>
export type GetComponentGroupsLazyQueryHookResult = ReturnType<
  typeof useGetComponentGroupsLazyQuery
>
export type GetComponentGroupsQueryResult = Apollo.QueryResult<
  Types.GetComponentGroupsQuery,
  Types.GetComponentGroupsQueryVariables
>
export const GetComponentWithUuidDocument = /*#__PURE__*/ gql`
  query getComponentWithUuid($documentId: UUID!, $uuid: String!) {
    componentInDocumentWithUuid(documentId: $documentId, uuid: $uuid) {
      ...ComponentInfo
    }
  }
  ${ComponentInfoFragmentDoc}
`

/**
 * __useGetComponentWithUuidQuery__
 *
 * To run a query within a React component, call `useGetComponentWithUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComponentWithUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComponentWithUuidQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetComponentWithUuidQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetComponentWithUuidQuery,
    Types.GetComponentWithUuidQueryVariables
  > &
    (
      | { variables: Types.GetComponentWithUuidQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetComponentWithUuidQuery,
    Types.GetComponentWithUuidQueryVariables
  >(GetComponentWithUuidDocument, options)
}
export function useGetComponentWithUuidLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetComponentWithUuidQuery,
    Types.GetComponentWithUuidQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetComponentWithUuidQuery,
    Types.GetComponentWithUuidQueryVariables
  >(GetComponentWithUuidDocument, options)
}

export type GetComponentWithUuidQueryHookResult = ReturnType<
  typeof useGetComponentWithUuidQuery
>
export type GetComponentWithUuidLazyQueryHookResult = ReturnType<
  typeof useGetComponentWithUuidLazyQuery
>
export type GetComponentWithUuidQueryResult = Apollo.QueryResult<
  Types.GetComponentWithUuidQuery,
  Types.GetComponentWithUuidQueryVariables
>
export const GetComponentsStateDocument = /*#__PURE__*/ gql`
  query getComponentsState($shareIdentifier: UUID, $versionShortId: ShortId) {
    share(id: $shareIdentifier) {
      identifier
      version(shortId: $versionShortId) {
        shortId
        identifier
        document {
          identifier
          componentCount {
            layerStyle
            textStyle
            colorVar
            symbol
          }
          components {
            status
          }
        }
      }
    }
  }
`

/**
 * __useGetComponentsStateQuery__
 *
 * To run a query within a React component, call `useGetComponentsStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComponentsStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComponentsStateQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *   },
 * });
 */
export function useGetComponentsStateQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetComponentsStateQuery,
    Types.GetComponentsStateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetComponentsStateQuery,
    Types.GetComponentsStateQueryVariables
  >(GetComponentsStateDocument, options)
}
export function useGetComponentsStateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetComponentsStateQuery,
    Types.GetComponentsStateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetComponentsStateQuery,
    Types.GetComponentsStateQueryVariables
  >(GetComponentsStateDocument, options)
}

export type GetComponentsStateQueryHookResult = ReturnType<
  typeof useGetComponentsStateQuery
>
export type GetComponentsStateLazyQueryHookResult = ReturnType<
  typeof useGetComponentsStateLazyQuery
>
export type GetComponentsStateQueryResult = Apollo.QueryResult<
  Types.GetComponentsStateQuery,
  Types.GetComponentsStateQueryVariables
>
export const EditDescriptionsDocument = /*#__PURE__*/ gql`
  mutation editDescriptions(
    $baseVersionIdentifier: UUID4!
    $compatibilityVersion: Int!
    $documentVersion: Int!
    $edits: [ComponentDescriptionEditInput!]!
    $shareIdentifier: UUID4!
  ) @capacitorapi {
    editComponents(
      baseVersionIdentifier: $baseVersionIdentifier
      compatibilityVersion: $compatibilityVersion
      documentVersion: $documentVersion
      edits: $edits
      shareIdentifier: $shareIdentifier
    ) {
      status
    }
  }
`
export type EditDescriptionsMutationFn = Apollo.MutationFunction<
  Types.EditDescriptionsMutation,
  Types.EditDescriptionsMutationVariables
>

/**
 * __useEditDescriptionsMutation__
 *
 * To run a mutation, you first call `useEditDescriptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDescriptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDescriptionsMutation, { data, loading, error }] = useEditDescriptionsMutation({
 *   variables: {
 *      baseVersionIdentifier: // value for 'baseVersionIdentifier'
 *      compatibilityVersion: // value for 'compatibilityVersion'
 *      documentVersion: // value for 'documentVersion'
 *      edits: // value for 'edits'
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useEditDescriptionsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.EditDescriptionsMutation,
    Types.EditDescriptionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.EditDescriptionsMutation,
    Types.EditDescriptionsMutationVariables
  >(EditDescriptionsDocument, options)
}
export type EditDescriptionsMutationHookResult = ReturnType<
  typeof useEditDescriptionsMutation
>
export type EditDescriptionsMutationResult =
  Apollo.MutationResult<Types.EditDescriptionsMutation>
export type EditDescriptionsMutationOptions = Apollo.BaseMutationOptions<
  Types.EditDescriptionsMutation,
  Types.EditDescriptionsMutationVariables
>
export const GetPendingDescriptionDocument = /*#__PURE__*/ gql`
  query getPendingDescription(
    $shareIdentifier: UUID4!
    $versionIdentifier: UUID4!
  ) @capacitorapi {
    collaborativeEditingSession(shareIdentifier: $shareIdentifier) {
      baseVersionIdentifier
      shareIdentifier
      compatibilityVersion
      componentEdits(versionIdentifier: $versionIdentifier) {
        componentUuid
        description
      }
    }
  }
`

/**
 * __useGetPendingDescriptionQuery__
 *
 * To run a query within a React component, call `useGetPendingDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingDescriptionQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionIdentifier: // value for 'versionIdentifier'
 *   },
 * });
 */
export function useGetPendingDescriptionQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPendingDescriptionQuery,
    Types.GetPendingDescriptionQueryVariables
  > &
    (
      | { variables: Types.GetPendingDescriptionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPendingDescriptionQuery,
    Types.GetPendingDescriptionQueryVariables
  >(GetPendingDescriptionDocument, options)
}
export function useGetPendingDescriptionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPendingDescriptionQuery,
    Types.GetPendingDescriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPendingDescriptionQuery,
    Types.GetPendingDescriptionQueryVariables
  >(GetPendingDescriptionDocument, options)
}

export type GetPendingDescriptionQueryHookResult = ReturnType<
  typeof useGetPendingDescriptionQuery
>
export type GetPendingDescriptionLazyQueryHookResult = ReturnType<
  typeof useGetPendingDescriptionLazyQuery
>
export type GetPendingDescriptionQueryResult = Apollo.QueryResult<
  Types.GetPendingDescriptionQuery,
  Types.GetPendingDescriptionQueryVariables
>
export const GetPageDocument = /*#__PURE__*/ gql`
  query getPage($share: UUID!, $version: ShortId, $pageUUID: String) {
    share(id: $share) {
      identifier
      commentsEnabled
      version(shortId: $version) {
        identifier
        shortId
        document {
          identifier
          frameCount
          page(uuid: $pageUUID) {
            identifier
            uuid
            name
          }
        }
      }
    }
  }
`

/**
 * __useGetPageQuery__
 *
 * To run a query within a React component, call `useGetPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageQuery({
 *   variables: {
 *      share: // value for 'share'
 *      version: // value for 'version'
 *      pageUUID: // value for 'pageUUID'
 *   },
 * });
 */
export function useGetPageQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPageQuery,
    Types.GetPageQueryVariables
  > &
    (
      | { variables: Types.GetPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPageQuery,
    Types.GetPageQueryVariables
  >(GetPageDocument, options)
}
export function useGetPageLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPageQuery,
    Types.GetPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPageQuery,
    Types.GetPageQueryVariables
  >(GetPageDocument, options)
}

export type GetPageQueryHookResult = ReturnType<typeof useGetPageQuery>
export type GetPageLazyQueryHookResult = ReturnType<typeof useGetPageLazyQuery>
export type GetPageQueryResult = Apollo.QueryResult<
  Types.GetPageQuery,
  Types.GetPageQueryVariables
>
export const GetPagesDocument = /*#__PURE__*/ gql`
  query getPages(
    $shareIdentifier: UUID!
    $versionShortId: ShortId!
    $after: String = null
    $search: String = null
  ) {
    share(id: $shareIdentifier) {
      identifier
      version(shortId: $versionShortId) {
        identifier
        shortId
        document {
          identifier
          componentCount {
            symbol
            textStyle
            colorVar
            layerStyle
          }
          prototypes: frames(filter: PROTOTYPE) {
            meta {
              totalCount
            }
          }
          pages(after: $after, search: $search) {
            entries {
              name
              identifier
              uuid
              ...AnnotationPageInfo
            }
            meta {
              after
              limit
              totalCount
            }
          }
        }
      }
    }
  }
  ${AnnotationPageInfoFragmentDoc}
`

/**
 * __useGetPagesQuery__
 *
 * To run a query within a React component, call `useGetPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPagesQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPagesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPagesQuery,
    Types.GetPagesQueryVariables
  > &
    (
      | { variables: Types.GetPagesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPagesQuery,
    Types.GetPagesQueryVariables
  >(GetPagesDocument, options)
}
export function useGetPagesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPagesQuery,
    Types.GetPagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPagesQuery,
    Types.GetPagesQueryVariables
  >(GetPagesDocument, options)
}

export type GetPagesQueryHookResult = ReturnType<typeof useGetPagesQuery>
export type GetPagesLazyQueryHookResult = ReturnType<
  typeof useGetPagesLazyQuery
>
export type GetPagesQueryResult = Apollo.QueryResult<
  Types.GetPagesQuery,
  Types.GetPagesQueryVariables
>
export const RenderDownloadableAssetsDocument = /*#__PURE__*/ gql`
  mutation renderDownloadableAssets(
    $documentIdentifier: String!
    $input: RenderLayerDownloadableAssetsInput
  ) {
    renderDownloadableAssets(
      input: {
        documentIdentifier: $documentIdentifier
        renderLayerDownloadableAssetsInput: $input
      }
    ) {
      downloadableAsset {
        ...DownloadableAsset
      }
      errors {
        ...UserError
      }
    }
  }
  ${DownloadableAssetFragmentDoc}
  ${UserErrorFragmentDoc}
`
export type RenderDownloadableAssetsMutationFn = Apollo.MutationFunction<
  Types.RenderDownloadableAssetsMutation,
  Types.RenderDownloadableAssetsMutationVariables
>

/**
 * __useRenderDownloadableAssetsMutation__
 *
 * To run a mutation, you first call `useRenderDownloadableAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenderDownloadableAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renderDownloadableAssetsMutation, { data, loading, error }] = useRenderDownloadableAssetsMutation({
 *   variables: {
 *      documentIdentifier: // value for 'documentIdentifier'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenderDownloadableAssetsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RenderDownloadableAssetsMutation,
    Types.RenderDownloadableAssetsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RenderDownloadableAssetsMutation,
    Types.RenderDownloadableAssetsMutationVariables
  >(RenderDownloadableAssetsDocument, options)
}
export type RenderDownloadableAssetsMutationHookResult = ReturnType<
  typeof useRenderDownloadableAssetsMutation
>
export type RenderDownloadableAssetsMutationResult =
  Apollo.MutationResult<Types.RenderDownloadableAssetsMutation>
export type RenderDownloadableAssetsMutationOptions =
  Apollo.BaseMutationOptions<
    Types.RenderDownloadableAssetsMutation,
    Types.RenderDownloadableAssetsMutationVariables
  >
export const GetDownloadableAssetsDocument = /*#__PURE__*/ gql`
  query getDownloadableAssets(
    $shareIdentifier: UUID!
    $versionShortId: ShortId
  ) {
    share(id: $shareIdentifier) {
      identifier
      version(shortId: $versionShortId) {
        shortId
        identifier
        document {
          identifier
          ...DocumentDownloadableAssets
        }
      }
    }
  }
  ${DocumentDownloadableAssetsFragmentDoc}
`

/**
 * __useGetDownloadableAssetsQuery__
 *
 * To run a query within a React component, call `useGetDownloadableAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadableAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadableAssetsQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *   },
 * });
 */
export function useGetDownloadableAssetsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetDownloadableAssetsQuery,
    Types.GetDownloadableAssetsQueryVariables
  > &
    (
      | { variables: Types.GetDownloadableAssetsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetDownloadableAssetsQuery,
    Types.GetDownloadableAssetsQueryVariables
  >(GetDownloadableAssetsDocument, options)
}
export function useGetDownloadableAssetsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetDownloadableAssetsQuery,
    Types.GetDownloadableAssetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetDownloadableAssetsQuery,
    Types.GetDownloadableAssetsQueryVariables
  >(GetDownloadableAssetsDocument, options)
}

export type GetDownloadableAssetsQueryHookResult = ReturnType<
  typeof useGetDownloadableAssetsQuery
>
export type GetDownloadableAssetsLazyQueryHookResult = ReturnType<
  typeof useGetDownloadableAssetsLazyQuery
>
export type GetDownloadableAssetsQueryResult = Apollo.QueryResult<
  Types.GetDownloadableAssetsQuery,
  Types.GetDownloadableAssetsQueryVariables
>
export const GetFrameViewDocument = /*#__PURE__*/ gql`
  query getFrameView(
    $frameUUID: String!
    $documentVersionShortId: ShortId
    $shareIdentifier: UUID!
  ) {
    frame(
      uuid: $frameUUID
      documentVersionShortId: $documentVersionShortId
      shareIdentifier: $shareIdentifier
    ) {
      ... on Artboard {
        ...ArtboardDetailInfo
      }
      ... on Frame {
        ...FrameDetailInfo
      }
    }
  }
  ${ArtboardDetailInfoFragmentDoc}
  ${FrameDetailInfoFragmentDoc}
`

/**
 * __useGetFrameViewQuery__
 *
 * To run a query within a React component, call `useGetFrameViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFrameViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFrameViewQuery({
 *   variables: {
 *      frameUUID: // value for 'frameUUID'
 *      documentVersionShortId: // value for 'documentVersionShortId'
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetFrameViewQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetFrameViewQuery,
    Types.GetFrameViewQueryVariables
  > &
    (
      | { variables: Types.GetFrameViewQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetFrameViewQuery,
    Types.GetFrameViewQueryVariables
  >(GetFrameViewDocument, options)
}
export function useGetFrameViewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetFrameViewQuery,
    Types.GetFrameViewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetFrameViewQuery,
    Types.GetFrameViewQueryVariables
  >(GetFrameViewDocument, options)
}

export type GetFrameViewQueryHookResult = ReturnType<
  typeof useGetFrameViewQuery
>
export type GetFrameViewLazyQueryHookResult = ReturnType<
  typeof useGetFrameViewLazyQuery
>
export type GetFrameViewQueryResult = Apollo.QueryResult<
  Types.GetFrameViewQuery,
  Types.GetFrameViewQueryVariables
>
export const GetSurroundingFramesDocument = /*#__PURE__*/ gql`
  query getSurroundingFrames(
    $frameUUID: String!
    $documentVersionShortId: ShortId!
    $shareIdentifier: UUID!
  ) {
    frame(
      uuid: $frameUUID
      documentVersionShortId: $documentVersionShortId
      shareIdentifier: $shareIdentifier
    ) {
      identifier
      documentOrder
      documentVersionShortId
      ... on Artboard {
        shortId
        documentVersionShortId
        permanentArtboardShortId
      }
      next {
        ... on Frame {
          ...FrameDetailInfo
        }
        ... on Artboard {
          ...ArtboardDetailInfo
        }
      }
      previous {
        ... on Frame {
          ...FrameDetailInfo
        }
        ... on Artboard {
          ...ArtboardDetailInfo
        }
      }
    }
  }
  ${FrameDetailInfoFragmentDoc}
  ${ArtboardDetailInfoFragmentDoc}
`

/**
 * __useGetSurroundingFramesQuery__
 *
 * To run a query within a React component, call `useGetSurroundingFramesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurroundingFramesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurroundingFramesQuery({
 *   variables: {
 *      frameUUID: // value for 'frameUUID'
 *      documentVersionShortId: // value for 'documentVersionShortId'
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetSurroundingFramesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSurroundingFramesQuery,
    Types.GetSurroundingFramesQueryVariables
  > &
    (
      | { variables: Types.GetSurroundingFramesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSurroundingFramesQuery,
    Types.GetSurroundingFramesQueryVariables
  >(GetSurroundingFramesDocument, options)
}
export function useGetSurroundingFramesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSurroundingFramesQuery,
    Types.GetSurroundingFramesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSurroundingFramesQuery,
    Types.GetSurroundingFramesQueryVariables
  >(GetSurroundingFramesDocument, options)
}

export type GetSurroundingFramesQueryHookResult = ReturnType<
  typeof useGetSurroundingFramesQuery
>
export type GetSurroundingFramesLazyQueryHookResult = ReturnType<
  typeof useGetSurroundingFramesLazyQuery
>
export type GetSurroundingFramesQueryResult = Apollo.QueryResult<
  Types.GetSurroundingFramesQuery,
  Types.GetSurroundingFramesQueryVariables
>
export const GetFramesForDocumentDocument = /*#__PURE__*/ gql`
  query getFramesForDocument(
    $identifier: UUID!
    $versionShortId: ShortId
    $after: String
    $filter: FrameFilterType = ALL
    $search: String
  ) {
    share(id: $identifier) {
      identifier
      commentsEnabled
      userCanEdit
      version(shortId: $versionShortId) {
        identifier
        shortId
        document {
          identifier
          frames(after: $after, filter: $filter, search: $search) {
            entries {
              ... on Frame {
                ...FrameDetailInfo
              }
              ... on Artboard {
                ...ArtboardDetailInfo
              }
            }
            meta {
              after
              totalCount
            }
          }
        }
      }
    }
  }
  ${FrameDetailInfoFragmentDoc}
  ${ArtboardDetailInfoFragmentDoc}
`

/**
 * __useGetFramesForDocumentQuery__
 *
 * To run a query within a React component, call `useGetFramesForDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFramesForDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFramesForDocumentQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      versionShortId: // value for 'versionShortId'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetFramesForDocumentQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetFramesForDocumentQuery,
    Types.GetFramesForDocumentQueryVariables
  > &
    (
      | { variables: Types.GetFramesForDocumentQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetFramesForDocumentQuery,
    Types.GetFramesForDocumentQueryVariables
  >(GetFramesForDocumentDocument, options)
}
export function useGetFramesForDocumentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetFramesForDocumentQuery,
    Types.GetFramesForDocumentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetFramesForDocumentQuery,
    Types.GetFramesForDocumentQueryVariables
  >(GetFramesForDocumentDocument, options)
}

export type GetFramesForDocumentQueryHookResult = ReturnType<
  typeof useGetFramesForDocumentQuery
>
export type GetFramesForDocumentLazyQueryHookResult = ReturnType<
  typeof useGetFramesForDocumentLazyQuery
>
export type GetFramesForDocumentQueryResult = Apollo.QueryResult<
  Types.GetFramesForDocumentQuery,
  Types.GetFramesForDocumentQueryVariables
>
export const GetFramesForPageDocument = /*#__PURE__*/ gql`
  query getFramesForPage(
    $identifier: UUID!
    $versionShortId: ShortId
    $pageUUID: String
    $after: String
    $search: String
  ) {
    share(id: $identifier) {
      identifier
      commentsEnabled
      version(shortId: $versionShortId) {
        identifier
        shortId
        document {
          identifier
          frameCount
          page(uuid: $pageUUID) {
            identifier
            frames(after: $after, search: $search) {
              entries {
                ... on Frame {
                  ...FrameDetailInfo
                }
                ... on Artboard {
                  ...ArtboardDetailInfo
                }
              }
              meta {
                after
                totalCount
              }
            }
          }
        }
      }
    }
  }
  ${FrameDetailInfoFragmentDoc}
  ${ArtboardDetailInfoFragmentDoc}
`

/**
 * __useGetFramesForPageQuery__
 *
 * To run a query within a React component, call `useGetFramesForPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFramesForPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFramesForPageQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      versionShortId: // value for 'versionShortId'
 *      pageUUID: // value for 'pageUUID'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetFramesForPageQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetFramesForPageQuery,
    Types.GetFramesForPageQueryVariables
  > &
    (
      | { variables: Types.GetFramesForPageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetFramesForPageQuery,
    Types.GetFramesForPageQueryVariables
  >(GetFramesForPageDocument, options)
}
export function useGetFramesForPageLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetFramesForPageQuery,
    Types.GetFramesForPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetFramesForPageQuery,
    Types.GetFramesForPageQueryVariables
  >(GetFramesForPageDocument, options)
}

export type GetFramesForPageQueryHookResult = ReturnType<
  typeof useGetFramesForPageQuery
>
export type GetFramesForPageLazyQueryHookResult = ReturnType<
  typeof useGetFramesForPageLazyQuery
>
export type GetFramesForPageQueryResult = Apollo.QueryResult<
  Types.GetFramesForPageQuery,
  Types.GetFramesForPageQueryVariables
>
export const GetFrameDescriptionDocument = /*#__PURE__*/ gql`
  query getFrameDescription(
    $frameUUID: String!
    $shareIdentifier: UUID!
    $documentVersionShortId: ShortId
  ) {
    frame(
      uuid: $frameUUID
      shareIdentifier: $shareIdentifier
      documentVersionShortId: $documentVersionShortId
    ) {
      uuid
      identifier
      documentVersionShortId
      ... on Artboard {
        documentVersionShortId
        permanentArtboardShortId
      }
      component {
        identifier
        description
      }
    }
  }
`

/**
 * __useGetFrameDescriptionQuery__
 *
 * To run a query within a React component, call `useGetFrameDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFrameDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFrameDescriptionQuery({
 *   variables: {
 *      frameUUID: // value for 'frameUUID'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      documentVersionShortId: // value for 'documentVersionShortId'
 *   },
 * });
 */
export function useGetFrameDescriptionQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetFrameDescriptionQuery,
    Types.GetFrameDescriptionQueryVariables
  > &
    (
      | { variables: Types.GetFrameDescriptionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetFrameDescriptionQuery,
    Types.GetFrameDescriptionQueryVariables
  >(GetFrameDescriptionDocument, options)
}
export function useGetFrameDescriptionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetFrameDescriptionQuery,
    Types.GetFrameDescriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetFrameDescriptionQuery,
    Types.GetFrameDescriptionQueryVariables
  >(GetFrameDescriptionDocument, options)
}

export type GetFrameDescriptionQueryHookResult = ReturnType<
  typeof useGetFrameDescriptionQuery
>
export type GetFrameDescriptionLazyQueryHookResult = ReturnType<
  typeof useGetFrameDescriptionLazyQuery
>
export type GetFrameDescriptionQueryResult = Apollo.QueryResult<
  Types.GetFrameDescriptionQuery,
  Types.GetFrameDescriptionQueryVariables
>
export const GetFrameAnnotationInfoDocument = /*#__PURE__*/ gql`
  query getFrameAnnotationInfo($frameUUID: String!, $shareIdentifier: UUID!) {
    frame(uuid: $frameUUID, shareIdentifier: $shareIdentifier) {
      uuid
      identifier
      ...AnnotationFrameGroupInfo
    }
  }
  ${AnnotationFrameGroupInfoFragmentDoc}
`

/**
 * __useGetFrameAnnotationInfoQuery__
 *
 * To run a query within a React component, call `useGetFrameAnnotationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFrameAnnotationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFrameAnnotationInfoQuery({
 *   variables: {
 *      frameUUID: // value for 'frameUUID'
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetFrameAnnotationInfoQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetFrameAnnotationInfoQuery,
    Types.GetFrameAnnotationInfoQueryVariables
  > &
    (
      | {
          variables: Types.GetFrameAnnotationInfoQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetFrameAnnotationInfoQuery,
    Types.GetFrameAnnotationInfoQueryVariables
  >(GetFrameAnnotationInfoDocument, options)
}
export function useGetFrameAnnotationInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetFrameAnnotationInfoQuery,
    Types.GetFrameAnnotationInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetFrameAnnotationInfoQuery,
    Types.GetFrameAnnotationInfoQueryVariables
  >(GetFrameAnnotationInfoDocument, options)
}

export type GetFrameAnnotationInfoQueryHookResult = ReturnType<
  typeof useGetFrameAnnotationInfoQuery
>
export type GetFrameAnnotationInfoLazyQueryHookResult = ReturnType<
  typeof useGetFrameAnnotationInfoLazyQuery
>
export type GetFrameAnnotationInfoQueryResult = Apollo.QueryResult<
  Types.GetFrameAnnotationInfoQuery,
  Types.GetFrameAnnotationInfoQueryVariables
>
export const GetInspectorComponentDataDocument = /*#__PURE__*/ gql`
  query getInspectorComponentData($componentId: UUID) {
    inspectorData(componentId: $componentId) {
      inspector {
        status
        data
      }
    }
  }
`

/**
 * __useGetInspectorComponentDataQuery__
 *
 * To run a query within a React component, call `useGetInspectorComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInspectorComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInspectorComponentDataQuery({
 *   variables: {
 *      componentId: // value for 'componentId'
 *   },
 * });
 */
export function useGetInspectorComponentDataQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetInspectorComponentDataQuery,
    Types.GetInspectorComponentDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetInspectorComponentDataQuery,
    Types.GetInspectorComponentDataQueryVariables
  >(GetInspectorComponentDataDocument, options)
}
export function useGetInspectorComponentDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetInspectorComponentDataQuery,
    Types.GetInspectorComponentDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetInspectorComponentDataQuery,
    Types.GetInspectorComponentDataQueryVariables
  >(GetInspectorComponentDataDocument, options)
}

export type GetInspectorComponentDataQueryHookResult = ReturnType<
  typeof useGetInspectorComponentDataQuery
>
export type GetInspectorComponentDataLazyQueryHookResult = ReturnType<
  typeof useGetInspectorComponentDataLazyQuery
>
export type GetInspectorComponentDataQueryResult = Apollo.QueryResult<
  Types.GetInspectorComponentDataQuery,
  Types.GetInspectorComponentDataQueryVariables
>
export const RenderPresentationDocument = /*#__PURE__*/ gql`
  mutation renderPresentation(
    $versionIdentifier: UUID
    $previewIdentifier: UUID
  ) {
    renderPresentation(
      versionIdentifier: $versionIdentifier
      previewIdentifier: $previewIdentifier
    ) {
      presentationStatus
    }
  }
`
export type RenderPresentationMutationFn = Apollo.MutationFunction<
  Types.RenderPresentationMutation,
  Types.RenderPresentationMutationVariables
>

/**
 * __useRenderPresentationMutation__
 *
 * To run a mutation, you first call `useRenderPresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenderPresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renderPresentationMutation, { data, loading, error }] = useRenderPresentationMutation({
 *   variables: {
 *      versionIdentifier: // value for 'versionIdentifier'
 *      previewIdentifier: // value for 'previewIdentifier'
 *   },
 * });
 */
export function useRenderPresentationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RenderPresentationMutation,
    Types.RenderPresentationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RenderPresentationMutation,
    Types.RenderPresentationMutationVariables
  >(RenderPresentationDocument, options)
}
export type RenderPresentationMutationHookResult = ReturnType<
  typeof useRenderPresentationMutation
>
export type RenderPresentationMutationResult =
  Apollo.MutationResult<Types.RenderPresentationMutation>
export type RenderPresentationMutationOptions = Apollo.BaseMutationOptions<
  Types.RenderPresentationMutation,
  Types.RenderPresentationMutationVariables
>
export const GetPagePresentationFileDocument = /*#__PURE__*/ gql`
  query getPagePresentationFile(
    $shareIdentifier: UUID!
    $versionShortId: ShortId
    $pageUUID: String
  ) {
    share(id: $shareIdentifier) {
      identifier
      version(shortId: $versionShortId) {
        identifier
        shortId
        document {
          identifier
          page(uuid: $pageUUID) {
            name
            identifier
            uuid
            ...PresentationFile
          }
        }
      }
    }
  }
  ${PresentationFileFragmentDoc}
`

/**
 * __useGetPagePresentationFileQuery__
 *
 * To run a query within a React component, call `useGetPagePresentationFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPagePresentationFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPagePresentationFileQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *      pageUUID: // value for 'pageUUID'
 *   },
 * });
 */
export function useGetPagePresentationFileQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPagePresentationFileQuery,
    Types.GetPagePresentationFileQueryVariables
  > &
    (
      | {
          variables: Types.GetPagePresentationFileQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPagePresentationFileQuery,
    Types.GetPagePresentationFileQueryVariables
  >(GetPagePresentationFileDocument, options)
}
export function useGetPagePresentationFileLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPagePresentationFileQuery,
    Types.GetPagePresentationFileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPagePresentationFileQuery,
    Types.GetPagePresentationFileQueryVariables
  >(GetPagePresentationFileDocument, options)
}

export type GetPagePresentationFileQueryHookResult = ReturnType<
  typeof useGetPagePresentationFileQuery
>
export type GetPagePresentationFileLazyQueryHookResult = ReturnType<
  typeof useGetPagePresentationFileLazyQuery
>
export type GetPagePresentationFileQueryResult = Apollo.QueryResult<
  Types.GetPagePresentationFileQuery,
  Types.GetPagePresentationFileQueryVariables
>
export const GetPresentationAssetsByArtboardDocument = /*#__PURE__*/ gql`
  query getPresentationAssetsByArtboard(
    $documentId: String!
    $artboardUuid: String!
  ) {
    artboardInDocumentWithUuid(documentId: $documentId, uuid: $artboardUuid) {
      uuid
      documentVersionShortId
      permanentArtboardShortId
      page {
        identifier
        uuid
        ...PresentationFile
      }
    }
  }
  ${PresentationFileFragmentDoc}
`

/**
 * __useGetPresentationAssetsByArtboardQuery__
 *
 * To run a query within a React component, call `useGetPresentationAssetsByArtboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPresentationAssetsByArtboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPresentationAssetsByArtboardQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      artboardUuid: // value for 'artboardUuid'
 *   },
 * });
 */
export function useGetPresentationAssetsByArtboardQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPresentationAssetsByArtboardQuery,
    Types.GetPresentationAssetsByArtboardQueryVariables
  > &
    (
      | {
          variables: Types.GetPresentationAssetsByArtboardQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPresentationAssetsByArtboardQuery,
    Types.GetPresentationAssetsByArtboardQueryVariables
  >(GetPresentationAssetsByArtboardDocument, options)
}
export function useGetPresentationAssetsByArtboardLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPresentationAssetsByArtboardQuery,
    Types.GetPresentationAssetsByArtboardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPresentationAssetsByArtboardQuery,
    Types.GetPresentationAssetsByArtboardQueryVariables
  >(GetPresentationAssetsByArtboardDocument, options)
}

export type GetPresentationAssetsByArtboardQueryHookResult = ReturnType<
  typeof useGetPresentationAssetsByArtboardQuery
>
export type GetPresentationAssetsByArtboardLazyQueryHookResult = ReturnType<
  typeof useGetPresentationAssetsByArtboardLazyQuery
>
export type GetPresentationAssetsByArtboardQueryResult = Apollo.QueryResult<
  Types.GetPresentationAssetsByArtboardQuery,
  Types.GetPresentationAssetsByArtboardQueryVariables
>
export const GetPageImageTokensDocument = /*#__PURE__*/ gql`
  query getPageImageTokens(
    $shareIdentifier: UUID!
    $versionShortId: ShortId!
    $after: String = null
  ) {
    share(id: $shareIdentifier) {
      identifier
      version(shortId: $versionShortId) {
        identifier
        shortId
        document {
          identifier
          pages(after: $after) {
            entries {
              identifier
              uuid
              presentationFile {
                imageToken
              }
            }
            meta {
              after
              limit
              totalCount
            }
          }
        }
      }
    }
  }
`

/**
 * __useGetPageImageTokensQuery__
 *
 * To run a query within a React component, call `useGetPageImageTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageImageTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageImageTokensQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPageImageTokensQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPageImageTokensQuery,
    Types.GetPageImageTokensQueryVariables
  > &
    (
      | { variables: Types.GetPageImageTokensQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPageImageTokensQuery,
    Types.GetPageImageTokensQueryVariables
  >(GetPageImageTokensDocument, options)
}
export function useGetPageImageTokensLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPageImageTokensQuery,
    Types.GetPageImageTokensQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPageImageTokensQuery,
    Types.GetPageImageTokensQueryVariables
  >(GetPageImageTokensDocument, options)
}

export type GetPageImageTokensQueryHookResult = ReturnType<
  typeof useGetPageImageTokensQuery
>
export type GetPageImageTokensLazyQueryHookResult = ReturnType<
  typeof useGetPageImageTokensLazyQuery
>
export type GetPageImageTokensQueryResult = Apollo.QueryResult<
  Types.GetPageImageTokensQuery,
  Types.GetPageImageTokensQueryVariables
>
export const ShareDeleteDocument = /*#__PURE__*/ gql`
  mutation shareDelete($identifier: UUID!) {
    shareDelete(identifier: $identifier) {
      errors {
        ...UserError
      }
      successful
      share {
        identifier
        name
        deletedAt
        workspace {
          identifier
        }
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type ShareDeleteMutationFn = Apollo.MutationFunction<
  Types.ShareDeleteMutation,
  Types.ShareDeleteMutationVariables
>

/**
 * __useShareDeleteMutation__
 *
 * To run a mutation, you first call `useShareDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareDeleteMutation, { data, loading, error }] = useShareDeleteMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useShareDeleteMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ShareDeleteMutation,
    Types.ShareDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ShareDeleteMutation,
    Types.ShareDeleteMutationVariables
  >(ShareDeleteDocument, options)
}
export type ShareDeleteMutationHookResult = ReturnType<
  typeof useShareDeleteMutation
>
export type ShareDeleteMutationResult =
  Apollo.MutationResult<Types.ShareDeleteMutation>
export type ShareDeleteMutationOptions = Apollo.BaseMutationOptions<
  Types.ShareDeleteMutation,
  Types.ShareDeleteMutationVariables
>
export const SharesDeleteDocument = /*#__PURE__*/ gql`
  mutation sharesDelete($identifiers: [UUID!]!) {
    sharesDelete(identifiers: $identifiers) {
      shares {
        identifier
      }
    }
  }
`
export type SharesDeleteMutationFn = Apollo.MutationFunction<
  Types.SharesDeleteMutation,
  Types.SharesDeleteMutationVariables
>

/**
 * __useSharesDeleteMutation__
 *
 * To run a mutation, you first call `useSharesDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharesDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharesDeleteMutation, { data, loading, error }] = useSharesDeleteMutation({
 *   variables: {
 *      identifiers: // value for 'identifiers'
 *   },
 * });
 */
export function useSharesDeleteMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SharesDeleteMutation,
    Types.SharesDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SharesDeleteMutation,
    Types.SharesDeleteMutationVariables
  >(SharesDeleteDocument, options)
}
export type SharesDeleteMutationHookResult = ReturnType<
  typeof useSharesDeleteMutation
>
export type SharesDeleteMutationResult =
  Apollo.MutationResult<Types.SharesDeleteMutation>
export type SharesDeleteMutationOptions = Apollo.BaseMutationOptions<
  Types.SharesDeleteMutation,
  Types.SharesDeleteMutationVariables
>
export const RestoreShareDocument = /*#__PURE__*/ gql`
  mutation restoreShare($identifier: UUID!) {
    restoreShare(identifier: $identifier) {
      share {
        ...ShareInfo
      }
    }
  }
  ${ShareInfoFragmentDoc}
`
export type RestoreShareMutationFn = Apollo.MutationFunction<
  Types.RestoreShareMutation,
  Types.RestoreShareMutationVariables
>

/**
 * __useRestoreShareMutation__
 *
 * To run a mutation, you first call `useRestoreShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreShareMutation, { data, loading, error }] = useRestoreShareMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useRestoreShareMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RestoreShareMutation,
    Types.RestoreShareMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RestoreShareMutation,
    Types.RestoreShareMutationVariables
  >(RestoreShareDocument, options)
}
export type RestoreShareMutationHookResult = ReturnType<
  typeof useRestoreShareMutation
>
export type RestoreShareMutationResult =
  Apollo.MutationResult<Types.RestoreShareMutation>
export type RestoreShareMutationOptions = Apollo.BaseMutationOptions<
  Types.RestoreShareMutation,
  Types.RestoreShareMutationVariables
>
export const ShareUpdateDocument = /*#__PURE__*/ gql`
  mutation shareUpdate($identifier: UUID!, $share: ShareParams!) {
    shareUpdate(identifier: $identifier, share: $share) {
      errors {
        ...UserError
      }
      share {
        name
        identifier
        ...ShareSettings
      }
      successful
    }
  }
  ${UserErrorFragmentDoc}
  ${ShareSettingsFragmentDoc}
`
export type ShareUpdateMutationFn = Apollo.MutationFunction<
  Types.ShareUpdateMutation,
  Types.ShareUpdateMutationVariables
>

/**
 * __useShareUpdateMutation__
 *
 * To run a mutation, you first call `useShareUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareUpdateMutation, { data, loading, error }] = useShareUpdateMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      share: // value for 'share'
 *   },
 * });
 */
export function useShareUpdateMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ShareUpdateMutation,
    Types.ShareUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ShareUpdateMutation,
    Types.ShareUpdateMutationVariables
  >(ShareUpdateDocument, options)
}
export type ShareUpdateMutationHookResult = ReturnType<
  typeof useShareUpdateMutation
>
export type ShareUpdateMutationResult =
  Apollo.MutationResult<Types.ShareUpdateMutation>
export type ShareUpdateMutationOptions = Apollo.BaseMutationOptions<
  Types.ShareUpdateMutation,
  Types.ShareUpdateMutationVariables
>
export const ShareLeaveDocument = /*#__PURE__*/ gql`
  mutation shareLeave($identifier: UUID!) {
    shareLeave(identifier: $identifier) {
      errors {
        ...UserError
      }
      successful
      share {
        identifier
        workspace {
          identifier
          userIsMember
        }
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type ShareLeaveMutationFn = Apollo.MutationFunction<
  Types.ShareLeaveMutation,
  Types.ShareLeaveMutationVariables
>

/**
 * __useShareLeaveMutation__
 *
 * To run a mutation, you first call `useShareLeaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareLeaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareLeaveMutation, { data, loading, error }] = useShareLeaveMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useShareLeaveMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ShareLeaveMutation,
    Types.ShareLeaveMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ShareLeaveMutation,
    Types.ShareLeaveMutationVariables
  >(ShareLeaveDocument, options)
}
export type ShareLeaveMutationHookResult = ReturnType<
  typeof useShareLeaveMutation
>
export type ShareLeaveMutationResult =
  Apollo.MutationResult<Types.ShareLeaveMutation>
export type ShareLeaveMutationOptions = Apollo.BaseMutationOptions<
  Types.ShareLeaveMutation,
  Types.ShareLeaveMutationVariables
>
export const DeleteSharePermanentlyDocument = /*#__PURE__*/ gql`
  mutation deleteSharePermanently(
    $workspaceId: UUID!
    $shareIdentifier: UUID!
  ) {
    deleteSharePermanently(
      workspaceIdentifier: $workspaceId
      shareIdentifier: $shareIdentifier
    ) {
      shareIdentifier
      workspace {
        identifier
      }
    }
  }
`
export type DeleteSharePermanentlyMutationFn = Apollo.MutationFunction<
  Types.DeleteSharePermanentlyMutation,
  Types.DeleteSharePermanentlyMutationVariables
>

/**
 * __useDeleteSharePermanentlyMutation__
 *
 * To run a mutation, you first call `useDeleteSharePermanentlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSharePermanentlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSharePermanentlyMutation, { data, loading, error }] = useDeleteSharePermanentlyMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useDeleteSharePermanentlyMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeleteSharePermanentlyMutation,
    Types.DeleteSharePermanentlyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeleteSharePermanentlyMutation,
    Types.DeleteSharePermanentlyMutationVariables
  >(DeleteSharePermanentlyDocument, options)
}
export type DeleteSharePermanentlyMutationHookResult = ReturnType<
  typeof useDeleteSharePermanentlyMutation
>
export type DeleteSharePermanentlyMutationResult =
  Apollo.MutationResult<Types.DeleteSharePermanentlyMutation>
export type DeleteSharePermanentlyMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteSharePermanentlyMutation,
  Types.DeleteSharePermanentlyMutationVariables
>
export const EmptyWorkspaceTrashDocument = /*#__PURE__*/ gql`
  mutation emptyWorkspaceTrash($identifier: UUID!) {
    emptyWorkspaceTrash(identifier: $identifier) {
      workspace {
        identifier
      }
    }
  }
`
export type EmptyWorkspaceTrashMutationFn = Apollo.MutationFunction<
  Types.EmptyWorkspaceTrashMutation,
  Types.EmptyWorkspaceTrashMutationVariables
>

/**
 * __useEmptyWorkspaceTrashMutation__
 *
 * To run a mutation, you first call `useEmptyWorkspaceTrashMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmptyWorkspaceTrashMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emptyWorkspaceTrashMutation, { data, loading, error }] = useEmptyWorkspaceTrashMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useEmptyWorkspaceTrashMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.EmptyWorkspaceTrashMutation,
    Types.EmptyWorkspaceTrashMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.EmptyWorkspaceTrashMutation,
    Types.EmptyWorkspaceTrashMutationVariables
  >(EmptyWorkspaceTrashDocument, options)
}
export type EmptyWorkspaceTrashMutationHookResult = ReturnType<
  typeof useEmptyWorkspaceTrashMutation
>
export type EmptyWorkspaceTrashMutationResult =
  Apollo.MutationResult<Types.EmptyWorkspaceTrashMutation>
export type EmptyWorkspaceTrashMutationOptions = Apollo.BaseMutationOptions<
  Types.EmptyWorkspaceTrashMutation,
  Types.EmptyWorkspaceTrashMutationVariables
>
export const UpdateSharePublicPermissionsDocument = /*#__PURE__*/ gql`
  mutation updateSharePublicPermissions(
    $input: UpdateSharePublicPermissionsParams!
  ) {
    updateSharePublicPermissions(input: $input) {
      ...SharePublicPermissions
    }
  }
  ${SharePublicPermissionsFragmentDoc}
`
export type UpdateSharePublicPermissionsMutationFn = Apollo.MutationFunction<
  Types.UpdateSharePublicPermissionsMutation,
  Types.UpdateSharePublicPermissionsMutationVariables
>

/**
 * __useUpdateSharePublicPermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateSharePublicPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSharePublicPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSharePublicPermissionsMutation, { data, loading, error }] = useUpdateSharePublicPermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSharePublicPermissionsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateSharePublicPermissionsMutation,
    Types.UpdateSharePublicPermissionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateSharePublicPermissionsMutation,
    Types.UpdateSharePublicPermissionsMutationVariables
  >(UpdateSharePublicPermissionsDocument, options)
}
export type UpdateSharePublicPermissionsMutationHookResult = ReturnType<
  typeof useUpdateSharePublicPermissionsMutation
>
export type UpdateSharePublicPermissionsMutationResult =
  Apollo.MutationResult<Types.UpdateSharePublicPermissionsMutation>
export type UpdateSharePublicPermissionsMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateSharePublicPermissionsMutation,
    Types.UpdateSharePublicPermissionsMutationVariables
  >
export const UpdateShareParentPermissionsDocument = /*#__PURE__*/ gql`
  mutation updateShareParentPermissions(
    $input: UpdateShareParentPermissionsParams!
  ) {
    updateShareParentPermissions(input: $input) {
      identifier
      userCanUpdateSettings
      parentAccessLevel
    }
  }
`
export type UpdateShareParentPermissionsMutationFn = Apollo.MutationFunction<
  Types.UpdateShareParentPermissionsMutation,
  Types.UpdateShareParentPermissionsMutationVariables
>

/**
 * __useUpdateShareParentPermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateShareParentPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShareParentPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShareParentPermissionsMutation, { data, loading, error }] = useUpdateShareParentPermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShareParentPermissionsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateShareParentPermissionsMutation,
    Types.UpdateShareParentPermissionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateShareParentPermissionsMutation,
    Types.UpdateShareParentPermissionsMutationVariables
  >(UpdateShareParentPermissionsDocument, options)
}
export type UpdateShareParentPermissionsMutationHookResult = ReturnType<
  typeof useUpdateShareParentPermissionsMutation
>
export type UpdateShareParentPermissionsMutationResult =
  Apollo.MutationResult<Types.UpdateShareParentPermissionsMutation>
export type UpdateShareParentPermissionsMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateShareParentPermissionsMutation,
    Types.UpdateShareParentPermissionsMutationVariables
  >
export const TransferShareDocument = /*#__PURE__*/ gql`
  mutation transferShare(
    $shareIdentifier: UUID!
    $workspaceIdentifier: UUID!
    $projectIdentifier: UUID
    $membershipsOperation: MembershipsTransferOperation!
  ) {
    transferShare(
      shareIdentifier: $shareIdentifier
      workspaceIdentifier: $workspaceIdentifier
      projectIdentifier: $projectIdentifier
      membershipsOperation: $membershipsOperation
    ) {
      share {
        identifier
        project {
          ...Project
        }
        workspace {
          identifier
          name
        }
      }
    }
  }
  ${ProjectFragmentDoc}
`
export type TransferShareMutationFn = Apollo.MutationFunction<
  Types.TransferShareMutation,
  Types.TransferShareMutationVariables
>

/**
 * __useTransferShareMutation__
 *
 * To run a mutation, you first call `useTransferShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferShareMutation, { data, loading, error }] = useTransferShareMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      projectIdentifier: // value for 'projectIdentifier'
 *      membershipsOperation: // value for 'membershipsOperation'
 *   },
 * });
 */
export function useTransferShareMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.TransferShareMutation,
    Types.TransferShareMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.TransferShareMutation,
    Types.TransferShareMutationVariables
  >(TransferShareDocument, options)
}
export type TransferShareMutationHookResult = ReturnType<
  typeof useTransferShareMutation
>
export type TransferShareMutationResult =
  Apollo.MutationResult<Types.TransferShareMutation>
export type TransferShareMutationOptions = Apollo.BaseMutationOptions<
  Types.TransferShareMutation,
  Types.TransferShareMutationVariables
>
export const UpdateSharePublicTokenExportDocument = /*#__PURE__*/ gql`
  mutation updateSharePublicTokenExport(
    $shareIdentifier: UUID!
    $shareParams: ShareParams!
    $format: TokenExportFormat!
    $colorFormat: TokenColorFormat
    $tokenTypes: [ExportableComponentType]!
  ) {
    shareUpdate(identifier: $shareIdentifier, share: $shareParams) {
      share {
        identifier
        publicTokenExport
        publicTokenExportUrl(
          format: $format
          colorFormat: $colorFormat
          tokenTypes: $tokenTypes
        )
      }
    }
  }
`
export type UpdateSharePublicTokenExportMutationFn = Apollo.MutationFunction<
  Types.UpdateSharePublicTokenExportMutation,
  Types.UpdateSharePublicTokenExportMutationVariables
>

/**
 * __useUpdateSharePublicTokenExportMutation__
 *
 * To run a mutation, you first call `useUpdateSharePublicTokenExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSharePublicTokenExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSharePublicTokenExportMutation, { data, loading, error }] = useUpdateSharePublicTokenExportMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      shareParams: // value for 'shareParams'
 *      format: // value for 'format'
 *      colorFormat: // value for 'colorFormat'
 *      tokenTypes: // value for 'tokenTypes'
 *   },
 * });
 */
export function useUpdateSharePublicTokenExportMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateSharePublicTokenExportMutation,
    Types.UpdateSharePublicTokenExportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateSharePublicTokenExportMutation,
    Types.UpdateSharePublicTokenExportMutationVariables
  >(UpdateSharePublicTokenExportDocument, options)
}
export type UpdateSharePublicTokenExportMutationHookResult = ReturnType<
  typeof useUpdateSharePublicTokenExportMutation
>
export type UpdateSharePublicTokenExportMutationResult =
  Apollo.MutationResult<Types.UpdateSharePublicTokenExportMutation>
export type UpdateSharePublicTokenExportMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateSharePublicTokenExportMutation,
    Types.UpdateSharePublicTokenExportMutationVariables
  >
export const ShareRenameDocument = /*#__PURE__*/ gql`
  mutation shareRename($identifier: UUID!, $name: String!) {
    shareUpdate(identifier: $identifier, share: { name: $name }) {
      successful
      share {
        identifier
        name
      }
      errors {
        message
      }
    }
  }
`
export type ShareRenameMutationFn = Apollo.MutationFunction<
  Types.ShareRenameMutation,
  Types.ShareRenameMutationVariables
>

/**
 * __useShareRenameMutation__
 *
 * To run a mutation, you first call `useShareRenameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareRenameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareRenameMutation, { data, loading, error }] = useShareRenameMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useShareRenameMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ShareRenameMutation,
    Types.ShareRenameMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ShareRenameMutation,
    Types.ShareRenameMutationVariables
  >(ShareRenameDocument, options)
}
export type ShareRenameMutationHookResult = ReturnType<
  typeof useShareRenameMutation
>
export type ShareRenameMutationResult =
  Apollo.MutationResult<Types.ShareRenameMutation>
export type ShareRenameMutationOptions = Apollo.BaseMutationOptions<
  Types.ShareRenameMutation,
  Types.ShareRenameMutationVariables
>
export const ShareDescriptionChangeDocument = /*#__PURE__*/ gql`
  mutation shareDescriptionChange($identifier: UUID!, $description: String!) {
    shareUpdate(identifier: $identifier, share: { description: $description }) {
      successful
      share {
        identifier
        description
      }
      errors {
        message
      }
    }
  }
`
export type ShareDescriptionChangeMutationFn = Apollo.MutationFunction<
  Types.ShareDescriptionChangeMutation,
  Types.ShareDescriptionChangeMutationVariables
>

/**
 * __useShareDescriptionChangeMutation__
 *
 * To run a mutation, you first call `useShareDescriptionChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareDescriptionChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareDescriptionChangeMutation, { data, loading, error }] = useShareDescriptionChangeMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useShareDescriptionChangeMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ShareDescriptionChangeMutation,
    Types.ShareDescriptionChangeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ShareDescriptionChangeMutation,
    Types.ShareDescriptionChangeMutationVariables
  >(ShareDescriptionChangeDocument, options)
}
export type ShareDescriptionChangeMutationHookResult = ReturnType<
  typeof useShareDescriptionChangeMutation
>
export type ShareDescriptionChangeMutationResult =
  Apollo.MutationResult<Types.ShareDescriptionChangeMutation>
export type ShareDescriptionChangeMutationOptions = Apollo.BaseMutationOptions<
  Types.ShareDescriptionChangeMutation,
  Types.ShareDescriptionChangeMutationVariables
>
export const ShareTypeChangeDocument = /*#__PURE__*/ gql`
  mutation shareTypeChange($identifier: UUID!, $type: ShareType!) {
    shareUpdate(identifier: $identifier, share: { type: $type }) {
      successful
      share {
        identifier
        shareType
      }
      errors {
        message
      }
    }
  }
`
export type ShareTypeChangeMutationFn = Apollo.MutationFunction<
  Types.ShareTypeChangeMutation,
  Types.ShareTypeChangeMutationVariables
>

/**
 * __useShareTypeChangeMutation__
 *
 * To run a mutation, you first call `useShareTypeChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareTypeChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareTypeChangeMutation, { data, loading, error }] = useShareTypeChangeMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useShareTypeChangeMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ShareTypeChangeMutation,
    Types.ShareTypeChangeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ShareTypeChangeMutation,
    Types.ShareTypeChangeMutationVariables
  >(ShareTypeChangeDocument, options)
}
export type ShareTypeChangeMutationHookResult = ReturnType<
  typeof useShareTypeChangeMutation
>
export type ShareTypeChangeMutationResult =
  Apollo.MutationResult<Types.ShareTypeChangeMutation>
export type ShareTypeChangeMutationOptions = Apollo.BaseMutationOptions<
  Types.ShareTypeChangeMutation,
  Types.ShareTypeChangeMutationVariables
>
export const DuplicateShareToDraftsDocument = /*#__PURE__*/ gql`
  mutation duplicateShareToDrafts($input: DuplicateShareToDraftsParams!) {
    duplicateShareToDrafts(input: $input) {
      share {
        identifier
        workspace {
          identifier
          name
        }
        project {
          identifier
        }
      }
    }
  }
`
export type DuplicateShareToDraftsMutationFn = Apollo.MutationFunction<
  Types.DuplicateShareToDraftsMutation,
  Types.DuplicateShareToDraftsMutationVariables
>

/**
 * __useDuplicateShareToDraftsMutation__
 *
 * To run a mutation, you first call `useDuplicateShareToDraftsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateShareToDraftsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateShareToDraftsMutation, { data, loading, error }] = useDuplicateShareToDraftsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateShareToDraftsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DuplicateShareToDraftsMutation,
    Types.DuplicateShareToDraftsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DuplicateShareToDraftsMutation,
    Types.DuplicateShareToDraftsMutationVariables
  >(DuplicateShareToDraftsDocument, options)
}
export type DuplicateShareToDraftsMutationHookResult = ReturnType<
  typeof useDuplicateShareToDraftsMutation
>
export type DuplicateShareToDraftsMutationResult =
  Apollo.MutationResult<Types.DuplicateShareToDraftsMutation>
export type DuplicateShareToDraftsMutationOptions = Apollo.BaseMutationOptions<
  Types.DuplicateShareToDraftsMutation,
  Types.DuplicateShareToDraftsMutationVariables
>
export const DuplicateShareToDocument = /*#__PURE__*/ gql`
  mutation duplicateShareTo(
    $sourceShareIdentifier: UUID!
    $sourceVersionIdentifier: UUID!
    $targetWorkspaceIdentifier: UUID!
    $targetProjectIdentifier: UUID
    $targetCollectionIdentifier: UUID
  ) {
    duplicateShareTo(
      sourceShareIdentifier: $sourceShareIdentifier
      sourceVersionIdentifier: $sourceVersionIdentifier
      targetWorkspaceIdentifier: $targetWorkspaceIdentifier
      targetProjectIdentifier: $targetProjectIdentifier
      targetCollectionIdentifier: $targetCollectionIdentifier
    ) {
      share {
        identifier
        project {
          identifier
        }
        collection {
          identifier
        }
      }
    }
  }
`
export type DuplicateShareToMutationFn = Apollo.MutationFunction<
  Types.DuplicateShareToMutation,
  Types.DuplicateShareToMutationVariables
>

/**
 * __useDuplicateShareToMutation__
 *
 * To run a mutation, you first call `useDuplicateShareToMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateShareToMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateShareToMutation, { data, loading, error }] = useDuplicateShareToMutation({
 *   variables: {
 *      sourceShareIdentifier: // value for 'sourceShareIdentifier'
 *      sourceVersionIdentifier: // value for 'sourceVersionIdentifier'
 *      targetWorkspaceIdentifier: // value for 'targetWorkspaceIdentifier'
 *      targetProjectIdentifier: // value for 'targetProjectIdentifier'
 *      targetCollectionIdentifier: // value for 'targetCollectionIdentifier'
 *   },
 * });
 */
export function useDuplicateShareToMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DuplicateShareToMutation,
    Types.DuplicateShareToMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DuplicateShareToMutation,
    Types.DuplicateShareToMutationVariables
  >(DuplicateShareToDocument, options)
}
export type DuplicateShareToMutationHookResult = ReturnType<
  typeof useDuplicateShareToMutation
>
export type DuplicateShareToMutationResult =
  Apollo.MutationResult<Types.DuplicateShareToMutation>
export type DuplicateShareToMutationOptions = Apollo.BaseMutationOptions<
  Types.DuplicateShareToMutation,
  Types.DuplicateShareToMutationVariables
>
export const PublishShareDocument = /*#__PURE__*/ gql`
  mutation publishShare(
    $shareIdentifier: UUID!
    $publicCommentsEnabled: Boolean!
    $publicInspectEnabled: Boolean!
  ) {
    publishShare(
      shareIdentifier: $shareIdentifier
      publicInspectEnabled: $publicInspectEnabled
      publicCommentsEnabled: $publicCommentsEnabled
    ) {
      publication {
        share {
          identifier
          ...SharePublicPermissions
        }
      }
    }
  }
  ${SharePublicPermissionsFragmentDoc}
`
export type PublishShareMutationFn = Apollo.MutationFunction<
  Types.PublishShareMutation,
  Types.PublishShareMutationVariables
>

/**
 * __usePublishShareMutation__
 *
 * To run a mutation, you first call `usePublishShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishShareMutation, { data, loading, error }] = usePublishShareMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      publicCommentsEnabled: // value for 'publicCommentsEnabled'
 *      publicInspectEnabled: // value for 'publicInspectEnabled'
 *   },
 * });
 */
export function usePublishShareMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.PublishShareMutation,
    Types.PublishShareMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.PublishShareMutation,
    Types.PublishShareMutationVariables
  >(PublishShareDocument, options)
}
export type PublishShareMutationHookResult = ReturnType<
  typeof usePublishShareMutation
>
export type PublishShareMutationResult =
  Apollo.MutationResult<Types.PublishShareMutation>
export type PublishShareMutationOptions = Apollo.BaseMutationOptions<
  Types.PublishShareMutation,
  Types.PublishShareMutationVariables
>
export const UnpublishShareDocument = /*#__PURE__*/ gql`
  mutation unpublishShare(
    $shareIdentifier: UUID!
    $publicAccessLevel: PublicAccessLevel!
    $publicCommentsEnabled: Boolean!
    $publicInspectEnabled: Boolean!
  ) {
    unpublishShare(
      shareIdentifier: $shareIdentifier
      publicInspectEnabled: $publicInspectEnabled
      publicCommentsEnabled: $publicCommentsEnabled
      publicAccessLevel: $publicAccessLevel
    ) {
      share {
        identifier
        ...SharePublicPermissions
      }
    }
  }
  ${SharePublicPermissionsFragmentDoc}
`
export type UnpublishShareMutationFn = Apollo.MutationFunction<
  Types.UnpublishShareMutation,
  Types.UnpublishShareMutationVariables
>

/**
 * __useUnpublishShareMutation__
 *
 * To run a mutation, you first call `useUnpublishShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishShareMutation, { data, loading, error }] = useUnpublishShareMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      publicAccessLevel: // value for 'publicAccessLevel'
 *      publicCommentsEnabled: // value for 'publicCommentsEnabled'
 *      publicInspectEnabled: // value for 'publicInspectEnabled'
 *   },
 * });
 */
export function useUnpublishShareMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UnpublishShareMutation,
    Types.UnpublishShareMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UnpublishShareMutation,
    Types.UnpublishShareMutationVariables
  >(UnpublishShareDocument, options)
}
export type UnpublishShareMutationHookResult = ReturnType<
  typeof useUnpublishShareMutation
>
export type UnpublishShareMutationResult =
  Apollo.MutationResult<Types.UnpublishShareMutation>
export type UnpublishShareMutationOptions = Apollo.BaseMutationOptions<
  Types.UnpublishShareMutation,
  Types.UnpublishShareMutationVariables
>
export const ReportShareDocument = /*#__PURE__*/ gql`
  mutation reportShare($identifier: UUID!, $reason: ShareReportReason!) {
    reportShare(identifier: $identifier, reason: $reason) {
      reported
    }
  }
`
export type ReportShareMutationFn = Apollo.MutationFunction<
  Types.ReportShareMutation,
  Types.ReportShareMutationVariables
>

/**
 * __useReportShareMutation__
 *
 * To run a mutation, you first call `useReportShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportShareMutation, { data, loading, error }] = useReportShareMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useReportShareMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ReportShareMutation,
    Types.ReportShareMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ReportShareMutation,
    Types.ReportShareMutationVariables
  >(ReportShareDocument, options)
}
export type ReportShareMutationHookResult = ReturnType<
  typeof useReportShareMutation
>
export type ReportShareMutationResult =
  Apollo.MutationResult<Types.ReportShareMutation>
export type ReportShareMutationOptions = Apollo.BaseMutationOptions<
  Types.ReportShareMutation,
  Types.ReportShareMutationVariables
>
export const ConsolidateAutoVersionDocument = /*#__PURE__*/ gql`
  mutation consolidateAutoVersion($shareIdentifier: UUID4!) @capacitorapi {
    createCollaborativeVersion(shareIdentifier: $shareIdentifier, kind: AUTO) {
      id
      status
    }
  }
`
export type ConsolidateAutoVersionMutationFn = Apollo.MutationFunction<
  Types.ConsolidateAutoVersionMutation,
  Types.ConsolidateAutoVersionMutationVariables
>

/**
 * __useConsolidateAutoVersionMutation__
 *
 * To run a mutation, you first call `useConsolidateAutoVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsolidateAutoVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consolidateAutoVersionMutation, { data, loading, error }] = useConsolidateAutoVersionMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useConsolidateAutoVersionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ConsolidateAutoVersionMutation,
    Types.ConsolidateAutoVersionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ConsolidateAutoVersionMutation,
    Types.ConsolidateAutoVersionMutationVariables
  >(ConsolidateAutoVersionDocument, options)
}
export type ConsolidateAutoVersionMutationHookResult = ReturnType<
  typeof useConsolidateAutoVersionMutation
>
export type ConsolidateAutoVersionMutationResult =
  Apollo.MutationResult<Types.ConsolidateAutoVersionMutation>
export type ConsolidateAutoVersionMutationOptions = Apollo.BaseMutationOptions<
  Types.ConsolidateAutoVersionMutation,
  Types.ConsolidateAutoVersionMutationVariables
>
export const PinShareDocument = /*#__PURE__*/ gql`
  mutation pinShare($shareIdentifier: UUID!) {
    pinShare(input: { shareIdentifier: $shareIdentifier }) {
      share {
        identifier
        pinnedByCurrentUserAt
      }
    }
  }
`
export type PinShareMutationFn = Apollo.MutationFunction<
  Types.PinShareMutation,
  Types.PinShareMutationVariables
>

/**
 * __usePinShareMutation__
 *
 * To run a mutation, you first call `usePinShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinShareMutation, { data, loading, error }] = usePinShareMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function usePinShareMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.PinShareMutation,
    Types.PinShareMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.PinShareMutation,
    Types.PinShareMutationVariables
  >(PinShareDocument, options)
}
export type PinShareMutationHookResult = ReturnType<typeof usePinShareMutation>
export type PinShareMutationResult =
  Apollo.MutationResult<Types.PinShareMutation>
export type PinShareMutationOptions = Apollo.BaseMutationOptions<
  Types.PinShareMutation,
  Types.PinShareMutationVariables
>
export const UnpinShareDocument = /*#__PURE__*/ gql`
  mutation unpinShare($shareIdentifier: UUID!) {
    unpinShare(input: { shareIdentifier: $shareIdentifier }) {
      share {
        identifier
        pinnedByCurrentUserAt
      }
    }
  }
`
export type UnpinShareMutationFn = Apollo.MutationFunction<
  Types.UnpinShareMutation,
  Types.UnpinShareMutationVariables
>

/**
 * __useUnpinShareMutation__
 *
 * To run a mutation, you first call `useUnpinShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinShareMutation, { data, loading, error }] = useUnpinShareMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useUnpinShareMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UnpinShareMutation,
    Types.UnpinShareMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UnpinShareMutation,
    Types.UnpinShareMutationVariables
  >(UnpinShareDocument, options)
}
export type UnpinShareMutationHookResult = ReturnType<
  typeof useUnpinShareMutation
>
export type UnpinShareMutationResult =
  Apollo.MutationResult<Types.UnpinShareMutation>
export type UnpinShareMutationOptions = Apollo.BaseMutationOptions<
  Types.UnpinShareMutation,
  Types.UnpinShareMutationVariables
>
export const GetShareDocument = /*#__PURE__*/ gql`
  query getShare($id: UUID!) {
    share(id: $id) {
      ...ShareInfo
    }
  }
  ${ShareInfoFragmentDoc}
`

/**
 * __useGetShareQuery__
 *
 * To run a query within a React component, call `useGetShareQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetShareQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetShareQuery,
    Types.GetShareQueryVariables
  > &
    (
      | { variables: Types.GetShareQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareQuery,
    Types.GetShareQueryVariables
  >(GetShareDocument, options)
}
export function useGetShareLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareQuery,
    Types.GetShareQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareQuery,
    Types.GetShareQueryVariables
  >(GetShareDocument, options)
}

export type GetShareQueryHookResult = ReturnType<typeof useGetShareQuery>
export type GetShareLazyQueryHookResult = ReturnType<
  typeof useGetShareLazyQuery
>
export type GetShareQueryResult = Apollo.QueryResult<
  Types.GetShareQuery,
  Types.GetShareQueryVariables
>
export const GetShareDropdownOptionsDocument = /*#__PURE__*/ gql`
  query getShareDropdownOptions(
    $shareIdentifier: UUID!
    $versionShortId: ShortId!
  ) {
    share(id: $shareIdentifier) {
      ...ShareDropdownOptions
    }
  }
  ${ShareDropdownOptionsFragmentDoc}
`

/**
 * __useGetShareDropdownOptionsQuery__
 *
 * To run a query within a React component, call `useGetShareDropdownOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareDropdownOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareDropdownOptionsQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *   },
 * });
 */
export function useGetShareDropdownOptionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetShareDropdownOptionsQuery,
    Types.GetShareDropdownOptionsQueryVariables
  > &
    (
      | {
          variables: Types.GetShareDropdownOptionsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareDropdownOptionsQuery,
    Types.GetShareDropdownOptionsQueryVariables
  >(GetShareDropdownOptionsDocument, options)
}
export function useGetShareDropdownOptionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareDropdownOptionsQuery,
    Types.GetShareDropdownOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareDropdownOptionsQuery,
    Types.GetShareDropdownOptionsQueryVariables
  >(GetShareDropdownOptionsDocument, options)
}

export type GetShareDropdownOptionsQueryHookResult = ReturnType<
  typeof useGetShareDropdownOptionsQuery
>
export type GetShareDropdownOptionsLazyQueryHookResult = ReturnType<
  typeof useGetShareDropdownOptionsLazyQuery
>
export type GetShareDropdownOptionsQueryResult = Apollo.QueryResult<
  Types.GetShareDropdownOptionsQuery,
  Types.GetShareDropdownOptionsQueryVariables
>
export const GetShareWorkspaceDocument = /*#__PURE__*/ gql`
  query getShareWorkspace($shareIdentifier: UUID!) {
    share(id: $shareIdentifier) {
      ...ShareWorkspace
    }
  }
  ${ShareWorkspaceFragmentDoc}
`

/**
 * __useGetShareWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetShareWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareWorkspaceQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetShareWorkspaceQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetShareWorkspaceQuery,
    Types.GetShareWorkspaceQueryVariables
  > &
    (
      | { variables: Types.GetShareWorkspaceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareWorkspaceQuery,
    Types.GetShareWorkspaceQueryVariables
  >(GetShareWorkspaceDocument, options)
}
export function useGetShareWorkspaceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareWorkspaceQuery,
    Types.GetShareWorkspaceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareWorkspaceQuery,
    Types.GetShareWorkspaceQueryVariables
  >(GetShareWorkspaceDocument, options)
}

export type GetShareWorkspaceQueryHookResult = ReturnType<
  typeof useGetShareWorkspaceQuery
>
export type GetShareWorkspaceLazyQueryHookResult = ReturnType<
  typeof useGetShareWorkspaceLazyQuery
>
export type GetShareWorkspaceQueryResult = Apollo.QueryResult<
  Types.GetShareWorkspaceQuery,
  Types.GetShareWorkspaceQueryVariables
>
export const GetSharesDocument = /*#__PURE__*/ gql`
  query getShares(
    $identifier: UUID!
    $after: String
    $search: SharesSearchParams
    $sortOrder: ShareSortOrder
    $archived: ShareArchivedStatus
  ) {
    workspace(identifier: $identifier) {
      identifier
      status
      shares(
        after: $after
        search: $search
        sortOrder: $sortOrder
        archived: $archived
      ) {
        entries {
          ...ShareListItem
        }
        meta {
          ...ShareMeta
        }
      }
    }
  }
  ${ShareListItemFragmentDoc}
  ${ShareMetaFragmentDoc}
`

/**
 * __useGetSharesQuery__
 *
 * To run a query within a React component, call `useGetSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharesQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      sortOrder: // value for 'sortOrder'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useGetSharesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSharesQuery,
    Types.GetSharesQueryVariables
  > &
    (
      | { variables: Types.GetSharesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSharesQuery,
    Types.GetSharesQueryVariables
  >(GetSharesDocument, options)
}
export function useGetSharesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSharesQuery,
    Types.GetSharesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSharesQuery,
    Types.GetSharesQueryVariables
  >(GetSharesDocument, options)
}

export type GetSharesQueryHookResult = ReturnType<typeof useGetSharesQuery>
export type GetSharesLazyQueryHookResult = ReturnType<
  typeof useGetSharesLazyQuery
>
export type GetSharesQueryResult = Apollo.QueryResult<
  Types.GetSharesQuery,
  Types.GetSharesQueryVariables
>
export const GetSharesLibrariesDocument = /*#__PURE__*/ gql`
  query getSharesLibraries(
    $identifier: UUID!
    $after: String
    $search: SharesSearchParams
  ) {
    workspace(identifier: $identifier) {
      identifier
      status
      shares(after: $after, search: $search) {
        entries {
          ...ShareListItem
        }
        meta {
          ...ShareMeta
        }
      }
    }
  }
  ${ShareListItemFragmentDoc}
  ${ShareMetaFragmentDoc}
`

/**
 * __useGetSharesLibrariesQuery__
 *
 * To run a query within a React component, call `useGetSharesLibrariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharesLibrariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharesLibrariesQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetSharesLibrariesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSharesLibrariesQuery,
    Types.GetSharesLibrariesQueryVariables
  > &
    (
      | { variables: Types.GetSharesLibrariesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSharesLibrariesQuery,
    Types.GetSharesLibrariesQueryVariables
  >(GetSharesLibrariesDocument, options)
}
export function useGetSharesLibrariesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSharesLibrariesQuery,
    Types.GetSharesLibrariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSharesLibrariesQuery,
    Types.GetSharesLibrariesQueryVariables
  >(GetSharesLibrariesDocument, options)
}

export type GetSharesLibrariesQueryHookResult = ReturnType<
  typeof useGetSharesLibrariesQuery
>
export type GetSharesLibrariesLazyQueryHookResult = ReturnType<
  typeof useGetSharesLibrariesLazyQuery
>
export type GetSharesLibrariesQueryResult = Apollo.QueryResult<
  Types.GetSharesLibrariesQuery,
  Types.GetSharesLibrariesQueryVariables
>
export const GetSharesDropdownOptionsDocument = /*#__PURE__*/ gql`
  query getSharesDropdownOptions(
    $identifier: UUID!
    $after: String
    $search: SharesSearchParams
    $sortOrder: ShareSortOrder
  ) {
    workspace(identifier: $identifier) {
      identifier
      shares(after: $after, search: $search, sortOrder: $sortOrder) {
        entries {
          ...ShareDropdownOptionsPreload
        }
      }
    }
  }
  ${ShareDropdownOptionsPreloadFragmentDoc}
`

/**
 * __useGetSharesDropdownOptionsQuery__
 *
 * To run a query within a React component, call `useGetSharesDropdownOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharesDropdownOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharesDropdownOptionsQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetSharesDropdownOptionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSharesDropdownOptionsQuery,
    Types.GetSharesDropdownOptionsQueryVariables
  > &
    (
      | {
          variables: Types.GetSharesDropdownOptionsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSharesDropdownOptionsQuery,
    Types.GetSharesDropdownOptionsQueryVariables
  >(GetSharesDropdownOptionsDocument, options)
}
export function useGetSharesDropdownOptionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSharesDropdownOptionsQuery,
    Types.GetSharesDropdownOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSharesDropdownOptionsQuery,
    Types.GetSharesDropdownOptionsQueryVariables
  >(GetSharesDropdownOptionsDocument, options)
}

export type GetSharesDropdownOptionsQueryHookResult = ReturnType<
  typeof useGetSharesDropdownOptionsQuery
>
export type GetSharesDropdownOptionsLazyQueryHookResult = ReturnType<
  typeof useGetSharesDropdownOptionsLazyQuery
>
export type GetSharesDropdownOptionsQueryResult = Apollo.QueryResult<
  Types.GetSharesDropdownOptionsQuery,
  Types.GetSharesDropdownOptionsQueryVariables
>
export const GetShareUserAccessLevelDocument = /*#__PURE__*/ gql`
  query getShareUserAccessLevel($identifier: UUID!) {
    share(id: $identifier) {
      identifier
      ...ShareUserAccessLevel
    }
  }
  ${ShareUserAccessLevelFragmentDoc}
`

/**
 * __useGetShareUserAccessLevelQuery__
 *
 * To run a query within a React component, call `useGetShareUserAccessLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareUserAccessLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareUserAccessLevelQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetShareUserAccessLevelQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetShareUserAccessLevelQuery,
    Types.GetShareUserAccessLevelQueryVariables
  > &
    (
      | {
          variables: Types.GetShareUserAccessLevelQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareUserAccessLevelQuery,
    Types.GetShareUserAccessLevelQueryVariables
  >(GetShareUserAccessLevelDocument, options)
}
export function useGetShareUserAccessLevelLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareUserAccessLevelQuery,
    Types.GetShareUserAccessLevelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareUserAccessLevelQuery,
    Types.GetShareUserAccessLevelQueryVariables
  >(GetShareUserAccessLevelDocument, options)
}

export type GetShareUserAccessLevelQueryHookResult = ReturnType<
  typeof useGetShareUserAccessLevelQuery
>
export type GetShareUserAccessLevelLazyQueryHookResult = ReturnType<
  typeof useGetShareUserAccessLevelLazyQuery
>
export type GetShareUserAccessLevelQueryResult = Apollo.QueryResult<
  Types.GetShareUserAccessLevelQuery,
  Types.GetShareUserAccessLevelQueryVariables
>
export const GetProjectSharesDocument = /*#__PURE__*/ gql`
  query getProjectShares(
    $shortId: ShortId!
    $after: String
    $search: SharesSearchParams
    $sortOrder: ShareSortOrder
  ) {
    project(shortId: $shortId) {
      ...Project
      workspaceAccessLevel
      shares(after: $after, searchParams: $search, sortOrder: $sortOrder) {
        entries {
          ...ShareListItem
        }
        meta {
          ...ShareMeta
        }
      }
    }
  }
  ${ProjectFragmentDoc}
  ${ShareListItemFragmentDoc}
  ${ShareMetaFragmentDoc}
`

/**
 * __useGetProjectSharesQuery__
 *
 * To run a query within a React component, call `useGetProjectSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSharesQuery({
 *   variables: {
 *      shortId: // value for 'shortId'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetProjectSharesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectSharesQuery,
    Types.GetProjectSharesQueryVariables
  > &
    (
      | { variables: Types.GetProjectSharesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectSharesQuery,
    Types.GetProjectSharesQueryVariables
  >(GetProjectSharesDocument, options)
}
export function useGetProjectSharesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectSharesQuery,
    Types.GetProjectSharesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectSharesQuery,
    Types.GetProjectSharesQueryVariables
  >(GetProjectSharesDocument, options)
}

export type GetProjectSharesQueryHookResult = ReturnType<
  typeof useGetProjectSharesQuery
>
export type GetProjectSharesLazyQueryHookResult = ReturnType<
  typeof useGetProjectSharesLazyQuery
>
export type GetProjectSharesQueryResult = Apollo.QueryResult<
  Types.GetProjectSharesQuery,
  Types.GetProjectSharesQueryVariables
>
export const GetProjectSharesDropdownOptionsDocument = /*#__PURE__*/ gql`
  query getProjectSharesDropdownOptions(
    $shortId: ShortId!
    $after: String
    $search: SharesSearchParams
    $sortOrder: ShareSortOrder
  ) {
    project(shortId: $shortId) {
      shortId
      identifier
      shares(after: $after, searchParams: $search, sortOrder: $sortOrder) {
        entries {
          ...ShareDropdownOptionsPreload
        }
      }
    }
  }
  ${ShareDropdownOptionsPreloadFragmentDoc}
`

/**
 * __useGetProjectSharesDropdownOptionsQuery__
 *
 * To run a query within a React component, call `useGetProjectSharesDropdownOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSharesDropdownOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSharesDropdownOptionsQuery({
 *   variables: {
 *      shortId: // value for 'shortId'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetProjectSharesDropdownOptionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProjectSharesDropdownOptionsQuery,
    Types.GetProjectSharesDropdownOptionsQueryVariables
  > &
    (
      | {
          variables: Types.GetProjectSharesDropdownOptionsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProjectSharesDropdownOptionsQuery,
    Types.GetProjectSharesDropdownOptionsQueryVariables
  >(GetProjectSharesDropdownOptionsDocument, options)
}
export function useGetProjectSharesDropdownOptionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProjectSharesDropdownOptionsQuery,
    Types.GetProjectSharesDropdownOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProjectSharesDropdownOptionsQuery,
    Types.GetProjectSharesDropdownOptionsQueryVariables
  >(GetProjectSharesDropdownOptionsDocument, options)
}

export type GetProjectSharesDropdownOptionsQueryHookResult = ReturnType<
  typeof useGetProjectSharesDropdownOptionsQuery
>
export type GetProjectSharesDropdownOptionsLazyQueryHookResult = ReturnType<
  typeof useGetProjectSharesDropdownOptionsLazyQuery
>
export type GetProjectSharesDropdownOptionsQueryResult = Apollo.QueryResult<
  Types.GetProjectSharesDropdownOptionsQuery,
  Types.GetProjectSharesDropdownOptionsQueryVariables
>
export const GetPersonalWorkspaceSharesCountDocument = /*#__PURE__*/ gql`
  query getPersonalWorkspaceSharesCount {
    me {
      identifier
      personalWorkspace {
        identifier
        allShares: shares {
          meta {
            totalCount
          }
        }
        libraries: shares(search: { filters: [LIBRARY] }) {
          meta {
            totalCount
          }
        }
      }
    }
  }
`

/**
 * __useGetPersonalWorkspaceSharesCountQuery__
 *
 * To run a query within a React component, call `useGetPersonalWorkspaceSharesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalWorkspaceSharesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalWorkspaceSharesCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPersonalWorkspaceSharesCountQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetPersonalWorkspaceSharesCountQuery,
    Types.GetPersonalWorkspaceSharesCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPersonalWorkspaceSharesCountQuery,
    Types.GetPersonalWorkspaceSharesCountQueryVariables
  >(GetPersonalWorkspaceSharesCountDocument, options)
}
export function useGetPersonalWorkspaceSharesCountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPersonalWorkspaceSharesCountQuery,
    Types.GetPersonalWorkspaceSharesCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPersonalWorkspaceSharesCountQuery,
    Types.GetPersonalWorkspaceSharesCountQueryVariables
  >(GetPersonalWorkspaceSharesCountDocument, options)
}

export type GetPersonalWorkspaceSharesCountQueryHookResult = ReturnType<
  typeof useGetPersonalWorkspaceSharesCountQuery
>
export type GetPersonalWorkspaceSharesCountLazyQueryHookResult = ReturnType<
  typeof useGetPersonalWorkspaceSharesCountLazyQuery
>
export type GetPersonalWorkspaceSharesCountQueryResult = Apollo.QueryResult<
  Types.GetPersonalWorkspaceSharesCountQuery,
  Types.GetPersonalWorkspaceSharesCountQueryVariables
>
export const GetLibrariesDocument = /*#__PURE__*/ gql`
  query getLibraries($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      libraries: shares(search: { filters: [LIBRARY] }) {
        entries {
          identifier
          name
          version(preferredState: PROCESSED) {
            shortId
            identifier
            document {
              previewFile {
                identifier
                url
              }
            }
          }
        }
        meta {
          ...ShareMeta
        }
      }
    }
  }
  ${ShareMetaFragmentDoc}
`

/**
 * __useGetLibrariesQuery__
 *
 * To run a query within a React component, call `useGetLibrariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibrariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibrariesQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetLibrariesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetLibrariesQuery,
    Types.GetLibrariesQueryVariables
  > &
    (
      | { variables: Types.GetLibrariesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetLibrariesQuery,
    Types.GetLibrariesQueryVariables
  >(GetLibrariesDocument, options)
}
export function useGetLibrariesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetLibrariesQuery,
    Types.GetLibrariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetLibrariesQuery,
    Types.GetLibrariesQueryVariables
  >(GetLibrariesDocument, options)
}

export type GetLibrariesQueryHookResult = ReturnType<
  typeof useGetLibrariesQuery
>
export type GetLibrariesLazyQueryHookResult = ReturnType<
  typeof useGetLibrariesLazyQuery
>
export type GetLibrariesQueryResult = Apollo.QueryResult<
  Types.GetLibrariesQuery,
  Types.GetLibrariesQueryVariables
>
export const GetWorkspaceSharesCountDocument = /*#__PURE__*/ gql`
  query getWorkspaceSharesCount($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      shares {
        meta {
          totalCount
        }
      }
    }
  }
`

/**
 * __useGetWorkspaceSharesCountQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSharesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSharesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSharesCountQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceSharesCountQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceSharesCountQuery,
    Types.GetWorkspaceSharesCountQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceSharesCountQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceSharesCountQuery,
    Types.GetWorkspaceSharesCountQueryVariables
  >(GetWorkspaceSharesCountDocument, options)
}
export function useGetWorkspaceSharesCountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceSharesCountQuery,
    Types.GetWorkspaceSharesCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceSharesCountQuery,
    Types.GetWorkspaceSharesCountQueryVariables
  >(GetWorkspaceSharesCountDocument, options)
}

export type GetWorkspaceSharesCountQueryHookResult = ReturnType<
  typeof useGetWorkspaceSharesCountQuery
>
export type GetWorkspaceSharesCountLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceSharesCountLazyQuery
>
export type GetWorkspaceSharesCountQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceSharesCountQuery,
  Types.GetWorkspaceSharesCountQueryVariables
>
export const GetDocumentListSettingsDocument = /*#__PURE__*/ gql`
  query getDocumentListSettings {
    documentsLayout @client
    showDocumentsInProjects @client
    showArchivedDocuments @client
  }
`

/**
 * __useGetDocumentListSettingsQuery__
 *
 * To run a query within a React component, call `useGetDocumentListSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentListSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentListSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDocumentListSettingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetDocumentListSettingsQuery,
    Types.GetDocumentListSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetDocumentListSettingsQuery,
    Types.GetDocumentListSettingsQueryVariables
  >(GetDocumentListSettingsDocument, options)
}
export function useGetDocumentListSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetDocumentListSettingsQuery,
    Types.GetDocumentListSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetDocumentListSettingsQuery,
    Types.GetDocumentListSettingsQueryVariables
  >(GetDocumentListSettingsDocument, options)
}

export type GetDocumentListSettingsQueryHookResult = ReturnType<
  typeof useGetDocumentListSettingsQuery
>
export type GetDocumentListSettingsLazyQueryHookResult = ReturnType<
  typeof useGetDocumentListSettingsLazyQuery
>
export type GetDocumentListSettingsQueryResult = Apollo.QueryResult<
  Types.GetDocumentListSettingsQuery,
  Types.GetDocumentListSettingsQueryVariables
>
export const ShareForDocumentWithUuidDocument = /*#__PURE__*/ gql`
  query shareForDocumentWithUuid($name: String!, $uuid: String!) {
    shareForDocumentWithUuid(uuid: $uuid, name: $name) {
      identifier
      name
      version {
        identifier
        shortId
        document {
          identifier
        }
      }
    }
  }
`

/**
 * __useShareForDocumentWithUuidQuery__
 *
 * To run a query within a React component, call `useShareForDocumentWithUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareForDocumentWithUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareForDocumentWithUuidQuery({
 *   variables: {
 *      name: // value for 'name'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useShareForDocumentWithUuidQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.ShareForDocumentWithUuidQuery,
    Types.ShareForDocumentWithUuidQueryVariables
  > &
    (
      | {
          variables: Types.ShareForDocumentWithUuidQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.ShareForDocumentWithUuidQuery,
    Types.ShareForDocumentWithUuidQueryVariables
  >(ShareForDocumentWithUuidDocument, options)
}
export function useShareForDocumentWithUuidLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.ShareForDocumentWithUuidQuery,
    Types.ShareForDocumentWithUuidQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.ShareForDocumentWithUuidQuery,
    Types.ShareForDocumentWithUuidQueryVariables
  >(ShareForDocumentWithUuidDocument, options)
}

export type ShareForDocumentWithUuidQueryHookResult = ReturnType<
  typeof useShareForDocumentWithUuidQuery
>
export type ShareForDocumentWithUuidLazyQueryHookResult = ReturnType<
  typeof useShareForDocumentWithUuidLazyQuery
>
export type ShareForDocumentWithUuidQueryResult = Apollo.QueryResult<
  Types.ShareForDocumentWithUuidQuery,
  Types.ShareForDocumentWithUuidQueryVariables
>
export const GetSymbolMasterDocumentDocument = /*#__PURE__*/ gql`
  query getSymbolMasterDocument(
    $name: String!
    $uuid: String!
    $frameUUID: String!
  ) {
    shareForDocumentWithUuid(uuid: $uuid, name: $name) {
      identifier
      version {
        identifier
        shortId
        document {
          identifier
          frame(uuid: $frameUUID) {
            identifier
            uuid
            ... on Artboard {
              permanentArtboardShortId
              documentVersionShortId
            }
            files(type: FULL) {
              identifier
              url
              thumbnails {
                type
                url
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useGetSymbolMasterDocumentQuery__
 *
 * To run a query within a React component, call `useGetSymbolMasterDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSymbolMasterDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSymbolMasterDocumentQuery({
 *   variables: {
 *      name: // value for 'name'
 *      uuid: // value for 'uuid'
 *      frameUUID: // value for 'frameUUID'
 *   },
 * });
 */
export function useGetSymbolMasterDocumentQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSymbolMasterDocumentQuery,
    Types.GetSymbolMasterDocumentQueryVariables
  > &
    (
      | {
          variables: Types.GetSymbolMasterDocumentQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSymbolMasterDocumentQuery,
    Types.GetSymbolMasterDocumentQueryVariables
  >(GetSymbolMasterDocumentDocument, options)
}
export function useGetSymbolMasterDocumentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSymbolMasterDocumentQuery,
    Types.GetSymbolMasterDocumentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSymbolMasterDocumentQuery,
    Types.GetSymbolMasterDocumentQueryVariables
  >(GetSymbolMasterDocumentDocument, options)
}

export type GetSymbolMasterDocumentQueryHookResult = ReturnType<
  typeof useGetSymbolMasterDocumentQuery
>
export type GetSymbolMasterDocumentLazyQueryHookResult = ReturnType<
  typeof useGetSymbolMasterDocumentLazyQuery
>
export type GetSymbolMasterDocumentQueryResult = Apollo.QueryResult<
  Types.GetSymbolMasterDocumentQuery,
  Types.GetSymbolMasterDocumentQueryVariables
>
export const GetShareSidebarDocument = /*#__PURE__*/ gql`
  query getShareSidebar($identifier: UUID, $versionShortId: ShortId) {
    share(id: $identifier) {
      ...ShareAbout
    }
  }
  ${ShareAboutFragmentDoc}
`

/**
 * __useGetShareSidebarQuery__
 *
 * To run a query within a React component, call `useGetShareSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareSidebarQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      versionShortId: // value for 'versionShortId'
 *   },
 * });
 */
export function useGetShareSidebarQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetShareSidebarQuery,
    Types.GetShareSidebarQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareSidebarQuery,
    Types.GetShareSidebarQueryVariables
  >(GetShareSidebarDocument, options)
}
export function useGetShareSidebarLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareSidebarQuery,
    Types.GetShareSidebarQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareSidebarQuery,
    Types.GetShareSidebarQueryVariables
  >(GetShareSidebarDocument, options)
}

export type GetShareSidebarQueryHookResult = ReturnType<
  typeof useGetShareSidebarQuery
>
export type GetShareSidebarLazyQueryHookResult = ReturnType<
  typeof useGetShareSidebarLazyQuery
>
export type GetShareSidebarQueryResult = Apollo.QueryResult<
  Types.GetShareSidebarQuery,
  Types.GetShareSidebarQueryVariables
>
export const GetShareDesignTokenExportDocument = /*#__PURE__*/ gql`
  query getShareDesignTokenExport(
    $shareIdentifier: UUID
    $versionShortId: ShortId
    $format: TokenExportFormat!
    $colorFormat: TokenColorFormat
    $tokenTypes: [ExportableComponentType!]
  ) {
    share(id: $shareIdentifier) {
      identifier
      workspace {
        identifier
      }
      publicTokenExport
      publicTokenExportUrl(
        format: $format
        colorFormat: $colorFormat
        tokenTypes: $tokenTypes
      )
      version(shortId: $versionShortId) {
        identifier
        shortId
        document {
          identifier
          tokenExport(
            format: $format
            colorFormat: $colorFormat
            tokenTypes: $tokenTypes
          ) {
            data
            downloadUrl
          }
        }
      }
    }
  }
`

/**
 * __useGetShareDesignTokenExportQuery__
 *
 * To run a query within a React component, call `useGetShareDesignTokenExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareDesignTokenExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareDesignTokenExportQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *      format: // value for 'format'
 *      colorFormat: // value for 'colorFormat'
 *      tokenTypes: // value for 'tokenTypes'
 *   },
 * });
 */
export function useGetShareDesignTokenExportQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetShareDesignTokenExportQuery,
    Types.GetShareDesignTokenExportQueryVariables
  > &
    (
      | {
          variables: Types.GetShareDesignTokenExportQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareDesignTokenExportQuery,
    Types.GetShareDesignTokenExportQueryVariables
  >(GetShareDesignTokenExportDocument, options)
}
export function useGetShareDesignTokenExportLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareDesignTokenExportQuery,
    Types.GetShareDesignTokenExportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareDesignTokenExportQuery,
    Types.GetShareDesignTokenExportQueryVariables
  >(GetShareDesignTokenExportDocument, options)
}

export type GetShareDesignTokenExportQueryHookResult = ReturnType<
  typeof useGetShareDesignTokenExportQuery
>
export type GetShareDesignTokenExportLazyQueryHookResult = ReturnType<
  typeof useGetShareDesignTokenExportLazyQuery
>
export type GetShareDesignTokenExportQueryResult = Apollo.QueryResult<
  Types.GetShareDesignTokenExportQuery,
  Types.GetShareDesignTokenExportQueryVariables
>
export const GetSharePermissionsDocument = /*#__PURE__*/ gql`
  query getSharePermissions($shareIdentifier: UUID!) {
    share(id: $shareIdentifier) {
      ...SharePermissions
    }
  }
  ${SharePermissionsFragmentDoc}
`

/**
 * __useGetSharePermissionsQuery__
 *
 * To run a query within a React component, call `useGetSharePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharePermissionsQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetSharePermissionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSharePermissionsQuery,
    Types.GetSharePermissionsQueryVariables
  > &
    (
      | { variables: Types.GetSharePermissionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSharePermissionsQuery,
    Types.GetSharePermissionsQueryVariables
  >(GetSharePermissionsDocument, options)
}
export function useGetSharePermissionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSharePermissionsQuery,
    Types.GetSharePermissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSharePermissionsQuery,
    Types.GetSharePermissionsQueryVariables
  >(GetSharePermissionsDocument, options)
}

export type GetSharePermissionsQueryHookResult = ReturnType<
  typeof useGetSharePermissionsQuery
>
export type GetSharePermissionsLazyQueryHookResult = ReturnType<
  typeof useGetSharePermissionsLazyQuery
>
export type GetSharePermissionsQueryResult = Apollo.QueryResult<
  Types.GetSharePermissionsQuery,
  Types.GetSharePermissionsQueryVariables
>
export const GetShareListItemDocument = /*#__PURE__*/ gql`
  query getShareListItem($shareIdentifier: UUID!) {
    share(id: $shareIdentifier) {
      identifier
      ...ShareListItem
    }
  }
  ${ShareListItemFragmentDoc}
`

/**
 * __useGetShareListItemQuery__
 *
 * To run a query within a React component, call `useGetShareListItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareListItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareListItemQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetShareListItemQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetShareListItemQuery,
    Types.GetShareListItemQueryVariables
  > &
    (
      | { variables: Types.GetShareListItemQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareListItemQuery,
    Types.GetShareListItemQueryVariables
  >(GetShareListItemDocument, options)
}
export function useGetShareListItemLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareListItemQuery,
    Types.GetShareListItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareListItemQuery,
    Types.GetShareListItemQueryVariables
  >(GetShareListItemDocument, options)
}

export type GetShareListItemQueryHookResult = ReturnType<
  typeof useGetShareListItemQuery
>
export type GetShareListItemLazyQueryHookResult = ReturnType<
  typeof useGetShareListItemLazyQuery
>
export type GetShareListItemQueryResult = Apollo.QueryResult<
  Types.GetShareListItemQuery,
  Types.GetShareListItemQueryVariables
>
export const GetHasPendingPatchesDocument = /*#__PURE__*/ gql`
  query getHasPendingPatches($shareIdentifier: UUID4!) @capacitorapi {
    collaborativeEditingSession(shareIdentifier: $shareIdentifier) {
      hasPendingPatches
    }
  }
`

/**
 * __useGetHasPendingPatchesQuery__
 *
 * To run a query within a React component, call `useGetHasPendingPatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHasPendingPatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHasPendingPatchesQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetHasPendingPatchesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetHasPendingPatchesQuery,
    Types.GetHasPendingPatchesQueryVariables
  > &
    (
      | { variables: Types.GetHasPendingPatchesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetHasPendingPatchesQuery,
    Types.GetHasPendingPatchesQueryVariables
  >(GetHasPendingPatchesDocument, options)
}
export function useGetHasPendingPatchesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetHasPendingPatchesQuery,
    Types.GetHasPendingPatchesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetHasPendingPatchesQuery,
    Types.GetHasPendingPatchesQueryVariables
  >(GetHasPendingPatchesDocument, options)
}

export type GetHasPendingPatchesQueryHookResult = ReturnType<
  typeof useGetHasPendingPatchesQuery
>
export type GetHasPendingPatchesLazyQueryHookResult = ReturnType<
  typeof useGetHasPendingPatchesLazyQuery
>
export type GetHasPendingPatchesQueryResult = Apollo.QueryResult<
  Types.GetHasPendingPatchesQuery,
  Types.GetHasPendingPatchesQueryVariables
>
export const GetLicenseAgreementDocument = /*#__PURE__*/ gql`
  query getLicenseAgreement($shareIdentifier: UUID!) {
    share(id: $shareIdentifier) {
      identifier
      licenseAgreement {
        body
      }
    }
  }
`

/**
 * __useGetLicenseAgreementQuery__
 *
 * To run a query within a React component, call `useGetLicenseAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLicenseAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLicenseAgreementQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetLicenseAgreementQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetLicenseAgreementQuery,
    Types.GetLicenseAgreementQueryVariables
  > &
    (
      | { variables: Types.GetLicenseAgreementQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetLicenseAgreementQuery,
    Types.GetLicenseAgreementQueryVariables
  >(GetLicenseAgreementDocument, options)
}
export function useGetLicenseAgreementLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetLicenseAgreementQuery,
    Types.GetLicenseAgreementQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetLicenseAgreementQuery,
    Types.GetLicenseAgreementQueryVariables
  >(GetLicenseAgreementDocument, options)
}

export type GetLicenseAgreementQueryHookResult = ReturnType<
  typeof useGetLicenseAgreementQuery
>
export type GetLicenseAgreementLazyQueryHookResult = ReturnType<
  typeof useGetLicenseAgreementLazyQuery
>
export type GetLicenseAgreementQueryResult = Apollo.QueryResult<
  Types.GetLicenseAgreementQuery,
  Types.GetLicenseAgreementQueryVariables
>
export const GetSharesForDocumentSelectionDocument = /*#__PURE__*/ gql`
  query getSharesForDocumentSelection(
    $identifier: UUID!
    $after: String
    $search: SharesSearchParams
    $sortOrder: ShareSortOrder
  ) {
    workspace(identifier: $identifier) {
      identifier
      status
      shares(after: $after, search: $search, sortOrder: $sortOrder) {
        entries {
          ...ShareWithPublication
        }
        meta {
          ...ShareMeta
        }
      }
    }
  }
  ${ShareWithPublicationFragmentDoc}
  ${ShareMetaFragmentDoc}
`

/**
 * __useGetSharesForDocumentSelectionQuery__
 *
 * To run a query within a React component, call `useGetSharesForDocumentSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharesForDocumentSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharesForDocumentSelectionQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetSharesForDocumentSelectionQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSharesForDocumentSelectionQuery,
    Types.GetSharesForDocumentSelectionQueryVariables
  > &
    (
      | {
          variables: Types.GetSharesForDocumentSelectionQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSharesForDocumentSelectionQuery,
    Types.GetSharesForDocumentSelectionQueryVariables
  >(GetSharesForDocumentSelectionDocument, options)
}
export function useGetSharesForDocumentSelectionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSharesForDocumentSelectionQuery,
    Types.GetSharesForDocumentSelectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSharesForDocumentSelectionQuery,
    Types.GetSharesForDocumentSelectionQueryVariables
  >(GetSharesForDocumentSelectionDocument, options)
}

export type GetSharesForDocumentSelectionQueryHookResult = ReturnType<
  typeof useGetSharesForDocumentSelectionQuery
>
export type GetSharesForDocumentSelectionLazyQueryHookResult = ReturnType<
  typeof useGetSharesForDocumentSelectionLazyQuery
>
export type GetSharesForDocumentSelectionQueryResult = Apollo.QueryResult<
  Types.GetSharesForDocumentSelectionQuery,
  Types.GetSharesForDocumentSelectionQueryVariables
>
export const EmptiedWorkspaceTrashDocument = /*#__PURE__*/ gql`
  subscription emptiedWorkspaceTrash {
    emptiedWorkspaceTrash {
      workspaceIdentifier
    }
  }
`

/**
 * __useEmptiedWorkspaceTrashSubscription__
 *
 * To run a query within a React component, call `useEmptiedWorkspaceTrashSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEmptiedWorkspaceTrashSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmptiedWorkspaceTrashSubscription({
 *   variables: {
 *   },
 * });
 */
export function useEmptiedWorkspaceTrashSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.EmptiedWorkspaceTrashSubscription,
    Types.EmptiedWorkspaceTrashSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.EmptiedWorkspaceTrashSubscription,
    Types.EmptiedWorkspaceTrashSubscriptionVariables
  >(EmptiedWorkspaceTrashDocument, options)
}
export type EmptiedWorkspaceTrashSubscriptionHookResult = ReturnType<
  typeof useEmptiedWorkspaceTrashSubscription
>
export type EmptiedWorkspaceTrashSubscriptionResult =
  Apollo.SubscriptionResult<Types.EmptiedWorkspaceTrashSubscription>
export const ShareChangedDocument = /*#__PURE__*/ gql`
  subscription shareChanged {
    shareChanged {
      shareIdentifier
      workspace {
        identifier
      }
      ... on ShareDeletedEvent {
        share {
          ...SubscriptionShare
        }
      }
      ... on ShareRestoredEvent {
        share {
          ...SubscriptionShare
        }
      }
      ... on ShareProjectChangedEvent {
        share {
          ...SubscriptionShare
        }
      }
      ... on ShareUpdatedEvent {
        share {
          ...SubscriptionShare
        }
      }
      ... on ShareTransferredEvent {
        share {
          ...SubscriptionShare
        }
      }
      ... on ShareArchivedEvent {
        share {
          ...SubscriptionShare
        }
      }
    }
  }
  ${SubscriptionShareFragmentDoc}
`

/**
 * __useShareChangedSubscription__
 *
 * To run a query within a React component, call `useShareChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShareChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useShareChangedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.ShareChangedSubscription,
    Types.ShareChangedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.ShareChangedSubscription,
    Types.ShareChangedSubscriptionVariables
  >(ShareChangedDocument, options)
}
export type ShareChangedSubscriptionHookResult = ReturnType<
  typeof useShareChangedSubscription
>
export type ShareChangedSubscriptionResult =
  Apollo.SubscriptionResult<Types.ShareChangedSubscription>
export const ShareMembershipChangedDocument = /*#__PURE__*/ gql`
  subscription shareMembershipChanged {
    shareMembershipChanged {
      shareMembership {
        identifier
        share {
          identifier
          ...ShareUserRelatedFields
        }
      }
    }
  }
  ${ShareUserRelatedFieldsFragmentDoc}
`

/**
 * __useShareMembershipChangedSubscription__
 *
 * To run a query within a React component, call `useShareMembershipChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useShareMembershipChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareMembershipChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useShareMembershipChangedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.ShareMembershipChangedSubscription,
    Types.ShareMembershipChangedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.ShareMembershipChangedSubscription,
    Types.ShareMembershipChangedSubscriptionVariables
  >(ShareMembershipChangedDocument, options)
}
export type ShareMembershipChangedSubscriptionHookResult = ReturnType<
  typeof useShareMembershipChangedSubscription
>
export type ShareMembershipChangedSubscriptionResult =
  Apollo.SubscriptionResult<Types.ShareMembershipChangedSubscription>
export const ShareAcceptRequestDocument = /*#__PURE__*/ gql`
  mutation shareAcceptRequest($id: UUID!) {
    shareAcceptRequest(id: $id) {
      errors {
        ...UserError
      }
      successful
      membership {
        identifier
        share {
          identifier
        }
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type ShareAcceptRequestMutationFn = Apollo.MutationFunction<
  Types.ShareAcceptRequestMutation,
  Types.ShareAcceptRequestMutationVariables
>

/**
 * __useShareAcceptRequestMutation__
 *
 * To run a mutation, you first call `useShareAcceptRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareAcceptRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareAcceptRequestMutation, { data, loading, error }] = useShareAcceptRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShareAcceptRequestMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ShareAcceptRequestMutation,
    Types.ShareAcceptRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ShareAcceptRequestMutation,
    Types.ShareAcceptRequestMutationVariables
  >(ShareAcceptRequestDocument, options)
}
export type ShareAcceptRequestMutationHookResult = ReturnType<
  typeof useShareAcceptRequestMutation
>
export type ShareAcceptRequestMutationResult =
  Apollo.MutationResult<Types.ShareAcceptRequestMutation>
export type ShareAcceptRequestMutationOptions = Apollo.BaseMutationOptions<
  Types.ShareAcceptRequestMutation,
  Types.ShareAcceptRequestMutationVariables
>
export const AcceptShareMembershipInvitationDocument = /*#__PURE__*/ gql`
  mutation acceptShareMembershipInvitation(
    $shareIdentifier: UUID
    $token: String
  ) {
    acceptShareMembershipInvitation(
      shareIdentifier: $shareIdentifier
      token: $token
    ) {
      identifier
      share {
        identifier
        userHasUnacceptedInvitationToView
      }
    }
  }
`
export type AcceptShareMembershipInvitationMutationFn = Apollo.MutationFunction<
  Types.AcceptShareMembershipInvitationMutation,
  Types.AcceptShareMembershipInvitationMutationVariables
>

/**
 * __useAcceptShareMembershipInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptShareMembershipInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptShareMembershipInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptShareMembershipInvitationMutation, { data, loading, error }] = useAcceptShareMembershipInvitationMutation({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAcceptShareMembershipInvitationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AcceptShareMembershipInvitationMutation,
    Types.AcceptShareMembershipInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AcceptShareMembershipInvitationMutation,
    Types.AcceptShareMembershipInvitationMutationVariables
  >(AcceptShareMembershipInvitationDocument, options)
}
export type AcceptShareMembershipInvitationMutationHookResult = ReturnType<
  typeof useAcceptShareMembershipInvitationMutation
>
export type AcceptShareMembershipInvitationMutationResult =
  Apollo.MutationResult<Types.AcceptShareMembershipInvitationMutation>
export type AcceptShareMembershipInvitationMutationOptions =
  Apollo.BaseMutationOptions<
    Types.AcceptShareMembershipInvitationMutation,
    Types.AcceptShareMembershipInvitationMutationVariables
  >
export const ShareDeleteMembershipDocument = /*#__PURE__*/ gql`
  mutation shareDeleteMembership(
    $membershipIdentifier: UUID!
    $confirmed: Boolean
  ) {
    shareDeleteMembership(
      membershipIdentifier: $membershipIdentifier
      confirmed: $confirmed
    ) {
      errors {
        ...UserError
      }
      successful
      membership {
        ...ShareMembershipInfo
        share {
          identifier
          userCanUpdateSettings
        }
      }
    }
  }
  ${UserErrorFragmentDoc}
  ${ShareMembershipInfoFragmentDoc}
`
export type ShareDeleteMembershipMutationFn = Apollo.MutationFunction<
  Types.ShareDeleteMembershipMutation,
  Types.ShareDeleteMembershipMutationVariables
>

/**
 * __useShareDeleteMembershipMutation__
 *
 * To run a mutation, you first call `useShareDeleteMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareDeleteMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareDeleteMembershipMutation, { data, loading, error }] = useShareDeleteMembershipMutation({
 *   variables: {
 *      membershipIdentifier: // value for 'membershipIdentifier'
 *      confirmed: // value for 'confirmed'
 *   },
 * });
 */
export function useShareDeleteMembershipMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ShareDeleteMembershipMutation,
    Types.ShareDeleteMembershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ShareDeleteMembershipMutation,
    Types.ShareDeleteMembershipMutationVariables
  >(ShareDeleteMembershipDocument, options)
}
export type ShareDeleteMembershipMutationHookResult = ReturnType<
  typeof useShareDeleteMembershipMutation
>
export type ShareDeleteMembershipMutationResult =
  Apollo.MutationResult<Types.ShareDeleteMembershipMutation>
export type ShareDeleteMembershipMutationOptions = Apollo.BaseMutationOptions<
  Types.ShareDeleteMembershipMutation,
  Types.ShareDeleteMembershipMutationVariables
>
export const ShareRequestAccessDocument = /*#__PURE__*/ gql`
  mutation shareRequestAccess($shortId: ShortId!) {
    shareRequestAccess(shortId: $shortId) {
      errors {
        ...UserError
      }
      successful
    }
  }
  ${UserErrorFragmentDoc}
`
export type ShareRequestAccessMutationFn = Apollo.MutationFunction<
  Types.ShareRequestAccessMutation,
  Types.ShareRequestAccessMutationVariables
>

/**
 * __useShareRequestAccessMutation__
 *
 * To run a mutation, you first call `useShareRequestAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareRequestAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareRequestAccessMutation, { data, loading, error }] = useShareRequestAccessMutation({
 *   variables: {
 *      shortId: // value for 'shortId'
 *   },
 * });
 */
export function useShareRequestAccessMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ShareRequestAccessMutation,
    Types.ShareRequestAccessMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ShareRequestAccessMutation,
    Types.ShareRequestAccessMutationVariables
  >(ShareRequestAccessDocument, options)
}
export type ShareRequestAccessMutationHookResult = ReturnType<
  typeof useShareRequestAccessMutation
>
export type ShareRequestAccessMutationResult =
  Apollo.MutationResult<Types.ShareRequestAccessMutation>
export type ShareRequestAccessMutationOptions = Apollo.BaseMutationOptions<
  Types.ShareRequestAccessMutation,
  Types.ShareRequestAccessMutationVariables
>
export const AddShareMembershipDocument = /*#__PURE__*/ gql`
  mutation addShareMembership($input: AddShareMembershipParams!) {
    addShareMembership(input: $input) {
      shareMembership {
        ...ShareMembershipInfo
        share {
          identifier
          userCanUpdateSettings
          workspace {
            identifier
          }
        }
      }
    }
  }
  ${ShareMembershipInfoFragmentDoc}
`
export type AddShareMembershipMutationFn = Apollo.MutationFunction<
  Types.AddShareMembershipMutation,
  Types.AddShareMembershipMutationVariables
>

/**
 * __useAddShareMembershipMutation__
 *
 * To run a mutation, you first call `useAddShareMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddShareMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addShareMembershipMutation, { data, loading, error }] = useAddShareMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddShareMembershipMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AddShareMembershipMutation,
    Types.AddShareMembershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AddShareMembershipMutation,
    Types.AddShareMembershipMutationVariables
  >(AddShareMembershipDocument, options)
}
export type AddShareMembershipMutationHookResult = ReturnType<
  typeof useAddShareMembershipMutation
>
export type AddShareMembershipMutationResult =
  Apollo.MutationResult<Types.AddShareMembershipMutation>
export type AddShareMembershipMutationOptions = Apollo.BaseMutationOptions<
  Types.AddShareMembershipMutation,
  Types.AddShareMembershipMutationVariables
>
export const UpdateShareMembershipDocument = /*#__PURE__*/ gql`
  mutation updateShareMembership($input: UpdateShareMembershipParams!) {
    updateShareMembership(input: $input) {
      shareMembership {
        ...ShareMembershipInfo
        share {
          identifier
          userCanUpdateSettings
        }
      }
    }
  }
  ${ShareMembershipInfoFragmentDoc}
`
export type UpdateShareMembershipMutationFn = Apollo.MutationFunction<
  Types.UpdateShareMembershipMutation,
  Types.UpdateShareMembershipMutationVariables
>

/**
 * __useUpdateShareMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateShareMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShareMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShareMembershipMutation, { data, loading, error }] = useUpdateShareMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShareMembershipMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateShareMembershipMutation,
    Types.UpdateShareMembershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateShareMembershipMutation,
    Types.UpdateShareMembershipMutationVariables
  >(UpdateShareMembershipDocument, options)
}
export type UpdateShareMembershipMutationHookResult = ReturnType<
  typeof useUpdateShareMembershipMutation
>
export type UpdateShareMembershipMutationResult =
  Apollo.MutationResult<Types.UpdateShareMembershipMutation>
export type UpdateShareMembershipMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateShareMembershipMutation,
  Types.UpdateShareMembershipMutationVariables
>
export const GetShareMembershipsDocument = /*#__PURE__*/ gql`
  query getShareMemberships(
    $shareIdentifier: UUID!
    $after: String
    $limit: Int = 10
  ) {
    share(id: $shareIdentifier) {
      identifier
      myMembership {
        ...ShareMembershipInfo
      }
      members(limit: $limit, after: $after) {
        entries {
          ... on ShareMembership {
            ...ShareMembershipInfo
          }
          ... on PermissionGroupRelationShare {
            ...ShareGroupMembershipInfo
          }
        }
        meta {
          after
          totalCount
        }
      }
      parentAccessLevel
      workspace {
        avatar {
          small
        }
        name
        identifier
      }
    }
  }
  ${ShareMembershipInfoFragmentDoc}
  ${ShareGroupMembershipInfoFragmentDoc}
`

/**
 * __useGetShareMembershipsQuery__
 *
 * To run a query within a React component, call `useGetShareMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareMembershipsQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetShareMembershipsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetShareMembershipsQuery,
    Types.GetShareMembershipsQueryVariables
  > &
    (
      | { variables: Types.GetShareMembershipsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareMembershipsQuery,
    Types.GetShareMembershipsQueryVariables
  >(GetShareMembershipsDocument, options)
}
export function useGetShareMembershipsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareMembershipsQuery,
    Types.GetShareMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareMembershipsQuery,
    Types.GetShareMembershipsQueryVariables
  >(GetShareMembershipsDocument, options)
}

export type GetShareMembershipsQueryHookResult = ReturnType<
  typeof useGetShareMembershipsQuery
>
export type GetShareMembershipsLazyQueryHookResult = ReturnType<
  typeof useGetShareMembershipsLazyQuery
>
export type GetShareMembershipsQueryResult = Apollo.QueryResult<
  Types.GetShareMembershipsQuery,
  Types.GetShareMembershipsQueryVariables
>
export const GetShareMembershipByShareShortIdDocument = /*#__PURE__*/ gql`
  query getShareMembershipByShareShortId($shareIdentifier: ShortId) {
    share(shortId: $shareIdentifier) {
      identifier
      name
      version(preferredState: PROCESSED) {
        identifier
        shortId
        document {
          identifier
          name
        }
      }
    }
    shareMembership(shareShortId: $shareIdentifier) {
      identifier
      inviteStatus
      inviter {
        name
        avatar {
          large
        }
      }
    }
  }
`

/**
 * __useGetShareMembershipByShareShortIdQuery__
 *
 * To run a query within a React component, call `useGetShareMembershipByShareShortIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareMembershipByShareShortIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareMembershipByShareShortIdQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetShareMembershipByShareShortIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetShareMembershipByShareShortIdQuery,
    Types.GetShareMembershipByShareShortIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareMembershipByShareShortIdQuery,
    Types.GetShareMembershipByShareShortIdQueryVariables
  >(GetShareMembershipByShareShortIdDocument, options)
}
export function useGetShareMembershipByShareShortIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareMembershipByShareShortIdQuery,
    Types.GetShareMembershipByShareShortIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareMembershipByShareShortIdQuery,
    Types.GetShareMembershipByShareShortIdQueryVariables
  >(GetShareMembershipByShareShortIdDocument, options)
}

export type GetShareMembershipByShareShortIdQueryHookResult = ReturnType<
  typeof useGetShareMembershipByShareShortIdQuery
>
export type GetShareMembershipByShareShortIdLazyQueryHookResult = ReturnType<
  typeof useGetShareMembershipByShareShortIdLazyQuery
>
export type GetShareMembershipByShareShortIdQueryResult = Apollo.QueryResult<
  Types.GetShareMembershipByShareShortIdQuery,
  Types.GetShareMembershipByShareShortIdQueryVariables
>
export const GetShareMembershipDocument = /*#__PURE__*/ gql`
  query getShareMembership($token: String) {
    shareMembership(token: $token) {
      identifier
      email
      inviteStatus
      inviter {
        name
        avatar {
          large
        }
      }
    }
  }
`

/**
 * __useGetShareMembershipQuery__
 *
 * To run a query within a React component, call `useGetShareMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareMembershipQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetShareMembershipQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetShareMembershipQuery,
    Types.GetShareMembershipQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareMembershipQuery,
    Types.GetShareMembershipQueryVariables
  >(GetShareMembershipDocument, options)
}
export function useGetShareMembershipLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareMembershipQuery,
    Types.GetShareMembershipQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareMembershipQuery,
    Types.GetShareMembershipQueryVariables
  >(GetShareMembershipDocument, options)
}

export type GetShareMembershipQueryHookResult = ReturnType<
  typeof useGetShareMembershipQuery
>
export type GetShareMembershipLazyQueryHookResult = ReturnType<
  typeof useGetShareMembershipLazyQuery
>
export type GetShareMembershipQueryResult = Apollo.QueryResult<
  Types.GetShareMembershipQuery,
  Types.GetShareMembershipQueryVariables
>
export const GetTrashDocument = /*#__PURE__*/ gql`
  query getTrash(
    $identifier: UUID!
    $after: String
    $search: TrashSearchParams
  ) {
    workspaceTrash(identifier: $identifier, after: $after, search: $search) {
      entries {
        __typename
        ... on TrashedProject {
          ...TrashedProject
        }
        ... on TrashedShare {
          ...TrashedShare
        }
      }
      meta {
        ...ShareMeta
      }
    }
  }
  ${TrashedProjectFragmentDoc}
  ${TrashedShareFragmentDoc}
  ${ShareMetaFragmentDoc}
`

/**
 * __useGetTrashQuery__
 *
 * To run a query within a React component, call `useGetTrashQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrashQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTrashQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetTrashQuery,
    Types.GetTrashQueryVariables
  > &
    (
      | { variables: Types.GetTrashQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetTrashQuery,
    Types.GetTrashQueryVariables
  >(GetTrashDocument, options)
}
export function useGetTrashLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetTrashQuery,
    Types.GetTrashQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetTrashQuery,
    Types.GetTrashQueryVariables
  >(GetTrashDocument, options)
}

export type GetTrashQueryHookResult = ReturnType<typeof useGetTrashQuery>
export type GetTrashLazyQueryHookResult = ReturnType<
  typeof useGetTrashLazyQuery
>
export type GetTrashQueryResult = Apollo.QueryResult<
  Types.GetTrashQuery,
  Types.GetTrashQueryVariables
>
export const UpdateWorkspaceCustomerSsoShortNameDocument = /*#__PURE__*/ gql`
  mutation updateWorkspaceCustomerSsoShortName(
    $customerId: UUID!
    $shortName: String!
  ) {
    updateWorkspaceCustomerSsoShortName(
      customerIdentifier: $customerId
      shortName: $shortName
    ) {
      customer {
        identifier
        ssoShortName
      }
    }
  }
`
export type UpdateWorkspaceCustomerSsoShortNameMutationFn =
  Apollo.MutationFunction<
    Types.UpdateWorkspaceCustomerSsoShortNameMutation,
    Types.UpdateWorkspaceCustomerSsoShortNameMutationVariables
  >

/**
 * __useUpdateWorkspaceCustomerSsoShortNameMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceCustomerSsoShortNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceCustomerSsoShortNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceCustomerSsoShortNameMutation, { data, loading, error }] = useUpdateWorkspaceCustomerSsoShortNameMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      shortName: // value for 'shortName'
 *   },
 * });
 */
export function useUpdateWorkspaceCustomerSsoShortNameMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateWorkspaceCustomerSsoShortNameMutation,
    Types.UpdateWorkspaceCustomerSsoShortNameMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateWorkspaceCustomerSsoShortNameMutation,
    Types.UpdateWorkspaceCustomerSsoShortNameMutationVariables
  >(UpdateWorkspaceCustomerSsoShortNameDocument, options)
}
export type UpdateWorkspaceCustomerSsoShortNameMutationHookResult = ReturnType<
  typeof useUpdateWorkspaceCustomerSsoShortNameMutation
>
export type UpdateWorkspaceCustomerSsoShortNameMutationResult =
  Apollo.MutationResult<Types.UpdateWorkspaceCustomerSsoShortNameMutation>
export type UpdateWorkspaceCustomerSsoShortNameMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateWorkspaceCustomerSsoShortNameMutation,
    Types.UpdateWorkspaceCustomerSsoShortNameMutationVariables
  >
export const UpdateWorkspaceCustomerSsoIdentityProviderConfigDocument = /*#__PURE__*/ gql`
  mutation updateWorkspaceCustomerSsoIdentityProviderConfig(
    $config: UpdateWorkspaceCustomerSsoIdentityProviderConfigParams
    $customerId: UUID!
    $metadata: Upload
  ) {
    updateWorkspaceCustomerSsoIdentityProviderConfig(
      config: $config
      customerIdentifier: $customerId
      metadata: $metadata
    ) {
      customer {
        identifier
        ssoEnabled
        ssoConfig {
          ...WorkspaceSsoConfig
        }
      }
    }
  }
  ${WorkspaceSsoConfigFragmentDoc}
`
export type UpdateWorkspaceCustomerSsoIdentityProviderConfigMutationFn =
  Apollo.MutationFunction<
    Types.UpdateWorkspaceCustomerSsoIdentityProviderConfigMutation,
    Types.UpdateWorkspaceCustomerSsoIdentityProviderConfigMutationVariables
  >

/**
 * __useUpdateWorkspaceCustomerSsoIdentityProviderConfigMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceCustomerSsoIdentityProviderConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceCustomerSsoIdentityProviderConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceCustomerSsoIdentityProviderConfigMutation, { data, loading, error }] = useUpdateWorkspaceCustomerSsoIdentityProviderConfigMutation({
 *   variables: {
 *      config: // value for 'config'
 *      customerId: // value for 'customerId'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useUpdateWorkspaceCustomerSsoIdentityProviderConfigMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateWorkspaceCustomerSsoIdentityProviderConfigMutation,
    Types.UpdateWorkspaceCustomerSsoIdentityProviderConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateWorkspaceCustomerSsoIdentityProviderConfigMutation,
    Types.UpdateWorkspaceCustomerSsoIdentityProviderConfigMutationVariables
  >(UpdateWorkspaceCustomerSsoIdentityProviderConfigDocument, options)
}
export type UpdateWorkspaceCustomerSsoIdentityProviderConfigMutationHookResult =
  ReturnType<typeof useUpdateWorkspaceCustomerSsoIdentityProviderConfigMutation>
export type UpdateWorkspaceCustomerSsoIdentityProviderConfigMutationResult =
  Apollo.MutationResult<Types.UpdateWorkspaceCustomerSsoIdentityProviderConfigMutation>
export type UpdateWorkspaceCustomerSsoIdentityProviderConfigMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateWorkspaceCustomerSsoIdentityProviderConfigMutation,
    Types.UpdateWorkspaceCustomerSsoIdentityProviderConfigMutationVariables
  >
export const UpdateWorkspaceCustomerSsoAttributeMappingDocument = /*#__PURE__*/ gql`
  mutation updateWorkspaceCustomerSsoAttributeMapping(
    $customerIdentifier: UUID!
    $mappings: UpdateWorkspaceCustomerSsoAttributeMappingParams!
  ) {
    updateWorkspaceCustomerSsoAttributeMapping(
      customerIdentifier: $customerIdentifier
      mappings: $mappings
    ) {
      customer {
        identifier
        ssoConfig {
          ...WorkspaceSsoConfig
        }
      }
    }
  }
  ${WorkspaceSsoConfigFragmentDoc}
`
export type UpdateWorkspaceCustomerSsoAttributeMappingMutationFn =
  Apollo.MutationFunction<
    Types.UpdateWorkspaceCustomerSsoAttributeMappingMutation,
    Types.UpdateWorkspaceCustomerSsoAttributeMappingMutationVariables
  >

/**
 * __useUpdateWorkspaceCustomerSsoAttributeMappingMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceCustomerSsoAttributeMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceCustomerSsoAttributeMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceCustomerSsoAttributeMappingMutation, { data, loading, error }] = useUpdateWorkspaceCustomerSsoAttributeMappingMutation({
 *   variables: {
 *      customerIdentifier: // value for 'customerIdentifier'
 *      mappings: // value for 'mappings'
 *   },
 * });
 */
export function useUpdateWorkspaceCustomerSsoAttributeMappingMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateWorkspaceCustomerSsoAttributeMappingMutation,
    Types.UpdateWorkspaceCustomerSsoAttributeMappingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateWorkspaceCustomerSsoAttributeMappingMutation,
    Types.UpdateWorkspaceCustomerSsoAttributeMappingMutationVariables
  >(UpdateWorkspaceCustomerSsoAttributeMappingDocument, options)
}
export type UpdateWorkspaceCustomerSsoAttributeMappingMutationHookResult =
  ReturnType<typeof useUpdateWorkspaceCustomerSsoAttributeMappingMutation>
export type UpdateWorkspaceCustomerSsoAttributeMappingMutationResult =
  Apollo.MutationResult<Types.UpdateWorkspaceCustomerSsoAttributeMappingMutation>
export type UpdateWorkspaceCustomerSsoAttributeMappingMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateWorkspaceCustomerSsoAttributeMappingMutation,
    Types.UpdateWorkspaceCustomerSsoAttributeMappingMutationVariables
  >
export const LinkRegularAccountDocument = /*#__PURE__*/ gql`
  mutation linkRegularAccount($email: Email!, $password: String!) {
    linkRegularAccount(email: $email, password: $password) {
      user {
        email
      }
    }
  }
`
export type LinkRegularAccountMutationFn = Apollo.MutationFunction<
  Types.LinkRegularAccountMutation,
  Types.LinkRegularAccountMutationVariables
>

/**
 * __useLinkRegularAccountMutation__
 *
 * To run a mutation, you first call `useLinkRegularAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkRegularAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkRegularAccountMutation, { data, loading, error }] = useLinkRegularAccountMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLinkRegularAccountMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.LinkRegularAccountMutation,
    Types.LinkRegularAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.LinkRegularAccountMutation,
    Types.LinkRegularAccountMutationVariables
  >(LinkRegularAccountDocument, options)
}
export type LinkRegularAccountMutationHookResult = ReturnType<
  typeof useLinkRegularAccountMutation
>
export type LinkRegularAccountMutationResult =
  Apollo.MutationResult<Types.LinkRegularAccountMutation>
export type LinkRegularAccountMutationOptions = Apollo.BaseMutationOptions<
  Types.LinkRegularAccountMutation,
  Types.LinkRegularAccountMutationVariables
>
export const LinkRegularAccountWithMfaDocument = /*#__PURE__*/ gql`
  mutation linkRegularAccountWithMfa(
    $mfa_token: String!
    $totp: String
    $recovery_code: String
  ) {
    linkRegularAccountWithMfa(
      mfaToken: $mfa_token
      totp: $totp
      recoveryCode: $recovery_code
    ) {
      user {
        identifier
      }
    }
  }
`
export type LinkRegularAccountWithMfaMutationFn = Apollo.MutationFunction<
  Types.LinkRegularAccountWithMfaMutation,
  Types.LinkRegularAccountWithMfaMutationVariables
>

/**
 * __useLinkRegularAccountWithMfaMutation__
 *
 * To run a mutation, you first call `useLinkRegularAccountWithMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkRegularAccountWithMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkRegularAccountWithMfaMutation, { data, loading, error }] = useLinkRegularAccountWithMfaMutation({
 *   variables: {
 *      mfa_token: // value for 'mfa_token'
 *      totp: // value for 'totp'
 *      recovery_code: // value for 'recovery_code'
 *   },
 * });
 */
export function useLinkRegularAccountWithMfaMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.LinkRegularAccountWithMfaMutation,
    Types.LinkRegularAccountWithMfaMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.LinkRegularAccountWithMfaMutation,
    Types.LinkRegularAccountWithMfaMutationVariables
  >(LinkRegularAccountWithMfaDocument, options)
}
export type LinkRegularAccountWithMfaMutationHookResult = ReturnType<
  typeof useLinkRegularAccountWithMfaMutation
>
export type LinkRegularAccountWithMfaMutationResult =
  Apollo.MutationResult<Types.LinkRegularAccountWithMfaMutation>
export type LinkRegularAccountWithMfaMutationOptions =
  Apollo.BaseMutationOptions<
    Types.LinkRegularAccountWithMfaMutation,
    Types.LinkRegularAccountWithMfaMutationVariables
  >
export const GetPublicWorkspaceForAccountLinkingDocument = /*#__PURE__*/ gql`
  query getPublicWorkspaceForAccountLinking($workspaceId: UUID!) {
    publicWorkspace(identifier: $workspaceId) {
      ...PublicWorkspaceMinimalWithFeatureFlags
    }
    me {
      identifier
      personalWorkspace {
        ...WorkspaceMinimalIdentity
      }
      workspaces {
        ...WorkspaceMinimalIdentity
      }
      ssoLinkToken(team: $workspaceId)
    }
  }
  ${PublicWorkspaceMinimalWithFeatureFlagsFragmentDoc}
  ${WorkspaceMinimalIdentityFragmentDoc}
`

/**
 * __useGetPublicWorkspaceForAccountLinkingQuery__
 *
 * To run a query within a React component, call `useGetPublicWorkspaceForAccountLinkingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicWorkspaceForAccountLinkingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicWorkspaceForAccountLinkingQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetPublicWorkspaceForAccountLinkingQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPublicWorkspaceForAccountLinkingQuery,
    Types.GetPublicWorkspaceForAccountLinkingQueryVariables
  > &
    (
      | {
          variables: Types.GetPublicWorkspaceForAccountLinkingQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPublicWorkspaceForAccountLinkingQuery,
    Types.GetPublicWorkspaceForAccountLinkingQueryVariables
  >(GetPublicWorkspaceForAccountLinkingDocument, options)
}
export function useGetPublicWorkspaceForAccountLinkingLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPublicWorkspaceForAccountLinkingQuery,
    Types.GetPublicWorkspaceForAccountLinkingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPublicWorkspaceForAccountLinkingQuery,
    Types.GetPublicWorkspaceForAccountLinkingQueryVariables
  >(GetPublicWorkspaceForAccountLinkingDocument, options)
}

export type GetPublicWorkspaceForAccountLinkingQueryHookResult = ReturnType<
  typeof useGetPublicWorkspaceForAccountLinkingQuery
>
export type GetPublicWorkspaceForAccountLinkingLazyQueryHookResult = ReturnType<
  typeof useGetPublicWorkspaceForAccountLinkingLazyQuery
>
export type GetPublicWorkspaceForAccountLinkingQueryResult = Apollo.QueryResult<
  Types.GetPublicWorkspaceForAccountLinkingQuery,
  Types.GetPublicWorkspaceForAccountLinkingQueryVariables
>
export const DisableScimDocument = /*#__PURE__*/ gql`
  mutation disableScim($identifier: UUID!) {
    disableScim(identifier: $identifier) {
      workspace {
        identifier
        scimEnabled
        scimEndpoint
      }
    }
  }
`
export type DisableScimMutationFn = Apollo.MutationFunction<
  Types.DisableScimMutation,
  Types.DisableScimMutationVariables
>

/**
 * __useDisableScimMutation__
 *
 * To run a mutation, you first call `useDisableScimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableScimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableScimMutation, { data, loading, error }] = useDisableScimMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useDisableScimMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DisableScimMutation,
    Types.DisableScimMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DisableScimMutation,
    Types.DisableScimMutationVariables
  >(DisableScimDocument, options)
}
export type DisableScimMutationHookResult = ReturnType<
  typeof useDisableScimMutation
>
export type DisableScimMutationResult =
  Apollo.MutationResult<Types.DisableScimMutation>
export type DisableScimMutationOptions = Apollo.BaseMutationOptions<
  Types.DisableScimMutation,
  Types.DisableScimMutationVariables
>
export const EnableScimDocument = /*#__PURE__*/ gql`
  mutation enableScim($identifier: UUID!) {
    enableScim(identifier: $identifier) {
      workspace {
        identifier
        scimEnabled
        scimEndpoint
      }
      scimToken
    }
  }
`
export type EnableScimMutationFn = Apollo.MutationFunction<
  Types.EnableScimMutation,
  Types.EnableScimMutationVariables
>

/**
 * __useEnableScimMutation__
 *
 * To run a mutation, you first call `useEnableScimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableScimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableScimMutation, { data, loading, error }] = useEnableScimMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useEnableScimMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.EnableScimMutation,
    Types.EnableScimMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.EnableScimMutation,
    Types.EnableScimMutationVariables
  >(EnableScimDocument, options)
}
export type EnableScimMutationHookResult = ReturnType<
  typeof useEnableScimMutation
>
export type EnableScimMutationResult =
  Apollo.MutationResult<Types.EnableScimMutation>
export type EnableScimMutationOptions = Apollo.BaseMutationOptions<
  Types.EnableScimMutation,
  Types.EnableScimMutationVariables
>
export const ResetScimTokenDocument = /*#__PURE__*/ gql`
  mutation resetScimToken($identifier: UUID!) {
    resetScimToken(identifier: $identifier) {
      scimToken
    }
  }
`
export type ResetScimTokenMutationFn = Apollo.MutationFunction<
  Types.ResetScimTokenMutation,
  Types.ResetScimTokenMutationVariables
>

/**
 * __useResetScimTokenMutation__
 *
 * To run a mutation, you first call `useResetScimTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetScimTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetScimTokenMutation, { data, loading, error }] = useResetScimTokenMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useResetScimTokenMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ResetScimTokenMutation,
    Types.ResetScimTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ResetScimTokenMutation,
    Types.ResetScimTokenMutationVariables
  >(ResetScimTokenDocument, options)
}
export type ResetScimTokenMutationHookResult = ReturnType<
  typeof useResetScimTokenMutation
>
export type ResetScimTokenMutationResult =
  Apollo.MutationResult<Types.ResetScimTokenMutation>
export type ResetScimTokenMutationOptions = Apollo.BaseMutationOptions<
  Types.ResetScimTokenMutation,
  Types.ResetScimTokenMutationVariables
>
export const GetSsoStartUrlDocument = /*#__PURE__*/ gql`
  query getSsoStartUrl($teamName: String!) {
    ssoStartUrl(teamName: $teamName) {
      successful
      errors {
        ...UserError
      }
      url
    }
  }
  ${UserErrorFragmentDoc}
`

/**
 * __useGetSsoStartUrlQuery__
 *
 * To run a query within a React component, call `useGetSsoStartUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSsoStartUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSsoStartUrlQuery({
 *   variables: {
 *      teamName: // value for 'teamName'
 *   },
 * });
 */
export function useGetSsoStartUrlQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSsoStartUrlQuery,
    Types.GetSsoStartUrlQueryVariables
  > &
    (
      | { variables: Types.GetSsoStartUrlQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSsoStartUrlQuery,
    Types.GetSsoStartUrlQueryVariables
  >(GetSsoStartUrlDocument, options)
}
export function useGetSsoStartUrlLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSsoStartUrlQuery,
    Types.GetSsoStartUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSsoStartUrlQuery,
    Types.GetSsoStartUrlQueryVariables
  >(GetSsoStartUrlDocument, options)
}

export type GetSsoStartUrlQueryHookResult = ReturnType<
  typeof useGetSsoStartUrlQuery
>
export type GetSsoStartUrlLazyQueryHookResult = ReturnType<
  typeof useGetSsoStartUrlLazyQuery
>
export type GetSsoStartUrlQueryResult = Apollo.QueryResult<
  Types.GetSsoStartUrlQuery,
  Types.GetSsoStartUrlQueryVariables
>
export const TransferStorageItemDocument = /*#__PURE__*/ gql`
  mutation transferStorageItem(
    $identifier: UUID!
    $parentProjectId: UUID
    $workspaceId: UUID
    $type: StorageItemType!
  ) {
    transferStorageItem(
      identifier: $identifier
      parentProjectIdentifier: $parentProjectId
      workspaceIdentifier: $workspaceId
      type: $type
    ) {
      storageItem {
        ...StorageItemDetails
      }
    }
  }
  ${StorageItemDetailsFragmentDoc}
`
export type TransferStorageItemMutationFn = Apollo.MutationFunction<
  Types.TransferStorageItemMutation,
  Types.TransferStorageItemMutationVariables
>

/**
 * __useTransferStorageItemMutation__
 *
 * To run a mutation, you first call `useTransferStorageItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferStorageItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferStorageItemMutation, { data, loading, error }] = useTransferStorageItemMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      parentProjectId: // value for 'parentProjectId'
 *      workspaceId: // value for 'workspaceId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useTransferStorageItemMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.TransferStorageItemMutation,
    Types.TransferStorageItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.TransferStorageItemMutation,
    Types.TransferStorageItemMutationVariables
  >(TransferStorageItemDocument, options)
}
export type TransferStorageItemMutationHookResult = ReturnType<
  typeof useTransferStorageItemMutation
>
export type TransferStorageItemMutationResult =
  Apollo.MutationResult<Types.TransferStorageItemMutation>
export type TransferStorageItemMutationOptions = Apollo.BaseMutationOptions<
  Types.TransferStorageItemMutation,
  Types.TransferStorageItemMutationVariables
>
export const TransferStorageItemsDocument = /*#__PURE__*/ gql`
  mutation transferStorageItems(
    $storageItems: [MinimalStorageItem!]!
    $parentProjectIdentifier: UUID
    $workspaceIdentifier: UUID
  ) {
    transferStorageItems(
      parentProjectIdentifier: $parentProjectIdentifier
      workspaceIdentifier: $workspaceIdentifier
      storageItems: $storageItems
    ) {
      storageItems {
        ...StorageItemDetails
      }
    }
  }
  ${StorageItemDetailsFragmentDoc}
`
export type TransferStorageItemsMutationFn = Apollo.MutationFunction<
  Types.TransferStorageItemsMutation,
  Types.TransferStorageItemsMutationVariables
>

/**
 * __useTransferStorageItemsMutation__
 *
 * To run a mutation, you first call `useTransferStorageItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferStorageItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferStorageItemsMutation, { data, loading, error }] = useTransferStorageItemsMutation({
 *   variables: {
 *      storageItems: // value for 'storageItems'
 *      parentProjectIdentifier: // value for 'parentProjectIdentifier'
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *   },
 * });
 */
export function useTransferStorageItemsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.TransferStorageItemsMutation,
    Types.TransferStorageItemsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.TransferStorageItemsMutation,
    Types.TransferStorageItemsMutationVariables
  >(TransferStorageItemsDocument, options)
}
export type TransferStorageItemsMutationHookResult = ReturnType<
  typeof useTransferStorageItemsMutation
>
export type TransferStorageItemsMutationResult =
  Apollo.MutationResult<Types.TransferStorageItemsMutation>
export type TransferStorageItemsMutationOptions = Apollo.BaseMutationOptions<
  Types.TransferStorageItemsMutation,
  Types.TransferStorageItemsMutationVariables
>
export const ArchiveStorageItemsDocument = /*#__PURE__*/ gql`
  mutation archiveStorageItems($storageItems: [MinimalStorageItem!]!) {
    archiveStorageItems(storageItems: $storageItems) {
      storageItems {
        ...StorageItemDetails
      }
    }
  }
  ${StorageItemDetailsFragmentDoc}
`
export type ArchiveStorageItemsMutationFn = Apollo.MutationFunction<
  Types.ArchiveStorageItemsMutation,
  Types.ArchiveStorageItemsMutationVariables
>

/**
 * __useArchiveStorageItemsMutation__
 *
 * To run a mutation, you first call `useArchiveStorageItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveStorageItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveStorageItemsMutation, { data, loading, error }] = useArchiveStorageItemsMutation({
 *   variables: {
 *      storageItems: // value for 'storageItems'
 *   },
 * });
 */
export function useArchiveStorageItemsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ArchiveStorageItemsMutation,
    Types.ArchiveStorageItemsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ArchiveStorageItemsMutation,
    Types.ArchiveStorageItemsMutationVariables
  >(ArchiveStorageItemsDocument, options)
}
export type ArchiveStorageItemsMutationHookResult = ReturnType<
  typeof useArchiveStorageItemsMutation
>
export type ArchiveStorageItemsMutationResult =
  Apollo.MutationResult<Types.ArchiveStorageItemsMutation>
export type ArchiveStorageItemsMutationOptions = Apollo.BaseMutationOptions<
  Types.ArchiveStorageItemsMutation,
  Types.ArchiveStorageItemsMutationVariables
>
export const DeleteStorageItemsDocument = /*#__PURE__*/ gql`
  mutation deleteStorageItems($storageItems: [MinimalStorageItem!]!) {
    deleteStorageItems(storageItems: $storageItems) {
      storageItems {
        ...StorageItemDetails
      }
    }
  }
  ${StorageItemDetailsFragmentDoc}
`
export type DeleteStorageItemsMutationFn = Apollo.MutationFunction<
  Types.DeleteStorageItemsMutation,
  Types.DeleteStorageItemsMutationVariables
>

/**
 * __useDeleteStorageItemsMutation__
 *
 * To run a mutation, you first call `useDeleteStorageItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStorageItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStorageItemsMutation, { data, loading, error }] = useDeleteStorageItemsMutation({
 *   variables: {
 *      storageItems: // value for 'storageItems'
 *   },
 * });
 */
export function useDeleteStorageItemsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeleteStorageItemsMutation,
    Types.DeleteStorageItemsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeleteStorageItemsMutation,
    Types.DeleteStorageItemsMutationVariables
  >(DeleteStorageItemsDocument, options)
}
export type DeleteStorageItemsMutationHookResult = ReturnType<
  typeof useDeleteStorageItemsMutation
>
export type DeleteStorageItemsMutationResult =
  Apollo.MutationResult<Types.DeleteStorageItemsMutation>
export type DeleteStorageItemsMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteStorageItemsMutation,
  Types.DeleteStorageItemsMutationVariables
>
export const GetStorageItemsDocument = /*#__PURE__*/ gql`
  query getStorageItems(
    $projectIdentifier: UUID!
    $after: String
    $limit: Int
    $search: String
    $types: [StorageItemType!]
    $filters: [StorageItemFilterType!]
    $includeAllNestedLevels: Boolean!
    $sharesSortOrder: ShareSortOrder
  ) {
    project(identifier: $projectIdentifier) {
      ...ProjectListCounts
      storageItems(
        after: $after
        limit: $limit
        includeAllNestedLevels: $includeAllNestedLevels
        search: { name: $search, filters: $filters, types: $types }
        sharesSortOrder: $sharesSortOrder
      ) {
        entries {
          ...StorageItem
        }
        meta {
          ...StorageItemsPaginationMeta
        }
      }
    }
  }
  ${ProjectListCountsFragmentDoc}
  ${StorageItemFragmentDoc}
  ${StorageItemsPaginationMetaFragmentDoc}
`

/**
 * __useGetStorageItemsQuery__
 *
 * To run a query within a React component, call `useGetStorageItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStorageItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStorageItemsQuery({
 *   variables: {
 *      projectIdentifier: // value for 'projectIdentifier'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      types: // value for 'types'
 *      filters: // value for 'filters'
 *      includeAllNestedLevels: // value for 'includeAllNestedLevels'
 *      sharesSortOrder: // value for 'sharesSortOrder'
 *   },
 * });
 */
export function useGetStorageItemsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetStorageItemsQuery,
    Types.GetStorageItemsQueryVariables
  > &
    (
      | { variables: Types.GetStorageItemsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetStorageItemsQuery,
    Types.GetStorageItemsQueryVariables
  >(GetStorageItemsDocument, options)
}
export function useGetStorageItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetStorageItemsQuery,
    Types.GetStorageItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetStorageItemsQuery,
    Types.GetStorageItemsQueryVariables
  >(GetStorageItemsDocument, options)
}

export type GetStorageItemsQueryHookResult = ReturnType<
  typeof useGetStorageItemsQuery
>
export type GetStorageItemsLazyQueryHookResult = ReturnType<
  typeof useGetStorageItemsLazyQuery
>
export type GetStorageItemsQueryResult = Apollo.QueryResult<
  Types.GetStorageItemsQuery,
  Types.GetStorageItemsQueryVariables
>
export const GetStashedStorageItemsDocument = /*#__PURE__*/ gql`
  query getStashedStorageItems(
    $workspaceId: UUID!
    $source: StorageItemSource!
    $after: String
    $limit: Int
    $search: String
    $filters: [StorageItemFilterType!]
    $includeAllNestedLevels: Boolean!
    $types: [StorageItemType!]
  ) {
    workspace(identifier: $workspaceId) {
      identifier
      storageItems(
        source: $source
        after: $after
        limit: $limit
        includeAllNestedLevels: $includeAllNestedLevels
        search: { name: $search, filters: $filters, types: $types }
      ) {
        entries {
          ...StorageItem
        }
        meta {
          ...StorageItemsPaginationMeta
        }
      }
    }
  }
  ${StorageItemFragmentDoc}
  ${StorageItemsPaginationMetaFragmentDoc}
`

/**
 * __useGetStashedStorageItemsQuery__
 *
 * To run a query within a React component, call `useGetStashedStorageItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStashedStorageItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStashedStorageItemsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      source: // value for 'source'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      includeAllNestedLevels: // value for 'includeAllNestedLevels'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGetStashedStorageItemsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetStashedStorageItemsQuery,
    Types.GetStashedStorageItemsQueryVariables
  > &
    (
      | {
          variables: Types.GetStashedStorageItemsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetStashedStorageItemsQuery,
    Types.GetStashedStorageItemsQueryVariables
  >(GetStashedStorageItemsDocument, options)
}
export function useGetStashedStorageItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetStashedStorageItemsQuery,
    Types.GetStashedStorageItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetStashedStorageItemsQuery,
    Types.GetStashedStorageItemsQueryVariables
  >(GetStashedStorageItemsDocument, options)
}

export type GetStashedStorageItemsQueryHookResult = ReturnType<
  typeof useGetStashedStorageItemsQuery
>
export type GetStashedStorageItemsLazyQueryHookResult = ReturnType<
  typeof useGetStashedStorageItemsLazyQuery
>
export type GetStashedStorageItemsQueryResult = Apollo.QueryResult<
  Types.GetStashedStorageItemsQuery,
  Types.GetStashedStorageItemsQueryVariables
>
export const NotificationMarkAllAsReadDocument = /*#__PURE__*/ gql`
  mutation notificationMarkAllAsRead {
    notificationMarkAllAsRead {
      successful
      errors {
        ...UserError
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type NotificationMarkAllAsReadMutationFn = Apollo.MutationFunction<
  Types.NotificationMarkAllAsReadMutation,
  Types.NotificationMarkAllAsReadMutationVariables
>

/**
 * __useNotificationMarkAllAsReadMutation__
 *
 * To run a mutation, you first call `useNotificationMarkAllAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationMarkAllAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationMarkAllAsReadMutation, { data, loading, error }] = useNotificationMarkAllAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useNotificationMarkAllAsReadMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.NotificationMarkAllAsReadMutation,
    Types.NotificationMarkAllAsReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.NotificationMarkAllAsReadMutation,
    Types.NotificationMarkAllAsReadMutationVariables
  >(NotificationMarkAllAsReadDocument, options)
}
export type NotificationMarkAllAsReadMutationHookResult = ReturnType<
  typeof useNotificationMarkAllAsReadMutation
>
export type NotificationMarkAllAsReadMutationResult =
  Apollo.MutationResult<Types.NotificationMarkAllAsReadMutation>
export type NotificationMarkAllAsReadMutationOptions =
  Apollo.BaseMutationOptions<
    Types.NotificationMarkAllAsReadMutation,
    Types.NotificationMarkAllAsReadMutationVariables
  >
export const NotificationMarkAsReadDocument = /*#__PURE__*/ gql`
  mutation notificationMarkAsRead($identifier: UUID!) {
    notificationMarkAsRead(identifier: $identifier) {
      successful
      notification {
        identifier
        state
      }
      errors {
        ...UserError
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type NotificationMarkAsReadMutationFn = Apollo.MutationFunction<
  Types.NotificationMarkAsReadMutation,
  Types.NotificationMarkAsReadMutationVariables
>

/**
 * __useNotificationMarkAsReadMutation__
 *
 * To run a mutation, you first call `useNotificationMarkAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationMarkAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationMarkAsReadMutation, { data, loading, error }] = useNotificationMarkAsReadMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useNotificationMarkAsReadMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.NotificationMarkAsReadMutation,
    Types.NotificationMarkAsReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.NotificationMarkAsReadMutation,
    Types.NotificationMarkAsReadMutationVariables
  >(NotificationMarkAsReadDocument, options)
}
export type NotificationMarkAsReadMutationHookResult = ReturnType<
  typeof useNotificationMarkAsReadMutation
>
export type NotificationMarkAsReadMutationResult =
  Apollo.MutationResult<Types.NotificationMarkAsReadMutation>
export type NotificationMarkAsReadMutationOptions = Apollo.BaseMutationOptions<
  Types.NotificationMarkAsReadMutation,
  Types.NotificationMarkAsReadMutationVariables
>
export const UpdateNotificationDocument = /*#__PURE__*/ gql`
  mutation updateNotification($identifier: UUID!, $input: NotificationInput!) {
    updateNotification(identifier: $identifier, input: $input) {
      successful
      notification {
        identifier
        isPinned
        state
      }
      errors {
        ...UserError
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type UpdateNotificationMutationFn = Apollo.MutationFunction<
  Types.UpdateNotificationMutation,
  Types.UpdateNotificationMutationVariables
>

/**
 * __useUpdateNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationMutation, { data, loading, error }] = useUpdateNotificationMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateNotificationMutation,
    Types.UpdateNotificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateNotificationMutation,
    Types.UpdateNotificationMutationVariables
  >(UpdateNotificationDocument, options)
}
export type UpdateNotificationMutationHookResult = ReturnType<
  typeof useUpdateNotificationMutation
>
export type UpdateNotificationMutationResult =
  Apollo.MutationResult<Types.UpdateNotificationMutation>
export type UpdateNotificationMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateNotificationMutation,
  Types.UpdateNotificationMutationVariables
>
export const GetNotificationsDocument = /*#__PURE__*/ gql`
  query getNotifications(
    $after: String
    $filter: UserNotificationFilterType
    $sortOrder: NotificationSortOrder
  ) {
    me {
      identifier
      ...NotificationStatus
      notifications(after: $after, filter: $filter, sortOrder: $sortOrder) {
        entries {
          ...NotificationListInfo
        }
        meta {
          after
        }
      }
    }
  }
  ${NotificationStatusFragmentDoc}
  ${NotificationListInfoFragmentDoc}
`

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetNotificationsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetNotificationsQuery,
    Types.GetNotificationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetNotificationsQuery,
    Types.GetNotificationsQueryVariables
  >(GetNotificationsDocument, options)
}
export function useGetNotificationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetNotificationsQuery,
    Types.GetNotificationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetNotificationsQuery,
    Types.GetNotificationsQueryVariables
  >(GetNotificationsDocument, options)
}

export type GetNotificationsQueryHookResult = ReturnType<
  typeof useGetNotificationsQuery
>
export type GetNotificationsLazyQueryHookResult = ReturnType<
  typeof useGetNotificationsLazyQuery
>
export type GetNotificationsQueryResult = Apollo.QueryResult<
  Types.GetNotificationsQuery,
  Types.GetNotificationsQueryVariables
>
export const GetUpdatesNotificationsDocument = /*#__PURE__*/ gql`
  query getUpdatesNotifications(
    $after: String
    $filter: UserNotificationFilterType
    $sortOrder: NotificationSortOrder
  ) {
    me {
      identifier
      ...NotificationStatus
      notifications(after: $after, filter: $filter, sortOrder: $sortOrder) {
        entries {
          ...NotificationInfo
        }
        meta {
          after
        }
      }
    }
  }
  ${NotificationStatusFragmentDoc}
  ${NotificationInfoFragmentDoc}
`

/**
 * __useGetUpdatesNotificationsQuery__
 *
 * To run a query within a React component, call `useGetUpdatesNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpdatesNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpdatesNotificationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetUpdatesNotificationsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetUpdatesNotificationsQuery,
    Types.GetUpdatesNotificationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetUpdatesNotificationsQuery,
    Types.GetUpdatesNotificationsQueryVariables
  >(GetUpdatesNotificationsDocument, options)
}
export function useGetUpdatesNotificationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetUpdatesNotificationsQuery,
    Types.GetUpdatesNotificationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetUpdatesNotificationsQuery,
    Types.GetUpdatesNotificationsQueryVariables
  >(GetUpdatesNotificationsDocument, options)
}

export type GetUpdatesNotificationsQueryHookResult = ReturnType<
  typeof useGetUpdatesNotificationsQuery
>
export type GetUpdatesNotificationsLazyQueryHookResult = ReturnType<
  typeof useGetUpdatesNotificationsLazyQuery
>
export type GetUpdatesNotificationsQueryResult = Apollo.QueryResult<
  Types.GetUpdatesNotificationsQuery,
  Types.GetUpdatesNotificationsQueryVariables
>
export const GetNotificationDocument = /*#__PURE__*/ gql`
  query getNotification($identifier: UUID!) {
    notification(identifier: $identifier) {
      ...NotificationInfo
    }
  }
  ${NotificationInfoFragmentDoc}
`

/**
 * __useGetNotificationQuery__
 *
 * To run a query within a React component, call `useGetNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetNotificationQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetNotificationQuery,
    Types.GetNotificationQueryVariables
  > &
    (
      | { variables: Types.GetNotificationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetNotificationQuery,
    Types.GetNotificationQueryVariables
  >(GetNotificationDocument, options)
}
export function useGetNotificationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetNotificationQuery,
    Types.GetNotificationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetNotificationQuery,
    Types.GetNotificationQueryVariables
  >(GetNotificationDocument, options)
}

export type GetNotificationQueryHookResult = ReturnType<
  typeof useGetNotificationQuery
>
export type GetNotificationLazyQueryHookResult = ReturnType<
  typeof useGetNotificationLazyQuery
>
export type GetNotificationQueryResult = Apollo.QueryResult<
  Types.GetNotificationQuery,
  Types.GetNotificationQueryVariables
>
export const GetNotificationsCountDocument = /*#__PURE__*/ gql`
  query getNotificationsCount($filter: UserNotificationFilterType) {
    me {
      identifier
      notifications(filter: $filter) {
        meta {
          totalCount
        }
      }
    }
  }
`

/**
 * __useGetNotificationsCountQuery__
 *
 * To run a query within a React component, call `useGetNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetNotificationsCountQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetNotificationsCountQuery,
    Types.GetNotificationsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetNotificationsCountQuery,
    Types.GetNotificationsCountQueryVariables
  >(GetNotificationsCountDocument, options)
}
export function useGetNotificationsCountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetNotificationsCountQuery,
    Types.GetNotificationsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetNotificationsCountQuery,
    Types.GetNotificationsCountQueryVariables
  >(GetNotificationsCountDocument, options)
}

export type GetNotificationsCountQueryHookResult = ReturnType<
  typeof useGetNotificationsCountQuery
>
export type GetNotificationsCountLazyQueryHookResult = ReturnType<
  typeof useGetNotificationsCountLazyQuery
>
export type GetNotificationsCountQueryResult = Apollo.QueryResult<
  Types.GetNotificationsCountQuery,
  Types.GetNotificationsCountQueryVariables
>
export const NotificationCreatedDocument = /*#__PURE__*/ gql`
  subscription notificationCreated {
    notificationCreated {
      ...NotificationListInfo
    }
  }
  ${NotificationListInfoFragmentDoc}
`

/**
 * __useNotificationCreatedSubscription__
 *
 * To run a query within a React component, call `useNotificationCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNotificationCreatedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.NotificationCreatedSubscription,
    Types.NotificationCreatedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.NotificationCreatedSubscription,
    Types.NotificationCreatedSubscriptionVariables
  >(NotificationCreatedDocument, options)
}
export type NotificationCreatedSubscriptionHookResult = ReturnType<
  typeof useNotificationCreatedSubscription
>
export type NotificationCreatedSubscriptionResult =
  Apollo.SubscriptionResult<Types.NotificationCreatedSubscription>
export const UserPasswordUpdateDocument = /*#__PURE__*/ gql`
  mutation userPasswordUpdate(
    $currentPassword: String!
    $newPassword: String!
  ) {
    userPasswordUpdate(
      input: { currentPassword: $currentPassword, password: $newPassword }
    ) {
      errors {
        ...UserError
      }
      successful
    }
  }
  ${UserErrorFragmentDoc}
`
export type UserPasswordUpdateMutationFn = Apollo.MutationFunction<
  Types.UserPasswordUpdateMutation,
  Types.UserPasswordUpdateMutationVariables
>

/**
 * __useUserPasswordUpdateMutation__
 *
 * To run a mutation, you first call `useUserPasswordUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserPasswordUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userPasswordUpdateMutation, { data, loading, error }] = useUserPasswordUpdateMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useUserPasswordUpdateMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UserPasswordUpdateMutation,
    Types.UserPasswordUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UserPasswordUpdateMutation,
    Types.UserPasswordUpdateMutationVariables
  >(UserPasswordUpdateDocument, options)
}
export type UserPasswordUpdateMutationHookResult = ReturnType<
  typeof useUserPasswordUpdateMutation
>
export type UserPasswordUpdateMutationResult =
  Apollo.MutationResult<Types.UserPasswordUpdateMutation>
export type UserPasswordUpdateMutationOptions = Apollo.BaseMutationOptions<
  Types.UserPasswordUpdateMutation,
  Types.UserPasswordUpdateMutationVariables
>
export const UserDeleteDocument = /*#__PURE__*/ gql`
  mutation userDelete($password: String!) {
    userDelete(password: $password) {
      successful
      errors {
        ...UserError
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type UserDeleteMutationFn = Apollo.MutationFunction<
  Types.UserDeleteMutation,
  Types.UserDeleteMutationVariables
>

/**
 * __useUserDeleteMutation__
 *
 * To run a mutation, you first call `useUserDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeleteMutation, { data, loading, error }] = useUserDeleteMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useUserDeleteMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UserDeleteMutation,
    Types.UserDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UserDeleteMutation,
    Types.UserDeleteMutationVariables
  >(UserDeleteDocument, options)
}
export type UserDeleteMutationHookResult = ReturnType<
  typeof useUserDeleteMutation
>
export type UserDeleteMutationResult =
  Apollo.MutationResult<Types.UserDeleteMutation>
export type UserDeleteMutationOptions = Apollo.BaseMutationOptions<
  Types.UserDeleteMutation,
  Types.UserDeleteMutationVariables
>
export const EmailUpdateDocument = /*#__PURE__*/ gql`
  mutation emailUpdate($email: String!, $password: String!) {
    emailUpdate(email: $email, password: $password) {
      errors {
        ...UserError
      }
      user {
        identifier
        email
        newEmail
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type EmailUpdateMutationFn = Apollo.MutationFunction<
  Types.EmailUpdateMutation,
  Types.EmailUpdateMutationVariables
>

/**
 * __useEmailUpdateMutation__
 *
 * To run a mutation, you first call `useEmailUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailUpdateMutation, { data, loading, error }] = useEmailUpdateMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useEmailUpdateMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.EmailUpdateMutation,
    Types.EmailUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.EmailUpdateMutation,
    Types.EmailUpdateMutationVariables
  >(EmailUpdateDocument, options)
}
export type EmailUpdateMutationHookResult = ReturnType<
  typeof useEmailUpdateMutation
>
export type EmailUpdateMutationResult =
  Apollo.MutationResult<Types.EmailUpdateMutation>
export type EmailUpdateMutationOptions = Apollo.BaseMutationOptions<
  Types.EmailUpdateMutation,
  Types.EmailUpdateMutationVariables
>
export const EmailResendChangeConfirmationDocument = /*#__PURE__*/ gql`
  mutation emailResendChangeConfirmation {
    emailResendChangeConfirmation {
      errors {
        ...UserError
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type EmailResendChangeConfirmationMutationFn = Apollo.MutationFunction<
  Types.EmailResendChangeConfirmationMutation,
  Types.EmailResendChangeConfirmationMutationVariables
>

/**
 * __useEmailResendChangeConfirmationMutation__
 *
 * To run a mutation, you first call `useEmailResendChangeConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailResendChangeConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailResendChangeConfirmationMutation, { data, loading, error }] = useEmailResendChangeConfirmationMutation({
 *   variables: {
 *   },
 * });
 */
export function useEmailResendChangeConfirmationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.EmailResendChangeConfirmationMutation,
    Types.EmailResendChangeConfirmationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.EmailResendChangeConfirmationMutation,
    Types.EmailResendChangeConfirmationMutationVariables
  >(EmailResendChangeConfirmationDocument, options)
}
export type EmailResendChangeConfirmationMutationHookResult = ReturnType<
  typeof useEmailResendChangeConfirmationMutation
>
export type EmailResendChangeConfirmationMutationResult =
  Apollo.MutationResult<Types.EmailResendChangeConfirmationMutation>
export type EmailResendChangeConfirmationMutationOptions =
  Apollo.BaseMutationOptions<
    Types.EmailResendChangeConfirmationMutation,
    Types.EmailResendChangeConfirmationMutationVariables
  >
export const UserRequestPasswordResetDocument = /*#__PURE__*/ gql`
  mutation userRequestPasswordReset($email: String!) {
    userRequestPasswordReset(email: $email) {
      errors {
        ...UserError
      }
      successful
    }
  }
  ${UserErrorFragmentDoc}
`
export type UserRequestPasswordResetMutationFn = Apollo.MutationFunction<
  Types.UserRequestPasswordResetMutation,
  Types.UserRequestPasswordResetMutationVariables
>

/**
 * __useUserRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useUserRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRequestPasswordResetMutation, { data, loading, error }] = useUserRequestPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserRequestPasswordResetMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UserRequestPasswordResetMutation,
    Types.UserRequestPasswordResetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UserRequestPasswordResetMutation,
    Types.UserRequestPasswordResetMutationVariables
  >(UserRequestPasswordResetDocument, options)
}
export type UserRequestPasswordResetMutationHookResult = ReturnType<
  typeof useUserRequestPasswordResetMutation
>
export type UserRequestPasswordResetMutationResult =
  Apollo.MutationResult<Types.UserRequestPasswordResetMutation>
export type UserRequestPasswordResetMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UserRequestPasswordResetMutation,
    Types.UserRequestPasswordResetMutationVariables
  >
export const EmailVerifyDocument = /*#__PURE__*/ gql`
  mutation emailVerify($token: String!) {
    emailVerify(token: $token) {
      errors {
        ...UserError
      }
      email
      successful
    }
  }
  ${UserErrorFragmentDoc}
`
export type EmailVerifyMutationFn = Apollo.MutationFunction<
  Types.EmailVerifyMutation,
  Types.EmailVerifyMutationVariables
>

/**
 * __useEmailVerifyMutation__
 *
 * To run a mutation, you first call `useEmailVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailVerifyMutation, { data, loading, error }] = useEmailVerifyMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useEmailVerifyMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.EmailVerifyMutation,
    Types.EmailVerifyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.EmailVerifyMutation,
    Types.EmailVerifyMutationVariables
  >(EmailVerifyDocument, options)
}
export type EmailVerifyMutationHookResult = ReturnType<
  typeof useEmailVerifyMutation
>
export type EmailVerifyMutationResult =
  Apollo.MutationResult<Types.EmailVerifyMutation>
export type EmailVerifyMutationOptions = Apollo.BaseMutationOptions<
  Types.EmailVerifyMutation,
  Types.EmailVerifyMutationVariables
>
export const ResendVerificationEmailDocument = /*#__PURE__*/ gql`
  mutation resendVerificationEmail {
    resendVerificationEmail {
      errors {
        ...UserError
      }
      successful
    }
  }
  ${UserErrorFragmentDoc}
`
export type ResendVerificationEmailMutationFn = Apollo.MutationFunction<
  Types.ResendVerificationEmailMutation,
  Types.ResendVerificationEmailMutationVariables
>

/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailMutation, { data, loading, error }] = useResendVerificationEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useResendVerificationEmailMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ResendVerificationEmailMutation,
    Types.ResendVerificationEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ResendVerificationEmailMutation,
    Types.ResendVerificationEmailMutationVariables
  >(ResendVerificationEmailDocument, options)
}
export type ResendVerificationEmailMutationHookResult = ReturnType<
  typeof useResendVerificationEmailMutation
>
export type ResendVerificationEmailMutationResult =
  Apollo.MutationResult<Types.ResendVerificationEmailMutation>
export type ResendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<
  Types.ResendVerificationEmailMutation,
  Types.ResendVerificationEmailMutationVariables
>
export const UserPasswordResetDocument = /*#__PURE__*/ gql`
  mutation userPasswordReset($token: String!, $newPassword: String!) {
    userPasswordReset(input: { token: $token, newPassword: $newPassword }) {
      successful
      errors {
        ...UserError
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type UserPasswordResetMutationFn = Apollo.MutationFunction<
  Types.UserPasswordResetMutation,
  Types.UserPasswordResetMutationVariables
>

/**
 * __useUserPasswordResetMutation__
 *
 * To run a mutation, you first call `useUserPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userPasswordResetMutation, { data, loading, error }] = useUserPasswordResetMutation({
 *   variables: {
 *      token: // value for 'token'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useUserPasswordResetMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UserPasswordResetMutation,
    Types.UserPasswordResetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UserPasswordResetMutation,
    Types.UserPasswordResetMutationVariables
  >(UserPasswordResetDocument, options)
}
export type UserPasswordResetMutationHookResult = ReturnType<
  typeof useUserPasswordResetMutation
>
export type UserPasswordResetMutationResult =
  Apollo.MutationResult<Types.UserPasswordResetMutation>
export type UserPasswordResetMutationOptions = Apollo.BaseMutationOptions<
  Types.UserPasswordResetMutation,
  Types.UserPasswordResetMutationVariables
>
export const UserUpdateDocument = /*#__PURE__*/ gql`
  mutation userUpdate($input: UserParams) {
    userUpdate(input: $input) {
      errors {
        ...UserError
      }
      successful
      user {
        identifier
        name
        receiveEmailNotifications
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type UserUpdateMutationFn = Apollo.MutationFunction<
  Types.UserUpdateMutation,
  Types.UserUpdateMutationVariables
>

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserUpdateMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UserUpdateMutation,
    Types.UserUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UserUpdateMutation,
    Types.UserUpdateMutationVariables
  >(UserUpdateDocument, options)
}
export type UserUpdateMutationHookResult = ReturnType<
  typeof useUserUpdateMutation
>
export type UserUpdateMutationResult =
  Apollo.MutationResult<Types.UserUpdateMutation>
export type UserUpdateMutationOptions = Apollo.BaseMutationOptions<
  Types.UserUpdateMutation,
  Types.UserUpdateMutationVariables
>
export const UserAvatarDeleteDocument = /*#__PURE__*/ gql`
  mutation userAvatarDelete {
    userAvatarDelete {
      user {
        identifier
        hasAvatar
        avatar {
          large
          small
        }
      }
      successful
      errors {
        ...UserError
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type UserAvatarDeleteMutationFn = Apollo.MutationFunction<
  Types.UserAvatarDeleteMutation,
  Types.UserAvatarDeleteMutationVariables
>

/**
 * __useUserAvatarDeleteMutation__
 *
 * To run a mutation, you first call `useUserAvatarDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAvatarDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAvatarDeleteMutation, { data, loading, error }] = useUserAvatarDeleteMutation({
 *   variables: {
 *   },
 * });
 */
export function useUserAvatarDeleteMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UserAvatarDeleteMutation,
    Types.UserAvatarDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UserAvatarDeleteMutation,
    Types.UserAvatarDeleteMutationVariables
  >(UserAvatarDeleteDocument, options)
}
export type UserAvatarDeleteMutationHookResult = ReturnType<
  typeof useUserAvatarDeleteMutation
>
export type UserAvatarDeleteMutationResult =
  Apollo.MutationResult<Types.UserAvatarDeleteMutation>
export type UserAvatarDeleteMutationOptions = Apollo.BaseMutationOptions<
  Types.UserAvatarDeleteMutation,
  Types.UserAvatarDeleteMutationVariables
>
export const UserAvatarCreateDocument = /*#__PURE__*/ gql`
  mutation userAvatarCreate($file: Upload!) {
    userAvatarCreate(file: $file) {
      user {
        identifier
        hasAvatar
        avatar {
          large
          small
        }
      }
      successful
      errors {
        ...UserError
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type UserAvatarCreateMutationFn = Apollo.MutationFunction<
  Types.UserAvatarCreateMutation,
  Types.UserAvatarCreateMutationVariables
>

/**
 * __useUserAvatarCreateMutation__
 *
 * To run a mutation, you first call `useUserAvatarCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAvatarCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAvatarCreateMutation, { data, loading, error }] = useUserAvatarCreateMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUserAvatarCreateMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UserAvatarCreateMutation,
    Types.UserAvatarCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UserAvatarCreateMutation,
    Types.UserAvatarCreateMutationVariables
  >(UserAvatarCreateDocument, options)
}
export type UserAvatarCreateMutationHookResult = ReturnType<
  typeof useUserAvatarCreateMutation
>
export type UserAvatarCreateMutationResult =
  Apollo.MutationResult<Types.UserAvatarCreateMutation>
export type UserAvatarCreateMutationOptions = Apollo.BaseMutationOptions<
  Types.UserAvatarCreateMutation,
  Types.UserAvatarCreateMutationVariables
>
export const SendDownloadSketchEmailDocument = /*#__PURE__*/ gql`
  mutation sendDownloadSketchEmail {
    sendDownloadSketchEmail {
      sent
    }
  }
`
export type SendDownloadSketchEmailMutationFn = Apollo.MutationFunction<
  Types.SendDownloadSketchEmailMutation,
  Types.SendDownloadSketchEmailMutationVariables
>

/**
 * __useSendDownloadSketchEmailMutation__
 *
 * To run a mutation, you first call `useSendDownloadSketchEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDownloadSketchEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDownloadSketchEmailMutation, { data, loading, error }] = useSendDownloadSketchEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendDownloadSketchEmailMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SendDownloadSketchEmailMutation,
    Types.SendDownloadSketchEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SendDownloadSketchEmailMutation,
    Types.SendDownloadSketchEmailMutationVariables
  >(SendDownloadSketchEmailDocument, options)
}
export type SendDownloadSketchEmailMutationHookResult = ReturnType<
  typeof useSendDownloadSketchEmailMutation
>
export type SendDownloadSketchEmailMutationResult =
  Apollo.MutationResult<Types.SendDownloadSketchEmailMutation>
export type SendDownloadSketchEmailMutationOptions = Apollo.BaseMutationOptions<
  Types.SendDownloadSketchEmailMutation,
  Types.SendDownloadSketchEmailMutationVariables
>
export const UserAcceptTosAgreementDocument = /*#__PURE__*/ gql`
  mutation userAcceptTosAgreement {
    userAcceptTosAgreement {
      successful
      errors {
        ...UserError
      }
    }
  }
  ${UserErrorFragmentDoc}
`
export type UserAcceptTosAgreementMutationFn = Apollo.MutationFunction<
  Types.UserAcceptTosAgreementMutation,
  Types.UserAcceptTosAgreementMutationVariables
>

/**
 * __useUserAcceptTosAgreementMutation__
 *
 * To run a mutation, you first call `useUserAcceptTosAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAcceptTosAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAcceptTosAgreementMutation, { data, loading, error }] = useUserAcceptTosAgreementMutation({
 *   variables: {
 *   },
 * });
 */
export function useUserAcceptTosAgreementMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UserAcceptTosAgreementMutation,
    Types.UserAcceptTosAgreementMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UserAcceptTosAgreementMutation,
    Types.UserAcceptTosAgreementMutationVariables
  >(UserAcceptTosAgreementDocument, options)
}
export type UserAcceptTosAgreementMutationHookResult = ReturnType<
  typeof useUserAcceptTosAgreementMutation
>
export type UserAcceptTosAgreementMutationResult =
  Apollo.MutationResult<Types.UserAcceptTosAgreementMutation>
export type UserAcceptTosAgreementMutationOptions = Apollo.BaseMutationOptions<
  Types.UserAcceptTosAgreementMutation,
  Types.UserAcceptTosAgreementMutationVariables
>
export const UpdateUserPreferencesDocument = /*#__PURE__*/ gql`
  mutation updateUserPreferences(
    $showOnboardingFirstSteps: Boolean
    $showStorageLimitChanges: Boolean
  ) {
    updateUserPreferences(
      showOnboardingFirstSteps: $showOnboardingFirstSteps
      showStorageLimitChanges: $showStorageLimitChanges
    ) {
      user {
        ...UserPreferences
      }
    }
  }
  ${UserPreferencesFragmentDoc}
`
export type UpdateUserPreferencesMutationFn = Apollo.MutationFunction<
  Types.UpdateUserPreferencesMutation,
  Types.UpdateUserPreferencesMutationVariables
>

/**
 * __useUpdateUserPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateUserPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPreferencesMutation, { data, loading, error }] = useUpdateUserPreferencesMutation({
 *   variables: {
 *      showOnboardingFirstSteps: // value for 'showOnboardingFirstSteps'
 *      showStorageLimitChanges: // value for 'showStorageLimitChanges'
 *   },
 * });
 */
export function useUpdateUserPreferencesMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateUserPreferencesMutation,
    Types.UpdateUserPreferencesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateUserPreferencesMutation,
    Types.UpdateUserPreferencesMutationVariables
  >(UpdateUserPreferencesDocument, options)
}
export type UpdateUserPreferencesMutationHookResult = ReturnType<
  typeof useUpdateUserPreferencesMutation
>
export type UpdateUserPreferencesMutationResult =
  Apollo.MutationResult<Types.UpdateUserPreferencesMutation>
export type UpdateUserPreferencesMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateUserPreferencesMutation,
  Types.UpdateUserPreferencesMutationVariables
>
export const SendPasswordSetupEmailDocument = /*#__PURE__*/ gql`
  mutation sendPasswordSetupEmail {
    sendPasswordSetupEmail {
      user {
        identifier
      }
    }
  }
`
export type SendPasswordSetupEmailMutationFn = Apollo.MutationFunction<
  Types.SendPasswordSetupEmailMutation,
  Types.SendPasswordSetupEmailMutationVariables
>

/**
 * __useSendPasswordSetupEmailMutation__
 *
 * To run a mutation, you first call `useSendPasswordSetupEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordSetupEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordSetupEmailMutation, { data, loading, error }] = useSendPasswordSetupEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendPasswordSetupEmailMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SendPasswordSetupEmailMutation,
    Types.SendPasswordSetupEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SendPasswordSetupEmailMutation,
    Types.SendPasswordSetupEmailMutationVariables
  >(SendPasswordSetupEmailDocument, options)
}
export type SendPasswordSetupEmailMutationHookResult = ReturnType<
  typeof useSendPasswordSetupEmailMutation
>
export type SendPasswordSetupEmailMutationResult =
  Apollo.MutationResult<Types.SendPasswordSetupEmailMutation>
export type SendPasswordSetupEmailMutationOptions = Apollo.BaseMutationOptions<
  Types.SendPasswordSetupEmailMutation,
  Types.SendPasswordSetupEmailMutationVariables
>
export const GetUserIdDocument = /*#__PURE__*/ gql`
  query getUserId {
    me {
      identifier
    }
  }
`

/**
 * __useGetUserIdQuery__
 *
 * To run a query within a React component, call `useGetUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetUserIdQuery,
    Types.GetUserIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetUserIdQuery,
    Types.GetUserIdQueryVariables
  >(GetUserIdDocument, options)
}
export function useGetUserIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetUserIdQuery,
    Types.GetUserIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetUserIdQuery,
    Types.GetUserIdQueryVariables
  >(GetUserIdDocument, options)
}

export type GetUserIdQueryHookResult = ReturnType<typeof useGetUserIdQuery>
export type GetUserIdLazyQueryHookResult = ReturnType<
  typeof useGetUserIdLazyQuery
>
export type GetUserIdQueryResult = Apollo.QueryResult<
  Types.GetUserIdQuery,
  Types.GetUserIdQueryVariables
>
export const GetInitialUserDocument = /*#__PURE__*/ gql`
  query getInitialUser {
    me {
      identifier
      ...InitialUser
    }
  }
  ${InitialUserFragmentDoc}
`

/**
 * __useGetInitialUserQuery__
 *
 * To run a query within a React component, call `useGetInitialUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInitialUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetInitialUserQuery,
    Types.GetInitialUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetInitialUserQuery,
    Types.GetInitialUserQueryVariables
  >(GetInitialUserDocument, options)
}
export function useGetInitialUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetInitialUserQuery,
    Types.GetInitialUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetInitialUserQuery,
    Types.GetInitialUserQueryVariables
  >(GetInitialUserDocument, options)
}

export type GetInitialUserQueryHookResult = ReturnType<
  typeof useGetInitialUserQuery
>
export type GetInitialUserLazyQueryHookResult = ReturnType<
  typeof useGetInitialUserLazyQuery
>
export type GetInitialUserQueryResult = Apollo.QueryResult<
  Types.GetInitialUserQuery,
  Types.GetInitialUserQueryVariables
>
export const GetVerifiedUserDocument = /*#__PURE__*/ gql`
  query getVerifiedUser {
    me {
      identifier
      isVerified
    }
  }
`

/**
 * __useGetVerifiedUserQuery__
 *
 * To run a query within a React component, call `useGetVerifiedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVerifiedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVerifiedUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVerifiedUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetVerifiedUserQuery,
    Types.GetVerifiedUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetVerifiedUserQuery,
    Types.GetVerifiedUserQueryVariables
  >(GetVerifiedUserDocument, options)
}
export function useGetVerifiedUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetVerifiedUserQuery,
    Types.GetVerifiedUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetVerifiedUserQuery,
    Types.GetVerifiedUserQueryVariables
  >(GetVerifiedUserDocument, options)
}

export type GetVerifiedUserQueryHookResult = ReturnType<
  typeof useGetVerifiedUserQuery
>
export type GetVerifiedUserLazyQueryHookResult = ReturnType<
  typeof useGetVerifiedUserLazyQuery
>
export type GetVerifiedUserQueryResult = Apollo.QueryResult<
  Types.GetVerifiedUserQuery,
  Types.GetVerifiedUserQueryVariables
>
export const GetNotificationStatusDocument = /*#__PURE__*/ gql`
  query getNotificationStatus {
    me {
      ...NotificationStatus
    }
  }
  ${NotificationStatusFragmentDoc}
`

/**
 * __useGetNotificationStatusQuery__
 *
 * To run a query within a React component, call `useGetNotificationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationStatusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetNotificationStatusQuery,
    Types.GetNotificationStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetNotificationStatusQuery,
    Types.GetNotificationStatusQueryVariables
  >(GetNotificationStatusDocument, options)
}
export function useGetNotificationStatusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetNotificationStatusQuery,
    Types.GetNotificationStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetNotificationStatusQuery,
    Types.GetNotificationStatusQueryVariables
  >(GetNotificationStatusDocument, options)
}

export type GetNotificationStatusQueryHookResult = ReturnType<
  typeof useGetNotificationStatusQuery
>
export type GetNotificationStatusLazyQueryHookResult = ReturnType<
  typeof useGetNotificationStatusLazyQuery
>
export type GetNotificationStatusQueryResult = Apollo.QueryResult<
  Types.GetNotificationStatusQuery,
  Types.GetNotificationStatusQueryVariables
>
export const GetUserSettingsDocument = /*#__PURE__*/ gql`
  query getUserSettings($after: String, $limit: Int) {
    me {
      ...User
      identifier
      mfaState
      newEmail
      avatar {
        large
      }
      socialAccounts {
        identifier
        provider
        email
      }
      workspaceMemberships(after: $after, limit: $limit) {
        entries {
          ...UserWorkspaceMembership
        }
        meta {
          after
        }
      }
      activeSessions(limit: 20) {
        entries {
          ...UserActiveSession
        }
      }
    }
  }
  ${UserFragmentDoc}
  ${UserWorkspaceMembershipFragmentDoc}
  ${UserActiveSessionFragmentDoc}
`

/**
 * __useGetUserSettingsQuery__
 *
 * To run a query within a React component, call `useGetUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSettingsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUserSettingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetUserSettingsQuery,
    Types.GetUserSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetUserSettingsQuery,
    Types.GetUserSettingsQueryVariables
  >(GetUserSettingsDocument, options)
}
export function useGetUserSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetUserSettingsQuery,
    Types.GetUserSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetUserSettingsQuery,
    Types.GetUserSettingsQueryVariables
  >(GetUserSettingsDocument, options)
}

export type GetUserSettingsQueryHookResult = ReturnType<
  typeof useGetUserSettingsQuery
>
export type GetUserSettingsLazyQueryHookResult = ReturnType<
  typeof useGetUserSettingsLazyQuery
>
export type GetUserSettingsQueryResult = Apollo.QueryResult<
  Types.GetUserSettingsQuery,
  Types.GetUserSettingsQueryVariables
>
export const GetUserNotificationsCountDocument = /*#__PURE__*/ gql`
  query getUserNotificationsCount {
    me {
      identifier
      ...UserNotificationCount
    }
  }
  ${UserNotificationCountFragmentDoc}
`

/**
 * __useGetUserNotificationsCountQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserNotificationsCountQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetUserNotificationsCountQuery,
    Types.GetUserNotificationsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetUserNotificationsCountQuery,
    Types.GetUserNotificationsCountQueryVariables
  >(GetUserNotificationsCountDocument, options)
}
export function useGetUserNotificationsCountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetUserNotificationsCountQuery,
    Types.GetUserNotificationsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetUserNotificationsCountQuery,
    Types.GetUserNotificationsCountQueryVariables
  >(GetUserNotificationsCountDocument, options)
}

export type GetUserNotificationsCountQueryHookResult = ReturnType<
  typeof useGetUserNotificationsCountQuery
>
export type GetUserNotificationsCountLazyQueryHookResult = ReturnType<
  typeof useGetUserNotificationsCountLazyQuery
>
export type GetUserNotificationsCountQueryResult = Apollo.QueryResult<
  Types.GetUserNotificationsCountQuery,
  Types.GetUserNotificationsCountQueryVariables
>
export const GetShareForDeleteEntityFromCacheDocument = /*#__PURE__*/ gql`
  query getShareForDeleteEntityFromCache($id: UUID!) {
    share(id: $id) {
      identifier
    }
  }
`

/**
 * __useGetShareForDeleteEntityFromCacheQuery__
 *
 * To run a query within a React component, call `useGetShareForDeleteEntityFromCacheQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareForDeleteEntityFromCacheQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareForDeleteEntityFromCacheQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetShareForDeleteEntityFromCacheQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetShareForDeleteEntityFromCacheQuery,
    Types.GetShareForDeleteEntityFromCacheQueryVariables
  > &
    (
      | {
          variables: Types.GetShareForDeleteEntityFromCacheQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetShareForDeleteEntityFromCacheQuery,
    Types.GetShareForDeleteEntityFromCacheQueryVariables
  >(GetShareForDeleteEntityFromCacheDocument, options)
}
export function useGetShareForDeleteEntityFromCacheLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetShareForDeleteEntityFromCacheQuery,
    Types.GetShareForDeleteEntityFromCacheQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetShareForDeleteEntityFromCacheQuery,
    Types.GetShareForDeleteEntityFromCacheQueryVariables
  >(GetShareForDeleteEntityFromCacheDocument, options)
}

export type GetShareForDeleteEntityFromCacheQueryHookResult = ReturnType<
  typeof useGetShareForDeleteEntityFromCacheQuery
>
export type GetShareForDeleteEntityFromCacheLazyQueryHookResult = ReturnType<
  typeof useGetShareForDeleteEntityFromCacheLazyQuery
>
export type GetShareForDeleteEntityFromCacheQueryResult = Apollo.QueryResult<
  Types.GetShareForDeleteEntityFromCacheQuery,
  Types.GetShareForDeleteEntityFromCacheQueryVariables
>
export const GetArtboardRevisionsDocument = /*#__PURE__*/ gql`
  query getArtboardRevisions(
    $shareIdentifier: UUID!
    $permanentArtboardIdentifier: ID!
    $after: String
  ) {
    artboardRevisions(
      shareIdentifier: $shareIdentifier
      permanentArtboardId: $permanentArtboardIdentifier
      after: $after
    ) {
      entries {
        ... on Revision {
          order
          ...ArtboardRevision
        }
        ... on RevisionDeleted {
          order
          ...ArtboardRevisionDeleted
        }
        ... on RevisionUnavailable {
          order
          ...ArtboardRevisionUnavailable
        }
      }
      meta {
        after
        totalCount
      }
    }
  }
  ${ArtboardRevisionFragmentDoc}
  ${ArtboardRevisionDeletedFragmentDoc}
  ${ArtboardRevisionUnavailableFragmentDoc}
`

/**
 * __useGetArtboardRevisionsQuery__
 *
 * To run a query within a React component, call `useGetArtboardRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtboardRevisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtboardRevisionsQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      permanentArtboardIdentifier: // value for 'permanentArtboardIdentifier'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetArtboardRevisionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetArtboardRevisionsQuery,
    Types.GetArtboardRevisionsQueryVariables
  > &
    (
      | { variables: Types.GetArtboardRevisionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetArtboardRevisionsQuery,
    Types.GetArtboardRevisionsQueryVariables
  >(GetArtboardRevisionsDocument, options)
}
export function useGetArtboardRevisionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetArtboardRevisionsQuery,
    Types.GetArtboardRevisionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetArtboardRevisionsQuery,
    Types.GetArtboardRevisionsQueryVariables
  >(GetArtboardRevisionsDocument, options)
}

export type GetArtboardRevisionsQueryHookResult = ReturnType<
  typeof useGetArtboardRevisionsQuery
>
export type GetArtboardRevisionsLazyQueryHookResult = ReturnType<
  typeof useGetArtboardRevisionsLazyQuery
>
export type GetArtboardRevisionsQueryResult = Apollo.QueryResult<
  Types.GetArtboardRevisionsQuery,
  Types.GetArtboardRevisionsQueryVariables
>
export const GetFrameRevisionsDocument = /*#__PURE__*/ gql`
  query getFrameRevisions(
    $frameUUID: String!
    $shareIdentifier: UUID!
    $after: String
  ) {
    frame(uuid: $frameUUID, shareIdentifier: $shareIdentifier) {
      ... on Artboard {
        documentVersionShortId
        permanentArtboardShortId
      }
      identifier
      revisions(after: $after) {
        entries {
          ... on Revision {
            order
            ...FrameGroupRevision
          }
          ... on RevisionDeleted {
            order
            ...FrameGroupRevisionDeleted
          }
          ... on RevisionUnavailable {
            order
            ...FrameGroupRevisionUnavailable
          }
        }
        meta {
          after
          totalCount
        }
      }
    }
  }
  ${FrameGroupRevisionFragmentDoc}
  ${FrameGroupRevisionDeletedFragmentDoc}
  ${FrameGroupRevisionUnavailableFragmentDoc}
`

/**
 * __useGetFrameRevisionsQuery__
 *
 * To run a query within a React component, call `useGetFrameRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFrameRevisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFrameRevisionsQuery({
 *   variables: {
 *      frameUUID: // value for 'frameUUID'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetFrameRevisionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetFrameRevisionsQuery,
    Types.GetFrameRevisionsQueryVariables
  > &
    (
      | { variables: Types.GetFrameRevisionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetFrameRevisionsQuery,
    Types.GetFrameRevisionsQueryVariables
  >(GetFrameRevisionsDocument, options)
}
export function useGetFrameRevisionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetFrameRevisionsQuery,
    Types.GetFrameRevisionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetFrameRevisionsQuery,
    Types.GetFrameRevisionsQueryVariables
  >(GetFrameRevisionsDocument, options)
}

export type GetFrameRevisionsQueryHookResult = ReturnType<
  typeof useGetFrameRevisionsQuery
>
export type GetFrameRevisionsLazyQueryHookResult = ReturnType<
  typeof useGetFrameRevisionsLazyQuery
>
export type GetFrameRevisionsQueryResult = Apollo.QueryResult<
  Types.GetFrameRevisionsQuery,
  Types.GetFrameRevisionsQueryVariables
>
export const VersionDeleteDocument = /*#__PURE__*/ gql`
  mutation versionDelete($versionIdentifier: UUID!) {
    versionDelete(versionIdentifier: $versionIdentifier) {
      successful
      errors {
        ...UserError
      }
      versionDeleted {
        ...VersionDeleted
      }
      share {
        ...ShareInfo
      }
    }
  }
  ${UserErrorFragmentDoc}
  ${VersionDeletedFragmentDoc}
  ${ShareInfoFragmentDoc}
`
export type VersionDeleteMutationFn = Apollo.MutationFunction<
  Types.VersionDeleteMutation,
  Types.VersionDeleteMutationVariables
>

/**
 * __useVersionDeleteMutation__
 *
 * To run a mutation, you first call `useVersionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVersionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [versionDeleteMutation, { data, loading, error }] = useVersionDeleteMutation({
 *   variables: {
 *      versionIdentifier: // value for 'versionIdentifier'
 *   },
 * });
 */
export function useVersionDeleteMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.VersionDeleteMutation,
    Types.VersionDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.VersionDeleteMutation,
    Types.VersionDeleteMutationVariables
  >(VersionDeleteDocument, options)
}
export type VersionDeleteMutationHookResult = ReturnType<
  typeof useVersionDeleteMutation
>
export type VersionDeleteMutationResult =
  Apollo.MutationResult<Types.VersionDeleteMutation>
export type VersionDeleteMutationOptions = Apollo.BaseMutationOptions<
  Types.VersionDeleteMutation,
  Types.VersionDeleteMutationVariables
>
export const VersionUpdateKindDocument = /*#__PURE__*/ gql`
  mutation versionUpdateKind($versionIdentifier: UUID!, $kind: Kind!) {
    versionUpdateKind(versionIdentifier: $versionIdentifier, kind: $kind) {
      shortId
      kind
    }
  }
`
export type VersionUpdateKindMutationFn = Apollo.MutationFunction<
  Types.VersionUpdateKindMutation,
  Types.VersionUpdateKindMutationVariables
>

/**
 * __useVersionUpdateKindMutation__
 *
 * To run a mutation, you first call `useVersionUpdateKindMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVersionUpdateKindMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [versionUpdateKindMutation, { data, loading, error }] = useVersionUpdateKindMutation({
 *   variables: {
 *      versionIdentifier: // value for 'versionIdentifier'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useVersionUpdateKindMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.VersionUpdateKindMutation,
    Types.VersionUpdateKindMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.VersionUpdateKindMutation,
    Types.VersionUpdateKindMutationVariables
  >(VersionUpdateKindDocument, options)
}
export type VersionUpdateKindMutationHookResult = ReturnType<
  typeof useVersionUpdateKindMutation
>
export type VersionUpdateKindMutationResult =
  Apollo.MutationResult<Types.VersionUpdateKindMutation>
export type VersionUpdateKindMutationOptions = Apollo.BaseMutationOptions<
  Types.VersionUpdateKindMutation,
  Types.VersionUpdateKindMutationVariables
>
export const UpdateVersionDescriptionDocument = /*#__PURE__*/ gql`
  mutation updateVersionDescription(
    $versionIdentifier: UUID!
    $shareIdentifier: UUID!
    $description: String!
  ) {
    updateVersionDescription(
      versionIdentifier: $versionIdentifier
      shareIdentifier: $shareIdentifier
      description: $description
    ) {
      shortId
      description
    }
  }
`
export type UpdateVersionDescriptionMutationFn = Apollo.MutationFunction<
  Types.UpdateVersionDescriptionMutation,
  Types.UpdateVersionDescriptionMutationVariables
>

/**
 * __useUpdateVersionDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateVersionDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVersionDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVersionDescriptionMutation, { data, loading, error }] = useUpdateVersionDescriptionMutation({
 *   variables: {
 *      versionIdentifier: // value for 'versionIdentifier'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateVersionDescriptionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateVersionDescriptionMutation,
    Types.UpdateVersionDescriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateVersionDescriptionMutation,
    Types.UpdateVersionDescriptionMutationVariables
  >(UpdateVersionDescriptionDocument, options)
}
export type UpdateVersionDescriptionMutationHookResult = ReturnType<
  typeof useUpdateVersionDescriptionMutation
>
export type UpdateVersionDescriptionMutationResult =
  Apollo.MutationResult<Types.UpdateVersionDescriptionMutation>
export type UpdateVersionDescriptionMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateVersionDescriptionMutation,
    Types.UpdateVersionDescriptionMutationVariables
  >
export const DeletePreviousShareVersionsDocument = /*#__PURE__*/ gql`
  mutation deletePreviousShareVersions(
    $shareIdentifiers: [UUID!]!
    $versionIdentifier: UUID
    $preserveVersions: PreserveVersionsOption
  ) {
    deletePreviousShareVersions(
      shareIdentifiers: $shareIdentifiers
      versionIdentifier: $versionIdentifier
      preserveVersions: $preserveVersions
    ) {
      shares {
        ...ShareInfo
        versions {
          meta {
            totalCount
          }
        }
      }
      deletedCount
    }
  }
  ${ShareInfoFragmentDoc}
`
export type DeletePreviousShareVersionsMutationFn = Apollo.MutationFunction<
  Types.DeletePreviousShareVersionsMutation,
  Types.DeletePreviousShareVersionsMutationVariables
>

/**
 * __useDeletePreviousShareVersionsMutation__
 *
 * To run a mutation, you first call `useDeletePreviousShareVersionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePreviousShareVersionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePreviousShareVersionsMutation, { data, loading, error }] = useDeletePreviousShareVersionsMutation({
 *   variables: {
 *      shareIdentifiers: // value for 'shareIdentifiers'
 *      versionIdentifier: // value for 'versionIdentifier'
 *      preserveVersions: // value for 'preserveVersions'
 *   },
 * });
 */
export function useDeletePreviousShareVersionsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeletePreviousShareVersionsMutation,
    Types.DeletePreviousShareVersionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeletePreviousShareVersionsMutation,
    Types.DeletePreviousShareVersionsMutationVariables
  >(DeletePreviousShareVersionsDocument, options)
}
export type DeletePreviousShareVersionsMutationHookResult = ReturnType<
  typeof useDeletePreviousShareVersionsMutation
>
export type DeletePreviousShareVersionsMutationResult =
  Apollo.MutationResult<Types.DeletePreviousShareVersionsMutation>
export type DeletePreviousShareVersionsMutationOptions =
  Apollo.BaseMutationOptions<
    Types.DeletePreviousShareVersionsMutation,
    Types.DeletePreviousShareVersionsMutationVariables
  >
export const GetVersionDocument = /*#__PURE__*/ gql`
  query getVersion($shareIdentifier: UUID!, $versionShortId: ShortId) {
    share(id: $shareIdentifier) {
      identifier
      version(shortId: $versionShortId) {
        ...Version
      }
    }
  }
  ${VersionFragmentDoc}
`

/**
 * __useGetVersionQuery__
 *
 * To run a query within a React component, call `useGetVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVersionQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      versionShortId: // value for 'versionShortId'
 *   },
 * });
 */
export function useGetVersionQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetVersionQuery,
    Types.GetVersionQueryVariables
  > &
    (
      | { variables: Types.GetVersionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetVersionQuery,
    Types.GetVersionQueryVariables
  >(GetVersionDocument, options)
}
export function useGetVersionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetVersionQuery,
    Types.GetVersionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetVersionQuery,
    Types.GetVersionQueryVariables
  >(GetVersionDocument, options)
}

export type GetVersionQueryHookResult = ReturnType<typeof useGetVersionQuery>
export type GetVersionLazyQueryHookResult = ReturnType<
  typeof useGetVersionLazyQuery
>
export type GetVersionQueryResult = Apollo.QueryResult<
  Types.GetVersionQuery,
  Types.GetVersionQueryVariables
>
export const GetLatestStarDocument = /*#__PURE__*/ gql`
  query getLatestStar($shareIdentifier: UUID) {
    share(id: $shareIdentifier) {
      identifier
      version(preferredState: PROCESSED_AND_PUBLISHED) {
        kind
        ...Version
      }
    }
  }
  ${VersionFragmentDoc}
`

/**
 * __useGetLatestStarQuery__
 *
 * To run a query within a React component, call `useGetLatestStarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestStarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestStarQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useGetLatestStarQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetLatestStarQuery,
    Types.GetLatestStarQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetLatestStarQuery,
    Types.GetLatestStarQueryVariables
  >(GetLatestStarDocument, options)
}
export function useGetLatestStarLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetLatestStarQuery,
    Types.GetLatestStarQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetLatestStarQuery,
    Types.GetLatestStarQueryVariables
  >(GetLatestStarDocument, options)
}

export type GetLatestStarQueryHookResult = ReturnType<
  typeof useGetLatestStarQuery
>
export type GetLatestStarLazyQueryHookResult = ReturnType<
  typeof useGetLatestStarLazyQuery
>
export type GetLatestStarQueryResult = Apollo.QueryResult<
  Types.GetLatestStarQuery,
  Types.GetLatestStarQueryVariables
>
export const VersionUploadProcessedDocument = /*#__PURE__*/ gql`
  subscription versionUploadProcessed(
    $shareIdentifier: UUID
    $preferredState: VersionSubscriptionStateFilter
  ) {
    versionUploadProcessed(
      preferredState: $preferredState
      shareIdentifier: $shareIdentifier
    ) {
      ...ShareInfo
    }
  }
  ${ShareInfoFragmentDoc}
`

/**
 * __useVersionUploadProcessedSubscription__
 *
 * To run a query within a React component, call `useVersionUploadProcessedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVersionUploadProcessedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVersionUploadProcessedSubscription({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      preferredState: // value for 'preferredState'
 *   },
 * });
 */
export function useVersionUploadProcessedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.VersionUploadProcessedSubscription,
    Types.VersionUploadProcessedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.VersionUploadProcessedSubscription,
    Types.VersionUploadProcessedSubscriptionVariables
  >(VersionUploadProcessedDocument, options)
}
export type VersionUploadProcessedSubscriptionHookResult = ReturnType<
  typeof useVersionUploadProcessedSubscription
>
export type VersionUploadProcessedSubscriptionResult =
  Apollo.SubscriptionResult<Types.VersionUploadProcessedSubscription>
export const VersionUploadCompleteDocument = /*#__PURE__*/ gql`
  subscription versionUploadComplete(
    $shareIdentifier: UUID
    $preferredState: VersionSubscriptionStateFilter
    $after: String = null
    $limit: Int = 20
  ) {
    versionUploadComplete(
      preferredState: $preferredState
      shareIdentifier: $shareIdentifier
    ) {
      ...ShareVersionHistory
    }
  }
  ${ShareVersionHistoryFragmentDoc}
`

/**
 * __useVersionUploadCompleteSubscription__
 *
 * To run a query within a React component, call `useVersionUploadCompleteSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVersionUploadCompleteSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVersionUploadCompleteSubscription({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      preferredState: // value for 'preferredState'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useVersionUploadCompleteSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.VersionUploadCompleteSubscription,
    Types.VersionUploadCompleteSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.VersionUploadCompleteSubscription,
    Types.VersionUploadCompleteSubscriptionVariables
  >(VersionUploadCompleteDocument, options)
}
export type VersionUploadCompleteSubscriptionHookResult = ReturnType<
  typeof useVersionUploadCompleteSubscription
>
export type VersionUploadCompleteSubscriptionResult =
  Apollo.SubscriptionResult<Types.VersionUploadCompleteSubscription>
export const VersionDeletedDocument = /*#__PURE__*/ gql`
  subscription versionDeleted {
    versionDeleted {
      share {
        ...ShareInfo
        ...ShareLatestStarredVersion
      }
      versionDeleted {
        ...VersionDeleted
      }
    }
  }
  ${ShareInfoFragmentDoc}
  ${ShareLatestStarredVersionFragmentDoc}
  ${VersionDeletedFragmentDoc}
`

/**
 * __useVersionDeletedSubscription__
 *
 * To run a query within a React component, call `useVersionDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVersionDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVersionDeletedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useVersionDeletedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.VersionDeletedSubscription,
    Types.VersionDeletedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.VersionDeletedSubscription,
    Types.VersionDeletedSubscriptionVariables
  >(VersionDeletedDocument, options)
}
export type VersionDeletedSubscriptionHookResult = ReturnType<
  typeof useVersionDeletedSubscription
>
export type VersionDeletedSubscriptionResult =
  Apollo.SubscriptionResult<Types.VersionDeletedSubscription>
export const VersionUpdatedDocument = /*#__PURE__*/ gql`
  subscription versionUpdated {
    versionUpdated {
      ...VersionListItem
      share {
        identifier
      }
    }
  }
  ${VersionListItemFragmentDoc}
`

/**
 * __useVersionUpdatedSubscription__
 *
 * To run a query within a React component, call `useVersionUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVersionUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVersionUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useVersionUpdatedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.VersionUpdatedSubscription,
    Types.VersionUpdatedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.VersionUpdatedSubscription,
    Types.VersionUpdatedSubscriptionVariables
  >(VersionUpdatedDocument, options)
}
export type VersionUpdatedSubscriptionHookResult = ReturnType<
  typeof useVersionUpdatedSubscription
>
export type VersionUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<Types.VersionUpdatedSubscription>
export const GetVersionHistoryDocument = /*#__PURE__*/ gql`
  query getVersionHistory(
    $shareIdentifier: UUID!
    $after: String = null
    $limit: Int = 20
  ) {
    share(id: $shareIdentifier) {
      ...ShareVersionHistory
    }
  }
  ${ShareVersionHistoryFragmentDoc}
`

/**
 * __useGetVersionHistoryQuery__
 *
 * To run a query within a React component, call `useGetVersionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVersionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVersionHistoryQuery({
 *   variables: {
 *      shareIdentifier: // value for 'shareIdentifier'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetVersionHistoryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetVersionHistoryQuery,
    Types.GetVersionHistoryQueryVariables
  > &
    (
      | { variables: Types.GetVersionHistoryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetVersionHistoryQuery,
    Types.GetVersionHistoryQueryVariables
  >(GetVersionHistoryDocument, options)
}
export function useGetVersionHistoryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetVersionHistoryQuery,
    Types.GetVersionHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetVersionHistoryQuery,
    Types.GetVersionHistoryQueryVariables
  >(GetVersionHistoryDocument, options)
}

export type GetVersionHistoryQueryHookResult = ReturnType<
  typeof useGetVersionHistoryQuery
>
export type GetVersionHistoryLazyQueryHookResult = ReturnType<
  typeof useGetVersionHistoryLazyQuery
>
export type GetVersionHistoryQueryResult = Apollo.QueryResult<
  Types.GetVersionHistoryQuery,
  Types.GetVersionHistoryQueryVariables
>
export const GetWorkspaceBillingDocument = /*#__PURE__*/ gql`
  query getWorkspaceBilling($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      customer {
        identifier
        billing {
          ...BillingMinimal
        }
      }
    }
  }
  ${BillingMinimalFragmentDoc}
`

/**
 * __useGetWorkspaceBillingQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceBillingQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceBillingQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceBillingQuery,
    Types.GetWorkspaceBillingQueryVariables
  > &
    (
      | { variables: Types.GetWorkspaceBillingQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceBillingQuery,
    Types.GetWorkspaceBillingQueryVariables
  >(GetWorkspaceBillingDocument, options)
}
export function useGetWorkspaceBillingLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceBillingQuery,
    Types.GetWorkspaceBillingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceBillingQuery,
    Types.GetWorkspaceBillingQueryVariables
  >(GetWorkspaceBillingDocument, options)
}

export type GetWorkspaceBillingQueryHookResult = ReturnType<
  typeof useGetWorkspaceBillingQuery
>
export type GetWorkspaceBillingLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceBillingLazyQuery
>
export type GetWorkspaceBillingQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceBillingQuery,
  Types.GetWorkspaceBillingQueryVariables
>
export const GetBillingForWorkspaceNoticeDocument = /*#__PURE__*/ gql`
  query getBillingForWorkspaceNotice($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      customer {
        identifier
        billing {
          ...BillingWorkspaceNotice
        }
      }
    }
  }
  ${BillingWorkspaceNoticeFragmentDoc}
`

/**
 * __useGetBillingForWorkspaceNoticeQuery__
 *
 * To run a query within a React component, call `useGetBillingForWorkspaceNoticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingForWorkspaceNoticeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingForWorkspaceNoticeQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetBillingForWorkspaceNoticeQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetBillingForWorkspaceNoticeQuery,
    Types.GetBillingForWorkspaceNoticeQueryVariables
  > &
    (
      | {
          variables: Types.GetBillingForWorkspaceNoticeQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetBillingForWorkspaceNoticeQuery,
    Types.GetBillingForWorkspaceNoticeQueryVariables
  >(GetBillingForWorkspaceNoticeDocument, options)
}
export function useGetBillingForWorkspaceNoticeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetBillingForWorkspaceNoticeQuery,
    Types.GetBillingForWorkspaceNoticeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetBillingForWorkspaceNoticeQuery,
    Types.GetBillingForWorkspaceNoticeQueryVariables
  >(GetBillingForWorkspaceNoticeDocument, options)
}

export type GetBillingForWorkspaceNoticeQueryHookResult = ReturnType<
  typeof useGetBillingForWorkspaceNoticeQuery
>
export type GetBillingForWorkspaceNoticeLazyQueryHookResult = ReturnType<
  typeof useGetBillingForWorkspaceNoticeLazyQuery
>
export type GetBillingForWorkspaceNoticeQueryResult = Apollo.QueryResult<
  Types.GetBillingForWorkspaceNoticeQuery,
  Types.GetBillingForWorkspaceNoticeQueryVariables
>
export const GetNextBillingCycleDocument = /*#__PURE__*/ gql`
  query getNextBillingCycle($customerId: UUID!) @PaymentQLApi {
    customer(id: $customerId) {
      id
      billingSummary {
        next {
          invoice
          currency
        }
      }
    }
  }
`

/**
 * __useGetNextBillingCycleQuery__
 *
 * To run a query within a React component, call `useGetNextBillingCycleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextBillingCycleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextBillingCycleQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetNextBillingCycleQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetNextBillingCycleQuery,
    Types.GetNextBillingCycleQueryVariables
  > &
    (
      | { variables: Types.GetNextBillingCycleQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetNextBillingCycleQuery,
    Types.GetNextBillingCycleQueryVariables
  >(GetNextBillingCycleDocument, options)
}
export function useGetNextBillingCycleLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetNextBillingCycleQuery,
    Types.GetNextBillingCycleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetNextBillingCycleQuery,
    Types.GetNextBillingCycleQueryVariables
  >(GetNextBillingCycleDocument, options)
}

export type GetNextBillingCycleQueryHookResult = ReturnType<
  typeof useGetNextBillingCycleQuery
>
export type GetNextBillingCycleLazyQueryHookResult = ReturnType<
  typeof useGetNextBillingCycleLazyQuery
>
export type GetNextBillingCycleQueryResult = Apollo.QueryResult<
  Types.GetNextBillingCycleQuery,
  Types.GetNextBillingCycleQueryVariables
>
export const UpdateBillingDetailsDocument = /*#__PURE__*/ gql`
  mutation updateBillingDetails($input: UpdateBillingDetailsInput!)
  @PaymentQLApi {
    updateBillingDetails(input: $input) {
      customer {
        id
        billingDetails {
          ...BillingDetails
        }
      }
    }
  }
  ${BillingDetailsFragmentDoc}
`
export type UpdateBillingDetailsMutationFn = Apollo.MutationFunction<
  Types.UpdateBillingDetailsMutation,
  Types.UpdateBillingDetailsMutationVariables
>

/**
 * __useUpdateBillingDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateBillingDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingDetailsMutation, { data, loading, error }] = useUpdateBillingDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillingDetailsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateBillingDetailsMutation,
    Types.UpdateBillingDetailsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateBillingDetailsMutation,
    Types.UpdateBillingDetailsMutationVariables
  >(UpdateBillingDetailsDocument, options)
}
export type UpdateBillingDetailsMutationHookResult = ReturnType<
  typeof useUpdateBillingDetailsMutation
>
export type UpdateBillingDetailsMutationResult =
  Apollo.MutationResult<Types.UpdateBillingDetailsMutation>
export type UpdateBillingDetailsMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateBillingDetailsMutation,
  Types.UpdateBillingDetailsMutationVariables
>
export const GetBillingHistoryDocument = /*#__PURE__*/ gql`
  query getBillingHistory($customerId: UUID!, $after: String, $limit: Int! = 10)
  @PaymentQLApi {
    customer(id: $customerId) {
      id
      billingHistory(after: $after, limit: $limit) {
        entries {
          ...BillingHistoryEntry
        }
        meta {
          after
          totalCount
        }
      }
    }
  }
  ${BillingHistoryEntryFragmentDoc}
`

/**
 * __useGetBillingHistoryQuery__
 *
 * To run a query within a React component, call `useGetBillingHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingHistoryQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBillingHistoryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetBillingHistoryQuery,
    Types.GetBillingHistoryQueryVariables
  > &
    (
      | { variables: Types.GetBillingHistoryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetBillingHistoryQuery,
    Types.GetBillingHistoryQueryVariables
  >(GetBillingHistoryDocument, options)
}
export function useGetBillingHistoryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetBillingHistoryQuery,
    Types.GetBillingHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetBillingHistoryQuery,
    Types.GetBillingHistoryQueryVariables
  >(GetBillingHistoryDocument, options)
}

export type GetBillingHistoryQueryHookResult = ReturnType<
  typeof useGetBillingHistoryQuery
>
export type GetBillingHistoryLazyQueryHookResult = ReturnType<
  typeof useGetBillingHistoryLazyQuery
>
export type GetBillingHistoryQueryResult = Apollo.QueryResult<
  Types.GetBillingHistoryQuery,
  Types.GetBillingHistoryQueryVariables
>
export const ChangePlanDocument = /*#__PURE__*/ gql`
  mutation changePlan($input: ChangePlanInput!) @PaymentQLApi {
    changePlan(input: $input) {
      customer {
        id
        paymentDetails {
          ...PaymentDetails
        }
      }
    }
  }
  ${PaymentDetailsFragmentDoc}
`
export type ChangePlanMutationFn = Apollo.MutationFunction<
  Types.ChangePlanMutation,
  Types.ChangePlanMutationVariables
>

/**
 * __useChangePlanMutation__
 *
 * To run a mutation, you first call `useChangePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePlanMutation, { data, loading, error }] = useChangePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePlanMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ChangePlanMutation,
    Types.ChangePlanMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ChangePlanMutation,
    Types.ChangePlanMutationVariables
  >(ChangePlanDocument, options)
}
export type ChangePlanMutationHookResult = ReturnType<
  typeof useChangePlanMutation
>
export type ChangePlanMutationResult =
  Apollo.MutationResult<Types.ChangePlanMutation>
export type ChangePlanMutationOptions = Apollo.BaseMutationOptions<
  Types.ChangePlanMutation,
  Types.ChangePlanMutationVariables
>
export const GetAvailablePlansDocument = /*#__PURE__*/ gql`
  query getAvailablePlans @PaymentQLApi {
    availablePlans: availableCloudPlans {
      ... on CloudBillingPlan {
        ...CloudBillingPlan
      }
    }
  }
  ${CloudBillingPlanFragmentDoc}
`

/**
 * __useGetAvailablePlansQuery__
 *
 * To run a query within a React component, call `useGetAvailablePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailablePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailablePlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailablePlansQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetAvailablePlansQuery,
    Types.GetAvailablePlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAvailablePlansQuery,
    Types.GetAvailablePlansQueryVariables
  >(GetAvailablePlansDocument, options)
}
export function useGetAvailablePlansLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAvailablePlansQuery,
    Types.GetAvailablePlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAvailablePlansQuery,
    Types.GetAvailablePlansQueryVariables
  >(GetAvailablePlansDocument, options)
}

export type GetAvailablePlansQueryHookResult = ReturnType<
  typeof useGetAvailablePlansQuery
>
export type GetAvailablePlansLazyQueryHookResult = ReturnType<
  typeof useGetAvailablePlansLazyQuery
>
export type GetAvailablePlansQueryResult = Apollo.QueryResult<
  Types.GetAvailablePlansQuery,
  Types.GetAvailablePlansQueryVariables
>
export const SubscriptionUpdateBillingSimulationDocument = /*#__PURE__*/ gql`
  query subscriptionUpdateBillingSimulation(
    $customerId: UUID!
    $seats: Int!
    $planId: String!
    $promotionCode: String
  ) @PaymentQLApi {
    subscriptionUpdateBillingSimulation(
      customerId: $customerId
      seats: $seats
      planId: $planId
      promotionCode: $promotionCode
    ) {
      price {
        ...BillingPrice
      }
      prorated {
        creditsAmount
        chargeAmount
        price {
          ...Price
        }
        daysRemainingInCycle
        discountForUnusedDays
        couponInfo {
          ...Coupon
        }
      }
      couponInfo {
        ...Coupon
      }
    }
  }
  ${BillingPriceFragmentDoc}
  ${PriceFragmentDoc}
  ${CouponFragmentDoc}
`

/**
 * __useSubscriptionUpdateBillingSimulationQuery__
 *
 * To run a query within a React component, call `useSubscriptionUpdateBillingSimulationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionUpdateBillingSimulationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionUpdateBillingSimulationQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      seats: // value for 'seats'
 *      planId: // value for 'planId'
 *      promotionCode: // value for 'promotionCode'
 *   },
 * });
 */
export function useSubscriptionUpdateBillingSimulationQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.SubscriptionUpdateBillingSimulationQuery,
    Types.SubscriptionUpdateBillingSimulationQueryVariables
  > &
    (
      | {
          variables: Types.SubscriptionUpdateBillingSimulationQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.SubscriptionUpdateBillingSimulationQuery,
    Types.SubscriptionUpdateBillingSimulationQueryVariables
  >(SubscriptionUpdateBillingSimulationDocument, options)
}
export function useSubscriptionUpdateBillingSimulationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.SubscriptionUpdateBillingSimulationQuery,
    Types.SubscriptionUpdateBillingSimulationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.SubscriptionUpdateBillingSimulationQuery,
    Types.SubscriptionUpdateBillingSimulationQueryVariables
  >(SubscriptionUpdateBillingSimulationDocument, options)
}

export type SubscriptionUpdateBillingSimulationQueryHookResult = ReturnType<
  typeof useSubscriptionUpdateBillingSimulationQuery
>
export type SubscriptionUpdateBillingSimulationLazyQueryHookResult = ReturnType<
  typeof useSubscriptionUpdateBillingSimulationLazyQuery
>
export type SubscriptionUpdateBillingSimulationQueryResult = Apollo.QueryResult<
  Types.SubscriptionUpdateBillingSimulationQuery,
  Types.SubscriptionUpdateBillingSimulationQueryVariables
>
export const CancelScheduledBillingSeatsDocument = /*#__PURE__*/ gql`
  mutation cancelScheduledBillingSeats($workspaceId: UUID!) {
    cancelScheduledBillingSeats(input: { workspaceIdentifier: $workspaceId }) {
      workspace {
        identifier
        customer {
          identifier
          billing {
            seats {
              ...BillingSeatsInfo
            }
          }
        }
      }
    }
  }
  ${BillingSeatsInfoFragmentDoc}
`
export type CancelScheduledBillingSeatsMutationFn = Apollo.MutationFunction<
  Types.CancelScheduledBillingSeatsMutation,
  Types.CancelScheduledBillingSeatsMutationVariables
>

/**
 * __useCancelScheduledBillingSeatsMutation__
 *
 * To run a mutation, you first call `useCancelScheduledBillingSeatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledBillingSeatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduledBillingSeatsMutation, { data, loading, error }] = useCancelScheduledBillingSeatsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useCancelScheduledBillingSeatsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CancelScheduledBillingSeatsMutation,
    Types.CancelScheduledBillingSeatsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CancelScheduledBillingSeatsMutation,
    Types.CancelScheduledBillingSeatsMutationVariables
  >(CancelScheduledBillingSeatsDocument, options)
}
export type CancelScheduledBillingSeatsMutationHookResult = ReturnType<
  typeof useCancelScheduledBillingSeatsMutation
>
export type CancelScheduledBillingSeatsMutationResult =
  Apollo.MutationResult<Types.CancelScheduledBillingSeatsMutation>
export type CancelScheduledBillingSeatsMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CancelScheduledBillingSeatsMutation,
    Types.CancelScheduledBillingSeatsMutationVariables
  >
export const UpdateBillingSeatsDocument = /*#__PURE__*/ gql`
  mutation updateBillingSeats($input: UpdateBillingSeatsParams!) {
    updateBillingSeats(input: $input) {
      workspace {
        identifier
        customer {
          identifier
          billing {
            seats {
              ...BillingSeatsInfo
            }
          }
        }
      }
      pendingScaToken
    }
  }
  ${BillingSeatsInfoFragmentDoc}
`
export type UpdateBillingSeatsMutationFn = Apollo.MutationFunction<
  Types.UpdateBillingSeatsMutation,
  Types.UpdateBillingSeatsMutationVariables
>

/**
 * __useUpdateBillingSeatsMutation__
 *
 * To run a mutation, you first call `useUpdateBillingSeatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingSeatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingSeatsMutation, { data, loading, error }] = useUpdateBillingSeatsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillingSeatsMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateBillingSeatsMutation,
    Types.UpdateBillingSeatsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateBillingSeatsMutation,
    Types.UpdateBillingSeatsMutationVariables
  >(UpdateBillingSeatsDocument, options)
}
export type UpdateBillingSeatsMutationHookResult = ReturnType<
  typeof useUpdateBillingSeatsMutation
>
export type UpdateBillingSeatsMutationResult =
  Apollo.MutationResult<Types.UpdateBillingSeatsMutation>
export type UpdateBillingSeatsMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateBillingSeatsMutation,
  Types.UpdateBillingSeatsMutationVariables
>
export const ApplyCouponDocument = /*#__PURE__*/ gql`
  mutation applyCoupon($promotionCode: String!, $customerId: UUID!)
  @PaymentQLApi {
    applyCoupon(promotionCode: $promotionCode, customerId: $customerId) {
      customer {
        id
        subscriptionInfo {
          status
        }
      }
    }
  }
`
export type ApplyCouponMutationFn = Apollo.MutationFunction<
  Types.ApplyCouponMutation,
  Types.ApplyCouponMutationVariables
>

/**
 * __useApplyCouponMutation__
 *
 * To run a mutation, you first call `useApplyCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCouponMutation, { data, loading, error }] = useApplyCouponMutation({
 *   variables: {
 *      promotionCode: // value for 'promotionCode'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useApplyCouponMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ApplyCouponMutation,
    Types.ApplyCouponMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ApplyCouponMutation,
    Types.ApplyCouponMutationVariables
  >(ApplyCouponDocument, options)
}
export type ApplyCouponMutationHookResult = ReturnType<
  typeof useApplyCouponMutation
>
export type ApplyCouponMutationResult =
  Apollo.MutationResult<Types.ApplyCouponMutation>
export type ApplyCouponMutationOptions = Apollo.BaseMutationOptions<
  Types.ApplyCouponMutation,
  Types.ApplyCouponMutationVariables
>
export const GetClientCurrencyDocument = /*#__PURE__*/ gql`
  query getClientCurrency($token: String) @PaymentQLApi {
    currencies(token: $token) {
      default
      available
      restriction {
        reason
        countryCode
      }
    }
  }
`

/**
 * __useGetClientCurrencyQuery__
 *
 * To run a query within a React component, call `useGetClientCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientCurrencyQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetClientCurrencyQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetClientCurrencyQuery,
    Types.GetClientCurrencyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetClientCurrencyQuery,
    Types.GetClientCurrencyQueryVariables
  >(GetClientCurrencyDocument, options)
}
export function useGetClientCurrencyLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetClientCurrencyQuery,
    Types.GetClientCurrencyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetClientCurrencyQuery,
    Types.GetClientCurrencyQueryVariables
  >(GetClientCurrencyDocument, options)
}

export type GetClientCurrencyQueryHookResult = ReturnType<
  typeof useGetClientCurrencyQuery
>
export type GetClientCurrencyLazyQueryHookResult = ReturnType<
  typeof useGetClientCurrencyLazyQuery
>
export type GetClientCurrencyQueryResult = Apollo.QueryResult<
  Types.GetClientCurrencyQuery,
  Types.GetClientCurrencyQueryVariables
>
export const SubscribeCustomerToPlanDocument = /*#__PURE__*/ gql`
  mutation subscribeCustomerToPlan($input: SubscribeCustomerToPlanInput!)
  @PaymentQLApi {
    subscribeCustomerToPlan(input: $input) {
      pendingScaToken
      customer {
        id
        paymentDetails {
          ...PaymentDetails
        }
      }
    }
  }
  ${PaymentDetailsFragmentDoc}
`
export type SubscribeCustomerToPlanMutationFn = Apollo.MutationFunction<
  Types.SubscribeCustomerToPlanMutation,
  Types.SubscribeCustomerToPlanMutationVariables
>

/**
 * __useSubscribeCustomerToPlanMutation__
 *
 * To run a mutation, you first call `useSubscribeCustomerToPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeCustomerToPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeCustomerToPlanMutation, { data, loading, error }] = useSubscribeCustomerToPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeCustomerToPlanMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.SubscribeCustomerToPlanMutation,
    Types.SubscribeCustomerToPlanMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.SubscribeCustomerToPlanMutation,
    Types.SubscribeCustomerToPlanMutationVariables
  >(SubscribeCustomerToPlanDocument, options)
}
export type SubscribeCustomerToPlanMutationHookResult = ReturnType<
  typeof useSubscribeCustomerToPlanMutation
>
export type SubscribeCustomerToPlanMutationResult =
  Apollo.MutationResult<Types.SubscribeCustomerToPlanMutation>
export type SubscribeCustomerToPlanMutationOptions = Apollo.BaseMutationOptions<
  Types.SubscribeCustomerToPlanMutation,
  Types.SubscribeCustomerToPlanMutationVariables
>
export const GetCustomerDocument = /*#__PURE__*/ gql`
  query getCustomer($customerId: UUID!) @PaymentQLApi {
    customer(id: $customerId) {
      id
      creditBalance {
        ...CreditBalance
      }
      subscriptionInfo {
        renewalDate
        ... on CloudSubscription {
          pendingScaToken
        }
        ...SubscriptionInfoPlan
      }
      billingSummary {
        next {
          ...BillingPrice
        }
        current {
          currency
        }
      }
      paymentDetails {
        ...PaymentDetails
      }
      billingDetails {
        ...BillingDetails
      }
    }
  }
  ${CreditBalanceFragmentDoc}
  ${SubscriptionInfoPlanFragmentDoc}
  ${BillingPriceFragmentDoc}
  ${PaymentDetailsFragmentDoc}
  ${BillingDetailsFragmentDoc}
`

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetCustomerQuery,
    Types.GetCustomerQueryVariables
  > &
    (
      | { variables: Types.GetCustomerQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetCustomerQuery,
    Types.GetCustomerQueryVariables
  >(GetCustomerDocument, options)
}
export function useGetCustomerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetCustomerQuery,
    Types.GetCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetCustomerQuery,
    Types.GetCustomerQueryVariables
  >(GetCustomerDocument, options)
}

export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>
export type GetCustomerLazyQueryHookResult = ReturnType<
  typeof useGetCustomerLazyQuery
>
export type GetCustomerQueryResult = Apollo.QueryResult<
  Types.GetCustomerQuery,
  Types.GetCustomerQueryVariables
>
export const GetCustomerForPartnerSubscribeDocument = /*#__PURE__*/ gql`
  query getCustomerForPartnerSubscribe($customerId: UUID!) @PaymentQLApi {
    customer(id: $customerId) {
      id
      billingSummary {
        current {
          currency
        }
      }
      subscriptionInfo {
        status
        ... on CloudSubscription {
          trialEnd
          pendingScaToken
          scheduledSeatsTotal
          currentSeatsTotal
        }
        ...SubscriptionInfoPlan
      }
    }
  }
  ${SubscriptionInfoPlanFragmentDoc}
`

/**
 * __useGetCustomerForPartnerSubscribeQuery__
 *
 * To run a query within a React component, call `useGetCustomerForPartnerSubscribeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerForPartnerSubscribeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerForPartnerSubscribeQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerForPartnerSubscribeQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetCustomerForPartnerSubscribeQuery,
    Types.GetCustomerForPartnerSubscribeQueryVariables
  > &
    (
      | {
          variables: Types.GetCustomerForPartnerSubscribeQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetCustomerForPartnerSubscribeQuery,
    Types.GetCustomerForPartnerSubscribeQueryVariables
  >(GetCustomerForPartnerSubscribeDocument, options)
}
export function useGetCustomerForPartnerSubscribeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetCustomerForPartnerSubscribeQuery,
    Types.GetCustomerForPartnerSubscribeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetCustomerForPartnerSubscribeQuery,
    Types.GetCustomerForPartnerSubscribeQueryVariables
  >(GetCustomerForPartnerSubscribeDocument, options)
}

export type GetCustomerForPartnerSubscribeQueryHookResult = ReturnType<
  typeof useGetCustomerForPartnerSubscribeQuery
>
export type GetCustomerForPartnerSubscribeLazyQueryHookResult = ReturnType<
  typeof useGetCustomerForPartnerSubscribeLazyQuery
>
export type GetCustomerForPartnerSubscribeQueryResult = Apollo.QueryResult<
  Types.GetCustomerForPartnerSubscribeQuery,
  Types.GetCustomerForPartnerSubscribeQueryVariables
>
export const GetCustomerProviderDocument = /*#__PURE__*/ gql`
  query getCustomerProvider($customerId: UUID!) @PaymentQLApi {
    customer(id: $customerId) {
      id
      subscriptionInfo {
        status
      }
    }
  }
`

/**
 * __useGetCustomerProviderQuery__
 *
 * To run a query within a React component, call `useGetCustomerProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerProviderQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerProviderQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetCustomerProviderQuery,
    Types.GetCustomerProviderQueryVariables
  > &
    (
      | { variables: Types.GetCustomerProviderQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetCustomerProviderQuery,
    Types.GetCustomerProviderQueryVariables
  >(GetCustomerProviderDocument, options)
}
export function useGetCustomerProviderLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetCustomerProviderQuery,
    Types.GetCustomerProviderQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetCustomerProviderQuery,
    Types.GetCustomerProviderQueryVariables
  >(GetCustomerProviderDocument, options)
}

export type GetCustomerProviderQueryHookResult = ReturnType<
  typeof useGetCustomerProviderQuery
>
export type GetCustomerProviderLazyQueryHookResult = ReturnType<
  typeof useGetCustomerProviderLazyQuery
>
export type GetCustomerProviderQueryResult = Apollo.QueryResult<
  Types.GetCustomerProviderQuery,
  Types.GetCustomerProviderQueryVariables
>
export const GetCustomerSignupSourceDocument = /*#__PURE__*/ gql`
  query getCustomerSignupSource($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      customer {
        identifier
        source
      }
    }
  }
`

/**
 * __useGetCustomerSignupSourceQuery__
 *
 * To run a query within a React component, call `useGetCustomerSignupSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerSignupSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerSignupSourceQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetCustomerSignupSourceQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetCustomerSignupSourceQuery,
    Types.GetCustomerSignupSourceQueryVariables
  > &
    (
      | {
          variables: Types.GetCustomerSignupSourceQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetCustomerSignupSourceQuery,
    Types.GetCustomerSignupSourceQueryVariables
  >(GetCustomerSignupSourceDocument, options)
}
export function useGetCustomerSignupSourceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetCustomerSignupSourceQuery,
    Types.GetCustomerSignupSourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetCustomerSignupSourceQuery,
    Types.GetCustomerSignupSourceQueryVariables
  >(GetCustomerSignupSourceDocument, options)
}

export type GetCustomerSignupSourceQueryHookResult = ReturnType<
  typeof useGetCustomerSignupSourceQuery
>
export type GetCustomerSignupSourceLazyQueryHookResult = ReturnType<
  typeof useGetCustomerSignupSourceLazyQuery
>
export type GetCustomerSignupSourceQueryResult = Apollo.QueryResult<
  Types.GetCustomerSignupSourceQuery,
  Types.GetCustomerSignupSourceQueryVariables
>
export const DraftBillingSummaryDocument = /*#__PURE__*/ gql`
  query draftBillingSummary(
    $planId: String!
    $seats: Int!
    $promotionCode: String
    $currency: Currency
  ) @PaymentQLApi {
    draftBillingSummary(
      planID: $planId
      seats: $seats
      promotionCode: $promotionCode
      currency: $currency
    ) {
      memberPrice {
        ...BillingPrice
      }
      price {
        ...BillingPrice
      }
      trialEnd
      couponInfo {
        ...Coupon
      }
    }
  }
  ${BillingPriceFragmentDoc}
  ${CouponFragmentDoc}
`

/**
 * __useDraftBillingSummaryQuery__
 *
 * To run a query within a React component, call `useDraftBillingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftBillingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftBillingSummaryQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *      seats: // value for 'seats'
 *      promotionCode: // value for 'promotionCode'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useDraftBillingSummaryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.DraftBillingSummaryQuery,
    Types.DraftBillingSummaryQueryVariables
  > &
    (
      | { variables: Types.DraftBillingSummaryQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.DraftBillingSummaryQuery,
    Types.DraftBillingSummaryQueryVariables
  >(DraftBillingSummaryDocument, options)
}
export function useDraftBillingSummaryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.DraftBillingSummaryQuery,
    Types.DraftBillingSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.DraftBillingSummaryQuery,
    Types.DraftBillingSummaryQueryVariables
  >(DraftBillingSummaryDocument, options)
}

export type DraftBillingSummaryQueryHookResult = ReturnType<
  typeof useDraftBillingSummaryQuery
>
export type DraftBillingSummaryLazyQueryHookResult = ReturnType<
  typeof useDraftBillingSummaryLazyQuery
>
export type DraftBillingSummaryQueryResult = Apollo.QueryResult<
  Types.DraftBillingSummaryQuery,
  Types.DraftBillingSummaryQueryVariables
>
export const GetIntegrationIdentityConnectUrlDocument = /*#__PURE__*/ gql`
  mutation getIntegrationIdentityConnectUrl(
    $provider: IntegrationProvider!
    $workspaceIdentifier: UUID!
  ) {
    getIntegrationIdentityConnectUrl(
      provider: $provider
      workspaceIdentifier: $workspaceIdentifier
    ) {
      url
    }
  }
`
export type GetIntegrationIdentityConnectUrlMutationFn =
  Apollo.MutationFunction<
    Types.GetIntegrationIdentityConnectUrlMutation,
    Types.GetIntegrationIdentityConnectUrlMutationVariables
  >

/**
 * __useGetIntegrationIdentityConnectUrlMutation__
 *
 * To run a mutation, you first call `useGetIntegrationIdentityConnectUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationIdentityConnectUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getIntegrationIdentityConnectUrlMutation, { data, loading, error }] = useGetIntegrationIdentityConnectUrlMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *   },
 * });
 */
export function useGetIntegrationIdentityConnectUrlMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.GetIntegrationIdentityConnectUrlMutation,
    Types.GetIntegrationIdentityConnectUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.GetIntegrationIdentityConnectUrlMutation,
    Types.GetIntegrationIdentityConnectUrlMutationVariables
  >(GetIntegrationIdentityConnectUrlDocument, options)
}
export type GetIntegrationIdentityConnectUrlMutationHookResult = ReturnType<
  typeof useGetIntegrationIdentityConnectUrlMutation
>
export type GetIntegrationIdentityConnectUrlMutationResult =
  Apollo.MutationResult<Types.GetIntegrationIdentityConnectUrlMutation>
export type GetIntegrationIdentityConnectUrlMutationOptions =
  Apollo.BaseMutationOptions<
    Types.GetIntegrationIdentityConnectUrlMutation,
    Types.GetIntegrationIdentityConnectUrlMutationVariables
  >
export const RemoveIntegrationIdentityDocument = /*#__PURE__*/ gql`
  mutation removeIntegrationIdentity($identifier: UUID!) {
    removeIntegrationIdentity(identifier: $identifier) {
      integrationIdentity {
        identifier
      }
    }
  }
`
export type RemoveIntegrationIdentityMutationFn = Apollo.MutationFunction<
  Types.RemoveIntegrationIdentityMutation,
  Types.RemoveIntegrationIdentityMutationVariables
>

/**
 * __useRemoveIntegrationIdentityMutation__
 *
 * To run a mutation, you first call `useRemoveIntegrationIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIntegrationIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeIntegrationIdentityMutation, { data, loading, error }] = useRemoveIntegrationIdentityMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useRemoveIntegrationIdentityMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RemoveIntegrationIdentityMutation,
    Types.RemoveIntegrationIdentityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RemoveIntegrationIdentityMutation,
    Types.RemoveIntegrationIdentityMutationVariables
  >(RemoveIntegrationIdentityDocument, options)
}
export type RemoveIntegrationIdentityMutationHookResult = ReturnType<
  typeof useRemoveIntegrationIdentityMutation
>
export type RemoveIntegrationIdentityMutationResult =
  Apollo.MutationResult<Types.RemoveIntegrationIdentityMutation>
export type RemoveIntegrationIdentityMutationOptions =
  Apollo.BaseMutationOptions<
    Types.RemoveIntegrationIdentityMutation,
    Types.RemoveIntegrationIdentityMutationVariables
  >
export const GetIntegrationIdentitiesDocument = /*#__PURE__*/ gql`
  query getIntegrationIdentities($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      integrations {
        identifier
        integrationProvider
      }
    }
    me {
      identifier
      workspaceMemberships {
        entries {
          workspace {
            identifier
          }
          integrationIdentities {
            ...IntegrationIdentity
          }
        }
      }
    }
  }
  ${IntegrationIdentityFragmentDoc}
`

/**
 * __useGetIntegrationIdentitiesQuery__
 *
 * To run a query within a React component, call `useGetIntegrationIdentitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationIdentitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationIdentitiesQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetIntegrationIdentitiesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetIntegrationIdentitiesQuery,
    Types.GetIntegrationIdentitiesQueryVariables
  > &
    (
      | {
          variables: Types.GetIntegrationIdentitiesQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetIntegrationIdentitiesQuery,
    Types.GetIntegrationIdentitiesQueryVariables
  >(GetIntegrationIdentitiesDocument, options)
}
export function useGetIntegrationIdentitiesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetIntegrationIdentitiesQuery,
    Types.GetIntegrationIdentitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetIntegrationIdentitiesQuery,
    Types.GetIntegrationIdentitiesQueryVariables
  >(GetIntegrationIdentitiesDocument, options)
}

export type GetIntegrationIdentitiesQueryHookResult = ReturnType<
  typeof useGetIntegrationIdentitiesQuery
>
export type GetIntegrationIdentitiesLazyQueryHookResult = ReturnType<
  typeof useGetIntegrationIdentitiesLazyQuery
>
export type GetIntegrationIdentitiesQueryResult = Apollo.QueryResult<
  Types.GetIntegrationIdentitiesQuery,
  Types.GetIntegrationIdentitiesQueryVariables
>
export const UpdatePaymentMethodDocument = /*#__PURE__*/ gql`
  mutation updatePaymentMethod($input: UpdatePaymentMethodInput!)
  @PaymentQLApi {
    updatePaymentMethod(input: $input) {
      customer {
        id
        paymentDetails {
          ...PaymentDetails
        }
        subscriptionInfo {
          ... on CloudSubscription {
            pendingScaToken
          }
        }
      }
    }
  }
  ${PaymentDetailsFragmentDoc}
`
export type UpdatePaymentMethodMutationFn = Apollo.MutationFunction<
  Types.UpdatePaymentMethodMutation,
  Types.UpdatePaymentMethodMutationVariables
>

/**
 * __useUpdatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMethodMutation, { data, loading, error }] = useUpdatePaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentMethodMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdatePaymentMethodMutation,
    Types.UpdatePaymentMethodMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdatePaymentMethodMutation,
    Types.UpdatePaymentMethodMutationVariables
  >(UpdatePaymentMethodDocument, options)
}
export type UpdatePaymentMethodMutationHookResult = ReturnType<
  typeof useUpdatePaymentMethodMutation
>
export type UpdatePaymentMethodMutationResult =
  Apollo.MutationResult<Types.UpdatePaymentMethodMutation>
export type UpdatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdatePaymentMethodMutation,
  Types.UpdatePaymentMethodMutationVariables
>
export const CreateSetupIntentDocument = /*#__PURE__*/ gql`
  mutation createSetupIntent($input: CreateSetupIntentInput!) @PaymentQLApi {
    createSetupIntent(input: $input) {
      pendingScaToken
    }
  }
`
export type CreateSetupIntentMutationFn = Apollo.MutationFunction<
  Types.CreateSetupIntentMutation,
  Types.CreateSetupIntentMutationVariables
>

/**
 * __useCreateSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetupIntentMutation, { data, loading, error }] = useCreateSetupIntentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSetupIntentMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreateSetupIntentMutation,
    Types.CreateSetupIntentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreateSetupIntentMutation,
    Types.CreateSetupIntentMutationVariables
  >(CreateSetupIntentDocument, options)
}
export type CreateSetupIntentMutationHookResult = ReturnType<
  typeof useCreateSetupIntentMutation
>
export type CreateSetupIntentMutationResult =
  Apollo.MutationResult<Types.CreateSetupIntentMutation>
export type CreateSetupIntentMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateSetupIntentMutation,
  Types.CreateSetupIntentMutationVariables
>
export const GetPaymentDetailsDocument = /*#__PURE__*/ gql`
  query getPaymentDetails($customerId: UUID!) @PaymentQLApi {
    customer(id: $customerId) {
      id
      paymentDetails {
        ...PaymentDetails
      }
    }
  }
  ${PaymentDetailsFragmentDoc}
`

/**
 * __useGetPaymentDetailsQuery__
 *
 * To run a query within a React component, call `useGetPaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentDetailsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetPaymentDetailsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPaymentDetailsQuery,
    Types.GetPaymentDetailsQueryVariables
  > &
    (
      | { variables: Types.GetPaymentDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPaymentDetailsQuery,
    Types.GetPaymentDetailsQueryVariables
  >(GetPaymentDetailsDocument, options)
}
export function useGetPaymentDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPaymentDetailsQuery,
    Types.GetPaymentDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPaymentDetailsQuery,
    Types.GetPaymentDetailsQueryVariables
  >(GetPaymentDetailsDocument, options)
}

export type GetPaymentDetailsQueryHookResult = ReturnType<
  typeof useGetPaymentDetailsQuery
>
export type GetPaymentDetailsLazyQueryHookResult = ReturnType<
  typeof useGetPaymentDetailsLazyQuery
>
export type GetPaymentDetailsQueryResult = Apollo.QueryResult<
  Types.GetPaymentDetailsQuery,
  Types.GetPaymentDetailsQueryVariables
>
export const GetSeatsUpdateBillingSimulationDocument = /*#__PURE__*/ gql`
  query getSeatsUpdateBillingSimulation(
    $customerId: UUID!
    $totalSeats: Int!
    $cycle: BillingSimulationCycle! = CURRENT
  ) @PaymentQLApi {
    seatsUpdateBillingSimulation(
      customerId: $customerId
      seats: $totalSeats
      cycle: $cycle
    ) {
      price {
        ...BillingPrice
      }
      extraSeatsPrice {
        ...BillingPrice
      }
      plan {
        ...BillingPlanInfo
      }
      prorated {
        price {
          ...Price
        }
        creditsAmount
        chargeAmount
        daysElapsedInCycle
        discountForUnusedDays
      }
      couponInfo {
        ...Coupon
      }
    }
  }
  ${BillingPriceFragmentDoc}
  ${BillingPlanInfoFragmentDoc}
  ${PriceFragmentDoc}
  ${CouponFragmentDoc}
`

/**
 * __useGetSeatsUpdateBillingSimulationQuery__
 *
 * To run a query within a React component, call `useGetSeatsUpdateBillingSimulationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeatsUpdateBillingSimulationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeatsUpdateBillingSimulationQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      totalSeats: // value for 'totalSeats'
 *      cycle: // value for 'cycle'
 *   },
 * });
 */
export function useGetSeatsUpdateBillingSimulationQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetSeatsUpdateBillingSimulationQuery,
    Types.GetSeatsUpdateBillingSimulationQueryVariables
  > &
    (
      | {
          variables: Types.GetSeatsUpdateBillingSimulationQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetSeatsUpdateBillingSimulationQuery,
    Types.GetSeatsUpdateBillingSimulationQueryVariables
  >(GetSeatsUpdateBillingSimulationDocument, options)
}
export function useGetSeatsUpdateBillingSimulationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetSeatsUpdateBillingSimulationQuery,
    Types.GetSeatsUpdateBillingSimulationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetSeatsUpdateBillingSimulationQuery,
    Types.GetSeatsUpdateBillingSimulationQueryVariables
  >(GetSeatsUpdateBillingSimulationDocument, options)
}

export type GetSeatsUpdateBillingSimulationQueryHookResult = ReturnType<
  typeof useGetSeatsUpdateBillingSimulationQuery
>
export type GetSeatsUpdateBillingSimulationLazyQueryHookResult = ReturnType<
  typeof useGetSeatsUpdateBillingSimulationLazyQuery
>
export type GetSeatsUpdateBillingSimulationQueryResult = Apollo.QueryResult<
  Types.GetSeatsUpdateBillingSimulationQuery,
  Types.GetSeatsUpdateBillingSimulationQueryVariables
>
export const CancelSubscriptionDocument = /*#__PURE__*/ gql`
  mutation cancelSubscription($customerId: UUID!) @PaymentQLApi {
    cancelSubscription(customerId: $customerId) {
      customer {
        id
        subscriptionInfo {
          subscriptionEnd
          renewalDate
        }
        billingSummary {
          next {
            ...BillingPrice
          }
          current {
            currency
          }
        }
      }
    }
  }
  ${BillingPriceFragmentDoc}
`
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<
  Types.CancelSubscriptionMutation,
  Types.CancelSubscriptionMutationVariables
>

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CancelSubscriptionMutation,
    Types.CancelSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CancelSubscriptionMutation,
    Types.CancelSubscriptionMutationVariables
  >(CancelSubscriptionDocument, options)
}
export type CancelSubscriptionMutationHookResult = ReturnType<
  typeof useCancelSubscriptionMutation
>
export type CancelSubscriptionMutationResult =
  Apollo.MutationResult<Types.CancelSubscriptionMutation>
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  Types.CancelSubscriptionMutation,
  Types.CancelSubscriptionMutationVariables
>
export const UndoScheduledSubscriptionCancellationDocument = /*#__PURE__*/ gql`
  mutation undoScheduledSubscriptionCancellation($customerId: UUID!)
  @PaymentQLApi {
    undoScheduledSubscriptionCancellation(customerId: $customerId) {
      customer {
        id
        subscriptionInfo {
          subscriptionEnd
          renewalDate
        }
        billingSummary {
          next {
            ...BillingPrice
          }
          current {
            currency
          }
        }
      }
    }
  }
  ${BillingPriceFragmentDoc}
`
export type UndoScheduledSubscriptionCancellationMutationFn =
  Apollo.MutationFunction<
    Types.UndoScheduledSubscriptionCancellationMutation,
    Types.UndoScheduledSubscriptionCancellationMutationVariables
  >

/**
 * __useUndoScheduledSubscriptionCancellationMutation__
 *
 * To run a mutation, you first call `useUndoScheduledSubscriptionCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoScheduledSubscriptionCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoScheduledSubscriptionCancellationMutation, { data, loading, error }] = useUndoScheduledSubscriptionCancellationMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useUndoScheduledSubscriptionCancellationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UndoScheduledSubscriptionCancellationMutation,
    Types.UndoScheduledSubscriptionCancellationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UndoScheduledSubscriptionCancellationMutation,
    Types.UndoScheduledSubscriptionCancellationMutationVariables
  >(UndoScheduledSubscriptionCancellationDocument, options)
}
export type UndoScheduledSubscriptionCancellationMutationHookResult =
  ReturnType<typeof useUndoScheduledSubscriptionCancellationMutation>
export type UndoScheduledSubscriptionCancellationMutationResult =
  Apollo.MutationResult<Types.UndoScheduledSubscriptionCancellationMutation>
export type UndoScheduledSubscriptionCancellationMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UndoScheduledSubscriptionCancellationMutation,
    Types.UndoScheduledSubscriptionCancellationMutationVariables
  >
export const ReactivateSubscriptionDocument = /*#__PURE__*/ gql`
  mutation ReactivateSubscription($customerId: UUID!) @PaymentQLApi {
    reactivateSubscription(customerId: $customerId) {
      customer {
        id
      }
    }
  }
`
export type ReactivateSubscriptionMutationFn = Apollo.MutationFunction<
  Types.ReactivateSubscriptionMutation,
  Types.ReactivateSubscriptionMutationVariables
>

/**
 * __useReactivateSubscriptionMutation__
 *
 * To run a mutation, you first call `useReactivateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateSubscriptionMutation, { data, loading, error }] = useReactivateSubscriptionMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useReactivateSubscriptionMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ReactivateSubscriptionMutation,
    Types.ReactivateSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ReactivateSubscriptionMutation,
    Types.ReactivateSubscriptionMutationVariables
  >(ReactivateSubscriptionDocument, options)
}
export type ReactivateSubscriptionMutationHookResult = ReturnType<
  typeof useReactivateSubscriptionMutation
>
export type ReactivateSubscriptionMutationResult =
  Apollo.MutationResult<Types.ReactivateSubscriptionMutation>
export type ReactivateSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  Types.ReactivateSubscriptionMutation,
  Types.ReactivateSubscriptionMutationVariables
>
export const GetTaxableCountriesDocument = /*#__PURE__*/ gql`
  query getTaxableCountries @PaymentQLApi {
    taxableCountries {
      code
    }
  }
`

/**
 * __useGetTaxableCountriesQuery__
 *
 * To run a query within a React component, call `useGetTaxableCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxableCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxableCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxableCountriesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetTaxableCountriesQuery,
    Types.GetTaxableCountriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetTaxableCountriesQuery,
    Types.GetTaxableCountriesQueryVariables
  >(GetTaxableCountriesDocument, options)
}
export function useGetTaxableCountriesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetTaxableCountriesQuery,
    Types.GetTaxableCountriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetTaxableCountriesQuery,
    Types.GetTaxableCountriesQueryVariables
  >(GetTaxableCountriesDocument, options)
}

export type GetTaxableCountriesQueryHookResult = ReturnType<
  typeof useGetTaxableCountriesQuery
>
export type GetTaxableCountriesLazyQueryHookResult = ReturnType<
  typeof useGetTaxableCountriesLazyQuery
>
export type GetTaxableCountriesQueryResult = Apollo.QueryResult<
  Types.GetTaxableCountriesQuery,
  Types.GetTaxableCountriesQueryVariables
>
export const CreateWorkspaceDocument = /*#__PURE__*/ gql`
  mutation createWorkspace($input: CreateWorkspaceParams!) {
    createWorkspace(input: $input) {
      pendingScaToken
      workspace {
        ...WorkspaceMinimal
        memberships {
          list(limit: 1) {
            entries {
              identifier
              role
            }
          }
        }
      }
    }
  }
  ${WorkspaceMinimalFragmentDoc}
`
export type CreateWorkspaceMutationFn = Apollo.MutationFunction<
  Types.CreateWorkspaceMutation,
  Types.CreateWorkspaceMutationVariables
>

/**
 * __useCreateWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceMutation, { data, loading, error }] = useCreateWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkspaceMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreateWorkspaceMutation,
    Types.CreateWorkspaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreateWorkspaceMutation,
    Types.CreateWorkspaceMutationVariables
  >(CreateWorkspaceDocument, options)
}
export type CreateWorkspaceMutationHookResult = ReturnType<
  typeof useCreateWorkspaceMutation
>
export type CreateWorkspaceMutationResult =
  Apollo.MutationResult<Types.CreateWorkspaceMutation>
export type CreateWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateWorkspaceMutation,
  Types.CreateWorkspaceMutationVariables
>
export const UpgradePersonalWorkspaceDocument = /*#__PURE__*/ gql`
  mutation upgradePersonalWorkspace($input: UpgradePersonalWorkspaceParams!) {
    upgradePersonalWorkspace(input: $input) {
      workspace {
        ...WorkspaceMinimal
        memberships {
          list(limit: 1) {
            entries {
              identifier
              role
            }
          }
        }
      }
    }
  }
  ${WorkspaceMinimalFragmentDoc}
`
export type UpgradePersonalWorkspaceMutationFn = Apollo.MutationFunction<
  Types.UpgradePersonalWorkspaceMutation,
  Types.UpgradePersonalWorkspaceMutationVariables
>

/**
 * __useUpgradePersonalWorkspaceMutation__
 *
 * To run a mutation, you first call `useUpgradePersonalWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradePersonalWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradePersonalWorkspaceMutation, { data, loading, error }] = useUpgradePersonalWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpgradePersonalWorkspaceMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpgradePersonalWorkspaceMutation,
    Types.UpgradePersonalWorkspaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpgradePersonalWorkspaceMutation,
    Types.UpgradePersonalWorkspaceMutationVariables
  >(UpgradePersonalWorkspaceDocument, options)
}
export type UpgradePersonalWorkspaceMutationHookResult = ReturnType<
  typeof useUpgradePersonalWorkspaceMutation
>
export type UpgradePersonalWorkspaceMutationResult =
  Apollo.MutationResult<Types.UpgradePersonalWorkspaceMutation>
export type UpgradePersonalWorkspaceMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpgradePersonalWorkspaceMutation,
    Types.UpgradePersonalWorkspaceMutationVariables
  >
export const AcceptWorkspaceInviteDocument = /*#__PURE__*/ gql`
  mutation acceptWorkspaceInvite(
    $membershipToken: String
    $membershipId: UUID
  ) {
    acceptWorkspaceInvite(
      membershipToken: $membershipToken
      membershipIdentifier: $membershipId
    ) {
      membership {
        identifier
        acceptedAt
        inviter {
          identifier
          name
        }
        workspace {
          identifier
          name
        }
      }
    }
  }
`
export type AcceptWorkspaceInviteMutationFn = Apollo.MutationFunction<
  Types.AcceptWorkspaceInviteMutation,
  Types.AcceptWorkspaceInviteMutationVariables
>

/**
 * __useAcceptWorkspaceInviteMutation__
 *
 * To run a mutation, you first call `useAcceptWorkspaceInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptWorkspaceInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptWorkspaceInviteMutation, { data, loading, error }] = useAcceptWorkspaceInviteMutation({
 *   variables: {
 *      membershipToken: // value for 'membershipToken'
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useAcceptWorkspaceInviteMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AcceptWorkspaceInviteMutation,
    Types.AcceptWorkspaceInviteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AcceptWorkspaceInviteMutation,
    Types.AcceptWorkspaceInviteMutationVariables
  >(AcceptWorkspaceInviteDocument, options)
}
export type AcceptWorkspaceInviteMutationHookResult = ReturnType<
  typeof useAcceptWorkspaceInviteMutation
>
export type AcceptWorkspaceInviteMutationResult =
  Apollo.MutationResult<Types.AcceptWorkspaceInviteMutation>
export type AcceptWorkspaceInviteMutationOptions = Apollo.BaseMutationOptions<
  Types.AcceptWorkspaceInviteMutation,
  Types.AcceptWorkspaceInviteMutationVariables
>
export const UpdateWorkspaceDocument = /*#__PURE__*/ gql`
  mutation updateWorkspace($input: UpdateWorkspaceParams!) {
    updateWorkspace(input: $input) {
      workspace {
        identifier
        name
        avatar {
          large
          small
        }
      }
    }
  }
`
export type UpdateWorkspaceMutationFn = Apollo.MutationFunction<
  Types.UpdateWorkspaceMutation,
  Types.UpdateWorkspaceMutationVariables
>

/**
 * __useUpdateWorkspaceMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceMutation, { data, loading, error }] = useUpdateWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateWorkspaceMutation,
    Types.UpdateWorkspaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateWorkspaceMutation,
    Types.UpdateWorkspaceMutationVariables
  >(UpdateWorkspaceDocument, options)
}
export type UpdateWorkspaceMutationHookResult = ReturnType<
  typeof useUpdateWorkspaceMutation
>
export type UpdateWorkspaceMutationResult =
  Apollo.MutationResult<Types.UpdateWorkspaceMutation>
export type UpdateWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateWorkspaceMutation,
  Types.UpdateWorkspaceMutationVariables
>
export const DeleteWorkspaceAvatarDocument = /*#__PURE__*/ gql`
  mutation deleteWorkspaceAvatar($workspaceId: UUID!) {
    deleteWorkspaceAvatar(identifier: $workspaceId) {
      workspace {
        identifier
        avatar {
          small
          large
        }
      }
    }
  }
`
export type DeleteWorkspaceAvatarMutationFn = Apollo.MutationFunction<
  Types.DeleteWorkspaceAvatarMutation,
  Types.DeleteWorkspaceAvatarMutationVariables
>

/**
 * __useDeleteWorkspaceAvatarMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceAvatarMutation, { data, loading, error }] = useDeleteWorkspaceAvatarMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteWorkspaceAvatarMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeleteWorkspaceAvatarMutation,
    Types.DeleteWorkspaceAvatarMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeleteWorkspaceAvatarMutation,
    Types.DeleteWorkspaceAvatarMutationVariables
  >(DeleteWorkspaceAvatarDocument, options)
}
export type DeleteWorkspaceAvatarMutationHookResult = ReturnType<
  typeof useDeleteWorkspaceAvatarMutation
>
export type DeleteWorkspaceAvatarMutationResult =
  Apollo.MutationResult<Types.DeleteWorkspaceAvatarMutation>
export type DeleteWorkspaceAvatarMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteWorkspaceAvatarMutation,
  Types.DeleteWorkspaceAvatarMutationVariables
>
export const DeleteWorkspaceDocument = /*#__PURE__*/ gql`
  mutation deleteWorkspace($workspaceId: UUID!, $password: String) {
    deleteWorkspace(identifier: $workspaceId, password: $password) {
      deletedWorkspace {
        identifier
      }
    }
  }
`
export type DeleteWorkspaceMutationFn = Apollo.MutationFunction<
  Types.DeleteWorkspaceMutation,
  Types.DeleteWorkspaceMutationVariables
>

/**
 * __useDeleteWorkspaceMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceMutation, { data, loading, error }] = useDeleteWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useDeleteWorkspaceMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeleteWorkspaceMutation,
    Types.DeleteWorkspaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeleteWorkspaceMutation,
    Types.DeleteWorkspaceMutationVariables
  >(DeleteWorkspaceDocument, options)
}
export type DeleteWorkspaceMutationHookResult = ReturnType<
  typeof useDeleteWorkspaceMutation
>
export type DeleteWorkspaceMutationResult =
  Apollo.MutationResult<Types.DeleteWorkspaceMutation>
export type DeleteWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  Types.DeleteWorkspaceMutation,
  Types.DeleteWorkspaceMutationVariables
>
export const AgreeToWorkspaceCustomerTermsOfServiceDocument = /*#__PURE__*/ gql`
  mutation agreeToWorkspaceCustomerTermsOfService(
    $customerId: UUID!
    $tosAgreed: Boolean!
  ) {
    agreeToWorkspaceCustomerTermsOfService(
      customerIdentifier: $customerId
      agreed: $tosAgreed
    ) {
      customer {
        identifier
        tosAgreed
      }
    }
  }
`
export type AgreeToWorkspaceCustomerTermsOfServiceMutationFn =
  Apollo.MutationFunction<
    Types.AgreeToWorkspaceCustomerTermsOfServiceMutation,
    Types.AgreeToWorkspaceCustomerTermsOfServiceMutationVariables
  >

/**
 * __useAgreeToWorkspaceCustomerTermsOfServiceMutation__
 *
 * To run a mutation, you first call `useAgreeToWorkspaceCustomerTermsOfServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgreeToWorkspaceCustomerTermsOfServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agreeToWorkspaceCustomerTermsOfServiceMutation, { data, loading, error }] = useAgreeToWorkspaceCustomerTermsOfServiceMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      tosAgreed: // value for 'tosAgreed'
 *   },
 * });
 */
export function useAgreeToWorkspaceCustomerTermsOfServiceMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AgreeToWorkspaceCustomerTermsOfServiceMutation,
    Types.AgreeToWorkspaceCustomerTermsOfServiceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AgreeToWorkspaceCustomerTermsOfServiceMutation,
    Types.AgreeToWorkspaceCustomerTermsOfServiceMutationVariables
  >(AgreeToWorkspaceCustomerTermsOfServiceDocument, options)
}
export type AgreeToWorkspaceCustomerTermsOfServiceMutationHookResult =
  ReturnType<typeof useAgreeToWorkspaceCustomerTermsOfServiceMutation>
export type AgreeToWorkspaceCustomerTermsOfServiceMutationResult =
  Apollo.MutationResult<Types.AgreeToWorkspaceCustomerTermsOfServiceMutation>
export type AgreeToWorkspaceCustomerTermsOfServiceMutationOptions =
  Apollo.BaseMutationOptions<
    Types.AgreeToWorkspaceCustomerTermsOfServiceMutation,
    Types.AgreeToWorkspaceCustomerTermsOfServiceMutationVariables
  >
export const UpdateRestrictedUploadsStateDocument = /*#__PURE__*/ gql`
  mutation updateRestrictedUploadsState(
    $workspaceId: UUID!
    $enableRestrictedUploads: Boolean!
  ) {
    updateRestrictedUploadsState(
      input: {
        identifier: $workspaceId
        restrictedUploads: $enableRestrictedUploads
      }
    ) {
      workspace {
        identifier
        uploadsRestrictedFor
      }
    }
  }
`
export type UpdateRestrictedUploadsStateMutationFn = Apollo.MutationFunction<
  Types.UpdateRestrictedUploadsStateMutation,
  Types.UpdateRestrictedUploadsStateMutationVariables
>

/**
 * __useUpdateRestrictedUploadsStateMutation__
 *
 * To run a mutation, you first call `useUpdateRestrictedUploadsStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRestrictedUploadsStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRestrictedUploadsStateMutation, { data, loading, error }] = useUpdateRestrictedUploadsStateMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      enableRestrictedUploads: // value for 'enableRestrictedUploads'
 *   },
 * });
 */
export function useUpdateRestrictedUploadsStateMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateRestrictedUploadsStateMutation,
    Types.UpdateRestrictedUploadsStateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateRestrictedUploadsStateMutation,
    Types.UpdateRestrictedUploadsStateMutationVariables
  >(UpdateRestrictedUploadsStateDocument, options)
}
export type UpdateRestrictedUploadsStateMutationHookResult = ReturnType<
  typeof useUpdateRestrictedUploadsStateMutation
>
export type UpdateRestrictedUploadsStateMutationResult =
  Apollo.MutationResult<Types.UpdateRestrictedUploadsStateMutation>
export type UpdateRestrictedUploadsStateMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateRestrictedUploadsStateMutation,
    Types.UpdateRestrictedUploadsStateMutationVariables
  >
export const UpdateRestrictedPublicLinksDocument = /*#__PURE__*/ gql`
  mutation updateRestrictedPublicLinks(
    $workspaceId: UUID!
    $enabled: Boolean!
  ) {
    updateRestrictedPublicLinks(
      input: { workspaceIdentifier: $workspaceId, enabled: $enabled }
    ) {
      workspace {
        identifier
        features {
          restrictedPublicLinks
        }
      }
    }
  }
`
export type UpdateRestrictedPublicLinksMutationFn = Apollo.MutationFunction<
  Types.UpdateRestrictedPublicLinksMutation,
  Types.UpdateRestrictedPublicLinksMutationVariables
>

/**
 * __useUpdateRestrictedPublicLinksMutation__
 *
 * To run a mutation, you first call `useUpdateRestrictedPublicLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRestrictedPublicLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRestrictedPublicLinksMutation, { data, loading, error }] = useUpdateRestrictedPublicLinksMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateRestrictedPublicLinksMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateRestrictedPublicLinksMutation,
    Types.UpdateRestrictedPublicLinksMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateRestrictedPublicLinksMutation,
    Types.UpdateRestrictedPublicLinksMutationVariables
  >(UpdateRestrictedPublicLinksDocument, options)
}
export type UpdateRestrictedPublicLinksMutationHookResult = ReturnType<
  typeof useUpdateRestrictedPublicLinksMutation
>
export type UpdateRestrictedPublicLinksMutationResult =
  Apollo.MutationResult<Types.UpdateRestrictedPublicLinksMutation>
export type UpdateRestrictedPublicLinksMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateRestrictedPublicLinksMutation,
    Types.UpdateRestrictedPublicLinksMutationVariables
  >
export const EnableSupportAccessDocument = /*#__PURE__*/ gql`
  mutation enableSupportAccess($identifier: UUID!) {
    enableSupportAccess(identifier: $identifier) {
      workspace {
        supportAccessGrantedUntil
      }
    }
  }
`
export type EnableSupportAccessMutationFn = Apollo.MutationFunction<
  Types.EnableSupportAccessMutation,
  Types.EnableSupportAccessMutationVariables
>

/**
 * __useEnableSupportAccessMutation__
 *
 * To run a mutation, you first call `useEnableSupportAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableSupportAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableSupportAccessMutation, { data, loading, error }] = useEnableSupportAccessMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useEnableSupportAccessMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.EnableSupportAccessMutation,
    Types.EnableSupportAccessMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.EnableSupportAccessMutation,
    Types.EnableSupportAccessMutationVariables
  >(EnableSupportAccessDocument, options)
}
export type EnableSupportAccessMutationHookResult = ReturnType<
  typeof useEnableSupportAccessMutation
>
export type EnableSupportAccessMutationResult =
  Apollo.MutationResult<Types.EnableSupportAccessMutation>
export type EnableSupportAccessMutationOptions = Apollo.BaseMutationOptions<
  Types.EnableSupportAccessMutation,
  Types.EnableSupportAccessMutationVariables
>
export const DisableSupportAccessDocument = /*#__PURE__*/ gql`
  mutation disableSupportAccess($identifier: UUID!) {
    disableSupportAccess(identifier: $identifier) {
      workspace {
        supportAccessGrantedUntil
      }
    }
  }
`
export type DisableSupportAccessMutationFn = Apollo.MutationFunction<
  Types.DisableSupportAccessMutation,
  Types.DisableSupportAccessMutationVariables
>

/**
 * __useDisableSupportAccessMutation__
 *
 * To run a mutation, you first call `useDisableSupportAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableSupportAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableSupportAccessMutation, { data, loading, error }] = useDisableSupportAccessMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useDisableSupportAccessMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DisableSupportAccessMutation,
    Types.DisableSupportAccessMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DisableSupportAccessMutation,
    Types.DisableSupportAccessMutationVariables
  >(DisableSupportAccessDocument, options)
}
export type DisableSupportAccessMutationHookResult = ReturnType<
  typeof useDisableSupportAccessMutation
>
export type DisableSupportAccessMutationResult =
  Apollo.MutationResult<Types.DisableSupportAccessMutation>
export type DisableSupportAccessMutationOptions = Apollo.BaseMutationOptions<
  Types.DisableSupportAccessMutation,
  Types.DisableSupportAccessMutationVariables
>
export const WorkspaceMembersReportDocument = /*#__PURE__*/ gql`
  mutation workspaceMembersReport($workspaceIdentifier: UUID!) {
    workspaceMembersReport(workspaceIdentifier: $workspaceIdentifier) {
      downloadUrl
    }
  }
`
export type WorkspaceMembersReportMutationFn = Apollo.MutationFunction<
  Types.WorkspaceMembersReportMutation,
  Types.WorkspaceMembersReportMutationVariables
>

/**
 * __useWorkspaceMembersReportMutation__
 *
 * To run a mutation, you first call `useWorkspaceMembersReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceMembersReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workspaceMembersReportMutation, { data, loading, error }] = useWorkspaceMembersReportMutation({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *   },
 * });
 */
export function useWorkspaceMembersReportMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.WorkspaceMembersReportMutation,
    Types.WorkspaceMembersReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.WorkspaceMembersReportMutation,
    Types.WorkspaceMembersReportMutationVariables
  >(WorkspaceMembersReportDocument, options)
}
export type WorkspaceMembersReportMutationHookResult = ReturnType<
  typeof useWorkspaceMembersReportMutation
>
export type WorkspaceMembersReportMutationResult =
  Apollo.MutationResult<Types.WorkspaceMembersReportMutation>
export type WorkspaceMembersReportMutationOptions = Apollo.BaseMutationOptions<
  Types.WorkspaceMembersReportMutation,
  Types.WorkspaceMembersReportMutationVariables
>
export const UpdateWorkspaceSecurityEmailDocument = /*#__PURE__*/ gql`
  mutation updateWorkspaceSecurityEmail(
    $identifier: UUID!
    $securityEmail: Email!
  ) {
    updateWorkspaceSecurityEmail(
      input: { identifier: $identifier, securityEmail: $securityEmail }
    ) {
      workspace {
        identifier
        securityEmail
      }
    }
  }
`
export type UpdateWorkspaceSecurityEmailMutationFn = Apollo.MutationFunction<
  Types.UpdateWorkspaceSecurityEmailMutation,
  Types.UpdateWorkspaceSecurityEmailMutationVariables
>

/**
 * __useUpdateWorkspaceSecurityEmailMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceSecurityEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceSecurityEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceSecurityEmailMutation, { data, loading, error }] = useUpdateWorkspaceSecurityEmailMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      securityEmail: // value for 'securityEmail'
 *   },
 * });
 */
export function useUpdateWorkspaceSecurityEmailMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateWorkspaceSecurityEmailMutation,
    Types.UpdateWorkspaceSecurityEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateWorkspaceSecurityEmailMutation,
    Types.UpdateWorkspaceSecurityEmailMutationVariables
  >(UpdateWorkspaceSecurityEmailDocument, options)
}
export type UpdateWorkspaceSecurityEmailMutationHookResult = ReturnType<
  typeof useUpdateWorkspaceSecurityEmailMutation
>
export type UpdateWorkspaceSecurityEmailMutationResult =
  Apollo.MutationResult<Types.UpdateWorkspaceSecurityEmailMutation>
export type UpdateWorkspaceSecurityEmailMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateWorkspaceSecurityEmailMutation,
    Types.UpdateWorkspaceSecurityEmailMutationVariables
  >
export const ConfigureWorkspaceEncryptionKeysDocument = /*#__PURE__*/ gql`
  mutation configureWorkspaceEncryptionKeys(
    $encryptionParams: ConfigureWorkspaceEncryptionKeysParams!
  ) {
    configureWorkspaceEncryptionKeys(input: $encryptionParams) {
      workspace {
        identifier
        features {
          encryptionEnabled
        }
        encryptionConfig {
          roleArn
          kmsArns
        }
      }
    }
  }
`
export type ConfigureWorkspaceEncryptionKeysMutationFn =
  Apollo.MutationFunction<
    Types.ConfigureWorkspaceEncryptionKeysMutation,
    Types.ConfigureWorkspaceEncryptionKeysMutationVariables
  >

/**
 * __useConfigureWorkspaceEncryptionKeysMutation__
 *
 * To run a mutation, you first call `useConfigureWorkspaceEncryptionKeysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureWorkspaceEncryptionKeysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureWorkspaceEncryptionKeysMutation, { data, loading, error }] = useConfigureWorkspaceEncryptionKeysMutation({
 *   variables: {
 *      encryptionParams: // value for 'encryptionParams'
 *   },
 * });
 */
export function useConfigureWorkspaceEncryptionKeysMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ConfigureWorkspaceEncryptionKeysMutation,
    Types.ConfigureWorkspaceEncryptionKeysMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ConfigureWorkspaceEncryptionKeysMutation,
    Types.ConfigureWorkspaceEncryptionKeysMutationVariables
  >(ConfigureWorkspaceEncryptionKeysDocument, options)
}
export type ConfigureWorkspaceEncryptionKeysMutationHookResult = ReturnType<
  typeof useConfigureWorkspaceEncryptionKeysMutation
>
export type ConfigureWorkspaceEncryptionKeysMutationResult =
  Apollo.MutationResult<Types.ConfigureWorkspaceEncryptionKeysMutation>
export type ConfigureWorkspaceEncryptionKeysMutationOptions =
  Apollo.BaseMutationOptions<
    Types.ConfigureWorkspaceEncryptionKeysMutation,
    Types.ConfigureWorkspaceEncryptionKeysMutationVariables
  >
export const GetWorkspacesDocument = /*#__PURE__*/ gql`
  query getWorkspaces {
    me {
      identifier
      personalWorkspace {
        ...WorkspaceMinimal
      }
      workspaces {
        ...WorkspaceMinimalWithBillingStatus
      }
    }
  }
  ${WorkspaceMinimalFragmentDoc}
  ${WorkspaceMinimalWithBillingStatusFragmentDoc}
`

/**
 * __useGetWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkspacesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspacesQuery,
    Types.GetWorkspacesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspacesQuery,
    Types.GetWorkspacesQueryVariables
  >(GetWorkspacesDocument, options)
}
export function useGetWorkspacesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspacesQuery,
    Types.GetWorkspacesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspacesQuery,
    Types.GetWorkspacesQueryVariables
  >(GetWorkspacesDocument, options)
}

export type GetWorkspacesQueryHookResult = ReturnType<
  typeof useGetWorkspacesQuery
>
export type GetWorkspacesLazyQueryHookResult = ReturnType<
  typeof useGetWorkspacesLazyQuery
>
export type GetWorkspacesQueryResult = Apollo.QueryResult<
  Types.GetWorkspacesQuery,
  Types.GetWorkspacesQueryVariables
>
export const GetWorkspacesForDuplicationDocument = /*#__PURE__*/ gql`
  query getWorkspacesForDuplication {
    me {
      identifier
      workspaces {
        ...DuplicationWorkspace
      }
    }
  }
  ${DuplicationWorkspaceFragmentDoc}
`

/**
 * __useGetWorkspacesForDuplicationQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesForDuplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesForDuplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesForDuplicationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkspacesForDuplicationQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspacesForDuplicationQuery,
    Types.GetWorkspacesForDuplicationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspacesForDuplicationQuery,
    Types.GetWorkspacesForDuplicationQueryVariables
  >(GetWorkspacesForDuplicationDocument, options)
}
export function useGetWorkspacesForDuplicationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspacesForDuplicationQuery,
    Types.GetWorkspacesForDuplicationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspacesForDuplicationQuery,
    Types.GetWorkspacesForDuplicationQueryVariables
  >(GetWorkspacesForDuplicationDocument, options)
}

export type GetWorkspacesForDuplicationQueryHookResult = ReturnType<
  typeof useGetWorkspacesForDuplicationQuery
>
export type GetWorkspacesForDuplicationLazyQueryHookResult = ReturnType<
  typeof useGetWorkspacesForDuplicationLazyQuery
>
export type GetWorkspacesForDuplicationQueryResult = Apollo.QueryResult<
  Types.GetWorkspacesForDuplicationQuery,
  Types.GetWorkspacesForDuplicationQueryVariables
>
export const GetWorkspaceDocument = /*#__PURE__*/ gql`
  query getWorkspace($identifier: UUID!) {
    workspace(identifier: $identifier) {
      ...WorkspaceMinimalWithBillingStatus
    }
  }
  ${WorkspaceMinimalWithBillingStatusFragmentDoc}
`

/**
 * __useGetWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceQuery,
    Types.GetWorkspaceQueryVariables
  > &
    (
      | { variables: Types.GetWorkspaceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceQuery,
    Types.GetWorkspaceQueryVariables
  >(GetWorkspaceDocument, options)
}
export function useGetWorkspaceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceQuery,
    Types.GetWorkspaceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceQuery,
    Types.GetWorkspaceQueryVariables
  >(GetWorkspaceDocument, options)
}

export type GetWorkspaceQueryHookResult = ReturnType<
  typeof useGetWorkspaceQuery
>
export type GetWorkspaceLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceLazyQuery
>
export type GetWorkspaceQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceQuery,
  Types.GetWorkspaceQueryVariables
>
export const GetPublicWorkspaceDocument = /*#__PURE__*/ gql`
  query getPublicWorkspace($identifier: UUID!) {
    publicWorkspace(identifier: $identifier) {
      ...PublicWorkspaceMinimal
    }
  }
  ${PublicWorkspaceMinimalFragmentDoc}
`

/**
 * __useGetPublicWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetPublicWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicWorkspaceQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetPublicWorkspaceQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPublicWorkspaceQuery,
    Types.GetPublicWorkspaceQueryVariables
  > &
    (
      | { variables: Types.GetPublicWorkspaceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPublicWorkspaceQuery,
    Types.GetPublicWorkspaceQueryVariables
  >(GetPublicWorkspaceDocument, options)
}
export function useGetPublicWorkspaceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPublicWorkspaceQuery,
    Types.GetPublicWorkspaceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPublicWorkspaceQuery,
    Types.GetPublicWorkspaceQueryVariables
  >(GetPublicWorkspaceDocument, options)
}

export type GetPublicWorkspaceQueryHookResult = ReturnType<
  typeof useGetPublicWorkspaceQuery
>
export type GetPublicWorkspaceLazyQueryHookResult = ReturnType<
  typeof useGetPublicWorkspaceLazyQuery
>
export type GetPublicWorkspaceQueryResult = Apollo.QueryResult<
  Types.GetPublicWorkspaceQuery,
  Types.GetPublicWorkspaceQueryVariables
>
export const GetPublicWorkspaceWithFeatureFlagsDocument = /*#__PURE__*/ gql`
  query getPublicWorkspaceWithFeatureFlags($identifier: UUID!) {
    publicWorkspace(identifier: $identifier) {
      ...PublicWorkspaceMinimalWithFeatureFlags
    }
  }
  ${PublicWorkspaceMinimalWithFeatureFlagsFragmentDoc}
`

/**
 * __useGetPublicWorkspaceWithFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetPublicWorkspaceWithFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicWorkspaceWithFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicWorkspaceWithFeatureFlagsQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetPublicWorkspaceWithFeatureFlagsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPublicWorkspaceWithFeatureFlagsQuery,
    Types.GetPublicWorkspaceWithFeatureFlagsQueryVariables
  > &
    (
      | {
          variables: Types.GetPublicWorkspaceWithFeatureFlagsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPublicWorkspaceWithFeatureFlagsQuery,
    Types.GetPublicWorkspaceWithFeatureFlagsQueryVariables
  >(GetPublicWorkspaceWithFeatureFlagsDocument, options)
}
export function useGetPublicWorkspaceWithFeatureFlagsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPublicWorkspaceWithFeatureFlagsQuery,
    Types.GetPublicWorkspaceWithFeatureFlagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPublicWorkspaceWithFeatureFlagsQuery,
    Types.GetPublicWorkspaceWithFeatureFlagsQueryVariables
  >(GetPublicWorkspaceWithFeatureFlagsDocument, options)
}

export type GetPublicWorkspaceWithFeatureFlagsQueryHookResult = ReturnType<
  typeof useGetPublicWorkspaceWithFeatureFlagsQuery
>
export type GetPublicWorkspaceWithFeatureFlagsLazyQueryHookResult = ReturnType<
  typeof useGetPublicWorkspaceWithFeatureFlagsLazyQuery
>
export type GetPublicWorkspaceWithFeatureFlagsQueryResult = Apollo.QueryResult<
  Types.GetPublicWorkspaceWithFeatureFlagsQuery,
  Types.GetPublicWorkspaceWithFeatureFlagsQueryVariables
>
export const GetWorkspaceSettingsDocument = /*#__PURE__*/ gql`
  query getWorkspaceSettings(
    $identifier: UUID!
    $includeShares: Boolean = true
  ) {
    workspace(identifier: $identifier) {
      ...WorkspaceMinimal
      identifier
      canUseRestrictedUploads
      uploadsRestrictedFor
      scimEnabled
      scimEndpoint
      securityEmail
      customer {
        identifier
        source
        billing {
          status
          seats {
            ...BillingSeatsInfo
          }
          trialEnd
          subscriptionEnd
          subscriptionSetUp
        }
        ssoEnabled
        ssoShortName
      }
      features {
        ssoEnabled
        userDirectoryEnabled
        encryptionEnabled
        scimAccessEnabled
      }
      encryptionConfig {
        kmsArns
        roleArn
      }
      shares @include(if: $includeShares) {
        meta {
          totalCount
        }
      }
    }
  }
  ${WorkspaceMinimalFragmentDoc}
  ${BillingSeatsInfoFragmentDoc}
`

/**
 * __useGetWorkspaceSettingsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSettingsQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      includeShares: // value for 'includeShares'
 *   },
 * });
 */
export function useGetWorkspaceSettingsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceSettingsQuery,
    Types.GetWorkspaceSettingsQueryVariables
  > &
    (
      | { variables: Types.GetWorkspaceSettingsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceSettingsQuery,
    Types.GetWorkspaceSettingsQueryVariables
  >(GetWorkspaceSettingsDocument, options)
}
export function useGetWorkspaceSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceSettingsQuery,
    Types.GetWorkspaceSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceSettingsQuery,
    Types.GetWorkspaceSettingsQueryVariables
  >(GetWorkspaceSettingsDocument, options)
}

export type GetWorkspaceSettingsQueryHookResult = ReturnType<
  typeof useGetWorkspaceSettingsQuery
>
export type GetWorkspaceSettingsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceSettingsLazyQuery
>
export type GetWorkspaceSettingsQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceSettingsQuery,
  Types.GetWorkspaceSettingsQueryVariables
>
export const GetWorkspaceSsoSettingsDocument = /*#__PURE__*/ gql`
  query getWorkspaceSsoSettings($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      customer {
        identifier
        ssoConfig {
          ...WorkspaceSsoConfig
        }
      }
    }
  }
  ${WorkspaceSsoConfigFragmentDoc}
`

/**
 * __useGetWorkspaceSsoSettingsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSsoSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSsoSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSsoSettingsQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceSsoSettingsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceSsoSettingsQuery,
    Types.GetWorkspaceSsoSettingsQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceSsoSettingsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceSsoSettingsQuery,
    Types.GetWorkspaceSsoSettingsQueryVariables
  >(GetWorkspaceSsoSettingsDocument, options)
}
export function useGetWorkspaceSsoSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceSsoSettingsQuery,
    Types.GetWorkspaceSsoSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceSsoSettingsQuery,
    Types.GetWorkspaceSsoSettingsQueryVariables
  >(GetWorkspaceSsoSettingsDocument, options)
}

export type GetWorkspaceSsoSettingsQueryHookResult = ReturnType<
  typeof useGetWorkspaceSsoSettingsQuery
>
export type GetWorkspaceSsoSettingsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceSsoSettingsLazyQuery
>
export type GetWorkspaceSsoSettingsQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceSsoSettingsQuery,
  Types.GetWorkspaceSsoSettingsQueryVariables
>
export const GetWorkspaceSubscribeInformationDocument = /*#__PURE__*/ gql`
  query getWorkspaceSubscribeInformation($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      customer {
        identifier
        billing {
          trialEnd
          seats {
            ...BillingSeatsInfo
          }
        }
      }
      memberships {
        list {
          meta {
            totalCount
          }
        }
      }
    }
  }
  ${BillingSeatsInfoFragmentDoc}
`

/**
 * __useGetWorkspaceSubscribeInformationQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSubscribeInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSubscribeInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSubscribeInformationQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceSubscribeInformationQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceSubscribeInformationQuery,
    Types.GetWorkspaceSubscribeInformationQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceSubscribeInformationQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceSubscribeInformationQuery,
    Types.GetWorkspaceSubscribeInformationQueryVariables
  >(GetWorkspaceSubscribeInformationDocument, options)
}
export function useGetWorkspaceSubscribeInformationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceSubscribeInformationQuery,
    Types.GetWorkspaceSubscribeInformationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceSubscribeInformationQuery,
    Types.GetWorkspaceSubscribeInformationQueryVariables
  >(GetWorkspaceSubscribeInformationDocument, options)
}

export type GetWorkspaceSubscribeInformationQueryHookResult = ReturnType<
  typeof useGetWorkspaceSubscribeInformationQuery
>
export type GetWorkspaceSubscribeInformationLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceSubscribeInformationLazyQuery
>
export type GetWorkspaceSubscribeInformationQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceSubscribeInformationQuery,
  Types.GetWorkspaceSubscribeInformationQueryVariables
>
export const GetPublicWorkspaceFromTokenDocument = /*#__PURE__*/ gql`
  query getPublicWorkspaceFromToken($inviteToken: String!) {
    getPublicWorkspaceFromToken(membershipToken: $inviteToken) {
      identifier
      name
      avatar {
        small
      }
    }
  }
`

/**
 * __useGetPublicWorkspaceFromTokenQuery__
 *
 * To run a query within a React component, call `useGetPublicWorkspaceFromTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicWorkspaceFromTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicWorkspaceFromTokenQuery({
 *   variables: {
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useGetPublicWorkspaceFromTokenQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPublicWorkspaceFromTokenQuery,
    Types.GetPublicWorkspaceFromTokenQueryVariables
  > &
    (
      | {
          variables: Types.GetPublicWorkspaceFromTokenQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPublicWorkspaceFromTokenQuery,
    Types.GetPublicWorkspaceFromTokenQueryVariables
  >(GetPublicWorkspaceFromTokenDocument, options)
}
export function useGetPublicWorkspaceFromTokenLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPublicWorkspaceFromTokenQuery,
    Types.GetPublicWorkspaceFromTokenQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPublicWorkspaceFromTokenQuery,
    Types.GetPublicWorkspaceFromTokenQueryVariables
  >(GetPublicWorkspaceFromTokenDocument, options)
}

export type GetPublicWorkspaceFromTokenQueryHookResult = ReturnType<
  typeof useGetPublicWorkspaceFromTokenQuery
>
export type GetPublicWorkspaceFromTokenLazyQueryHookResult = ReturnType<
  typeof useGetPublicWorkspaceFromTokenLazyQuery
>
export type GetPublicWorkspaceFromTokenQueryResult = Apollo.QueryResult<
  Types.GetPublicWorkspaceFromTokenQuery,
  Types.GetPublicWorkspaceFromTokenQueryVariables
>
export const GetWorkspaceUploadsRestrictedForDocument = /*#__PURE__*/ gql`
  query getWorkspaceUploadsRestrictedFor($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      uploadsRestrictedFor
    }
  }
`

/**
 * __useGetWorkspaceUploadsRestrictedForQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceUploadsRestrictedForQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceUploadsRestrictedForQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceUploadsRestrictedForQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceUploadsRestrictedForQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceUploadsRestrictedForQuery,
    Types.GetWorkspaceUploadsRestrictedForQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceUploadsRestrictedForQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceUploadsRestrictedForQuery,
    Types.GetWorkspaceUploadsRestrictedForQueryVariables
  >(GetWorkspaceUploadsRestrictedForDocument, options)
}
export function useGetWorkspaceUploadsRestrictedForLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceUploadsRestrictedForQuery,
    Types.GetWorkspaceUploadsRestrictedForQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceUploadsRestrictedForQuery,
    Types.GetWorkspaceUploadsRestrictedForQueryVariables
  >(GetWorkspaceUploadsRestrictedForDocument, options)
}

export type GetWorkspaceUploadsRestrictedForQueryHookResult = ReturnType<
  typeof useGetWorkspaceUploadsRestrictedForQuery
>
export type GetWorkspaceUploadsRestrictedForLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceUploadsRestrictedForLazyQuery
>
export type GetWorkspaceUploadsRestrictedForQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceUploadsRestrictedForQuery,
  Types.GetWorkspaceUploadsRestrictedForQueryVariables
>
export const GetWorkspaceProfileIdentifierDocument = /*#__PURE__*/ gql`
  query getWorkspaceProfileIdentifier($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      profile {
        identifier
      }
    }
  }
`

/**
 * __useGetWorkspaceProfileIdentifierQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceProfileIdentifierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceProfileIdentifierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceProfileIdentifierQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceProfileIdentifierQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceProfileIdentifierQuery,
    Types.GetWorkspaceProfileIdentifierQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceProfileIdentifierQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceProfileIdentifierQuery,
    Types.GetWorkspaceProfileIdentifierQueryVariables
  >(GetWorkspaceProfileIdentifierDocument, options)
}
export function useGetWorkspaceProfileIdentifierLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceProfileIdentifierQuery,
    Types.GetWorkspaceProfileIdentifierQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceProfileIdentifierQuery,
    Types.GetWorkspaceProfileIdentifierQueryVariables
  >(GetWorkspaceProfileIdentifierDocument, options)
}

export type GetWorkspaceProfileIdentifierQueryHookResult = ReturnType<
  typeof useGetWorkspaceProfileIdentifierQuery
>
export type GetWorkspaceProfileIdentifierLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceProfileIdentifierLazyQuery
>
export type GetWorkspaceProfileIdentifierQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceProfileIdentifierQuery,
  Types.GetWorkspaceProfileIdentifierQueryVariables
>
export const GetWorkspaceSupportAccessDocument = /*#__PURE__*/ gql`
  query getWorkspaceSupportAccess($identifier: UUID!) {
    workspace(identifier: $identifier) {
      identifier
      supportAccessGrantedUntil
    }
  }
`

/**
 * __useGetWorkspaceSupportAccessQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSupportAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSupportAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSupportAccessQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceSupportAccessQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceSupportAccessQuery,
    Types.GetWorkspaceSupportAccessQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceSupportAccessQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceSupportAccessQuery,
    Types.GetWorkspaceSupportAccessQueryVariables
  >(GetWorkspaceSupportAccessDocument, options)
}
export function useGetWorkspaceSupportAccessLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceSupportAccessQuery,
    Types.GetWorkspaceSupportAccessQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceSupportAccessQuery,
    Types.GetWorkspaceSupportAccessQueryVariables
  >(GetWorkspaceSupportAccessDocument, options)
}

export type GetWorkspaceSupportAccessQueryHookResult = ReturnType<
  typeof useGetWorkspaceSupportAccessQuery
>
export type GetWorkspaceSupportAccessLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceSupportAccessLazyQuery
>
export type GetWorkspaceSupportAccessQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceSupportAccessQuery,
  Types.GetWorkspaceSupportAccessQueryVariables
>
export const GetWorkspaceHeaviestSharesDocument = /*#__PURE__*/ gql`
  query getWorkspaceHeaviestShares($identifier: UUID!) {
    workspaceHeaviestShares(identifier: $identifier) {
      ...ShareWithSize
    }
  }
  ${ShareWithSizeFragmentDoc}
`

/**
 * __useGetWorkspaceHeaviestSharesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceHeaviestSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceHeaviestSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceHeaviestSharesQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceHeaviestSharesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceHeaviestSharesQuery,
    Types.GetWorkspaceHeaviestSharesQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceHeaviestSharesQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceHeaviestSharesQuery,
    Types.GetWorkspaceHeaviestSharesQueryVariables
  >(GetWorkspaceHeaviestSharesDocument, options)
}
export function useGetWorkspaceHeaviestSharesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceHeaviestSharesQuery,
    Types.GetWorkspaceHeaviestSharesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceHeaviestSharesQuery,
    Types.GetWorkspaceHeaviestSharesQueryVariables
  >(GetWorkspaceHeaviestSharesDocument, options)
}

export type GetWorkspaceHeaviestSharesQueryHookResult = ReturnType<
  typeof useGetWorkspaceHeaviestSharesQuery
>
export type GetWorkspaceHeaviestSharesLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceHeaviestSharesLazyQuery
>
export type GetWorkspaceHeaviestSharesQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceHeaviestSharesQuery,
  Types.GetWorkspaceHeaviestSharesQueryVariables
>
export const WorkspaceMembershipUpdatedDocument = /*#__PURE__*/ gql`
  subscription workspaceMembershipUpdated {
    workspaceMembershipUpdated {
      status
      workspaceIdentifier
    }
  }
`

/**
 * __useWorkspaceMembershipUpdatedSubscription__
 *
 * To run a query within a React component, call `useWorkspaceMembershipUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceMembershipUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceMembershipUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceMembershipUpdatedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    Types.WorkspaceMembershipUpdatedSubscription,
    Types.WorkspaceMembershipUpdatedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useSubscription<
    Types.WorkspaceMembershipUpdatedSubscription,
    Types.WorkspaceMembershipUpdatedSubscriptionVariables
  >(WorkspaceMembershipUpdatedDocument, options)
}
export type WorkspaceMembershipUpdatedSubscriptionHookResult = ReturnType<
  typeof useWorkspaceMembershipUpdatedSubscription
>
export type WorkspaceMembershipUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<Types.WorkspaceMembershipUpdatedSubscription>
export const GetWorkspaceCustomerDocument = /*#__PURE__*/ gql`
  query getWorkspaceCustomer($identifier: UUID!) {
    workspaceCustomer(identifier: $identifier) {
      workspaces {
        entries {
          ...WorkspaceMinimal
        }
      }
    }
  }
  ${WorkspaceMinimalFragmentDoc}
`

/**
 * __useGetWorkspaceCustomerQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceCustomerQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceCustomerQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceCustomerQuery,
    Types.GetWorkspaceCustomerQueryVariables
  > &
    (
      | { variables: Types.GetWorkspaceCustomerQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceCustomerQuery,
    Types.GetWorkspaceCustomerQueryVariables
  >(GetWorkspaceCustomerDocument, options)
}
export function useGetWorkspaceCustomerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceCustomerQuery,
    Types.GetWorkspaceCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceCustomerQuery,
    Types.GetWorkspaceCustomerQueryVariables
  >(GetWorkspaceCustomerDocument, options)
}

export type GetWorkspaceCustomerQueryHookResult = ReturnType<
  typeof useGetWorkspaceCustomerQuery
>
export type GetWorkspaceCustomerLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceCustomerLazyQuery
>
export type GetWorkspaceCustomerQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceCustomerQuery,
  Types.GetWorkspaceCustomerQueryVariables
>
export const GetIntegrationConnectUrlDocument = /*#__PURE__*/ gql`
  mutation getIntegrationConnectUrl(
    $provider: IntegrationProvider!
    $workspaceIdentifier: UUID!
  ) {
    getIntegrationConnectUrl(
      provider: $provider
      workspaceIdentifier: $workspaceIdentifier
    ) {
      url
    }
  }
`
export type GetIntegrationConnectUrlMutationFn = Apollo.MutationFunction<
  Types.GetIntegrationConnectUrlMutation,
  Types.GetIntegrationConnectUrlMutationVariables
>

/**
 * __useGetIntegrationConnectUrlMutation__
 *
 * To run a mutation, you first call `useGetIntegrationConnectUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationConnectUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getIntegrationConnectUrlMutation, { data, loading, error }] = useGetIntegrationConnectUrlMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *   },
 * });
 */
export function useGetIntegrationConnectUrlMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.GetIntegrationConnectUrlMutation,
    Types.GetIntegrationConnectUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.GetIntegrationConnectUrlMutation,
    Types.GetIntegrationConnectUrlMutationVariables
  >(GetIntegrationConnectUrlDocument, options)
}
export type GetIntegrationConnectUrlMutationHookResult = ReturnType<
  typeof useGetIntegrationConnectUrlMutation
>
export type GetIntegrationConnectUrlMutationResult =
  Apollo.MutationResult<Types.GetIntegrationConnectUrlMutation>
export type GetIntegrationConnectUrlMutationOptions =
  Apollo.BaseMutationOptions<
    Types.GetIntegrationConnectUrlMutation,
    Types.GetIntegrationConnectUrlMutationVariables
  >
export const RemoveIntegrationDocument = /*#__PURE__*/ gql`
  mutation removeIntegration($identifier: UUID!) {
    removeIntegration(identifier: $identifier) {
      integration {
        identifier
      }
    }
  }
`
export type RemoveIntegrationMutationFn = Apollo.MutationFunction<
  Types.RemoveIntegrationMutation,
  Types.RemoveIntegrationMutationVariables
>

/**
 * __useRemoveIntegrationMutation__
 *
 * To run a mutation, you first call `useRemoveIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeIntegrationMutation, { data, loading, error }] = useRemoveIntegrationMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useRemoveIntegrationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RemoveIntegrationMutation,
    Types.RemoveIntegrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RemoveIntegrationMutation,
    Types.RemoveIntegrationMutationVariables
  >(RemoveIntegrationDocument, options)
}
export type RemoveIntegrationMutationHookResult = ReturnType<
  typeof useRemoveIntegrationMutation
>
export type RemoveIntegrationMutationResult =
  Apollo.MutationResult<Types.RemoveIntegrationMutation>
export type RemoveIntegrationMutationOptions = Apollo.BaseMutationOptions<
  Types.RemoveIntegrationMutation,
  Types.RemoveIntegrationMutationVariables
>
export const GetWorkspaceIntegrationsDocument = /*#__PURE__*/ gql`
  query getWorkspaceIntegrations($identifier: UUID!) {
    workspace(identifier: $identifier) {
      ...WorkspaceIntegrations
    }
  }
  ${WorkspaceIntegrationsFragmentDoc}
`

/**
 * __useGetWorkspaceIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceIntegrationsQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceIntegrationsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceIntegrationsQuery,
    Types.GetWorkspaceIntegrationsQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceIntegrationsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceIntegrationsQuery,
    Types.GetWorkspaceIntegrationsQueryVariables
  >(GetWorkspaceIntegrationsDocument, options)
}
export function useGetWorkspaceIntegrationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceIntegrationsQuery,
    Types.GetWorkspaceIntegrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceIntegrationsQuery,
    Types.GetWorkspaceIntegrationsQueryVariables
  >(GetWorkspaceIntegrationsDocument, options)
}

export type GetWorkspaceIntegrationsQueryHookResult = ReturnType<
  typeof useGetWorkspaceIntegrationsQuery
>
export type GetWorkspaceIntegrationsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceIntegrationsLazyQuery
>
export type GetWorkspaceIntegrationsQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceIntegrationsQuery,
  Types.GetWorkspaceIntegrationsQueryVariables
>
export const GetIntegrationDocument = /*#__PURE__*/ gql`
  query getIntegration(
    $integrationProvider: IntegrationProvider!
    $workspaceIdentifier: UUID!
  ) {
    integration(
      integrationProvider: $integrationProvider
      workspaceIdentifier: $workspaceIdentifier
    ) {
      ...Integration
    }
  }
  ${IntegrationFragmentDoc}
`

/**
 * __useGetIntegrationQuery__
 *
 * To run a query within a React component, call `useGetIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationQuery({
 *   variables: {
 *      integrationProvider: // value for 'integrationProvider'
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *   },
 * });
 */
export function useGetIntegrationQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetIntegrationQuery,
    Types.GetIntegrationQueryVariables
  > &
    (
      | { variables: Types.GetIntegrationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetIntegrationQuery,
    Types.GetIntegrationQueryVariables
  >(GetIntegrationDocument, options)
}
export function useGetIntegrationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetIntegrationQuery,
    Types.GetIntegrationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetIntegrationQuery,
    Types.GetIntegrationQueryVariables
  >(GetIntegrationDocument, options)
}

export type GetIntegrationQueryHookResult = ReturnType<
  typeof useGetIntegrationQuery
>
export type GetIntegrationLazyQueryHookResult = ReturnType<
  typeof useGetIntegrationLazyQuery
>
export type GetIntegrationQueryResult = Apollo.QueryResult<
  Types.GetIntegrationQuery,
  Types.GetIntegrationQueryVariables
>
export const InviteWorkspaceMembersDocument = /*#__PURE__*/ gql`
  mutation inviteWorkspaceMembers($input: InviteWorkspaceMembersParams!) {
    inviteWorkspaceMembers(input: $input) {
      workspace {
        identifier
        customer {
          identifier
          billing {
            seats {
              ...BillingSeatsInfo
            }
          }
        }
      }
      pendingScaToken
    }
  }
  ${BillingSeatsInfoFragmentDoc}
`
export type InviteWorkspaceMembersMutationFn = Apollo.MutationFunction<
  Types.InviteWorkspaceMembersMutation,
  Types.InviteWorkspaceMembersMutationVariables
>

/**
 * __useInviteWorkspaceMembersMutation__
 *
 * To run a mutation, you first call `useInviteWorkspaceMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteWorkspaceMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteWorkspaceMembersMutation, { data, loading, error }] = useInviteWorkspaceMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteWorkspaceMembersMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.InviteWorkspaceMembersMutation,
    Types.InviteWorkspaceMembersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.InviteWorkspaceMembersMutation,
    Types.InviteWorkspaceMembersMutationVariables
  >(InviteWorkspaceMembersDocument, options)
}
export type InviteWorkspaceMembersMutationHookResult = ReturnType<
  typeof useInviteWorkspaceMembersMutation
>
export type InviteWorkspaceMembersMutationResult =
  Apollo.MutationResult<Types.InviteWorkspaceMembersMutation>
export type InviteWorkspaceMembersMutationOptions = Apollo.BaseMutationOptions<
  Types.InviteWorkspaceMembersMutation,
  Types.InviteWorkspaceMembersMutationVariables
>
export const UpdateWorkspaceMemberDocument = /*#__PURE__*/ gql`
  mutation updateWorkspaceMember($input: UpdateWorkspaceMemberParams!) {
    updateWorkspaceMember(input: $input) {
      membership {
        ...WorkspaceMembership
        identifier
        role
        isEditor
        workspace {
          identifier
          customer {
            identifier
            billing {
              seats {
                ...BillingSeatsInfo
              }
            }
          }
        }
      }
      pendingScaToken
    }
  }
  ${WorkspaceMembershipFragmentDoc}
  ${BillingSeatsInfoFragmentDoc}
`
export type UpdateWorkspaceMemberMutationFn = Apollo.MutationFunction<
  Types.UpdateWorkspaceMemberMutation,
  Types.UpdateWorkspaceMemberMutationVariables
>

/**
 * __useUpdateWorkspaceMemberMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceMemberMutation, { data, loading, error }] = useUpdateWorkspaceMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceMemberMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateWorkspaceMemberMutation,
    Types.UpdateWorkspaceMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateWorkspaceMemberMutation,
    Types.UpdateWorkspaceMemberMutationVariables
  >(UpdateWorkspaceMemberDocument, options)
}
export type UpdateWorkspaceMemberMutationHookResult = ReturnType<
  typeof useUpdateWorkspaceMemberMutation
>
export type UpdateWorkspaceMemberMutationResult =
  Apollo.MutationResult<Types.UpdateWorkspaceMemberMutation>
export type UpdateWorkspaceMemberMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateWorkspaceMemberMutation,
  Types.UpdateWorkspaceMemberMutationVariables
>
export const RemoveWorkspaceMemberDocument = /*#__PURE__*/ gql`
  mutation removeWorkspaceMember($membershipId: UUID!) {
    removeWorkspaceMember(membershipIdentifier: $membershipId) {
      workspace {
        identifier
        memberships {
          userCanAccess
          totalMemberships: list {
            meta {
              totalCount
            }
          }
        }
        customer {
          identifier
          billing {
            seats {
              ...BillingSeatsInfo
            }
          }
        }
      }
    }
  }
  ${BillingSeatsInfoFragmentDoc}
`
export type RemoveWorkspaceMemberMutationFn = Apollo.MutationFunction<
  Types.RemoveWorkspaceMemberMutation,
  Types.RemoveWorkspaceMemberMutationVariables
>

/**
 * __useRemoveWorkspaceMemberMutation__
 *
 * To run a mutation, you first call `useRemoveWorkspaceMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkspaceMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkspaceMemberMutation, { data, loading, error }] = useRemoveWorkspaceMemberMutation({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useRemoveWorkspaceMemberMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RemoveWorkspaceMemberMutation,
    Types.RemoveWorkspaceMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RemoveWorkspaceMemberMutation,
    Types.RemoveWorkspaceMemberMutationVariables
  >(RemoveWorkspaceMemberDocument, options)
}
export type RemoveWorkspaceMemberMutationHookResult = ReturnType<
  typeof useRemoveWorkspaceMemberMutation
>
export type RemoveWorkspaceMemberMutationResult =
  Apollo.MutationResult<Types.RemoveWorkspaceMemberMutation>
export type RemoveWorkspaceMemberMutationOptions = Apollo.BaseMutationOptions<
  Types.RemoveWorkspaceMemberMutation,
  Types.RemoveWorkspaceMemberMutationVariables
>
export const ResendWorkspaceInviteDocument = /*#__PURE__*/ gql`
  mutation resendWorkspaceInvite($membershipId: UUID!) {
    resendWorkspaceInvite(identifier: $membershipId) {
      membership {
        identifier
      }
    }
  }
`
export type ResendWorkspaceInviteMutationFn = Apollo.MutationFunction<
  Types.ResendWorkspaceInviteMutation,
  Types.ResendWorkspaceInviteMutationVariables
>

/**
 * __useResendWorkspaceInviteMutation__
 *
 * To run a mutation, you first call `useResendWorkspaceInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendWorkspaceInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendWorkspaceInviteMutation, { data, loading, error }] = useResendWorkspaceInviteMutation({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useResendWorkspaceInviteMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.ResendWorkspaceInviteMutation,
    Types.ResendWorkspaceInviteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.ResendWorkspaceInviteMutation,
    Types.ResendWorkspaceInviteMutationVariables
  >(ResendWorkspaceInviteDocument, options)
}
export type ResendWorkspaceInviteMutationHookResult = ReturnType<
  typeof useResendWorkspaceInviteMutation
>
export type ResendWorkspaceInviteMutationResult =
  Apollo.MutationResult<Types.ResendWorkspaceInviteMutation>
export type ResendWorkspaceInviteMutationOptions = Apollo.BaseMutationOptions<
  Types.ResendWorkspaceInviteMutation,
  Types.ResendWorkspaceInviteMutationVariables
>
export const LeaveWorkspaceDocument = /*#__PURE__*/ gql`
  mutation leaveWorkspace($membershipId: UUID!) {
    removeWorkspaceMember(membershipIdentifier: $membershipId) {
      workspace {
        identifier
      }
    }
  }
`
export type LeaveWorkspaceMutationFn = Apollo.MutationFunction<
  Types.LeaveWorkspaceMutation,
  Types.LeaveWorkspaceMutationVariables
>

/**
 * __useLeaveWorkspaceMutation__
 *
 * To run a mutation, you first call `useLeaveWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveWorkspaceMutation, { data, loading, error }] = useLeaveWorkspaceMutation({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useLeaveWorkspaceMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.LeaveWorkspaceMutation,
    Types.LeaveWorkspaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.LeaveWorkspaceMutation,
    Types.LeaveWorkspaceMutationVariables
  >(LeaveWorkspaceDocument, options)
}
export type LeaveWorkspaceMutationHookResult = ReturnType<
  typeof useLeaveWorkspaceMutation
>
export type LeaveWorkspaceMutationResult =
  Apollo.MutationResult<Types.LeaveWorkspaceMutation>
export type LeaveWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  Types.LeaveWorkspaceMutation,
  Types.LeaveWorkspaceMutationVariables
>
export const GetPendingWorkspaceMembershipDocument = /*#__PURE__*/ gql`
  query getPendingWorkspaceMembership(
    $membershipToken: String
    $membershipId: UUID
    $includeCustomer: Boolean! = false
  ) {
    pendingWorkspaceMembership(
      membershipToken: $membershipToken
      membershipId: $membershipId
    ) {
      identifier
      isEditor
      role
      user {
        identifier
        name
        email
        avatar {
          small
          large
        }
      }
      workspace {
        identifier
        name
        userRole
        avatar {
          small
          large
        }
        customer @include(if: $includeCustomer) {
          identifier
          ssoStartUrl
          ssoEnabled
        }
      }
      invite {
        identifier
        email
      }
      inviter {
        identifier
        name
      }
    }
    me {
      ...UserEmail
      personalIdentityEmail
    }
  }
  ${UserEmailFragmentDoc}
`

/**
 * __useGetPendingWorkspaceMembershipQuery__
 *
 * To run a query within a React component, call `useGetPendingWorkspaceMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingWorkspaceMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingWorkspaceMembershipQuery({
 *   variables: {
 *      membershipToken: // value for 'membershipToken'
 *      membershipId: // value for 'membershipId'
 *      includeCustomer: // value for 'includeCustomer'
 *   },
 * });
 */
export function useGetPendingWorkspaceMembershipQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetPendingWorkspaceMembershipQuery,
    Types.GetPendingWorkspaceMembershipQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPendingWorkspaceMembershipQuery,
    Types.GetPendingWorkspaceMembershipQueryVariables
  >(GetPendingWorkspaceMembershipDocument, options)
}
export function useGetPendingWorkspaceMembershipLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPendingWorkspaceMembershipQuery,
    Types.GetPendingWorkspaceMembershipQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPendingWorkspaceMembershipQuery,
    Types.GetPendingWorkspaceMembershipQueryVariables
  >(GetPendingWorkspaceMembershipDocument, options)
}

export type GetPendingWorkspaceMembershipQueryHookResult = ReturnType<
  typeof useGetPendingWorkspaceMembershipQuery
>
export type GetPendingWorkspaceMembershipLazyQueryHookResult = ReturnType<
  typeof useGetPendingWorkspaceMembershipLazyQuery
>
export type GetPendingWorkspaceMembershipQueryResult = Apollo.QueryResult<
  Types.GetPendingWorkspaceMembershipQuery,
  Types.GetPendingWorkspaceMembershipQueryVariables
>
export const GetWorkspaceMembershipsDocument = /*#__PURE__*/ gql`
  query getWorkspaceMemberships(
    $workspaceId: UUID!
    $after: String
    $filter: String
    $limit: Int = 20
    $role: WorkspaceMembershipRole
    $accessLevel: WorkspaceMemberAccessLevel
    $excludeRoles: [WorkspaceMembershipRole]
    $activityStatus: UserActivityStatus
    $order: WorkspaceMembershipOrderType
    $orderDirection: OrderDirection
  ) {
    workspace(identifier: $workspaceId) {
      identifier
      memberships {
        userCanAccess
        totalMemberships: list {
          meta {
            totalCount
          }
        }
        totalGuests: list(role: GUEST) {
          meta {
            totalCount
          }
        }
        totalMembers: list(excludeRoles: GUEST) {
          meta {
            totalCount
          }
        }
        list(
          after: $after
          search: $filter
          limit: $limit
          role: $role
          accessLevel: $accessLevel
          excludeRoles: $excludeRoles
          activityStatus: $activityStatus
          order: $order
          orderDirection: $orderDirection
        ) {
          entries {
            ...WorkspaceMembership
          }
          meta {
            after
            totalCount
          }
        }
      }
    }
  }
  ${WorkspaceMembershipFragmentDoc}
`

/**
 * __useGetWorkspaceMembershipsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceMembershipsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      role: // value for 'role'
 *      accessLevel: // value for 'accessLevel'
 *      excludeRoles: // value for 'excludeRoles'
 *      activityStatus: // value for 'activityStatus'
 *      order: // value for 'order'
 *      orderDirection: // value for 'orderDirection'
 *   },
 * });
 */
export function useGetWorkspaceMembershipsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceMembershipsQuery,
    Types.GetWorkspaceMembershipsQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceMembershipsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceMembershipsQuery,
    Types.GetWorkspaceMembershipsQueryVariables
  >(GetWorkspaceMembershipsDocument, options)
}
export function useGetWorkspaceMembershipsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceMembershipsQuery,
    Types.GetWorkspaceMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceMembershipsQuery,
    Types.GetWorkspaceMembershipsQueryVariables
  >(GetWorkspaceMembershipsDocument, options)
}

export type GetWorkspaceMembershipsQueryHookResult = ReturnType<
  typeof useGetWorkspaceMembershipsQuery
>
export type GetWorkspaceMembershipsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceMembershipsLazyQuery
>
export type GetWorkspaceMembershipsQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceMembershipsQuery,
  Types.GetWorkspaceMembershipsQueryVariables
>
export const GetWorkspaceMembershipsCountDocument = /*#__PURE__*/ gql`
  query getWorkspaceMembershipsCount($workspaceId: UUID!) {
    workspace(identifier: $workspaceId) {
      identifier
      memberships {
        totalMemberships: list {
          meta {
            totalCount
          }
        }
        totalGuests: list(role: GUEST) {
          meta {
            totalCount
          }
        }
        totalMembers: list(excludeRoles: GUEST) {
          meta {
            totalCount
          }
        }
      }
    }
  }
`

/**
 * __useGetWorkspaceMembershipsCountQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceMembershipsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceMembershipsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceMembershipsCountQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceMembershipsCountQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceMembershipsCountQuery,
    Types.GetWorkspaceMembershipsCountQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceMembershipsCountQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceMembershipsCountQuery,
    Types.GetWorkspaceMembershipsCountQueryVariables
  >(GetWorkspaceMembershipsCountDocument, options)
}
export function useGetWorkspaceMembershipsCountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceMembershipsCountQuery,
    Types.GetWorkspaceMembershipsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceMembershipsCountQuery,
    Types.GetWorkspaceMembershipsCountQueryVariables
  >(GetWorkspaceMembershipsCountDocument, options)
}

export type GetWorkspaceMembershipsCountQueryHookResult = ReturnType<
  typeof useGetWorkspaceMembershipsCountQuery
>
export type GetWorkspaceMembershipsCountLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceMembershipsCountLazyQuery
>
export type GetWorkspaceMembershipsCountQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceMembershipsCountQuery,
  Types.GetWorkspaceMembershipsCountQueryVariables
>
export const GetWorkspaceMembersCountWithCustomerDocument = /*#__PURE__*/ gql`
  query getWorkspaceMembersCountWithCustomer($workspaceId: UUID!) {
    workspace(identifier: $workspaceId) {
      identifier
      memberships {
        totalMemberships: list {
          meta {
            totalCount
          }
        }
      }
    }
  }
`

/**
 * __useGetWorkspaceMembersCountWithCustomerQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceMembersCountWithCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceMembersCountWithCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceMembersCountWithCustomerQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceMembersCountWithCustomerQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceMembersCountWithCustomerQuery,
    Types.GetWorkspaceMembersCountWithCustomerQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceMembersCountWithCustomerQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceMembersCountWithCustomerQuery,
    Types.GetWorkspaceMembersCountWithCustomerQueryVariables
  >(GetWorkspaceMembersCountWithCustomerDocument, options)
}
export function useGetWorkspaceMembersCountWithCustomerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceMembersCountWithCustomerQuery,
    Types.GetWorkspaceMembersCountWithCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceMembersCountWithCustomerQuery,
    Types.GetWorkspaceMembersCountWithCustomerQueryVariables
  >(GetWorkspaceMembersCountWithCustomerDocument, options)
}

export type GetWorkspaceMembersCountWithCustomerQueryHookResult = ReturnType<
  typeof useGetWorkspaceMembersCountWithCustomerQuery
>
export type GetWorkspaceMembersCountWithCustomerLazyQueryHookResult =
  ReturnType<typeof useGetWorkspaceMembersCountWithCustomerLazyQuery>
export type GetWorkspaceMembersCountWithCustomerQueryResult =
  Apollo.QueryResult<
    Types.GetWorkspaceMembersCountWithCustomerQuery,
    Types.GetWorkspaceMembersCountWithCustomerQueryVariables
  >
export const GetInvitableUsersAndGroupsDocument = /*#__PURE__*/ gql`
  query getInvitableUsersAndGroups(
    $workspaceIdentifier: UUID!
    $shareIdentifier: UUID
    $projectIdentifier: UUID
    $search: String
  ) {
    invitableUsersAndGroups(
      shareIdentifier: $shareIdentifier
      workspaceIdentifier: $workspaceIdentifier
      projectIdentifier: $projectIdentifier
      search: $search
      limit: 5
    ) {
      ... on WorkspaceMembership {
        ...InvitableUser
      }
      ... on PermissionGroup {
        ...WorkspacePermissionGroup
      }
    }
  }
  ${InvitableUserFragmentDoc}
  ${WorkspacePermissionGroupFragmentDoc}
`

/**
 * __useGetInvitableUsersAndGroupsQuery__
 *
 * To run a query within a React component, call `useGetInvitableUsersAndGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitableUsersAndGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitableUsersAndGroupsQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      shareIdentifier: // value for 'shareIdentifier'
 *      projectIdentifier: // value for 'projectIdentifier'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetInvitableUsersAndGroupsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetInvitableUsersAndGroupsQuery,
    Types.GetInvitableUsersAndGroupsQueryVariables
  > &
    (
      | {
          variables: Types.GetInvitableUsersAndGroupsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetInvitableUsersAndGroupsQuery,
    Types.GetInvitableUsersAndGroupsQueryVariables
  >(GetInvitableUsersAndGroupsDocument, options)
}
export function useGetInvitableUsersAndGroupsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetInvitableUsersAndGroupsQuery,
    Types.GetInvitableUsersAndGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetInvitableUsersAndGroupsQuery,
    Types.GetInvitableUsersAndGroupsQueryVariables
  >(GetInvitableUsersAndGroupsDocument, options)
}

export type GetInvitableUsersAndGroupsQueryHookResult = ReturnType<
  typeof useGetInvitableUsersAndGroupsQuery
>
export type GetInvitableUsersAndGroupsLazyQueryHookResult = ReturnType<
  typeof useGetInvitableUsersAndGroupsLazyQuery
>
export type GetInvitableUsersAndGroupsQueryResult = Apollo.QueryResult<
  Types.GetInvitableUsersAndGroupsQuery,
  Types.GetInvitableUsersAndGroupsQueryVariables
>
export const GetAccessShareMembershipsDocument = /*#__PURE__*/ gql`
  query getAccessShareMemberships(
    $workspaceIdentifier: UUID!
    $workspaceMembershipIdentifier: UUID!
    $shareSearch: ShareMemberAccessSearchParams
    $after: String
    $limit: Int = 10
  ) {
    workspace(identifier: $workspaceIdentifier) {
      identifier
      workspaceMembership(identifier: $workspaceMembershipIdentifier) {
        identifier
        shareMemberships(search: $shareSearch, after: $after, limit: $limit) {
          entries {
            ...UserAccessShareMembership
          }
          meta {
            after
            limit
            totalCount
          }
        }
      }
    }
  }
  ${UserAccessShareMembershipFragmentDoc}
`

/**
 * __useGetAccessShareMembershipsQuery__
 *
 * To run a query within a React component, call `useGetAccessShareMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessShareMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessShareMembershipsQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      workspaceMembershipIdentifier: // value for 'workspaceMembershipIdentifier'
 *      shareSearch: // value for 'shareSearch'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAccessShareMembershipsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetAccessShareMembershipsQuery,
    Types.GetAccessShareMembershipsQueryVariables
  > &
    (
      | {
          variables: Types.GetAccessShareMembershipsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAccessShareMembershipsQuery,
    Types.GetAccessShareMembershipsQueryVariables
  >(GetAccessShareMembershipsDocument, options)
}
export function useGetAccessShareMembershipsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAccessShareMembershipsQuery,
    Types.GetAccessShareMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAccessShareMembershipsQuery,
    Types.GetAccessShareMembershipsQueryVariables
  >(GetAccessShareMembershipsDocument, options)
}

export type GetAccessShareMembershipsQueryHookResult = ReturnType<
  typeof useGetAccessShareMembershipsQuery
>
export type GetAccessShareMembershipsLazyQueryHookResult = ReturnType<
  typeof useGetAccessShareMembershipsLazyQuery
>
export type GetAccessShareMembershipsQueryResult = Apollo.QueryResult<
  Types.GetAccessShareMembershipsQuery,
  Types.GetAccessShareMembershipsQueryVariables
>
export const GetAccessProjectMembershipsDocument = /*#__PURE__*/ gql`
  query getAccessProjectMemberships(
    $workspaceIdentifier: UUID!
    $workspaceMembershipIdentifier: UUID!
    $projectSearch: ProjectMemberAccessSearchParams
    $after: String
    $limit: Int = 10
  ) {
    workspace(identifier: $workspaceIdentifier) {
      identifier
      workspaceMembership(identifier: $workspaceMembershipIdentifier) {
        identifier
        projectMemberships(
          search: $projectSearch
          after: $after
          limit: $limit
        ) {
          entries {
            ...UserAccessProjectMembership
          }
          meta {
            after
            limit
            totalCount
          }
        }
      }
    }
  }
  ${UserAccessProjectMembershipFragmentDoc}
`

/**
 * __useGetAccessProjectMembershipsQuery__
 *
 * To run a query within a React component, call `useGetAccessProjectMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessProjectMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessProjectMembershipsQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      workspaceMembershipIdentifier: // value for 'workspaceMembershipIdentifier'
 *      projectSearch: // value for 'projectSearch'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAccessProjectMembershipsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetAccessProjectMembershipsQuery,
    Types.GetAccessProjectMembershipsQueryVariables
  > &
    (
      | {
          variables: Types.GetAccessProjectMembershipsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAccessProjectMembershipsQuery,
    Types.GetAccessProjectMembershipsQueryVariables
  >(GetAccessProjectMembershipsDocument, options)
}
export function useGetAccessProjectMembershipsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAccessProjectMembershipsQuery,
    Types.GetAccessProjectMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAccessProjectMembershipsQuery,
    Types.GetAccessProjectMembershipsQueryVariables
  >(GetAccessProjectMembershipsDocument, options)
}

export type GetAccessProjectMembershipsQueryHookResult = ReturnType<
  typeof useGetAccessProjectMembershipsQuery
>
export type GetAccessProjectMembershipsLazyQueryHookResult = ReturnType<
  typeof useGetAccessProjectMembershipsLazyQuery
>
export type GetAccessProjectMembershipsQueryResult = Apollo.QueryResult<
  Types.GetAccessProjectMembershipsQuery,
  Types.GetAccessProjectMembershipsQueryVariables
>
export const GetAccessPermissionGroupMembershipsDocument = /*#__PURE__*/ gql`
  query getAccessPermissionGroupMemberships(
    $workspaceIdentifier: UUID!
    $workspaceMembershipIdentifier: UUID!
    $permissionGroupSearch: String
    $after: String
    $limit: Int = 10
  ) {
    workspace(identifier: $workspaceIdentifier) {
      identifier
      workspaceMembership(identifier: $workspaceMembershipIdentifier) {
        identifier
        permissionGroupMemberships(
          search: $permissionGroupSearch
          after: $after
          limit: $limit
        ) {
          entries {
            identifier
            permissionGroup {
              identifier
              ...WorkspacePermissionGroup
            }
          }
          meta {
            after
            limit
            totalCount
          }
        }
      }
    }
  }
  ${WorkspacePermissionGroupFragmentDoc}
`

/**
 * __useGetAccessPermissionGroupMembershipsQuery__
 *
 * To run a query within a React component, call `useGetAccessPermissionGroupMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessPermissionGroupMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessPermissionGroupMembershipsQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      workspaceMembershipIdentifier: // value for 'workspaceMembershipIdentifier'
 *      permissionGroupSearch: // value for 'permissionGroupSearch'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAccessPermissionGroupMembershipsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetAccessPermissionGroupMembershipsQuery,
    Types.GetAccessPermissionGroupMembershipsQueryVariables
  > &
    (
      | {
          variables: Types.GetAccessPermissionGroupMembershipsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetAccessPermissionGroupMembershipsQuery,
    Types.GetAccessPermissionGroupMembershipsQueryVariables
  >(GetAccessPermissionGroupMembershipsDocument, options)
}
export function useGetAccessPermissionGroupMembershipsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetAccessPermissionGroupMembershipsQuery,
    Types.GetAccessPermissionGroupMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetAccessPermissionGroupMembershipsQuery,
    Types.GetAccessPermissionGroupMembershipsQueryVariables
  >(GetAccessPermissionGroupMembershipsDocument, options)
}

export type GetAccessPermissionGroupMembershipsQueryHookResult = ReturnType<
  typeof useGetAccessPermissionGroupMembershipsQuery
>
export type GetAccessPermissionGroupMembershipsLazyQueryHookResult = ReturnType<
  typeof useGetAccessPermissionGroupMembershipsLazyQuery
>
export type GetAccessPermissionGroupMembershipsQueryResult = Apollo.QueryResult<
  Types.GetAccessPermissionGroupMembershipsQuery,
  Types.GetAccessPermissionGroupMembershipsQueryVariables
>
export const InviteWorkspacePartnerDocument = /*#__PURE__*/ gql`
  mutation inviteWorkspacePartner($input: InviteWorkspacePartnerParams!) {
    inviteWorkspacePartner(input: $input) {
      identifier
      name
    }
  }
`
export type InviteWorkspacePartnerMutationFn = Apollo.MutationFunction<
  Types.InviteWorkspacePartnerMutation,
  Types.InviteWorkspacePartnerMutationVariables
>

/**
 * __useInviteWorkspacePartnerMutation__
 *
 * To run a mutation, you first call `useInviteWorkspacePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteWorkspacePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteWorkspacePartnerMutation, { data, loading, error }] = useInviteWorkspacePartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteWorkspacePartnerMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.InviteWorkspacePartnerMutation,
    Types.InviteWorkspacePartnerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.InviteWorkspacePartnerMutation,
    Types.InviteWorkspacePartnerMutationVariables
  >(InviteWorkspacePartnerDocument, options)
}
export type InviteWorkspacePartnerMutationHookResult = ReturnType<
  typeof useInviteWorkspacePartnerMutation
>
export type InviteWorkspacePartnerMutationResult =
  Apollo.MutationResult<Types.InviteWorkspacePartnerMutation>
export type InviteWorkspacePartnerMutationOptions = Apollo.BaseMutationOptions<
  Types.InviteWorkspacePartnerMutation,
  Types.InviteWorkspacePartnerMutationVariables
>
export const AcceptPartnershipInviteDocument = /*#__PURE__*/ gql`
  mutation acceptPartnershipInvite(
    $membershipToken: String
    $membershipId: UUID
    $seats: Int!
    $tosAgreed: Boolean!
    $shipping: ShippingDetailsInput
  ) {
    acceptPartnershipInvite(
      membershipToken: $membershipToken
      membershipId: $membershipId
      seats: $seats
      tosAgreed: $tosAgreed
      shipping: $shipping
    ) {
      membership {
        identifier
      }
    }
  }
`
export type AcceptPartnershipInviteMutationFn = Apollo.MutationFunction<
  Types.AcceptPartnershipInviteMutation,
  Types.AcceptPartnershipInviteMutationVariables
>

/**
 * __useAcceptPartnershipInviteMutation__
 *
 * To run a mutation, you first call `useAcceptPartnershipInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptPartnershipInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptPartnershipInviteMutation, { data, loading, error }] = useAcceptPartnershipInviteMutation({
 *   variables: {
 *      membershipToken: // value for 'membershipToken'
 *      membershipId: // value for 'membershipId'
 *      seats: // value for 'seats'
 *      tosAgreed: // value for 'tosAgreed'
 *      shipping: // value for 'shipping'
 *   },
 * });
 */
export function useAcceptPartnershipInviteMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AcceptPartnershipInviteMutation,
    Types.AcceptPartnershipInviteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AcceptPartnershipInviteMutation,
    Types.AcceptPartnershipInviteMutationVariables
  >(AcceptPartnershipInviteDocument, options)
}
export type AcceptPartnershipInviteMutationHookResult = ReturnType<
  typeof useAcceptPartnershipInviteMutation
>
export type AcceptPartnershipInviteMutationResult =
  Apollo.MutationResult<Types.AcceptPartnershipInviteMutation>
export type AcceptPartnershipInviteMutationOptions = Apollo.BaseMutationOptions<
  Types.AcceptPartnershipInviteMutation,
  Types.AcceptPartnershipInviteMutationVariables
>
export const CreatePartnerWorkspaceDocument = /*#__PURE__*/ gql`
  mutation createPartnerWorkspace($input: CreatePartnerWorkspaceParams!) {
    createPartnerWorkspace(input: $input) {
      workspace {
        identifier
      }
    }
  }
`
export type CreatePartnerWorkspaceMutationFn = Apollo.MutationFunction<
  Types.CreatePartnerWorkspaceMutation,
  Types.CreatePartnerWorkspaceMutationVariables
>

/**
 * __useCreatePartnerWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreatePartnerWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartnerWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartnerWorkspaceMutation, { data, loading, error }] = useCreatePartnerWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePartnerWorkspaceMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreatePartnerWorkspaceMutation,
    Types.CreatePartnerWorkspaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreatePartnerWorkspaceMutation,
    Types.CreatePartnerWorkspaceMutationVariables
  >(CreatePartnerWorkspaceDocument, options)
}
export type CreatePartnerWorkspaceMutationHookResult = ReturnType<
  typeof useCreatePartnerWorkspaceMutation
>
export type CreatePartnerWorkspaceMutationResult =
  Apollo.MutationResult<Types.CreatePartnerWorkspaceMutation>
export type CreatePartnerWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  Types.CreatePartnerWorkspaceMutation,
  Types.CreatePartnerWorkspaceMutationVariables
>
export const GetPartnerDocument = /*#__PURE__*/ gql`
  query getPartner($email: String!) {
    partner(email: $email) {
      identifier
      name
      email
      avatar {
        small
      }
    }
  }
`

/**
 * __useGetPartnerQuery__
 *
 * To run a query within a React component, call `useGetPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetPartnerQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetPartnerQuery,
    Types.GetPartnerQueryVariables
  > &
    (
      | { variables: Types.GetPartnerQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPartnerQuery,
    Types.GetPartnerQueryVariables
  >(GetPartnerDocument, options)
}
export function useGetPartnerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPartnerQuery,
    Types.GetPartnerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPartnerQuery,
    Types.GetPartnerQueryVariables
  >(GetPartnerDocument, options)
}

export type GetPartnerQueryHookResult = ReturnType<typeof useGetPartnerQuery>
export type GetPartnerLazyQueryHookResult = ReturnType<
  typeof useGetPartnerLazyQuery
>
export type GetPartnerQueryResult = Apollo.QueryResult<
  Types.GetPartnerQuery,
  Types.GetPartnerQueryVariables
>
export const GetPartnerBillingDetailsDocument = /*#__PURE__*/ gql`
  query getPartnerBillingDetails @PaymentQLApi {
    partnerBillingDetails {
      name
      email
      address {
        line1
        city
        state
        country
        postalCode
      }
      taxId
    }
  }
`

/**
 * __useGetPartnerBillingDetailsQuery__
 *
 * To run a query within a React component, call `useGetPartnerBillingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerBillingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerBillingDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartnerBillingDetailsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetPartnerBillingDetailsQuery,
    Types.GetPartnerBillingDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetPartnerBillingDetailsQuery,
    Types.GetPartnerBillingDetailsQueryVariables
  >(GetPartnerBillingDetailsDocument, options)
}
export function useGetPartnerBillingDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetPartnerBillingDetailsQuery,
    Types.GetPartnerBillingDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetPartnerBillingDetailsQuery,
    Types.GetPartnerBillingDetailsQueryVariables
  >(GetPartnerBillingDetailsDocument, options)
}

export type GetPartnerBillingDetailsQueryHookResult = ReturnType<
  typeof useGetPartnerBillingDetailsQuery
>
export type GetPartnerBillingDetailsLazyQueryHookResult = ReturnType<
  typeof useGetPartnerBillingDetailsLazyQuery
>
export type GetPartnerBillingDetailsQueryResult = Apollo.QueryResult<
  Types.GetPartnerBillingDetailsQuery,
  Types.GetPartnerBillingDetailsQueryVariables
>
export const CreatePermissionGroupDocument = /*#__PURE__*/ gql`
  mutation createPermissionGroup($input: CreatePermissionGroupParams!) {
    createPermissionGroup(input: $input) {
      permissionGroup {
        identifier
        ...WorkspacePermissionGroup
      }
    }
  }
  ${WorkspacePermissionGroupFragmentDoc}
`
export type CreatePermissionGroupMutationFn = Apollo.MutationFunction<
  Types.CreatePermissionGroupMutation,
  Types.CreatePermissionGroupMutationVariables
>

/**
 * __useCreatePermissionGroupMutation__
 *
 * To run a mutation, you first call `useCreatePermissionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePermissionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPermissionGroupMutation, { data, loading, error }] = useCreatePermissionGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePermissionGroupMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreatePermissionGroupMutation,
    Types.CreatePermissionGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreatePermissionGroupMutation,
    Types.CreatePermissionGroupMutationVariables
  >(CreatePermissionGroupDocument, options)
}
export type CreatePermissionGroupMutationHookResult = ReturnType<
  typeof useCreatePermissionGroupMutation
>
export type CreatePermissionGroupMutationResult =
  Apollo.MutationResult<Types.CreatePermissionGroupMutation>
export type CreatePermissionGroupMutationOptions = Apollo.BaseMutationOptions<
  Types.CreatePermissionGroupMutation,
  Types.CreatePermissionGroupMutationVariables
>
export const UpdatePermissionGroupNameDocument = /*#__PURE__*/ gql`
  mutation updatePermissionGroupName($input: UpdatePermissionGroupParams!) {
    updatePermissionGroup(input: $input) {
      permissionGroup {
        identifier
        name
      }
    }
  }
`
export type UpdatePermissionGroupNameMutationFn = Apollo.MutationFunction<
  Types.UpdatePermissionGroupNameMutation,
  Types.UpdatePermissionGroupNameMutationVariables
>

/**
 * __useUpdatePermissionGroupNameMutation__
 *
 * To run a mutation, you first call `useUpdatePermissionGroupNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePermissionGroupNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePermissionGroupNameMutation, { data, loading, error }] = useUpdatePermissionGroupNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePermissionGroupNameMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdatePermissionGroupNameMutation,
    Types.UpdatePermissionGroupNameMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdatePermissionGroupNameMutation,
    Types.UpdatePermissionGroupNameMutationVariables
  >(UpdatePermissionGroupNameDocument, options)
}
export type UpdatePermissionGroupNameMutationHookResult = ReturnType<
  typeof useUpdatePermissionGroupNameMutation
>
export type UpdatePermissionGroupNameMutationResult =
  Apollo.MutationResult<Types.UpdatePermissionGroupNameMutation>
export type UpdatePermissionGroupNameMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdatePermissionGroupNameMutation,
    Types.UpdatePermissionGroupNameMutationVariables
  >
export const AddMemberToPermissionGroupDocument = /*#__PURE__*/ gql`
  mutation addMemberToPermissionGroup(
    $input: AddPermissionGroupMembersParams!
  ) {
    addPermissionGroupMembers(input: $input) {
      permissionGroup {
        ...WorkspacePermissionGroup
      }
      members {
        identifier
        workspaceMember {
          ...WorkspaceMembership
        }
      }
    }
  }
  ${WorkspacePermissionGroupFragmentDoc}
  ${WorkspaceMembershipFragmentDoc}
`
export type AddMemberToPermissionGroupMutationFn = Apollo.MutationFunction<
  Types.AddMemberToPermissionGroupMutation,
  Types.AddMemberToPermissionGroupMutationVariables
>

/**
 * __useAddMemberToPermissionGroupMutation__
 *
 * To run a mutation, you first call `useAddMemberToPermissionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberToPermissionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberToPermissionGroupMutation, { data, loading, error }] = useAddMemberToPermissionGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMemberToPermissionGroupMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AddMemberToPermissionGroupMutation,
    Types.AddMemberToPermissionGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AddMemberToPermissionGroupMutation,
    Types.AddMemberToPermissionGroupMutationVariables
  >(AddMemberToPermissionGroupDocument, options)
}
export type AddMemberToPermissionGroupMutationHookResult = ReturnType<
  typeof useAddMemberToPermissionGroupMutation
>
export type AddMemberToPermissionGroupMutationResult =
  Apollo.MutationResult<Types.AddMemberToPermissionGroupMutation>
export type AddMemberToPermissionGroupMutationOptions =
  Apollo.BaseMutationOptions<
    Types.AddMemberToPermissionGroupMutation,
    Types.AddMemberToPermissionGroupMutationVariables
  >
export const RemovePermissionGroupMemberDocument = /*#__PURE__*/ gql`
  mutation removePermissionGroupMember(
    $input: RemovePermissionGroupMemberParams!
  ) {
    removePermissionGroupMember(input: $input) {
      permissionGroup {
        ...WorkspacePermissionGroup
      }
    }
  }
  ${WorkspacePermissionGroupFragmentDoc}
`
export type RemovePermissionGroupMemberMutationFn = Apollo.MutationFunction<
  Types.RemovePermissionGroupMemberMutation,
  Types.RemovePermissionGroupMemberMutationVariables
>

/**
 * __useRemovePermissionGroupMemberMutation__
 *
 * To run a mutation, you first call `useRemovePermissionGroupMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePermissionGroupMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePermissionGroupMemberMutation, { data, loading, error }] = useRemovePermissionGroupMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemovePermissionGroupMemberMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RemovePermissionGroupMemberMutation,
    Types.RemovePermissionGroupMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RemovePermissionGroupMemberMutation,
    Types.RemovePermissionGroupMemberMutationVariables
  >(RemovePermissionGroupMemberDocument, options)
}
export type RemovePermissionGroupMemberMutationHookResult = ReturnType<
  typeof useRemovePermissionGroupMemberMutation
>
export type RemovePermissionGroupMemberMutationResult =
  Apollo.MutationResult<Types.RemovePermissionGroupMemberMutation>
export type RemovePermissionGroupMemberMutationOptions =
  Apollo.BaseMutationOptions<
    Types.RemovePermissionGroupMemberMutation,
    Types.RemovePermissionGroupMemberMutationVariables
  >
export const DeletePermissionGroupDocument = /*#__PURE__*/ gql`
  mutation deletePermissionGroup($input: DeletePermissionGroupParams!) {
    deletePermissionGroup(input: $input) {
      permissionGroupIdentifier
    }
  }
`
export type DeletePermissionGroupMutationFn = Apollo.MutationFunction<
  Types.DeletePermissionGroupMutation,
  Types.DeletePermissionGroupMutationVariables
>

/**
 * __useDeletePermissionGroupMutation__
 *
 * To run a mutation, you first call `useDeletePermissionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePermissionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePermissionGroupMutation, { data, loading, error }] = useDeletePermissionGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePermissionGroupMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.DeletePermissionGroupMutation,
    Types.DeletePermissionGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.DeletePermissionGroupMutation,
    Types.DeletePermissionGroupMutationVariables
  >(DeletePermissionGroupDocument, options)
}
export type DeletePermissionGroupMutationHookResult = ReturnType<
  typeof useDeletePermissionGroupMutation
>
export type DeletePermissionGroupMutationResult =
  Apollo.MutationResult<Types.DeletePermissionGroupMutation>
export type DeletePermissionGroupMutationOptions = Apollo.BaseMutationOptions<
  Types.DeletePermissionGroupMutation,
  Types.DeletePermissionGroupMutationVariables
>
export const AddSharePermissionGroupRelationDocument = /*#__PURE__*/ gql`
  mutation addSharePermissionGroupRelation(
    $accessLevel: PrivateAccessLevel!
    $permissionGroupIdentifier: UUID!
    $shareIdentifier: UUID!
  ) {
    addSharePermissionGroupRelation(
      accessLevel: $accessLevel
      permissionGroupIdentifier: $permissionGroupIdentifier
      shareIdentifier: $shareIdentifier
    ) {
      relation {
        identifier
      }
    }
  }
`
export type AddSharePermissionGroupRelationMutationFn = Apollo.MutationFunction<
  Types.AddSharePermissionGroupRelationMutation,
  Types.AddSharePermissionGroupRelationMutationVariables
>

/**
 * __useAddSharePermissionGroupRelationMutation__
 *
 * To run a mutation, you first call `useAddSharePermissionGroupRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSharePermissionGroupRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSharePermissionGroupRelationMutation, { data, loading, error }] = useAddSharePermissionGroupRelationMutation({
 *   variables: {
 *      accessLevel: // value for 'accessLevel'
 *      permissionGroupIdentifier: // value for 'permissionGroupIdentifier'
 *      shareIdentifier: // value for 'shareIdentifier'
 *   },
 * });
 */
export function useAddSharePermissionGroupRelationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AddSharePermissionGroupRelationMutation,
    Types.AddSharePermissionGroupRelationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AddSharePermissionGroupRelationMutation,
    Types.AddSharePermissionGroupRelationMutationVariables
  >(AddSharePermissionGroupRelationDocument, options)
}
export type AddSharePermissionGroupRelationMutationHookResult = ReturnType<
  typeof useAddSharePermissionGroupRelationMutation
>
export type AddSharePermissionGroupRelationMutationResult =
  Apollo.MutationResult<Types.AddSharePermissionGroupRelationMutation>
export type AddSharePermissionGroupRelationMutationOptions =
  Apollo.BaseMutationOptions<
    Types.AddSharePermissionGroupRelationMutation,
    Types.AddSharePermissionGroupRelationMutationVariables
  >
export const AddProjectPermissionGroupRelationDocument = /*#__PURE__*/ gql`
  mutation addProjectPermissionGroupRelation(
    $permissionGroupIdentifier: UUID!
    $projectIdentifier: UUID!
  ) {
    addProjectPermissionGroupRelation(
      permissionGroupIdentifier: $permissionGroupIdentifier
      projectIdentifier: $projectIdentifier
    ) {
      relation {
        identifier
      }
    }
  }
`
export type AddProjectPermissionGroupRelationMutationFn =
  Apollo.MutationFunction<
    Types.AddProjectPermissionGroupRelationMutation,
    Types.AddProjectPermissionGroupRelationMutationVariables
  >

/**
 * __useAddProjectPermissionGroupRelationMutation__
 *
 * To run a mutation, you first call `useAddProjectPermissionGroupRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectPermissionGroupRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectPermissionGroupRelationMutation, { data, loading, error }] = useAddProjectPermissionGroupRelationMutation({
 *   variables: {
 *      permissionGroupIdentifier: // value for 'permissionGroupIdentifier'
 *      projectIdentifier: // value for 'projectIdentifier'
 *   },
 * });
 */
export function useAddProjectPermissionGroupRelationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.AddProjectPermissionGroupRelationMutation,
    Types.AddProjectPermissionGroupRelationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.AddProjectPermissionGroupRelationMutation,
    Types.AddProjectPermissionGroupRelationMutationVariables
  >(AddProjectPermissionGroupRelationDocument, options)
}
export type AddProjectPermissionGroupRelationMutationHookResult = ReturnType<
  typeof useAddProjectPermissionGroupRelationMutation
>
export type AddProjectPermissionGroupRelationMutationResult =
  Apollo.MutationResult<Types.AddProjectPermissionGroupRelationMutation>
export type AddProjectPermissionGroupRelationMutationOptions =
  Apollo.BaseMutationOptions<
    Types.AddProjectPermissionGroupRelationMutation,
    Types.AddProjectPermissionGroupRelationMutationVariables
  >
export const RemovePermissionGroupToShareProjectDocument = /*#__PURE__*/ gql`
  mutation removePermissionGroupToShareProject(
    $input: RemovePermissionGroupRelationParams!
  ) {
    removePermissionGroupRelation(input: $input) {
      permissionGroup {
        identifier
      }
      share {
        identifier
      }
      project {
        identifier
      }
    }
  }
`
export type RemovePermissionGroupToShareProjectMutationFn =
  Apollo.MutationFunction<
    Types.RemovePermissionGroupToShareProjectMutation,
    Types.RemovePermissionGroupToShareProjectMutationVariables
  >

/**
 * __useRemovePermissionGroupToShareProjectMutation__
 *
 * To run a mutation, you first call `useRemovePermissionGroupToShareProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePermissionGroupToShareProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePermissionGroupToShareProjectMutation, { data, loading, error }] = useRemovePermissionGroupToShareProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemovePermissionGroupToShareProjectMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.RemovePermissionGroupToShareProjectMutation,
    Types.RemovePermissionGroupToShareProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.RemovePermissionGroupToShareProjectMutation,
    Types.RemovePermissionGroupToShareProjectMutationVariables
  >(RemovePermissionGroupToShareProjectDocument, options)
}
export type RemovePermissionGroupToShareProjectMutationHookResult = ReturnType<
  typeof useRemovePermissionGroupToShareProjectMutation
>
export type RemovePermissionGroupToShareProjectMutationResult =
  Apollo.MutationResult<Types.RemovePermissionGroupToShareProjectMutation>
export type RemovePermissionGroupToShareProjectMutationOptions =
  Apollo.BaseMutationOptions<
    Types.RemovePermissionGroupToShareProjectMutation,
    Types.RemovePermissionGroupToShareProjectMutationVariables
  >
export const UpdateSharePermissionGroupRelationDocument = /*#__PURE__*/ gql`
  mutation updateSharePermissionGroupRelation(
    $accessLevel: PrivateAccessLevel!
    $relationIdentifier: UUID!
  ) {
    updateSharePermissionGroupRelation(
      accessLevel: $accessLevel
      relationIdentifier: $relationIdentifier
    ) {
      relation {
        identifier
        accessLevel
      }
    }
  }
`
export type UpdateSharePermissionGroupRelationMutationFn =
  Apollo.MutationFunction<
    Types.UpdateSharePermissionGroupRelationMutation,
    Types.UpdateSharePermissionGroupRelationMutationVariables
  >

/**
 * __useUpdateSharePermissionGroupRelationMutation__
 *
 * To run a mutation, you first call `useUpdateSharePermissionGroupRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSharePermissionGroupRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSharePermissionGroupRelationMutation, { data, loading, error }] = useUpdateSharePermissionGroupRelationMutation({
 *   variables: {
 *      accessLevel: // value for 'accessLevel'
 *      relationIdentifier: // value for 'relationIdentifier'
 *   },
 * });
 */
export function useUpdateSharePermissionGroupRelationMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateSharePermissionGroupRelationMutation,
    Types.UpdateSharePermissionGroupRelationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateSharePermissionGroupRelationMutation,
    Types.UpdateSharePermissionGroupRelationMutationVariables
  >(UpdateSharePermissionGroupRelationDocument, options)
}
export type UpdateSharePermissionGroupRelationMutationHookResult = ReturnType<
  typeof useUpdateSharePermissionGroupRelationMutation
>
export type UpdateSharePermissionGroupRelationMutationResult =
  Apollo.MutationResult<Types.UpdateSharePermissionGroupRelationMutation>
export type UpdateSharePermissionGroupRelationMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateSharePermissionGroupRelationMutation,
    Types.UpdateSharePermissionGroupRelationMutationVariables
  >
export const GetWorkspacePermissionGroupsDocument = /*#__PURE__*/ gql`
  query getWorkspacePermissionGroups(
    $workspaceIdentifier: UUID!
    $search: String
    $after: String
  ) {
    workspace(identifier: $workspaceIdentifier) {
      identifier
      permissionGroups(search: $search, after: $after) {
        entries {
          ...WorkspacePermissionGroup
        }
        meta {
          after
          totalCount
        }
      }
      totalWorkspacePermissionGroups: permissionGroups {
        meta {
          totalCount
        }
      }
    }
  }
  ${WorkspacePermissionGroupFragmentDoc}
`

/**
 * __useGetWorkspacePermissionGroupsQuery__
 *
 * To run a query within a React component, call `useGetWorkspacePermissionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacePermissionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacePermissionGroupsQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      search: // value for 'search'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetWorkspacePermissionGroupsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspacePermissionGroupsQuery,
    Types.GetWorkspacePermissionGroupsQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspacePermissionGroupsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspacePermissionGroupsQuery,
    Types.GetWorkspacePermissionGroupsQueryVariables
  >(GetWorkspacePermissionGroupsDocument, options)
}
export function useGetWorkspacePermissionGroupsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspacePermissionGroupsQuery,
    Types.GetWorkspacePermissionGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspacePermissionGroupsQuery,
    Types.GetWorkspacePermissionGroupsQueryVariables
  >(GetWorkspacePermissionGroupsDocument, options)
}

export type GetWorkspacePermissionGroupsQueryHookResult = ReturnType<
  typeof useGetWorkspacePermissionGroupsQuery
>
export type GetWorkspacePermissionGroupsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspacePermissionGroupsLazyQuery
>
export type GetWorkspacePermissionGroupsQueryResult = Apollo.QueryResult<
  Types.GetWorkspacePermissionGroupsQuery,
  Types.GetWorkspacePermissionGroupsQueryVariables
>
export const GetWorkspacePermissionGroupMembersDocument = /*#__PURE__*/ gql`
  query getWorkspacePermissionGroupMembers(
    $permissionGroupIdentifier: UUID!
    $after: String
  ) {
    permissionGroup(identifier: $permissionGroupIdentifier) {
      identifier
      members(after: $after) {
        entries {
          identifier
          workspaceMember {
            ...WorkspaceMembership
          }
        }
        meta {
          totalCount
          after
        }
      }
    }
  }
  ${WorkspaceMembershipFragmentDoc}
`

/**
 * __useGetWorkspacePermissionGroupMembersQuery__
 *
 * To run a query within a React component, call `useGetWorkspacePermissionGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacePermissionGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacePermissionGroupMembersQuery({
 *   variables: {
 *      permissionGroupIdentifier: // value for 'permissionGroupIdentifier'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetWorkspacePermissionGroupMembersQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspacePermissionGroupMembersQuery,
    Types.GetWorkspacePermissionGroupMembersQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspacePermissionGroupMembersQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspacePermissionGroupMembersQuery,
    Types.GetWorkspacePermissionGroupMembersQueryVariables
  >(GetWorkspacePermissionGroupMembersDocument, options)
}
export function useGetWorkspacePermissionGroupMembersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspacePermissionGroupMembersQuery,
    Types.GetWorkspacePermissionGroupMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspacePermissionGroupMembersQuery,
    Types.GetWorkspacePermissionGroupMembersQueryVariables
  >(GetWorkspacePermissionGroupMembersDocument, options)
}

export type GetWorkspacePermissionGroupMembersQueryHookResult = ReturnType<
  typeof useGetWorkspacePermissionGroupMembersQuery
>
export type GetWorkspacePermissionGroupMembersLazyQueryHookResult = ReturnType<
  typeof useGetWorkspacePermissionGroupMembersLazyQuery
>
export type GetWorkspacePermissionGroupMembersQueryResult = Apollo.QueryResult<
  Types.GetWorkspacePermissionGroupMembersQuery,
  Types.GetWorkspacePermissionGroupMembersQueryVariables
>
export const GetWorkspacePermissionGroupSharesDocument = /*#__PURE__*/ gql`
  query getWorkspacePermissionGroupShares(
    $permissionGroupIdentifier: UUID!
    $after: String
    $search: String
  ) {
    permissionGroup(identifier: $permissionGroupIdentifier) {
      identifier
      shares(search: $search, after: $after) {
        entries {
          identifier
          share {
            identifier
            name
            updatedAt
            version(preferredState: PROCESSED) {
              ...Version
              document {
                identifier
                previewFile {
                  ...ShareThumbnails
                }
              }
            }
          }
        }
        meta {
          after
          totalCount
        }
      }
      projects(search: $search) {
        meta {
          totalCount
        }
      }
    }
  }
  ${VersionFragmentDoc}
  ${ShareThumbnailsFragmentDoc}
`

/**
 * __useGetWorkspacePermissionGroupSharesQuery__
 *
 * To run a query within a React component, call `useGetWorkspacePermissionGroupSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacePermissionGroupSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacePermissionGroupSharesQuery({
 *   variables: {
 *      permissionGroupIdentifier: // value for 'permissionGroupIdentifier'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetWorkspacePermissionGroupSharesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspacePermissionGroupSharesQuery,
    Types.GetWorkspacePermissionGroupSharesQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspacePermissionGroupSharesQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspacePermissionGroupSharesQuery,
    Types.GetWorkspacePermissionGroupSharesQueryVariables
  >(GetWorkspacePermissionGroupSharesDocument, options)
}
export function useGetWorkspacePermissionGroupSharesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspacePermissionGroupSharesQuery,
    Types.GetWorkspacePermissionGroupSharesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspacePermissionGroupSharesQuery,
    Types.GetWorkspacePermissionGroupSharesQueryVariables
  >(GetWorkspacePermissionGroupSharesDocument, options)
}

export type GetWorkspacePermissionGroupSharesQueryHookResult = ReturnType<
  typeof useGetWorkspacePermissionGroupSharesQuery
>
export type GetWorkspacePermissionGroupSharesLazyQueryHookResult = ReturnType<
  typeof useGetWorkspacePermissionGroupSharesLazyQuery
>
export type GetWorkspacePermissionGroupSharesQueryResult = Apollo.QueryResult<
  Types.GetWorkspacePermissionGroupSharesQuery,
  Types.GetWorkspacePermissionGroupSharesQueryVariables
>
export const GetWorkspacePermissionGroupProjectsDocument = /*#__PURE__*/ gql`
  query getWorkspacePermissionGroupProjects(
    $permissionGroupIdentifier: UUID!
    $after: String
    $search: String
  ) {
    permissionGroup(identifier: $permissionGroupIdentifier) {
      identifier
      projects(search: $search, after: $after) {
        entries {
          identifier
          project {
            identifier
            ...Project
          }
        }
        meta {
          after
          totalCount
        }
      }
      shares(search: $search) {
        meta {
          totalCount
        }
      }
    }
  }
  ${ProjectFragmentDoc}
`

/**
 * __useGetWorkspacePermissionGroupProjectsQuery__
 *
 * To run a query within a React component, call `useGetWorkspacePermissionGroupProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacePermissionGroupProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacePermissionGroupProjectsQuery({
 *   variables: {
 *      permissionGroupIdentifier: // value for 'permissionGroupIdentifier'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetWorkspacePermissionGroupProjectsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspacePermissionGroupProjectsQuery,
    Types.GetWorkspacePermissionGroupProjectsQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspacePermissionGroupProjectsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspacePermissionGroupProjectsQuery,
    Types.GetWorkspacePermissionGroupProjectsQueryVariables
  >(GetWorkspacePermissionGroupProjectsDocument, options)
}
export function useGetWorkspacePermissionGroupProjectsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspacePermissionGroupProjectsQuery,
    Types.GetWorkspacePermissionGroupProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspacePermissionGroupProjectsQuery,
    Types.GetWorkspacePermissionGroupProjectsQueryVariables
  >(GetWorkspacePermissionGroupProjectsDocument, options)
}

export type GetWorkspacePermissionGroupProjectsQueryHookResult = ReturnType<
  typeof useGetWorkspacePermissionGroupProjectsQuery
>
export type GetWorkspacePermissionGroupProjectsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspacePermissionGroupProjectsLazyQuery
>
export type GetWorkspacePermissionGroupProjectsQueryResult = Apollo.QueryResult<
  Types.GetWorkspacePermissionGroupProjectsQuery,
  Types.GetWorkspacePermissionGroupProjectsQueryVariables
>
export const GetInvitableUsersForPermissionGroupDocument = /*#__PURE__*/ gql`
  query getInvitableUsersForPermissionGroup(
    $workspaceIdentifier: UUID!
    $permissionGroupIdentifier: UUID
    $search: String
  ) {
    invitableUsersForPermissionGroup(
      workspaceIdentifier: $workspaceIdentifier
      permissionGroupIdentifier: $permissionGroupIdentifier
      search: $search
    ) {
      entries {
        identifier
        ...WorkspaceMembership
      }
    }
  }
  ${WorkspaceMembershipFragmentDoc}
`

/**
 * __useGetInvitableUsersForPermissionGroupQuery__
 *
 * To run a query within a React component, call `useGetInvitableUsersForPermissionGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitableUsersForPermissionGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitableUsersForPermissionGroupQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      permissionGroupIdentifier: // value for 'permissionGroupIdentifier'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetInvitableUsersForPermissionGroupQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetInvitableUsersForPermissionGroupQuery,
    Types.GetInvitableUsersForPermissionGroupQueryVariables
  > &
    (
      | {
          variables: Types.GetInvitableUsersForPermissionGroupQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetInvitableUsersForPermissionGroupQuery,
    Types.GetInvitableUsersForPermissionGroupQueryVariables
  >(GetInvitableUsersForPermissionGroupDocument, options)
}
export function useGetInvitableUsersForPermissionGroupLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetInvitableUsersForPermissionGroupQuery,
    Types.GetInvitableUsersForPermissionGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetInvitableUsersForPermissionGroupQuery,
    Types.GetInvitableUsersForPermissionGroupQueryVariables
  >(GetInvitableUsersForPermissionGroupDocument, options)
}

export type GetInvitableUsersForPermissionGroupQueryHookResult = ReturnType<
  typeof useGetInvitableUsersForPermissionGroupQuery
>
export type GetInvitableUsersForPermissionGroupLazyQueryHookResult = ReturnType<
  typeof useGetInvitableUsersForPermissionGroupLazyQuery
>
export type GetInvitableUsersForPermissionGroupQueryResult = Apollo.QueryResult<
  Types.GetInvitableUsersForPermissionGroupQuery,
  Types.GetInvitableUsersForPermissionGroupQueryVariables
>
export const GetWorkspaceStorageDetailsDocument = /*#__PURE__*/ gql`
  query getWorkspaceStorageDetails($identifier: UUID!) {
    workspaceStorage(identifier: $identifier) {
      used
      limit
      shareCount
    }
  }
`

/**
 * __useGetWorkspaceStorageDetailsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceStorageDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceStorageDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceStorageDetailsQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetWorkspaceStorageDetailsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceStorageDetailsQuery,
    Types.GetWorkspaceStorageDetailsQueryVariables
  > &
    (
      | {
          variables: Types.GetWorkspaceStorageDetailsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceStorageDetailsQuery,
    Types.GetWorkspaceStorageDetailsQueryVariables
  >(GetWorkspaceStorageDetailsDocument, options)
}
export function useGetWorkspaceStorageDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceStorageDetailsQuery,
    Types.GetWorkspaceStorageDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceStorageDetailsQuery,
    Types.GetWorkspaceStorageDetailsQueryVariables
  >(GetWorkspaceStorageDetailsDocument, options)
}

export type GetWorkspaceStorageDetailsQueryHookResult = ReturnType<
  typeof useGetWorkspaceStorageDetailsQuery
>
export type GetWorkspaceStorageDetailsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceStorageDetailsLazyQuery
>
export type GetWorkspaceStorageDetailsQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceStorageDetailsQuery,
  Types.GetWorkspaceStorageDetailsQueryVariables
>
export const CreateWorkspaceProfileDocument = /*#__PURE__*/ gql`
  mutation createWorkspaceProfile(
    $workspaceIdentifier: UUID!
    $input: CreateWorkspaceProfileParams
  ) {
    createWorkspaceProfile(
      workspaceIdentifier: $workspaceIdentifier
      input: $input
    ) {
      workspaceProfile {
        identifier
      }
    }
  }
`
export type CreateWorkspaceProfileMutationFn = Apollo.MutationFunction<
  Types.CreateWorkspaceProfileMutation,
  Types.CreateWorkspaceProfileMutationVariables
>

/**
 * __useCreateWorkspaceProfileMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceProfileMutation, { data, loading, error }] = useCreateWorkspaceProfileMutation({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkspaceProfileMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CreateWorkspaceProfileMutation,
    Types.CreateWorkspaceProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CreateWorkspaceProfileMutation,
    Types.CreateWorkspaceProfileMutationVariables
  >(CreateWorkspaceProfileDocument, options)
}
export type CreateWorkspaceProfileMutationHookResult = ReturnType<
  typeof useCreateWorkspaceProfileMutation
>
export type CreateWorkspaceProfileMutationResult =
  Apollo.MutationResult<Types.CreateWorkspaceProfileMutation>
export type CreateWorkspaceProfileMutationOptions = Apollo.BaseMutationOptions<
  Types.CreateWorkspaceProfileMutation,
  Types.CreateWorkspaceProfileMutationVariables
>
export const UpdateWorkspaceProfileDocument = /*#__PURE__*/ gql`
  mutation updateWorkspaceProfile($input: UpdateWorkspaceProfileParams!) {
    updateWorkspaceProfile(input: $input) {
      workspaceProfile {
        identifier
        ...WorkspaceProfile
      }
    }
  }
  ${WorkspaceProfileFragmentDoc}
`
export type UpdateWorkspaceProfileMutationFn = Apollo.MutationFunction<
  Types.UpdateWorkspaceProfileMutation,
  Types.UpdateWorkspaceProfileMutationVariables
>

/**
 * __useUpdateWorkspaceProfileMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceProfileMutation, { data, loading, error }] = useUpdateWorkspaceProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceProfileMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateWorkspaceProfileMutation,
    Types.UpdateWorkspaceProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateWorkspaceProfileMutation,
    Types.UpdateWorkspaceProfileMutationVariables
  >(UpdateWorkspaceProfileDocument, options)
}
export type UpdateWorkspaceProfileMutationHookResult = ReturnType<
  typeof useUpdateWorkspaceProfileMutation
>
export type UpdateWorkspaceProfileMutationResult =
  Apollo.MutationResult<Types.UpdateWorkspaceProfileMutation>
export type UpdateWorkspaceProfileMutationOptions = Apollo.BaseMutationOptions<
  Types.UpdateWorkspaceProfileMutation,
  Types.UpdateWorkspaceProfileMutationVariables
>
export const CheckWorkspaceProfileShortUrlDocument = /*#__PURE__*/ gql`
  mutation checkWorkspaceProfileShortUrl($shortUrlName: String!) {
    checkWorkspaceProfileShortUrl(shortUrlName: $shortUrlName) {
      available
    }
  }
`
export type CheckWorkspaceProfileShortUrlMutationFn = Apollo.MutationFunction<
  Types.CheckWorkspaceProfileShortUrlMutation,
  Types.CheckWorkspaceProfileShortUrlMutationVariables
>

/**
 * __useCheckWorkspaceProfileShortUrlMutation__
 *
 * To run a mutation, you first call `useCheckWorkspaceProfileShortUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckWorkspaceProfileShortUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkWorkspaceProfileShortUrlMutation, { data, loading, error }] = useCheckWorkspaceProfileShortUrlMutation({
 *   variables: {
 *      shortUrlName: // value for 'shortUrlName'
 *   },
 * });
 */
export function useCheckWorkspaceProfileShortUrlMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.CheckWorkspaceProfileShortUrlMutation,
    Types.CheckWorkspaceProfileShortUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.CheckWorkspaceProfileShortUrlMutation,
    Types.CheckWorkspaceProfileShortUrlMutationVariables
  >(CheckWorkspaceProfileShortUrlDocument, options)
}
export type CheckWorkspaceProfileShortUrlMutationHookResult = ReturnType<
  typeof useCheckWorkspaceProfileShortUrlMutation
>
export type CheckWorkspaceProfileShortUrlMutationResult =
  Apollo.MutationResult<Types.CheckWorkspaceProfileShortUrlMutation>
export type CheckWorkspaceProfileShortUrlMutationOptions =
  Apollo.BaseMutationOptions<
    Types.CheckWorkspaceProfileShortUrlMutation,
    Types.CheckWorkspaceProfileShortUrlMutationVariables
  >
export const UpdateWorkspaceProfileShortUrlDocument = /*#__PURE__*/ gql`
  mutation updateWorkspaceProfileShortUrl(
    $input: UpdateWorkspaceProfileShortUrlParams!
  ) {
    updateWorkspaceProfileShortUrl(input: $input) {
      workspaceProfile {
        ...WorkspaceProfile
      }
    }
  }
  ${WorkspaceProfileFragmentDoc}
`
export type UpdateWorkspaceProfileShortUrlMutationFn = Apollo.MutationFunction<
  Types.UpdateWorkspaceProfileShortUrlMutation,
  Types.UpdateWorkspaceProfileShortUrlMutationVariables
>

/**
 * __useUpdateWorkspaceProfileShortUrlMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceProfileShortUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceProfileShortUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceProfileShortUrlMutation, { data, loading, error }] = useUpdateWorkspaceProfileShortUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceProfileShortUrlMutation(
  baseOptions: ApolloReactHooks.MutationHookOptions<
    Types.UpdateWorkspaceProfileShortUrlMutation,
    Types.UpdateWorkspaceProfileShortUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    Types.UpdateWorkspaceProfileShortUrlMutation,
    Types.UpdateWorkspaceProfileShortUrlMutationVariables
  >(UpdateWorkspaceProfileShortUrlDocument, options)
}
export type UpdateWorkspaceProfileShortUrlMutationHookResult = ReturnType<
  typeof useUpdateWorkspaceProfileShortUrlMutation
>
export type UpdateWorkspaceProfileShortUrlMutationResult =
  Apollo.MutationResult<Types.UpdateWorkspaceProfileShortUrlMutation>
export type UpdateWorkspaceProfileShortUrlMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateWorkspaceProfileShortUrlMutation,
    Types.UpdateWorkspaceProfileShortUrlMutationVariables
  >
export const GetWorkspaceProfileDocument = /*#__PURE__*/ gql`
  query getWorkspaceProfile($workspaceIdentifier: UUID, $shortUrlName: String) {
    workspaceProfile(
      workspaceIdentifier: $workspaceIdentifier
      shortUrlName: $shortUrlName
    ) {
      ...WorkspaceProfile
    }
  }
  ${WorkspaceProfileFragmentDoc}
`

/**
 * __useGetWorkspaceProfileQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceProfileQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      shortUrlName: // value for 'shortUrlName'
 *   },
 * });
 */
export function useGetWorkspaceProfileQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Types.GetWorkspaceProfileQuery,
    Types.GetWorkspaceProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetWorkspaceProfileQuery,
    Types.GetWorkspaceProfileQueryVariables
  >(GetWorkspaceProfileDocument, options)
}
export function useGetWorkspaceProfileLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetWorkspaceProfileQuery,
    Types.GetWorkspaceProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetWorkspaceProfileQuery,
    Types.GetWorkspaceProfileQueryVariables
  >(GetWorkspaceProfileDocument, options)
}

export type GetWorkspaceProfileQueryHookResult = ReturnType<
  typeof useGetWorkspaceProfileQuery
>
export type GetWorkspaceProfileLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceProfileLazyQuery
>
export type GetWorkspaceProfileQueryResult = Apollo.QueryResult<
  Types.GetWorkspaceProfileQuery,
  Types.GetWorkspaceProfileQueryVariables
>
export const GetProfilePublicationsDocument = /*#__PURE__*/ gql`
  query getProfilePublications($workspaceIdentifier: UUID!, $after: String) {
    workspaceProfile(workspaceIdentifier: $workspaceIdentifier) {
      identifier
      publications(after: $after) {
        entries {
          ...PublicationItem
        }
        meta {
          after
          totalCount
        }
      }
    }
  }
  ${PublicationItemFragmentDoc}
`

/**
 * __useGetProfilePublicationsQuery__
 *
 * To run a query within a React component, call `useGetProfilePublicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilePublicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilePublicationsQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetProfilePublicationsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetProfilePublicationsQuery,
    Types.GetProfilePublicationsQueryVariables
  > &
    (
      | {
          variables: Types.GetProfilePublicationsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetProfilePublicationsQuery,
    Types.GetProfilePublicationsQueryVariables
  >(GetProfilePublicationsDocument, options)
}
export function useGetProfilePublicationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetProfilePublicationsQuery,
    Types.GetProfilePublicationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetProfilePublicationsQuery,
    Types.GetProfilePublicationsQueryVariables
  >(GetProfilePublicationsDocument, options)
}

export type GetProfilePublicationsQueryHookResult = ReturnType<
  typeof useGetProfilePublicationsQuery
>
export type GetProfilePublicationsLazyQueryHookResult = ReturnType<
  typeof useGetProfilePublicationsLazyQuery
>
export type GetProfilePublicationsQueryResult = Apollo.QueryResult<
  Types.GetProfilePublicationsQuery,
  Types.GetProfilePublicationsQueryVariables
>
export const GetRandomPublicationsDocument = /*#__PURE__*/ gql`
  query getRandomPublications(
    $workspaceIdentifier: UUID!
    $exclude: [UUID!]
    $limit: Int = 2
  ) {
    workspaceProfile(workspaceIdentifier: $workspaceIdentifier) {
      identifier
      shortUrlName
      publications(sortOrder: RANDOM, exclude: $exclude, limit: $limit) {
        entries {
          ...PublicationItem
        }
      }
    }
  }
  ${PublicationItemFragmentDoc}
`

/**
 * __useGetRandomPublicationsQuery__
 *
 * To run a query within a React component, call `useGetRandomPublicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRandomPublicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRandomPublicationsQuery({
 *   variables: {
 *      workspaceIdentifier: // value for 'workspaceIdentifier'
 *      exclude: // value for 'exclude'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetRandomPublicationsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    Types.GetRandomPublicationsQuery,
    Types.GetRandomPublicationsQueryVariables
  > &
    (
      | { variables: Types.GetRandomPublicationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    Types.GetRandomPublicationsQuery,
    Types.GetRandomPublicationsQueryVariables
  >(GetRandomPublicationsDocument, options)
}
export function useGetRandomPublicationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Types.GetRandomPublicationsQuery,
    Types.GetRandomPublicationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    Types.GetRandomPublicationsQuery,
    Types.GetRandomPublicationsQueryVariables
  >(GetRandomPublicationsDocument, options)
}

export type GetRandomPublicationsQueryHookResult = ReturnType<
  typeof useGetRandomPublicationsQuery
>
export type GetRandomPublicationsLazyQueryHookResult = ReturnType<
  typeof useGetRandomPublicationsLazyQuery
>
export type GetRandomPublicationsQueryResult = Apollo.QueryResult<
  Types.GetRandomPublicationsQuery,
  Types.GetRandomPublicationsQueryVariables
>
export type AcceptMembershipInviteAuditKeySpecifier = (
  | 'acceptedUser'
  | 'acceptedUserEmail'
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'inviter'
  | 'inviteSentToEmail'
  | 'role'
  | 'version'
  | AcceptMembershipInviteAuditKeySpecifier
)[]
export type AcceptMembershipInviteAuditFieldPolicy = {
  acceptedUser?: FieldPolicy<any> | FieldReadFunction<any>
  acceptedUserEmail?: FieldPolicy<any> | FieldReadFunction<any>
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  inviter?: FieldPolicy<any> | FieldReadFunction<any>
  inviteSentToEmail?: FieldPolicy<any> | FieldReadFunction<any>
  role?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AcceptProjectAccessRequestResponseKeySpecifier = (
  | 'project'
  | 'projectMembership'
  | AcceptProjectAccessRequestResponseKeySpecifier
)[]
export type AcceptProjectAccessRequestResponseFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
  projectMembership?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AcceptProjectMembershipInvitationResponseKeySpecifier = (
  | 'projectMembership'
  | AcceptProjectMembershipInvitationResponseKeySpecifier
)[]
export type AcceptProjectMembershipInvitationResponseFieldPolicy = {
  projectMembership?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AcceptWorkspaceInviteResponseKeySpecifier = (
  | 'membership'
  | AcceptWorkspaceInviteResponseKeySpecifier
)[]
export type AcceptWorkspaceInviteResponseFieldPolicy = {
  membership?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AccountExistsResponseKeySpecifier = (
  | 'exists'
  | AccountExistsResponseKeySpecifier
)[]
export type AccountExistsResponseFieldPolicy = {
  exists?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ActivityStatusKeySpecifier = (
  | 'lastSeenInDays'
  | 'status'
  | ActivityStatusKeySpecifier
)[]
export type ActivityStatusFieldPolicy = {
  lastSeenInDays?: FieldPolicy<any> | FieldReadFunction<any>
  status?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AddMemberPermissionGroupKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'members'
  | 'permissionGroup'
  | 'version'
  | AddMemberPermissionGroupKeySpecifier
)[]
export type AddMemberPermissionGroupFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  members?: FieldPolicy<any> | FieldReadFunction<any>
  permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AddPermissionGroupMembersResponseKeySpecifier = (
  | 'members'
  | 'permissionGroup'
  | AddPermissionGroupMembersResponseKeySpecifier
)[]
export type AddPermissionGroupMembersResponseFieldPolicy = {
  members?: FieldPolicy<any> | FieldReadFunction<any>
  permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AddPermissionGroupRelationResponseKeySpecifier = (
  | 'relation'
  | AddPermissionGroupRelationResponseKeySpecifier
)[]
export type AddPermissionGroupRelationResponseFieldPolicy = {
  relation?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AddProjectMemberNotificationKeySpecifier = (
  | 'createdAt'
  | 'folder'
  | 'identifier'
  | 'isPinned'
  | 'path'
  | 'share'
  | 'state'
  | 'subtitle'
  | 'title'
  | 'token'
  | 'url'
  | 'user'
  | 'workspace'
  | AddProjectMemberNotificationKeySpecifier
)[]
export type AddProjectMemberNotificationFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  folder?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isPinned?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  state?: FieldPolicy<any> | FieldReadFunction<any>
  subtitle?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
  token?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AddProjectMemberResponseKeySpecifier = (
  | 'project'
  | 'projectMembership'
  | AddProjectMemberResponseKeySpecifier
)[]
export type AddProjectMemberResponseFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
  projectMembership?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AddProjectPermissionGroupRelationResponseKeySpecifier = (
  | 'relation'
  | AddProjectPermissionGroupRelationResponseKeySpecifier
)[]
export type AddProjectPermissionGroupRelationResponseFieldPolicy = {
  relation?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AddReactionToPublicationResponseKeySpecifier = (
  | 'publication'
  | AddReactionToPublicationResponseKeySpecifier
)[]
export type AddReactionToPublicationResponseFieldPolicy = {
  publication?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AddShareMemberNotificationKeySpecifier = (
  | 'createdAt'
  | 'identifier'
  | 'isPinned'
  | 'path'
  | 'share'
  | 'state'
  | 'subtitle'
  | 'title'
  | 'token'
  | 'url'
  | 'user'
  | 'workspace'
  | AddShareMemberNotificationKeySpecifier
)[]
export type AddShareMemberNotificationFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isPinned?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  state?: FieldPolicy<any> | FieldReadFunction<any>
  subtitle?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
  token?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AddShareMembershipResponseKeySpecifier = (
  | 'shareMembership'
  | AddShareMembershipResponseKeySpecifier
)[]
export type AddShareMembershipResponseFieldPolicy = {
  shareMembership?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AddSharePermissionGroupRelationResponseKeySpecifier = (
  | 'relation'
  | AddSharePermissionGroupRelationResponseKeySpecifier
)[]
export type AddSharePermissionGroupRelationResponseFieldPolicy = {
  relation?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AddSharesToCollectionResponseKeySpecifier = (
  | 'collection'
  | AddSharesToCollectionResponseKeySpecifier
)[]
export type AddSharesToCollectionResponseFieldPolicy = {
  collection?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AgreeToWorkspaceTermsOfServiceResponseKeySpecifier = (
  | 'customer'
  | AgreeToWorkspaceTermsOfServiceResponseKeySpecifier
)[]
export type AgreeToWorkspaceTermsOfServiceResponseFieldPolicy = {
  customer?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AnnotationKeySpecifier = (
  | 'comments'
  | 'coordinates'
  | 'createdAt'
  | 'currentArtboard'
  | 'currentPage'
  | 'currentSubject'
  | 'firstComment'
  | 'frame'
  | 'frameUuid'
  | 'hasNewComments'
  | 'identifier'
  | 'isNew'
  | 'isOptimistic'
  | 'latestCommentCreatedAt'
  | 'latestVisibleVersion'
  | 'page'
  | 'permanentArtboardId'
  | 'permanentArtboardShortId'
  | 'permanentComponentId'
  | 'permanentPageId'
  | 'resolution'
  | 'share'
  | 'shareIdentifier'
  | 'subscriptionStatus'
  | 'updatedAt'
  | 'versionIdentifier'
  | 'visibleInVersion'
  | AnnotationKeySpecifier
)[]
export type AnnotationFieldPolicy = {
  comments?: FieldPolicy<any> | FieldReadFunction<any>
  coordinates?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  currentArtboard?: FieldPolicy<any> | FieldReadFunction<any>
  currentPage?: FieldPolicy<any> | FieldReadFunction<any>
  currentSubject?: FieldPolicy<any> | FieldReadFunction<any>
  firstComment?: FieldPolicy<any> | FieldReadFunction<any>
  frame?: FieldPolicy<any> | FieldReadFunction<any>
  frameUuid?: FieldPolicy<any> | FieldReadFunction<any>
  hasNewComments?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isNew?: FieldPolicy<any> | FieldReadFunction<any>
  isOptimistic?: FieldPolicy<any> | FieldReadFunction<any>
  latestCommentCreatedAt?: FieldPolicy<any> | FieldReadFunction<any>
  latestVisibleVersion?: FieldPolicy<any> | FieldReadFunction<any>
  page?: FieldPolicy<any> | FieldReadFunction<any>
  permanentArtboardId?: FieldPolicy<any> | FieldReadFunction<any>
  permanentArtboardShortId?: FieldPolicy<any> | FieldReadFunction<any>
  permanentComponentId?: FieldPolicy<any> | FieldReadFunction<any>
  permanentPageId?: FieldPolicy<any> | FieldReadFunction<any>
  resolution?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  shareIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  subscriptionStatus?: FieldPolicy<any> | FieldReadFunction<any>
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
  versionIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  visibleInVersion?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AnnotationCoordinatesKeySpecifier = (
  | 'identifier'
  | 'x'
  | 'y'
  | AnnotationCoordinatesKeySpecifier
)[]
export type AnnotationCoordinatesFieldPolicy = {
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  x?: FieldPolicy<any> | FieldReadFunction<any>
  y?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AnnotationDeletedEventKeySpecifier = (
  | 'currentArtboard'
  | 'currentPage'
  | 'currentSubject'
  | 'identifier'
  | 'share'
  | AnnotationDeletedEventKeySpecifier
)[]
export type AnnotationDeletedEventFieldPolicy = {
  currentArtboard?: FieldPolicy<any> | FieldReadFunction<any>
  currentPage?: FieldPolicy<any> | FieldReadFunction<any>
  currentSubject?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AnnotationResolutionKeySpecifier = (
  | 'resolvedAt'
  | 'user'
  | AnnotationResolutionKeySpecifier
)[]
export type AnnotationResolutionFieldPolicy = {
  resolvedAt?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AnnotationsKeySpecifier = (
  | 'entries'
  | 'meta'
  | AnnotationsKeySpecifier
)[]
export type AnnotationsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ApplyCouponResponseKeySpecifier = (
  | 'customer'
  | ApplyCouponResponseKeySpecifier
)[]
export type ApplyCouponResponseFieldPolicy = {
  customer?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ApprovedEducationRequestAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'educationRequest'
  | 'expiryDate'
  | 'seats'
  | 'version'
  | ApprovedEducationRequestAuditKeySpecifier
)[]
export type ApprovedEducationRequestAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  educationRequest?: FieldPolicy<any> | FieldReadFunction<any>
  expiryDate?: FieldPolicy<any> | FieldReadFunction<any>
  seats?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AppStoreBillingPlanKeySpecifier = (
  | 'id'
  | 'type'
  | AppStoreBillingPlanKeySpecifier
)[]
export type AppStoreBillingPlanFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AppStoreSubscriptionKeySpecifier = (
  | 'currentPlan'
  | 'currentSeatsTotal'
  | 'renewalDate'
  | 'status'
  | 'subscriptionEnd'
  | AppStoreSubscriptionKeySpecifier
)[]
export type AppStoreSubscriptionFieldPolicy = {
  currentPlan?: FieldPolicy<any> | FieldReadFunction<any>
  currentSeatsTotal?: FieldPolicy<any> | FieldReadFunction<any>
  renewalDate?: FieldPolicy<any> | FieldReadFunction<any>
  status?: FieldPolicy<any> | FieldReadFunction<any>
  subscriptionEnd?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ArchiveProjectKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'project'
  | 'version'
  | ArchiveProjectKeySpecifier
)[]
export type ArchiveProjectFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ArchiveProjectResponseKeySpecifier = (
  | 'project'
  | ArchiveProjectResponseKeySpecifier
)[]
export type ArchiveProjectResponseFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ArchiveStorageItemResponseKeySpecifier = (
  | 'storageItem'
  | ArchiveStorageItemResponseKeySpecifier
)[]
export type ArchiveStorageItemResponseFieldPolicy = {
  storageItem?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ArchiveStorageItemsResponseKeySpecifier = (
  | 'storageItems'
  | ArchiveStorageItemsResponseKeySpecifier
)[]
export type ArchiveStorageItemsResponseFieldPolicy = {
  storageItems?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ArtboardKeySpecifier = (
  | 'annotationCount'
  | 'artboardBase'
  | 'commentCount'
  | 'component'
  | 'discussion'
  | 'documentOrder'
  | 'documentVersionShortId'
  | 'files'
  | 'hasMissingFonts'
  | 'height'
  | 'id'
  | 'identifier'
  | 'isFlowHome'
  | 'mentionableUsers'
  | 'name'
  | 'next'
  | 'nextArtboard'
  | 'order'
  | 'page'
  | 'permanentArtboardShortId'
  | 'previous'
  | 'previousArtboard'
  | 'revisionId'
  | 'revisionIdentifier'
  | 'revisions'
  | 'revisionShortId'
  | 'shortId'
  | 'subscriptionStatus'
  | 'unreadCount'
  | 'uuid'
  | 'width'
  | ArtboardKeySpecifier
)[]
export type ArtboardFieldPolicy = {
  annotationCount?: FieldPolicy<any> | FieldReadFunction<any>
  artboardBase?: FieldPolicy<any> | FieldReadFunction<any>
  commentCount?: FieldPolicy<any> | FieldReadFunction<any>
  component?: FieldPolicy<any> | FieldReadFunction<any>
  discussion?: FieldPolicy<any> | FieldReadFunction<any>
  documentOrder?: FieldPolicy<any> | FieldReadFunction<any>
  documentVersionShortId?: FieldPolicy<any> | FieldReadFunction<any>
  files?: FieldPolicy<any> | FieldReadFunction<any>
  hasMissingFonts?: FieldPolicy<any> | FieldReadFunction<any>
  height?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isFlowHome?: FieldPolicy<any> | FieldReadFunction<any>
  mentionableUsers?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  next?: FieldPolicy<any> | FieldReadFunction<any>
  nextArtboard?: FieldPolicy<any> | FieldReadFunction<any>
  order?: FieldPolicy<any> | FieldReadFunction<any>
  page?: FieldPolicy<any> | FieldReadFunction<any>
  permanentArtboardShortId?: FieldPolicy<any> | FieldReadFunction<any>
  previous?: FieldPolicy<any> | FieldReadFunction<any>
  previousArtboard?: FieldPolicy<any> | FieldReadFunction<any>
  revisionId?: FieldPolicy<any> | FieldReadFunction<any>
  revisionIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  revisions?: FieldPolicy<any> | FieldReadFunction<any>
  revisionShortId?: FieldPolicy<any> | FieldReadFunction<any>
  shortId?: FieldPolicy<any> | FieldReadFunction<any>
  subscriptionStatus?: FieldPolicy<any> | FieldReadFunction<any>
  unreadCount?: FieldPolicy<any> | FieldReadFunction<any>
  uuid?: FieldPolicy<any> | FieldReadFunction<any>
  width?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ArtboardBaseKeySpecifier = (
  | 'commentCount'
  | 'discussion'
  | 'shortId'
  | 'unreadCount'
  | ArtboardBaseKeySpecifier
)[]
export type ArtboardBaseFieldPolicy = {
  commentCount?: FieldPolicy<any> | FieldReadFunction<any>
  discussion?: FieldPolicy<any> | FieldReadFunction<any>
  shortId?: FieldPolicy<any> | FieldReadFunction<any>
  unreadCount?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ArtboardRevisionsKeySpecifier = (
  | 'entries'
  | 'meta'
  | ArtboardRevisionsKeySpecifier
)[]
export type ArtboardRevisionsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ArtboardsKeySpecifier = (
  | 'entries'
  | 'meta'
  | ArtboardsKeySpecifier
)[]
export type ArtboardsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AttachFeatureFlagAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'flagIdentifier'
  | 'flagName'
  | 'version'
  | AttachFeatureFlagAuditKeySpecifier
)[]
export type AttachFeatureFlagAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  flagIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  flagName?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AttributeMappingEntryKeySpecifier = (
  | 'avatarUrl'
  | 'email'
  | 'firstName'
  | 'fullName'
  | 'surname'
  | AttributeMappingEntryKeySpecifier
)[]
export type AttributeMappingEntryFieldPolicy = {
  avatarUrl?: FieldPolicy<any> | FieldReadFunction<any>
  email?: FieldPolicy<any> | FieldReadFunction<any>
  firstName?: FieldPolicy<any> | FieldReadFunction<any>
  fullName?: FieldPolicy<any> | FieldReadFunction<any>
  surname?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AuditActorKeySpecifier = (
  | 'email'
  | 'identifier'
  | 'name'
  | AuditActorKeySpecifier
)[]
export type AuditActorFieldPolicy = {
  email?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AuditCreditKeySpecifier = (
  | 'amount'
  | 'description'
  | AuditCreditKeySpecifier
)[]
export type AuditCreditFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>
  description?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AuditLogItemKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'version'
  | AuditLogItemKeySpecifier
)[]
export type AuditLogItemFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AuditMembershipKeySpecifier = (
  | 'assignLicense'
  | 'role'
  | AuditMembershipKeySpecifier
)[]
export type AuditMembershipFieldPolicy = {
  assignLicense?: FieldPolicy<any> | FieldReadFunction<any>
  role?: FieldPolicy<any> | FieldReadFunction<any>
}
export type AvatarKeySpecifier = ('large' | 'small' | AvatarKeySpecifier)[]
export type AvatarFieldPolicy = {
  large?: FieldPolicy<any> | FieldReadFunction<any>
  small?: FieldPolicy<any> | FieldReadFunction<any>
}
export type BasePreviewChangedEventKeySpecifier = (
  | 'preview'
  | BasePreviewChangedEventKeySpecifier
)[]
export type BasePreviewChangedEventFieldPolicy = {
  preview?: FieldPolicy<any> | FieldReadFunction<any>
}
export type BaseProjectAccessChangedEventKeySpecifier = (
  | 'workspaceIdentifier'
  | BaseProjectAccessChangedEventKeySpecifier
)[]
export type BaseProjectAccessChangedEventFieldPolicy = {
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type BaseProjectChangedEventKeySpecifier = (
  | 'projectIdentifier'
  | 'workspaceIdentifier'
  | BaseProjectChangedEventKeySpecifier
)[]
export type BaseProjectChangedEventFieldPolicy = {
  projectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type BaseShareChangedEventKeySpecifier = (
  | 'shareIdentifier'
  | 'type'
  | 'workspace'
  | BaseShareChangedEventKeySpecifier
)[]
export type BaseShareChangedEventFieldPolicy = {
  shareIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type BillingKeySpecifier = (
  | 'isSubscriptionActive'
  | 'seats'
  | 'status'
  | 'subscriptionEnd'
  | 'subscriptionSetUp'
  | 'trialEnd'
  | BillingKeySpecifier
)[]
export type BillingFieldPolicy = {
  isSubscriptionActive?: FieldPolicy<any> | FieldReadFunction<any>
  seats?: FieldPolicy<any> | FieldReadFunction<any>
  status?: FieldPolicy<any> | FieldReadFunction<any>
  subscriptionEnd?: FieldPolicy<any> | FieldReadFunction<any>
  subscriptionSetUp?: FieldPolicy<any> | FieldReadFunction<any>
  trialEnd?: FieldPolicy<any> | FieldReadFunction<any>
}
export type BillingCyclesKeySpecifier = (
  | 'couponInfo'
  | 'current'
  | 'currentBillingCycle'
  | 'next'
  | 'nextBillingCycle'
  | BillingCyclesKeySpecifier
)[]
export type BillingCyclesFieldPolicy = {
  couponInfo?: FieldPolicy<any> | FieldReadFunction<any>
  current?: FieldPolicy<any> | FieldReadFunction<any>
  currentBillingCycle?: FieldPolicy<any> | FieldReadFunction<any>
  next?: FieldPolicy<any> | FieldReadFunction<any>
  nextBillingCycle?: FieldPolicy<any> | FieldReadFunction<any>
}
export type BillingDetailsKeySpecifier = (
  | 'address'
  | 'email'
  | 'name'
  | 'taxId'
  | BillingDetailsKeySpecifier
)[]
export type BillingDetailsFieldPolicy = {
  address?: FieldPolicy<any> | FieldReadFunction<any>
  email?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  taxId?: FieldPolicy<any> | FieldReadFunction<any>
}
export type BillingHistoryKeySpecifier = (
  | 'entries'
  | 'meta'
  | BillingHistoryKeySpecifier
)[]
export type BillingHistoryFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type BillingHistoryEntryKeySpecifier = (
  | 'amount'
  | 'createdAt'
  | 'description'
  | 'id'
  | 'price'
  | BillingHistoryEntryKeySpecifier
)[]
export type BillingHistoryEntryFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  description?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  price?: FieldPolicy<any> | FieldReadFunction<any>
}
export type BillingInfoKeySpecifier = (
  | 'monthlyAmount'
  | 'totalAmount'
  | BillingInfoKeySpecifier
)[]
export type BillingInfoFieldPolicy = {
  monthlyAmount?: FieldPolicy<any> | FieldReadFunction<any>
  totalAmount?: FieldPolicy<any> | FieldReadFunction<any>
}
export type BillingPlanKeySpecifier = (
  | 'id'
  | 'invoicePrice'
  | 'monthlyPrice'
  | 'name'
  | 'prices'
  | 'product'
  | 'type'
  | BillingPlanKeySpecifier
)[]
export type BillingPlanFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>
  invoicePrice?: FieldPolicy<any> | FieldReadFunction<any>
  monthlyPrice?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  prices?: FieldPolicy<any> | FieldReadFunction<any>
  product?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
}
export type BillingPlanInfoKeySpecifier = (
  | 'id'
  | 'type'
  | BillingPlanInfoKeySpecifier
)[]
export type BillingPlanInfoFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
}
export type BillingPriceKeySpecifier = (
  | 'currency'
  | 'invoice'
  | 'monthly'
  | BillingPriceKeySpecifier
)[]
export type BillingPriceFieldPolicy = {
  currency?: FieldPolicy<any> | FieldReadFunction<any>
  invoice?: FieldPolicy<any> | FieldReadFunction<any>
  monthly?: FieldPolicy<any> | FieldReadFunction<any>
}
export type BillingSeatsInfoKeySpecifier = (
  | 'availableSeats'
  | 'currentSeatsTotal'
  | 'scheduledSeatsTotal'
  | 'usedSeats'
  | BillingSeatsInfoKeySpecifier
)[]
export type BillingSeatsInfoFieldPolicy = {
  availableSeats?: FieldPolicy<any> | FieldReadFunction<any>
  currentSeatsTotal?: FieldPolicy<any> | FieldReadFunction<any>
  scheduledSeatsTotal?: FieldPolicy<any> | FieldReadFunction<any>
  usedSeats?: FieldPolicy<any> | FieldReadFunction<any>
}
export type BillingSummaryKeySpecifier = (
  | 'billingCycleAmount'
  | 'couponInfo'
  | 'current'
  | 'memberBillingCycleAmount'
  | 'memberMonthlyAmount'
  | 'memberPrice'
  | 'monthlyAmount'
  | 'price'
  | 'renewalDate'
  | 'trialEnd'
  | BillingSummaryKeySpecifier
)[]
export type BillingSummaryFieldPolicy = {
  billingCycleAmount?: FieldPolicy<any> | FieldReadFunction<any>
  couponInfo?: FieldPolicy<any> | FieldReadFunction<any>
  current?: FieldPolicy<any> | FieldReadFunction<any>
  memberBillingCycleAmount?: FieldPolicy<any> | FieldReadFunction<any>
  memberMonthlyAmount?: FieldPolicy<any> | FieldReadFunction<any>
  memberPrice?: FieldPolicy<any> | FieldReadFunction<any>
  monthlyAmount?: FieldPolicy<any> | FieldReadFunction<any>
  price?: FieldPolicy<any> | FieldReadFunction<any>
  renewalDate?: FieldPolicy<any> | FieldReadFunction<any>
  trialEnd?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CancelLicenseAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'version'
  | CancelLicenseAuditKeySpecifier
)[]
export type CancelLicenseAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CancelScheduledBillingSeatsResponseKeySpecifier = (
  | 'workspace'
  | CancelScheduledBillingSeatsResponseKeySpecifier
)[]
export type CancelScheduledBillingSeatsResponseFieldPolicy = {
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CancelSubscriptionResponseKeySpecifier = (
  | 'customer'
  | CancelSubscriptionResponseKeySpecifier
)[]
export type CancelSubscriptionResponseFieldPolicy = {
  customer?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CapacitorMutationsKeySpecifier = (
  | 'collaborativeEdit'
  | 'collaborativeEditingSessionCreate'
  | 'collaborativeEditingSessionMigrateDocument'
  | 'collaborativeEditingSessionResetDocument'
  | 'createCollaborativeVersion'
  | 'editComponents'
  | 'remotePatchCompleteUpload'
  | 'remotePatchInitiateUpload'
  | 'serverSideMigrate'
  | CapacitorMutationsKeySpecifier
)[]
export type CapacitorMutationsFieldPolicy = {
  collaborativeEdit?: FieldPolicy<any> | FieldReadFunction<any>
  collaborativeEditingSessionCreate?: FieldPolicy<any> | FieldReadFunction<any>
  collaborativeEditingSessionMigrateDocument?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  collaborativeEditingSessionResetDocument?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  createCollaborativeVersion?: FieldPolicy<any> | FieldReadFunction<any>
  editComponents?: FieldPolicy<any> | FieldReadFunction<any>
  remotePatchCompleteUpload?: FieldPolicy<any> | FieldReadFunction<any>
  remotePatchInitiateUpload?: FieldPolicy<any> | FieldReadFunction<any>
  serverSideMigrate?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ChangeAccountLinkingAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'enabled'
  | 'version'
  | ChangeAccountLinkingAuditKeySpecifier
)[]
export type ChangeAccountLinkingAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  enabled?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ChangedPlanAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'version'
  | ChangedPlanAuditKeySpecifier
)[]
export type ChangedPlanAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ChangePlanResponseKeySpecifier = (
  | 'customer'
  | ChangePlanResponseKeySpecifier
)[]
export type ChangePlanResponseFieldPolicy = {
  customer?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ChangeRestrictedUploadsAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'areUploadsRestricted'
  | 'createdAt'
  | 'version'
  | ChangeRestrictedUploadsAuditKeySpecifier
)[]
export type ChangeRestrictedUploadsAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  areUploadsRestricted?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ChangeScimAutoLinkAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'enabled'
  | 'version'
  | ChangeScimAutoLinkAuditKeySpecifier
)[]
export type ChangeScimAutoLinkAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  enabled?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ChangeSecurityEmailAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'previousSecurityEmail'
  | 'securityEmail'
  | 'version'
  | ChangeSecurityEmailAuditKeySpecifier
)[]
export type ChangeSecurityEmailAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  previousSecurityEmail?: FieldPolicy<any> | FieldReadFunction<any>
  securityEmail?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ChangeUnlimitedStorageOverrideEnabledKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'newValue'
  | 'version'
  | ChangeUnlimitedStorageOverrideEnabledKeySpecifier
)[]
export type ChangeUnlimitedStorageOverrideEnabledFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  newValue?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ChangeUnlimitedTrialKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'newValue'
  | 'version'
  | ChangeUnlimitedTrialKeySpecifier
)[]
export type ChangeUnlimitedTrialFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  newValue?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ChangeWorkspaceProfileEnabledKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'newValue'
  | 'version'
  | ChangeWorkspaceProfileEnabledKeySpecifier
)[]
export type ChangeWorkspaceProfileEnabledFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  newValue?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ChangeWorkspaceProfileIsOfficialKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'newValue'
  | 'version'
  | ChangeWorkspaceProfileIsOfficialKeySpecifier
)[]
export type ChangeWorkspaceProfileIsOfficialFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  newValue?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ChangeWorkspaceProfileShortUrlKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'newValue'
  | 'version'
  | ChangeWorkspaceProfileShortUrlKeySpecifier
)[]
export type ChangeWorkspaceProfileShortUrlFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  newValue?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ChangeWorkspaceProfileVisibilityKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'newValue'
  | 'version'
  | ChangeWorkspaceProfileVisibilityKeySpecifier
)[]
export type ChangeWorkspaceProfileVisibilityFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  newValue?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CheckWorkspaceProfileShortUrlResponseKeySpecifier = (
  | 'available'
  | CheckWorkspaceProfileShortUrlResponseKeySpecifier
)[]
export type CheckWorkspaceProfileShortUrlResponseFieldPolicy = {
  available?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CloudBillingPlanKeySpecifier = (
  | 'id'
  | 'invoicePrice'
  | 'monthlyPrice'
  | 'name'
  | 'prices'
  | 'product'
  | 'type'
  | CloudBillingPlanKeySpecifier
)[]
export type CloudBillingPlanFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>
  invoicePrice?: FieldPolicy<any> | FieldReadFunction<any>
  monthlyPrice?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  prices?: FieldPolicy<any> | FieldReadFunction<any>
  product?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CloudSubscriptionKeySpecifier = (
  | 'currentPlan'
  | 'currentSeatsTotal'
  | 'pendingScaToken'
  | 'renewalDate'
  | 'scheduledSeatsTotal'
  | 'status'
  | 'subscriptionEnd'
  | 'trialEnd'
  | CloudSubscriptionKeySpecifier
)[]
export type CloudSubscriptionFieldPolicy = {
  currentPlan?: FieldPolicy<any> | FieldReadFunction<any>
  currentSeatsTotal?: FieldPolicy<any> | FieldReadFunction<any>
  pendingScaToken?: FieldPolicy<any> | FieldReadFunction<any>
  renewalDate?: FieldPolicy<any> | FieldReadFunction<any>
  scheduledSeatsTotal?: FieldPolicy<any> | FieldReadFunction<any>
  status?: FieldPolicy<any> | FieldReadFunction<any>
  subscriptionEnd?: FieldPolicy<any> | FieldReadFunction<any>
  trialEnd?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CollaborativeEditingSessionKeySpecifier = (
  | 'baseVersionIdentifier'
  | 'catchUpStrategy'
  | 'collaborativeEditsPaginated'
  | 'compatibilityVersion'
  | 'componentEdits'
  | 'descendantOfBaseVersion'
  | 'hasPendingPatches'
  | 'latestVersionIdentifier'
  | 'nextVersionIdentifier'
  | 'shareIdentifier'
  | CollaborativeEditingSessionKeySpecifier
)[]
export type CollaborativeEditingSessionFieldPolicy = {
  baseVersionIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  catchUpStrategy?: FieldPolicy<any> | FieldReadFunction<any>
  collaborativeEditsPaginated?: FieldPolicy<any> | FieldReadFunction<any>
  compatibilityVersion?: FieldPolicy<any> | FieldReadFunction<any>
  componentEdits?: FieldPolicy<any> | FieldReadFunction<any>
  descendantOfBaseVersion?: FieldPolicy<any> | FieldReadFunction<any>
  hasPendingPatches?: FieldPolicy<any> | FieldReadFunction<any>
  latestVersionIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  nextVersionIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  shareIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CollaborativeEditsKeySpecifier = (
  | 'current'
  | 'entries'
  | 'metadata'
  | CollaborativeEditsKeySpecifier
)[]
export type CollaborativeEditsFieldPolicy = {
  current?: FieldPolicy<any> | FieldReadFunction<any>
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  metadata?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CollaborativeShareCreatePayloadKeySpecifier = (
  | 'document'
  | 'share'
  | 'version'
  | CollaborativeShareCreatePayloadKeySpecifier
)[]
export type CollaborativeShareCreatePayloadFieldPolicy = {
  document?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CollaborativeVersionKeySpecifier = (
  | 'baseVersionIdentifier'
  | 'id'
  | 'patches'
  | 'status'
  | CollaborativeVersionKeySpecifier
)[]
export type CollaborativeVersionFieldPolicy = {
  baseVersionIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  patches?: FieldPolicy<any> | FieldReadFunction<any>
  status?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CollectionKeySpecifier = (
  | 'description'
  | 'identifier'
  | 'name'
  | 'previews'
  | 'shareCount'
  | 'shares'
  | 'sharesUnpaginated'
  | CollectionKeySpecifier
)[]
export type CollectionFieldPolicy = {
  description?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  previews?: FieldPolicy<any> | FieldReadFunction<any>
  shareCount?: FieldPolicy<any> | FieldReadFunction<any>
  shares?: FieldPolicy<any> | FieldReadFunction<any>
  sharesUnpaginated?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CollectionChangedEventKeySpecifier = (
  | 'collection'
  | CollectionChangedEventKeySpecifier
)[]
export type CollectionChangedEventFieldPolicy = {
  collection?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CollectionCreatedEventKeySpecifier = (
  | 'collection'
  | CollectionCreatedEventKeySpecifier
)[]
export type CollectionCreatedEventFieldPolicy = {
  collection?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CollectionDeletedEventKeySpecifier = (
  | 'identifier'
  | CollectionDeletedEventKeySpecifier
)[]
export type CollectionDeletedEventFieldPolicy = {
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CollectionsKeySpecifier = (
  | 'entries'
  | 'meta'
  | CollectionsKeySpecifier
)[]
export type CollectionsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CollectionSharePreviewKeySpecifier = (
  | 'file'
  | 'name'
  | 'shareIdentifier'
  | CollectionSharePreviewKeySpecifier
)[]
export type CollectionSharePreviewFieldPolicy = {
  file?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  shareIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ColorVariableKeySpecifier = (
  | 'depth'
  | 'description'
  | 'identifier'
  | 'name'
  | 'needsContrastingBackground'
  | 'path'
  | 'pathGroups'
  | 'pathInfo'
  | 'rgbaValue'
  | 'uuid'
  | ColorVariableKeySpecifier
)[]
export type ColorVariableFieldPolicy = {
  depth?: FieldPolicy<any> | FieldReadFunction<any>
  description?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  needsContrastingBackground?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  pathGroups?: FieldPolicy<any> | FieldReadFunction<any>
  pathInfo?: FieldPolicy<any> | FieldReadFunction<any>
  rgbaValue?: FieldPolicy<any> | FieldReadFunction<any>
  uuid?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CommentKeySpecifier = (
  | 'annotation'
  | 'artboard'
  | 'body'
  | 'createdAt'
  | 'id'
  | 'identifier'
  | 'isEdited'
  | 'isRead'
  | 'parent'
  | 'subscriptionStatus'
  | 'updatedAt'
  | 'user'
  | 'userCanDelete'
  | 'userIsCreator'
  | 'viewerDidAuthor'
  | CommentKeySpecifier
)[]
export type CommentFieldPolicy = {
  annotation?: FieldPolicy<any> | FieldReadFunction<any>
  artboard?: FieldPolicy<any> | FieldReadFunction<any>
  body?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isEdited?: FieldPolicy<any> | FieldReadFunction<any>
  isRead?: FieldPolicy<any> | FieldReadFunction<any>
  parent?: FieldPolicy<any> | FieldReadFunction<any>
  subscriptionStatus?: FieldPolicy<any> | FieldReadFunction<any>
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  userCanDelete?: FieldPolicy<any> | FieldReadFunction<any>
  userIsCreator?: FieldPolicy<any> | FieldReadFunction<any>
  viewerDidAuthor?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CommentNotificationKeySpecifier = (
  | 'artboard'
  | 'comment'
  | 'createdAt'
  | 'identifier'
  | 'isMentioned'
  | 'isPinned'
  | 'path'
  | 'previews'
  | 'share'
  | 'state'
  | 'subtitle'
  | 'title'
  | 'token'
  | 'url'
  | 'user'
  | 'workspace'
  | CommentNotificationKeySpecifier
)[]
export type CommentNotificationFieldPolicy = {
  artboard?: FieldPolicy<any> | FieldReadFunction<any>
  comment?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isMentioned?: FieldPolicy<any> | FieldReadFunction<any>
  isPinned?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  previews?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  state?: FieldPolicy<any> | FieldReadFunction<any>
  subtitle?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
  token?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CommentsKeySpecifier = ('entries' | 'meta' | CommentsKeySpecifier)[]
export type CommentsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CommunityKeySpecifier = ('sections' | CommunityKeySpecifier)[]
export type CommunityFieldPolicy = {
  sections?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CommunityGridKeySpecifier = (
  | 'id'
  | 'link'
  | 'modifiers'
  | 'preferences'
  | 'subTitle'
  | 'title'
  | CommunityGridKeySpecifier
)[]
export type CommunityGridFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>
  link?: FieldPolicy<any> | FieldReadFunction<any>
  modifiers?: FieldPolicy<any> | FieldReadFunction<any>
  preferences?: FieldPolicy<any> | FieldReadFunction<any>
  subTitle?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CommunityHeroKeySpecifier = (
  | 'backgroundColor'
  | 'content'
  | 'contentPosition'
  | 'icon'
  | 'id'
  | 'image'
  | 'links'
  | 'size'
  | 'title'
  | 'video'
  | CommunityHeroKeySpecifier
)[]
export type CommunityHeroFieldPolicy = {
  backgroundColor?: FieldPolicy<any> | FieldReadFunction<any>
  content?: FieldPolicy<any> | FieldReadFunction<any>
  contentPosition?: FieldPolicy<any> | FieldReadFunction<any>
  icon?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  image?: FieldPolicy<any> | FieldReadFunction<any>
  links?: FieldPolicy<any> | FieldReadFunction<any>
  size?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
  video?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CommunityListingKeySpecifier = (
  | 'id'
  | 'link'
  | 'preferences'
  | 'subTitle'
  | 'title'
  | CommunityListingKeySpecifier
)[]
export type CommunityListingFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>
  link?: FieldPolicy<any> | FieldReadFunction<any>
  preferences?: FieldPolicy<any> | FieldReadFunction<any>
  subTitle?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CommunityPublicationQueryKeySpecifier = (
  | 'id'
  | 'link'
  | 'preferences'
  | 'subTitle'
  | 'title'
  | CommunityPublicationQueryKeySpecifier
)[]
export type CommunityPublicationQueryFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>
  link?: FieldPolicy<any> | FieldReadFunction<any>
  preferences?: FieldPolicy<any> | FieldReadFunction<any>
  subTitle?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CommunitySectionKeySpecifier = (
  | 'id'
  | 'items'
  | 'size'
  | CommunitySectionKeySpecifier
)[]
export type CommunitySectionFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>
  items?: FieldPolicy<any> | FieldReadFunction<any>
  size?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CommunitySliderKeySpecifier = (
  | 'id'
  | 'link'
  | 'preferences'
  | 'subTitle'
  | 'title'
  | CommunitySliderKeySpecifier
)[]
export type CommunitySliderFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>
  link?: FieldPolicy<any> | FieldReadFunction<any>
  preferences?: FieldPolicy<any> | FieldReadFunction<any>
  subTitle?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ComponentKeySpecifier = (
  | 'depth'
  | 'description'
  | 'identifier'
  | 'name'
  | 'path'
  | 'pathGroups'
  | 'pathInfo'
  | 'uuid'
  | ComponentKeySpecifier
)[]
export type ComponentFieldPolicy = {
  depth?: FieldPolicy<any> | FieldReadFunction<any>
  description?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  pathGroups?: FieldPolicy<any> | FieldReadFunction<any>
  pathInfo?: FieldPolicy<any> | FieldReadFunction<any>
  uuid?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ComponentCountKeySpecifier = (
  | 'colorVar'
  | 'layerStyle'
  | 'symbol'
  | 'textStyle'
  | ComponentCountKeySpecifier
)[]
export type ComponentCountFieldPolicy = {
  colorVar?: FieldPolicy<any> | FieldReadFunction<any>
  layerStyle?: FieldPolicy<any> | FieldReadFunction<any>
  symbol?: FieldPolicy<any> | FieldReadFunction<any>
  textStyle?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ComponentDescriptionEditKeySpecifier = (
  | 'componentUuid'
  | 'description'
  | ComponentDescriptionEditKeySpecifier
)[]
export type ComponentDescriptionEditFieldPolicy = {
  componentUuid?: FieldPolicy<any> | FieldReadFunction<any>
  description?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ComponentGroupDataKeySpecifier = (
  | 'data'
  | ComponentGroupDataKeySpecifier
)[]
export type ComponentGroupDataFieldPolicy = {
  data?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ComponentsKeySpecifier = (
  | 'entries'
  | 'meta'
  | 'status'
  | ComponentsKeySpecifier
)[]
export type ComponentsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
  status?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ConfigureEncryptionKeysAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'kmsArns'
  | 'version'
  | ConfigureEncryptionKeysAuditKeySpecifier
)[]
export type ConfigureEncryptionKeysAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  kmsArns?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ConfigureWorkspaceEncryptionKeysResponseKeySpecifier = (
  | 'workspace'
  | ConfigureWorkspaceEncryptionKeysResponseKeySpecifier
)[]
export type ConfigureWorkspaceEncryptionKeysResponseFieldPolicy = {
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ConfirmAppStorePurchaseResponseKeySpecifier = (
  | 'customer'
  | ConfirmAppStorePurchaseResponseKeySpecifier
)[]
export type ConfirmAppStorePurchaseResponseFieldPolicy = {
  customer?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ConvertToEducationWorkspaceAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'educationRequest'
  | 'expiryDate'
  | 'seats'
  | 'version'
  | ConvertToEducationWorkspaceAuditKeySpecifier
)[]
export type ConvertToEducationWorkspaceAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  educationRequest?: FieldPolicy<any> | FieldReadFunction<any>
  expiryDate?: FieldPolicy<any> | FieldReadFunction<any>
  seats?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CountryKeySpecifier = ('code' | 'name' | CountryKeySpecifier)[]
export type CountryFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CouponInfoKeySpecifier = (
  | 'amountOff'
  | 'endDate'
  | 'errorCode'
  | 'errorMessage'
  | 'percentOff'
  | 'promotionCode'
  | CouponInfoKeySpecifier
)[]
export type CouponInfoFieldPolicy = {
  amountOff?: FieldPolicy<any> | FieldReadFunction<any>
  endDate?: FieldPolicy<any> | FieldReadFunction<any>
  errorCode?: FieldPolicy<any> | FieldReadFunction<any>
  errorMessage?: FieldPolicy<any> | FieldReadFunction<any>
  percentOff?: FieldPolicy<any> | FieldReadFunction<any>
  promotionCode?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreateAnnotationReplyResponseKeySpecifier = (
  | 'comment'
  | CreateAnnotationReplyResponseKeySpecifier
)[]
export type CreateAnnotationReplyResponseFieldPolicy = {
  comment?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreateAnnotationResponseKeySpecifier = (
  | 'annotation'
  | CreateAnnotationResponseKeySpecifier
)[]
export type CreateAnnotationResponseFieldPolicy = {
  annotation?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreateCollectionResponseKeySpecifier = (
  | 'collection'
  | CreateCollectionResponseKeySpecifier
)[]
export type CreateCollectionResponseFieldPolicy = {
  collection?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreateEducationApplicationResponseKeySpecifier = (
  | 'educationApplication'
  | 'workspace'
  | CreateEducationApplicationResponseKeySpecifier
)[]
export type CreateEducationApplicationResponseFieldPolicy = {
  educationApplication?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreateMembershipAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'invitee'
  | 'inviteeEmail'
  | 'membership'
  | 'version'
  | CreateMembershipAuditKeySpecifier
)[]
export type CreateMembershipAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  invitee?: FieldPolicy<any> | FieldReadFunction<any>
  inviteeEmail?: FieldPolicy<any> | FieldReadFunction<any>
  membership?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreatePartnerWorkspaceResponseKeySpecifier = (
  | 'workspace'
  | CreatePartnerWorkspaceResponseKeySpecifier
)[]
export type CreatePartnerWorkspaceResponseFieldPolicy = {
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreatePermissionGroupKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'name'
  | 'permissionGroup'
  | 'version'
  | CreatePermissionGroupKeySpecifier
)[]
export type CreatePermissionGroupFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreatePermissionGroupRelationKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'name'
  | 'permissionGroup'
  | 'project'
  | 'share'
  | 'version'
  | CreatePermissionGroupRelationKeySpecifier
)[]
export type CreatePermissionGroupRelationFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreatePermissionGroupResponseKeySpecifier = (
  | 'permissionGroup'
  | CreatePermissionGroupResponseKeySpecifier
)[]
export type CreatePermissionGroupResponseFieldPolicy = {
  permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreatePreviewResponseKeySpecifier = (
  | 'preview'
  | CreatePreviewResponseKeySpecifier
)[]
export type CreatePreviewResponseFieldPolicy = {
  preview?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreateSetupIntentResponseKeySpecifier = (
  | 'pendingScaToken'
  | CreateSetupIntentResponseKeySpecifier
)[]
export type CreateSetupIntentResponseFieldPolicy = {
  pendingScaToken?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreateWorkspaceAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'paymentMethod'
  | 'version'
  | CreateWorkspaceAuditKeySpecifier
)[]
export type CreateWorkspaceAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  paymentMethod?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreateWorkspaceProfileResponseKeySpecifier = (
  | 'workspaceProfile'
  | CreateWorkspaceProfileResponseKeySpecifier
)[]
export type CreateWorkspaceProfileResponseFieldPolicy = {
  workspaceProfile?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreateWorkspaceProjectResponseKeySpecifier = (
  | 'project'
  | CreateWorkspaceProjectResponseKeySpecifier
)[]
export type CreateWorkspaceProjectResponseFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreateWorkspaceResponseKeySpecifier = (
  | 'pendingScaToken'
  | 'workspace'
  | CreateWorkspaceResponseKeySpecifier
)[]
export type CreateWorkspaceResponseFieldPolicy = {
  pendingScaToken?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreateWorkspaceShareResponseKeySpecifier = (
  | 'document'
  | 'share'
  | 'version'
  | CreateWorkspaceShareResponseKeySpecifier
)[]
export type CreateWorkspaceShareResponseFieldPolicy = {
  document?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreditAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'credit'
  | 'version'
  | CreditAuditKeySpecifier
)[]
export type CreditAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  credit?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreditBalanceKeySpecifier = (
  | 'amount'
  | 'projectedDuration'
  | CreditBalanceKeySpecifier
)[]
export type CreditBalanceFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>
  projectedDuration?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreditCardExpirationKeySpecifier = (
  | 'month'
  | 'year'
  | CreditCardExpirationKeySpecifier
)[]
export type CreditCardExpirationFieldPolicy = {
  month?: FieldPolicy<any> | FieldReadFunction<any>
  year?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreditCardPaymentDetailsKeySpecifier = (
  | 'brand'
  | 'expiration'
  | 'id'
  | 'last4Digits'
  | 'type'
  | CreditCardPaymentDetailsKeySpecifier
)[]
export type CreditCardPaymentDetailsFieldPolicy = {
  brand?: FieldPolicy<any> | FieldReadFunction<any>
  expiration?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  last4Digits?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreditNoteKeySpecifier = (
  | 'amount'
  | 'createdAt'
  | 'id'
  | 'invoiceId'
  | 'memo'
  | 'number'
  | 'pdf'
  | 'price'
  | 'reason'
  | 'status'
  | 'type'
  | 'voidedAt'
  | CreditNoteKeySpecifier
)[]
export type CreditNoteFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  invoiceId?: FieldPolicy<any> | FieldReadFunction<any>
  memo?: FieldPolicy<any> | FieldReadFunction<any>
  number?: FieldPolicy<any> | FieldReadFunction<any>
  pdf?: FieldPolicy<any> | FieldReadFunction<any>
  price?: FieldPolicy<any> | FieldReadFunction<any>
  reason?: FieldPolicy<any> | FieldReadFunction<any>
  status?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  voidedAt?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CreditTransactionKeySpecifier = (
  | 'addedBy'
  | 'amount'
  | 'createdAt'
  | 'description'
  | 'id'
  | 'licenseRedemption'
  | 'price'
  | CreditTransactionKeySpecifier
)[]
export type CreditTransactionFieldPolicy = {
  addedBy?: FieldPolicy<any> | FieldReadFunction<any>
  amount?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  description?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  licenseRedemption?: FieldPolicy<any> | FieldReadFunction<any>
  price?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CurrenciesKeySpecifier = (
  | 'available'
  | 'default'
  | 'restriction'
  | CurrenciesKeySpecifier
)[]
export type CurrenciesFieldPolicy = {
  available?: FieldPolicy<any> | FieldReadFunction<any>
  default?: FieldPolicy<any> | FieldReadFunction<any>
  restriction?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CustomerKeySpecifier = (
  | 'billingDetails'
  | 'billingHistory'
  | 'billingSummary'
  | 'creditBalance'
  | 'credits'
  | 'hasPartner'
  | 'id'
  | 'licenseRedemptions'
  | 'paymentDetails'
  | 'subscription'
  | 'subscriptionInfo'
  | CustomerKeySpecifier
)[]
export type CustomerFieldPolicy = {
  billingDetails?: FieldPolicy<any> | FieldReadFunction<any>
  billingHistory?: FieldPolicy<any> | FieldReadFunction<any>
  billingSummary?: FieldPolicy<any> | FieldReadFunction<any>
  creditBalance?: FieldPolicy<any> | FieldReadFunction<any>
  credits?: FieldPolicy<any> | FieldReadFunction<any>
  hasPartner?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  licenseRedemptions?: FieldPolicy<any> | FieldReadFunction<any>
  paymentDetails?: FieldPolicy<any> | FieldReadFunction<any>
  subscription?: FieldPolicy<any> | FieldReadFunction<any>
  subscriptionInfo?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CustomerAddressKeySpecifier = (
  | 'city'
  | 'country'
  | 'line1'
  | 'postalCode'
  | 'state'
  | CustomerAddressKeySpecifier
)[]
export type CustomerAddressFieldPolicy = {
  city?: FieldPolicy<any> | FieldReadFunction<any>
  country?: FieldPolicy<any> | FieldReadFunction<any>
  line1?: FieldPolicy<any> | FieldReadFunction<any>
  postalCode?: FieldPolicy<any> | FieldReadFunction<any>
  state?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CustomerInvoiceKeySpecifier = (
  | 'amount'
  | 'couponInfo'
  | 'createdAt'
  | 'creditNotes'
  | 'description'
  | 'dueDate'
  | 'id'
  | 'isPaid'
  | 'number'
  | 'pdf'
  | 'price'
  | CustomerInvoiceKeySpecifier
)[]
export type CustomerInvoiceFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>
  couponInfo?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  creditNotes?: FieldPolicy<any> | FieldReadFunction<any>
  description?: FieldPolicy<any> | FieldReadFunction<any>
  dueDate?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  isPaid?: FieldPolicy<any> | FieldReadFunction<any>
  number?: FieldPolicy<any> | FieldReadFunction<any>
  pdf?: FieldPolicy<any> | FieldReadFunction<any>
  price?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CustomerMutationResponseKeySpecifier = (
  | 'customer'
  | 'successful'
  | CustomerMutationResponseKeySpecifier
)[]
export type CustomerMutationResponseFieldPolicy = {
  customer?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type CustomerTaxIdKeySpecifier = (
  | 'id'
  | 'status'
  | CustomerTaxIdKeySpecifier
)[]
export type CustomerTaxIdFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>
  status?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DeleteAllPreviewsResponseKeySpecifier = (
  | 'workspace'
  | DeleteAllPreviewsResponseKeySpecifier
)[]
export type DeleteAllPreviewsResponseFieldPolicy = {
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DeleteAnnotationReplyResponseKeySpecifier = (
  | 'comment'
  | DeleteAnnotationReplyResponseKeySpecifier
)[]
export type DeleteAnnotationReplyResponseFieldPolicy = {
  comment?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DeleteAnnotationResponseKeySpecifier = (
  | 'annotation'
  | DeleteAnnotationResponseKeySpecifier
)[]
export type DeleteAnnotationResponseFieldPolicy = {
  annotation?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DeleteCollectionResponseKeySpecifier = (
  | 'collection'
  | DeleteCollectionResponseKeySpecifier
)[]
export type DeleteCollectionResponseFieldPolicy = {
  collection?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DeletedScimPersonalAccessTokenKeySpecifier = (
  | 'identifier'
  | DeletedScimPersonalAccessTokenKeySpecifier
)[]
export type DeletedScimPersonalAccessTokenFieldPolicy = {
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DeletedSharePermanentlyEventKeySpecifier = (
  | 'shareIdentifier'
  | 'workspaceIdentifier'
  | DeletedSharePermanentlyEventKeySpecifier
)[]
export type DeletedSharePermanentlyEventFieldPolicy = {
  shareIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DeleteMembershipAuditKeySpecifier = (
  | 'acceptedAt'
  | 'action'
  | 'actor'
  | 'auditSource'
  | 'createdAt'
  | 'deletedSeat'
  | 'role'
  | 'user'
  | 'userEmail'
  | 'version'
  | DeleteMembershipAuditKeySpecifier
)[]
export type DeleteMembershipAuditFieldPolicy = {
  acceptedAt?: FieldPolicy<any> | FieldReadFunction<any>
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  auditSource?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  deletedSeat?: FieldPolicy<any> | FieldReadFunction<any>
  role?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  userEmail?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DeleteOrganizationAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'version'
  | DeleteOrganizationAuditKeySpecifier
)[]
export type DeleteOrganizationAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DeletePermissionGroupKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'name'
  | 'version'
  | DeletePermissionGroupKeySpecifier
)[]
export type DeletePermissionGroupFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DeletePermissionGroupResponseKeySpecifier = (
  | 'permissionGroupIdentifier'
  | DeletePermissionGroupResponseKeySpecifier
)[]
export type DeletePermissionGroupResponseFieldPolicy = {
  permissionGroupIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DeletePreviewResponseKeySpecifier = (
  | 'preview'
  | DeletePreviewResponseKeySpecifier
)[]
export type DeletePreviewResponseFieldPolicy = {
  preview?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DeletePreviousShareVersionsResponseKeySpecifier = (
  | 'deletedCount'
  | 'share'
  | 'shares'
  | DeletePreviousShareVersionsResponseKeySpecifier
)[]
export type DeletePreviousShareVersionsResponseFieldPolicy = {
  deletedCount?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  shares?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DeleteProjectPermanentlyResponseKeySpecifier = (
  | 'projectIdentifier'
  | 'workspace'
  | DeleteProjectPermanentlyResponseKeySpecifier
)[]
export type DeleteProjectPermanentlyResponseFieldPolicy = {
  projectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DeleteSharePermanentlyResponseKeySpecifier = (
  | 'shareIdentifier'
  | 'workspace'
  | DeleteSharePermanentlyResponseKeySpecifier
)[]
export type DeleteSharePermanentlyResponseFieldPolicy = {
  shareIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DeleteStorageItemResponseKeySpecifier = (
  | 'storageItem'
  | DeleteStorageItemResponseKeySpecifier
)[]
export type DeleteStorageItemResponseFieldPolicy = {
  storageItem?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DeleteStorageItemsResponseKeySpecifier = (
  | 'storageItems'
  | DeleteStorageItemsResponseKeySpecifier
)[]
export type DeleteStorageItemsResponseFieldPolicy = {
  storageItems?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DeleteWorkspaceAvatarResponseKeySpecifier = (
  | 'workspace'
  | DeleteWorkspaceAvatarResponseKeySpecifier
)[]
export type DeleteWorkspaceAvatarResponseFieldPolicy = {
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DeleteWorkspaceResponseKeySpecifier = (
  | 'deletedWorkspace'
  | DeleteWorkspaceResponseKeySpecifier
)[]
export type DeleteWorkspaceResponseFieldPolicy = {
  deletedWorkspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DetachFeatureFlagAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'flagIdentifier'
  | 'flagName'
  | 'version'
  | DetachFeatureFlagAuditKeySpecifier
)[]
export type DetachFeatureFlagAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  flagIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  flagName?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DisableMembershipAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'auditSource'
  | 'createdAt'
  | 'deletedSeat'
  | 'role'
  | 'user'
  | 'userEmail'
  | 'version'
  | DisableMembershipAuditKeySpecifier
)[]
export type DisableMembershipAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  auditSource?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  deletedSeat?: FieldPolicy<any> | FieldReadFunction<any>
  role?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  userEmail?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DisableMfaResponseKeySpecifier = (
  | 'user'
  | DisableMfaResponseKeySpecifier
)[]
export type DisableMfaResponseFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DisableScimResponseKeySpecifier = (
  | 'workspace'
  | DisableScimResponseKeySpecifier
)[]
export type DisableScimResponseFieldPolicy = {
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DisableSsoAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'version'
  | DisableSsoAuditKeySpecifier
)[]
export type DisableSsoAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DisableSupportAccessResponseKeySpecifier = (
  | 'workspace'
  | DisableSupportAccessResponseKeySpecifier
)[]
export type DisableSupportAccessResponseFieldPolicy = {
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DiscoverKeySpecifier = (
  | 'contentHash'
  | 'sections'
  | DiscoverKeySpecifier
)[]
export type DiscoverFieldPolicy = {
  contentHash?: FieldPolicy<any> | FieldReadFunction<any>
  sections?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DiscoverItemKeySpecifier = (
  | 'author'
  | 'backgroundColor'
  | 'categories'
  | 'content'
  | 'contentPosition'
  | 'date'
  | 'dismissable'
  | 'featured'
  | 'icon'
  | 'id'
  | 'image'
  | 'length'
  | 'links'
  | 'mobile'
  | 'note'
  | 'permissions'
  | 'place'
  | 'size'
  | 'source'
  | 'speakers'
  | 'title'
  | 'type'
  | 'url'
  | 'video'
  | DiscoverItemKeySpecifier
)[]
export type DiscoverItemFieldPolicy = {
  author?: FieldPolicy<any> | FieldReadFunction<any>
  backgroundColor?: FieldPolicy<any> | FieldReadFunction<any>
  categories?: FieldPolicy<any> | FieldReadFunction<any>
  content?: FieldPolicy<any> | FieldReadFunction<any>
  contentPosition?: FieldPolicy<any> | FieldReadFunction<any>
  date?: FieldPolicy<any> | FieldReadFunction<any>
  dismissable?: FieldPolicy<any> | FieldReadFunction<any>
  featured?: FieldPolicy<any> | FieldReadFunction<any>
  icon?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  image?: FieldPolicy<any> | FieldReadFunction<any>
  length?: FieldPolicy<any> | FieldReadFunction<any>
  links?: FieldPolicy<any> | FieldReadFunction<any>
  mobile?: FieldPolicy<any> | FieldReadFunction<any>
  note?: FieldPolicy<any> | FieldReadFunction<any>
  permissions?: FieldPolicy<any> | FieldReadFunction<any>
  place?: FieldPolicy<any> | FieldReadFunction<any>
  size?: FieldPolicy<any> | FieldReadFunction<any>
  source?: FieldPolicy<any> | FieldReadFunction<any>
  speakers?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
  video?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DiscoverSectionKeySpecifier = (
  | 'categories'
  | 'id'
  | 'items'
  | 'limit'
  | 'links'
  | 'permissions'
  | 'size'
  | 'stretchedContent'
  | 'subTitle'
  | 'title'
  | 'type'
  | 'visibility'
  | DiscoverSectionKeySpecifier
)[]
export type DiscoverSectionFieldPolicy = {
  categories?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  items?: FieldPolicy<any> | FieldReadFunction<any>
  limit?: FieldPolicy<any> | FieldReadFunction<any>
  links?: FieldPolicy<any> | FieldReadFunction<any>
  permissions?: FieldPolicy<any> | FieldReadFunction<any>
  size?: FieldPolicy<any> | FieldReadFunction<any>
  stretchedContent?: FieldPolicy<any> | FieldReadFunction<any>
  subTitle?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  visibility?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DiscussionKeySpecifier = (
  | 'id'
  | 'identifier'
  | DiscussionKeySpecifier
)[]
export type DiscussionFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DocumentKeySpecifier = (
  | 'artboard'
  | 'artboardCount'
  | 'artboards'
  | 'assetStatus'
  | 'canEditDescriptions'
  | 'coeditCompatibilityVersion'
  | 'colorspace'
  | 'componentCount'
  | 'componentGroups'
  | 'components'
  | 'createdAt'
  | 'documentVersion'
  | 'downloadableAssets'
  | 'downloadAvailable'
  | 'downloadUnavailableError'
  | 'frame'
  | 'frameCount'
  | 'frames'
  | 'hasMissingFonts'
  | 'id'
  | 'identifier'
  | 'isPresent'
  | 'isProcessing'
  | 'metaImageUrl'
  | 'name'
  | 'page'
  | 'pageCount'
  | 'pages'
  | 'path'
  | 'previewFile'
  | 'renderStatus'
  | 'size'
  | 'sketchVariant'
  | 'sketchVersion'
  | 'slug'
  | 'tokenExport'
  | 'updatedAt'
  | 'url'
  | 'userCanOpenInApp'
  | 'uuid'
  | 'willUploadDocument'
  | DocumentKeySpecifier
)[]
export type DocumentFieldPolicy = {
  artboard?: FieldPolicy<any> | FieldReadFunction<any>
  artboardCount?: FieldPolicy<any> | FieldReadFunction<any>
  artboards?: FieldPolicy<any> | FieldReadFunction<any>
  assetStatus?: FieldPolicy<any> | FieldReadFunction<any>
  canEditDescriptions?: FieldPolicy<any> | FieldReadFunction<any>
  coeditCompatibilityVersion?: FieldPolicy<any> | FieldReadFunction<any>
  colorspace?: FieldPolicy<any> | FieldReadFunction<any>
  componentCount?: FieldPolicy<any> | FieldReadFunction<any>
  componentGroups?: FieldPolicy<any> | FieldReadFunction<any>
  components?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  documentVersion?: FieldPolicy<any> | FieldReadFunction<any>
  downloadableAssets?: FieldPolicy<any> | FieldReadFunction<any>
  downloadAvailable?: FieldPolicy<any> | FieldReadFunction<any>
  downloadUnavailableError?: FieldPolicy<any> | FieldReadFunction<any>
  frame?: FieldPolicy<any> | FieldReadFunction<any>
  frameCount?: FieldPolicy<any> | FieldReadFunction<any>
  frames?: FieldPolicy<any> | FieldReadFunction<any>
  hasMissingFonts?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isPresent?: FieldPolicy<any> | FieldReadFunction<any>
  isProcessing?: FieldPolicy<any> | FieldReadFunction<any>
  metaImageUrl?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  page?: FieldPolicy<any> | FieldReadFunction<any>
  pageCount?: FieldPolicy<any> | FieldReadFunction<any>
  pages?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  previewFile?: FieldPolicy<any> | FieldReadFunction<any>
  renderStatus?: FieldPolicy<any> | FieldReadFunction<any>
  size?: FieldPolicy<any> | FieldReadFunction<any>
  sketchVariant?: FieldPolicy<any> | FieldReadFunction<any>
  sketchVersion?: FieldPolicy<any> | FieldReadFunction<any>
  slug?: FieldPolicy<any> | FieldReadFunction<any>
  tokenExport?: FieldPolicy<any> | FieldReadFunction<any>
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
  userCanOpenInApp?: FieldPolicy<any> | FieldReadFunction<any>
  uuid?: FieldPolicy<any> | FieldReadFunction<any>
  willUploadDocument?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DocumentUploadCancelPayloadKeySpecifier = (
  | 'message'
  | 'successful'
  | DocumentUploadCancelPayloadKeySpecifier
)[]
export type DocumentUploadCancelPayloadFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DocumentUploadCompletePayloadKeySpecifier = (
  | 'message'
  | 'successful'
  | 'version'
  | DocumentUploadCompletePayloadKeySpecifier
)[]
export type DocumentUploadCompletePayloadFieldPolicy = {
  message?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DowngradedSsoMembershipProvisionedAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'auditSource'
  | 'createdAt'
  | 'user'
  | 'userEmail'
  | 'version'
  | DowngradedSsoMembershipProvisionedAuditKeySpecifier
)[]
export type DowngradedSsoMembershipProvisionedAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  auditSource?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  userEmail?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DownloadableAssetKeySpecifier = (
  | 'fileName'
  | 'fileSizeInBytes'
  | 'formats'
  | 'identifier'
  | 'layerUuids'
  | 'path'
  | 'scales'
  | 'status'
  | DownloadableAssetKeySpecifier
)[]
export type DownloadableAssetFieldPolicy = {
  fileName?: FieldPolicy<any> | FieldReadFunction<any>
  fileSizeInBytes?: FieldPolicy<any> | FieldReadFunction<any>
  formats?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  layerUuids?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  scales?: FieldPolicy<any> | FieldReadFunction<any>
  status?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DownloadableAssetRenderedNotificationKeySpecifier = (
  | 'createdAt'
  | 'identifier'
  | 'isPinned'
  | 'notifiedVersion'
  | 'path'
  | 'share'
  | 'state'
  | 'subtitle'
  | 'title'
  | 'token'
  | 'url'
  | 'user'
  | 'workspace'
  | DownloadableAssetRenderedNotificationKeySpecifier
)[]
export type DownloadableAssetRenderedNotificationFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isPinned?: FieldPolicy<any> | FieldReadFunction<any>
  notifiedVersion?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  state?: FieldPolicy<any> | FieldReadFunction<any>
  subtitle?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
  token?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DownloadLatestVersionCatchUpKeySpecifier = (
  | 'latestVersionIdentifier'
  | DownloadLatestVersionCatchUpKeySpecifier
)[]
export type DownloadLatestVersionCatchUpFieldPolicy = {
  latestVersionIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DownloadPatchesCatchUpKeySpecifier = (
  | 'startingPatchIdentifier'
  | DownloadPatchesCatchUpKeySpecifier
)[]
export type DownloadPatchesCatchUpFieldPolicy = {
  startingPatchIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DuplicateShareToDraftsResponseKeySpecifier = (
  | 'share'
  | DuplicateShareToDraftsResponseKeySpecifier
)[]
export type DuplicateShareToDraftsResponseFieldPolicy = {
  share?: FieldPolicy<any> | FieldReadFunction<any>
}
export type DuplicateShareToResponseKeySpecifier = (
  | 'share'
  | DuplicateShareToResponseKeySpecifier
)[]
export type DuplicateShareToResponseFieldPolicy = {
  share?: FieldPolicy<any> | FieldReadFunction<any>
}
export type EditCollectionDescriptionResponseKeySpecifier = (
  | 'collection'
  | EditCollectionDescriptionResponseKeySpecifier
)[]
export type EditCollectionDescriptionResponseFieldPolicy = {
  collection?: FieldPolicy<any> | FieldReadFunction<any>
}
export type EditCollectionResponseKeySpecifier = (
  | 'collection'
  | EditCollectionResponseKeySpecifier
)[]
export type EditCollectionResponseFieldPolicy = {
  collection?: FieldPolicy<any> | FieldReadFunction<any>
}
export type EditCommentResponseKeySpecifier = (
  | 'comment'
  | EditCommentResponseKeySpecifier
)[]
export type EditCommentResponseFieldPolicy = {
  comment?: FieldPolicy<any> | FieldReadFunction<any>
}
export type EducationApplicationKeySpecifier = (
  | 'comments'
  | 'contactDetails'
  | 'courses'
  | 'createdAt'
  | 'files'
  | 'identifier'
  | 'institutionName'
  | 'institutionUrl'
  | 'isInstitutional'
  | 'latestInfoRequestReason'
  | 'requestedNumberOfSeats'
  | 'state'
  | 'submittedAt'
  | 'type'
  | 'updatedAt'
  | 'user'
  | 'workspace'
  | EducationApplicationKeySpecifier
)[]
export type EducationApplicationFieldPolicy = {
  comments?: FieldPolicy<any> | FieldReadFunction<any>
  contactDetails?: FieldPolicy<any> | FieldReadFunction<any>
  courses?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  files?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  institutionName?: FieldPolicy<any> | FieldReadFunction<any>
  institutionUrl?: FieldPolicy<any> | FieldReadFunction<any>
  isInstitutional?: FieldPolicy<any> | FieldReadFunction<any>
  latestInfoRequestReason?: FieldPolicy<any> | FieldReadFunction<any>
  requestedNumberOfSeats?: FieldPolicy<any> | FieldReadFunction<any>
  state?: FieldPolicy<any> | FieldReadFunction<any>
  submittedAt?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type EducationApplicationContactDetailsKeySpecifier = (
  | 'city'
  | 'contactInfo'
  | 'country'
  | 'line'
  | 'postCode'
  | 'state'
  | EducationApplicationContactDetailsKeySpecifier
)[]
export type EducationApplicationContactDetailsFieldPolicy = {
  city?: FieldPolicy<any> | FieldReadFunction<any>
  contactInfo?: FieldPolicy<any> | FieldReadFunction<any>
  country?: FieldPolicy<any> | FieldReadFunction<any>
  line?: FieldPolicy<any> | FieldReadFunction<any>
  postCode?: FieldPolicy<any> | FieldReadFunction<any>
  state?: FieldPolicy<any> | FieldReadFunction<any>
}
export type EducationApplicationFilesKeySpecifier = (
  | 'courseDocumentation'
  | 'proof'
  | EducationApplicationFilesKeySpecifier
)[]
export type EducationApplicationFilesFieldPolicy = {
  courseDocumentation?: FieldPolicy<any> | FieldReadFunction<any>
  proof?: FieldPolicy<any> | FieldReadFunction<any>
}
export type EmailResendChangeConfirmationPayloadKeySpecifier = (
  | 'errors'
  | 'successful'
  | EmailResendChangeConfirmationPayloadKeySpecifier
)[]
export type EmailResendChangeConfirmationPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type EmailUpdatePayloadKeySpecifier = (
  | 'errors'
  | 'successful'
  | 'user'
  | EmailUpdatePayloadKeySpecifier
)[]
export type EmailUpdatePayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
}
export type EmailVerifyPayloadKeySpecifier = (
  | 'email'
  | 'errors'
  | 'successful'
  | EmailVerifyPayloadKeySpecifier
)[]
export type EmailVerifyPayloadFieldPolicy = {
  email?: FieldPolicy<any> | FieldReadFunction<any>
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type EmptiedWorkspaceTrashEventKeySpecifier = (
  | 'workspaceIdentifier'
  | EmptiedWorkspaceTrashEventKeySpecifier
)[]
export type EmptiedWorkspaceTrashEventFieldPolicy = {
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type EmptyWorkspaceTrashResponseKeySpecifier = (
  | 'workspace'
  | EmptyWorkspaceTrashResponseKeySpecifier
)[]
export type EmptyWorkspaceTrashResponseFieldPolicy = {
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type EnableScimResponseKeySpecifier = (
  | 'scimToken'
  | 'workspace'
  | EnableScimResponseKeySpecifier
)[]
export type EnableScimResponseFieldPolicy = {
  scimToken?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type EnableSupportAccessResponseKeySpecifier = (
  | 'workspace'
  | EnableSupportAccessResponseKeySpecifier
)[]
export type EnableSupportAccessResponseFieldPolicy = {
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type EncryptionConfigKeySpecifier = (
  | 'kmsArns'
  | 'roleArn'
  | EncryptionConfigKeySpecifier
)[]
export type EncryptionConfigFieldPolicy = {
  kmsArns?: FieldPolicy<any> | FieldReadFunction<any>
  roleArn?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ErrorContextKeySpecifier = (
  | 'key'
  | 'value'
  | ErrorContextKeySpecifier
)[]
export type ErrorContextFieldPolicy = {
  key?: FieldPolicy<any> | FieldReadFunction<any>
  value?: FieldPolicy<any> | FieldReadFunction<any>
}
export type EventDateKeySpecifier = ('day' | 'time' | EventDateKeySpecifier)[]
export type EventDateFieldPolicy = {
  day?: FieldPolicy<any> | FieldReadFunction<any>
  time?: FieldPolicy<any> | FieldReadFunction<any>
}
export type FileKeySpecifier = (
  | 'hash'
  | 'height'
  | 'id'
  | 'identifier'
  | 'isPresent'
  | 'path'
  | 'scale'
  | 'size'
  | 'slug'
  | 'thumbnails'
  | 'type'
  | 'url'
  | 'width'
  | FileKeySpecifier
)[]
export type FileFieldPolicy = {
  hash?: FieldPolicy<any> | FieldReadFunction<any>
  height?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isPresent?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  scale?: FieldPolicy<any> | FieldReadFunction<any>
  size?: FieldPolicy<any> | FieldReadFunction<any>
  slug?: FieldPolicy<any> | FieldReadFunction<any>
  thumbnails?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
  width?: FieldPolicy<any> | FieldReadFunction<any>
}
export type FolderArchivedNotificationKeySpecifier = (
  | 'createdAt'
  | 'folder'
  | 'identifier'
  | 'isPinned'
  | 'path'
  | 'share'
  | 'state'
  | 'subtitle'
  | 'title'
  | 'token'
  | 'url'
  | 'user'
  | 'workspace'
  | FolderArchivedNotificationKeySpecifier
)[]
export type FolderArchivedNotificationFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  folder?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isPinned?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  state?: FieldPolicy<any> | FieldReadFunction<any>
  subtitle?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
  token?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type FolderPermanentlyDeletedNotificationKeySpecifier = (
  | 'createdAt'
  | 'identifier'
  | 'isPinned'
  | 'path'
  | 'share'
  | 'state'
  | 'subtitle'
  | 'title'
  | 'token'
  | 'url'
  | 'user'
  | 'workspace'
  | FolderPermanentlyDeletedNotificationKeySpecifier
)[]
export type FolderPermanentlyDeletedNotificationFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isPinned?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  state?: FieldPolicy<any> | FieldReadFunction<any>
  subtitle?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
  token?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type FolderRestoredNotificationKeySpecifier = (
  | 'createdAt'
  | 'folder'
  | 'identifier'
  | 'isPinned'
  | 'path'
  | 'share'
  | 'state'
  | 'subtitle'
  | 'title'
  | 'token'
  | 'url'
  | 'user'
  | 'workspace'
  | FolderRestoredNotificationKeySpecifier
)[]
export type FolderRestoredNotificationFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  folder?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isPinned?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  state?: FieldPolicy<any> | FieldReadFunction<any>
  subtitle?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
  token?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type FolderTrashedNotificationKeySpecifier = (
  | 'createdAt'
  | 'folder'
  | 'identifier'
  | 'isPinned'
  | 'path'
  | 'share'
  | 'state'
  | 'subtitle'
  | 'title'
  | 'token'
  | 'url'
  | 'user'
  | 'workspace'
  | FolderTrashedNotificationKeySpecifier
)[]
export type FolderTrashedNotificationFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  folder?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isPinned?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  state?: FieldPolicy<any> | FieldReadFunction<any>
  subtitle?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
  token?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type FrameKeySpecifier = (
  | 'annotationCount'
  | 'component'
  | 'documentOrder'
  | 'documentVersionShortId'
  | 'files'
  | 'hasMissingFonts'
  | 'height'
  | 'identifier'
  | 'isFlowHome'
  | 'name'
  | 'next'
  | 'order'
  | 'page'
  | 'previous'
  | 'revisions'
  | 'section'
  | 'subscriptionStatus'
  | 'unreadCount'
  | 'uuid'
  | 'width'
  | FrameKeySpecifier
)[]
export type FrameFieldPolicy = {
  annotationCount?: FieldPolicy<any> | FieldReadFunction<any>
  component?: FieldPolicy<any> | FieldReadFunction<any>
  documentOrder?: FieldPolicy<any> | FieldReadFunction<any>
  documentVersionShortId?: FieldPolicy<any> | FieldReadFunction<any>
  files?: FieldPolicy<any> | FieldReadFunction<any>
  hasMissingFonts?: FieldPolicy<any> | FieldReadFunction<any>
  height?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isFlowHome?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  next?: FieldPolicy<any> | FieldReadFunction<any>
  order?: FieldPolicy<any> | FieldReadFunction<any>
  page?: FieldPolicy<any> | FieldReadFunction<any>
  previous?: FieldPolicy<any> | FieldReadFunction<any>
  revisions?: FieldPolicy<any> | FieldReadFunction<any>
  section?: FieldPolicy<any> | FieldReadFunction<any>
  subscriptionStatus?: FieldPolicy<any> | FieldReadFunction<any>
  unreadCount?: FieldPolicy<any> | FieldReadFunction<any>
  uuid?: FieldPolicy<any> | FieldReadFunction<any>
  width?: FieldPolicy<any> | FieldReadFunction<any>
}
export type FrameGroupKeySpecifier = (
  | 'annotationCount'
  | 'component'
  | 'documentOrder'
  | 'documentVersionShortId'
  | 'files'
  | 'hasMissingFonts'
  | 'height'
  | 'identifier'
  | 'isFlowHome'
  | 'name'
  | 'next'
  | 'order'
  | 'page'
  | 'previous'
  | 'revisions'
  | 'subscriptionStatus'
  | 'unreadCount'
  | 'uuid'
  | 'width'
  | FrameGroupKeySpecifier
)[]
export type FrameGroupFieldPolicy = {
  annotationCount?: FieldPolicy<any> | FieldReadFunction<any>
  component?: FieldPolicy<any> | FieldReadFunction<any>
  documentOrder?: FieldPolicy<any> | FieldReadFunction<any>
  documentVersionShortId?: FieldPolicy<any> | FieldReadFunction<any>
  files?: FieldPolicy<any> | FieldReadFunction<any>
  hasMissingFonts?: FieldPolicy<any> | FieldReadFunction<any>
  height?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isFlowHome?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  next?: FieldPolicy<any> | FieldReadFunction<any>
  order?: FieldPolicy<any> | FieldReadFunction<any>
  page?: FieldPolicy<any> | FieldReadFunction<any>
  previous?: FieldPolicy<any> | FieldReadFunction<any>
  revisions?: FieldPolicy<any> | FieldReadFunction<any>
  subscriptionStatus?: FieldPolicy<any> | FieldReadFunction<any>
  unreadCount?: FieldPolicy<any> | FieldReadFunction<any>
  uuid?: FieldPolicy<any> | FieldReadFunction<any>
  width?: FieldPolicy<any> | FieldReadFunction<any>
}
export type FrameRevisionsKeySpecifier = (
  | 'entries'
  | 'meta'
  | FrameRevisionsKeySpecifier
)[]
export type FrameRevisionsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type FramesKeySpecifier = ('entries' | 'meta' | FramesKeySpecifier)[]
export type FramesFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type GeneratedDocumentsFeedAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'version'
  | GeneratedDocumentsFeedAuditKeySpecifier
)[]
export type GeneratedDocumentsFeedAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type GeneratedScimPersonalAccessTokenKeySpecifier = (
  | 'personalAccessToken'
  | 'secret'
  | GeneratedScimPersonalAccessTokenKeySpecifier
)[]
export type GeneratedScimPersonalAccessTokenFieldPolicy = {
  personalAccessToken?: FieldPolicy<any> | FieldReadFunction<any>
  secret?: FieldPolicy<any> | FieldReadFunction<any>
}
export type IdentityProviderConfigKeySpecifier = (
  | 'binding'
  | 'certificate'
  | 'entityId'
  | 'ssoUrl'
  | IdentityProviderConfigKeySpecifier
)[]
export type IdentityProviderConfigFieldPolicy = {
  binding?: FieldPolicy<any> | FieldReadFunction<any>
  certificate?: FieldPolicy<any> | FieldReadFunction<any>
  entityId?: FieldPolicy<any> | FieldReadFunction<any>
  ssoUrl?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ImmediateChargeKeySpecifier = (
  | 'amount'
  | 'chargeAmount'
  | 'couponInfo'
  | 'creditsAmount'
  | 'daysElapsedInCycle'
  | 'daysRemainingInCycle'
  | 'discountForUnusedDays'
  | 'price'
  | 'proratedRefundAmountForNewSeats'
  | ImmediateChargeKeySpecifier
)[]
export type ImmediateChargeFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>
  chargeAmount?: FieldPolicy<any> | FieldReadFunction<any>
  couponInfo?: FieldPolicy<any> | FieldReadFunction<any>
  creditsAmount?: FieldPolicy<any> | FieldReadFunction<any>
  daysElapsedInCycle?: FieldPolicy<any> | FieldReadFunction<any>
  daysRemainingInCycle?: FieldPolicy<any> | FieldReadFunction<any>
  discountForUnusedDays?: FieldPolicy<any> | FieldReadFunction<any>
  price?: FieldPolicy<any> | FieldReadFunction<any>
  proratedRefundAmountForNewSeats?: FieldPolicy<any> | FieldReadFunction<any>
}
export type InspectorDataKeySpecifier = (
  | 'data'
  | 'status'
  | InspectorDataKeySpecifier
)[]
export type InspectorDataFieldPolicy = {
  data?: FieldPolicy<any> | FieldReadFunction<any>
  status?: FieldPolicy<any> | FieldReadFunction<any>
}
export type InspectorDataPayloadKeySpecifier = (
  | 'errors'
  | 'inspector'
  | 'successful'
  | InspectorDataPayloadKeySpecifier
)[]
export type InspectorDataPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  inspector?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type InstallIntegrationAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'provider'
  | 'version'
  | InstallIntegrationAuditKeySpecifier
)[]
export type InstallIntegrationAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  provider?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type IntegrationConnectUrlPayloadKeySpecifier = (
  | 'url'
  | IntegrationConnectUrlPayloadKeySpecifier
)[]
export type IntegrationConnectUrlPayloadFieldPolicy = {
  url?: FieldPolicy<any> | FieldReadFunction<any>
}
export type IntegrationIdentityConnectUrlPayloadKeySpecifier = (
  | 'url'
  | IntegrationIdentityConnectUrlPayloadKeySpecifier
)[]
export type IntegrationIdentityConnectUrlPayloadFieldPolicy = {
  url?: FieldPolicy<any> | FieldReadFunction<any>
}
export type InviteWorkspaceMembersResponseKeySpecifier = (
  | 'alreadyInvited'
  | 'newlyInvited'
  | 'pendingScaToken'
  | 'workspace'
  | InviteWorkspaceMembersResponseKeySpecifier
)[]
export type InviteWorkspaceMembersResponseFieldPolicy = {
  alreadyInvited?: FieldPolicy<any> | FieldReadFunction<any>
  newlyInvited?: FieldPolicy<any> | FieldReadFunction<any>
  pendingScaToken?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type InvoicePaymentDetailsKeySpecifier = (
  | 'daysUntilDue'
  | 'type'
  | InvoicePaymentDetailsKeySpecifier
)[]
export type InvoicePaymentDetailsFieldPolicy = {
  daysUntilDue?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ItemMobileKeySpecifier = (
  | 'description'
  | 'icon'
  | ItemMobileKeySpecifier
)[]
export type ItemMobileFieldPolicy = {
  description?: FieldPolicy<any> | FieldReadFunction<any>
  icon?: FieldPolicy<any> | FieldReadFunction<any>
}
export type LatestVisibleVersionKeySpecifier = (
  | 'identifier'
  | 'isLatest'
  | 'shortId'
  | LatestVisibleVersionKeySpecifier
)[]
export type LatestVisibleVersionFieldPolicy = {
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isLatest?: FieldPolicy<any> | FieldReadFunction<any>
  shortId?: FieldPolicy<any> | FieldReadFunction<any>
}
export type LayerStyleKeySpecifier = (
  | 'depth'
  | 'description'
  | 'files'
  | 'identifier'
  | 'name'
  | 'needsContrastingBackground'
  | 'path'
  | 'pathGroups'
  | 'pathInfo'
  | 'uuid'
  | LayerStyleKeySpecifier
)[]
export type LayerStyleFieldPolicy = {
  depth?: FieldPolicy<any> | FieldReadFunction<any>
  description?: FieldPolicy<any> | FieldReadFunction<any>
  files?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  needsContrastingBackground?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  pathGroups?: FieldPolicy<any> | FieldReadFunction<any>
  pathInfo?: FieldPolicy<any> | FieldReadFunction<any>
  uuid?: FieldPolicy<any> | FieldReadFunction<any>
}
export type LeaveProjectResponseKeySpecifier = (
  | 'project'
  | LeaveProjectResponseKeySpecifier
)[]
export type LeaveProjectResponseFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
}
export type LicensePlanKeySpecifier = (
  | 'id'
  | 'name'
  | 'prices'
  | 'type'
  | LicensePlanKeySpecifier
)[]
export type LicensePlanFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  prices?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
}
export type LicenseRedemptionKeySpecifier = (
  | 'createdAt'
  | 'credits'
  | 'customer'
  | 'id'
  | 'licenseEndDate'
  | 'months'
  | 'ownerEmail'
  | 'requesterUserID'
  | 'seats'
  | 'serial'
  | 'status'
  | LicenseRedemptionKeySpecifier
)[]
export type LicenseRedemptionFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  credits?: FieldPolicy<any> | FieldReadFunction<any>
  customer?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  licenseEndDate?: FieldPolicy<any> | FieldReadFunction<any>
  months?: FieldPolicy<any> | FieldReadFunction<any>
  ownerEmail?: FieldPolicy<any> | FieldReadFunction<any>
  requesterUserID?: FieldPolicy<any> | FieldReadFunction<any>
  seats?: FieldPolicy<any> | FieldReadFunction<any>
  serial?: FieldPolicy<any> | FieldReadFunction<any>
  status?: FieldPolicy<any> | FieldReadFunction<any>
}
export type LicenseRedemptionsKeySpecifier = (
  | 'entries'
  | 'meta'
  | LicenseRedemptionsKeySpecifier
)[]
export type LicenseRedemptionsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type LinkKeySpecifier = (
  | 'icon'
  | 'text'
  | 'url'
  | 'variant'
  | LinkKeySpecifier
)[]
export type LinkFieldPolicy = {
  icon?: FieldPolicy<any> | FieldReadFunction<any>
  text?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
  variant?: FieldPolicy<any> | FieldReadFunction<any>
}
export type LinkRegularAccountResponseKeySpecifier = (
  | 'user'
  | LinkRegularAccountResponseKeySpecifier
)[]
export type LinkRegularAccountResponseFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>
}
export type LocalCollaborativePatchKeySpecifier = (
  | 'baseVersionIdentifier'
  | 'id'
  | 'nextVersionIdentifier'
  | 'payload'
  | 'seq'
  | 'shareIdentifier'
  | LocalCollaborativePatchKeySpecifier
)[]
export type LocalCollaborativePatchFieldPolicy = {
  baseVersionIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  nextVersionIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  payload?: FieldPolicy<any> | FieldReadFunction<any>
  seq?: FieldPolicy<any> | FieldReadFunction<any>
  shareIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type MarkAllCommentsAsReadResponseKeySpecifier = (
  | 'comments'
  | MarkAllCommentsAsReadResponseKeySpecifier
)[]
export type MarkAllCommentsAsReadResponseFieldPolicy = {
  comments?: FieldPolicy<any> | FieldReadFunction<any>
}
export type MarkCommentsAsReadResponseKeySpecifier = (
  | 'comments'
  | MarkCommentsAsReadResponseKeySpecifier
)[]
export type MarkCommentsAsReadResponseFieldPolicy = {
  comments?: FieldPolicy<any> | FieldReadFunction<any>
}
export type MembershipCountKeySpecifier = (
  | 'admin'
  | 'group'
  | 'guest'
  | 'member'
  | MembershipCountKeySpecifier
)[]
export type MembershipCountFieldPolicy = {
  admin?: FieldPolicy<any> | FieldReadFunction<any>
  group?: FieldPolicy<any> | FieldReadFunction<any>
  guest?: FieldPolicy<any> | FieldReadFunction<any>
  member?: FieldPolicy<any> | FieldReadFunction<any>
}
export type MentionableUserKeySpecifier = (
  | 'avatar'
  | 'email'
  | 'id'
  | 'identifier'
  | 'name'
  | MentionableUserKeySpecifier
)[]
export type MentionableUserFieldPolicy = {
  avatar?: FieldPolicy<any> | FieldReadFunction<any>
  email?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
}
export type MentionNotificationKeySpecifier = (
  | 'artboard'
  | 'comment'
  | 'createdAt'
  | 'identifier'
  | 'isPinned'
  | 'path'
  | 'previews'
  | 'share'
  | 'state'
  | 'subtitle'
  | 'title'
  | 'token'
  | 'url'
  | 'user'
  | 'workspace'
  | MentionNotificationKeySpecifier
)[]
export type MentionNotificationFieldPolicy = {
  artboard?: FieldPolicy<any> | FieldReadFunction<any>
  comment?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isPinned?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  previews?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  state?: FieldPolicy<any> | FieldReadFunction<any>
  subtitle?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
  token?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type MfaConfigKeySpecifier = ('recoveryCodes' | MfaConfigKeySpecifier)[]
export type MfaConfigFieldPolicy = {
  recoveryCodes?: FieldPolicy<any> | FieldReadFunction<any>
}
export type MFACredentialsKeySpecifier = (
  | 'mfaToken'
  | MFACredentialsKeySpecifier
)[]
export type MFACredentialsFieldPolicy = {
  mfaToken?: FieldPolicy<any> | FieldReadFunction<any>
}
export type MigrationKeySpecifier = (
  | 'coeditCompatibilityVersion'
  | 'versionIdentifier'
  | MigrationKeySpecifier
)[]
export type MigrationFieldPolicy = {
  coeditCompatibilityVersion?: FieldPolicy<any> | FieldReadFunction<any>
  versionIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type MigrationCompletedKeySpecifier = (
  | 'coeditCompatibilityVersion'
  | 'versionIdentifier'
  | MigrationCompletedKeySpecifier
)[]
export type MigrationCompletedFieldPolicy = {
  coeditCompatibilityVersion?: FieldPolicy<any> | FieldReadFunction<any>
  versionIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type MigrationFailedKeySpecifier = (
  | 'error'
  | 'versionIdentifier'
  | MigrationFailedKeySpecifier
)[]
export type MigrationFailedFieldPolicy = {
  error?: FieldPolicy<any> | FieldReadFunction<any>
  versionIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type MigrationStartedKeySpecifier = (
  | 'coeditCompatibilityVersion'
  | 'versionIdentifier'
  | MigrationStartedKeySpecifier
)[]
export type MigrationStartedFieldPolicy = {
  coeditCompatibilityVersion?: FieldPolicy<any> | FieldReadFunction<any>
  versionIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type MoveAllCollectionSharesResponseKeySpecifier = (
  | 'projectIdentifier'
  | 'targetCollection'
  | 'targetIdentifier'
  | MoveAllCollectionSharesResponseKeySpecifier
)[]
export type MoveAllCollectionSharesResponseFieldPolicy = {
  projectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  targetCollection?: FieldPolicy<any> | FieldReadFunction<any>
  targetIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type MoveAnnotationResponseKeySpecifier = (
  | 'annotation'
  | MoveAnnotationResponseKeySpecifier
)[]
export type MoveAnnotationResponseFieldPolicy = {
  annotation?: FieldPolicy<any> | FieldReadFunction<any>
}
export type MoveAnnotationsResponseKeySpecifier = (
  | 'annotations'
  | MoveAnnotationsResponseKeySpecifier
)[]
export type MoveAnnotationsResponseFieldPolicy = {
  annotations?: FieldPolicy<any> | FieldReadFunction<any>
}
export type MultipartPartKeySpecifier = (
  | 'expiresAt'
  | 'partNumber'
  | 'url'
  | MultipartPartKeySpecifier
)[]
export type MultipartPartFieldPolicy = {
  expiresAt?: FieldPolicy<any> | FieldReadFunction<any>
  partNumber?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
}
export type MultipartUploadKeySpecifier = (
  | 'multipartSessionTicket'
  | 'parts'
  | 'partSize'
  | 'totalParts'
  | MultipartUploadKeySpecifier
)[]
export type MultipartUploadFieldPolicy = {
  multipartSessionTicket?: FieldPolicy<any> | FieldReadFunction<any>
  parts?: FieldPolicy<any> | FieldReadFunction<any>
  partSize?: FieldPolicy<any> | FieldReadFunction<any>
  totalParts?: FieldPolicy<any> | FieldReadFunction<any>
}
export type MutationKeySpecifier = (
  | 'applyCoupon'
  | 'cancelSubscription'
  | 'changePlan'
  | 'confirmAppStorePurchase'
  | 'createSetupIntent'
  | 'reactivateSubscription'
  | 'subscribeCustomerToPlan'
  | 'undoCancelSubscription'
  | 'undoScheduledSubscriptionCancellation'
  | 'updateBillingDetails'
  | 'updatePaymentMethod'
  | MutationKeySpecifier
)[]
export type MutationFieldPolicy = {
  applyCoupon?: FieldPolicy<any> | FieldReadFunction<any>
  cancelSubscription?: FieldPolicy<any> | FieldReadFunction<any>
  changePlan?: FieldPolicy<any> | FieldReadFunction<any>
  confirmAppStorePurchase?: FieldPolicy<any> | FieldReadFunction<any>
  createSetupIntent?: FieldPolicy<any> | FieldReadFunction<any>
  reactivateSubscription?: FieldPolicy<any> | FieldReadFunction<any>
  subscribeCustomerToPlan?: FieldPolicy<any> | FieldReadFunction<any>
  undoCancelSubscription?: FieldPolicy<any> | FieldReadFunction<any>
  undoScheduledSubscriptionCancellation?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  updateBillingDetails?: FieldPolicy<any> | FieldReadFunction<any>
  updatePaymentMethod?: FieldPolicy<any> | FieldReadFunction<any>
}
export type NameMappingKeySpecifier = (
  | 'firstName'
  | 'surname'
  | 'updateOnLogin'
  | NameMappingKeySpecifier
)[]
export type NameMappingFieldPolicy = {
  firstName?: FieldPolicy<any> | FieldReadFunction<any>
  surname?: FieldPolicy<any> | FieldReadFunction<any>
  updateOnLogin?: FieldPolicy<any> | FieldReadFunction<any>
}
export type NewEducationRequestAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'educationRequest'
  | 'version'
  | NewEducationRequestAuditKeySpecifier
)[]
export type NewEducationRequestAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  educationRequest?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type NoPaymentDetailsKeySpecifier = (
  | 'type'
  | NoPaymentDetailsKeySpecifier
)[]
export type NoPaymentDetailsFieldPolicy = {
  type?: FieldPolicy<any> | FieldReadFunction<any>
}
export type NotificationMarkAllAsReadPayloadKeySpecifier = (
  | 'errors'
  | 'successful'
  | NotificationMarkAllAsReadPayloadKeySpecifier
)[]
export type NotificationMarkAllAsReadPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type NotificationMarkAsReadPayloadKeySpecifier = (
  | 'errors'
  | 'notification'
  | 'successful'
  | NotificationMarkAsReadPayloadKeySpecifier
)[]
export type NotificationMarkAsReadPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  notification?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type NotificationMarkEveryReadAsDonePayloadKeySpecifier = (
  | 'errors'
  | 'successful'
  | NotificationMarkEveryReadAsDonePayloadKeySpecifier
)[]
export type NotificationMarkEveryReadAsDonePayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type NotificationsKeySpecifier = (
  | 'entries'
  | 'meta'
  | NotificationsKeySpecifier
)[]
export type NotificationsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type NotificationsUpdatedPayloadKeySpecifier = (
  | 'errors'
  | 'successful'
  | NotificationsUpdatedPayloadKeySpecifier
)[]
export type NotificationsUpdatedPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type NotificationUpdatedPayloadKeySpecifier = (
  | 'errors'
  | 'notification'
  | 'successful'
  | NotificationUpdatedPayloadKeySpecifier
)[]
export type NotificationUpdatedPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  notification?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type OAuthCredentialsKeySpecifier = (
  | 'authToken'
  | 'expirationDateTime'
  | 'refreshToken'
  | OAuthCredentialsKeySpecifier
)[]
export type OAuthCredentialsFieldPolicy = {
  authToken?: FieldPolicy<any> | FieldReadFunction<any>
  expirationDateTime?: FieldPolicy<any> | FieldReadFunction<any>
  refreshToken?: FieldPolicy<any> | FieldReadFunction<any>
}
export type OrganizationKeySpecifier = (
  | 'avatar'
  | 'billing'
  | 'canUseRestrictedUploads'
  | 'canUseSso'
  | 'customerId'
  | 'featureFlags'
  | 'id'
  | 'identifier'
  | 'memberships'
  | 'name'
  | 'organizationMembership'
  | 'projects'
  | 'shares'
  | 'shortId'
  | 'ssoConfig'
  | 'ssoEnabled'
  | 'ssoShortName'
  | 'ssoStartUrl'
  | 'tosAccepted'
  | 'tosAcceptedAt'
  | 'userCanAdminister'
  | 'userCanContribute'
  | 'userIsMember'
  | 'userIsOwner'
  | 'userRole'
  | 'viewerCanAdminister'
  | 'viewerCanContribute'
  | 'viewerIsMember'
  | 'viewerIsOwner'
  | 'viewerRole'
  | OrganizationKeySpecifier
)[]
export type OrganizationFieldPolicy = {
  avatar?: FieldPolicy<any> | FieldReadFunction<any>
  billing?: FieldPolicy<any> | FieldReadFunction<any>
  canUseRestrictedUploads?: FieldPolicy<any> | FieldReadFunction<any>
  canUseSso?: FieldPolicy<any> | FieldReadFunction<any>
  customerId?: FieldPolicy<any> | FieldReadFunction<any>
  featureFlags?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  memberships?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  organizationMembership?: FieldPolicy<any> | FieldReadFunction<any>
  projects?: FieldPolicy<any> | FieldReadFunction<any>
  shares?: FieldPolicy<any> | FieldReadFunction<any>
  shortId?: FieldPolicy<any> | FieldReadFunction<any>
  ssoConfig?: FieldPolicy<any> | FieldReadFunction<any>
  ssoEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  ssoShortName?: FieldPolicy<any> | FieldReadFunction<any>
  ssoStartUrl?: FieldPolicy<any> | FieldReadFunction<any>
  tosAccepted?: FieldPolicy<any> | FieldReadFunction<any>
  tosAcceptedAt?: FieldPolicy<any> | FieldReadFunction<any>
  userCanAdminister?: FieldPolicy<any> | FieldReadFunction<any>
  userCanContribute?: FieldPolicy<any> | FieldReadFunction<any>
  userIsMember?: FieldPolicy<any> | FieldReadFunction<any>
  userIsOwner?: FieldPolicy<any> | FieldReadFunction<any>
  userRole?: FieldPolicy<any> | FieldReadFunction<any>
  viewerCanAdminister?: FieldPolicy<any> | FieldReadFunction<any>
  viewerCanContribute?: FieldPolicy<any> | FieldReadFunction<any>
  viewerIsMember?: FieldPolicy<any> | FieldReadFunction<any>
  viewerIsOwner?: FieldPolicy<any> | FieldReadFunction<any>
  viewerRole?: FieldPolicy<any> | FieldReadFunction<any>
}
export type OrganizationAcceptInvitePayloadKeySpecifier = (
  | 'errors'
  | 'membership'
  | 'successful'
  | OrganizationAcceptInvitePayloadKeySpecifier
)[]
export type OrganizationAcceptInvitePayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  membership?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type OrganizationAcceptTosPayloadKeySpecifier = (
  | 'errors'
  | 'organization'
  | 'successful'
  | OrganizationAcceptTosPayloadKeySpecifier
)[]
export type OrganizationAcceptTosPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  organization?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type OrganizationInviteKeySpecifier = (
  | 'email'
  | 'id'
  | 'identifier'
  | OrganizationInviteKeySpecifier
)[]
export type OrganizationInviteFieldPolicy = {
  email?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type OrganizationMembershipKeySpecifier = (
  | 'acceptedAt'
  | 'hasLicense'
  | 'id'
  | 'identifier'
  | 'inviter'
  | 'isContributor'
  | 'isPrimary'
  | 'organization'
  | 'organizationInvite'
  | 'role'
  | 'user'
  | OrganizationMembershipKeySpecifier
)[]
export type OrganizationMembershipFieldPolicy = {
  acceptedAt?: FieldPolicy<any> | FieldReadFunction<any>
  hasLicense?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  inviter?: FieldPolicy<any> | FieldReadFunction<any>
  isContributor?: FieldPolicy<any> | FieldReadFunction<any>
  isPrimary?: FieldPolicy<any> | FieldReadFunction<any>
  organization?: FieldPolicy<any> | FieldReadFunction<any>
  organizationInvite?: FieldPolicy<any> | FieldReadFunction<any>
  role?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
}
export type OrganizationMembershipsKeySpecifier = (
  | 'entries'
  | 'meta'
  | OrganizationMembershipsKeySpecifier
)[]
export type OrganizationMembershipsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type OrganizationResendInvitePayloadKeySpecifier = (
  | 'errors'
  | 'membership'
  | 'successful'
  | OrganizationResendInvitePayloadKeySpecifier
)[]
export type OrganizationResendInvitePayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  membership?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type OrganizationSsoConfigKeySpecifier = (
  | 'attributeMapping'
  | 'config'
  | OrganizationSsoConfigKeySpecifier
)[]
export type OrganizationSsoConfigFieldPolicy = {
  attributeMapping?: FieldPolicy<any> | FieldReadFunction<any>
  config?: FieldPolicy<any> | FieldReadFunction<any>
}
export type OrganizationUpdateAttributeMappingPayloadKeySpecifier = (
  | 'errors'
  | 'organization'
  | 'successful'
  | OrganizationUpdateAttributeMappingPayloadKeySpecifier
)[]
export type OrganizationUpdateAttributeMappingPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  organization?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type OrganizationUpdateIdentityProviderConfigPayloadKeySpecifier = (
  | 'errors'
  | 'organization'
  | 'successful'
  | OrganizationUpdateIdentityProviderConfigPayloadKeySpecifier
)[]
export type OrganizationUpdateIdentityProviderConfigPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  organization?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type OrganizationUpdatePayloadKeySpecifier = (
  | 'errors'
  | 'organization'
  | 'successful'
  | OrganizationUpdatePayloadKeySpecifier
)[]
export type OrganizationUpdatePayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  organization?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type OrganizationUserKeySpecifier = (
  | 'avatar'
  | 'email'
  | 'id'
  | 'identifier'
  | 'name'
  | OrganizationUserKeySpecifier
)[]
export type OrganizationUserFieldPolicy = {
  avatar?: FieldPolicy<any> | FieldReadFunction<any>
  email?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
}
export type OutOfDateBaseVersionCatchUpKeySpecifier = (
  | 'compatibilityVersion'
  | 'latestVersionIdentifier'
  | OutOfDateBaseVersionCatchUpKeySpecifier
)[]
export type OutOfDateBaseVersionCatchUpFieldPolicy = {
  compatibilityVersion?: FieldPolicy<any> | FieldReadFunction<any>
  latestVersionIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PageKeySpecifier = (
  | 'annotationCount'
  | 'artboard'
  | 'artboardCount'
  | 'artboards'
  | 'frame'
  | 'frameCount'
  | 'frames'
  | 'hasUnreadComments'
  | 'id'
  | 'identifier'
  | 'name'
  | 'order'
  | 'presentationFile'
  | 'sections'
  | 'slug'
  | 'uuid'
  | PageKeySpecifier
)[]
export type PageFieldPolicy = {
  annotationCount?: FieldPolicy<any> | FieldReadFunction<any>
  artboard?: FieldPolicy<any> | FieldReadFunction<any>
  artboardCount?: FieldPolicy<any> | FieldReadFunction<any>
  artboards?: FieldPolicy<any> | FieldReadFunction<any>
  frame?: FieldPolicy<any> | FieldReadFunction<any>
  frameCount?: FieldPolicy<any> | FieldReadFunction<any>
  frames?: FieldPolicy<any> | FieldReadFunction<any>
  hasUnreadComments?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  order?: FieldPolicy<any> | FieldReadFunction<any>
  presentationFile?: FieldPolicy<any> | FieldReadFunction<any>
  sections?: FieldPolicy<any> | FieldReadFunction<any>
  slug?: FieldPolicy<any> | FieldReadFunction<any>
  uuid?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PagesKeySpecifier = ('entries' | 'meta' | PagesKeySpecifier)[]
export type PagesFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PaginationMetaKeySpecifier = (
  | 'after'
  | 'before'
  | 'limit'
  | 'totalCount'
  | PaginationMetaKeySpecifier
)[]
export type PaginationMetaFieldPolicy = {
  after?: FieldPolicy<any> | FieldReadFunction<any>
  before?: FieldPolicy<any> | FieldReadFunction<any>
  limit?: FieldPolicy<any> | FieldReadFunction<any>
  totalCount?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PaginationMetadataKeySpecifier = (
  | 'after'
  | 'limit'
  | 'totalCount'
  | PaginationMetadataKeySpecifier
)[]
export type PaginationMetadataFieldPolicy = {
  after?: FieldPolicy<any> | FieldReadFunction<any>
  limit?: FieldPolicy<any> | FieldReadFunction<any>
  totalCount?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ParentCommentKeySpecifier = (
  | 'identifier'
  | 'subscriptionStatus'
  | ParentCommentKeySpecifier
)[]
export type ParentCommentFieldPolicy = {
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  subscriptionStatus?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PartnerKeySpecifier = (
  | 'avatar'
  | 'email'
  | 'identifier'
  | 'name'
  | PartnerKeySpecifier
)[]
export type PartnerFieldPolicy = {
  avatar?: FieldPolicy<any> | FieldReadFunction<any>
  email?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PartnerBillingDetailsKeySpecifier = (
  | 'address'
  | 'collectionMethod'
  | 'email'
  | 'name'
  | 'taxId'
  | PartnerBillingDetailsKeySpecifier
)[]
export type PartnerBillingDetailsFieldPolicy = {
  address?: FieldPolicy<any> | FieldReadFunction<any>
  collectionMethod?: FieldPolicy<any> | FieldReadFunction<any>
  email?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  taxId?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PartnerBillingSummaryKeySpecifier = (
  | 'billingCycleAmount'
  | 'memberBillingCycleAmount'
  | 'partnerDiscount'
  | 'totalBillingCycleAmount'
  | PartnerBillingSummaryKeySpecifier
)[]
export type PartnerBillingSummaryFieldPolicy = {
  billingCycleAmount?: FieldPolicy<any> | FieldReadFunction<any>
  memberBillingCycleAmount?: FieldPolicy<any> | FieldReadFunction<any>
  partnerDiscount?: FieldPolicy<any> | FieldReadFunction<any>
  totalBillingCycleAmount?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PartnerCouponKeySpecifier = (
  | 'amountOff'
  | 'couponId'
  | 'name'
  | 'percentOff'
  | 'valid'
  | PartnerCouponKeySpecifier
)[]
export type PartnerCouponFieldPolicy = {
  amountOff?: FieldPolicy<any> | FieldReadFunction<any>
  couponId?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  percentOff?: FieldPolicy<any> | FieldReadFunction<any>
  valid?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PatchKeySpecifier = (
  | 'baseVersion'
  | 'id'
  | 'nextVersion'
  | 'payload'
  | 'seq'
  | PatchKeySpecifier
)[]
export type PatchFieldPolicy = {
  baseVersion?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  nextVersion?: FieldPolicy<any> | FieldReadFunction<any>
  payload?: FieldPolicy<any> | FieldReadFunction<any>
  seq?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PathComponentInfoKeySpecifier = (
  | 'id'
  | 'name'
  | PathComponentInfoKeySpecifier
)[]
export type PathComponentInfoFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PaymentDetailsKeySpecifier = ('type' | PaymentDetailsKeySpecifier)[]
export type PaymentDetailsFieldPolicy = {
  type?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PaymentMethodConvertedToInvoiceAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'version'
  | PaymentMethodConvertedToInvoiceAuditKeySpecifier
)[]
export type PaymentMethodConvertedToInvoiceAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PaymentsPartnerKeySpecifier = (
  | 'billingDetails'
  | 'id'
  | 'stripeCouponId'
  | PaymentsPartnerKeySpecifier
)[]
export type PaymentsPartnerFieldPolicy = {
  billingDetails?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  stripeCouponId?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PermissionGroupKeySpecifier = (
  | 'identifier'
  | 'members'
  | 'name'
  | 'projects'
  | 'shares'
  | PermissionGroupKeySpecifier
)[]
export type PermissionGroupFieldPolicy = {
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  members?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  projects?: FieldPolicy<any> | FieldReadFunction<any>
  shares?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PermissionGroupMembershipKeySpecifier = (
  | 'identifier'
  | 'permissionGroup'
  | 'workspaceMember'
  | PermissionGroupMembershipKeySpecifier
)[]
export type PermissionGroupMembershipFieldPolicy = {
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceMember?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PermissionGroupMembershipsKeySpecifier = (
  | 'entries'
  | 'meta'
  | PermissionGroupMembershipsKeySpecifier
)[]
export type PermissionGroupMembershipsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PermissionGroupRelationProjectKeySpecifier = (
  | 'accessLevel'
  | 'createdAt'
  | 'identifier'
  | 'permissionGroup'
  | 'project'
  | PermissionGroupRelationProjectKeySpecifier
)[]
export type PermissionGroupRelationProjectFieldPolicy = {
  accessLevel?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PermissionGroupRelationProjectsKeySpecifier = (
  | 'entries'
  | 'meta'
  | PermissionGroupRelationProjectsKeySpecifier
)[]
export type PermissionGroupRelationProjectsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PermissionGroupRelationShareKeySpecifier = (
  | 'accessLevel'
  | 'createdAt'
  | 'identifier'
  | 'permissionGroup'
  | 'share'
  | PermissionGroupRelationShareKeySpecifier
)[]
export type PermissionGroupRelationShareFieldPolicy = {
  accessLevel?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PermissionGroupRelationSharesKeySpecifier = (
  | 'entries'
  | 'meta'
  | PermissionGroupRelationSharesKeySpecifier
)[]
export type PermissionGroupRelationSharesFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PermissionGroupsKeySpecifier = (
  | 'entries'
  | 'meta'
  | PermissionGroupsKeySpecifier
)[]
export type PermissionGroupsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PermissionsKeySpecifier = (
  | 'audience'
  | 'categories'
  | 'roles'
  | PermissionsKeySpecifier
)[]
export type PermissionsFieldPolicy = {
  audience?: FieldPolicy<any> | FieldReadFunction<any>
  categories?: FieldPolicy<any> | FieldReadFunction<any>
  roles?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PinProjectResponseKeySpecifier = (
  | 'project'
  | PinProjectResponseKeySpecifier
)[]
export type PinProjectResponseFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PinShareResponseKeySpecifier = (
  | 'share'
  | PinShareResponseKeySpecifier
)[]
export type PinShareResponseFieldPolicy = {
  share?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PlanUpdateSimulationKeySpecifier = (
  | 'couponInfo'
  | 'extraSeatsAmount'
  | 'extraSeatsPrice'
  | 'monthlyAmount'
  | 'price'
  | 'prorated'
  | 'totalAmount'
  | PlanUpdateSimulationKeySpecifier
)[]
export type PlanUpdateSimulationFieldPolicy = {
  couponInfo?: FieldPolicy<any> | FieldReadFunction<any>
  extraSeatsAmount?: FieldPolicy<any> | FieldReadFunction<any>
  extraSeatsPrice?: FieldPolicy<any> | FieldReadFunction<any>
  monthlyAmount?: FieldPolicy<any> | FieldReadFunction<any>
  price?: FieldPolicy<any> | FieldReadFunction<any>
  prorated?: FieldPolicy<any> | FieldReadFunction<any>
  totalAmount?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PresentationFileKeySpecifier = (
  | 'downloadUrl'
  | 'imageToken'
  | 'manifestUrl'
  | PresentationFileKeySpecifier
)[]
export type PresentationFileFieldPolicy = {
  downloadUrl?: FieldPolicy<any> | FieldReadFunction<any>
  imageToken?: FieldPolicy<any> | FieldReadFunction<any>
  manifestUrl?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PreviewKeySpecifier = (
  | 'commentsEnabled'
  | 'description'
  | 'expiryDate'
  | 'identifier'
  | 'inspectEnabled'
  | 'mentionableUsers'
  | 'name'
  | 'page'
  | 'pages'
  | 'passwordProtected'
  | 'presentationStatus'
  | 'prototypes'
  | PreviewKeySpecifier
)[]
export type PreviewFieldPolicy = {
  commentsEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  description?: FieldPolicy<any> | FieldReadFunction<any>
  expiryDate?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  inspectEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  mentionableUsers?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  page?: FieldPolicy<any> | FieldReadFunction<any>
  pages?: FieldPolicy<any> | FieldReadFunction<any>
  passwordProtected?: FieldPolicy<any> | FieldReadFunction<any>
  presentationStatus?: FieldPolicy<any> | FieldReadFunction<any>
  prototypes?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PreviewCreatedEventKeySpecifier = (
  | 'preview'
  | PreviewCreatedEventKeySpecifier
)[]
export type PreviewCreatedEventFieldPolicy = {
  preview?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PreviewDeletedEventKeySpecifier = (
  | 'preview'
  | PreviewDeletedEventKeySpecifier
)[]
export type PreviewDeletedEventFieldPolicy = {
  preview?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PreviewUpdatedEventKeySpecifier = (
  | 'preview'
  | PreviewUpdatedEventKeySpecifier
)[]
export type PreviewUpdatedEventFieldPolicy = {
  preview?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PriceKeySpecifier = ('amount' | 'currency' | PriceKeySpecifier)[]
export type PriceFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>
  currency?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectKeySpecifier = (
  | 'archivedAt'
  | 'collection'
  | 'collections'
  | 'collectionsUnpaginated'
  | 'createdAt'
  | 'deletedAt'
  | 'description'
  | 'id'
  | 'identifier'
  | 'isOptimistic'
  | 'members'
  | 'membershipCount'
  | 'memberships'
  | 'name'
  | 'nestedProjectsCount'
  | 'parentProject'
  | 'parentProjectIdentifier'
  | 'parentProjects'
  | 'permissionGroupRelations'
  | 'pinnedByCurrentUserAt'
  | 'previews'
  | 'privacyIcon'
  | 'projectPrivacyIcon'
  | 'projects'
  | 'projectsUnpaginated'
  | 'projectType'
  | 'shares'
  | 'sharesCount'
  | 'shortId'
  | 'storageItems'
  | 'topLevelProject'
  | 'type'
  | 'updatedAt'
  | 'userCanLeave'
  | 'userMembership'
  | 'workspace'
  | 'workspaceAccessLevel'
  | ProjectKeySpecifier
)[]
export type ProjectFieldPolicy = {
  archivedAt?: FieldPolicy<any> | FieldReadFunction<any>
  collection?: FieldPolicy<any> | FieldReadFunction<any>
  collections?: FieldPolicy<any> | FieldReadFunction<any>
  collectionsUnpaginated?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  deletedAt?: FieldPolicy<any> | FieldReadFunction<any>
  description?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isOptimistic?: FieldPolicy<any> | FieldReadFunction<any>
  members?: FieldPolicy<any> | FieldReadFunction<any>
  membershipCount?: FieldPolicy<any> | FieldReadFunction<any>
  memberships?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  nestedProjectsCount?: FieldPolicy<any> | FieldReadFunction<any>
  parentProject?: FieldPolicy<any> | FieldReadFunction<any>
  parentProjectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  parentProjects?: FieldPolicy<any> | FieldReadFunction<any>
  permissionGroupRelations?: FieldPolicy<any> | FieldReadFunction<any>
  pinnedByCurrentUserAt?: FieldPolicy<any> | FieldReadFunction<any>
  previews?: FieldPolicy<any> | FieldReadFunction<any>
  privacyIcon?: FieldPolicy<any> | FieldReadFunction<any>
  projectPrivacyIcon?: FieldPolicy<any> | FieldReadFunction<any>
  projects?: FieldPolicy<any> | FieldReadFunction<any>
  projectsUnpaginated?: FieldPolicy<any> | FieldReadFunction<any>
  projectType?: FieldPolicy<any> | FieldReadFunction<any>
  shares?: FieldPolicy<any> | FieldReadFunction<any>
  sharesCount?: FieldPolicy<any> | FieldReadFunction<any>
  shortId?: FieldPolicy<any> | FieldReadFunction<any>
  storageItems?: FieldPolicy<any> | FieldReadFunction<any>
  topLevelProject?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
  userCanLeave?: FieldPolicy<any> | FieldReadFunction<any>
  userMembership?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceAccessLevel?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectAccessGrantedEventKeySpecifier = (
  | 'project'
  | 'workspaceIdentifier'
  | ProjectAccessGrantedEventKeySpecifier
)[]
export type ProjectAccessGrantedEventFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectAccessRevokedEventKeySpecifier = (
  | 'project'
  | 'workspaceIdentifier'
  | ProjectAccessRevokedEventKeySpecifier
)[]
export type ProjectAccessRevokedEventFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectArchivedEventKeySpecifier = (
  | 'oldParentProjectIdentifier'
  | 'project'
  | 'projectIdentifier'
  | 'workspaceIdentifier'
  | ProjectArchivedEventKeySpecifier
)[]
export type ProjectArchivedEventFieldPolicy = {
  oldParentProjectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  projectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectChangedEventKeySpecifier = (
  | 'project'
  | 'projectIdentifier'
  | 'workspaceIdentifier'
  | ProjectChangedEventKeySpecifier
)[]
export type ProjectChangedEventFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
  projectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectCreatedEventKeySpecifier = (
  | 'project'
  | 'projectIdentifier'
  | 'workspaceIdentifier'
  | ProjectCreatedEventKeySpecifier
)[]
export type ProjectCreatedEventFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
  projectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectCreatePayloadKeySpecifier = (
  | 'errors'
  | 'project'
  | 'successful'
  | ProjectCreatePayloadKeySpecifier
)[]
export type ProjectCreatePayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectDeletedEventKeySpecifier = (
  | 'project'
  | 'projectIdentifier'
  | 'workspaceIdentifier'
  | ProjectDeletedEventKeySpecifier
)[]
export type ProjectDeletedEventFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
  projectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectDeletePayloadKeySpecifier = (
  | 'errors'
  | 'project'
  | 'successful'
  | ProjectDeletePayloadKeySpecifier
)[]
export type ProjectDeletePayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectMemberAddedEventKeySpecifier = (
  | 'membership'
  | 'project'
  | 'projectIdentifier'
  | 'workspaceIdentifier'
  | ProjectMemberAddedEventKeySpecifier
)[]
export type ProjectMemberAddedEventFieldPolicy = {
  membership?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  projectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectMemberChangedEventKeySpecifier = (
  | 'membership'
  | 'project'
  | 'projectIdentifier'
  | 'workspaceIdentifier'
  | ProjectMemberChangedEventKeySpecifier
)[]
export type ProjectMemberChangedEventFieldPolicy = {
  membership?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  projectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectMemberRemovedEventKeySpecifier = (
  | 'membershipIdentifier'
  | 'project'
  | 'projectIdentifier'
  | 'workspaceIdentifier'
  | ProjectMemberRemovedEventKeySpecifier
)[]
export type ProjectMemberRemovedEventFieldPolicy = {
  membershipIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  projectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectMembershipKeySpecifier = (
  | 'email'
  | 'guestCommentsEnabled'
  | 'guestInspectEnabled'
  | 'identifier'
  | 'inviter'
  | 'inviteStatus'
  | 'privateAccessLevel'
  | 'project'
  | 'workspaceMembership'
  | ProjectMembershipKeySpecifier
)[]
export type ProjectMembershipFieldPolicy = {
  email?: FieldPolicy<any> | FieldReadFunction<any>
  guestCommentsEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  guestInspectEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  inviter?: FieldPolicy<any> | FieldReadFunction<any>
  inviteStatus?: FieldPolicy<any> | FieldReadFunction<any>
  privateAccessLevel?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceMembership?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectMembershipPaginationItemsKeySpecifier = (
  | 'entries'
  | 'meta'
  | ProjectMembershipPaginationItemsKeySpecifier
)[]
export type ProjectMembershipPaginationItemsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectMembershipsKeySpecifier = (
  | 'entries'
  | 'meta'
  | ProjectMembershipsKeySpecifier
)[]
export type ProjectMembershipsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectPermanentlyDeletedEventKeySpecifier = (
  | 'projectIdentifier'
  | 'workspaceIdentifier'
  | ProjectPermanentlyDeletedEventKeySpecifier
)[]
export type ProjectPermanentlyDeletedEventFieldPolicy = {
  projectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectRenamePayloadKeySpecifier = (
  | 'errors'
  | 'project'
  | 'successful'
  | ProjectRenamePayloadKeySpecifier
)[]
export type ProjectRenamePayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectRestoredEventKeySpecifier = (
  | 'project'
  | 'projectIdentifier'
  | 'workspaceIdentifier'
  | ProjectRestoredEventKeySpecifier
)[]
export type ProjectRestoredEventFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
  projectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectsKeySpecifier = ('entries' | 'meta' | ProjectsKeySpecifier)[]
export type ProjectsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectSharePreviewKeySpecifier = (
  | 'file'
  | 'name'
  | 'shareIdentifier'
  | ProjectSharePreviewKeySpecifier
)[]
export type ProjectSharePreviewFieldPolicy = {
  file?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  shareIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectTransferredEventKeySpecifier = (
  | 'oldParentProjectIdentifier'
  | 'oldSource'
  | 'oldWorkspaceIdentifier'
  | 'project'
  | 'projectIdentifier'
  | 'workspaceIdentifier'
  | ProjectTransferredEventKeySpecifier
)[]
export type ProjectTransferredEventFieldPolicy = {
  oldParentProjectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  oldSource?: FieldPolicy<any> | FieldReadFunction<any>
  oldWorkspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  projectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectUnarchivedEventKeySpecifier = (
  | 'project'
  | 'projectIdentifier'
  | 'workspaceIdentifier'
  | ProjectUnarchivedEventKeySpecifier
)[]
export type ProjectUnarchivedEventFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
  projectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ProjectWorkspaceAccessLevelChangedEventKeySpecifier = (
  | 'project'
  | 'projectIdentifier'
  | 'workspaceIdentifier'
  | ProjectWorkspaceAccessLevelChangedEventKeySpecifier
)[]
export type ProjectWorkspaceAccessLevelChangedEventFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
  projectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PublicationKeySpecifier = (
  | 'createdAt'
  | 'identifier'
  | 'previewFile'
  | 'share'
  | 'totalHearts'
  | 'updatedAt'
  | 'userReaction'
  | 'workspaceProfile'
  | PublicationKeySpecifier
)[]
export type PublicationFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  previewFile?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  totalHearts?: FieldPolicy<any> | FieldReadFunction<any>
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
  userReaction?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceProfile?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PublicationListingKeySpecifier = (
  | 'modifiers'
  | 'preferences'
  | 'title'
  | PublicationListingKeySpecifier
)[]
export type PublicationListingFieldPolicy = {
  modifiers?: FieldPolicy<any> | FieldReadFunction<any>
  preferences?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PublicationQueryPreferencesKeySpecifier = (
  | 'allowPagination'
  | 'documentType'
  | 'exclude'
  | 'include'
  | 'limit'
  | 'period'
  | 'search'
  | 'sort'
  | PublicationQueryPreferencesKeySpecifier
)[]
export type PublicationQueryPreferencesFieldPolicy = {
  allowPagination?: FieldPolicy<any> | FieldReadFunction<any>
  documentType?: FieldPolicy<any> | FieldReadFunction<any>
  exclude?: FieldPolicy<any> | FieldReadFunction<any>
  include?: FieldPolicy<any> | FieldReadFunction<any>
  limit?: FieldPolicy<any> | FieldReadFunction<any>
  period?: FieldPolicy<any> | FieldReadFunction<any>
  search?: FieldPolicy<any> | FieldReadFunction<any>
  sort?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PublicationReactionsUpdatedEventKeySpecifier = (
  | 'publication'
  | PublicationReactionsUpdatedEventKeySpecifier
)[]
export type PublicationReactionsUpdatedEventFieldPolicy = {
  publication?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PublicationsKeySpecifier = (
  | 'entries'
  | 'meta'
  | PublicationsKeySpecifier
)[]
export type PublicationsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PublicOrganizationKeySpecifier = (
  | 'avatar'
  | 'id'
  | 'identifier'
  | 'name'
  | 'shortId'
  | 'ssoStartUrl'
  | 'userIsMember'
  | 'viewerIsMember'
  | PublicOrganizationKeySpecifier
)[]
export type PublicOrganizationFieldPolicy = {
  avatar?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  shortId?: FieldPolicy<any> | FieldReadFunction<any>
  ssoStartUrl?: FieldPolicy<any> | FieldReadFunction<any>
  userIsMember?: FieldPolicy<any> | FieldReadFunction<any>
  viewerIsMember?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PublicProjectKeySpecifier = (
  | 'identifier'
  | 'name'
  | 'workspace'
  | 'workspaceAccessLevel'
  | PublicProjectKeySpecifier
)[]
export type PublicProjectFieldPolicy = {
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceAccessLevel?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PublicProjectMembershipKeySpecifier = (
  | 'email'
  | 'guestCommentsEnabled'
  | 'guestInspectEnabled'
  | 'identifier'
  | 'inviter'
  | 'inviteStatus'
  | 'privateAccessLevel'
  | 'project'
  | PublicProjectMembershipKeySpecifier
)[]
export type PublicProjectMembershipFieldPolicy = {
  email?: FieldPolicy<any> | FieldReadFunction<any>
  guestCommentsEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  guestInspectEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  inviter?: FieldPolicy<any> | FieldReadFunction<any>
  inviteStatus?: FieldPolicy<any> | FieldReadFunction<any>
  privateAccessLevel?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PublicUserKeySpecifier = (
  | 'avatar'
  | 'id'
  | 'identifier'
  | 'name'
  | PublicUserKeySpecifier
)[]
export type PublicUserFieldPolicy = {
  avatar?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PublicWorkspaceKeySpecifier = (
  | 'avatar'
  | 'customer'
  | 'features'
  | 'identifier'
  | 'name'
  | 'profile'
  | 'type'
  | 'userIsMember'
  | 'userIsOwner'
  | 'userRole'
  | PublicWorkspaceKeySpecifier
)[]
export type PublicWorkspaceFieldPolicy = {
  avatar?: FieldPolicy<any> | FieldReadFunction<any>
  customer?: FieldPolicy<any> | FieldReadFunction<any>
  features?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  profile?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  userIsMember?: FieldPolicy<any> | FieldReadFunction<any>
  userIsOwner?: FieldPolicy<any> | FieldReadFunction<any>
  userRole?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PublicWorkspaceCustomerKeySpecifier = (
  | 'canUseSso'
  | 'identifier'
  | 'ssoConfig'
  | 'ssoEnabled'
  | 'ssoShortName'
  | 'ssoStartUrl'
  | 'workspaces'
  | PublicWorkspaceCustomerKeySpecifier
)[]
export type PublicWorkspaceCustomerFieldPolicy = {
  canUseSso?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  ssoConfig?: FieldPolicy<any> | FieldReadFunction<any>
  ssoEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  ssoShortName?: FieldPolicy<any> | FieldReadFunction<any>
  ssoStartUrl?: FieldPolicy<any> | FieldReadFunction<any>
  workspaces?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PublicWorkspaceFeaturesKeySpecifier = (
  | 'accountLinkingEnabled'
  | 'encryptionEnabled'
  | PublicWorkspaceFeaturesKeySpecifier
)[]
export type PublicWorkspaceFeaturesFieldPolicy = {
  accountLinkingEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  encryptionEnabled?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PublicWorkspaceMembershipKeySpecifier = (
  | 'acceptedAt'
  | 'identifier'
  | 'invite'
  | 'inviter'
  | 'isEditor'
  | 'role'
  | 'user'
  | 'workspace'
  | PublicWorkspaceMembershipKeySpecifier
)[]
export type PublicWorkspaceMembershipFieldPolicy = {
  acceptedAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  invite?: FieldPolicy<any> | FieldReadFunction<any>
  inviter?: FieldPolicy<any> | FieldReadFunction<any>
  isEditor?: FieldPolicy<any> | FieldReadFunction<any>
  role?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PublicWorkspaceProfileKeySpecifier = (
  | 'description'
  | 'donateUrl'
  | 'identifier'
  | 'isPublic'
  | 'shortUrlName'
  | 'websiteUrl'
  | PublicWorkspaceProfileKeySpecifier
)[]
export type PublicWorkspaceProfileFieldPolicy = {
  description?: FieldPolicy<any> | FieldReadFunction<any>
  donateUrl?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isPublic?: FieldPolicy<any> | FieldReadFunction<any>
  shortUrlName?: FieldPolicy<any> | FieldReadFunction<any>
  websiteUrl?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PublicWorkspacesKeySpecifier = (
  | 'entries'
  | 'meta'
  | PublicWorkspacesKeySpecifier
)[]
export type PublicWorkspacesFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PublishShareResponseKeySpecifier = (
  | 'publication'
  | PublishShareResponseKeySpecifier
)[]
export type PublishShareResponseFieldPolicy = {
  publication?: FieldPolicy<any> | FieldReadFunction<any>
}
export type PurchaseRestrictionKeySpecifier = (
  | 'countryCode'
  | 'reason'
  | PurchaseRestrictionKeySpecifier
)[]
export type PurchaseRestrictionFieldPolicy = {
  countryCode?: FieldPolicy<any> | FieldReadFunction<any>
  reason?: FieldPolicy<any> | FieldReadFunction<any>
}
export type QueryKeySpecifier = (
  | 'availableCloudPlans'
  | 'currencies'
  | 'customer'
  | 'draftBillingSummary'
  | 'licensePlan'
  | 'partnerBillingDetails'
  | 'seatsUpdateBillingSimulation'
  | 'subscriptionUpdateBillingSimulation'
  | 'taxableCountries'
  | QueryKeySpecifier
)[]
export type QueryFieldPolicy = {
  availableCloudPlans?: FieldPolicy<any> | FieldReadFunction<any>
  currencies?: FieldPolicy<any> | FieldReadFunction<any>
  customer?: FieldPolicy<any> | FieldReadFunction<any>
  draftBillingSummary?: FieldPolicy<any> | FieldReadFunction<any>
  licensePlan?: FieldPolicy<any> | FieldReadFunction<any>
  partnerBillingDetails?: FieldPolicy<any> | FieldReadFunction<any>
  seatsUpdateBillingSimulation?: FieldPolicy<any> | FieldReadFunction<any>
  subscriptionUpdateBillingSimulation?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  taxableCountries?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ReactivateSubscriptionResponseKeySpecifier = (
  | 'customer'
  | ReactivateSubscriptionResponseKeySpecifier
)[]
export type ReactivateSubscriptionResponseFieldPolicy = {
  customer?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RecoveryCodesKeySpecifier = (
  | 'entries'
  | RecoveryCodesKeySpecifier
)[]
export type RecoveryCodesFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RefreshAllPreviewsResponseKeySpecifier = (
  | 'workspace'
  | RefreshAllPreviewsResponseKeySpecifier
)[]
export type RefreshAllPreviewsResponseFieldPolicy = {
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RejectEducationRequestAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'educationRequest'
  | 'rejectReason'
  | 'version'
  | RejectEducationRequestAuditKeySpecifier
)[]
export type RejectEducationRequestAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  educationRequest?: FieldPolicy<any> | FieldReadFunction<any>
  rejectReason?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RemoteCollaborativePatchKeySpecifier = (
  | 'baseVersionIdentifier'
  | 'id'
  | 'nextVersionIdentifier'
  | 'payloadUrl'
  | 'seq'
  | 'shareIdentifier'
  | RemoteCollaborativePatchKeySpecifier
)[]
export type RemoteCollaborativePatchFieldPolicy = {
  baseVersionIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  nextVersionIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  payloadUrl?: FieldPolicy<any> | FieldReadFunction<any>
  seq?: FieldPolicy<any> | FieldReadFunction<any>
  shareIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RemoteMigrationCatchUpKeySpecifier = (
  | 'shareIdentifier'
  | RemoteMigrationCatchUpKeySpecifier
)[]
export type RemoteMigrationCatchUpFieldPolicy = {
  shareIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RemotePatchUploadRequestKeySpecifier = (
  | 'uploadIdentifier'
  | 'uploadUrl'
  | RemotePatchUploadRequestKeySpecifier
)[]
export type RemotePatchUploadRequestFieldPolicy = {
  uploadIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  uploadUrl?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RemoveIntegrationIdentityResponseKeySpecifier = (
  | 'integrationIdentity'
  | RemoveIntegrationIdentityResponseKeySpecifier
)[]
export type RemoveIntegrationIdentityResponseFieldPolicy = {
  integrationIdentity?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RemoveIntegrationResponseKeySpecifier = (
  | 'integration'
  | RemoveIntegrationResponseKeySpecifier
)[]
export type RemoveIntegrationResponseFieldPolicy = {
  integration?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RemoveMemberPermissionGroupKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'member'
  | 'permissionGroup'
  | 'version'
  | RemoveMemberPermissionGroupKeySpecifier
)[]
export type RemoveMemberPermissionGroupFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  member?: FieldPolicy<any> | FieldReadFunction<any>
  permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RemovePermissionGroupMemberResponseKeySpecifier = (
  | 'permissionGroup'
  | RemovePermissionGroupMemberResponseKeySpecifier
)[]
export type RemovePermissionGroupMemberResponseFieldPolicy = {
  permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RemovePermissionGroupRelationKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'name'
  | 'permissionGroup'
  | 'project'
  | 'share'
  | 'version'
  | RemovePermissionGroupRelationKeySpecifier
)[]
export type RemovePermissionGroupRelationFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RemovePermissionGroupRelationResponseKeySpecifier = (
  | 'permissionGroup'
  | 'project'
  | 'share'
  | RemovePermissionGroupRelationResponseKeySpecifier
)[]
export type RemovePermissionGroupRelationResponseFieldPolicy = {
  permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RemoveProjectMemberResponseKeySpecifier = (
  | 'project'
  | RemoveProjectMemberResponseKeySpecifier
)[]
export type RemoveProjectMemberResponseFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RemoveSharesFromCollectionResponseKeySpecifier = (
  | 'collection'
  | RemoveSharesFromCollectionResponseKeySpecifier
)[]
export type RemoveSharesFromCollectionResponseFieldPolicy = {
  collection?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RemoveWorkspaceMemberResponseKeySpecifier = (
  | 'workspace'
  | RemoveWorkspaceMemberResponseKeySpecifier
)[]
export type RemoveWorkspaceMemberResponseFieldPolicy = {
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RenameCollectionResponseKeySpecifier = (
  | 'collection'
  | RenameCollectionResponseKeySpecifier
)[]
export type RenameCollectionResponseFieldPolicy = {
  collection?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RenderDownloadableAssetsPayloadKeySpecifier = (
  | 'downloadableAsset'
  | 'errors'
  | 'successful'
  | RenderDownloadableAssetsPayloadKeySpecifier
)[]
export type RenderDownloadableAssetsPayloadFieldPolicy = {
  downloadableAsset?: FieldPolicy<any> | FieldReadFunction<any>
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RenderPresentationResponseKeySpecifier = (
  | 'presentationStatus'
  | RenderPresentationResponseKeySpecifier
)[]
export type RenderPresentationResponseFieldPolicy = {
  presentationStatus?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ReportShareResponseKeySpecifier = (
  | 'reported'
  | ReportShareResponseKeySpecifier
)[]
export type ReportShareResponseFieldPolicy = {
  reported?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RequestAccessToProjectResponseKeySpecifier = (
  | 'projectIdentifier'
  | RequestAccessToProjectResponseKeySpecifier
)[]
export type RequestAccessToProjectResponseFieldPolicy = {
  projectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RequestInfoEducationRequestAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'educationRequest'
  | 'infoRequestReason'
  | 'version'
  | RequestInfoEducationRequestAuditKeySpecifier
)[]
export type RequestInfoEducationRequestAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  educationRequest?: FieldPolicy<any> | FieldReadFunction<any>
  infoRequestReason?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ResendVerificationEmailPayloadKeySpecifier = (
  | 'errors'
  | 'successful'
  | ResendVerificationEmailPayloadKeySpecifier
)[]
export type ResendVerificationEmailPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ResendWorkspaceInviteResponseKeySpecifier = (
  | 'membership'
  | ResendWorkspaceInviteResponseKeySpecifier
)[]
export type ResendWorkspaceInviteResponseFieldPolicy = {
  membership?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ResetScimTokenAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'version'
  | ResetScimTokenAuditKeySpecifier
)[]
export type ResetScimTokenAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ResetScimTokenResponseKeySpecifier = (
  | 'scimToken'
  | 'workspace'
  | ResetScimTokenResponseKeySpecifier
)[]
export type ResetScimTokenResponseFieldPolicy = {
  scimToken?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ResolveAnnotationResponseKeySpecifier = (
  | 'annotation'
  | ResolveAnnotationResponseKeySpecifier
)[]
export type ResolveAnnotationResponseFieldPolicy = {
  annotation?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ResponsiveImageKeySpecifier = (
  | 'alt'
  | 'source'
  | ResponsiveImageKeySpecifier
)[]
export type ResponsiveImageFieldPolicy = {
  alt?: FieldPolicy<any> | FieldReadFunction<any>
  source?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ResponsiveSourceKeySpecifier = (
  | 'lg'
  | 'md'
  | 'sm'
  | 'xl'
  | 'xs'
  | ResponsiveSourceKeySpecifier
)[]
export type ResponsiveSourceFieldPolicy = {
  lg?: FieldPolicy<any> | FieldReadFunction<any>
  md?: FieldPolicy<any> | FieldReadFunction<any>
  sm?: FieldPolicy<any> | FieldReadFunction<any>
  xl?: FieldPolicy<any> | FieldReadFunction<any>
  xs?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RestoreMembershipAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'auditSource'
  | 'consumedSeat'
  | 'createdAt'
  | 'role'
  | 'user'
  | 'userEmail'
  | 'version'
  | RestoreMembershipAuditKeySpecifier
)[]
export type RestoreMembershipAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  auditSource?: FieldPolicy<any> | FieldReadFunction<any>
  consumedSeat?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  role?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  userEmail?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RestoreProjectResponseKeySpecifier = (
  | 'project'
  | RestoreProjectResponseKeySpecifier
)[]
export type RestoreProjectResponseFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RestoreShareResponseKeySpecifier = (
  | 'share'
  | RestoreShareResponseKeySpecifier
)[]
export type RestoreShareResponseFieldPolicy = {
  share?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RevisionKeySpecifier = (
  | 'artboard'
  | 'artboardId'
  | 'artboardShortId'
  | 'createdAfterVersioning'
  | 'createdAt'
  | 'creator'
  | 'frame'
  | 'id'
  | 'identifier'
  | 'kind'
  | 'order'
  | 'updatedAt'
  | 'userIsCreator'
  | 'version'
  | 'viewerIsCreator'
  | RevisionKeySpecifier
)[]
export type RevisionFieldPolicy = {
  artboard?: FieldPolicy<any> | FieldReadFunction<any>
  artboardId?: FieldPolicy<any> | FieldReadFunction<any>
  artboardShortId?: FieldPolicy<any> | FieldReadFunction<any>
  createdAfterVersioning?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  creator?: FieldPolicy<any> | FieldReadFunction<any>
  frame?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  kind?: FieldPolicy<any> | FieldReadFunction<any>
  order?: FieldPolicy<any> | FieldReadFunction<any>
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
  userIsCreator?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
  viewerIsCreator?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RevisionDeletedKeySpecifier = (
  | 'artboardIdentifier'
  | 'createdAt'
  | 'creator'
  | 'deletedAt'
  | 'frameIdentifier'
  | 'identifier'
  | 'order'
  | 'updatedAt'
  | 'userIsCreator'
  | RevisionDeletedKeySpecifier
)[]
export type RevisionDeletedFieldPolicy = {
  artboardIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  creator?: FieldPolicy<any> | FieldReadFunction<any>
  deletedAt?: FieldPolicy<any> | FieldReadFunction<any>
  frameIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  order?: FieldPolicy<any> | FieldReadFunction<any>
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
  userIsCreator?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RevisionMovedEventKeySpecifier = (
  | 'previousArtboardIdentifier'
  | 'previousFrameIdentifier'
  | 'revision'
  | RevisionMovedEventKeySpecifier
)[]
export type RevisionMovedEventFieldPolicy = {
  previousArtboardIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  previousFrameIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  revision?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RevisionUnavailableKeySpecifier = (
  | 'createdAt'
  | 'creator'
  | 'identifier'
  | 'order'
  | 'userIsCreator'
  | RevisionUnavailableKeySpecifier
)[]
export type RevisionUnavailableFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  creator?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  order?: FieldPolicy<any> | FieldReadFunction<any>
  userIsCreator?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RevokeActiveSessionsPayloadKeySpecifier = (
  | 'errors'
  | 'successful'
  | RevokeActiveSessionsPayloadKeySpecifier
)[]
export type RevokeActiveSessionsPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RevokeOAuthResponseKeySpecifier = (
  | 'successful'
  | RevokeOAuthResponseKeySpecifier
)[]
export type RevokeOAuthResponseFieldPolicy = {
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RevokeSessionPayloadKeySpecifier = (
  | 'errors'
  | 'successful'
  | RevokeSessionPayloadKeySpecifier
)[]
export type RevokeSessionPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RGBAColorKeySpecifier = (
  | 'alpha'
  | 'blue'
  | 'green'
  | 'red'
  | RGBAColorKeySpecifier
)[]
export type RGBAColorFieldPolicy = {
  alpha?: FieldPolicy<any> | FieldReadFunction<any>
  blue?: FieldPolicy<any> | FieldReadFunction<any>
  green?: FieldPolicy<any> | FieldReadFunction<any>
  red?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RootMutationTypeKeySpecifier = (
  | 'acceptPartnershipInvite'
  | 'acceptProjectAccessRequest'
  | 'acceptProjectMembershipInvitation'
  | 'acceptShareMembershipInvitation'
  | 'acceptWorkspaceInvite'
  | 'addPermissionGroupMembers'
  | 'addPermissionGroupRelation'
  | 'addProjectMember'
  | 'addProjectPermissionGroupRelation'
  | 'addReactionToPublication'
  | 'addShareMembership'
  | 'addSharePermissionGroupRelation'
  | 'addSharesToCollection'
  | 'agreeToWorkspaceCustomerTermsOfService'
  | 'applyCoupon'
  | 'archiveProject'
  | 'archiveStorageItem'
  | 'archiveStorageItems'
  | 'cancelScheduledBillingSeats'
  | 'cancelSubscription'
  | 'changePlan'
  | 'checkWorkspaceProfileShortUrl'
  | 'collaborativeEdit'
  | 'collaborativeEditingSessionCreate'
  | 'collaborativeEditingSessionMigrateDocument'
  | 'collaborativeEditingSessionResetDocument'
  | 'collaborativeShareCreate'
  | 'collaborativeShareCreateMigratedVersion'
  | 'collaborativeShareCreateResetVersion'
  | 'collaborativeShareInitialDocumentUploadComplete'
  | 'collaborativeShareInitialDocumentUploadStart'
  | 'collaborativeShareMigratedDocumentUploadComplete'
  | 'collaborativeShareMigratedDocumentUploadStart'
  | 'collaborativeShareResetDocumentUploadComplete'
  | 'collaborativeShareResetDocumentUploadStart'
  | 'configureWorkspaceEncryptionKeys'
  | 'confirmAppStorePurchase'
  | 'confirmMfaSetup'
  | 'createAnnotation'
  | 'createAnnotationReply'
  | 'createCollaborativeVersion'
  | 'createCollection'
  | 'createInstitutionApplication'
  | 'createOrganizationProject'
  | 'createPartnerWorkspace'
  | 'createPermissionGroup'
  | 'createPreview'
  | 'createPreviewAnnotation'
  | 'createSetupIntent'
  | 'createStudentApplication'
  | 'createTeacherApplication'
  | 'createUserProject'
  | 'createWorkspace'
  | 'createWorkspaceProfile'
  | 'createWorkspaceProject'
  | 'createWorkspaceShare'
  | 'deleteAllPreviews'
  | 'deleteAnnotation'
  | 'deleteAnnotationReply'
  | 'deleteCollection'
  | 'deletePermissionGroup'
  | 'deletePreview'
  | 'deletePreviousShareVersions'
  | 'deleteProject'
  | 'deleteProjectPermanently'
  | 'deleteSharePermanently'
  | 'deleteStorageItem'
  | 'deleteStorageItems'
  | 'deleteWorkspace'
  | 'deleteWorkspaceAvatar'
  | 'disableMfa'
  | 'disableScim'
  | 'disableSupportAccess'
  | 'documentUploadCancel'
  | 'documentUploadComplete'
  | 'documentUploadStart'
  | 'duplicateShareTo'
  | 'duplicateShareToDrafts'
  | 'editCollection'
  | 'editCollectionDescription'
  | 'editComment'
  | 'editComponents'
  | 'emailResendChangeConfirmation'
  | 'emailUpdate'
  | 'emailVerify'
  | 'emptyWorkspaceTrash'
  | 'enableScim'
  | 'enableSupportAccess'
  | 'generateMfaRecoveryCodes'
  | 'getIntegrationConnectUrl'
  | 'getIntegrationIdentityConnectUrl'
  | 'inviteWorkspaceMembers'
  | 'inviteWorkspacePartner'
  | 'leaveProject'
  | 'linkRegularAccount'
  | 'linkRegularAccountWithMfa'
  | 'markAllCommentsAsRead'
  | 'markCommentsAsRead'
  | 'moveAllCollectionShares'
  | 'moveAnnotation'
  | 'moveAnnotations'
  | 'moveShareToProject'
  | 'notificationMarkAllAsRead'
  | 'notificationMarkAsRead'
  | 'notificationMarkEveryReadAsDone'
  | 'organizationAcceptInvite'
  | 'organizationAcceptTos'
  | 'organizationResendInvite'
  | 'organizationShortNameUpdate'
  | 'organizationUpdateAttributeMapping'
  | 'organizationUpdateIdentityProviderConfig'
  | 'pinProject'
  | 'pinShare'
  | 'publishShare'
  | 'reactivateSubscription'
  | 'refreshAllPreviews'
  | 'refreshPreview'
  | 'remotePatchCompleteUpload'
  | 'remotePatchInitiateUpload'
  | 'removeIntegration'
  | 'removeIntegrationIdentity'
  | 'removePermissionGroupMember'
  | 'removePermissionGroupRelation'
  | 'removeProjectMember'
  | 'removeShareFromProject'
  | 'removeSharesFromCollection'
  | 'removeWorkspaceMember'
  | 'renameCollection'
  | 'renameProject'
  | 'renderDownloadableAssets'
  | 'renderPresentation'
  | 'reportShare'
  | 'requestAccessToProject'
  | 'resendVerificationEmail'
  | 'resendWorkspaceInvite'
  | 'resetScimToken'
  | 'resolveAnnotation'
  | 'restoreProject'
  | 'restoreShare'
  | 'revokeActiveSessions'
  | 'revokeOAuth'
  | 'revokeSession'
  | 'scimPersonalAccessTokenCreate'
  | 'scimPersonalAccessTokenDelete'
  | 'sendDownloadSketchEmail'
  | 'sendPasswordSetupEmail'
  | 'serverSideMigrate'
  | 'setNotificationSubscription'
  | 'setupMfa'
  | 'shareAcceptRequest'
  | 'shareCreate'
  | 'shareCreateVersion'
  | 'shareDelete'
  | 'shareDeleteMembership'
  | 'shareLeave'
  | 'shareMembershipAccept'
  | 'shareRequestAccess'
  | 'shareRestore'
  | 'sharesDelete'
  | 'shareUnwatch'
  | 'shareUpdate'
  | 'shareWatch'
  | 'signIn'
  | 'signInAndDisableMfa'
  | 'signInWithSocial'
  | 'signInWithSso'
  | 'signUp'
  | 'socialAuthStartUrl'
  | 'socialSignInDeleteAccountUrl'
  | 'socialSignInDeleteWorkspaceUrl'
  | 'subscribeCustomerToPlan'
  | 'togglePasswordProtectedPreviews'
  | 'transferShare'
  | 'transferStorageItem'
  | 'transferStorageItems'
  | 'unarchiveProject'
  | 'undoCancelSubscription'
  | 'undoScheduledSubscriptionCancellation'
  | 'unlinkSocialAccount'
  | 'unpinProject'
  | 'unpinShare'
  | 'unpublishShare'
  | 'unresolveAnnotation'
  | 'updateBillingDetails'
  | 'updateBillingSeats'
  | 'updateNotification'
  | 'updateNotifications'
  | 'updatePaymentMethod'
  | 'updatePermissionGroup'
  | 'updatePermissionGroupRelation'
  | 'updatePreview'
  | 'updateProject'
  | 'updateProjectMembership'
  | 'updateProjectPermission'
  | 'updateRestrictedPublicLinks'
  | 'updateRestrictedUploadsState'
  | 'updateShareMembership'
  | 'updateShareParentPermissions'
  | 'updateSharePermissionGroupRelation'
  | 'updateSharePublicPermissions'
  | 'updateUserPreferences'
  | 'updateVersionDescription'
  | 'updateWorkspace'
  | 'updateWorkspaceCustomerSsoAttributeMapping'
  | 'updateWorkspaceCustomerSsoIdentityProviderConfig'
  | 'updateWorkspaceCustomerSsoShortName'
  | 'updateWorkspaceMember'
  | 'updateWorkspaceProfile'
  | 'updateWorkspaceProfileShortUrl'
  | 'updateWorkspaceSecurityEmail'
  | 'upgradePersonalWorkspace'
  | 'userAcceptTosAgreement'
  | 'userAvatarCreate'
  | 'userAvatarDelete'
  | 'userDelete'
  | 'userPasswordReset'
  | 'userPasswordUpdate'
  | 'userRequestPasswordReset'
  | 'userUpdate'
  | 'validateMfaRecoveryCode'
  | 'validateMfaTotp'
  | 'versionDelete'
  | 'versionUpdateKind'
  | 'workspaceMembersReport'
  | RootMutationTypeKeySpecifier
)[]
export type RootMutationTypeFieldPolicy = {
  acceptPartnershipInvite?: FieldPolicy<any> | FieldReadFunction<any>
  acceptProjectAccessRequest?: FieldPolicy<any> | FieldReadFunction<any>
  acceptProjectMembershipInvitation?: FieldPolicy<any> | FieldReadFunction<any>
  acceptShareMembershipInvitation?: FieldPolicy<any> | FieldReadFunction<any>
  acceptWorkspaceInvite?: FieldPolicy<any> | FieldReadFunction<any>
  addPermissionGroupMembers?: FieldPolicy<any> | FieldReadFunction<any>
  addPermissionGroupRelation?: FieldPolicy<any> | FieldReadFunction<any>
  addProjectMember?: FieldPolicy<any> | FieldReadFunction<any>
  addProjectPermissionGroupRelation?: FieldPolicy<any> | FieldReadFunction<any>
  addReactionToPublication?: FieldPolicy<any> | FieldReadFunction<any>
  addShareMembership?: FieldPolicy<any> | FieldReadFunction<any>
  addSharePermissionGroupRelation?: FieldPolicy<any> | FieldReadFunction<any>
  addSharesToCollection?: FieldPolicy<any> | FieldReadFunction<any>
  agreeToWorkspaceCustomerTermsOfService?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  applyCoupon?: FieldPolicy<any> | FieldReadFunction<any>
  archiveProject?: FieldPolicy<any> | FieldReadFunction<any>
  archiveStorageItem?: FieldPolicy<any> | FieldReadFunction<any>
  archiveStorageItems?: FieldPolicy<any> | FieldReadFunction<any>
  cancelScheduledBillingSeats?: FieldPolicy<any> | FieldReadFunction<any>
  cancelSubscription?: FieldPolicy<any> | FieldReadFunction<any>
  changePlan?: FieldPolicy<any> | FieldReadFunction<any>
  checkWorkspaceProfileShortUrl?: FieldPolicy<any> | FieldReadFunction<any>
  collaborativeEdit?: FieldPolicy<any> | FieldReadFunction<any>
  collaborativeEditingSessionCreate?: FieldPolicy<any> | FieldReadFunction<any>
  collaborativeEditingSessionMigrateDocument?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  collaborativeEditingSessionResetDocument?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  collaborativeShareCreate?: FieldPolicy<any> | FieldReadFunction<any>
  collaborativeShareCreateMigratedVersion?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  collaborativeShareCreateResetVersion?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  collaborativeShareInitialDocumentUploadComplete?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  collaborativeShareInitialDocumentUploadStart?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  collaborativeShareMigratedDocumentUploadComplete?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  collaborativeShareMigratedDocumentUploadStart?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  collaborativeShareResetDocumentUploadComplete?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  collaborativeShareResetDocumentUploadStart?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  configureWorkspaceEncryptionKeys?: FieldPolicy<any> | FieldReadFunction<any>
  confirmAppStorePurchase?: FieldPolicy<any> | FieldReadFunction<any>
  confirmMfaSetup?: FieldPolicy<any> | FieldReadFunction<any>
  createAnnotation?: FieldPolicy<any> | FieldReadFunction<any>
  createAnnotationReply?: FieldPolicy<any> | FieldReadFunction<any>
  createCollaborativeVersion?: FieldPolicy<any> | FieldReadFunction<any>
  createCollection?: FieldPolicy<any> | FieldReadFunction<any>
  createInstitutionApplication?: FieldPolicy<any> | FieldReadFunction<any>
  createOrganizationProject?: FieldPolicy<any> | FieldReadFunction<any>
  createPartnerWorkspace?: FieldPolicy<any> | FieldReadFunction<any>
  createPermissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
  createPreview?: FieldPolicy<any> | FieldReadFunction<any>
  createPreviewAnnotation?: FieldPolicy<any> | FieldReadFunction<any>
  createSetupIntent?: FieldPolicy<any> | FieldReadFunction<any>
  createStudentApplication?: FieldPolicy<any> | FieldReadFunction<any>
  createTeacherApplication?: FieldPolicy<any> | FieldReadFunction<any>
  createUserProject?: FieldPolicy<any> | FieldReadFunction<any>
  createWorkspace?: FieldPolicy<any> | FieldReadFunction<any>
  createWorkspaceProfile?: FieldPolicy<any> | FieldReadFunction<any>
  createWorkspaceProject?: FieldPolicy<any> | FieldReadFunction<any>
  createWorkspaceShare?: FieldPolicy<any> | FieldReadFunction<any>
  deleteAllPreviews?: FieldPolicy<any> | FieldReadFunction<any>
  deleteAnnotation?: FieldPolicy<any> | FieldReadFunction<any>
  deleteAnnotationReply?: FieldPolicy<any> | FieldReadFunction<any>
  deleteCollection?: FieldPolicy<any> | FieldReadFunction<any>
  deletePermissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
  deletePreview?: FieldPolicy<any> | FieldReadFunction<any>
  deletePreviousShareVersions?: FieldPolicy<any> | FieldReadFunction<any>
  deleteProject?: FieldPolicy<any> | FieldReadFunction<any>
  deleteProjectPermanently?: FieldPolicy<any> | FieldReadFunction<any>
  deleteSharePermanently?: FieldPolicy<any> | FieldReadFunction<any>
  deleteStorageItem?: FieldPolicy<any> | FieldReadFunction<any>
  deleteStorageItems?: FieldPolicy<any> | FieldReadFunction<any>
  deleteWorkspace?: FieldPolicy<any> | FieldReadFunction<any>
  deleteWorkspaceAvatar?: FieldPolicy<any> | FieldReadFunction<any>
  disableMfa?: FieldPolicy<any> | FieldReadFunction<any>
  disableScim?: FieldPolicy<any> | FieldReadFunction<any>
  disableSupportAccess?: FieldPolicy<any> | FieldReadFunction<any>
  documentUploadCancel?: FieldPolicy<any> | FieldReadFunction<any>
  documentUploadComplete?: FieldPolicy<any> | FieldReadFunction<any>
  documentUploadStart?: FieldPolicy<any> | FieldReadFunction<any>
  duplicateShareTo?: FieldPolicy<any> | FieldReadFunction<any>
  duplicateShareToDrafts?: FieldPolicy<any> | FieldReadFunction<any>
  editCollection?: FieldPolicy<any> | FieldReadFunction<any>
  editCollectionDescription?: FieldPolicy<any> | FieldReadFunction<any>
  editComment?: FieldPolicy<any> | FieldReadFunction<any>
  editComponents?: FieldPolicy<any> | FieldReadFunction<any>
  emailResendChangeConfirmation?: FieldPolicy<any> | FieldReadFunction<any>
  emailUpdate?: FieldPolicy<any> | FieldReadFunction<any>
  emailVerify?: FieldPolicy<any> | FieldReadFunction<any>
  emptyWorkspaceTrash?: FieldPolicy<any> | FieldReadFunction<any>
  enableScim?: FieldPolicy<any> | FieldReadFunction<any>
  enableSupportAccess?: FieldPolicy<any> | FieldReadFunction<any>
  generateMfaRecoveryCodes?: FieldPolicy<any> | FieldReadFunction<any>
  getIntegrationConnectUrl?: FieldPolicy<any> | FieldReadFunction<any>
  getIntegrationIdentityConnectUrl?: FieldPolicy<any> | FieldReadFunction<any>
  inviteWorkspaceMembers?: FieldPolicy<any> | FieldReadFunction<any>
  inviteWorkspacePartner?: FieldPolicy<any> | FieldReadFunction<any>
  leaveProject?: FieldPolicy<any> | FieldReadFunction<any>
  linkRegularAccount?: FieldPolicy<any> | FieldReadFunction<any>
  linkRegularAccountWithMfa?: FieldPolicy<any> | FieldReadFunction<any>
  markAllCommentsAsRead?: FieldPolicy<any> | FieldReadFunction<any>
  markCommentsAsRead?: FieldPolicy<any> | FieldReadFunction<any>
  moveAllCollectionShares?: FieldPolicy<any> | FieldReadFunction<any>
  moveAnnotation?: FieldPolicy<any> | FieldReadFunction<any>
  moveAnnotations?: FieldPolicy<any> | FieldReadFunction<any>
  moveShareToProject?: FieldPolicy<any> | FieldReadFunction<any>
  notificationMarkAllAsRead?: FieldPolicy<any> | FieldReadFunction<any>
  notificationMarkAsRead?: FieldPolicy<any> | FieldReadFunction<any>
  notificationMarkEveryReadAsDone?: FieldPolicy<any> | FieldReadFunction<any>
  organizationAcceptInvite?: FieldPolicy<any> | FieldReadFunction<any>
  organizationAcceptTos?: FieldPolicy<any> | FieldReadFunction<any>
  organizationResendInvite?: FieldPolicy<any> | FieldReadFunction<any>
  organizationShortNameUpdate?: FieldPolicy<any> | FieldReadFunction<any>
  organizationUpdateAttributeMapping?: FieldPolicy<any> | FieldReadFunction<any>
  organizationUpdateIdentityProviderConfig?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  pinProject?: FieldPolicy<any> | FieldReadFunction<any>
  pinShare?: FieldPolicy<any> | FieldReadFunction<any>
  publishShare?: FieldPolicy<any> | FieldReadFunction<any>
  reactivateSubscription?: FieldPolicy<any> | FieldReadFunction<any>
  refreshAllPreviews?: FieldPolicy<any> | FieldReadFunction<any>
  refreshPreview?: FieldPolicy<any> | FieldReadFunction<any>
  remotePatchCompleteUpload?: FieldPolicy<any> | FieldReadFunction<any>
  remotePatchInitiateUpload?: FieldPolicy<any> | FieldReadFunction<any>
  removeIntegration?: FieldPolicy<any> | FieldReadFunction<any>
  removeIntegrationIdentity?: FieldPolicy<any> | FieldReadFunction<any>
  removePermissionGroupMember?: FieldPolicy<any> | FieldReadFunction<any>
  removePermissionGroupRelation?: FieldPolicy<any> | FieldReadFunction<any>
  removeProjectMember?: FieldPolicy<any> | FieldReadFunction<any>
  removeShareFromProject?: FieldPolicy<any> | FieldReadFunction<any>
  removeSharesFromCollection?: FieldPolicy<any> | FieldReadFunction<any>
  removeWorkspaceMember?: FieldPolicy<any> | FieldReadFunction<any>
  renameCollection?: FieldPolicy<any> | FieldReadFunction<any>
  renameProject?: FieldPolicy<any> | FieldReadFunction<any>
  renderDownloadableAssets?: FieldPolicy<any> | FieldReadFunction<any>
  renderPresentation?: FieldPolicy<any> | FieldReadFunction<any>
  reportShare?: FieldPolicy<any> | FieldReadFunction<any>
  requestAccessToProject?: FieldPolicy<any> | FieldReadFunction<any>
  resendVerificationEmail?: FieldPolicy<any> | FieldReadFunction<any>
  resendWorkspaceInvite?: FieldPolicy<any> | FieldReadFunction<any>
  resetScimToken?: FieldPolicy<any> | FieldReadFunction<any>
  resolveAnnotation?: FieldPolicy<any> | FieldReadFunction<any>
  restoreProject?: FieldPolicy<any> | FieldReadFunction<any>
  restoreShare?: FieldPolicy<any> | FieldReadFunction<any>
  revokeActiveSessions?: FieldPolicy<any> | FieldReadFunction<any>
  revokeOAuth?: FieldPolicy<any> | FieldReadFunction<any>
  revokeSession?: FieldPolicy<any> | FieldReadFunction<any>
  scimPersonalAccessTokenCreate?: FieldPolicy<any> | FieldReadFunction<any>
  scimPersonalAccessTokenDelete?: FieldPolicy<any> | FieldReadFunction<any>
  sendDownloadSketchEmail?: FieldPolicy<any> | FieldReadFunction<any>
  sendPasswordSetupEmail?: FieldPolicy<any> | FieldReadFunction<any>
  serverSideMigrate?: FieldPolicy<any> | FieldReadFunction<any>
  setNotificationSubscription?: FieldPolicy<any> | FieldReadFunction<any>
  setupMfa?: FieldPolicy<any> | FieldReadFunction<any>
  shareAcceptRequest?: FieldPolicy<any> | FieldReadFunction<any>
  shareCreate?: FieldPolicy<any> | FieldReadFunction<any>
  shareCreateVersion?: FieldPolicy<any> | FieldReadFunction<any>
  shareDelete?: FieldPolicy<any> | FieldReadFunction<any>
  shareDeleteMembership?: FieldPolicy<any> | FieldReadFunction<any>
  shareLeave?: FieldPolicy<any> | FieldReadFunction<any>
  shareMembershipAccept?: FieldPolicy<any> | FieldReadFunction<any>
  shareRequestAccess?: FieldPolicy<any> | FieldReadFunction<any>
  shareRestore?: FieldPolicy<any> | FieldReadFunction<any>
  sharesDelete?: FieldPolicy<any> | FieldReadFunction<any>
  shareUnwatch?: FieldPolicy<any> | FieldReadFunction<any>
  shareUpdate?: FieldPolicy<any> | FieldReadFunction<any>
  shareWatch?: FieldPolicy<any> | FieldReadFunction<any>
  signIn?: FieldPolicy<any> | FieldReadFunction<any>
  signInAndDisableMfa?: FieldPolicy<any> | FieldReadFunction<any>
  signInWithSocial?: FieldPolicy<any> | FieldReadFunction<any>
  signInWithSso?: FieldPolicy<any> | FieldReadFunction<any>
  signUp?: FieldPolicy<any> | FieldReadFunction<any>
  socialAuthStartUrl?: FieldPolicy<any> | FieldReadFunction<any>
  socialSignInDeleteAccountUrl?: FieldPolicy<any> | FieldReadFunction<any>
  socialSignInDeleteWorkspaceUrl?: FieldPolicy<any> | FieldReadFunction<any>
  subscribeCustomerToPlan?: FieldPolicy<any> | FieldReadFunction<any>
  togglePasswordProtectedPreviews?: FieldPolicy<any> | FieldReadFunction<any>
  transferShare?: FieldPolicy<any> | FieldReadFunction<any>
  transferStorageItem?: FieldPolicy<any> | FieldReadFunction<any>
  transferStorageItems?: FieldPolicy<any> | FieldReadFunction<any>
  unarchiveProject?: FieldPolicy<any> | FieldReadFunction<any>
  undoCancelSubscription?: FieldPolicy<any> | FieldReadFunction<any>
  undoScheduledSubscriptionCancellation?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  unlinkSocialAccount?: FieldPolicy<any> | FieldReadFunction<any>
  unpinProject?: FieldPolicy<any> | FieldReadFunction<any>
  unpinShare?: FieldPolicy<any> | FieldReadFunction<any>
  unpublishShare?: FieldPolicy<any> | FieldReadFunction<any>
  unresolveAnnotation?: FieldPolicy<any> | FieldReadFunction<any>
  updateBillingDetails?: FieldPolicy<any> | FieldReadFunction<any>
  updateBillingSeats?: FieldPolicy<any> | FieldReadFunction<any>
  updateNotification?: FieldPolicy<any> | FieldReadFunction<any>
  updateNotifications?: FieldPolicy<any> | FieldReadFunction<any>
  updatePaymentMethod?: FieldPolicy<any> | FieldReadFunction<any>
  updatePermissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
  updatePermissionGroupRelation?: FieldPolicy<any> | FieldReadFunction<any>
  updatePreview?: FieldPolicy<any> | FieldReadFunction<any>
  updateProject?: FieldPolicy<any> | FieldReadFunction<any>
  updateProjectMembership?: FieldPolicy<any> | FieldReadFunction<any>
  updateProjectPermission?: FieldPolicy<any> | FieldReadFunction<any>
  updateRestrictedPublicLinks?: FieldPolicy<any> | FieldReadFunction<any>
  updateRestrictedUploadsState?: FieldPolicy<any> | FieldReadFunction<any>
  updateShareMembership?: FieldPolicy<any> | FieldReadFunction<any>
  updateShareParentPermissions?: FieldPolicy<any> | FieldReadFunction<any>
  updateSharePermissionGroupRelation?: FieldPolicy<any> | FieldReadFunction<any>
  updateSharePublicPermissions?: FieldPolicy<any> | FieldReadFunction<any>
  updateUserPreferences?: FieldPolicy<any> | FieldReadFunction<any>
  updateVersionDescription?: FieldPolicy<any> | FieldReadFunction<any>
  updateWorkspace?: FieldPolicy<any> | FieldReadFunction<any>
  updateWorkspaceCustomerSsoAttributeMapping?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  updateWorkspaceCustomerSsoIdentityProviderConfig?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  updateWorkspaceCustomerSsoShortName?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  updateWorkspaceMember?: FieldPolicy<any> | FieldReadFunction<any>
  updateWorkspaceProfile?: FieldPolicy<any> | FieldReadFunction<any>
  updateWorkspaceProfileShortUrl?: FieldPolicy<any> | FieldReadFunction<any>
  updateWorkspaceSecurityEmail?: FieldPolicy<any> | FieldReadFunction<any>
  upgradePersonalWorkspace?: FieldPolicy<any> | FieldReadFunction<any>
  userAcceptTosAgreement?: FieldPolicy<any> | FieldReadFunction<any>
  userAvatarCreate?: FieldPolicy<any> | FieldReadFunction<any>
  userAvatarDelete?: FieldPolicy<any> | FieldReadFunction<any>
  userDelete?: FieldPolicy<any> | FieldReadFunction<any>
  userPasswordReset?: FieldPolicy<any> | FieldReadFunction<any>
  userPasswordUpdate?: FieldPolicy<any> | FieldReadFunction<any>
  userRequestPasswordReset?: FieldPolicy<any> | FieldReadFunction<any>
  userUpdate?: FieldPolicy<any> | FieldReadFunction<any>
  validateMfaRecoveryCode?: FieldPolicy<any> | FieldReadFunction<any>
  validateMfaTotp?: FieldPolicy<any> | FieldReadFunction<any>
  versionDelete?: FieldPolicy<any> | FieldReadFunction<any>
  versionUpdateKind?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceMembersReport?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RootQueryTypeKeySpecifier = (
  | 'accountExists'
  | 'annotation'
  | 'annotations'
  | 'artboard'
  | 'artboardInDocumentWithUuid'
  | 'artboardRevisions'
  | 'availableCloudPlans'
  | 'collaborativeEditingSession'
  | 'comment'
  | 'community'
  | 'componentInDocumentWithUuid'
  | 'curatedSketchLibraries'
  | 'curatedSketchTemplates'
  | 'curatedThirdPartyLibraries'
  | 'currencies'
  | 'customer'
  | 'discover'
  | 'discoverResources'
  | 'documentsLayout'
  | 'documentUploadParts'
  | 'draftBillingSummary'
  | 'educationApplication'
  | 'frame'
  | 'getPublicWorkspaceFromToken'
  | 'inspectorData'
  | 'integration'
  | 'invitableUsers'
  | 'invitableUsersAndGroups'
  | 'invitableUsersForPermissionGroup'
  | 'invitableUsersForProject'
  | 'licensePlan'
  | 'linkAccountStartUrl'
  | 'me'
  | 'notification'
  | 'organization'
  | 'partner'
  | 'partnerBillingDetails'
  | 'pendingWorkspaceMembership'
  | 'permissionGroup'
  | 'preview'
  | 'previewAnnotations'
  | 'project'
  | 'projectMembership'
  | 'publication'
  | 'publicationListing'
  | 'publications'
  | 'publicOrganization'
  | 'publicWorkspace'
  | 'seatsUpdateBillingSimulation'
  | 'section'
  | 'share'
  | 'shareForDocumentWithUuid'
  | 'shareMembership'
  | 'showArchivedDocuments'
  | 'showDocumentsInProjects'
  | 'sidebarRightOpen'
  | 'socialSignInStartUrl'
  | 'ssoStartUrl'
  | 'subscriptionUpdateBillingSimulation'
  | 'taxableCountries'
  | 'userCredentials'
  | 'version'
  | 'workspace'
  | 'workspaceAuditLogs'
  | 'workspaceCustomer'
  | 'workspaceHeaviestShares'
  | 'workspaceProfile'
  | 'workspaceStorage'
  | 'workspaceTransferDestinations'
  | 'workspaceTrash'
  | RootQueryTypeKeySpecifier
)[]
export type RootQueryTypeFieldPolicy = {
  accountExists?: FieldPolicy<any> | FieldReadFunction<any>
  annotation?: FieldPolicy<any> | FieldReadFunction<any>
  annotations?: FieldPolicy<any> | FieldReadFunction<any>
  artboard?: FieldPolicy<any> | FieldReadFunction<any>
  artboardInDocumentWithUuid?: FieldPolicy<any> | FieldReadFunction<any>
  artboardRevisions?: FieldPolicy<any> | FieldReadFunction<any>
  availableCloudPlans?: FieldPolicy<any> | FieldReadFunction<any>
  collaborativeEditingSession?: FieldPolicy<any> | FieldReadFunction<any>
  comment?: FieldPolicy<any> | FieldReadFunction<any>
  community?: FieldPolicy<any> | FieldReadFunction<any>
  componentInDocumentWithUuid?: FieldPolicy<any> | FieldReadFunction<any>
  curatedSketchLibraries?: FieldPolicy<any> | FieldReadFunction<any>
  curatedSketchTemplates?: FieldPolicy<any> | FieldReadFunction<any>
  curatedThirdPartyLibraries?: FieldPolicy<any> | FieldReadFunction<any>
  currencies?: FieldPolicy<any> | FieldReadFunction<any>
  customer?: FieldPolicy<any> | FieldReadFunction<any>
  discover?: FieldPolicy<any> | FieldReadFunction<any>
  discoverResources?: FieldPolicy<any> | FieldReadFunction<any>
  documentsLayout?: FieldPolicy<any> | FieldReadFunction<any>
  documentUploadParts?: FieldPolicy<any> | FieldReadFunction<any>
  draftBillingSummary?: FieldPolicy<any> | FieldReadFunction<any>
  educationApplication?: FieldPolicy<any> | FieldReadFunction<any>
  frame?: FieldPolicy<any> | FieldReadFunction<any>
  getPublicWorkspaceFromToken?: FieldPolicy<any> | FieldReadFunction<any>
  inspectorData?: FieldPolicy<any> | FieldReadFunction<any>
  integration?: FieldPolicy<any> | FieldReadFunction<any>
  invitableUsers?: FieldPolicy<any> | FieldReadFunction<any>
  invitableUsersAndGroups?: FieldPolicy<any> | FieldReadFunction<any>
  invitableUsersForPermissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
  invitableUsersForProject?: FieldPolicy<any> | FieldReadFunction<any>
  licensePlan?: FieldPolicy<any> | FieldReadFunction<any>
  linkAccountStartUrl?: FieldPolicy<any> | FieldReadFunction<any>
  me?: FieldPolicy<any> | FieldReadFunction<any>
  notification?: FieldPolicy<any> | FieldReadFunction<any>
  organization?: FieldPolicy<any> | FieldReadFunction<any>
  partner?: FieldPolicy<any> | FieldReadFunction<any>
  partnerBillingDetails?: FieldPolicy<any> | FieldReadFunction<any>
  pendingWorkspaceMembership?: FieldPolicy<any> | FieldReadFunction<any>
  permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
  preview?: FieldPolicy<any> | FieldReadFunction<any>
  previewAnnotations?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  projectMembership?: FieldPolicy<any> | FieldReadFunction<any>
  publication?: FieldPolicy<any> | FieldReadFunction<any>
  publicationListing?: FieldPolicy<any> | FieldReadFunction<any>
  publications?: FieldPolicy<any> | FieldReadFunction<any>
  publicOrganization?: FieldPolicy<any> | FieldReadFunction<any>
  publicWorkspace?: FieldPolicy<any> | FieldReadFunction<any>
  seatsUpdateBillingSimulation?: FieldPolicy<any> | FieldReadFunction<any>
  section?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  shareForDocumentWithUuid?: FieldPolicy<any> | FieldReadFunction<any>
  shareMembership?: FieldPolicy<any> | FieldReadFunction<any>
  showArchivedDocuments?: FieldPolicy<any> | FieldReadFunction<any>
  showDocumentsInProjects?: FieldPolicy<any> | FieldReadFunction<any>
  sidebarRightOpen?: FieldPolicy<any> | FieldReadFunction<any>
  socialSignInStartUrl?: FieldPolicy<any> | FieldReadFunction<any>
  ssoStartUrl?: FieldPolicy<any> | FieldReadFunction<any>
  subscriptionUpdateBillingSimulation?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  taxableCountries?: FieldPolicy<any> | FieldReadFunction<any>
  userCredentials?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceAuditLogs?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceCustomer?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceHeaviestShares?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceProfile?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceStorage?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceTransferDestinations?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceTrash?: FieldPolicy<any> | FieldReadFunction<any>
}
export type RootSubscriptionTypeKeySpecifier = (
  | 'annotationCreated'
  | 'annotationDeleted'
  | 'annotationMoved'
  | 'annotationReplyCreated'
  | 'annotationReplyDeleted'
  | 'annotationResolved'
  | 'annotationUnresolved'
  | 'collaborativeEdits'
  | 'collectionChanged'
  | 'collectionCreated'
  | 'collectionDeleted'
  | 'commentEdited'
  | 'commentsMarkedAsRead'
  | 'deletedSharePermanently'
  | 'documentMigrations'
  | 'emptiedWorkspaceTrash'
  | 'notificationCreated'
  | 'previewChanged'
  | 'projectAccessChanged'
  | 'projectChanged'
  | 'publicationReactionsUpdated'
  | 'revisionCreated'
  | 'revisionDeleted'
  | 'revisionMoved'
  | 'shareChanged'
  | 'shareCollectionChanged'
  | 'shareDeleted'
  | 'shareMembershipChanged'
  | 'shareRestored'
  | 'versionDeleted'
  | 'versionUpdated'
  | 'versionUploadComplete'
  | 'versionUploadProcessed'
  | 'workspaceChanged'
  | 'workspaceCustomerSubscriptionUpdated'
  | 'workspaceMembershipUpdated'
  | RootSubscriptionTypeKeySpecifier
)[]
export type RootSubscriptionTypeFieldPolicy = {
  annotationCreated?: FieldPolicy<any> | FieldReadFunction<any>
  annotationDeleted?: FieldPolicy<any> | FieldReadFunction<any>
  annotationMoved?: FieldPolicy<any> | FieldReadFunction<any>
  annotationReplyCreated?: FieldPolicy<any> | FieldReadFunction<any>
  annotationReplyDeleted?: FieldPolicy<any> | FieldReadFunction<any>
  annotationResolved?: FieldPolicy<any> | FieldReadFunction<any>
  annotationUnresolved?: FieldPolicy<any> | FieldReadFunction<any>
  collaborativeEdits?: FieldPolicy<any> | FieldReadFunction<any>
  collectionChanged?: FieldPolicy<any> | FieldReadFunction<any>
  collectionCreated?: FieldPolicy<any> | FieldReadFunction<any>
  collectionDeleted?: FieldPolicy<any> | FieldReadFunction<any>
  commentEdited?: FieldPolicy<any> | FieldReadFunction<any>
  commentsMarkedAsRead?: FieldPolicy<any> | FieldReadFunction<any>
  deletedSharePermanently?: FieldPolicy<any> | FieldReadFunction<any>
  documentMigrations?: FieldPolicy<any> | FieldReadFunction<any>
  emptiedWorkspaceTrash?: FieldPolicy<any> | FieldReadFunction<any>
  notificationCreated?: FieldPolicy<any> | FieldReadFunction<any>
  previewChanged?: FieldPolicy<any> | FieldReadFunction<any>
  projectAccessChanged?: FieldPolicy<any> | FieldReadFunction<any>
  projectChanged?: FieldPolicy<any> | FieldReadFunction<any>
  publicationReactionsUpdated?: FieldPolicy<any> | FieldReadFunction<any>
  revisionCreated?: FieldPolicy<any> | FieldReadFunction<any>
  revisionDeleted?: FieldPolicy<any> | FieldReadFunction<any>
  revisionMoved?: FieldPolicy<any> | FieldReadFunction<any>
  shareChanged?: FieldPolicy<any> | FieldReadFunction<any>
  shareCollectionChanged?: FieldPolicy<any> | FieldReadFunction<any>
  shareDeleted?: FieldPolicy<any> | FieldReadFunction<any>
  shareMembershipChanged?: FieldPolicy<any> | FieldReadFunction<any>
  shareRestored?: FieldPolicy<any> | FieldReadFunction<any>
  versionDeleted?: FieldPolicy<any> | FieldReadFunction<any>
  versionUpdated?: FieldPolicy<any> | FieldReadFunction<any>
  versionUploadComplete?: FieldPolicy<any> | FieldReadFunction<any>
  versionUploadProcessed?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceChanged?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceCustomerSubscriptionUpdated?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  workspaceMembershipUpdated?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SamlAttributeKeySpecifier = (
  | 'mapping'
  | 'updateOnLogin'
  | SamlAttributeKeySpecifier
)[]
export type SamlAttributeFieldPolicy = {
  mapping?: FieldPolicy<any> | FieldReadFunction<any>
  updateOnLogin?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ScimPersonalAccessTokenKeySpecifier = (
  | 'accessScopes'
  | 'createdAt'
  | 'description'
  | 'expiresAt'
  | 'identifier'
  | 'lastUsedAt'
  | ScimPersonalAccessTokenKeySpecifier
)[]
export type ScimPersonalAccessTokenFieldPolicy = {
  accessScopes?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  description?: FieldPolicy<any> | FieldReadFunction<any>
  expiresAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  lastUsedAt?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SeatsUpdateSimulationKeySpecifier = (
  | 'couponInfo'
  | 'extraSeatsPrice'
  | 'plan'
  | 'price'
  | 'prorated'
  | SeatsUpdateSimulationKeySpecifier
)[]
export type SeatsUpdateSimulationFieldPolicy = {
  couponInfo?: FieldPolicy<any> | FieldReadFunction<any>
  extraSeatsPrice?: FieldPolicy<any> | FieldReadFunction<any>
  plan?: FieldPolicy<any> | FieldReadFunction<any>
  price?: FieldPolicy<any> | FieldReadFunction<any>
  prorated?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SectionKeySpecifier = (
  | 'frames'
  | 'identifier'
  | 'isVariantSet'
  | 'name'
  | 'order'
  | 'page'
  | 'parentSection'
  | 'slug'
  | 'uuid'
  | SectionKeySpecifier
)[]
export type SectionFieldPolicy = {
  frames?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isVariantSet?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  order?: FieldPolicy<any> | FieldReadFunction<any>
  page?: FieldPolicy<any> | FieldReadFunction<any>
  parentSection?: FieldPolicy<any> | FieldReadFunction<any>
  slug?: FieldPolicy<any> | FieldReadFunction<any>
  uuid?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SectionCategoryKeySpecifier = (
  | 'id'
  | 'name'
  | SectionCategoryKeySpecifier
)[]
export type SectionCategoryFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SectionSubTitleKeySpecifier = (
  | 'text'
  | 'visibility'
  | SectionSubTitleKeySpecifier
)[]
export type SectionSubTitleFieldPolicy = {
  text?: FieldPolicy<any> | FieldReadFunction<any>
  visibility?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SendDownloadSketchEmailResponseKeySpecifier = (
  | 'sent'
  | SendDownloadSketchEmailResponseKeySpecifier
)[]
export type SendDownloadSketchEmailResponseFieldPolicy = {
  sent?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SendPasswordSetupEmailResponseKeySpecifier = (
  | 'user'
  | SendPasswordSetupEmailResponseKeySpecifier
)[]
export type SendPasswordSetupEmailResponseFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SessionKeySpecifier = (
  | 'countryCode'
  | 'deviceName'
  | 'id'
  | 'ipAddress'
  | 'isCurrentOne'
  | 'lastUpdateAt'
  | 'type'
  | 'userAgent'
  | SessionKeySpecifier
)[]
export type SessionFieldPolicy = {
  countryCode?: FieldPolicy<any> | FieldReadFunction<any>
  deviceName?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  ipAddress?: FieldPolicy<any> | FieldReadFunction<any>
  isCurrentOne?: FieldPolicy<any> | FieldReadFunction<any>
  lastUpdateAt?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  userAgent?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SessionsKeySpecifier = ('entries' | 'meta' | SessionsKeySpecifier)[]
export type SessionsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SetDesignSystemsEligibilityAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'designSystemsEnabled'
  | 'version'
  | SetDesignSystemsEligibilityAuditKeySpecifier
)[]
export type SetDesignSystemsEligibilityAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  designSystemsEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SetNotificationSubscriptionResponseKeySpecifier = (
  | 'annotation'
  | 'frame'
  | 'share'
  | SetNotificationSubscriptionResponseKeySpecifier
)[]
export type SetNotificationSubscriptionResponseFieldPolicy = {
  annotation?: FieldPolicy<any> | FieldReadFunction<any>
  frame?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SetRestrictedUploadsEligibilityAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'restrictedUploadsEnabled'
  | 'version'
  | SetRestrictedUploadsEligibilityAuditKeySpecifier
)[]
export type SetRestrictedUploadsEligibilityAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  restrictedUploadsEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SetScimEnabledAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'scimEnabled'
  | 'version'
  | SetScimEnabledAuditKeySpecifier
)[]
export type SetScimEnabledAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  scimEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SetSsoConfigAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'version'
  | SetSsoConfigAuditKeySpecifier
)[]
export type SetSsoConfigAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SetSsoEligibilityAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'ssoEnabled'
  | 'version'
  | SetSsoEligibilityAuditKeySpecifier
)[]
export type SetSsoEligibilityAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  ssoEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SetupMfaResponseKeySpecifier = (
  | 'otpAuthUri'
  | SetupMfaResponseKeySpecifier
)[]
export type SetupMfaResponseFieldPolicy = {
  otpAuthUri?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SetWorkspaceExpiredVersionsRulesAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'newRules'
  | 'previousRules'
  | 'version'
  | SetWorkspaceExpiredVersionsRulesAuditKeySpecifier
)[]
export type SetWorkspaceExpiredVersionsRulesAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  newRules?: FieldPolicy<any> | FieldReadFunction<any>
  previousRules?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareKeySpecifier = (
  | 'allowedParentAccessLevels'
  | 'allowedPrivateAccessLevels'
  | 'allowedWorkspaceAccessLevels'
  | 'archivedAt'
  | 'artboard'
  | 'belongsToTeam'
  | 'collection'
  | 'commentsEnabled'
  | 'createdAt'
  | 'curatedCategory'
  | 'currentVersion'
  | 'deletedAt'
  | 'description'
  | 'downloadEnabled'
  | 'id'
  | 'identifier'
  | 'invitableUsers'
  | 'isDraft'
  | 'isOptimistic'
  | 'isPrivate'
  | 'isShared'
  | 'isSharedWithGuests'
  | 'latestVersionIdentifier'
  | 'libraryEnabled'
  | 'licenseAgreement'
  | 'members'
  | 'memberships'
  | 'mentionableUsers'
  | 'myMembership'
  | 'name'
  | 'owner'
  | 'page'
  | 'parentAccessLevel'
  | 'parentCommentsEnabled'
  | 'permissionGroupRelations'
  | 'pinnedByCurrentUserAt'
  | 'preview'
  | 'previewFiles'
  | 'previews'
  | 'previewThumbnails'
  | 'privacyIcon'
  | 'project'
  | 'publicAccessLevel'
  | 'publication'
  | 'publicCommentsEnabled'
  | 'publicInspectEnabled'
  | 'publicTokenExport'
  | 'publicTokenExportUrl'
  | 'publicUrl'
  | 'sharePrivacyIcon'
  | 'shareType'
  | 'shortId'
  | 'subscriptionStatus'
  | 'templateCategory'
  | 'type'
  | 'unreadCount'
  | 'updatedAt'
  | 'userAccessLevel'
  | 'userCanAccessVersions'
  | 'userCanAdminister'
  | 'userCanContribute'
  | 'userCanEdit'
  | 'userCanInspect'
  | 'userCanLeaveShare'
  | 'userCanPublish'
  | 'userCanUpdateCommentsEnabled'
  | 'userCanUpdateParentPermissions'
  | 'userCanUpdateSettings'
  | 'userCanUpdateWorkspacePermissions'
  | 'userHasAcceptedInvitationToView'
  | 'userHasUnacceptedInvitationToView'
  | 'userIsMember'
  | 'userIsOwner'
  | 'userIsWatching'
  | 'version'
  | 'versionHistory'
  | 'versions'
  | 'versionTypeAvailableToUser'
  | 'viewerCanAccessVersions'
  | 'viewerCanAdminister'
  | 'viewerCanContribute'
  | 'viewerCanUpdate'
  | 'viewerHasUnacceptedMembershipInvite'
  | 'viewerIsMember'
  | 'viewerIsOwner'
  | 'viewerIsWatching'
  | 'workspace'
  | 'workspaceAccessLevel'
  | 'workspaceCommentsEnabled'
  | ShareKeySpecifier
)[]
export type ShareFieldPolicy = {
  allowedParentAccessLevels?: FieldPolicy<any> | FieldReadFunction<any>
  allowedPrivateAccessLevels?: FieldPolicy<any> | FieldReadFunction<any>
  allowedWorkspaceAccessLevels?: FieldPolicy<any> | FieldReadFunction<any>
  archivedAt?: FieldPolicy<any> | FieldReadFunction<any>
  artboard?: FieldPolicy<any> | FieldReadFunction<any>
  belongsToTeam?: FieldPolicy<any> | FieldReadFunction<any>
  collection?: FieldPolicy<any> | FieldReadFunction<any>
  commentsEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  curatedCategory?: FieldPolicy<any> | FieldReadFunction<any>
  currentVersion?: FieldPolicy<any> | FieldReadFunction<any>
  deletedAt?: FieldPolicy<any> | FieldReadFunction<any>
  description?: FieldPolicy<any> | FieldReadFunction<any>
  downloadEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  invitableUsers?: FieldPolicy<any> | FieldReadFunction<any>
  isDraft?: FieldPolicy<any> | FieldReadFunction<any>
  isOptimistic?: FieldPolicy<any> | FieldReadFunction<any>
  isPrivate?: FieldPolicy<any> | FieldReadFunction<any>
  isShared?: FieldPolicy<any> | FieldReadFunction<any>
  isSharedWithGuests?: FieldPolicy<any> | FieldReadFunction<any>
  latestVersionIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  libraryEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  licenseAgreement?: FieldPolicy<any> | FieldReadFunction<any>
  members?: FieldPolicy<any> | FieldReadFunction<any>
  memberships?: FieldPolicy<any> | FieldReadFunction<any>
  mentionableUsers?: FieldPolicy<any> | FieldReadFunction<any>
  myMembership?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  owner?: FieldPolicy<any> | FieldReadFunction<any>
  page?: FieldPolicy<any> | FieldReadFunction<any>
  parentAccessLevel?: FieldPolicy<any> | FieldReadFunction<any>
  parentCommentsEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  permissionGroupRelations?: FieldPolicy<any> | FieldReadFunction<any>
  pinnedByCurrentUserAt?: FieldPolicy<any> | FieldReadFunction<any>
  preview?: FieldPolicy<any> | FieldReadFunction<any>
  previewFiles?: FieldPolicy<any> | FieldReadFunction<any>
  previews?: FieldPolicy<any> | FieldReadFunction<any>
  previewThumbnails?: FieldPolicy<any> | FieldReadFunction<any>
  privacyIcon?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  publicAccessLevel?: FieldPolicy<any> | FieldReadFunction<any>
  publication?: FieldPolicy<any> | FieldReadFunction<any>
  publicCommentsEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  publicInspectEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  publicTokenExport?: FieldPolicy<any> | FieldReadFunction<any>
  publicTokenExportUrl?: FieldPolicy<any> | FieldReadFunction<any>
  publicUrl?: FieldPolicy<any> | FieldReadFunction<any>
  sharePrivacyIcon?: FieldPolicy<any> | FieldReadFunction<any>
  shareType?: FieldPolicy<any> | FieldReadFunction<any>
  shortId?: FieldPolicy<any> | FieldReadFunction<any>
  subscriptionStatus?: FieldPolicy<any> | FieldReadFunction<any>
  templateCategory?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  unreadCount?: FieldPolicy<any> | FieldReadFunction<any>
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
  userAccessLevel?: FieldPolicy<any> | FieldReadFunction<any>
  userCanAccessVersions?: FieldPolicy<any> | FieldReadFunction<any>
  userCanAdminister?: FieldPolicy<any> | FieldReadFunction<any>
  userCanContribute?: FieldPolicy<any> | FieldReadFunction<any>
  userCanEdit?: FieldPolicy<any> | FieldReadFunction<any>
  userCanInspect?: FieldPolicy<any> | FieldReadFunction<any>
  userCanLeaveShare?: FieldPolicy<any> | FieldReadFunction<any>
  userCanPublish?: FieldPolicy<any> | FieldReadFunction<any>
  userCanUpdateCommentsEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  userCanUpdateParentPermissions?: FieldPolicy<any> | FieldReadFunction<any>
  userCanUpdateSettings?: FieldPolicy<any> | FieldReadFunction<any>
  userCanUpdateWorkspacePermissions?: FieldPolicy<any> | FieldReadFunction<any>
  userHasAcceptedInvitationToView?: FieldPolicy<any> | FieldReadFunction<any>
  userHasUnacceptedInvitationToView?: FieldPolicy<any> | FieldReadFunction<any>
  userIsMember?: FieldPolicy<any> | FieldReadFunction<any>
  userIsOwner?: FieldPolicy<any> | FieldReadFunction<any>
  userIsWatching?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
  versionHistory?: FieldPolicy<any> | FieldReadFunction<any>
  versions?: FieldPolicy<any> | FieldReadFunction<any>
  versionTypeAvailableToUser?: FieldPolicy<any> | FieldReadFunction<any>
  viewerCanAccessVersions?: FieldPolicy<any> | FieldReadFunction<any>
  viewerCanAdminister?: FieldPolicy<any> | FieldReadFunction<any>
  viewerCanContribute?: FieldPolicy<any> | FieldReadFunction<any>
  viewerCanUpdate?: FieldPolicy<any> | FieldReadFunction<any>
  viewerHasUnacceptedMembershipInvite?:
    | FieldPolicy<any>
    | FieldReadFunction<any>
  viewerIsMember?: FieldPolicy<any> | FieldReadFunction<any>
  viewerIsOwner?: FieldPolicy<any> | FieldReadFunction<any>
  viewerIsWatching?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceAccessLevel?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceCommentsEnabled?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareAcceptRequestPayloadKeySpecifier = (
  | 'errors'
  | 'membership'
  | 'successful'
  | ShareAcceptRequestPayloadKeySpecifier
)[]
export type ShareAcceptRequestPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  membership?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareAccessRevokedEventKeySpecifier = (
  | 'shareIdentifier'
  | 'type'
  | 'workspace'
  | ShareAccessRevokedEventKeySpecifier
)[]
export type ShareAccessRevokedEventFieldPolicy = {
  shareIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareAddedToCollectionEventKeySpecifier = (
  | 'collection'
  | 'projectIdentifier'
  | 'share'
  | ShareAddedToCollectionEventKeySpecifier
)[]
export type ShareAddedToCollectionEventFieldPolicy = {
  collection?: FieldPolicy<any> | FieldReadFunction<any>
  projectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareArchivedEventKeySpecifier = (
  | 'oldProjectIdentifier'
  | 'share'
  | 'shareIdentifier'
  | 'type'
  | 'workspace'
  | ShareArchivedEventKeySpecifier
)[]
export type ShareArchivedEventFieldPolicy = {
  oldProjectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  shareIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareCreatePayloadKeySpecifier = (
  | 'document'
  | 'errors'
  | 'share'
  | 'successful'
  | 'version'
  | ShareCreatePayloadKeySpecifier
)[]
export type ShareCreatePayloadFieldPolicy = {
  document?: FieldPolicy<any> | FieldReadFunction<any>
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareCreateVersionPayloadKeySpecifier = (
  | 'document'
  | 'errors'
  | 'share'
  | 'successful'
  | 'version'
  | ShareCreateVersionPayloadKeySpecifier
)[]
export type ShareCreateVersionPayloadFieldPolicy = {
  document?: FieldPolicy<any> | FieldReadFunction<any>
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareDeletedEventKeySpecifier = (
  | 'share'
  | 'shareIdentifier'
  | 'type'
  | 'workspace'
  | ShareDeletedEventKeySpecifier
)[]
export type ShareDeletedEventFieldPolicy = {
  share?: FieldPolicy<any> | FieldReadFunction<any>
  shareIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareDeletedPermanentlyEventKeySpecifier = (
  | 'shareIdentifier'
  | 'type'
  | 'workspace'
  | ShareDeletedPermanentlyEventKeySpecifier
)[]
export type ShareDeletedPermanentlyEventFieldPolicy = {
  shareIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareDeleteMembershipPayloadKeySpecifier = (
  | 'errors'
  | 'membership'
  | 'successful'
  | ShareDeleteMembershipPayloadKeySpecifier
)[]
export type ShareDeleteMembershipPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  membership?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareDeletePayloadKeySpecifier = (
  | 'errors'
  | 'share'
  | 'successful'
  | ShareDeletePayloadKeySpecifier
)[]
export type ShareDeletePayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareInviteKeySpecifier = (
  | 'email'
  | 'id'
  | 'identifier'
  | ShareInviteKeySpecifier
)[]
export type ShareInviteFieldPolicy = {
  email?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareLeavePayloadKeySpecifier = (
  | 'errors'
  | 'membership'
  | 'share'
  | 'successful'
  | ShareLeavePayloadKeySpecifier
)[]
export type ShareLeavePayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  membership?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareLicenseAgreementKeySpecifier = (
  | 'body'
  | 'updatedAt'
  | ShareLicenseAgreementKeySpecifier
)[]
export type ShareLicenseAgreementFieldPolicy = {
  body?: FieldPolicy<any> | FieldReadFunction<any>
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareMembershipKeySpecifier = (
  | 'acceptedAt'
  | 'email'
  | 'guestCommentsEnabled'
  | 'guestInspectEnabled'
  | 'id'
  | 'identifier'
  | 'invite'
  | 'inviter'
  | 'inviteStatus'
  | 'privateAccessLevel'
  | 'share'
  | 'userCanUpdateCommentsEnabled'
  | 'workspaceMembership'
  | ShareMembershipKeySpecifier
)[]
export type ShareMembershipFieldPolicy = {
  acceptedAt?: FieldPolicy<any> | FieldReadFunction<any>
  email?: FieldPolicy<any> | FieldReadFunction<any>
  guestCommentsEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  guestInspectEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  invite?: FieldPolicy<any> | FieldReadFunction<any>
  inviter?: FieldPolicy<any> | FieldReadFunction<any>
  inviteStatus?: FieldPolicy<any> | FieldReadFunction<any>
  privateAccessLevel?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  userCanUpdateCommentsEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceMembership?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareMembershipAcceptPayloadKeySpecifier = (
  | 'errors'
  | 'membership'
  | 'successful'
  | ShareMembershipAcceptPayloadKeySpecifier
)[]
export type ShareMembershipAcceptPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  membership?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareMembershipChangedEventKeySpecifier = (
  | 'shareMembership'
  | ShareMembershipChangedEventKeySpecifier
)[]
export type ShareMembershipChangedEventFieldPolicy = {
  shareMembership?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareMembershipPaginationItemsKeySpecifier = (
  | 'entries'
  | 'meta'
  | ShareMembershipPaginationItemsKeySpecifier
)[]
export type ShareMembershipPaginationItemsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareMembershipsKeySpecifier = (
  | 'entries'
  | 'meta'
  | ShareMembershipsKeySpecifier
)[]
export type ShareMembershipsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareMoveResultKeySpecifier = (
  | 'errors'
  | 'project'
  | 'share'
  | 'successful'
  | ShareMoveResultKeySpecifier
)[]
export type ShareMoveResultFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareOwnerKeySpecifier = (
  | 'id'
  | 'identifier'
  | 'name'
  | ShareOwnerKeySpecifier
)[]
export type ShareOwnerFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareProjectChangedEventKeySpecifier = (
  | 'share'
  | 'shareIdentifier'
  | 'type'
  | 'workspace'
  | ShareProjectChangedEventKeySpecifier
)[]
export type ShareProjectChangedEventFieldPolicy = {
  share?: FieldPolicy<any> | FieldReadFunction<any>
  shareIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareRemovedFromCollectionEventKeySpecifier = (
  | 'collection'
  | 'destinationProjectIdentifier'
  | 'share'
  | ShareRemovedFromCollectionEventKeySpecifier
)[]
export type ShareRemovedFromCollectionEventFieldPolicy = {
  collection?: FieldPolicy<any> | FieldReadFunction<any>
  destinationProjectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareRemoveFromProjectResultKeySpecifier = (
  | 'errors'
  | 'project'
  | 'share'
  | 'successful'
  | ShareRemoveFromProjectResultKeySpecifier
)[]
export type ShareRemoveFromProjectResultFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareRequestAccessPayloadKeySpecifier = (
  | 'errors'
  | 'membership'
  | 'share'
  | 'successful'
  | ShareRequestAccessPayloadKeySpecifier
)[]
export type ShareRequestAccessPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  membership?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareRestoredEventKeySpecifier = (
  | 'share'
  | 'shareIdentifier'
  | 'type'
  | 'workspace'
  | ShareRestoredEventKeySpecifier
)[]
export type ShareRestoredEventFieldPolicy = {
  share?: FieldPolicy<any> | FieldReadFunction<any>
  shareIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareRestorePayloadKeySpecifier = (
  | 'errors'
  | 'share'
  | 'successful'
  | ShareRestorePayloadKeySpecifier
)[]
export type ShareRestorePayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SharesKeySpecifier = ('entries' | 'meta' | SharesKeySpecifier)[]
export type SharesFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SharesDeletePayloadKeySpecifier = (
  | 'shares'
  | SharesDeletePayloadKeySpecifier
)[]
export type SharesDeletePayloadFieldPolicy = {
  shares?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareTransferredEventKeySpecifier = (
  | 'oldProjectIdentifier'
  | 'oldSource'
  | 'oldWorkspaceIdentifier'
  | 'share'
  | 'shareIdentifier'
  | 'type'
  | 'workspace'
  | ShareTransferredEventKeySpecifier
)[]
export type ShareTransferredEventFieldPolicy = {
  oldProjectIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  oldSource?: FieldPolicy<any> | FieldReadFunction<any>
  oldWorkspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  shareIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareUnwatchPayloadKeySpecifier = (
  | 'errors'
  | 'share'
  | 'successful'
  | ShareUnwatchPayloadKeySpecifier
)[]
export type ShareUnwatchPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareUpdatedEventKeySpecifier = (
  | 'share'
  | 'shareIdentifier'
  | 'type'
  | 'workspace'
  | ShareUpdatedEventKeySpecifier
)[]
export type ShareUpdatedEventFieldPolicy = {
  share?: FieldPolicy<any> | FieldReadFunction<any>
  shareIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareUpdatePayloadKeySpecifier = (
  | 'errors'
  | 'share'
  | 'successful'
  | ShareUpdatePayloadKeySpecifier
)[]
export type ShareUpdatePayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareWatchPayloadKeySpecifier = (
  | 'errors'
  | 'share'
  | 'successful'
  | ShareWatchPayloadKeySpecifier
)[]
export type ShareWatchPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ShareWithSizeKeySpecifier = (
  | 'share'
  | 'size'
  | ShareWithSizeKeySpecifier
)[]
export type ShareWithSizeFieldPolicy = {
  share?: FieldPolicy<any> | FieldReadFunction<any>
  size?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SignInAndDisableMfaResponseKeySpecifier = (
  | 'credentials'
  | SignInAndDisableMfaResponseKeySpecifier
)[]
export type SignInAndDisableMfaResponseFieldPolicy = {
  credentials?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SignInCredentialsKeySpecifier = (
  | 'createdWorkspace'
  | 'credentials'
  | SignInCredentialsKeySpecifier
)[]
export type SignInCredentialsFieldPolicy = {
  createdWorkspace?: FieldPolicy<any> | FieldReadFunction<any>
  credentials?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SignInWithSsoResponseKeySpecifier = (
  | 'credentials'
  | 'workspaceId'
  | SignInWithSsoResponseKeySpecifier
)[]
export type SignInWithSsoResponseFieldPolicy = {
  credentials?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceId?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SignOffResponseKeySpecifier = (
  | 'successful'
  | SignOffResponseKeySpecifier
)[]
export type SignOffResponseFieldPolicy = {
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SignUpPayloadKeySpecifier = (
  | 'credentials'
  | 'errors'
  | 'successful'
  | 'user'
  | SignUpPayloadKeySpecifier
)[]
export type SignUpPayloadFieldPolicy = {
  credentials?: FieldPolicy<any> | FieldReadFunction<any>
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SingleImageKeySpecifier = (
  | 'alt'
  | 'src'
  | SingleImageKeySpecifier
)[]
export type SingleImageFieldPolicy = {
  alt?: FieldPolicy<any> | FieldReadFunction<any>
  src?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SizeKeySpecifier = (
  | 'lg'
  | 'md'
  | 'sm'
  | 'xl'
  | 'xs'
  | SizeKeySpecifier
)[]
export type SizeFieldPolicy = {
  lg?: FieldPolicy<any> | FieldReadFunction<any>
  md?: FieldPolicy<any> | FieldReadFunction<any>
  sm?: FieldPolicy<any> | FieldReadFunction<any>
  xl?: FieldPolicy<any> | FieldReadFunction<any>
  xs?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SocialAccountKeySpecifier = (
  | 'email'
  | 'identifier'
  | 'provider'
  | SocialAccountKeySpecifier
)[]
export type SocialAccountFieldPolicy = {
  email?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  provider?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SocialSignInStartUrlPayloadKeySpecifier = (
  | 'state'
  | 'url'
  | SocialSignInStartUrlPayloadKeySpecifier
)[]
export type SocialSignInStartUrlPayloadFieldPolicy = {
  state?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SpeakerKeySpecifier = (
  | 'image'
  | 'name'
  | 'role'
  | SpeakerKeySpecifier
)[]
export type SpeakerFieldPolicy = {
  image?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  role?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SsoMembershipProvisionedAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'auditSource'
  | 'createdAt'
  | 'user'
  | 'userEmail'
  | 'version'
  | SsoMembershipProvisionedAuditKeySpecifier
)[]
export type SsoMembershipProvisionedAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  auditSource?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  userEmail?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SsoStartPayloadKeySpecifier = (
  | 'errors'
  | 'successful'
  | 'url'
  | SsoStartPayloadKeySpecifier
)[]
export type SsoStartPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
}
export type StarNotificationKeySpecifier = (
  | 'createdAt'
  | 'identifier'
  | 'isPinned'
  | 'path'
  | 'share'
  | 'state'
  | 'subtitle'
  | 'title'
  | 'token'
  | 'url'
  | 'user'
  | 'version'
  | 'workspace'
  | StarNotificationKeySpecifier
)[]
export type StarNotificationFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isPinned?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  state?: FieldPolicy<any> | FieldReadFunction<any>
  subtitle?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
  token?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type StorageItemKeySpecifier = (
  | 'archivedAt'
  | 'createdAt'
  | 'deletedAt'
  | 'identifier'
  | 'name'
  | 'updatedAt'
  | 'workspace'
  | StorageItemKeySpecifier
)[]
export type StorageItemFieldPolicy = {
  archivedAt?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  deletedAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type StorageItemsKeySpecifier = (
  | 'entries'
  | 'meta'
  | StorageItemsKeySpecifier
)[]
export type StorageItemsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type StorageItemsPaginationMetaKeySpecifier = (
  | 'after'
  | 'before'
  | 'limit'
  | 'nestedProjectsCount'
  | 'sharesCount'
  | 'totalCount'
  | StorageItemsPaginationMetaKeySpecifier
)[]
export type StorageItemsPaginationMetaFieldPolicy = {
  after?: FieldPolicy<any> | FieldReadFunction<any>
  before?: FieldPolicy<any> | FieldReadFunction<any>
  limit?: FieldPolicy<any> | FieldReadFunction<any>
  nestedProjectsCount?: FieldPolicy<any> | FieldReadFunction<any>
  sharesCount?: FieldPolicy<any> | FieldReadFunction<any>
  totalCount?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SubscribeCustomerToPlanResponseKeySpecifier = (
  | 'customer'
  | 'pendingScaToken'
  | SubscribeCustomerToPlanResponseKeySpecifier
)[]
export type SubscribeCustomerToPlanResponseFieldPolicy = {
  customer?: FieldPolicy<any> | FieldReadFunction<any>
  pendingScaToken?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SubscriptionDetailsKeySpecifier = (
  | 'currentPlan'
  | 'currentSeatsTotal'
  | 'pendingScaToken'
  | 'provider'
  | 'renewalDate'
  | 'scheduledSeatsTotal'
  | 'status'
  | 'subscriptionEnd'
  | 'trialEnd'
  | SubscriptionDetailsKeySpecifier
)[]
export type SubscriptionDetailsFieldPolicy = {
  currentPlan?: FieldPolicy<any> | FieldReadFunction<any>
  currentSeatsTotal?: FieldPolicy<any> | FieldReadFunction<any>
  pendingScaToken?: FieldPolicy<any> | FieldReadFunction<any>
  provider?: FieldPolicy<any> | FieldReadFunction<any>
  renewalDate?: FieldPolicy<any> | FieldReadFunction<any>
  scheduledSeatsTotal?: FieldPolicy<any> | FieldReadFunction<any>
  status?: FieldPolicy<any> | FieldReadFunction<any>
  subscriptionEnd?: FieldPolicy<any> | FieldReadFunction<any>
  trialEnd?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SubscriptionInfoKeySpecifier = (
  | 'currentPlan'
  | 'currentSeatsTotal'
  | 'renewalDate'
  | 'status'
  | 'subscriptionEnd'
  | SubscriptionInfoKeySpecifier
)[]
export type SubscriptionInfoFieldPolicy = {
  currentPlan?: FieldPolicy<any> | FieldReadFunction<any>
  currentSeatsTotal?: FieldPolicy<any> | FieldReadFunction<any>
  renewalDate?: FieldPolicy<any> | FieldReadFunction<any>
  status?: FieldPolicy<any> | FieldReadFunction<any>
  subscriptionEnd?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SupportAccessDisabledAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'version'
  | SupportAccessDisabledAuditKeySpecifier
)[]
export type SupportAccessDisabledAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SupportAccessEnabledAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'until'
  | 'version'
  | SupportAccessEnabledAuditKeySpecifier
)[]
export type SupportAccessEnabledAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  until?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type SymbolKeySpecifier = (
  | 'artboard'
  | 'depth'
  | 'description'
  | 'frame'
  | 'identifier'
  | 'name'
  | 'path'
  | 'pathGroups'
  | 'pathInfo'
  | 'uuid'
  | SymbolKeySpecifier
)[]
export type SymbolFieldPolicy = {
  artboard?: FieldPolicy<any> | FieldReadFunction<any>
  depth?: FieldPolicy<any> | FieldReadFunction<any>
  description?: FieldPolicy<any> | FieldReadFunction<any>
  frame?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  pathGroups?: FieldPolicy<any> | FieldReadFunction<any>
  pathInfo?: FieldPolicy<any> | FieldReadFunction<any>
  uuid?: FieldPolicy<any> | FieldReadFunction<any>
}
export type TextStyleKeySpecifier = (
  | 'depth'
  | 'description'
  | 'files'
  | 'font'
  | 'horizontalAlignment'
  | 'identifier'
  | 'name'
  | 'needsContrastingBackground'
  | 'path'
  | 'pathGroups'
  | 'pathInfo'
  | 'uuid'
  | TextStyleKeySpecifier
)[]
export type TextStyleFieldPolicy = {
  depth?: FieldPolicy<any> | FieldReadFunction<any>
  description?: FieldPolicy<any> | FieldReadFunction<any>
  files?: FieldPolicy<any> | FieldReadFunction<any>
  font?: FieldPolicy<any> | FieldReadFunction<any>
  horizontalAlignment?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  needsContrastingBackground?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  pathGroups?: FieldPolicy<any> | FieldReadFunction<any>
  pathInfo?: FieldPolicy<any> | FieldReadFunction<any>
  uuid?: FieldPolicy<any> | FieldReadFunction<any>
}
export type TextStyleFontKeySpecifier = (
  | 'name'
  | 'size'
  | 'weight'
  | TextStyleFontKeySpecifier
)[]
export type TextStyleFontFieldPolicy = {
  name?: FieldPolicy<any> | FieldReadFunction<any>
  size?: FieldPolicy<any> | FieldReadFunction<any>
  weight?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ThumbnailKeySpecifier = (
  | 'height'
  | 'id'
  | 'identifier'
  | 'path'
  | 'size'
  | 'type'
  | 'url'
  | 'url2x'
  | 'width'
  | ThumbnailKeySpecifier
)[]
export type ThumbnailFieldPolicy = {
  height?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  size?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
  url2x?: FieldPolicy<any> | FieldReadFunction<any>
  width?: FieldPolicy<any> | FieldReadFunction<any>
}
export type TogglePasswordProtectedPreviewsResponseKeySpecifier = (
  | 'workspace'
  | TogglePasswordProtectedPreviewsResponseKeySpecifier
)[]
export type TogglePasswordProtectedPreviewsResponseFieldPolicy = {
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type TokenExportKeySpecifier = (
  | 'data'
  | 'downloadUrl'
  | TokenExportKeySpecifier
)[]
export type TokenExportFieldPolicy = {
  data?: FieldPolicy<any> | FieldReadFunction<any>
  downloadUrl?: FieldPolicy<any> | FieldReadFunction<any>
}
export type TransferDestinationsKeySpecifier = (
  | 'entries'
  | 'meta'
  | TransferDestinationsKeySpecifier
)[]
export type TransferDestinationsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type TransferOrganizationAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'newOwner'
  | 'oldOwner'
  | 'version'
  | TransferOrganizationAuditKeySpecifier
)[]
export type TransferOrganizationAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  newOwner?: FieldPolicy<any> | FieldReadFunction<any>
  oldOwner?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type TransferShareResponseKeySpecifier = (
  | 'share'
  | 'workspace'
  | TransferShareResponseKeySpecifier
)[]
export type TransferShareResponseFieldPolicy = {
  share?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type TransferStorageItemResponseKeySpecifier = (
  | 'storageItem'
  | TransferStorageItemResponseKeySpecifier
)[]
export type TransferStorageItemResponseFieldPolicy = {
  storageItem?: FieldPolicy<any> | FieldReadFunction<any>
}
export type TransferStorageItemsResponseKeySpecifier = (
  | 'storageItems'
  | TransferStorageItemsResponseKeySpecifier
)[]
export type TransferStorageItemsResponseFieldPolicy = {
  storageItems?: FieldPolicy<any> | FieldReadFunction<any>
}
export type TrashedItemsKeySpecifier = (
  | 'entries'
  | 'meta'
  | TrashedItemsKeySpecifier
)[]
export type TrashedItemsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type TrashedProjectKeySpecifier = (
  | 'deletedAt'
  | 'identifier'
  | 'name'
  | 'projectPrivacyIcon'
  | 'projectType'
  | 'shares'
  | 'shortId'
  | TrashedProjectKeySpecifier
)[]
export type TrashedProjectFieldPolicy = {
  deletedAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  projectPrivacyIcon?: FieldPolicy<any> | FieldReadFunction<any>
  projectType?: FieldPolicy<any> | FieldReadFunction<any>
  shares?: FieldPolicy<any> | FieldReadFunction<any>
  shortId?: FieldPolicy<any> | FieldReadFunction<any>
}
export type TrashedShareKeySpecifier = (
  | 'deletedAt'
  | 'identifier'
  | 'libraryEnabled'
  | 'name'
  | 'privacyIcon'
  | 'project'
  | 'sharePrivacyIcon'
  | 'shareType'
  | 'type'
  | 'updatedAt'
  | 'userAccessLevel'
  | 'userCanEdit'
  | 'version'
  | 'workspace'
  | TrashedShareKeySpecifier
)[]
export type TrashedShareFieldPolicy = {
  deletedAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  libraryEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  privacyIcon?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  sharePrivacyIcon?: FieldPolicy<any> | FieldReadFunction<any>
  shareType?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
  userAccessLevel?: FieldPolicy<any> | FieldReadFunction<any>
  userCanEdit?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type TrashedSharesKeySpecifier = (
  | 'entries'
  | 'meta'
  | TrashedSharesKeySpecifier
)[]
export type TrashedSharesFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type TrialAmendAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'newTrialEnd'
  | 'oldTrialEnd'
  | 'version'
  | TrialAmendAuditKeySpecifier
)[]
export type TrialAmendAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  newTrialEnd?: FieldPolicy<any> | FieldReadFunction<any>
  oldTrialEnd?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UnarchiveProjectKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'project'
  | 'version'
  | UnarchiveProjectKeySpecifier
)[]
export type UnarchiveProjectFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  project?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UnarchiveProjectResponseKeySpecifier = (
  | 'project'
  | UnarchiveProjectResponseKeySpecifier
)[]
export type UnarchiveProjectResponseFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UndoScheduledSubscriptionCancellationResponseKeySpecifier = (
  | 'customer'
  | UndoScheduledSubscriptionCancellationResponseKeySpecifier
)[]
export type UndoScheduledSubscriptionCancellationResponseFieldPolicy = {
  customer?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UninstallIntegrationAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'cause'
  | 'createdAt'
  | 'provider'
  | 'version'
  | UninstallIntegrationAuditKeySpecifier
)[]
export type UninstallIntegrationAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  cause?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  provider?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UnknownAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'version'
  | UnknownAuditKeySpecifier
)[]
export type UnknownAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UnlinkSocialAccountResponseKeySpecifier = (
  | 'user'
  | UnlinkSocialAccountResponseKeySpecifier
)[]
export type UnlinkSocialAccountResponseFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UnpaginatedCollectionKeySpecifier = (
  | 'identifier'
  | 'name'
  | UnpaginatedCollectionKeySpecifier
)[]
export type UnpaginatedCollectionFieldPolicy = {
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UnpaginatedCollectionShareKeySpecifier = (
  | 'file'
  | 'identifier'
  | 'name'
  | 'updatedAt'
  | UnpaginatedCollectionShareKeySpecifier
)[]
export type UnpaginatedCollectionShareFieldPolicy = {
  file?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UnpaginatedProjectKeySpecifier = (
  | 'identifier'
  | 'name'
  | UnpaginatedProjectKeySpecifier
)[]
export type UnpaginatedProjectFieldPolicy = {
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UnpinProjectResponseKeySpecifier = (
  | 'project'
  | UnpinProjectResponseKeySpecifier
)[]
export type UnpinProjectResponseFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UnpinShareResponseKeySpecifier = (
  | 'share'
  | UnpinShareResponseKeySpecifier
)[]
export type UnpinShareResponseFieldPolicy = {
  share?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UnprocessedPageKeySpecifier = (
  | 'uuid'
  | UnprocessedPageKeySpecifier
)[]
export type UnprocessedPageFieldPolicy = {
  uuid?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UnprocessedSubjectKeySpecifier = (
  | 'componentType'
  | 'type'
  | 'uuid'
  | UnprocessedSubjectKeySpecifier
)[]
export type UnprocessedSubjectFieldPolicy = {
  componentType?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  uuid?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UnpublishShareResponseKeySpecifier = (
  | 'share'
  | UnpublishShareResponseKeySpecifier
)[]
export type UnpublishShareResponseFieldPolicy = {
  share?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UnresolveAnnotationResponseKeySpecifier = (
  | 'annotation'
  | UnresolveAnnotationResponseKeySpecifier
)[]
export type UnresolveAnnotationResponseFieldPolicy = {
  annotation?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateBillingDetailsResponseKeySpecifier = (
  | 'customer'
  | UpdateBillingDetailsResponseKeySpecifier
)[]
export type UpdateBillingDetailsResponseFieldPolicy = {
  customer?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateBillingSeatsResponseKeySpecifier = (
  | 'pendingScaToken'
  | 'workspace'
  | UpdateBillingSeatsResponseKeySpecifier
)[]
export type UpdateBillingSeatsResponseFieldPolicy = {
  pendingScaToken?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateMembershipAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'auditSource'
  | 'changedAssignLicense'
  | 'changedRole'
  | 'createdAt'
  | 'user'
  | 'userEmail'
  | 'version'
  | UpdateMembershipAuditKeySpecifier
)[]
export type UpdateMembershipAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  auditSource?: FieldPolicy<any> | FieldReadFunction<any>
  changedAssignLicense?: FieldPolicy<any> | FieldReadFunction<any>
  changedRole?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  userEmail?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdatePaymentDetailsResponseKeySpecifier = (
  | 'customer'
  | UpdatePaymentDetailsResponseKeySpecifier
)[]
export type UpdatePaymentDetailsResponseFieldPolicy = {
  customer?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdatePermissionGroupKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'newName'
  | 'oldName'
  | 'permissionGroup'
  | 'version'
  | UpdatePermissionGroupKeySpecifier
)[]
export type UpdatePermissionGroupFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  newName?: FieldPolicy<any> | FieldReadFunction<any>
  oldName?: FieldPolicy<any> | FieldReadFunction<any>
  permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdatePermissionGroupRelationResponseKeySpecifier = (
  | 'relation'
  | UpdatePermissionGroupRelationResponseKeySpecifier
)[]
export type UpdatePermissionGroupRelationResponseFieldPolicy = {
  relation?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdatePermissionGroupResponseKeySpecifier = (
  | 'permissionGroup'
  | UpdatePermissionGroupResponseKeySpecifier
)[]
export type UpdatePermissionGroupResponseFieldPolicy = {
  permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdatePreviewResponseKeySpecifier = (
  | 'preview'
  | UpdatePreviewResponseKeySpecifier
)[]
export type UpdatePreviewResponseFieldPolicy = {
  preview?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateProjectMembershipResponseKeySpecifier = (
  | 'projectMembership'
  | UpdateProjectMembershipResponseKeySpecifier
)[]
export type UpdateProjectMembershipResponseFieldPolicy = {
  projectMembership?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateProjectPermissionResponseKeySpecifier = (
  | 'project'
  | UpdateProjectPermissionResponseKeySpecifier
)[]
export type UpdateProjectPermissionResponseFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateProjectResponseKeySpecifier = (
  | 'project'
  | UpdateProjectResponseKeySpecifier
)[]
export type UpdateProjectResponseFieldPolicy = {
  project?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateRestrictedPublicLinksResponseKeySpecifier = (
  | 'workspace'
  | UpdateRestrictedPublicLinksResponseKeySpecifier
)[]
export type UpdateRestrictedPublicLinksResponseFieldPolicy = {
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateRestrictedUploadsStateResponseKeySpecifier = (
  | 'workspace'
  | UpdateRestrictedUploadsStateResponseKeySpecifier
)[]
export type UpdateRestrictedUploadsStateResponseFieldPolicy = {
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateShareMembershipResponseKeySpecifier = (
  | 'shareMembership'
  | UpdateShareMembershipResponseKeySpecifier
)[]
export type UpdateShareMembershipResponseFieldPolicy = {
  shareMembership?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateSharePermissionGroupRelationResponseKeySpecifier = (
  | 'relation'
  | UpdateSharePermissionGroupRelationResponseKeySpecifier
)[]
export type UpdateSharePermissionGroupRelationResponseFieldPolicy = {
  relation?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateUserPreferencesResponseKeySpecifier = (
  | 'user'
  | UpdateUserPreferencesResponseKeySpecifier
)[]
export type UpdateUserPreferencesResponseFieldPolicy = {
  user?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateWorksapceCustomerSsoShortNameResponseKeySpecifier = (
  | 'customer'
  | UpdateWorksapceCustomerSsoShortNameResponseKeySpecifier
)[]
export type UpdateWorksapceCustomerSsoShortNameResponseFieldPolicy = {
  customer?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateWorkspaceAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'avatarChanged'
  | 'createdAt'
  | 'name'
  | 'version'
  | UpdateWorkspaceAuditKeySpecifier
)[]
export type UpdateWorkspaceAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  avatarChanged?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateWorkspaceCustomerSsoAttributeMappingResponseKeySpecifier = (
  | 'customer'
  | UpdateWorkspaceCustomerSsoAttributeMappingResponseKeySpecifier
)[]
export type UpdateWorkspaceCustomerSsoAttributeMappingResponseFieldPolicy = {
  customer?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateWorkspaceCustomerSsoIdentityProviderConfigResponseKeySpecifier =
  (
    | 'customer'
    | UpdateWorkspaceCustomerSsoIdentityProviderConfigResponseKeySpecifier
  )[]
export type UpdateWorkspaceCustomerSsoIdentityProviderConfigResponseFieldPolicy =
  {
    customer?: FieldPolicy<any> | FieldReadFunction<any>
  }
export type UpdateWorkspaceMemberResponseKeySpecifier = (
  | 'membership'
  | 'pendingScaToken'
  | UpdateWorkspaceMemberResponseKeySpecifier
)[]
export type UpdateWorkspaceMemberResponseFieldPolicy = {
  membership?: FieldPolicy<any> | FieldReadFunction<any>
  pendingScaToken?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateWorkspaceProfileResponseKeySpecifier = (
  | 'workspaceProfile'
  | UpdateWorkspaceProfileResponseKeySpecifier
)[]
export type UpdateWorkspaceProfileResponseFieldPolicy = {
  workspaceProfile?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateWorkspaceProfileShortUrlResponseKeySpecifier = (
  | 'workspaceProfile'
  | UpdateWorkspaceProfileShortUrlResponseKeySpecifier
)[]
export type UpdateWorkspaceProfileShortUrlResponseFieldPolicy = {
  workspaceProfile?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateWorkspaceResponseKeySpecifier = (
  | 'workspace'
  | UpdateWorkspaceResponseKeySpecifier
)[]
export type UpdateWorkspaceResponseFieldPolicy = {
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpdateWorkspaceSecurityEmailResponseKeySpecifier = (
  | 'workspace'
  | UpdateWorkspaceSecurityEmailResponseKeySpecifier
)[]
export type UpdateWorkspaceSecurityEmailResponseFieldPolicy = {
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpgradePersonalWorkspaceAuditKeySpecifier = (
  | 'action'
  | 'actor'
  | 'createdAt'
  | 'version'
  | UpgradePersonalWorkspaceAuditKeySpecifier
)[]
export type UpgradePersonalWorkspaceAuditFieldPolicy = {
  action?: FieldPolicy<any> | FieldReadFunction<any>
  actor?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  version?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UpgradePersonalWorkspaceResponseKeySpecifier = (
  | 'pendingScaToken'
  | 'workspace'
  | UpgradePersonalWorkspaceResponseKeySpecifier
)[]
export type UpgradePersonalWorkspaceResponseFieldPolicy = {
  pendingScaToken?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UserKeySpecifier = (
  | 'activeSessions'
  | 'avatar'
  | 'createdAt'
  | 'eligibleForWorkspaceTrial'
  | 'email'
  | 'featureFlags'
  | 'friendlyName'
  | 'hasAcceptedAgreement'
  | 'hasAvatar'
  | 'hasPersonalIdentity'
  | 'hasUnreadNotifications'
  | 'hasUnseenNotifications'
  | 'id'
  | 'identifier'
  | 'isPaasAdmin'
  | 'isPartner'
  | 'isSuperadmin'
  | 'isVerified'
  | 'isWebSignup'
  | 'mfaState'
  | 'name'
  | 'newEmail'
  | 'notifications'
  | 'organizationMemberships'
  | 'organizations'
  | 'personalIdentityEmail'
  | 'personalWorkspace'
  | 'preferences'
  | 'professionalRole'
  | 'projects'
  | 'receiveEmailNotifications'
  | 'scimPersonalAccessTokens'
  | 'shares'
  | 'sharesTrashed'
  | 'signInOptions'
  | 'socialAccounts'
  | 'ssoLinkToken'
  | 'updatedAt'
  | 'workspaceCustomers'
  | 'workspaceMemberships'
  | 'workspaces'
  | UserKeySpecifier
)[]
export type UserFieldPolicy = {
  activeSessions?: FieldPolicy<any> | FieldReadFunction<any>
  avatar?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  eligibleForWorkspaceTrial?: FieldPolicy<any> | FieldReadFunction<any>
  email?: FieldPolicy<any> | FieldReadFunction<any>
  featureFlags?: FieldPolicy<any> | FieldReadFunction<any>
  friendlyName?: FieldPolicy<any> | FieldReadFunction<any>
  hasAcceptedAgreement?: FieldPolicy<any> | FieldReadFunction<any>
  hasAvatar?: FieldPolicy<any> | FieldReadFunction<any>
  hasPersonalIdentity?: FieldPolicy<any> | FieldReadFunction<any>
  hasUnreadNotifications?: FieldPolicy<any> | FieldReadFunction<any>
  hasUnseenNotifications?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isPaasAdmin?: FieldPolicy<any> | FieldReadFunction<any>
  isPartner?: FieldPolicy<any> | FieldReadFunction<any>
  isSuperadmin?: FieldPolicy<any> | FieldReadFunction<any>
  isVerified?: FieldPolicy<any> | FieldReadFunction<any>
  isWebSignup?: FieldPolicy<any> | FieldReadFunction<any>
  mfaState?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  newEmail?: FieldPolicy<any> | FieldReadFunction<any>
  notifications?: FieldPolicy<any> | FieldReadFunction<any>
  organizationMemberships?: FieldPolicy<any> | FieldReadFunction<any>
  organizations?: FieldPolicy<any> | FieldReadFunction<any>
  personalIdentityEmail?: FieldPolicy<any> | FieldReadFunction<any>
  personalWorkspace?: FieldPolicy<any> | FieldReadFunction<any>
  preferences?: FieldPolicy<any> | FieldReadFunction<any>
  professionalRole?: FieldPolicy<any> | FieldReadFunction<any>
  projects?: FieldPolicy<any> | FieldReadFunction<any>
  receiveEmailNotifications?: FieldPolicy<any> | FieldReadFunction<any>
  scimPersonalAccessTokens?: FieldPolicy<any> | FieldReadFunction<any>
  shares?: FieldPolicy<any> | FieldReadFunction<any>
  sharesTrashed?: FieldPolicy<any> | FieldReadFunction<any>
  signInOptions?: FieldPolicy<any> | FieldReadFunction<any>
  socialAccounts?: FieldPolicy<any> | FieldReadFunction<any>
  ssoLinkToken?: FieldPolicy<any> | FieldReadFunction<any>
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceCustomers?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceMemberships?: FieldPolicy<any> | FieldReadFunction<any>
  workspaces?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UserAcceptTosAgreementPayloadKeySpecifier = (
  | 'errors'
  | 'successful'
  | UserAcceptTosAgreementPayloadKeySpecifier
)[]
export type UserAcceptTosAgreementPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UserAvatarCreateKeySpecifier = (
  | 'errors'
  | 'successful'
  | 'user'
  | UserAvatarCreateKeySpecifier
)[]
export type UserAvatarCreateFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UserAvatarDeletePayloadKeySpecifier = (
  | 'errors'
  | 'successful'
  | 'user'
  | UserAvatarDeletePayloadKeySpecifier
)[]
export type UserAvatarDeletePayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UserDeletePayloadKeySpecifier = (
  | 'errors'
  | 'successful'
  | UserDeletePayloadKeySpecifier
)[]
export type UserDeletePayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UserErrorKeySpecifier = (
  | 'code'
  | 'context'
  | 'extensions'
  | 'message'
  | UserErrorKeySpecifier
)[]
export type UserErrorFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>
  context?: FieldPolicy<any> | FieldReadFunction<any>
  extensions?: FieldPolicy<any> | FieldReadFunction<any>
  message?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UserErrorExtensionsKeySpecifier = (
  | 'code'
  | 'minimumRequiredClientVersion'
  | 'reason'
  | 'stripeErrorCode'
  | UserErrorExtensionsKeySpecifier
)[]
export type UserErrorExtensionsFieldPolicy = {
  code?: FieldPolicy<any> | FieldReadFunction<any>
  minimumRequiredClientVersion?: FieldPolicy<any> | FieldReadFunction<any>
  reason?: FieldPolicy<any> | FieldReadFunction<any>
  stripeErrorCode?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UserNotificationKeySpecifier = (
  | 'createdAt'
  | 'identifier'
  | 'isPinned'
  | 'path'
  | 'share'
  | 'state'
  | 'subtitle'
  | 'title'
  | 'token'
  | 'url'
  | 'user'
  | 'workspace'
  | UserNotificationKeySpecifier
)[]
export type UserNotificationFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isPinned?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  state?: FieldPolicy<any> | FieldReadFunction<any>
  subtitle?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
  token?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UserPasswordResetPayloadKeySpecifier = (
  | 'errors'
  | 'successful'
  | UserPasswordResetPayloadKeySpecifier
)[]
export type UserPasswordResetPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UserPasswordUpdatePayloadKeySpecifier = (
  | 'errors'
  | 'successful'
  | 'user'
  | UserPasswordUpdatePayloadKeySpecifier
)[]
export type UserPasswordUpdatePayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UserPreferencesKeySpecifier = (
  | 'showOnboardingFirstSteps'
  | 'showStorageLimitChanges'
  | UserPreferencesKeySpecifier
)[]
export type UserPreferencesFieldPolicy = {
  showOnboardingFirstSteps?: FieldPolicy<any> | FieldReadFunction<any>
  showStorageLimitChanges?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UserRequestPasswordResetPayloadKeySpecifier = (
  | 'errors'
  | 'successful'
  | UserRequestPasswordResetPayloadKeySpecifier
)[]
export type UserRequestPasswordResetPayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
}
export type UserUpdatePayloadKeySpecifier = (
  | 'errors'
  | 'successful'
  | 'user'
  | UserUpdatePayloadKeySpecifier
)[]
export type UserUpdatePayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
}
export type ValidateMFAResponseKeySpecifier = (
  | 'createdWorkspace'
  | 'credentials'
  | ValidateMFAResponseKeySpecifier
)[]
export type ValidateMFAResponseFieldPolicy = {
  createdWorkspace?: FieldPolicy<any> | FieldReadFunction<any>
  credentials?: FieldPolicy<any> | FieldReadFunction<any>
}
export type VersionKeySpecifier = (
  | 'createdAfterVersioning'
  | 'createdAt'
  | 'creator'
  | 'deletedAt'
  | 'description'
  | 'document'
  | 'hasComponentManifest'
  | 'id'
  | 'identifier'
  | 'kind'
  | 'message'
  | 'order'
  | 'presentationStatus'
  | 'previewFiles'
  | 'previewThumbnails'
  | 'share'
  | 'shortId'
  | 'updatedAt'
  | 'userIsCreator'
  | 'viewerIsCreator'
  | VersionKeySpecifier
)[]
export type VersionFieldPolicy = {
  createdAfterVersioning?: FieldPolicy<any> | FieldReadFunction<any>
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  creator?: FieldPolicy<any> | FieldReadFunction<any>
  deletedAt?: FieldPolicy<any> | FieldReadFunction<any>
  description?: FieldPolicy<any> | FieldReadFunction<any>
  document?: FieldPolicy<any> | FieldReadFunction<any>
  hasComponentManifest?: FieldPolicy<any> | FieldReadFunction<any>
  id?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  kind?: FieldPolicy<any> | FieldReadFunction<any>
  message?: FieldPolicy<any> | FieldReadFunction<any>
  order?: FieldPolicy<any> | FieldReadFunction<any>
  presentationStatus?: FieldPolicy<any> | FieldReadFunction<any>
  previewFiles?: FieldPolicy<any> | FieldReadFunction<any>
  previewThumbnails?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  shortId?: FieldPolicy<any> | FieldReadFunction<any>
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
  userIsCreator?: FieldPolicy<any> | FieldReadFunction<any>
  viewerIsCreator?: FieldPolicy<any> | FieldReadFunction<any>
}
export type VersionDeletedKeySpecifier = (
  | 'createdAt'
  | 'creator'
  | 'deletedAt'
  | 'identifier'
  | 'kind'
  | 'order'
  | 'shortId'
  | 'updatedAt'
  | 'userIsCreator'
  | VersionDeletedKeySpecifier
)[]
export type VersionDeletedFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  creator?: FieldPolicy<any> | FieldReadFunction<any>
  deletedAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  kind?: FieldPolicy<any> | FieldReadFunction<any>
  order?: FieldPolicy<any> | FieldReadFunction<any>
  shortId?: FieldPolicy<any> | FieldReadFunction<any>
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
  userIsCreator?: FieldPolicy<any> | FieldReadFunction<any>
}
export type VersionDeletedEventKeySpecifier = (
  | 'share'
  | 'versionDeleted'
  | VersionDeletedEventKeySpecifier
)[]
export type VersionDeletedEventFieldPolicy = {
  share?: FieldPolicy<any> | FieldReadFunction<any>
  versionDeleted?: FieldPolicy<any> | FieldReadFunction<any>
}
export type VersionDeletePayloadKeySpecifier = (
  | 'errors'
  | 'share'
  | 'successful'
  | 'versionDeleted'
  | VersionDeletePayloadKeySpecifier
)[]
export type VersionDeletePayloadFieldPolicy = {
  errors?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  successful?: FieldPolicy<any> | FieldReadFunction<any>
  versionDeleted?: FieldPolicy<any> | FieldReadFunction<any>
}
export type VersionHistoryKeySpecifier = (
  | 'entries'
  | 'meta'
  | VersionHistoryKeySpecifier
)[]
export type VersionHistoryFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type VersionsKeySpecifier = ('entries' | 'meta' | VersionsKeySpecifier)[]
export type VersionsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type VersionUnavailableKeySpecifier = (
  | 'createdAt'
  | 'creator'
  | 'identifier'
  | 'order'
  | 'userIsCreator'
  | VersionUnavailableKeySpecifier
)[]
export type VersionUnavailableFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  creator?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  order?: FieldPolicy<any> | FieldReadFunction<any>
  userIsCreator?: FieldPolicy<any> | FieldReadFunction<any>
}
export type VideoKeySpecifier = ('retina' | 'standard' | VideoKeySpecifier)[]
export type VideoFieldPolicy = {
  retina?: FieldPolicy<any> | FieldReadFunction<any>
  standard?: FieldPolicy<any> | FieldReadFunction<any>
}
export type VideoSourceKeySpecifier = (
  | 'backgroundColor'
  | 'poster'
  | 'src'
  | VideoSourceKeySpecifier
)[]
export type VideoSourceFieldPolicy = {
  backgroundColor?: FieldPolicy<any> | FieldReadFunction<any>
  poster?: FieldPolicy<any> | FieldReadFunction<any>
  src?: FieldPolicy<any> | FieldReadFunction<any>
}
export type VisibilityKeySpecifier = (
  | 'hiddenForFF'
  | 'hideOnBreakpoint'
  | VisibilityKeySpecifier
)[]
export type VisibilityFieldPolicy = {
  hiddenForFF?: FieldPolicy<any> | FieldReadFunction<any>
  hideOnBreakpoint?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceKeySpecifier = (
  | 'avatar'
  | 'canUseRestrictedUploads'
  | 'customer'
  | 'encryptionConfig'
  | 'featureFlags'
  | 'features'
  | 'identifier'
  | 'integrations'
  | 'memberships'
  | 'name'
  | 'permissionGroups'
  | 'profile'
  | 'projects'
  | 'scimEnabled'
  | 'scimEndpoint'
  | 'securityEmail'
  | 'shares'
  | 'status'
  | 'storageItems'
  | 'supportAccessGrantedUntil'
  | 'type'
  | 'uploadsRestrictedFor'
  | 'userCanAdminister'
  | 'userCanEdit'
  | 'userHasEditableContent'
  | 'userIsMember'
  | 'userIsOwner'
  | 'userRole'
  | 'workspaceMembership'
  | WorkspaceKeySpecifier
)[]
export type WorkspaceFieldPolicy = {
  avatar?: FieldPolicy<any> | FieldReadFunction<any>
  canUseRestrictedUploads?: FieldPolicy<any> | FieldReadFunction<any>
  customer?: FieldPolicy<any> | FieldReadFunction<any>
  encryptionConfig?: FieldPolicy<any> | FieldReadFunction<any>
  featureFlags?: FieldPolicy<any> | FieldReadFunction<any>
  features?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  integrations?: FieldPolicy<any> | FieldReadFunction<any>
  memberships?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
  permissionGroups?: FieldPolicy<any> | FieldReadFunction<any>
  profile?: FieldPolicy<any> | FieldReadFunction<any>
  projects?: FieldPolicy<any> | FieldReadFunction<any>
  scimEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  scimEndpoint?: FieldPolicy<any> | FieldReadFunction<any>
  securityEmail?: FieldPolicy<any> | FieldReadFunction<any>
  shares?: FieldPolicy<any> | FieldReadFunction<any>
  status?: FieldPolicy<any> | FieldReadFunction<any>
  storageItems?: FieldPolicy<any> | FieldReadFunction<any>
  supportAccessGrantedUntil?: FieldPolicy<any> | FieldReadFunction<any>
  type?: FieldPolicy<any> | FieldReadFunction<any>
  uploadsRestrictedFor?: FieldPolicy<any> | FieldReadFunction<any>
  userCanAdminister?: FieldPolicy<any> | FieldReadFunction<any>
  userCanEdit?: FieldPolicy<any> | FieldReadFunction<any>
  userHasEditableContent?: FieldPolicy<any> | FieldReadFunction<any>
  userIsMember?: FieldPolicy<any> | FieldReadFunction<any>
  userIsOwner?: FieldPolicy<any> | FieldReadFunction<any>
  userRole?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceMembership?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceAuditLogsKeySpecifier = (
  | 'entries'
  | 'meta'
  | WorkspaceAuditLogsKeySpecifier
)[]
export type WorkspaceAuditLogsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceChangedEventKeySpecifier = (
  | 'customerIdentifier'
  | 'customerStatus'
  | 'customerSubscriptionEnd'
  | 'customerTrialEnd'
  | 'workspaceIdentifier'
  | WorkspaceChangedEventKeySpecifier
)[]
export type WorkspaceChangedEventFieldPolicy = {
  customerIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  customerStatus?: FieldPolicy<any> | FieldReadFunction<any>
  customerSubscriptionEnd?: FieldPolicy<any> | FieldReadFunction<any>
  customerTrialEnd?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceCustomerKeySpecifier = (
  | 'billing'
  | 'canUseSso'
  | 'identifier'
  | 'source'
  | 'ssoConfig'
  | 'ssoEnabled'
  | 'ssoShortName'
  | 'ssoStartUrl'
  | 'tosAgreed'
  | 'workspaces'
  | WorkspaceCustomerKeySpecifier
)[]
export type WorkspaceCustomerFieldPolicy = {
  billing?: FieldPolicy<any> | FieldReadFunction<any>
  canUseSso?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  source?: FieldPolicy<any> | FieldReadFunction<any>
  ssoConfig?: FieldPolicy<any> | FieldReadFunction<any>
  ssoEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  ssoShortName?: FieldPolicy<any> | FieldReadFunction<any>
  ssoStartUrl?: FieldPolicy<any> | FieldReadFunction<any>
  tosAgreed?: FieldPolicy<any> | FieldReadFunction<any>
  workspaces?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceCustomerSubscriptionUpdatedEventKeySpecifier = (
  | 'customerIdentifier'
  | 'customerWorkspaces'
  | 'status'
  | 'subscriptionEnd'
  | 'trialEnd'
  | WorkspaceCustomerSubscriptionUpdatedEventKeySpecifier
)[]
export type WorkspaceCustomerSubscriptionUpdatedEventFieldPolicy = {
  customerIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
  customerWorkspaces?: FieldPolicy<any> | FieldReadFunction<any>
  status?: FieldPolicy<any> | FieldReadFunction<any>
  subscriptionEnd?: FieldPolicy<any> | FieldReadFunction<any>
  trialEnd?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceFeaturesKeySpecifier = (
  | 'accountLinkingEnabled'
  | 'archiveEnabled'
  | 'encryptionEnabled'
  | 'passwordProtectedPreviewsEnabled'
  | 'permissionGroupsEnabled'
  | 'restrictedPublicLinks'
  | 'scimAccessEnabled'
  | 'scimAutoLinkEnabled'
  | 'ssoEnabled'
  | 'unlimitedStorageEnabled'
  | 'unlimitedTrialEnabled'
  | 'userDirectoryEnabled'
  | 'workspaceProfileEnabled'
  | WorkspaceFeaturesKeySpecifier
)[]
export type WorkspaceFeaturesFieldPolicy = {
  accountLinkingEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  archiveEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  encryptionEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  passwordProtectedPreviewsEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  permissionGroupsEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  restrictedPublicLinks?: FieldPolicy<any> | FieldReadFunction<any>
  scimAccessEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  scimAutoLinkEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  ssoEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  unlimitedStorageEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  unlimitedTrialEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  userDirectoryEnabled?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceProfileEnabled?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceIntegrationKeySpecifier = (
  | 'createdAt'
  | 'externalWorkspaceName'
  | 'identifier'
  | 'integrationProvider'
  | 'isActive'
  | 'managedBy'
  | WorkspaceIntegrationKeySpecifier
)[]
export type WorkspaceIntegrationFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  externalWorkspaceName?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  integrationProvider?: FieldPolicy<any> | FieldReadFunction<any>
  isActive?: FieldPolicy<any> | FieldReadFunction<any>
  managedBy?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceIntegrationIdentityKeySpecifier = (
  | 'createdAt'
  | 'identifier'
  | 'integration'
  | WorkspaceIntegrationIdentityKeySpecifier
)[]
export type WorkspaceIntegrationIdentityFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  integration?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceInviteKeySpecifier = (
  | 'email'
  | 'identifier'
  | WorkspaceInviteKeySpecifier
)[]
export type WorkspaceInviteFieldPolicy = {
  email?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceInviteAcceptedNotificationKeySpecifier = (
  | 'createdAt'
  | 'identifier'
  | 'isPinned'
  | 'membership'
  | 'path'
  | 'share'
  | 'state'
  | 'subtitle'
  | 'title'
  | 'token'
  | 'url'
  | 'user'
  | 'workspace'
  | WorkspaceInviteAcceptedNotificationKeySpecifier
)[]
export type WorkspaceInviteAcceptedNotificationFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isPinned?: FieldPolicy<any> | FieldReadFunction<any>
  membership?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  state?: FieldPolicy<any> | FieldReadFunction<any>
  subtitle?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
  token?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceInvitedNotificationKeySpecifier = (
  | 'createdAt'
  | 'identifier'
  | 'isPinned'
  | 'membership'
  | 'path'
  | 'share'
  | 'state'
  | 'subtitle'
  | 'title'
  | 'token'
  | 'url'
  | 'user'
  | 'workspace'
  | WorkspaceInvitedNotificationKeySpecifier
)[]
export type WorkspaceInvitedNotificationFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isPinned?: FieldPolicy<any> | FieldReadFunction<any>
  membership?: FieldPolicy<any> | FieldReadFunction<any>
  path?: FieldPolicy<any> | FieldReadFunction<any>
  share?: FieldPolicy<any> | FieldReadFunction<any>
  state?: FieldPolicy<any> | FieldReadFunction<any>
  subtitle?: FieldPolicy<any> | FieldReadFunction<any>
  title?: FieldPolicy<any> | FieldReadFunction<any>
  token?: FieldPolicy<any> | FieldReadFunction<any>
  url?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceMembersKeySpecifier = (
  | 'entries'
  | 'meta'
  | WorkspaceMembersKeySpecifier
)[]
export type WorkspaceMembersFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceMembershipKeySpecifier = (
  | 'acceptedAt'
  | 'activityStatus'
  | 'identifier'
  | 'integrationIdentities'
  | 'invite'
  | 'inviter'
  | 'isEditor'
  | 'isOwner'
  | 'permissionGroupMemberships'
  | 'projectMemberships'
  | 'role'
  | 'shareMemberships'
  | 'user'
  | 'workspace'
  | WorkspaceMembershipKeySpecifier
)[]
export type WorkspaceMembershipFieldPolicy = {
  acceptedAt?: FieldPolicy<any> | FieldReadFunction<any>
  activityStatus?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  integrationIdentities?: FieldPolicy<any> | FieldReadFunction<any>
  invite?: FieldPolicy<any> | FieldReadFunction<any>
  inviter?: FieldPolicy<any> | FieldReadFunction<any>
  isEditor?: FieldPolicy<any> | FieldReadFunction<any>
  isOwner?: FieldPolicy<any> | FieldReadFunction<any>
  permissionGroupMemberships?: FieldPolicy<any> | FieldReadFunction<any>
  projectMemberships?: FieldPolicy<any> | FieldReadFunction<any>
  role?: FieldPolicy<any> | FieldReadFunction<any>
  shareMemberships?: FieldPolicy<any> | FieldReadFunction<any>
  user?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceMembershipsKeySpecifier = (
  | 'entries'
  | 'meta'
  | WorkspaceMembershipsKeySpecifier
)[]
export type WorkspaceMembershipsFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceMembershipsRestrictedKeySpecifier = (
  | 'list'
  | 'userCanAccess'
  | WorkspaceMembershipsRestrictedKeySpecifier
)[]
export type WorkspaceMembershipsRestrictedFieldPolicy = {
  list?: FieldPolicy<any> | FieldReadFunction<any>
  userCanAccess?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceMembershipUpdatedEventKeySpecifier = (
  | 'status'
  | 'workspaceIdentifier'
  | WorkspaceMembershipUpdatedEventKeySpecifier
)[]
export type WorkspaceMembershipUpdatedEventFieldPolicy = {
  status?: FieldPolicy<any> | FieldReadFunction<any>
  workspaceIdentifier?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceMembersReportResponseKeySpecifier = (
  | 'downloadUrl'
  | WorkspaceMembersReportResponseKeySpecifier
)[]
export type WorkspaceMembersReportResponseFieldPolicy = {
  downloadUrl?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceProfileKeySpecifier = (
  | 'description'
  | 'donateUrl'
  | 'identifier'
  | 'isOfficial'
  | 'isPublic'
  | 'publications'
  | 'shortUrlName'
  | 'websiteUrl'
  | 'workspace'
  | WorkspaceProfileKeySpecifier
)[]
export type WorkspaceProfileFieldPolicy = {
  description?: FieldPolicy<any> | FieldReadFunction<any>
  donateUrl?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  isOfficial?: FieldPolicy<any> | FieldReadFunction<any>
  isPublic?: FieldPolicy<any> | FieldReadFunction<any>
  publications?: FieldPolicy<any> | FieldReadFunction<any>
  shortUrlName?: FieldPolicy<any> | FieldReadFunction<any>
  websiteUrl?: FieldPolicy<any> | FieldReadFunction<any>
  workspace?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspacesKeySpecifier = (
  | 'entries'
  | 'meta'
  | WorkspacesKeySpecifier
)[]
export type WorkspacesFieldPolicy = {
  entries?: FieldPolicy<any> | FieldReadFunction<any>
  meta?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceSsoConfigKeySpecifier = (
  | 'acsUrl'
  | 'attributeMapping'
  | 'config'
  | 'serviceProviderEntityId'
  | WorkspaceSsoConfigKeySpecifier
)[]
export type WorkspaceSsoConfigFieldPolicy = {
  acsUrl?: FieldPolicy<any> | FieldReadFunction<any>
  attributeMapping?: FieldPolicy<any> | FieldReadFunction<any>
  config?: FieldPolicy<any> | FieldReadFunction<any>
  serviceProviderEntityId?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceStorageKeySpecifier = (
  | 'limit'
  | 'shareCount'
  | 'used'
  | WorkspaceStorageKeySpecifier
)[]
export type WorkspaceStorageFieldPolicy = {
  limit?: FieldPolicy<any> | FieldReadFunction<any>
  shareCount?: FieldPolicy<any> | FieldReadFunction<any>
  used?: FieldPolicy<any> | FieldReadFunction<any>
}
export type WorkspaceUserKeySpecifier = (
  | 'avatar'
  | 'email'
  | 'identifier'
  | 'name'
  | WorkspaceUserKeySpecifier
)[]
export type WorkspaceUserFieldPolicy = {
  avatar?: FieldPolicy<any> | FieldReadFunction<any>
  email?: FieldPolicy<any> | FieldReadFunction<any>
  identifier?: FieldPolicy<any> | FieldReadFunction<any>
  name?: FieldPolicy<any> | FieldReadFunction<any>
}
export type StrictTypedTypePolicies = {
  AcceptMembershipInviteAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AcceptMembershipInviteAuditKeySpecifier
      | (() => undefined | AcceptMembershipInviteAuditKeySpecifier)
    fields?: AcceptMembershipInviteAuditFieldPolicy
  }
  AcceptProjectAccessRequestResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | AcceptProjectAccessRequestResponseKeySpecifier
      | (() => undefined | AcceptProjectAccessRequestResponseKeySpecifier)
    fields?: AcceptProjectAccessRequestResponseFieldPolicy
  }
  AcceptProjectMembershipInvitationResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | AcceptProjectMembershipInvitationResponseKeySpecifier
      | (() =>
          | undefined
          | AcceptProjectMembershipInvitationResponseKeySpecifier)
    fields?: AcceptProjectMembershipInvitationResponseFieldPolicy
  }
  AcceptWorkspaceInviteResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AcceptWorkspaceInviteResponseKeySpecifier
      | (() => undefined | AcceptWorkspaceInviteResponseKeySpecifier)
    fields?: AcceptWorkspaceInviteResponseFieldPolicy
  }
  AccountExistsResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AccountExistsResponseKeySpecifier
      | (() => undefined | AccountExistsResponseKeySpecifier)
    fields?: AccountExistsResponseFieldPolicy
  }
  ActivityStatus?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ActivityStatusKeySpecifier
      | (() => undefined | ActivityStatusKeySpecifier)
    fields?: ActivityStatusFieldPolicy
  }
  AddMemberPermissionGroup?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddMemberPermissionGroupKeySpecifier
      | (() => undefined | AddMemberPermissionGroupKeySpecifier)
    fields?: AddMemberPermissionGroupFieldPolicy
  }
  AddPermissionGroupMembersResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | AddPermissionGroupMembersResponseKeySpecifier
      | (() => undefined | AddPermissionGroupMembersResponseKeySpecifier)
    fields?: AddPermissionGroupMembersResponseFieldPolicy
  }
  AddPermissionGroupRelationResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | AddPermissionGroupRelationResponseKeySpecifier
      | (() => undefined | AddPermissionGroupRelationResponseKeySpecifier)
    fields?: AddPermissionGroupRelationResponseFieldPolicy
  }
  AddProjectMemberNotification?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddProjectMemberNotificationKeySpecifier
      | (() => undefined | AddProjectMemberNotificationKeySpecifier)
    fields?: AddProjectMemberNotificationFieldPolicy
  }
  AddProjectMemberResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddProjectMemberResponseKeySpecifier
      | (() => undefined | AddProjectMemberResponseKeySpecifier)
    fields?: AddProjectMemberResponseFieldPolicy
  }
  AddProjectPermissionGroupRelationResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | AddProjectPermissionGroupRelationResponseKeySpecifier
      | (() =>
          | undefined
          | AddProjectPermissionGroupRelationResponseKeySpecifier)
    fields?: AddProjectPermissionGroupRelationResponseFieldPolicy
  }
  AddReactionToPublicationResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | AddReactionToPublicationResponseKeySpecifier
      | (() => undefined | AddReactionToPublicationResponseKeySpecifier)
    fields?: AddReactionToPublicationResponseFieldPolicy
  }
  AddShareMemberNotification?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddShareMemberNotificationKeySpecifier
      | (() => undefined | AddShareMemberNotificationKeySpecifier)
    fields?: AddShareMemberNotificationFieldPolicy
  }
  AddShareMembershipResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddShareMembershipResponseKeySpecifier
      | (() => undefined | AddShareMembershipResponseKeySpecifier)
    fields?: AddShareMembershipResponseFieldPolicy
  }
  AddSharePermissionGroupRelationResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | AddSharePermissionGroupRelationResponseKeySpecifier
      | (() => undefined | AddSharePermissionGroupRelationResponseKeySpecifier)
    fields?: AddSharePermissionGroupRelationResponseFieldPolicy
  }
  AddSharesToCollectionResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AddSharesToCollectionResponseKeySpecifier
      | (() => undefined | AddSharesToCollectionResponseKeySpecifier)
    fields?: AddSharesToCollectionResponseFieldPolicy
  }
  AgreeToWorkspaceTermsOfServiceResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | AgreeToWorkspaceTermsOfServiceResponseKeySpecifier
      | (() => undefined | AgreeToWorkspaceTermsOfServiceResponseKeySpecifier)
    fields?: AgreeToWorkspaceTermsOfServiceResponseFieldPolicy
  }
  Annotation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AnnotationKeySpecifier
      | (() => undefined | AnnotationKeySpecifier)
    fields?: AnnotationFieldPolicy
  }
  AnnotationCoordinates?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AnnotationCoordinatesKeySpecifier
      | (() => undefined | AnnotationCoordinatesKeySpecifier)
    fields?: AnnotationCoordinatesFieldPolicy
  }
  AnnotationDeletedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AnnotationDeletedEventKeySpecifier
      | (() => undefined | AnnotationDeletedEventKeySpecifier)
    fields?: AnnotationDeletedEventFieldPolicy
  }
  AnnotationResolution?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AnnotationResolutionKeySpecifier
      | (() => undefined | AnnotationResolutionKeySpecifier)
    fields?: AnnotationResolutionFieldPolicy
  }
  Annotations?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AnnotationsKeySpecifier
      | (() => undefined | AnnotationsKeySpecifier)
    fields?: AnnotationsFieldPolicy
  }
  ApplyCouponResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ApplyCouponResponseKeySpecifier
      | (() => undefined | ApplyCouponResponseKeySpecifier)
    fields?: ApplyCouponResponseFieldPolicy
  }
  ApprovedEducationRequestAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ApprovedEducationRequestAuditKeySpecifier
      | (() => undefined | ApprovedEducationRequestAuditKeySpecifier)
    fields?: ApprovedEducationRequestAuditFieldPolicy
  }
  AppStoreBillingPlan?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AppStoreBillingPlanKeySpecifier
      | (() => undefined | AppStoreBillingPlanKeySpecifier)
    fields?: AppStoreBillingPlanFieldPolicy
  }
  AppStoreSubscription?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AppStoreSubscriptionKeySpecifier
      | (() => undefined | AppStoreSubscriptionKeySpecifier)
    fields?: AppStoreSubscriptionFieldPolicy
  }
  ArchiveProject?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ArchiveProjectKeySpecifier
      | (() => undefined | ArchiveProjectKeySpecifier)
    fields?: ArchiveProjectFieldPolicy
  }
  ArchiveProjectResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ArchiveProjectResponseKeySpecifier
      | (() => undefined | ArchiveProjectResponseKeySpecifier)
    fields?: ArchiveProjectResponseFieldPolicy
  }
  ArchiveStorageItemResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ArchiveStorageItemResponseKeySpecifier
      | (() => undefined | ArchiveStorageItemResponseKeySpecifier)
    fields?: ArchiveStorageItemResponseFieldPolicy
  }
  ArchiveStorageItemsResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ArchiveStorageItemsResponseKeySpecifier
      | (() => undefined | ArchiveStorageItemsResponseKeySpecifier)
    fields?: ArchiveStorageItemsResponseFieldPolicy
  }
  Artboard?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ArtboardKeySpecifier
      | (() => undefined | ArtboardKeySpecifier)
    fields?: ArtboardFieldPolicy
  }
  ArtboardBase?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ArtboardBaseKeySpecifier
      | (() => undefined | ArtboardBaseKeySpecifier)
    fields?: ArtboardBaseFieldPolicy
  }
  ArtboardRevisions?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ArtboardRevisionsKeySpecifier
      | (() => undefined | ArtboardRevisionsKeySpecifier)
    fields?: ArtboardRevisionsFieldPolicy
  }
  Artboards?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ArtboardsKeySpecifier
      | (() => undefined | ArtboardsKeySpecifier)
    fields?: ArtboardsFieldPolicy
  }
  AttachFeatureFlagAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AttachFeatureFlagAuditKeySpecifier
      | (() => undefined | AttachFeatureFlagAuditKeySpecifier)
    fields?: AttachFeatureFlagAuditFieldPolicy
  }
  AttributeMappingEntry?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AttributeMappingEntryKeySpecifier
      | (() => undefined | AttributeMappingEntryKeySpecifier)
    fields?: AttributeMappingEntryFieldPolicy
  }
  AuditActor?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AuditActorKeySpecifier
      | (() => undefined | AuditActorKeySpecifier)
    fields?: AuditActorFieldPolicy
  }
  AuditCredit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AuditCreditKeySpecifier
      | (() => undefined | AuditCreditKeySpecifier)
    fields?: AuditCreditFieldPolicy
  }
  AuditLogItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AuditLogItemKeySpecifier
      | (() => undefined | AuditLogItemKeySpecifier)
    fields?: AuditLogItemFieldPolicy
  }
  AuditMembership?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AuditMembershipKeySpecifier
      | (() => undefined | AuditMembershipKeySpecifier)
    fields?: AuditMembershipFieldPolicy
  }
  Avatar?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AvatarKeySpecifier
      | (() => undefined | AvatarKeySpecifier)
    fields?: AvatarFieldPolicy
  }
  BasePreviewChangedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BasePreviewChangedEventKeySpecifier
      | (() => undefined | BasePreviewChangedEventKeySpecifier)
    fields?: BasePreviewChangedEventFieldPolicy
  }
  BaseProjectAccessChangedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BaseProjectAccessChangedEventKeySpecifier
      | (() => undefined | BaseProjectAccessChangedEventKeySpecifier)
    fields?: BaseProjectAccessChangedEventFieldPolicy
  }
  BaseProjectChangedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BaseProjectChangedEventKeySpecifier
      | (() => undefined | BaseProjectChangedEventKeySpecifier)
    fields?: BaseProjectChangedEventFieldPolicy
  }
  BaseShareChangedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BaseShareChangedEventKeySpecifier
      | (() => undefined | BaseShareChangedEventKeySpecifier)
    fields?: BaseShareChangedEventFieldPolicy
  }
  Billing?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BillingKeySpecifier
      | (() => undefined | BillingKeySpecifier)
    fields?: BillingFieldPolicy
  }
  BillingCycles?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BillingCyclesKeySpecifier
      | (() => undefined | BillingCyclesKeySpecifier)
    fields?: BillingCyclesFieldPolicy
  }
  BillingDetails?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BillingDetailsKeySpecifier
      | (() => undefined | BillingDetailsKeySpecifier)
    fields?: BillingDetailsFieldPolicy
  }
  BillingHistory?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BillingHistoryKeySpecifier
      | (() => undefined | BillingHistoryKeySpecifier)
    fields?: BillingHistoryFieldPolicy
  }
  BillingHistoryEntry?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BillingHistoryEntryKeySpecifier
      | (() => undefined | BillingHistoryEntryKeySpecifier)
    fields?: BillingHistoryEntryFieldPolicy
  }
  BillingInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BillingInfoKeySpecifier
      | (() => undefined | BillingInfoKeySpecifier)
    fields?: BillingInfoFieldPolicy
  }
  BillingPlan?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BillingPlanKeySpecifier
      | (() => undefined | BillingPlanKeySpecifier)
    fields?: BillingPlanFieldPolicy
  }
  BillingPlanInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BillingPlanInfoKeySpecifier
      | (() => undefined | BillingPlanInfoKeySpecifier)
    fields?: BillingPlanInfoFieldPolicy
  }
  BillingPrice?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BillingPriceKeySpecifier
      | (() => undefined | BillingPriceKeySpecifier)
    fields?: BillingPriceFieldPolicy
  }
  BillingSeatsInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BillingSeatsInfoKeySpecifier
      | (() => undefined | BillingSeatsInfoKeySpecifier)
    fields?: BillingSeatsInfoFieldPolicy
  }
  BillingSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | BillingSummaryKeySpecifier
      | (() => undefined | BillingSummaryKeySpecifier)
    fields?: BillingSummaryFieldPolicy
  }
  CancelLicenseAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CancelLicenseAuditKeySpecifier
      | (() => undefined | CancelLicenseAuditKeySpecifier)
    fields?: CancelLicenseAuditFieldPolicy
  }
  CancelScheduledBillingSeatsResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | CancelScheduledBillingSeatsResponseKeySpecifier
      | (() => undefined | CancelScheduledBillingSeatsResponseKeySpecifier)
    fields?: CancelScheduledBillingSeatsResponseFieldPolicy
  }
  CancelSubscriptionResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CancelSubscriptionResponseKeySpecifier
      | (() => undefined | CancelSubscriptionResponseKeySpecifier)
    fields?: CancelSubscriptionResponseFieldPolicy
  }
  CapacitorMutations?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CapacitorMutationsKeySpecifier
      | (() => undefined | CapacitorMutationsKeySpecifier)
    fields?: CapacitorMutationsFieldPolicy
  }
  ChangeAccountLinkingAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeAccountLinkingAuditKeySpecifier
      | (() => undefined | ChangeAccountLinkingAuditKeySpecifier)
    fields?: ChangeAccountLinkingAuditFieldPolicy
  }
  ChangedPlanAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangedPlanAuditKeySpecifier
      | (() => undefined | ChangedPlanAuditKeySpecifier)
    fields?: ChangedPlanAuditFieldPolicy
  }
  ChangePlanResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangePlanResponseKeySpecifier
      | (() => undefined | ChangePlanResponseKeySpecifier)
    fields?: ChangePlanResponseFieldPolicy
  }
  ChangeRestrictedUploadsAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeRestrictedUploadsAuditKeySpecifier
      | (() => undefined | ChangeRestrictedUploadsAuditKeySpecifier)
    fields?: ChangeRestrictedUploadsAuditFieldPolicy
  }
  ChangeScimAutoLinkAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeScimAutoLinkAuditKeySpecifier
      | (() => undefined | ChangeScimAutoLinkAuditKeySpecifier)
    fields?: ChangeScimAutoLinkAuditFieldPolicy
  }
  ChangeSecurityEmailAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeSecurityEmailAuditKeySpecifier
      | (() => undefined | ChangeSecurityEmailAuditKeySpecifier)
    fields?: ChangeSecurityEmailAuditFieldPolicy
  }
  ChangeUnlimitedStorageOverrideEnabled?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ChangeUnlimitedStorageOverrideEnabledKeySpecifier
      | (() => undefined | ChangeUnlimitedStorageOverrideEnabledKeySpecifier)
    fields?: ChangeUnlimitedStorageOverrideEnabledFieldPolicy
  }
  ChangeUnlimitedTrial?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeUnlimitedTrialKeySpecifier
      | (() => undefined | ChangeUnlimitedTrialKeySpecifier)
    fields?: ChangeUnlimitedTrialFieldPolicy
  }
  ChangeWorkspaceProfileEnabled?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeWorkspaceProfileEnabledKeySpecifier
      | (() => undefined | ChangeWorkspaceProfileEnabledKeySpecifier)
    fields?: ChangeWorkspaceProfileEnabledFieldPolicy
  }
  ChangeWorkspaceProfileIsOfficial?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ChangeWorkspaceProfileIsOfficialKeySpecifier
      | (() => undefined | ChangeWorkspaceProfileIsOfficialKeySpecifier)
    fields?: ChangeWorkspaceProfileIsOfficialFieldPolicy
  }
  ChangeWorkspaceProfileShortUrl?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ChangeWorkspaceProfileShortUrlKeySpecifier
      | (() => undefined | ChangeWorkspaceProfileShortUrlKeySpecifier)
    fields?: ChangeWorkspaceProfileShortUrlFieldPolicy
  }
  ChangeWorkspaceProfileVisibility?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ChangeWorkspaceProfileVisibilityKeySpecifier
      | (() => undefined | ChangeWorkspaceProfileVisibilityKeySpecifier)
    fields?: ChangeWorkspaceProfileVisibilityFieldPolicy
  }
  CheckWorkspaceProfileShortUrlResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | CheckWorkspaceProfileShortUrlResponseKeySpecifier
      | (() => undefined | CheckWorkspaceProfileShortUrlResponseKeySpecifier)
    fields?: CheckWorkspaceProfileShortUrlResponseFieldPolicy
  }
  CloudBillingPlan?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CloudBillingPlanKeySpecifier
      | (() => undefined | CloudBillingPlanKeySpecifier)
    fields?: CloudBillingPlanFieldPolicy
  }
  CloudSubscription?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CloudSubscriptionKeySpecifier
      | (() => undefined | CloudSubscriptionKeySpecifier)
    fields?: CloudSubscriptionFieldPolicy
  }
  CollaborativeEditingSession?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CollaborativeEditingSessionKeySpecifier
      | (() => undefined | CollaborativeEditingSessionKeySpecifier)
    fields?: CollaborativeEditingSessionFieldPolicy
  }
  CollaborativeEdits?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CollaborativeEditsKeySpecifier
      | (() => undefined | CollaborativeEditsKeySpecifier)
    fields?: CollaborativeEditsFieldPolicy
  }
  CollaborativeShareCreatePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CollaborativeShareCreatePayloadKeySpecifier
      | (() => undefined | CollaborativeShareCreatePayloadKeySpecifier)
    fields?: CollaborativeShareCreatePayloadFieldPolicy
  }
  CollaborativeVersion?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CollaborativeVersionKeySpecifier
      | (() => undefined | CollaborativeVersionKeySpecifier)
    fields?: CollaborativeVersionFieldPolicy
  }
  Collection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CollectionKeySpecifier
      | (() => undefined | CollectionKeySpecifier)
    fields?: CollectionFieldPolicy
  }
  CollectionChangedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CollectionChangedEventKeySpecifier
      | (() => undefined | CollectionChangedEventKeySpecifier)
    fields?: CollectionChangedEventFieldPolicy
  }
  CollectionCreatedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CollectionCreatedEventKeySpecifier
      | (() => undefined | CollectionCreatedEventKeySpecifier)
    fields?: CollectionCreatedEventFieldPolicy
  }
  CollectionDeletedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CollectionDeletedEventKeySpecifier
      | (() => undefined | CollectionDeletedEventKeySpecifier)
    fields?: CollectionDeletedEventFieldPolicy
  }
  Collections?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CollectionsKeySpecifier
      | (() => undefined | CollectionsKeySpecifier)
    fields?: CollectionsFieldPolicy
  }
  CollectionSharePreview?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CollectionSharePreviewKeySpecifier
      | (() => undefined | CollectionSharePreviewKeySpecifier)
    fields?: CollectionSharePreviewFieldPolicy
  }
  ColorVariable?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ColorVariableKeySpecifier
      | (() => undefined | ColorVariableKeySpecifier)
    fields?: ColorVariableFieldPolicy
  }
  Comment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CommentKeySpecifier
      | (() => undefined | CommentKeySpecifier)
    fields?: CommentFieldPolicy
  }
  CommentNotification?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CommentNotificationKeySpecifier
      | (() => undefined | CommentNotificationKeySpecifier)
    fields?: CommentNotificationFieldPolicy
  }
  Comments?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CommentsKeySpecifier
      | (() => undefined | CommentsKeySpecifier)
    fields?: CommentsFieldPolicy
  }
  Community?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CommunityKeySpecifier
      | (() => undefined | CommunityKeySpecifier)
    fields?: CommunityFieldPolicy
  }
  CommunityGrid?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CommunityGridKeySpecifier
      | (() => undefined | CommunityGridKeySpecifier)
    fields?: CommunityGridFieldPolicy
  }
  CommunityHero?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CommunityHeroKeySpecifier
      | (() => undefined | CommunityHeroKeySpecifier)
    fields?: CommunityHeroFieldPolicy
  }
  CommunityListing?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CommunityListingKeySpecifier
      | (() => undefined | CommunityListingKeySpecifier)
    fields?: CommunityListingFieldPolicy
  }
  CommunityPublicationQuery?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CommunityPublicationQueryKeySpecifier
      | (() => undefined | CommunityPublicationQueryKeySpecifier)
    fields?: CommunityPublicationQueryFieldPolicy
  }
  CommunitySection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CommunitySectionKeySpecifier
      | (() => undefined | CommunitySectionKeySpecifier)
    fields?: CommunitySectionFieldPolicy
  }
  CommunitySlider?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CommunitySliderKeySpecifier
      | (() => undefined | CommunitySliderKeySpecifier)
    fields?: CommunitySliderFieldPolicy
  }
  Component?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ComponentKeySpecifier
      | (() => undefined | ComponentKeySpecifier)
    fields?: ComponentFieldPolicy
  }
  ComponentCount?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ComponentCountKeySpecifier
      | (() => undefined | ComponentCountKeySpecifier)
    fields?: ComponentCountFieldPolicy
  }
  ComponentDescriptionEdit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ComponentDescriptionEditKeySpecifier
      | (() => undefined | ComponentDescriptionEditKeySpecifier)
    fields?: ComponentDescriptionEditFieldPolicy
  }
  ComponentGroupData?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ComponentGroupDataKeySpecifier
      | (() => undefined | ComponentGroupDataKeySpecifier)
    fields?: ComponentGroupDataFieldPolicy
  }
  Components?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ComponentsKeySpecifier
      | (() => undefined | ComponentsKeySpecifier)
    fields?: ComponentsFieldPolicy
  }
  ConfigureEncryptionKeysAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConfigureEncryptionKeysAuditKeySpecifier
      | (() => undefined | ConfigureEncryptionKeysAuditKeySpecifier)
    fields?: ConfigureEncryptionKeysAuditFieldPolicy
  }
  ConfigureWorkspaceEncryptionKeysResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ConfigureWorkspaceEncryptionKeysResponseKeySpecifier
      | (() => undefined | ConfigureWorkspaceEncryptionKeysResponseKeySpecifier)
    fields?: ConfigureWorkspaceEncryptionKeysResponseFieldPolicy
  }
  ConfirmAppStorePurchaseResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ConfirmAppStorePurchaseResponseKeySpecifier
      | (() => undefined | ConfirmAppStorePurchaseResponseKeySpecifier)
    fields?: ConfirmAppStorePurchaseResponseFieldPolicy
  }
  ConvertToEducationWorkspaceAudit?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ConvertToEducationWorkspaceAuditKeySpecifier
      | (() => undefined | ConvertToEducationWorkspaceAuditKeySpecifier)
    fields?: ConvertToEducationWorkspaceAuditFieldPolicy
  }
  Country?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CountryKeySpecifier
      | (() => undefined | CountryKeySpecifier)
    fields?: CountryFieldPolicy
  }
  CouponInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CouponInfoKeySpecifier
      | (() => undefined | CouponInfoKeySpecifier)
    fields?: CouponInfoFieldPolicy
  }
  CreateAnnotationReplyResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateAnnotationReplyResponseKeySpecifier
      | (() => undefined | CreateAnnotationReplyResponseKeySpecifier)
    fields?: CreateAnnotationReplyResponseFieldPolicy
  }
  CreateAnnotationResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateAnnotationResponseKeySpecifier
      | (() => undefined | CreateAnnotationResponseKeySpecifier)
    fields?: CreateAnnotationResponseFieldPolicy
  }
  CreateCollectionResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateCollectionResponseKeySpecifier
      | (() => undefined | CreateCollectionResponseKeySpecifier)
    fields?: CreateCollectionResponseFieldPolicy
  }
  CreateEducationApplicationResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | CreateEducationApplicationResponseKeySpecifier
      | (() => undefined | CreateEducationApplicationResponseKeySpecifier)
    fields?: CreateEducationApplicationResponseFieldPolicy
  }
  CreateMembershipAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateMembershipAuditKeySpecifier
      | (() => undefined | CreateMembershipAuditKeySpecifier)
    fields?: CreateMembershipAuditFieldPolicy
  }
  CreatePartnerWorkspaceResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreatePartnerWorkspaceResponseKeySpecifier
      | (() => undefined | CreatePartnerWorkspaceResponseKeySpecifier)
    fields?: CreatePartnerWorkspaceResponseFieldPolicy
  }
  CreatePermissionGroup?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreatePermissionGroupKeySpecifier
      | (() => undefined | CreatePermissionGroupKeySpecifier)
    fields?: CreatePermissionGroupFieldPolicy
  }
  CreatePermissionGroupRelation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreatePermissionGroupRelationKeySpecifier
      | (() => undefined | CreatePermissionGroupRelationKeySpecifier)
    fields?: CreatePermissionGroupRelationFieldPolicy
  }
  CreatePermissionGroupResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreatePermissionGroupResponseKeySpecifier
      | (() => undefined | CreatePermissionGroupResponseKeySpecifier)
    fields?: CreatePermissionGroupResponseFieldPolicy
  }
  CreatePreviewResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreatePreviewResponseKeySpecifier
      | (() => undefined | CreatePreviewResponseKeySpecifier)
    fields?: CreatePreviewResponseFieldPolicy
  }
  CreateSetupIntentResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateSetupIntentResponseKeySpecifier
      | (() => undefined | CreateSetupIntentResponseKeySpecifier)
    fields?: CreateSetupIntentResponseFieldPolicy
  }
  CreateWorkspaceAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateWorkspaceAuditKeySpecifier
      | (() => undefined | CreateWorkspaceAuditKeySpecifier)
    fields?: CreateWorkspaceAuditFieldPolicy
  }
  CreateWorkspaceProfileResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateWorkspaceProfileResponseKeySpecifier
      | (() => undefined | CreateWorkspaceProfileResponseKeySpecifier)
    fields?: CreateWorkspaceProfileResponseFieldPolicy
  }
  CreateWorkspaceProjectResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateWorkspaceProjectResponseKeySpecifier
      | (() => undefined | CreateWorkspaceProjectResponseKeySpecifier)
    fields?: CreateWorkspaceProjectResponseFieldPolicy
  }
  CreateWorkspaceResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateWorkspaceResponseKeySpecifier
      | (() => undefined | CreateWorkspaceResponseKeySpecifier)
    fields?: CreateWorkspaceResponseFieldPolicy
  }
  CreateWorkspaceShareResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreateWorkspaceShareResponseKeySpecifier
      | (() => undefined | CreateWorkspaceShareResponseKeySpecifier)
    fields?: CreateWorkspaceShareResponseFieldPolicy
  }
  CreditAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreditAuditKeySpecifier
      | (() => undefined | CreditAuditKeySpecifier)
    fields?: CreditAuditFieldPolicy
  }
  CreditBalance?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreditBalanceKeySpecifier
      | (() => undefined | CreditBalanceKeySpecifier)
    fields?: CreditBalanceFieldPolicy
  }
  CreditCardExpiration?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreditCardExpirationKeySpecifier
      | (() => undefined | CreditCardExpirationKeySpecifier)
    fields?: CreditCardExpirationFieldPolicy
  }
  CreditCardPaymentDetails?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreditCardPaymentDetailsKeySpecifier
      | (() => undefined | CreditCardPaymentDetailsKeySpecifier)
    fields?: CreditCardPaymentDetailsFieldPolicy
  }
  CreditNote?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreditNoteKeySpecifier
      | (() => undefined | CreditNoteKeySpecifier)
    fields?: CreditNoteFieldPolicy
  }
  CreditTransaction?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CreditTransactionKeySpecifier
      | (() => undefined | CreditTransactionKeySpecifier)
    fields?: CreditTransactionFieldPolicy
  }
  Currencies?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CurrenciesKeySpecifier
      | (() => undefined | CurrenciesKeySpecifier)
    fields?: CurrenciesFieldPolicy
  }
  Customer?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerKeySpecifier
      | (() => undefined | CustomerKeySpecifier)
    fields?: CustomerFieldPolicy
  }
  CustomerAddress?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerAddressKeySpecifier
      | (() => undefined | CustomerAddressKeySpecifier)
    fields?: CustomerAddressFieldPolicy
  }
  CustomerInvoice?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerInvoiceKeySpecifier
      | (() => undefined | CustomerInvoiceKeySpecifier)
    fields?: CustomerInvoiceFieldPolicy
  }
  CustomerMutationResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerMutationResponseKeySpecifier
      | (() => undefined | CustomerMutationResponseKeySpecifier)
    fields?: CustomerMutationResponseFieldPolicy
  }
  CustomerTaxId?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CustomerTaxIdKeySpecifier
      | (() => undefined | CustomerTaxIdKeySpecifier)
    fields?: CustomerTaxIdFieldPolicy
  }
  DeleteAllPreviewsResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteAllPreviewsResponseKeySpecifier
      | (() => undefined | DeleteAllPreviewsResponseKeySpecifier)
    fields?: DeleteAllPreviewsResponseFieldPolicy
  }
  DeleteAnnotationReplyResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteAnnotationReplyResponseKeySpecifier
      | (() => undefined | DeleteAnnotationReplyResponseKeySpecifier)
    fields?: DeleteAnnotationReplyResponseFieldPolicy
  }
  DeleteAnnotationResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteAnnotationResponseKeySpecifier
      | (() => undefined | DeleteAnnotationResponseKeySpecifier)
    fields?: DeleteAnnotationResponseFieldPolicy
  }
  DeleteCollectionResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteCollectionResponseKeySpecifier
      | (() => undefined | DeleteCollectionResponseKeySpecifier)
    fields?: DeleteCollectionResponseFieldPolicy
  }
  DeletedScimPersonalAccessToken?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeletedScimPersonalAccessTokenKeySpecifier
      | (() => undefined | DeletedScimPersonalAccessTokenKeySpecifier)
    fields?: DeletedScimPersonalAccessTokenFieldPolicy
  }
  DeletedSharePermanentlyEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeletedSharePermanentlyEventKeySpecifier
      | (() => undefined | DeletedSharePermanentlyEventKeySpecifier)
    fields?: DeletedSharePermanentlyEventFieldPolicy
  }
  DeleteMembershipAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteMembershipAuditKeySpecifier
      | (() => undefined | DeleteMembershipAuditKeySpecifier)
    fields?: DeleteMembershipAuditFieldPolicy
  }
  DeleteOrganizationAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteOrganizationAuditKeySpecifier
      | (() => undefined | DeleteOrganizationAuditKeySpecifier)
    fields?: DeleteOrganizationAuditFieldPolicy
  }
  DeletePermissionGroup?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeletePermissionGroupKeySpecifier
      | (() => undefined | DeletePermissionGroupKeySpecifier)
    fields?: DeletePermissionGroupFieldPolicy
  }
  DeletePermissionGroupResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeletePermissionGroupResponseKeySpecifier
      | (() => undefined | DeletePermissionGroupResponseKeySpecifier)
    fields?: DeletePermissionGroupResponseFieldPolicy
  }
  DeletePreviewResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeletePreviewResponseKeySpecifier
      | (() => undefined | DeletePreviewResponseKeySpecifier)
    fields?: DeletePreviewResponseFieldPolicy
  }
  DeletePreviousShareVersionsResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | DeletePreviousShareVersionsResponseKeySpecifier
      | (() => undefined | DeletePreviousShareVersionsResponseKeySpecifier)
    fields?: DeletePreviousShareVersionsResponseFieldPolicy
  }
  DeleteProjectPermanentlyResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | DeleteProjectPermanentlyResponseKeySpecifier
      | (() => undefined | DeleteProjectPermanentlyResponseKeySpecifier)
    fields?: DeleteProjectPermanentlyResponseFieldPolicy
  }
  DeleteSharePermanentlyResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteSharePermanentlyResponseKeySpecifier
      | (() => undefined | DeleteSharePermanentlyResponseKeySpecifier)
    fields?: DeleteSharePermanentlyResponseFieldPolicy
  }
  DeleteStorageItemResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteStorageItemResponseKeySpecifier
      | (() => undefined | DeleteStorageItemResponseKeySpecifier)
    fields?: DeleteStorageItemResponseFieldPolicy
  }
  DeleteStorageItemsResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteStorageItemsResponseKeySpecifier
      | (() => undefined | DeleteStorageItemsResponseKeySpecifier)
    fields?: DeleteStorageItemsResponseFieldPolicy
  }
  DeleteWorkspaceAvatarResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteWorkspaceAvatarResponseKeySpecifier
      | (() => undefined | DeleteWorkspaceAvatarResponseKeySpecifier)
    fields?: DeleteWorkspaceAvatarResponseFieldPolicy
  }
  DeleteWorkspaceResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DeleteWorkspaceResponseKeySpecifier
      | (() => undefined | DeleteWorkspaceResponseKeySpecifier)
    fields?: DeleteWorkspaceResponseFieldPolicy
  }
  DetachFeatureFlagAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DetachFeatureFlagAuditKeySpecifier
      | (() => undefined | DetachFeatureFlagAuditKeySpecifier)
    fields?: DetachFeatureFlagAuditFieldPolicy
  }
  DisableMembershipAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DisableMembershipAuditKeySpecifier
      | (() => undefined | DisableMembershipAuditKeySpecifier)
    fields?: DisableMembershipAuditFieldPolicy
  }
  DisableMfaResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DisableMfaResponseKeySpecifier
      | (() => undefined | DisableMfaResponseKeySpecifier)
    fields?: DisableMfaResponseFieldPolicy
  }
  DisableScimResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DisableScimResponseKeySpecifier
      | (() => undefined | DisableScimResponseKeySpecifier)
    fields?: DisableScimResponseFieldPolicy
  }
  DisableSsoAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DisableSsoAuditKeySpecifier
      | (() => undefined | DisableSsoAuditKeySpecifier)
    fields?: DisableSsoAuditFieldPolicy
  }
  DisableSupportAccessResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DisableSupportAccessResponseKeySpecifier
      | (() => undefined | DisableSupportAccessResponseKeySpecifier)
    fields?: DisableSupportAccessResponseFieldPolicy
  }
  Discover?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DiscoverKeySpecifier
      | (() => undefined | DiscoverKeySpecifier)
    fields?: DiscoverFieldPolicy
  }
  DiscoverItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DiscoverItemKeySpecifier
      | (() => undefined | DiscoverItemKeySpecifier)
    fields?: DiscoverItemFieldPolicy
  }
  DiscoverSection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DiscoverSectionKeySpecifier
      | (() => undefined | DiscoverSectionKeySpecifier)
    fields?: DiscoverSectionFieldPolicy
  }
  Discussion?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DiscussionKeySpecifier
      | (() => undefined | DiscussionKeySpecifier)
    fields?: DiscussionFieldPolicy
  }
  Document?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DocumentKeySpecifier
      | (() => undefined | DocumentKeySpecifier)
    fields?: DocumentFieldPolicy
  }
  DocumentUploadCancelPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DocumentUploadCancelPayloadKeySpecifier
      | (() => undefined | DocumentUploadCancelPayloadKeySpecifier)
    fields?: DocumentUploadCancelPayloadFieldPolicy
  }
  DocumentUploadCompletePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DocumentUploadCompletePayloadKeySpecifier
      | (() => undefined | DocumentUploadCompletePayloadKeySpecifier)
    fields?: DocumentUploadCompletePayloadFieldPolicy
  }
  DowngradedSsoMembershipProvisionedAudit?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | DowngradedSsoMembershipProvisionedAuditKeySpecifier
      | (() => undefined | DowngradedSsoMembershipProvisionedAuditKeySpecifier)
    fields?: DowngradedSsoMembershipProvisionedAuditFieldPolicy
  }
  DownloadableAsset?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DownloadableAssetKeySpecifier
      | (() => undefined | DownloadableAssetKeySpecifier)
    fields?: DownloadableAssetFieldPolicy
  }
  DownloadableAssetRenderedNotification?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | DownloadableAssetRenderedNotificationKeySpecifier
      | (() => undefined | DownloadableAssetRenderedNotificationKeySpecifier)
    fields?: DownloadableAssetRenderedNotificationFieldPolicy
  }
  DownloadLatestVersionCatchUp?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DownloadLatestVersionCatchUpKeySpecifier
      | (() => undefined | DownloadLatestVersionCatchUpKeySpecifier)
    fields?: DownloadLatestVersionCatchUpFieldPolicy
  }
  DownloadPatchesCatchUp?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DownloadPatchesCatchUpKeySpecifier
      | (() => undefined | DownloadPatchesCatchUpKeySpecifier)
    fields?: DownloadPatchesCatchUpFieldPolicy
  }
  DuplicateShareToDraftsResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DuplicateShareToDraftsResponseKeySpecifier
      | (() => undefined | DuplicateShareToDraftsResponseKeySpecifier)
    fields?: DuplicateShareToDraftsResponseFieldPolicy
  }
  DuplicateShareToResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DuplicateShareToResponseKeySpecifier
      | (() => undefined | DuplicateShareToResponseKeySpecifier)
    fields?: DuplicateShareToResponseFieldPolicy
  }
  EditCollectionDescriptionResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | EditCollectionDescriptionResponseKeySpecifier
      | (() => undefined | EditCollectionDescriptionResponseKeySpecifier)
    fields?: EditCollectionDescriptionResponseFieldPolicy
  }
  EditCollectionResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EditCollectionResponseKeySpecifier
      | (() => undefined | EditCollectionResponseKeySpecifier)
    fields?: EditCollectionResponseFieldPolicy
  }
  EditCommentResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EditCommentResponseKeySpecifier
      | (() => undefined | EditCommentResponseKeySpecifier)
    fields?: EditCommentResponseFieldPolicy
  }
  EducationApplication?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EducationApplicationKeySpecifier
      | (() => undefined | EducationApplicationKeySpecifier)
    fields?: EducationApplicationFieldPolicy
  }
  EducationApplicationContactDetails?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | EducationApplicationContactDetailsKeySpecifier
      | (() => undefined | EducationApplicationContactDetailsKeySpecifier)
    fields?: EducationApplicationContactDetailsFieldPolicy
  }
  EducationApplicationFiles?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EducationApplicationFilesKeySpecifier
      | (() => undefined | EducationApplicationFilesKeySpecifier)
    fields?: EducationApplicationFilesFieldPolicy
  }
  EmailResendChangeConfirmationPayload?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | EmailResendChangeConfirmationPayloadKeySpecifier
      | (() => undefined | EmailResendChangeConfirmationPayloadKeySpecifier)
    fields?: EmailResendChangeConfirmationPayloadFieldPolicy
  }
  EmailUpdatePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EmailUpdatePayloadKeySpecifier
      | (() => undefined | EmailUpdatePayloadKeySpecifier)
    fields?: EmailUpdatePayloadFieldPolicy
  }
  EmailVerifyPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EmailVerifyPayloadKeySpecifier
      | (() => undefined | EmailVerifyPayloadKeySpecifier)
    fields?: EmailVerifyPayloadFieldPolicy
  }
  EmptiedWorkspaceTrashEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EmptiedWorkspaceTrashEventKeySpecifier
      | (() => undefined | EmptiedWorkspaceTrashEventKeySpecifier)
    fields?: EmptiedWorkspaceTrashEventFieldPolicy
  }
  EmptyWorkspaceTrashResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EmptyWorkspaceTrashResponseKeySpecifier
      | (() => undefined | EmptyWorkspaceTrashResponseKeySpecifier)
    fields?: EmptyWorkspaceTrashResponseFieldPolicy
  }
  EnableScimResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EnableScimResponseKeySpecifier
      | (() => undefined | EnableScimResponseKeySpecifier)
    fields?: EnableScimResponseFieldPolicy
  }
  EnableSupportAccessResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EnableSupportAccessResponseKeySpecifier
      | (() => undefined | EnableSupportAccessResponseKeySpecifier)
    fields?: EnableSupportAccessResponseFieldPolicy
  }
  EncryptionConfig?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EncryptionConfigKeySpecifier
      | (() => undefined | EncryptionConfigKeySpecifier)
    fields?: EncryptionConfigFieldPolicy
  }
  ErrorContext?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ErrorContextKeySpecifier
      | (() => undefined | ErrorContextKeySpecifier)
    fields?: ErrorContextFieldPolicy
  }
  EventDate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | EventDateKeySpecifier
      | (() => undefined | EventDateKeySpecifier)
    fields?: EventDateFieldPolicy
  }
  File?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | FileKeySpecifier | (() => undefined | FileKeySpecifier)
    fields?: FileFieldPolicy
  }
  FolderArchivedNotification?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FolderArchivedNotificationKeySpecifier
      | (() => undefined | FolderArchivedNotificationKeySpecifier)
    fields?: FolderArchivedNotificationFieldPolicy
  }
  FolderPermanentlyDeletedNotification?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | FolderPermanentlyDeletedNotificationKeySpecifier
      | (() => undefined | FolderPermanentlyDeletedNotificationKeySpecifier)
    fields?: FolderPermanentlyDeletedNotificationFieldPolicy
  }
  FolderRestoredNotification?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FolderRestoredNotificationKeySpecifier
      | (() => undefined | FolderRestoredNotificationKeySpecifier)
    fields?: FolderRestoredNotificationFieldPolicy
  }
  FolderTrashedNotification?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FolderTrashedNotificationKeySpecifier
      | (() => undefined | FolderTrashedNotificationKeySpecifier)
    fields?: FolderTrashedNotificationFieldPolicy
  }
  Frame?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FrameKeySpecifier
      | (() => undefined | FrameKeySpecifier)
    fields?: FrameFieldPolicy
  }
  FrameGroup?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FrameGroupKeySpecifier
      | (() => undefined | FrameGroupKeySpecifier)
    fields?: FrameGroupFieldPolicy
  }
  FrameRevisions?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FrameRevisionsKeySpecifier
      | (() => undefined | FrameRevisionsKeySpecifier)
    fields?: FrameRevisionsFieldPolicy
  }
  Frames?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | FramesKeySpecifier
      | (() => undefined | FramesKeySpecifier)
    fields?: FramesFieldPolicy
  }
  GeneratedDocumentsFeedAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | GeneratedDocumentsFeedAuditKeySpecifier
      | (() => undefined | GeneratedDocumentsFeedAuditKeySpecifier)
    fields?: GeneratedDocumentsFeedAuditFieldPolicy
  }
  GeneratedScimPersonalAccessToken?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | GeneratedScimPersonalAccessTokenKeySpecifier
      | (() => undefined | GeneratedScimPersonalAccessTokenKeySpecifier)
    fields?: GeneratedScimPersonalAccessTokenFieldPolicy
  }
  IdentityProviderConfig?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | IdentityProviderConfigKeySpecifier
      | (() => undefined | IdentityProviderConfigKeySpecifier)
    fields?: IdentityProviderConfigFieldPolicy
  }
  ImmediateCharge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ImmediateChargeKeySpecifier
      | (() => undefined | ImmediateChargeKeySpecifier)
    fields?: ImmediateChargeFieldPolicy
  }
  InspectorData?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InspectorDataKeySpecifier
      | (() => undefined | InspectorDataKeySpecifier)
    fields?: InspectorDataFieldPolicy
  }
  InspectorDataPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InspectorDataPayloadKeySpecifier
      | (() => undefined | InspectorDataPayloadKeySpecifier)
    fields?: InspectorDataPayloadFieldPolicy
  }
  InstallIntegrationAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InstallIntegrationAuditKeySpecifier
      | (() => undefined | InstallIntegrationAuditKeySpecifier)
    fields?: InstallIntegrationAuditFieldPolicy
  }
  IntegrationConnectUrlPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | IntegrationConnectUrlPayloadKeySpecifier
      | (() => undefined | IntegrationConnectUrlPayloadKeySpecifier)
    fields?: IntegrationConnectUrlPayloadFieldPolicy
  }
  IntegrationIdentityConnectUrlPayload?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | IntegrationIdentityConnectUrlPayloadKeySpecifier
      | (() => undefined | IntegrationIdentityConnectUrlPayloadKeySpecifier)
    fields?: IntegrationIdentityConnectUrlPayloadFieldPolicy
  }
  InviteWorkspaceMembersResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InviteWorkspaceMembersResponseKeySpecifier
      | (() => undefined | InviteWorkspaceMembersResponseKeySpecifier)
    fields?: InviteWorkspaceMembersResponseFieldPolicy
  }
  InvoicePaymentDetails?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InvoicePaymentDetailsKeySpecifier
      | (() => undefined | InvoicePaymentDetailsKeySpecifier)
    fields?: InvoicePaymentDetailsFieldPolicy
  }
  ItemMobile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ItemMobileKeySpecifier
      | (() => undefined | ItemMobileKeySpecifier)
    fields?: ItemMobileFieldPolicy
  }
  LatestVisibleVersion?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LatestVisibleVersionKeySpecifier
      | (() => undefined | LatestVisibleVersionKeySpecifier)
    fields?: LatestVisibleVersionFieldPolicy
  }
  LayerStyle?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LayerStyleKeySpecifier
      | (() => undefined | LayerStyleKeySpecifier)
    fields?: LayerStyleFieldPolicy
  }
  LeaveProjectResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LeaveProjectResponseKeySpecifier
      | (() => undefined | LeaveProjectResponseKeySpecifier)
    fields?: LeaveProjectResponseFieldPolicy
  }
  LicensePlan?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LicensePlanKeySpecifier
      | (() => undefined | LicensePlanKeySpecifier)
    fields?: LicensePlanFieldPolicy
  }
  LicenseRedemption?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LicenseRedemptionKeySpecifier
      | (() => undefined | LicenseRedemptionKeySpecifier)
    fields?: LicenseRedemptionFieldPolicy
  }
  LicenseRedemptions?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LicenseRedemptionsKeySpecifier
      | (() => undefined | LicenseRedemptionsKeySpecifier)
    fields?: LicenseRedemptionsFieldPolicy
  }
  Link?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | LinkKeySpecifier | (() => undefined | LinkKeySpecifier)
    fields?: LinkFieldPolicy
  }
  LinkRegularAccountResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LinkRegularAccountResponseKeySpecifier
      | (() => undefined | LinkRegularAccountResponseKeySpecifier)
    fields?: LinkRegularAccountResponseFieldPolicy
  }
  LocalCollaborativePatch?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | LocalCollaborativePatchKeySpecifier
      | (() => undefined | LocalCollaborativePatchKeySpecifier)
    fields?: LocalCollaborativePatchFieldPolicy
  }
  MarkAllCommentsAsReadResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MarkAllCommentsAsReadResponseKeySpecifier
      | (() => undefined | MarkAllCommentsAsReadResponseKeySpecifier)
    fields?: MarkAllCommentsAsReadResponseFieldPolicy
  }
  MarkCommentsAsReadResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MarkCommentsAsReadResponseKeySpecifier
      | (() => undefined | MarkCommentsAsReadResponseKeySpecifier)
    fields?: MarkCommentsAsReadResponseFieldPolicy
  }
  MembershipCount?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MembershipCountKeySpecifier
      | (() => undefined | MembershipCountKeySpecifier)
    fields?: MembershipCountFieldPolicy
  }
  MentionableUser?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MentionableUserKeySpecifier
      | (() => undefined | MentionableUserKeySpecifier)
    fields?: MentionableUserFieldPolicy
  }
  MentionNotification?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MentionNotificationKeySpecifier
      | (() => undefined | MentionNotificationKeySpecifier)
    fields?: MentionNotificationFieldPolicy
  }
  MfaConfig?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MfaConfigKeySpecifier
      | (() => undefined | MfaConfigKeySpecifier)
    fields?: MfaConfigFieldPolicy
  }
  MFACredentials?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MFACredentialsKeySpecifier
      | (() => undefined | MFACredentialsKeySpecifier)
    fields?: MFACredentialsFieldPolicy
  }
  Migration?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MigrationKeySpecifier
      | (() => undefined | MigrationKeySpecifier)
    fields?: MigrationFieldPolicy
  }
  MigrationCompleted?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MigrationCompletedKeySpecifier
      | (() => undefined | MigrationCompletedKeySpecifier)
    fields?: MigrationCompletedFieldPolicy
  }
  MigrationFailed?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MigrationFailedKeySpecifier
      | (() => undefined | MigrationFailedKeySpecifier)
    fields?: MigrationFailedFieldPolicy
  }
  MigrationStarted?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MigrationStartedKeySpecifier
      | (() => undefined | MigrationStartedKeySpecifier)
    fields?: MigrationStartedFieldPolicy
  }
  MoveAllCollectionSharesResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MoveAllCollectionSharesResponseKeySpecifier
      | (() => undefined | MoveAllCollectionSharesResponseKeySpecifier)
    fields?: MoveAllCollectionSharesResponseFieldPolicy
  }
  MoveAnnotationResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MoveAnnotationResponseKeySpecifier
      | (() => undefined | MoveAnnotationResponseKeySpecifier)
    fields?: MoveAnnotationResponseFieldPolicy
  }
  MoveAnnotationsResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MoveAnnotationsResponseKeySpecifier
      | (() => undefined | MoveAnnotationsResponseKeySpecifier)
    fields?: MoveAnnotationsResponseFieldPolicy
  }
  MultipartPart?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MultipartPartKeySpecifier
      | (() => undefined | MultipartPartKeySpecifier)
    fields?: MultipartPartFieldPolicy
  }
  MultipartUpload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MultipartUploadKeySpecifier
      | (() => undefined | MultipartUploadKeySpecifier)
    fields?: MultipartUploadFieldPolicy
  }
  Mutation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MutationKeySpecifier
      | (() => undefined | MutationKeySpecifier)
    fields?: MutationFieldPolicy
  }
  NameMapping?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NameMappingKeySpecifier
      | (() => undefined | NameMappingKeySpecifier)
    fields?: NameMappingFieldPolicy
  }
  NewEducationRequestAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NewEducationRequestAuditKeySpecifier
      | (() => undefined | NewEducationRequestAuditKeySpecifier)
    fields?: NewEducationRequestAuditFieldPolicy
  }
  NoPaymentDetails?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NoPaymentDetailsKeySpecifier
      | (() => undefined | NoPaymentDetailsKeySpecifier)
    fields?: NoPaymentDetailsFieldPolicy
  }
  NotificationMarkAllAsReadPayload?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | NotificationMarkAllAsReadPayloadKeySpecifier
      | (() => undefined | NotificationMarkAllAsReadPayloadKeySpecifier)
    fields?: NotificationMarkAllAsReadPayloadFieldPolicy
  }
  NotificationMarkAsReadPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NotificationMarkAsReadPayloadKeySpecifier
      | (() => undefined | NotificationMarkAsReadPayloadKeySpecifier)
    fields?: NotificationMarkAsReadPayloadFieldPolicy
  }
  NotificationMarkEveryReadAsDonePayload?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | NotificationMarkEveryReadAsDonePayloadKeySpecifier
      | (() => undefined | NotificationMarkEveryReadAsDonePayloadKeySpecifier)
    fields?: NotificationMarkEveryReadAsDonePayloadFieldPolicy
  }
  Notifications?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NotificationsKeySpecifier
      | (() => undefined | NotificationsKeySpecifier)
    fields?: NotificationsFieldPolicy
  }
  NotificationsUpdatedPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NotificationsUpdatedPayloadKeySpecifier
      | (() => undefined | NotificationsUpdatedPayloadKeySpecifier)
    fields?: NotificationsUpdatedPayloadFieldPolicy
  }
  NotificationUpdatedPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NotificationUpdatedPayloadKeySpecifier
      | (() => undefined | NotificationUpdatedPayloadKeySpecifier)
    fields?: NotificationUpdatedPayloadFieldPolicy
  }
  OAuthCredentials?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OAuthCredentialsKeySpecifier
      | (() => undefined | OAuthCredentialsKeySpecifier)
    fields?: OAuthCredentialsFieldPolicy
  }
  Organization?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrganizationKeySpecifier
      | (() => undefined | OrganizationKeySpecifier)
    fields?: OrganizationFieldPolicy
  }
  OrganizationAcceptInvitePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrganizationAcceptInvitePayloadKeySpecifier
      | (() => undefined | OrganizationAcceptInvitePayloadKeySpecifier)
    fields?: OrganizationAcceptInvitePayloadFieldPolicy
  }
  OrganizationAcceptTosPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrganizationAcceptTosPayloadKeySpecifier
      | (() => undefined | OrganizationAcceptTosPayloadKeySpecifier)
    fields?: OrganizationAcceptTosPayloadFieldPolicy
  }
  OrganizationInvite?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrganizationInviteKeySpecifier
      | (() => undefined | OrganizationInviteKeySpecifier)
    fields?: OrganizationInviteFieldPolicy
  }
  OrganizationMembership?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrganizationMembershipKeySpecifier
      | (() => undefined | OrganizationMembershipKeySpecifier)
    fields?: OrganizationMembershipFieldPolicy
  }
  OrganizationMemberships?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrganizationMembershipsKeySpecifier
      | (() => undefined | OrganizationMembershipsKeySpecifier)
    fields?: OrganizationMembershipsFieldPolicy
  }
  OrganizationResendInvitePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrganizationResendInvitePayloadKeySpecifier
      | (() => undefined | OrganizationResendInvitePayloadKeySpecifier)
    fields?: OrganizationResendInvitePayloadFieldPolicy
  }
  OrganizationSsoConfig?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrganizationSsoConfigKeySpecifier
      | (() => undefined | OrganizationSsoConfigKeySpecifier)
    fields?: OrganizationSsoConfigFieldPolicy
  }
  OrganizationUpdateAttributeMappingPayload?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | OrganizationUpdateAttributeMappingPayloadKeySpecifier
      | (() =>
          | undefined
          | OrganizationUpdateAttributeMappingPayloadKeySpecifier)
    fields?: OrganizationUpdateAttributeMappingPayloadFieldPolicy
  }
  OrganizationUpdateIdentityProviderConfigPayload?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | OrganizationUpdateIdentityProviderConfigPayloadKeySpecifier
      | (() =>
          | undefined
          | OrganizationUpdateIdentityProviderConfigPayloadKeySpecifier)
    fields?: OrganizationUpdateIdentityProviderConfigPayloadFieldPolicy
  }
  OrganizationUpdatePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrganizationUpdatePayloadKeySpecifier
      | (() => undefined | OrganizationUpdatePayloadKeySpecifier)
    fields?: OrganizationUpdatePayloadFieldPolicy
  }
  OrganizationUser?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OrganizationUserKeySpecifier
      | (() => undefined | OrganizationUserKeySpecifier)
    fields?: OrganizationUserFieldPolicy
  }
  OutOfDateBaseVersionCatchUp?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | OutOfDateBaseVersionCatchUpKeySpecifier
      | (() => undefined | OutOfDateBaseVersionCatchUpKeySpecifier)
    fields?: OutOfDateBaseVersionCatchUpFieldPolicy
  }
  Page?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | PageKeySpecifier | (() => undefined | PageKeySpecifier)
    fields?: PageFieldPolicy
  }
  Pages?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PagesKeySpecifier
      | (() => undefined | PagesKeySpecifier)
    fields?: PagesFieldPolicy
  }
  PaginationMeta?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PaginationMetaKeySpecifier
      | (() => undefined | PaginationMetaKeySpecifier)
    fields?: PaginationMetaFieldPolicy
  }
  PaginationMetadata?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PaginationMetadataKeySpecifier
      | (() => undefined | PaginationMetadataKeySpecifier)
    fields?: PaginationMetadataFieldPolicy
  }
  ParentComment?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ParentCommentKeySpecifier
      | (() => undefined | ParentCommentKeySpecifier)
    fields?: ParentCommentFieldPolicy
  }
  Partner?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PartnerKeySpecifier
      | (() => undefined | PartnerKeySpecifier)
    fields?: PartnerFieldPolicy
  }
  PartnerBillingDetails?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PartnerBillingDetailsKeySpecifier
      | (() => undefined | PartnerBillingDetailsKeySpecifier)
    fields?: PartnerBillingDetailsFieldPolicy
  }
  PartnerBillingSummary?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PartnerBillingSummaryKeySpecifier
      | (() => undefined | PartnerBillingSummaryKeySpecifier)
    fields?: PartnerBillingSummaryFieldPolicy
  }
  PartnerCoupon?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PartnerCouponKeySpecifier
      | (() => undefined | PartnerCouponKeySpecifier)
    fields?: PartnerCouponFieldPolicy
  }
  Patch?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PatchKeySpecifier
      | (() => undefined | PatchKeySpecifier)
    fields?: PatchFieldPolicy
  }
  PathComponentInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PathComponentInfoKeySpecifier
      | (() => undefined | PathComponentInfoKeySpecifier)
    fields?: PathComponentInfoFieldPolicy
  }
  PaymentDetails?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PaymentDetailsKeySpecifier
      | (() => undefined | PaymentDetailsKeySpecifier)
    fields?: PaymentDetailsFieldPolicy
  }
  PaymentMethodConvertedToInvoiceAudit?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | PaymentMethodConvertedToInvoiceAuditKeySpecifier
      | (() => undefined | PaymentMethodConvertedToInvoiceAuditKeySpecifier)
    fields?: PaymentMethodConvertedToInvoiceAuditFieldPolicy
  }
  PaymentsPartner?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PaymentsPartnerKeySpecifier
      | (() => undefined | PaymentsPartnerKeySpecifier)
    fields?: PaymentsPartnerFieldPolicy
  }
  PermissionGroup?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PermissionGroupKeySpecifier
      | (() => undefined | PermissionGroupKeySpecifier)
    fields?: PermissionGroupFieldPolicy
  }
  PermissionGroupMembership?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PermissionGroupMembershipKeySpecifier
      | (() => undefined | PermissionGroupMembershipKeySpecifier)
    fields?: PermissionGroupMembershipFieldPolicy
  }
  PermissionGroupMemberships?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PermissionGroupMembershipsKeySpecifier
      | (() => undefined | PermissionGroupMembershipsKeySpecifier)
    fields?: PermissionGroupMembershipsFieldPolicy
  }
  PermissionGroupRelationProject?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PermissionGroupRelationProjectKeySpecifier
      | (() => undefined | PermissionGroupRelationProjectKeySpecifier)
    fields?: PermissionGroupRelationProjectFieldPolicy
  }
  PermissionGroupRelationProjects?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PermissionGroupRelationProjectsKeySpecifier
      | (() => undefined | PermissionGroupRelationProjectsKeySpecifier)
    fields?: PermissionGroupRelationProjectsFieldPolicy
  }
  PermissionGroupRelationShare?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PermissionGroupRelationShareKeySpecifier
      | (() => undefined | PermissionGroupRelationShareKeySpecifier)
    fields?: PermissionGroupRelationShareFieldPolicy
  }
  PermissionGroupRelationShares?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PermissionGroupRelationSharesKeySpecifier
      | (() => undefined | PermissionGroupRelationSharesKeySpecifier)
    fields?: PermissionGroupRelationSharesFieldPolicy
  }
  PermissionGroups?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PermissionGroupsKeySpecifier
      | (() => undefined | PermissionGroupsKeySpecifier)
    fields?: PermissionGroupsFieldPolicy
  }
  Permissions?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PermissionsKeySpecifier
      | (() => undefined | PermissionsKeySpecifier)
    fields?: PermissionsFieldPolicy
  }
  PinProjectResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PinProjectResponseKeySpecifier
      | (() => undefined | PinProjectResponseKeySpecifier)
    fields?: PinProjectResponseFieldPolicy
  }
  PinShareResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PinShareResponseKeySpecifier
      | (() => undefined | PinShareResponseKeySpecifier)
    fields?: PinShareResponseFieldPolicy
  }
  PlanUpdateSimulation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PlanUpdateSimulationKeySpecifier
      | (() => undefined | PlanUpdateSimulationKeySpecifier)
    fields?: PlanUpdateSimulationFieldPolicy
  }
  PresentationFile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PresentationFileKeySpecifier
      | (() => undefined | PresentationFileKeySpecifier)
    fields?: PresentationFileFieldPolicy
  }
  Preview?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PreviewKeySpecifier
      | (() => undefined | PreviewKeySpecifier)
    fields?: PreviewFieldPolicy
  }
  PreviewCreatedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PreviewCreatedEventKeySpecifier
      | (() => undefined | PreviewCreatedEventKeySpecifier)
    fields?: PreviewCreatedEventFieldPolicy
  }
  PreviewDeletedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PreviewDeletedEventKeySpecifier
      | (() => undefined | PreviewDeletedEventKeySpecifier)
    fields?: PreviewDeletedEventFieldPolicy
  }
  PreviewUpdatedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PreviewUpdatedEventKeySpecifier
      | (() => undefined | PreviewUpdatedEventKeySpecifier)
    fields?: PreviewUpdatedEventFieldPolicy
  }
  Price?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PriceKeySpecifier
      | (() => undefined | PriceKeySpecifier)
    fields?: PriceFieldPolicy
  }
  Project?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectKeySpecifier
      | (() => undefined | ProjectKeySpecifier)
    fields?: ProjectFieldPolicy
  }
  ProjectAccessGrantedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectAccessGrantedEventKeySpecifier
      | (() => undefined | ProjectAccessGrantedEventKeySpecifier)
    fields?: ProjectAccessGrantedEventFieldPolicy
  }
  ProjectAccessRevokedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectAccessRevokedEventKeySpecifier
      | (() => undefined | ProjectAccessRevokedEventKeySpecifier)
    fields?: ProjectAccessRevokedEventFieldPolicy
  }
  ProjectArchivedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectArchivedEventKeySpecifier
      | (() => undefined | ProjectArchivedEventKeySpecifier)
    fields?: ProjectArchivedEventFieldPolicy
  }
  ProjectChangedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectChangedEventKeySpecifier
      | (() => undefined | ProjectChangedEventKeySpecifier)
    fields?: ProjectChangedEventFieldPolicy
  }
  ProjectCreatedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectCreatedEventKeySpecifier
      | (() => undefined | ProjectCreatedEventKeySpecifier)
    fields?: ProjectCreatedEventFieldPolicy
  }
  ProjectCreatePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectCreatePayloadKeySpecifier
      | (() => undefined | ProjectCreatePayloadKeySpecifier)
    fields?: ProjectCreatePayloadFieldPolicy
  }
  ProjectDeletedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectDeletedEventKeySpecifier
      | (() => undefined | ProjectDeletedEventKeySpecifier)
    fields?: ProjectDeletedEventFieldPolicy
  }
  ProjectDeletePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectDeletePayloadKeySpecifier
      | (() => undefined | ProjectDeletePayloadKeySpecifier)
    fields?: ProjectDeletePayloadFieldPolicy
  }
  ProjectMemberAddedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectMemberAddedEventKeySpecifier
      | (() => undefined | ProjectMemberAddedEventKeySpecifier)
    fields?: ProjectMemberAddedEventFieldPolicy
  }
  ProjectMemberChangedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectMemberChangedEventKeySpecifier
      | (() => undefined | ProjectMemberChangedEventKeySpecifier)
    fields?: ProjectMemberChangedEventFieldPolicy
  }
  ProjectMemberRemovedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectMemberRemovedEventKeySpecifier
      | (() => undefined | ProjectMemberRemovedEventKeySpecifier)
    fields?: ProjectMemberRemovedEventFieldPolicy
  }
  ProjectMembership?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectMembershipKeySpecifier
      | (() => undefined | ProjectMembershipKeySpecifier)
    fields?: ProjectMembershipFieldPolicy
  }
  ProjectMembershipPaginationItems?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ProjectMembershipPaginationItemsKeySpecifier
      | (() => undefined | ProjectMembershipPaginationItemsKeySpecifier)
    fields?: ProjectMembershipPaginationItemsFieldPolicy
  }
  ProjectMemberships?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectMembershipsKeySpecifier
      | (() => undefined | ProjectMembershipsKeySpecifier)
    fields?: ProjectMembershipsFieldPolicy
  }
  ProjectPermanentlyDeletedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectPermanentlyDeletedEventKeySpecifier
      | (() => undefined | ProjectPermanentlyDeletedEventKeySpecifier)
    fields?: ProjectPermanentlyDeletedEventFieldPolicy
  }
  ProjectRenamePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectRenamePayloadKeySpecifier
      | (() => undefined | ProjectRenamePayloadKeySpecifier)
    fields?: ProjectRenamePayloadFieldPolicy
  }
  ProjectRestoredEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectRestoredEventKeySpecifier
      | (() => undefined | ProjectRestoredEventKeySpecifier)
    fields?: ProjectRestoredEventFieldPolicy
  }
  Projects?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectsKeySpecifier
      | (() => undefined | ProjectsKeySpecifier)
    fields?: ProjectsFieldPolicy
  }
  ProjectSharePreview?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectSharePreviewKeySpecifier
      | (() => undefined | ProjectSharePreviewKeySpecifier)
    fields?: ProjectSharePreviewFieldPolicy
  }
  ProjectTransferredEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectTransferredEventKeySpecifier
      | (() => undefined | ProjectTransferredEventKeySpecifier)
    fields?: ProjectTransferredEventFieldPolicy
  }
  ProjectUnarchivedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ProjectUnarchivedEventKeySpecifier
      | (() => undefined | ProjectUnarchivedEventKeySpecifier)
    fields?: ProjectUnarchivedEventFieldPolicy
  }
  ProjectWorkspaceAccessLevelChangedEvent?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | ProjectWorkspaceAccessLevelChangedEventKeySpecifier
      | (() => undefined | ProjectWorkspaceAccessLevelChangedEventKeySpecifier)
    fields?: ProjectWorkspaceAccessLevelChangedEventFieldPolicy
  }
  Publication?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublicationKeySpecifier
      | (() => undefined | PublicationKeySpecifier)
    fields?: PublicationFieldPolicy
  }
  PublicationListing?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublicationListingKeySpecifier
      | (() => undefined | PublicationListingKeySpecifier)
    fields?: PublicationListingFieldPolicy
  }
  PublicationQueryPreferences?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublicationQueryPreferencesKeySpecifier
      | (() => undefined | PublicationQueryPreferencesKeySpecifier)
    fields?: PublicationQueryPreferencesFieldPolicy
  }
  PublicationReactionsUpdatedEvent?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | PublicationReactionsUpdatedEventKeySpecifier
      | (() => undefined | PublicationReactionsUpdatedEventKeySpecifier)
    fields?: PublicationReactionsUpdatedEventFieldPolicy
  }
  Publications?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublicationsKeySpecifier
      | (() => undefined | PublicationsKeySpecifier)
    fields?: PublicationsFieldPolicy
  }
  PublicOrganization?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublicOrganizationKeySpecifier
      | (() => undefined | PublicOrganizationKeySpecifier)
    fields?: PublicOrganizationFieldPolicy
  }
  PublicProject?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublicProjectKeySpecifier
      | (() => undefined | PublicProjectKeySpecifier)
    fields?: PublicProjectFieldPolicy
  }
  PublicProjectMembership?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublicProjectMembershipKeySpecifier
      | (() => undefined | PublicProjectMembershipKeySpecifier)
    fields?: PublicProjectMembershipFieldPolicy
  }
  PublicUser?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublicUserKeySpecifier
      | (() => undefined | PublicUserKeySpecifier)
    fields?: PublicUserFieldPolicy
  }
  PublicWorkspace?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublicWorkspaceKeySpecifier
      | (() => undefined | PublicWorkspaceKeySpecifier)
    fields?: PublicWorkspaceFieldPolicy
  }
  PublicWorkspaceCustomer?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublicWorkspaceCustomerKeySpecifier
      | (() => undefined | PublicWorkspaceCustomerKeySpecifier)
    fields?: PublicWorkspaceCustomerFieldPolicy
  }
  PublicWorkspaceFeatures?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublicWorkspaceFeaturesKeySpecifier
      | (() => undefined | PublicWorkspaceFeaturesKeySpecifier)
    fields?: PublicWorkspaceFeaturesFieldPolicy
  }
  PublicWorkspaceMembership?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublicWorkspaceMembershipKeySpecifier
      | (() => undefined | PublicWorkspaceMembershipKeySpecifier)
    fields?: PublicWorkspaceMembershipFieldPolicy
  }
  PublicWorkspaceProfile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublicWorkspaceProfileKeySpecifier
      | (() => undefined | PublicWorkspaceProfileKeySpecifier)
    fields?: PublicWorkspaceProfileFieldPolicy
  }
  PublicWorkspaces?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublicWorkspacesKeySpecifier
      | (() => undefined | PublicWorkspacesKeySpecifier)
    fields?: PublicWorkspacesFieldPolicy
  }
  PublishShareResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PublishShareResponseKeySpecifier
      | (() => undefined | PublishShareResponseKeySpecifier)
    fields?: PublishShareResponseFieldPolicy
  }
  PurchaseRestriction?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PurchaseRestrictionKeySpecifier
      | (() => undefined | PurchaseRestrictionKeySpecifier)
    fields?: PurchaseRestrictionFieldPolicy
  }
  Query?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QueryKeySpecifier
      | (() => undefined | QueryKeySpecifier)
    fields?: QueryFieldPolicy
  }
  ReactivateSubscriptionResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReactivateSubscriptionResponseKeySpecifier
      | (() => undefined | ReactivateSubscriptionResponseKeySpecifier)
    fields?: ReactivateSubscriptionResponseFieldPolicy
  }
  RecoveryCodes?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RecoveryCodesKeySpecifier
      | (() => undefined | RecoveryCodesKeySpecifier)
    fields?: RecoveryCodesFieldPolicy
  }
  RefreshAllPreviewsResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RefreshAllPreviewsResponseKeySpecifier
      | (() => undefined | RefreshAllPreviewsResponseKeySpecifier)
    fields?: RefreshAllPreviewsResponseFieldPolicy
  }
  RejectEducationRequestAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RejectEducationRequestAuditKeySpecifier
      | (() => undefined | RejectEducationRequestAuditKeySpecifier)
    fields?: RejectEducationRequestAuditFieldPolicy
  }
  RemoteCollaborativePatch?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemoteCollaborativePatchKeySpecifier
      | (() => undefined | RemoteCollaborativePatchKeySpecifier)
    fields?: RemoteCollaborativePatchFieldPolicy
  }
  RemoteMigrationCatchUp?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemoteMigrationCatchUpKeySpecifier
      | (() => undefined | RemoteMigrationCatchUpKeySpecifier)
    fields?: RemoteMigrationCatchUpFieldPolicy
  }
  RemotePatchUploadRequest?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemotePatchUploadRequestKeySpecifier
      | (() => undefined | RemotePatchUploadRequestKeySpecifier)
    fields?: RemotePatchUploadRequestFieldPolicy
  }
  RemoveIntegrationIdentityResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | RemoveIntegrationIdentityResponseKeySpecifier
      | (() => undefined | RemoveIntegrationIdentityResponseKeySpecifier)
    fields?: RemoveIntegrationIdentityResponseFieldPolicy
  }
  RemoveIntegrationResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemoveIntegrationResponseKeySpecifier
      | (() => undefined | RemoveIntegrationResponseKeySpecifier)
    fields?: RemoveIntegrationResponseFieldPolicy
  }
  RemoveMemberPermissionGroup?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemoveMemberPermissionGroupKeySpecifier
      | (() => undefined | RemoveMemberPermissionGroupKeySpecifier)
    fields?: RemoveMemberPermissionGroupFieldPolicy
  }
  RemovePermissionGroupMemberResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | RemovePermissionGroupMemberResponseKeySpecifier
      | (() => undefined | RemovePermissionGroupMemberResponseKeySpecifier)
    fields?: RemovePermissionGroupMemberResponseFieldPolicy
  }
  RemovePermissionGroupRelation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemovePermissionGroupRelationKeySpecifier
      | (() => undefined | RemovePermissionGroupRelationKeySpecifier)
    fields?: RemovePermissionGroupRelationFieldPolicy
  }
  RemovePermissionGroupRelationResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | RemovePermissionGroupRelationResponseKeySpecifier
      | (() => undefined | RemovePermissionGroupRelationResponseKeySpecifier)
    fields?: RemovePermissionGroupRelationResponseFieldPolicy
  }
  RemoveProjectMemberResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemoveProjectMemberResponseKeySpecifier
      | (() => undefined | RemoveProjectMemberResponseKeySpecifier)
    fields?: RemoveProjectMemberResponseFieldPolicy
  }
  RemoveSharesFromCollectionResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | RemoveSharesFromCollectionResponseKeySpecifier
      | (() => undefined | RemoveSharesFromCollectionResponseKeySpecifier)
    fields?: RemoveSharesFromCollectionResponseFieldPolicy
  }
  RemoveWorkspaceMemberResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemoveWorkspaceMemberResponseKeySpecifier
      | (() => undefined | RemoveWorkspaceMemberResponseKeySpecifier)
    fields?: RemoveWorkspaceMemberResponseFieldPolicy
  }
  RenameCollectionResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RenameCollectionResponseKeySpecifier
      | (() => undefined | RenameCollectionResponseKeySpecifier)
    fields?: RenameCollectionResponseFieldPolicy
  }
  RenderDownloadableAssetsPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RenderDownloadableAssetsPayloadKeySpecifier
      | (() => undefined | RenderDownloadableAssetsPayloadKeySpecifier)
    fields?: RenderDownloadableAssetsPayloadFieldPolicy
  }
  RenderPresentationResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RenderPresentationResponseKeySpecifier
      | (() => undefined | RenderPresentationResponseKeySpecifier)
    fields?: RenderPresentationResponseFieldPolicy
  }
  ReportShareResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ReportShareResponseKeySpecifier
      | (() => undefined | ReportShareResponseKeySpecifier)
    fields?: ReportShareResponseFieldPolicy
  }
  RequestAccessToProjectResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RequestAccessToProjectResponseKeySpecifier
      | (() => undefined | RequestAccessToProjectResponseKeySpecifier)
    fields?: RequestAccessToProjectResponseFieldPolicy
  }
  RequestInfoEducationRequestAudit?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | RequestInfoEducationRequestAuditKeySpecifier
      | (() => undefined | RequestInfoEducationRequestAuditKeySpecifier)
    fields?: RequestInfoEducationRequestAuditFieldPolicy
  }
  ResendVerificationEmailPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ResendVerificationEmailPayloadKeySpecifier
      | (() => undefined | ResendVerificationEmailPayloadKeySpecifier)
    fields?: ResendVerificationEmailPayloadFieldPolicy
  }
  ResendWorkspaceInviteResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ResendWorkspaceInviteResponseKeySpecifier
      | (() => undefined | ResendWorkspaceInviteResponseKeySpecifier)
    fields?: ResendWorkspaceInviteResponseFieldPolicy
  }
  ResetScimTokenAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ResetScimTokenAuditKeySpecifier
      | (() => undefined | ResetScimTokenAuditKeySpecifier)
    fields?: ResetScimTokenAuditFieldPolicy
  }
  ResetScimTokenResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ResetScimTokenResponseKeySpecifier
      | (() => undefined | ResetScimTokenResponseKeySpecifier)
    fields?: ResetScimTokenResponseFieldPolicy
  }
  ResolveAnnotationResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ResolveAnnotationResponseKeySpecifier
      | (() => undefined | ResolveAnnotationResponseKeySpecifier)
    fields?: ResolveAnnotationResponseFieldPolicy
  }
  ResponsiveImage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ResponsiveImageKeySpecifier
      | (() => undefined | ResponsiveImageKeySpecifier)
    fields?: ResponsiveImageFieldPolicy
  }
  ResponsiveSource?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ResponsiveSourceKeySpecifier
      | (() => undefined | ResponsiveSourceKeySpecifier)
    fields?: ResponsiveSourceFieldPolicy
  }
  RestoreMembershipAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RestoreMembershipAuditKeySpecifier
      | (() => undefined | RestoreMembershipAuditKeySpecifier)
    fields?: RestoreMembershipAuditFieldPolicy
  }
  RestoreProjectResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RestoreProjectResponseKeySpecifier
      | (() => undefined | RestoreProjectResponseKeySpecifier)
    fields?: RestoreProjectResponseFieldPolicy
  }
  RestoreShareResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RestoreShareResponseKeySpecifier
      | (() => undefined | RestoreShareResponseKeySpecifier)
    fields?: RestoreShareResponseFieldPolicy
  }
  Revision?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RevisionKeySpecifier
      | (() => undefined | RevisionKeySpecifier)
    fields?: RevisionFieldPolicy
  }
  RevisionDeleted?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RevisionDeletedKeySpecifier
      | (() => undefined | RevisionDeletedKeySpecifier)
    fields?: RevisionDeletedFieldPolicy
  }
  RevisionMovedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RevisionMovedEventKeySpecifier
      | (() => undefined | RevisionMovedEventKeySpecifier)
    fields?: RevisionMovedEventFieldPolicy
  }
  RevisionUnavailable?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RevisionUnavailableKeySpecifier
      | (() => undefined | RevisionUnavailableKeySpecifier)
    fields?: RevisionUnavailableFieldPolicy
  }
  RevokeActiveSessionsPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RevokeActiveSessionsPayloadKeySpecifier
      | (() => undefined | RevokeActiveSessionsPayloadKeySpecifier)
    fields?: RevokeActiveSessionsPayloadFieldPolicy
  }
  RevokeOAuthResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RevokeOAuthResponseKeySpecifier
      | (() => undefined | RevokeOAuthResponseKeySpecifier)
    fields?: RevokeOAuthResponseFieldPolicy
  }
  RevokeSessionPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RevokeSessionPayloadKeySpecifier
      | (() => undefined | RevokeSessionPayloadKeySpecifier)
    fields?: RevokeSessionPayloadFieldPolicy
  }
  RGBAColor?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RGBAColorKeySpecifier
      | (() => undefined | RGBAColorKeySpecifier)
    fields?: RGBAColorFieldPolicy
  }
  RootMutationType?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RootMutationTypeKeySpecifier
      | (() => undefined | RootMutationTypeKeySpecifier)
    fields?: RootMutationTypeFieldPolicy
  }
  RootQueryType?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RootQueryTypeKeySpecifier
      | (() => undefined | RootQueryTypeKeySpecifier)
    fields?: RootQueryTypeFieldPolicy
  }
  RootSubscriptionType?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RootSubscriptionTypeKeySpecifier
      | (() => undefined | RootSubscriptionTypeKeySpecifier)
    fields?: RootSubscriptionTypeFieldPolicy
  }
  SamlAttribute?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SamlAttributeKeySpecifier
      | (() => undefined | SamlAttributeKeySpecifier)
    fields?: SamlAttributeFieldPolicy
  }
  ScimPersonalAccessToken?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ScimPersonalAccessTokenKeySpecifier
      | (() => undefined | ScimPersonalAccessTokenKeySpecifier)
    fields?: ScimPersonalAccessTokenFieldPolicy
  }
  SeatsUpdateSimulation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SeatsUpdateSimulationKeySpecifier
      | (() => undefined | SeatsUpdateSimulationKeySpecifier)
    fields?: SeatsUpdateSimulationFieldPolicy
  }
  Section?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SectionKeySpecifier
      | (() => undefined | SectionKeySpecifier)
    fields?: SectionFieldPolicy
  }
  SectionCategory?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SectionCategoryKeySpecifier
      | (() => undefined | SectionCategoryKeySpecifier)
    fields?: SectionCategoryFieldPolicy
  }
  SectionSubTitle?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SectionSubTitleKeySpecifier
      | (() => undefined | SectionSubTitleKeySpecifier)
    fields?: SectionSubTitleFieldPolicy
  }
  SendDownloadSketchEmailResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SendDownloadSketchEmailResponseKeySpecifier
      | (() => undefined | SendDownloadSketchEmailResponseKeySpecifier)
    fields?: SendDownloadSketchEmailResponseFieldPolicy
  }
  SendPasswordSetupEmailResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SendPasswordSetupEmailResponseKeySpecifier
      | (() => undefined | SendPasswordSetupEmailResponseKeySpecifier)
    fields?: SendPasswordSetupEmailResponseFieldPolicy
  }
  Session?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SessionKeySpecifier
      | (() => undefined | SessionKeySpecifier)
    fields?: SessionFieldPolicy
  }
  Sessions?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SessionsKeySpecifier
      | (() => undefined | SessionsKeySpecifier)
    fields?: SessionsFieldPolicy
  }
  SetDesignSystemsEligibilityAudit?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | SetDesignSystemsEligibilityAuditKeySpecifier
      | (() => undefined | SetDesignSystemsEligibilityAuditKeySpecifier)
    fields?: SetDesignSystemsEligibilityAuditFieldPolicy
  }
  SetNotificationSubscriptionResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | SetNotificationSubscriptionResponseKeySpecifier
      | (() => undefined | SetNotificationSubscriptionResponseKeySpecifier)
    fields?: SetNotificationSubscriptionResponseFieldPolicy
  }
  SetRestrictedUploadsEligibilityAudit?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | SetRestrictedUploadsEligibilityAuditKeySpecifier
      | (() => undefined | SetRestrictedUploadsEligibilityAuditKeySpecifier)
    fields?: SetRestrictedUploadsEligibilityAuditFieldPolicy
  }
  SetScimEnabledAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SetScimEnabledAuditKeySpecifier
      | (() => undefined | SetScimEnabledAuditKeySpecifier)
    fields?: SetScimEnabledAuditFieldPolicy
  }
  SetSsoConfigAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SetSsoConfigAuditKeySpecifier
      | (() => undefined | SetSsoConfigAuditKeySpecifier)
    fields?: SetSsoConfigAuditFieldPolicy
  }
  SetSsoEligibilityAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SetSsoEligibilityAuditKeySpecifier
      | (() => undefined | SetSsoEligibilityAuditKeySpecifier)
    fields?: SetSsoEligibilityAuditFieldPolicy
  }
  SetupMfaResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SetupMfaResponseKeySpecifier
      | (() => undefined | SetupMfaResponseKeySpecifier)
    fields?: SetupMfaResponseFieldPolicy
  }
  SetWorkspaceExpiredVersionsRulesAudit?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | SetWorkspaceExpiredVersionsRulesAuditKeySpecifier
      | (() => undefined | SetWorkspaceExpiredVersionsRulesAuditKeySpecifier)
    fields?: SetWorkspaceExpiredVersionsRulesAuditFieldPolicy
  }
  Share?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareKeySpecifier
      | (() => undefined | ShareKeySpecifier)
    fields?: ShareFieldPolicy
  }
  ShareAcceptRequestPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareAcceptRequestPayloadKeySpecifier
      | (() => undefined | ShareAcceptRequestPayloadKeySpecifier)
    fields?: ShareAcceptRequestPayloadFieldPolicy
  }
  ShareAccessRevokedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareAccessRevokedEventKeySpecifier
      | (() => undefined | ShareAccessRevokedEventKeySpecifier)
    fields?: ShareAccessRevokedEventFieldPolicy
  }
  ShareAddedToCollectionEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareAddedToCollectionEventKeySpecifier
      | (() => undefined | ShareAddedToCollectionEventKeySpecifier)
    fields?: ShareAddedToCollectionEventFieldPolicy
  }
  ShareArchivedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareArchivedEventKeySpecifier
      | (() => undefined | ShareArchivedEventKeySpecifier)
    fields?: ShareArchivedEventFieldPolicy
  }
  ShareCreatePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareCreatePayloadKeySpecifier
      | (() => undefined | ShareCreatePayloadKeySpecifier)
    fields?: ShareCreatePayloadFieldPolicy
  }
  ShareCreateVersionPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareCreateVersionPayloadKeySpecifier
      | (() => undefined | ShareCreateVersionPayloadKeySpecifier)
    fields?: ShareCreateVersionPayloadFieldPolicy
  }
  ShareDeletedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareDeletedEventKeySpecifier
      | (() => undefined | ShareDeletedEventKeySpecifier)
    fields?: ShareDeletedEventFieldPolicy
  }
  ShareDeletedPermanentlyEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareDeletedPermanentlyEventKeySpecifier
      | (() => undefined | ShareDeletedPermanentlyEventKeySpecifier)
    fields?: ShareDeletedPermanentlyEventFieldPolicy
  }
  ShareDeleteMembershipPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareDeleteMembershipPayloadKeySpecifier
      | (() => undefined | ShareDeleteMembershipPayloadKeySpecifier)
    fields?: ShareDeleteMembershipPayloadFieldPolicy
  }
  ShareDeletePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareDeletePayloadKeySpecifier
      | (() => undefined | ShareDeletePayloadKeySpecifier)
    fields?: ShareDeletePayloadFieldPolicy
  }
  ShareInvite?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareInviteKeySpecifier
      | (() => undefined | ShareInviteKeySpecifier)
    fields?: ShareInviteFieldPolicy
  }
  ShareLeavePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareLeavePayloadKeySpecifier
      | (() => undefined | ShareLeavePayloadKeySpecifier)
    fields?: ShareLeavePayloadFieldPolicy
  }
  ShareLicenseAgreement?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareLicenseAgreementKeySpecifier
      | (() => undefined | ShareLicenseAgreementKeySpecifier)
    fields?: ShareLicenseAgreementFieldPolicy
  }
  ShareMembership?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareMembershipKeySpecifier
      | (() => undefined | ShareMembershipKeySpecifier)
    fields?: ShareMembershipFieldPolicy
  }
  ShareMembershipAcceptPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareMembershipAcceptPayloadKeySpecifier
      | (() => undefined | ShareMembershipAcceptPayloadKeySpecifier)
    fields?: ShareMembershipAcceptPayloadFieldPolicy
  }
  ShareMembershipChangedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareMembershipChangedEventKeySpecifier
      | (() => undefined | ShareMembershipChangedEventKeySpecifier)
    fields?: ShareMembershipChangedEventFieldPolicy
  }
  ShareMembershipPaginationItems?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareMembershipPaginationItemsKeySpecifier
      | (() => undefined | ShareMembershipPaginationItemsKeySpecifier)
    fields?: ShareMembershipPaginationItemsFieldPolicy
  }
  ShareMemberships?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareMembershipsKeySpecifier
      | (() => undefined | ShareMembershipsKeySpecifier)
    fields?: ShareMembershipsFieldPolicy
  }
  ShareMoveResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareMoveResultKeySpecifier
      | (() => undefined | ShareMoveResultKeySpecifier)
    fields?: ShareMoveResultFieldPolicy
  }
  ShareOwner?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareOwnerKeySpecifier
      | (() => undefined | ShareOwnerKeySpecifier)
    fields?: ShareOwnerFieldPolicy
  }
  ShareProjectChangedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareProjectChangedEventKeySpecifier
      | (() => undefined | ShareProjectChangedEventKeySpecifier)
    fields?: ShareProjectChangedEventFieldPolicy
  }
  ShareRemovedFromCollectionEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareRemovedFromCollectionEventKeySpecifier
      | (() => undefined | ShareRemovedFromCollectionEventKeySpecifier)
    fields?: ShareRemovedFromCollectionEventFieldPolicy
  }
  ShareRemoveFromProjectResult?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareRemoveFromProjectResultKeySpecifier
      | (() => undefined | ShareRemoveFromProjectResultKeySpecifier)
    fields?: ShareRemoveFromProjectResultFieldPolicy
  }
  ShareRequestAccessPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareRequestAccessPayloadKeySpecifier
      | (() => undefined | ShareRequestAccessPayloadKeySpecifier)
    fields?: ShareRequestAccessPayloadFieldPolicy
  }
  ShareRestoredEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareRestoredEventKeySpecifier
      | (() => undefined | ShareRestoredEventKeySpecifier)
    fields?: ShareRestoredEventFieldPolicy
  }
  ShareRestorePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareRestorePayloadKeySpecifier
      | (() => undefined | ShareRestorePayloadKeySpecifier)
    fields?: ShareRestorePayloadFieldPolicy
  }
  Shares?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SharesKeySpecifier
      | (() => undefined | SharesKeySpecifier)
    fields?: SharesFieldPolicy
  }
  SharesDeletePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SharesDeletePayloadKeySpecifier
      | (() => undefined | SharesDeletePayloadKeySpecifier)
    fields?: SharesDeletePayloadFieldPolicy
  }
  ShareTransferredEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareTransferredEventKeySpecifier
      | (() => undefined | ShareTransferredEventKeySpecifier)
    fields?: ShareTransferredEventFieldPolicy
  }
  ShareUnwatchPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareUnwatchPayloadKeySpecifier
      | (() => undefined | ShareUnwatchPayloadKeySpecifier)
    fields?: ShareUnwatchPayloadFieldPolicy
  }
  ShareUpdatedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareUpdatedEventKeySpecifier
      | (() => undefined | ShareUpdatedEventKeySpecifier)
    fields?: ShareUpdatedEventFieldPolicy
  }
  ShareUpdatePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareUpdatePayloadKeySpecifier
      | (() => undefined | ShareUpdatePayloadKeySpecifier)
    fields?: ShareUpdatePayloadFieldPolicy
  }
  ShareWatchPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareWatchPayloadKeySpecifier
      | (() => undefined | ShareWatchPayloadKeySpecifier)
    fields?: ShareWatchPayloadFieldPolicy
  }
  ShareWithSize?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShareWithSizeKeySpecifier
      | (() => undefined | ShareWithSizeKeySpecifier)
    fields?: ShareWithSizeFieldPolicy
  }
  SignInAndDisableMfaResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SignInAndDisableMfaResponseKeySpecifier
      | (() => undefined | SignInAndDisableMfaResponseKeySpecifier)
    fields?: SignInAndDisableMfaResponseFieldPolicy
  }
  SignInCredentials?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SignInCredentialsKeySpecifier
      | (() => undefined | SignInCredentialsKeySpecifier)
    fields?: SignInCredentialsFieldPolicy
  }
  SignInWithSsoResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SignInWithSsoResponseKeySpecifier
      | (() => undefined | SignInWithSsoResponseKeySpecifier)
    fields?: SignInWithSsoResponseFieldPolicy
  }
  SignOffResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SignOffResponseKeySpecifier
      | (() => undefined | SignOffResponseKeySpecifier)
    fields?: SignOffResponseFieldPolicy
  }
  SignUpPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SignUpPayloadKeySpecifier
      | (() => undefined | SignUpPayloadKeySpecifier)
    fields?: SignUpPayloadFieldPolicy
  }
  SingleImage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SingleImageKeySpecifier
      | (() => undefined | SingleImageKeySpecifier)
    fields?: SingleImageFieldPolicy
  }
  Size?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | SizeKeySpecifier | (() => undefined | SizeKeySpecifier)
    fields?: SizeFieldPolicy
  }
  SocialAccount?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SocialAccountKeySpecifier
      | (() => undefined | SocialAccountKeySpecifier)
    fields?: SocialAccountFieldPolicy
  }
  SocialSignInStartUrlPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SocialSignInStartUrlPayloadKeySpecifier
      | (() => undefined | SocialSignInStartUrlPayloadKeySpecifier)
    fields?: SocialSignInStartUrlPayloadFieldPolicy
  }
  Speaker?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SpeakerKeySpecifier
      | (() => undefined | SpeakerKeySpecifier)
    fields?: SpeakerFieldPolicy
  }
  SsoMembershipProvisionedAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SsoMembershipProvisionedAuditKeySpecifier
      | (() => undefined | SsoMembershipProvisionedAuditKeySpecifier)
    fields?: SsoMembershipProvisionedAuditFieldPolicy
  }
  SsoStartPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SsoStartPayloadKeySpecifier
      | (() => undefined | SsoStartPayloadKeySpecifier)
    fields?: SsoStartPayloadFieldPolicy
  }
  StarNotification?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StarNotificationKeySpecifier
      | (() => undefined | StarNotificationKeySpecifier)
    fields?: StarNotificationFieldPolicy
  }
  StorageItem?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StorageItemKeySpecifier
      | (() => undefined | StorageItemKeySpecifier)
    fields?: StorageItemFieldPolicy
  }
  StorageItems?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StorageItemsKeySpecifier
      | (() => undefined | StorageItemsKeySpecifier)
    fields?: StorageItemsFieldPolicy
  }
  StorageItemsPaginationMeta?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | StorageItemsPaginationMetaKeySpecifier
      | (() => undefined | StorageItemsPaginationMetaKeySpecifier)
    fields?: StorageItemsPaginationMetaFieldPolicy
  }
  SubscribeCustomerToPlanResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SubscribeCustomerToPlanResponseKeySpecifier
      | (() => undefined | SubscribeCustomerToPlanResponseKeySpecifier)
    fields?: SubscribeCustomerToPlanResponseFieldPolicy
  }
  SubscriptionDetails?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SubscriptionDetailsKeySpecifier
      | (() => undefined | SubscriptionDetailsKeySpecifier)
    fields?: SubscriptionDetailsFieldPolicy
  }
  SubscriptionInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SubscriptionInfoKeySpecifier
      | (() => undefined | SubscriptionInfoKeySpecifier)
    fields?: SubscriptionInfoFieldPolicy
  }
  SupportAccessDisabledAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SupportAccessDisabledAuditKeySpecifier
      | (() => undefined | SupportAccessDisabledAuditKeySpecifier)
    fields?: SupportAccessDisabledAuditFieldPolicy
  }
  SupportAccessEnabledAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SupportAccessEnabledAuditKeySpecifier
      | (() => undefined | SupportAccessEnabledAuditKeySpecifier)
    fields?: SupportAccessEnabledAuditFieldPolicy
  }
  Symbol?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SymbolKeySpecifier
      | (() => undefined | SymbolKeySpecifier)
    fields?: SymbolFieldPolicy
  }
  TextStyle?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TextStyleKeySpecifier
      | (() => undefined | TextStyleKeySpecifier)
    fields?: TextStyleFieldPolicy
  }
  TextStyleFont?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TextStyleFontKeySpecifier
      | (() => undefined | TextStyleFontKeySpecifier)
    fields?: TextStyleFontFieldPolicy
  }
  Thumbnail?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ThumbnailKeySpecifier
      | (() => undefined | ThumbnailKeySpecifier)
    fields?: ThumbnailFieldPolicy
  }
  TogglePasswordProtectedPreviewsResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | TogglePasswordProtectedPreviewsResponseKeySpecifier
      | (() => undefined | TogglePasswordProtectedPreviewsResponseKeySpecifier)
    fields?: TogglePasswordProtectedPreviewsResponseFieldPolicy
  }
  TokenExport?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TokenExportKeySpecifier
      | (() => undefined | TokenExportKeySpecifier)
    fields?: TokenExportFieldPolicy
  }
  TransferDestinations?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TransferDestinationsKeySpecifier
      | (() => undefined | TransferDestinationsKeySpecifier)
    fields?: TransferDestinationsFieldPolicy
  }
  TransferOrganizationAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TransferOrganizationAuditKeySpecifier
      | (() => undefined | TransferOrganizationAuditKeySpecifier)
    fields?: TransferOrganizationAuditFieldPolicy
  }
  TransferShareResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TransferShareResponseKeySpecifier
      | (() => undefined | TransferShareResponseKeySpecifier)
    fields?: TransferShareResponseFieldPolicy
  }
  TransferStorageItemResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TransferStorageItemResponseKeySpecifier
      | (() => undefined | TransferStorageItemResponseKeySpecifier)
    fields?: TransferStorageItemResponseFieldPolicy
  }
  TransferStorageItemsResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TransferStorageItemsResponseKeySpecifier
      | (() => undefined | TransferStorageItemsResponseKeySpecifier)
    fields?: TransferStorageItemsResponseFieldPolicy
  }
  TrashedItems?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TrashedItemsKeySpecifier
      | (() => undefined | TrashedItemsKeySpecifier)
    fields?: TrashedItemsFieldPolicy
  }
  TrashedProject?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TrashedProjectKeySpecifier
      | (() => undefined | TrashedProjectKeySpecifier)
    fields?: TrashedProjectFieldPolicy
  }
  TrashedShare?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TrashedShareKeySpecifier
      | (() => undefined | TrashedShareKeySpecifier)
    fields?: TrashedShareFieldPolicy
  }
  TrashedShares?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TrashedSharesKeySpecifier
      | (() => undefined | TrashedSharesKeySpecifier)
    fields?: TrashedSharesFieldPolicy
  }
  TrialAmendAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TrialAmendAuditKeySpecifier
      | (() => undefined | TrialAmendAuditKeySpecifier)
    fields?: TrialAmendAuditFieldPolicy
  }
  UnarchiveProject?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UnarchiveProjectKeySpecifier
      | (() => undefined | UnarchiveProjectKeySpecifier)
    fields?: UnarchiveProjectFieldPolicy
  }
  UnarchiveProjectResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UnarchiveProjectResponseKeySpecifier
      | (() => undefined | UnarchiveProjectResponseKeySpecifier)
    fields?: UnarchiveProjectResponseFieldPolicy
  }
  UndoScheduledSubscriptionCancellationResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UndoScheduledSubscriptionCancellationResponseKeySpecifier
      | (() =>
          | undefined
          | UndoScheduledSubscriptionCancellationResponseKeySpecifier)
    fields?: UndoScheduledSubscriptionCancellationResponseFieldPolicy
  }
  UninstallIntegrationAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UninstallIntegrationAuditKeySpecifier
      | (() => undefined | UninstallIntegrationAuditKeySpecifier)
    fields?: UninstallIntegrationAuditFieldPolicy
  }
  UnknownAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UnknownAuditKeySpecifier
      | (() => undefined | UnknownAuditKeySpecifier)
    fields?: UnknownAuditFieldPolicy
  }
  UnlinkSocialAccountResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UnlinkSocialAccountResponseKeySpecifier
      | (() => undefined | UnlinkSocialAccountResponseKeySpecifier)
    fields?: UnlinkSocialAccountResponseFieldPolicy
  }
  UnpaginatedCollection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UnpaginatedCollectionKeySpecifier
      | (() => undefined | UnpaginatedCollectionKeySpecifier)
    fields?: UnpaginatedCollectionFieldPolicy
  }
  UnpaginatedCollectionShare?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UnpaginatedCollectionShareKeySpecifier
      | (() => undefined | UnpaginatedCollectionShareKeySpecifier)
    fields?: UnpaginatedCollectionShareFieldPolicy
  }
  UnpaginatedProject?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UnpaginatedProjectKeySpecifier
      | (() => undefined | UnpaginatedProjectKeySpecifier)
    fields?: UnpaginatedProjectFieldPolicy
  }
  UnpinProjectResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UnpinProjectResponseKeySpecifier
      | (() => undefined | UnpinProjectResponseKeySpecifier)
    fields?: UnpinProjectResponseFieldPolicy
  }
  UnpinShareResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UnpinShareResponseKeySpecifier
      | (() => undefined | UnpinShareResponseKeySpecifier)
    fields?: UnpinShareResponseFieldPolicy
  }
  UnprocessedPage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UnprocessedPageKeySpecifier
      | (() => undefined | UnprocessedPageKeySpecifier)
    fields?: UnprocessedPageFieldPolicy
  }
  UnprocessedSubject?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UnprocessedSubjectKeySpecifier
      | (() => undefined | UnprocessedSubjectKeySpecifier)
    fields?: UnprocessedSubjectFieldPolicy
  }
  UnpublishShareResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UnpublishShareResponseKeySpecifier
      | (() => undefined | UnpublishShareResponseKeySpecifier)
    fields?: UnpublishShareResponseFieldPolicy
  }
  UnresolveAnnotationResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UnresolveAnnotationResponseKeySpecifier
      | (() => undefined | UnresolveAnnotationResponseKeySpecifier)
    fields?: UnresolveAnnotationResponseFieldPolicy
  }
  UpdateBillingDetailsResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateBillingDetailsResponseKeySpecifier
      | (() => undefined | UpdateBillingDetailsResponseKeySpecifier)
    fields?: UpdateBillingDetailsResponseFieldPolicy
  }
  UpdateBillingSeatsResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateBillingSeatsResponseKeySpecifier
      | (() => undefined | UpdateBillingSeatsResponseKeySpecifier)
    fields?: UpdateBillingSeatsResponseFieldPolicy
  }
  UpdateMembershipAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateMembershipAuditKeySpecifier
      | (() => undefined | UpdateMembershipAuditKeySpecifier)
    fields?: UpdateMembershipAuditFieldPolicy
  }
  UpdatePaymentDetailsResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePaymentDetailsResponseKeySpecifier
      | (() => undefined | UpdatePaymentDetailsResponseKeySpecifier)
    fields?: UpdatePaymentDetailsResponseFieldPolicy
  }
  UpdatePermissionGroup?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePermissionGroupKeySpecifier
      | (() => undefined | UpdatePermissionGroupKeySpecifier)
    fields?: UpdatePermissionGroupFieldPolicy
  }
  UpdatePermissionGroupRelationResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpdatePermissionGroupRelationResponseKeySpecifier
      | (() => undefined | UpdatePermissionGroupRelationResponseKeySpecifier)
    fields?: UpdatePermissionGroupRelationResponseFieldPolicy
  }
  UpdatePermissionGroupResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePermissionGroupResponseKeySpecifier
      | (() => undefined | UpdatePermissionGroupResponseKeySpecifier)
    fields?: UpdatePermissionGroupResponseFieldPolicy
  }
  UpdatePreviewResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdatePreviewResponseKeySpecifier
      | (() => undefined | UpdatePreviewResponseKeySpecifier)
    fields?: UpdatePreviewResponseFieldPolicy
  }
  UpdateProjectMembershipResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateProjectMembershipResponseKeySpecifier
      | (() => undefined | UpdateProjectMembershipResponseKeySpecifier)
    fields?: UpdateProjectMembershipResponseFieldPolicy
  }
  UpdateProjectPermissionResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateProjectPermissionResponseKeySpecifier
      | (() => undefined | UpdateProjectPermissionResponseKeySpecifier)
    fields?: UpdateProjectPermissionResponseFieldPolicy
  }
  UpdateProjectResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateProjectResponseKeySpecifier
      | (() => undefined | UpdateProjectResponseKeySpecifier)
    fields?: UpdateProjectResponseFieldPolicy
  }
  UpdateRestrictedPublicLinksResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpdateRestrictedPublicLinksResponseKeySpecifier
      | (() => undefined | UpdateRestrictedPublicLinksResponseKeySpecifier)
    fields?: UpdateRestrictedPublicLinksResponseFieldPolicy
  }
  UpdateRestrictedUploadsStateResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpdateRestrictedUploadsStateResponseKeySpecifier
      | (() => undefined | UpdateRestrictedUploadsStateResponseKeySpecifier)
    fields?: UpdateRestrictedUploadsStateResponseFieldPolicy
  }
  UpdateShareMembershipResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateShareMembershipResponseKeySpecifier
      | (() => undefined | UpdateShareMembershipResponseKeySpecifier)
    fields?: UpdateShareMembershipResponseFieldPolicy
  }
  UpdateSharePermissionGroupRelationResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpdateSharePermissionGroupRelationResponseKeySpecifier
      | (() =>
          | undefined
          | UpdateSharePermissionGroupRelationResponseKeySpecifier)
    fields?: UpdateSharePermissionGroupRelationResponseFieldPolicy
  }
  UpdateUserPreferencesResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateUserPreferencesResponseKeySpecifier
      | (() => undefined | UpdateUserPreferencesResponseKeySpecifier)
    fields?: UpdateUserPreferencesResponseFieldPolicy
  }
  UpdateWorksapceCustomerSsoShortNameResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpdateWorksapceCustomerSsoShortNameResponseKeySpecifier
      | (() =>
          | undefined
          | UpdateWorksapceCustomerSsoShortNameResponseKeySpecifier)
    fields?: UpdateWorksapceCustomerSsoShortNameResponseFieldPolicy
  }
  UpdateWorkspaceAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateWorkspaceAuditKeySpecifier
      | (() => undefined | UpdateWorkspaceAuditKeySpecifier)
    fields?: UpdateWorkspaceAuditFieldPolicy
  }
  UpdateWorkspaceCustomerSsoAttributeMappingResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpdateWorkspaceCustomerSsoAttributeMappingResponseKeySpecifier
      | (() =>
          | undefined
          | UpdateWorkspaceCustomerSsoAttributeMappingResponseKeySpecifier)
    fields?: UpdateWorkspaceCustomerSsoAttributeMappingResponseFieldPolicy
  }
  UpdateWorkspaceCustomerSsoIdentityProviderConfigResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpdateWorkspaceCustomerSsoIdentityProviderConfigResponseKeySpecifier
      | (() =>
          | undefined
          | UpdateWorkspaceCustomerSsoIdentityProviderConfigResponseKeySpecifier)
    fields?: UpdateWorkspaceCustomerSsoIdentityProviderConfigResponseFieldPolicy
  }
  UpdateWorkspaceMemberResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateWorkspaceMemberResponseKeySpecifier
      | (() => undefined | UpdateWorkspaceMemberResponseKeySpecifier)
    fields?: UpdateWorkspaceMemberResponseFieldPolicy
  }
  UpdateWorkspaceProfileResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateWorkspaceProfileResponseKeySpecifier
      | (() => undefined | UpdateWorkspaceProfileResponseKeySpecifier)
    fields?: UpdateWorkspaceProfileResponseFieldPolicy
  }
  UpdateWorkspaceProfileShortUrlResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpdateWorkspaceProfileShortUrlResponseKeySpecifier
      | (() => undefined | UpdateWorkspaceProfileShortUrlResponseKeySpecifier)
    fields?: UpdateWorkspaceProfileShortUrlResponseFieldPolicy
  }
  UpdateWorkspaceResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpdateWorkspaceResponseKeySpecifier
      | (() => undefined | UpdateWorkspaceResponseKeySpecifier)
    fields?: UpdateWorkspaceResponseFieldPolicy
  }
  UpdateWorkspaceSecurityEmailResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpdateWorkspaceSecurityEmailResponseKeySpecifier
      | (() => undefined | UpdateWorkspaceSecurityEmailResponseKeySpecifier)
    fields?: UpdateWorkspaceSecurityEmailResponseFieldPolicy
  }
  UpgradePersonalWorkspaceAudit?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UpgradePersonalWorkspaceAuditKeySpecifier
      | (() => undefined | UpgradePersonalWorkspaceAuditKeySpecifier)
    fields?: UpgradePersonalWorkspaceAuditFieldPolicy
  }
  UpgradePersonalWorkspaceResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | UpgradePersonalWorkspaceResponseKeySpecifier
      | (() => undefined | UpgradePersonalWorkspaceResponseKeySpecifier)
    fields?: UpgradePersonalWorkspaceResponseFieldPolicy
  }
  User?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier)
    fields?: UserFieldPolicy
  }
  UserAcceptTosAgreementPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserAcceptTosAgreementPayloadKeySpecifier
      | (() => undefined | UserAcceptTosAgreementPayloadKeySpecifier)
    fields?: UserAcceptTosAgreementPayloadFieldPolicy
  }
  UserAvatarCreate?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserAvatarCreateKeySpecifier
      | (() => undefined | UserAvatarCreateKeySpecifier)
    fields?: UserAvatarCreateFieldPolicy
  }
  UserAvatarDeletePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserAvatarDeletePayloadKeySpecifier
      | (() => undefined | UserAvatarDeletePayloadKeySpecifier)
    fields?: UserAvatarDeletePayloadFieldPolicy
  }
  UserDeletePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserDeletePayloadKeySpecifier
      | (() => undefined | UserDeletePayloadKeySpecifier)
    fields?: UserDeletePayloadFieldPolicy
  }
  UserError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserErrorKeySpecifier
      | (() => undefined | UserErrorKeySpecifier)
    fields?: UserErrorFieldPolicy
  }
  UserErrorExtensions?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserErrorExtensionsKeySpecifier
      | (() => undefined | UserErrorExtensionsKeySpecifier)
    fields?: UserErrorExtensionsFieldPolicy
  }
  UserNotification?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserNotificationKeySpecifier
      | (() => undefined | UserNotificationKeySpecifier)
    fields?: UserNotificationFieldPolicy
  }
  UserPasswordResetPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserPasswordResetPayloadKeySpecifier
      | (() => undefined | UserPasswordResetPayloadKeySpecifier)
    fields?: UserPasswordResetPayloadFieldPolicy
  }
  UserPasswordUpdatePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserPasswordUpdatePayloadKeySpecifier
      | (() => undefined | UserPasswordUpdatePayloadKeySpecifier)
    fields?: UserPasswordUpdatePayloadFieldPolicy
  }
  UserPreferences?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserPreferencesKeySpecifier
      | (() => undefined | UserPreferencesKeySpecifier)
    fields?: UserPreferencesFieldPolicy
  }
  UserRequestPasswordResetPayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserRequestPasswordResetPayloadKeySpecifier
      | (() => undefined | UserRequestPasswordResetPayloadKeySpecifier)
    fields?: UserRequestPasswordResetPayloadFieldPolicy
  }
  UserUpdatePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserUpdatePayloadKeySpecifier
      | (() => undefined | UserUpdatePayloadKeySpecifier)
    fields?: UserUpdatePayloadFieldPolicy
  }
  ValidateMFAResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ValidateMFAResponseKeySpecifier
      | (() => undefined | ValidateMFAResponseKeySpecifier)
    fields?: ValidateMFAResponseFieldPolicy
  }
  Version?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VersionKeySpecifier
      | (() => undefined | VersionKeySpecifier)
    fields?: VersionFieldPolicy
  }
  VersionDeleted?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VersionDeletedKeySpecifier
      | (() => undefined | VersionDeletedKeySpecifier)
    fields?: VersionDeletedFieldPolicy
  }
  VersionDeletedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VersionDeletedEventKeySpecifier
      | (() => undefined | VersionDeletedEventKeySpecifier)
    fields?: VersionDeletedEventFieldPolicy
  }
  VersionDeletePayload?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VersionDeletePayloadKeySpecifier
      | (() => undefined | VersionDeletePayloadKeySpecifier)
    fields?: VersionDeletePayloadFieldPolicy
  }
  VersionHistory?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VersionHistoryKeySpecifier
      | (() => undefined | VersionHistoryKeySpecifier)
    fields?: VersionHistoryFieldPolicy
  }
  Versions?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VersionsKeySpecifier
      | (() => undefined | VersionsKeySpecifier)
    fields?: VersionsFieldPolicy
  }
  VersionUnavailable?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VersionUnavailableKeySpecifier
      | (() => undefined | VersionUnavailableKeySpecifier)
    fields?: VersionUnavailableFieldPolicy
  }
  Video?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VideoKeySpecifier
      | (() => undefined | VideoKeySpecifier)
    fields?: VideoFieldPolicy
  }
  VideoSource?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VideoSourceKeySpecifier
      | (() => undefined | VideoSourceKeySpecifier)
    fields?: VideoSourceFieldPolicy
  }
  Visibility?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | VisibilityKeySpecifier
      | (() => undefined | VisibilityKeySpecifier)
    fields?: VisibilityFieldPolicy
  }
  Workspace?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceKeySpecifier
      | (() => undefined | WorkspaceKeySpecifier)
    fields?: WorkspaceFieldPolicy
  }
  WorkspaceAuditLogs?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceAuditLogsKeySpecifier
      | (() => undefined | WorkspaceAuditLogsKeySpecifier)
    fields?: WorkspaceAuditLogsFieldPolicy
  }
  WorkspaceChangedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceChangedEventKeySpecifier
      | (() => undefined | WorkspaceChangedEventKeySpecifier)
    fields?: WorkspaceChangedEventFieldPolicy
  }
  WorkspaceCustomer?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceCustomerKeySpecifier
      | (() => undefined | WorkspaceCustomerKeySpecifier)
    fields?: WorkspaceCustomerFieldPolicy
  }
  WorkspaceCustomerSubscriptionUpdatedEvent?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | WorkspaceCustomerSubscriptionUpdatedEventKeySpecifier
      | (() =>
          | undefined
          | WorkspaceCustomerSubscriptionUpdatedEventKeySpecifier)
    fields?: WorkspaceCustomerSubscriptionUpdatedEventFieldPolicy
  }
  WorkspaceFeatures?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceFeaturesKeySpecifier
      | (() => undefined | WorkspaceFeaturesKeySpecifier)
    fields?: WorkspaceFeaturesFieldPolicy
  }
  WorkspaceIntegration?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceIntegrationKeySpecifier
      | (() => undefined | WorkspaceIntegrationKeySpecifier)
    fields?: WorkspaceIntegrationFieldPolicy
  }
  WorkspaceIntegrationIdentity?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceIntegrationIdentityKeySpecifier
      | (() => undefined | WorkspaceIntegrationIdentityKeySpecifier)
    fields?: WorkspaceIntegrationIdentityFieldPolicy
  }
  WorkspaceInvite?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceInviteKeySpecifier
      | (() => undefined | WorkspaceInviteKeySpecifier)
    fields?: WorkspaceInviteFieldPolicy
  }
  WorkspaceInviteAcceptedNotification?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | WorkspaceInviteAcceptedNotificationKeySpecifier
      | (() => undefined | WorkspaceInviteAcceptedNotificationKeySpecifier)
    fields?: WorkspaceInviteAcceptedNotificationFieldPolicy
  }
  WorkspaceInvitedNotification?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceInvitedNotificationKeySpecifier
      | (() => undefined | WorkspaceInvitedNotificationKeySpecifier)
    fields?: WorkspaceInvitedNotificationFieldPolicy
  }
  WorkspaceMembers?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceMembersKeySpecifier
      | (() => undefined | WorkspaceMembersKeySpecifier)
    fields?: WorkspaceMembersFieldPolicy
  }
  WorkspaceMembership?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceMembershipKeySpecifier
      | (() => undefined | WorkspaceMembershipKeySpecifier)
    fields?: WorkspaceMembershipFieldPolicy
  }
  WorkspaceMemberships?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceMembershipsKeySpecifier
      | (() => undefined | WorkspaceMembershipsKeySpecifier)
    fields?: WorkspaceMembershipsFieldPolicy
  }
  WorkspaceMembershipsRestricted?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceMembershipsRestrictedKeySpecifier
      | (() => undefined | WorkspaceMembershipsRestrictedKeySpecifier)
    fields?: WorkspaceMembershipsRestrictedFieldPolicy
  }
  WorkspaceMembershipUpdatedEvent?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceMembershipUpdatedEventKeySpecifier
      | (() => undefined | WorkspaceMembershipUpdatedEventKeySpecifier)
    fields?: WorkspaceMembershipUpdatedEventFieldPolicy
  }
  WorkspaceMembersReportResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceMembersReportResponseKeySpecifier
      | (() => undefined | WorkspaceMembersReportResponseKeySpecifier)
    fields?: WorkspaceMembersReportResponseFieldPolicy
  }
  WorkspaceProfile?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceProfileKeySpecifier
      | (() => undefined | WorkspaceProfileKeySpecifier)
    fields?: WorkspaceProfileFieldPolicy
  }
  Workspaces?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspacesKeySpecifier
      | (() => undefined | WorkspacesKeySpecifier)
    fields?: WorkspacesFieldPolicy
  }
  WorkspaceSsoConfig?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceSsoConfigKeySpecifier
      | (() => undefined | WorkspaceSsoConfigKeySpecifier)
    fields?: WorkspaceSsoConfigFieldPolicy
  }
  WorkspaceStorage?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceStorageKeySpecifier
      | (() => undefined | WorkspaceStorageKeySpecifier)
    fields?: WorkspaceStorageFieldPolicy
  }
  WorkspaceUser?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | WorkspaceUserKeySpecifier
      | (() => undefined | WorkspaceUserKeySpecifier)
    fields?: WorkspaceUserFieldPolicy
  }
}
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies
